/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * Everyday Bullion inventory management API
 * OpenAPI spec version: 0.1.0
 */
export interface WhatnotShowWebhookConfiguration {
  /**
     * @minLength 20
     * @maxLength 512
     */
  signingSecret: string;
}

export interface WhatnotShowSyncStatus {
  enabled: boolean;
  /** @nullable */
  lastSuccessAt: string | null;
  /** @nullable */
  lastAttemptAt: string | null;
  /** @nullable */
  lastError: string | null;
  /** @nullable */
  nextAttemptAt: string | null;
  showCount: number;
  syncing: boolean;
  webhookConfigured: boolean;
  /** @nullable */
  webhookLastReceivedAt?: string | null;
}

export interface WhatsappInboxAttachment {
  id: string;
  fileName: string;
  contentType: string;
  /**
     * @minimum 1
     * @nullable
     */
  sizeBytes: number | null;
  /** @nullable */
  url: string | null;
}

export type WhatsappInboxConversationSummaryStatus = typeof WhatsappInboxConversationSummaryStatus[keyof typeof WhatsappInboxConversationSummaryStatus];


export const WhatsappInboxConversationSummaryStatus = {
  open: 'open',
  pending: 'pending',
  resolved: 'resolved',
} as const;

export type WhatsappInboxConversationSummaryPriority = typeof WhatsappInboxConversationSummaryPriority[keyof typeof WhatsappInboxConversationSummaryPriority];


export const WhatsappInboxConversationSummaryPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
} as const;

export type WhatsappInboxConversationSummaryLatestDirection = typeof WhatsappInboxConversationSummaryLatestDirection[keyof typeof WhatsappInboxConversationSummaryLatestDirection];


export const WhatsappInboxConversationSummaryLatestDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
  note: 'note',
} as const;

export type WhatsappInboxConversationSummaryConsentStatus = typeof WhatsappInboxConversationSummaryConsentStatus[keyof typeof WhatsappInboxConversationSummaryConsentStatus];


export const WhatsappInboxConversationSummaryConsentStatus = {
  unknown: 'unknown',
  opted_in: 'opted_in',
  opted_out: 'opted_out',
} as const;

export interface WhatsappInboxConversationSummary {
  id: string;
  senderPhone: string;
  recipientPhone: string;
  status: WhatsappInboxConversationSummaryStatus;
  priority: WhatsappInboxConversationSummaryPriority;
  /** @nullable */
  assignedUserId: string | null;
  /** @nullable */
  customerId: string | null;
  /** @nullable */
  customerName: string | null;
  /** @nullable */
  saleOrderId: string | null;
  latestBody: string;
  latestDirection: WhatsappInboxConversationSummaryLatestDirection;
  lastMessageAt: string;
  /** @nullable */
  lastInboundAt: string | null;
  /** @minimum 0 */
  unreadCount: number;
  consentStatus: WhatsappInboxConversationSummaryConsentStatus;
  tags: string[];
}

export type WhatsappInboxConversationPageCounts = {
  open: number;
  pending: number;
  resolved: number;
  unassigned: number;
  unread: number;
};

export interface WhatsappInboxConversationPage {
  conversations: WhatsappInboxConversationSummary[];
  /** @nullable */
  nextCursor: string | null;
  counts: WhatsappInboxConversationPageCounts;
}

export type WhatsappInboxTimelineItemKind = typeof WhatsappInboxTimelineItemKind[keyof typeof WhatsappInboxTimelineItemKind];


export const WhatsappInboxTimelineItemKind = {
  inbound: 'inbound',
  outbound: 'outbound',
  note: 'note',
} as const;

export interface WhatsappInboxTimelineItem {
  id: string;
  kind: WhatsappInboxTimelineItemKind;
  body: string;
  /** @nullable */
  status: string | null;
  /**
     * Bounded delivery diagnostic code.
     * @nullable
     */
  errorCode: string | null;
  /**
     * Human-readable delivery failure detail; never a credential.
     * @nullable
     */
  error: string | null;
  createdAt: string;
  /** @nullable */
  actorUserId: string | null;
  attachments: WhatsappInboxAttachment[];
}

export type WhatsappInboxConversationDetailCustomerOrdersItem = {
  id: string;
  orderNumber: string;
  status: string;
  paymentStatus: string;
  /** @nullable */
  trackingNumber: string | null;
  saleDate: string;
  /** @minimum 0 */
  returnCount: number;
};

export type WhatsappInboxConversationDetailCustomerCandidatesItemMatch = typeof WhatsappInboxConversationDetailCustomerCandidatesItemMatch[keyof typeof WhatsappInboxConversationDetailCustomerCandidatesItemMatch];


export const WhatsappInboxConversationDetailCustomerCandidatesItemMatch = {
  exact_phone: 'exact_phone',
} as const;

export type WhatsappInboxConversationDetailCustomerCandidatesItem = {
  id: string;
  name: string;
  /** @nullable */
  phone: string | null;
  /** @nullable */
  email: string | null;
  match: WhatsappInboxConversationDetailCustomerCandidatesItemMatch;
};

export interface WhatsappInboxConversationDetail {
  conversation: WhatsappInboxConversationSummary;
  timeline: WhatsappInboxTimelineItem[];
  customerOrders: WhatsappInboxConversationDetailCustomerOrdersItem[];
  customerCandidates: WhatsappInboxConversationDetailCustomerCandidatesItem[];
}

export type WhatsappInboxConversationUpdateStatus = typeof WhatsappInboxConversationUpdateStatus[keyof typeof WhatsappInboxConversationUpdateStatus];


export const WhatsappInboxConversationUpdateStatus = {
  open: 'open',
  pending: 'pending',
  resolved: 'resolved',
} as const;

export type WhatsappInboxConversationUpdatePriority = typeof WhatsappInboxConversationUpdatePriority[keyof typeof WhatsappInboxConversationUpdatePriority];


export const WhatsappInboxConversationUpdatePriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
} as const;

export type WhatsappInboxConversationUpdateConsentStatus = typeof WhatsappInboxConversationUpdateConsentStatus[keyof typeof WhatsappInboxConversationUpdateConsentStatus];


export const WhatsappInboxConversationUpdateConsentStatus = {
  unknown: 'unknown',
  opted_in: 'opted_in',
  opted_out: 'opted_out',
} as const;

export interface WhatsappInboxConversationUpdate {
  status?: WhatsappInboxConversationUpdateStatus;
  priority?: WhatsappInboxConversationUpdatePriority;
  /** @nullable */
  assignedUserId?: string | null;
  /** @nullable */
  customerId?: string | null;
  /** @nullable */
  saleOrderId?: string | null;
  /**
     * @maxItems 20
     * @items.minLength 1
     * @items.maxLength 40
     */
  tags?: string[];
  consentStatus?: WhatsappInboxConversationUpdateConsentStatus;
  /** @maxLength 500 */
  consentEvidence?: string;
}

export type WhatsappInboxSendInputMode = typeof WhatsappInboxSendInputMode[keyof typeof WhatsappInboxSendInputMode];


export const WhatsappInboxSendInputMode = {
  freeform: 'freeform',
  template: 'template',
} as const;

export type WhatsappInboxSendInputTemplateVariables = {[key: string]: string};

export interface WhatsappInboxSendInput {
  /** @maxLength 4000 */
  body: string;
  mode: WhatsappInboxSendInputMode;
  /**
     * @nullable
     * @pattern ^HX[a-fA-F0-9]{32}$
     */
  templateSid?: string | null;
  templateVariables?: WhatsappInboxSendInputTemplateVariables;
  /** @maxItems 1 */
  attachmentIds: string[];
  consentConfirmed: boolean;
  /** @maxLength 500 */
  consentEvidence?: string;
}

export interface WhatsappInboxSendResult {
  logId: string;
  status: string;
  queued: boolean;
}

export type WhatsappInboxSettingsOfficeHours = { [key: string]: unknown };

export type WhatsappInboundWebhookStatus = typeof WhatsappInboundWebhookStatus[keyof typeof WhatsappInboundWebhookStatus];


export const WhatsappInboundWebhookStatus = {
  missing_setup: 'missing_setup',
  awaiting_first_callback: 'awaiting_first_callback',
  verified: 'verified',
  stale: 'stale',
  failed: 'failed',
} as const;

export type WhatsappDeliveryCallbackStatus = typeof WhatsappDeliveryCallbackStatus[keyof typeof WhatsappDeliveryCallbackStatus];


export const WhatsappDeliveryCallbackStatus = {
  awaiting_first_callback: 'awaiting_first_callback',
  verified: 'verified',
  stale: 'stale',
  failed: 'failed',
} as const;

export interface WhatsappInboxSettings {
  timezone: string;
  officeHours: WhatsappInboxSettingsOfficeHours;
  greetingEnabled: boolean;
  /** @nullable */
  greetingBody: string | null;
  outOfHoursEnabled: boolean;
  /** @nullable */
  outOfHoursBody: string | null;
  /** @items.pattern ^HX[a-fA-F0-9]{32}$ */
  templateSids: string[];
  inboundWebhookUrl: string;
  statusCallbackUrl: string;
  inboundWebhookStatus: WhatsappInboundWebhookStatus;
  /** @nullable */
  lastInboundCallbackAt: string | null;
  deliveryCallbackStatus: WhatsappDeliveryCallbackStatus;
  /** @nullable */
  lastDeliveryCallbackAt: string | null;
}

export type WhatsappInboxSettingsInputOfficeHours = { [key: string]: unknown };

export interface WhatsappInboxSettingsInput {
  /**
     * @minLength 1
     * @maxLength 80
     */
  timezone: string;
  officeHours: WhatsappInboxSettingsInputOfficeHours;
  greetingEnabled: boolean;
  /**
     * @maxLength 1000
     * @nullable
     */
  greetingBody: string | null;
  outOfHoursEnabled: boolean;
  /**
     * @maxLength 1000
     * @nullable
     */
  outOfHoursBody: string | null;
  /**
     * @maxItems 20
     * @items.pattern ^HX[a-fA-F0-9]{32}$
     */
  templateSids: string[];
}

export type WhatsappInboxTemplateVariablesItem = {
  key: string;
  sample: string;
};

export interface WhatsappInboxTemplate {
  /** @pattern ^HX[a-fA-F0-9]{32}$ */
  contentSid: string;
  variables: WhatsappInboxTemplateVariablesItem[];
}

export interface WhatsappInboxQuickReply {
  id: string;
  title: string;
  body: string;
  active: boolean;
}

export type WhatsappInboxAnalyticsOperatorsItem = {
  userId: string;
  replies: number;
};

export interface WhatsappInboxAnalytics {
  days: number;
  openConversations: number;
  pendingConversations: number;
  inboundMessages: number;
  outboundMessages: number;
  /** @nullable */
  medianFirstResponseMinutes: number | null;
  operators: WhatsappInboxAnalyticsOperatorsItem[];
}

export type WhatnotProductAttributeValueType = typeof WhatnotProductAttributeValueType[keyof typeof WhatnotProductAttributeValueType];


export const WhatnotProductAttributeValueType = {
  BOOLEAN: 'BOOLEAN',
  INT: 'INT',
  FLOAT: 'FLOAT',
  STRING: 'STRING',
  ENUM: 'ENUM',
} as const;

export interface WhatnotProductAttribute {
  /**
     * @minLength 1
     * @maxLength 255
     */
  id: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  key: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  name: string;
  valueType: WhatnotProductAttributeValueType;
  /** @items.maxLength 500 */
  options: string[];
  required: boolean;
}

export interface WhatnotConditionOptions {
  available: boolean;
  /**
     * @minLength 1
     * @maxLength 255
     */
  taxonomyId: string;
  /** @nullable */
  attributeId: string | null;
  /** @items.minLength 1 */
  options: string[];
  required: boolean;
  /** @nullable */
  message: string | null;
  attributes: WhatnotProductAttribute[];
}

export type WhatnotShippingProfileWeightUnit = typeof WhatnotShippingProfileWeightUnit[keyof typeof WhatnotShippingProfileWeightUnit];


export const WhatnotShippingProfileWeightUnit = {
  GRAM: 'GRAM',
  KILOGRAM: 'KILOGRAM',
  POUND: 'POUND',
  OUNCE: 'OUNCE',
} as const;

export interface WhatnotShippingProfile {
  /**
     * @minLength 1
     * @maxLength 255
     */
  id: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  name: string;
  /** @exclusiveMinimum 0 */
  weight: number;
  weightUnit: WhatnotShippingProfileWeightUnit;
}

export interface WhatnotShippingProfiles {
  available: boolean;
  profiles: WhatnotShippingProfile[];
  /** @nullable */
  message: string | null;
}

export interface WhatnotCategory {
  /**
     * @minLength 1
     * @maxLength 255
     */
  id: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  label: string;
  /**
     * @minLength 1
     * @maxLength 4096
     */
  path: string;
  /**
     * @maxLength 255
     * @nullable
     */
  parentId: string | null;
}

export interface WhatnotCategoryCatalog {
  available: boolean;
  /**
     * @maxLength 64
     * @nullable
     */
  version: string | null;
  categories: WhatnotCategory[];
  /** @nullable */
  message: string | null;
}

export type WhatnotInventoryOverridesSaleMode = typeof WhatnotInventoryOverridesSaleMode[keyof typeof WhatnotInventoryOverridesSaleMode];


export const WhatnotInventoryOverridesSaleMode = {
  buy_it_now: 'buy_it_now',
  auction: 'auction',
  both: 'both',
} as const;

/**
 * @nullable
 */
export type WhatnotInventoryOverridesAttributes = {[key: string]: string | null} | null;

export interface WhatnotInventoryOverrides {
  /**
     * @maxLength 999
     * @nullable
     */
  title: string | null;
  /**
     * @maxLength 5000
     * @nullable
     */
  description: string | null;
  /**
     * @maxLength 255
     * @nullable
     */
  condition: string | null;
  /**
     * @maximum 21474836.47
     * @exclusiveMinimum 0
     * @nullable
     */
  price: number | null;
  /**
     * @maximum 21474836.47
     * @exclusiveMinimum 0
     * @nullable
     */
  auctionStartingPrice: number | null;
  saleMode: WhatnotInventoryOverridesSaleMode;
  acceptOffers: boolean;
  flashSale: boolean;
  reserveForLive: boolean;
  /**
     * @maximum 1000000
     * @exclusiveMinimum 0
     * @nullable
     */
  shippingWeightGrams: number | null;
  /**
     * @minimum 1
     * @maximum 2147483647
     * @nullable
     */
  categoryId: number | null;
  /**
     * @maxLength 255
     * @nullable
     */
  taxonomyId: string | null;
  /**
     * @maxLength 4096
     * @nullable
     */
  taxonomyLabel: string | null;
  /** @nullable */
  attributes: WhatnotInventoryOverridesAttributes;
  /**
     * @maxItems 10
     * @nullable
     * @items.minLength 1
     * @items.maxLength 4096
     */
  imageUrls: string[] | null;
  /**
     * @maxLength 255
     * @nullable
     */
  shippingProfileId: string | null;
  /**
     * @maximum 100000
     * @exclusiveMinimum 0
     * @nullable
     */
  packageLengthCm: number | null;
  /**
     * @maximum 100000
     * @exclusiveMinimum 0
     * @nullable
     */
  packageWidthCm: number | null;
  /**
     * @maximum 100000
     * @exclusiveMinimum 0
     * @nullable
     */
  packageHeightCm: number | null;
}

export interface WhatnotProductPublishInput {
  /**
     * @minLength 1
     * @maxLength 128
     */
  inventoryItemId: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  taxonomyId: string;
}

/**
 * @nullable
 */
export type WhatnotProductPublishResultAction = typeof WhatnotProductPublishResultAction[keyof typeof WhatnotProductPublishResultAction] | null;


export const WhatnotProductPublishResultAction = {
  published: 'published',
  updated: 'updated',
} as const;

export interface WhatnotProductPublishResult {
  ok: boolean;
  /** @nullable */
  action?: WhatnotProductPublishResultAction;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  variantId?: string | null;
  /** @nullable */
  listingId?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  quantity?: number | null;
  /** @nullable */
  published?: boolean | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  providerError?: boolean | null;
}

export interface WhatnotOrderAccessCheck {
  verified: true;
  ordersAvailable: boolean;
  checkedAt: string;
}

export interface WhatnotOrderRecoveryInput {
  /** @pattern ^\d{6,20}$ */
  orderNumber: string;
  /**
     * @minItems 1
     * @maxItems 3
     */
  dates: string[];
}

export type WhatnotOrderRecoveryResultStatus = typeof WhatnotOrderRecoveryResultStatus[keyof typeof WhatnotOrderRecoveryResultStatus];


export const WhatnotOrderRecoveryResultStatus = {
  imported: 'imported',
  duplicate: 'duplicate',
  unresolved: 'unresolved',
  skipped: 'skipped',
} as const;

export interface WhatnotOrderRecoveryResult {
  orderNumber: string;
  status: WhatnotOrderRecoveryResultStatus;
  message: string;
}

export interface WhatnotOrderHistoryBoundary {
  /**
     * @minimum 0
     * @maximum 5000
     */
  scanned: number;
  /** @nullable */
  oldestOrderCreatedAt: string | null;
  /** @nullable */
  newestOrderCreatedAt: string | null;
  complete: boolean;
  hasMoreOrders: boolean;
  checkedAt: string;
}

export interface WhatnotListingScanInput {
  /**
     * @minLength 1
     * @maxLength 128
     */
  inventoryItemId: string;
  /**
     * @minLength 2
     * @maxLength 120
     */
  search: string;
  /** @maxLength 90000 */
  scanToken?: string;
  /** Read-only exact inventory-SKU inspection; returns only matches on the current provider page. Its continuation cannot authorize mapping. */
  diagnostic?: boolean;
}

export interface WhatnotListingCandidate {
  id: string;
  /** @nullable */
  variantId?: string | null;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  title: string | null;
  /** @nullable */
  productTitle: string | null;
  /** @nullable */
  sku: string | null;
  /** @nullable */
  status: string | null;
  /** @nullable */
  published: boolean | null;
  /** @nullable */
  url: string | null;
  /** @nullable */
  quantity: number | null;
  skuMatches: boolean;
}

export type WhatnotListingScanStatus = typeof WhatnotListingScanStatus[keyof typeof WhatnotListingScanStatus];


export const WhatnotListingScanStatus = {
  running: 'running',
  complete: 'complete',
  blocked: 'blocked',
} as const;

export interface WhatnotListingScan {
  listings: WhatnotListingCandidate[];
  skuMatchCount: number;
  complete: boolean;
  scanComplete: boolean;
  resultsTruncated: boolean;
  status: WhatnotListingScanStatus;
  scanned: number;
  /** @nullable */
  blockedReason: string | null;
  scanToken: string;
}

export type PortalVerificationDeliveryOutcome = typeof PortalVerificationDeliveryOutcome[keyof typeof PortalVerificationDeliveryOutcome];


export const PortalVerificationDeliveryOutcome = {
  accepted: 'accepted',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export type PortalVerificationDeliveryReason = typeof PortalVerificationDeliveryReason[keyof typeof PortalVerificationDeliveryReason];


export const PortalVerificationDeliveryReason = {
  credential_active: 'credential_active',
  delivery_skipped: 'delivery_skipped',
} as const;

export interface PortalVerificationDelivery {
  outcome: PortalVerificationDeliveryOutcome;
  reason?: PortalVerificationDeliveryReason;
}

export type CentralMarketRefreshMetalStatus = typeof CentralMarketRefreshMetalStatus[keyof typeof CentralMarketRefreshMetalStatus];


export const CentralMarketRefreshMetalStatus = {
  completed: 'completed',
  unavailable: 'unavailable',
  'unchanged-source': 'unchanged-source',
  failed: 'failed',
} as const;

export interface CentralMarketRefreshMetal {
  metal: string;
  /** @nullable */
  source: string | null;
  /** @nullable */
  sourceTimestamp: string | null;
  status: CentralMarketRefreshMetalStatus;
  /**
     * Allowlisted provider failure category; never contains upstream response text
     * @nullable
     */
  reason: string | null;
}

export type CentralMarketRefreshResultStatus = typeof CentralMarketRefreshResultStatus[keyof typeof CentralMarketRefreshResultStatus];


export const CentralMarketRefreshResultStatus = {
  pending: 'pending',
  completed: 'completed',
  throttled: 'throttled',
  unavailable: 'unavailable',
  'unchanged-source': 'unchanged-source',
  failed: 'failed',
} as const;

export interface CentralMarketRefreshResult {
  /** @nullable */
  requestId: string | null;
  status: CentralMarketRefreshResultStatus;
  requestedAt: string;
  completedAt?: string;
  /** @minimum 0 */
  retryAfterSeconds?: number;
  /** @nullable */
  sequence?: number | null;
  metals?: CentralMarketRefreshMetal[];
}

export interface WholesaleApplicationInput {
  /**
     * @minLength 2
     * @maxLength 120
     */
  contactName: string;
  /** @maxLength 320 */
  email: string;
  /** @maxLength 40 */
  phone?: string;
  /**
     * @minLength 2
     * @maxLength 180
     */
  businessName: string;
  /** @maxLength 180 */
  legalName?: string;
  /** @maxLength 100 */
  businessType?: string;
  /** @maxLength 64 */
  companyNumber?: string;
  /** @maxLength 64 */
  vatNumber?: string;
  /** @maxLength 400 */
  website?: string;
  /** @maxLength 80 */
  country?: string;
  /** @maxLength 4000 */
  message?: string;
}

export interface WholesaleApplicationReceipt {
  accepted: true;
  message: string;
}

export interface VariantSplitCandidate {
  id: string;
  sku: string;
  /** @nullable */
  productTitle?: string | null;
  /** @nullable */
  year?: number | null;
  /** @nullable */
  familyId?: string | null;
  /** @nullable */
  masterInventoryItemId?: string | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  metal?: string | null;
  /** @nullable */
  productType?: string | null;
  /** @nullable */
  weight?: number | null;
  /** @nullable */
  purity?: string | null;
}

export type VariantSplitWorkspaceSource = { [key: string]: unknown };

export type VariantSplitWorkspaceMappingsItem = { [key: string]: unknown };

/**
 * @nullable
 */
export type VariantSplitWorkspaceDraft = { [key: string]: unknown } | null;

export interface VariantSplitSourceLot {
  id: string;
  lotRef: string;
  quantityReceived: number;
  quantityAvailable: number;
  receivedAt: string;
  /** @nullable */
  originalUnitCost?: string | null;
  landedUnitCost: string;
  currency: string;
  ownershipType: string;
  /** @nullable */
  supplierId?: string | null;
}

export interface VariantSplitWorkspace {
  source: VariantSplitWorkspaceSource;
  mappings: VariantSplitWorkspaceMappingsItem[];
  candidates: VariantSplitCandidate[];
  sourceLots: VariantSplitSourceLot[];
  /** @nullable */
  draft?: VariantSplitWorkspaceDraft;
}

export interface VariantSplitMatchInput {
  lineId: string;
  /**
     * @minItems 1
     * @maxItems 200
     * @items.minimum 1000
     * @items.maximum 9999
     */
  years: number[];
  /** @nullable */
  familyId?: string | null;
}

export type VariantSplitMatchResponseRowsItemStatus = typeof VariantSplitMatchResponseRowsItemStatus[keyof typeof VariantSplitMatchResponseRowsItemStatus];


export const VariantSplitMatchResponseRowsItemStatus = {
  MATCHED: 'MATCHED',
  POSSIBLE_MATCH: 'POSSIBLE_MATCH',
  NO_MATCH: 'NO_MATCH',
  NEW_SKU: 'NEW_SKU',
  CONFLICT: 'CONFLICT',
} as const;

export type VariantSplitMatchResponseRowsItem = {
  year: number;
  status: VariantSplitMatchResponseRowsItemStatus;
  /** @nullable */
  inventoryItemId?: string | null;
  /** @nullable */
  mappingSource?: string | null;
  candidates: VariantSplitCandidate[];
  selectedCandidate: VariantSplitCandidate | null;
  /** @nullable */
  reason?: string | null;
};

export interface VariantSplitMatchResponse {
  rows: VariantSplitMatchResponseRowsItem[];
}

export type VariantSplitDraftPayloadRowsItem = { [key: string]: unknown };

export type VariantSplitAllocationInputMappingSource = typeof VariantSplitAllocationInputMappingSource[keyof typeof VariantSplitAllocationInputMappingSource];


export const VariantSplitAllocationInputMappingSource = {
  SAVED_MAPPING: 'SAVED_MAPPING',
  PRODUCT_FAMILY: 'PRODUCT_FAMILY',
  STRUCTURED_MATCH: 'STRUCTURED_MATCH',
  MANUAL: 'MANUAL',
  CREATED_DURING_RECEIPT: 'CREATED_DURING_RECEIPT',
} as const;

export type VariantSplitAllocationInputCreateVariant = {
  /**
     * @minimum 1000
     * @maximum 9999
     */
  year: number;
  /** @maxLength 200 */
  sku?: string;
  /** @maxLength 2048 */
  token: string;
};

export interface VariantSplitAllocationInput {
  /**
     * @minimum 1000
     * @maximum 9999
     */
  year: number;
  /** @minimum 0 */
  quantity: number;
  destinationInventoryItemId?: string;
  createVariant?: VariantSplitAllocationInputCreateVariant;
  mappingSource: VariantSplitAllocationInputMappingSource;
}

export interface VariantSplitDraftPayload {
  /**
     * @minItems 1
     * @maxItems 200
     */
  rows: VariantSplitDraftPayloadRowsItem[];
  /** @maxItems 200 */
  allocations: VariantSplitAllocationInput[];
  /**
     * @minLength 1
     * @maxLength 64
     */
  step: string;
  /** @minimum 0 */
  receiptQuantity: number;
  [key: string]: unknown;
 }

export interface VariantSplitDraftInput {
  lineId: string;
  payload: VariantSplitDraftPayload;
}

export interface VariantSplitDraft {
  id: string;
  purchaseOrderId: string;
  purchaseOrderItemId: string;
  draftKey: string;
  payload: VariantSplitDraftPayload;
  updatedAt: string;
  createdAt?: string;
}

export interface VariantSplitVariantInput {
  lineId: string;
  /**
     * @minimum 1000
     * @maximum 9999
     */
  year: number;
  /**
     * @minLength 1
     * @maxLength 200
     */
  sku?: string;
  saveMapping?: boolean;
}

export type VariantSplitVariantResponseInventoryItem = { [key: string]: unknown };

export type VariantSplitVariantResponseMappingSource = typeof VariantSplitVariantResponseMappingSource[keyof typeof VariantSplitVariantResponseMappingSource];


export const VariantSplitVariantResponseMappingSource = {
  CREATED_DURING_RECEIPT: 'CREATED_DURING_RECEIPT',
} as const;

export interface VariantSplitVariantResponse {
  inventoryItem: VariantSplitVariantResponseInventoryItem;
  year: number;
  mappingSource: VariantSplitVariantResponseMappingSource;
  /** A durable content-review exception was raised after creation. */
  needsContentReview: boolean;
}

export type VariantSplitVariantProposalResponseProposal = { [key: string]: unknown };

export interface VariantSplitVariantProposalResponse {
  proposal: VariantSplitVariantProposalResponseProposal;
  token: string;
}

/**
 * Optional complete operator-confirmed acquisition VAT payload. The server validates it with the existing acquisition VAT resolver and writes its classification lineage atomically to each new lot when VAT columns are available; incomplete payloads are ignored.
 */
export type VariantSplitReceiptInputItemVat = { [key: string]: unknown } | null;

export interface VariantSplitReceiptInput {
  lineId: string;
  /** @minimum 1 */
  receiptQuantity: number;
  /**
     * @minLength 8
     * @maxLength 200
     */
  idempotencyKey: string;
  /** @minimum 0 */
  actualUnitCost?: number | string;
  /** @minimum 0 */
  expectedUnitCost?: number | string;
  /** @minimum 0 */
  allocatedLandedCharge?: number | string;
  /**
     * @maxLength 200
     * @nullable
     */
  storageLocation?: string | null;
  /**
     * @maxLength 2000
     * @nullable
     */
  notes?: string | null;
  receivedAt?: string;
  /** Optional complete operator-confirmed acquisition VAT payload. The server validates it with the existing acquisition VAT resolver and writes its classification lineage atomically to each new lot when VAT columns are available; incomplete payloads are ignored. */
  itemVat?: VariantSplitReceiptInputItemVat;
  /**
     * @minItems 1
     * @maxItems 200
     */
  allocations: VariantSplitAllocationInput[];
  /** Required explicitly when this receipt exceeds the ordered PO quantity. */
  confirmOverDelivery?: boolean;
  rememberMappings?: boolean;
}

export interface CheckedInVariantSplitSource {
  lotId: string;
  /** @minimum 1 */
  quantity: number;
}

export interface CheckedInVariantSplitInput {
  lineId: string;
  /** @minimum 1 */
  splitQuantity: number;
  /**
     * @minLength 8
     * @maxLength 200
     */
  idempotencyKey: string;
  /**
     * @minItems 1
     * @maxItems 200
     */
  sourceLots: CheckedInVariantSplitSource[];
  /**
     * @minItems 1
     * @maxItems 200
     */
  allocations: VariantSplitAllocationInput[];
  rememberMappings?: boolean;
}

export type VariantSplitReceiptVariantType = typeof VariantSplitReceiptVariantType[keyof typeof VariantSplitReceiptVariantType];


export const VariantSplitReceiptVariantType = {
  YEAR: 'YEAR',
} as const;

export type VariantSplitReceiptStatus = typeof VariantSplitReceiptStatus[keyof typeof VariantSplitReceiptStatus];


export const VariantSplitReceiptStatus = {
  FINALIZED: 'FINALIZED',
} as const;

export type VariantSplitReceiptOperationType = typeof VariantSplitReceiptOperationType[keyof typeof VariantSplitReceiptOperationType];


export const VariantSplitReceiptOperationType = {
  NEW_RECEIPT: 'NEW_RECEIPT',
  CHECKED_IN_SPLIT: 'CHECKED_IN_SPLIT',
} as const;

export interface VariantSplitOperator {
  /** @nullable */
  userId: string | null;
  /** @nullable */
  email: string | null;
}

export interface VariantSplitReceipt {
  id: string;
  purchaseOrderId: string;
  purchaseOrderItemId: string;
  receiptQuantity: number;
  variantType: VariantSplitReceiptVariantType;
  status: VariantSplitReceiptStatus;
  operationType: VariantSplitReceiptOperationType;
  idempotencyKey: string;
  /** @nullable */
  requestFingerprint?: string | null;
  createdAt: string;
  /** @nullable */
  finalisedAt?: string | null;
  operator?: VariantSplitOperator;
}

export interface VariantSplitReceiptAllocation {
  id: string;
  year: number;
  quantity: number;
  destinationInventoryItemId: string;
  /** @nullable */
  skuSnapshot: string | null;
  /** @nullable */
  lotId: string | null;
  /** @nullable */
  sourceLotId: string | null;
  /** @nullable */
  sourceLotRef: string | null;
  operator: VariantSplitOperator;
  receiptCreatedAt: string;
}

export type VariantSplitReceiptHistoryEntry = VariantSplitReceipt & {
  operator: VariantSplitOperator;
  allocations: VariantSplitReceiptAllocation[];
};

export type VariantSplitReceiptDetailAllocationsItem = {
  id: string;
  variantValue: number;
  destinationInventoryItemId: string;
  quantity: number;
  mappingSource: string;
  /** @nullable */
  createdSku?: string | null;
  /** @nullable */
  lotId?: string | null;
  /** @nullable */
  sourceLotId?: string | null;
  /** @nullable */
  sourceLotRef?: string | null;
  year?: number;
  /** @nullable */
  skuSnapshot?: string | null;
  operator?: VariantSplitOperator;
  receiptCreatedAt?: string;
};

export interface VariantSplitReceiptDetail {
  receipt: VariantSplitReceipt;
  allocations: VariantSplitReceiptDetailAllocationsItem[];
}

export type SalesPerformanceRequestComparison = typeof SalesPerformanceRequestComparison[keyof typeof SalesPerformanceRequestComparison];


export const SalesPerformanceRequestComparison = {
  previous_period: 'previous_period',
  previous_year: 'previous_year',
  none: 'none',
} as const;

export type SalesPerformanceRequestChannel = typeof SalesPerformanceRequestChannel[keyof typeof SalesPerformanceRequestChannel];


export const SalesPerformanceRequestChannel = {
  all: 'all',
  eBay: 'eBay',
  WhatsApp: 'WhatsApp',
  Shopify: 'Shopify',
  Whatnot: 'Whatnot',
  Direct: 'Direct',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
} as const;

export type SalesPerformanceRequestStockOwnership = typeof SalesPerformanceRequestStockOwnership[keyof typeof SalesPerformanceRequestStockOwnership];


export const SalesPerformanceRequestStockOwnership = {
  all: 'all',
  owned: 'owned',
  consignment: 'consignment',
} as const;

export type SalesPerformanceRequestOrderStatus = typeof SalesPerformanceRequestOrderStatus[keyof typeof SalesPerformanceRequestOrderStatus];


export const SalesPerformanceRequestOrderStatus = {
  recognised: 'recognised',
} as const;

export type SalesPerformanceRequestGroup = typeof SalesPerformanceRequestGroup[keyof typeof SalesPerformanceRequestGroup];


export const SalesPerformanceRequestGroup = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type SalesPerformanceRequestOrderGroup = typeof SalesPerformanceRequestOrderGroup[keyof typeof SalesPerformanceRequestOrderGroup];


export const SalesPerformanceRequestOrderGroup = {
  none: 'none',
  whatnot_show: 'whatnot_show',
} as const;

export interface SalesPerformanceRequest {
  start: string;
  end: string;
  comparison?: SalesPerformanceRequestComparison;
  channel?: SalesPerformanceRequestChannel;
  stockOwnership?: SalesPerformanceRequestStockOwnership;
  orderStatus?: SalesPerformanceRequestOrderStatus;
  group?: SalesPerformanceRequestGroup;
  orderGroup?: SalesPerformanceRequestOrderGroup;
  /** @maxLength 200 */
  search?: string;
  /** @maxLength 200 */
  orderSearch?: string;
  /** @minimum 1 */
  page?: number;
  /**
     * @minimum 1
     * @maximum 100
     */
  pageSize?: number;
}

export type SalesPerformanceResponseReportStatus = typeof SalesPerformanceResponseReportStatus[keyof typeof SalesPerformanceResponseReportStatus];


export const SalesPerformanceResponseReportStatus = {
  ready: 'ready',
  report_preparing: 'report_preparing',
} as const;

export type SalesPerformanceResponseKpis = { [key: string]: unknown };

/**
 * @nullable
 */
export type SalesPerformanceResponseComparison = { [key: string]: unknown } | null;

export type SalesPerformanceResponseTrendItem = { [key: string]: unknown };

export type SalesPerformanceResponseDailyItem = { [key: string]: unknown };

export type SalesPerformanceResponseChannelsItem = { [key: string]: unknown };

export type SalesPerformanceResponseTopProductsItem = { [key: string]: unknown };

export type SalesPerformanceResponseUnderperformingProductsItem = { [key: string]: unknown };

export type SalesPerformanceResponseOrdersRowsItem = { [key: string]: unknown };

export type SalesPerformanceResponseOrders = {
  rows: SalesPerformanceResponseOrdersRowsItem[];
  page: number;
  pageSize: number;
  total: number;
};

export type SalesPerformanceResponseWhatnotShowGroupsBasis = typeof SalesPerformanceResponseWhatnotShowGroupsBasis[keyof typeof SalesPerformanceResponseWhatnotShowGroupsBasis];


export const SalesPerformanceResponseWhatnotShowGroupsBasis = {
  verified_live_interval_inferred: 'verified_live_interval_inferred',
} as const;

export type SalesPerformanceResponseWhatnotShowGroupsGroupsItem = { [key: string]: unknown };

export type SalesPerformanceResponseWhatnotShowGroupsPermissions = { [key: string]: unknown };

export type SalesPerformanceResponseWhatnotShowGroups = {
  basis?: SalesPerformanceResponseWhatnotShowGroupsBasis;
  directAssociationAvailable?: boolean;
  groups?: SalesPerformanceResponseWhatnotShowGroupsGroupsItem[];
  permissions?: SalesPerformanceResponseWhatnotShowGroupsPermissions;
} | null;

export interface SalesPerformanceResponse {
  reportStatus: SalesPerformanceResponseReportStatus;
  kpis: SalesPerformanceResponseKpis;
  /** @nullable */
  comparison?: SalesPerformanceResponseComparison;
  trend: SalesPerformanceResponseTrendItem[];
  daily?: SalesPerformanceResponseDailyItem[];
  channels: SalesPerformanceResponseChannelsItem[];
  topProducts: SalesPerformanceResponseTopProductsItem[];
  underperformingProducts: SalesPerformanceResponseUnderperformingProductsItem[];
  orders: SalesPerformanceResponseOrders;
  whatnotShowGroups?: SalesPerformanceResponseWhatnotShowGroups;
}

export type PurchaseOrderOverviewCriteriaQuickFilter = typeof PurchaseOrderOverviewCriteriaQuickFilter[keyof typeof PurchaseOrderOverviewCriteriaQuickFilter];


export const PurchaseOrderOverviewCriteriaQuickFilter = {
  'paid-waiting-to-ship': 'paid-waiting-to-ship',
  'awaiting-payment': 'awaiting-payment',
  'in-transit': 'in-transit',
  'awaiting-final-costing': 'awaiting-final-costing',
  'missing-waybill': 'missing-waybill',
  'completed-awaiting-costs': 'completed-awaiting-costs',
  finalised: 'finalised',
  all: 'all',
} as const;

export type PurchaseOrderOverviewCriteriaWorkflow = typeof PurchaseOrderOverviewCriteriaWorkflow[keyof typeof PurchaseOrderOverviewCriteriaWorkflow];


export const PurchaseOrderOverviewCriteriaWorkflow = {
  not_received: 'not_received',
  partial: 'partial',
  complete: 'complete',
} as const;

export type PurchaseOrderOverviewCriteriaSecondary = typeof PurchaseOrderOverviewCriteriaSecondary[keyof typeof PurchaseOrderOverviewCriteriaSecondary];


export const PurchaseOrderOverviewCriteriaSecondary = {
  warnings: 'warnings',
  unpaid: 'unpaid',
  inbound: 'inbound',
} as const;

export type PurchaseOrderOverviewCriteriaAllocation = typeof PurchaseOrderOverviewCriteriaAllocation[keyof typeof PurchaseOrderOverviewCriteriaAllocation];


export const PurchaseOrderOverviewCriteriaAllocation = {
  needs_sku: 'needs_sku',
  complete: 'complete',
  all: 'all',
} as const;

export type PurchaseOrderOverviewCriteriaGroupBy = typeof PurchaseOrderOverviewCriteriaGroupBy[keyof typeof PurchaseOrderOverviewCriteriaGroupBy];


export const PurchaseOrderOverviewCriteriaGroupBy = {
  none: 'none',
  status: 'status',
  supplier: 'supplier',
  currency: 'currency',
  month: 'month',
} as const;

export type PurchaseOrderOverviewCriteriaSortBy = typeof PurchaseOrderOverviewCriteriaSortBy[keyof typeof PurchaseOrderOverviewCriteriaSortBy];


export const PurchaseOrderOverviewCriteriaSortBy = {
  purchaseDate: 'purchaseDate',
  deliveryDate: 'deliveryDate',
  total: 'total',
  supplier: 'supplier',
  status: 'status',
  payment: 'payment',
  updatedAt: 'updatedAt',
} as const;

export type PurchaseOrderOverviewCriteriaSortDirection = typeof PurchaseOrderOverviewCriteriaSortDirection[keyof typeof PurchaseOrderOverviewCriteriaSortDirection];


export const PurchaseOrderOverviewCriteriaSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

/**
 * Reusable criteria for overview filtering, grouping, sorting, and saved views.
 */
export interface PurchaseOrderOverviewCriteria {
  /** @maxLength 200 */
  search?: string;
  status?: string;
  quickFilter?: PurchaseOrderOverviewCriteriaQuickFilter;
  workflow?: PurchaseOrderOverviewCriteriaWorkflow;
  secondary?: PurchaseOrderOverviewCriteriaSecondary;
  allocation?: PurchaseOrderOverviewCriteriaAllocation;
  supplierId?: string;
  /** @maxLength 3 */
  currency?: string;
  dateFrom?: string;
  dateTo?: string;
  groupBy?: PurchaseOrderOverviewCriteriaGroupBy;
  sortBy?: PurchaseOrderOverviewCriteriaSortBy;
  sortDirection?: PurchaseOrderOverviewCriteriaSortDirection;
  savedViewId?: string;
  includeMetrics?: boolean;
  includeCounts?: boolean;
}

export type PurchaseOrderSavedViewCriteriaQuickFilter = typeof PurchaseOrderSavedViewCriteriaQuickFilter[keyof typeof PurchaseOrderSavedViewCriteriaQuickFilter];


export const PurchaseOrderSavedViewCriteriaQuickFilter = {
  'paid-waiting-to-ship': 'paid-waiting-to-ship',
  'awaiting-payment': 'awaiting-payment',
  'in-transit': 'in-transit',
  'awaiting-final-costing': 'awaiting-final-costing',
  'missing-waybill': 'missing-waybill',
  'completed-awaiting-costs': 'completed-awaiting-costs',
  finalised: 'finalised',
  all: 'all',
} as const;

export type PurchaseOrderSavedViewCriteriaAllocation = typeof PurchaseOrderSavedViewCriteriaAllocation[keyof typeof PurchaseOrderSavedViewCriteriaAllocation];


export const PurchaseOrderSavedViewCriteriaAllocation = {
  needs_sku: 'needs_sku',
  complete: 'complete',
  all: 'all',
} as const;

export type PurchaseOrderSavedViewCriteriaGroupBy = typeof PurchaseOrderSavedViewCriteriaGroupBy[keyof typeof PurchaseOrderSavedViewCriteriaGroupBy];


export const PurchaseOrderSavedViewCriteriaGroupBy = {
  none: 'none',
  supplier: 'supplier',
} as const;

export type PurchaseOrderSavedViewCriteriaSortBy = typeof PurchaseOrderSavedViewCriteriaSortBy[keyof typeof PurchaseOrderSavedViewCriteriaSortBy];


export const PurchaseOrderSavedViewCriteriaSortBy = {
  purchaseDate: 'purchaseDate',
  supplier: 'supplier',
} as const;

export type PurchaseOrderSavedViewCriteriaSortDirection = typeof PurchaseOrderSavedViewCriteriaSortDirection[keyof typeof PurchaseOrderSavedViewCriteriaSortDirection];


export const PurchaseOrderSavedViewCriteriaSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PurchaseOrderSavedViewCriteriaKpisItem = typeof PurchaseOrderSavedViewCriteriaKpisItem[keyof typeof PurchaseOrderSavedViewCriteriaKpisItem];


export const PurchaseOrderSavedViewCriteriaKpisItem = {
  open: 'open',
  outstanding: 'outstanding',
  inbound: 'inbound',
  profit: 'profit',
  paid: 'paid',
  costing: 'costing',
  transit: 'transit',
  waybill: 'waybill',
  finalised: 'finalised',
} as const;

export interface PurchaseOrderSavedViewCriteria {
  /** @maxLength 200 */
  search?: string;
  quickFilter: PurchaseOrderSavedViewCriteriaQuickFilter;
  allocation?: PurchaseOrderSavedViewCriteriaAllocation;
  groupBy: PurchaseOrderSavedViewCriteriaGroupBy;
  sortBy: PurchaseOrderSavedViewCriteriaSortBy;
  sortDirection: PurchaseOrderSavedViewCriteriaSortDirection;
  /**
     * @minItems 1
     * @maxItems 4
     */
  kpis: PurchaseOrderSavedViewCriteriaKpisItem[];
}

export interface PurchaseOrderSavedView {
  id: string;
  name: string;
  criteria: PurchaseOrderSavedViewCriteria;
  isShared: boolean;
  isOwner: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PurchaseOrderSavedViewList {
  views: PurchaseOrderSavedView[];
}

export interface PurchaseOrderSavedViewInput {
  /**
     * @minLength 1
     * @maxLength 80
     */
  name: string;
  criteria: PurchaseOrderSavedViewCriteria;
  isShared?: boolean;
}

export interface PurchaseOrderSavedViewUpdate {
  /**
     * @minLength 1
     * @maxLength 80
     */
  name?: string;
  isShared?: boolean;
  criteria?: PurchaseOrderSavedViewCriteria;
}

export type PurchaseOrderEstimateMetadataReliability = typeof PurchaseOrderEstimateMetadataReliability[keyof typeof PurchaseOrderEstimateMetadataReliability];


export const PurchaseOrderEstimateMetadataReliability = {
  high: 'high',
  medium: 'medium',
  low: 'low',
  unknown: 'unknown',
} as const;

export type PurchaseOrderEstimateMetadataSource = typeof PurchaseOrderEstimateMetadataSource[keyof typeof PurchaseOrderEstimateMetadataSource];


export const PurchaseOrderEstimateMetadataSource = {
  actual: 'actual',
  calculated: 'calculated',
  estimated: 'estimated',
  unavailable: 'unavailable',
} as const;

/**
 * Provenance for redacted or estimated finance values. When finance data is
 * unavailable, available is false, source is unavailable, and reason explains
 * the redaction; all monetary values in the related response are null.
 */
export interface PurchaseOrderEstimateMetadata {
  available: boolean;
  reliability: PurchaseOrderEstimateMetadataReliability;
  source: PurchaseOrderEstimateMetadataSource;
  /** @nullable */
  asOf?: string | null;
  /** @nullable */
  reason?: string | null;
}

/**
 * Present when groupBy=supplier; identifies the stable supplier bucket for this row.
 */
export type PurchaseOrderCompactSupplierGroup = {
  /** @nullable */
  id: string | null;
  name: string;
};

/**
 * @nullable
 */
export type PurchaseOrderCompactStockStage = typeof PurchaseOrderCompactStockStage[keyof typeof PurchaseOrderCompactStockStage] | null;


export const PurchaseOrderCompactStockStage = {
  Ordered: 'Ordered',
  In_transit: 'In transit',
  To_check_in: 'To check in',
  In_stock: 'In stock',
} as const;

/**
 * @nullable
 */
export type PurchaseOrderCompactPaymentState = typeof PurchaseOrderCompactPaymentState[keyof typeof PurchaseOrderCompactPaymentState] | null;


export const PurchaseOrderCompactPaymentState = {
  Unpaid: 'Unpaid',
  Part_paid: 'Part paid',
  Paid: 'Paid',
  Unknown: 'Unknown',
} as const;

/**
 * @nullable
 */
export type PurchaseOrderCompactCostingState = typeof PurchaseOrderCompactCostingState[keyof typeof PurchaseOrderCompactCostingState] | null;


export const PurchaseOrderCompactCostingState = {
  Not_valued: 'Not valued',
  Provisional: 'Provisional',
  Final: 'Final',
  Needs_review: 'Needs review',
} as const;

export interface PurchaseOrderCompact {
  id: string;
  orderNumber: string;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  supplierName?: string | null;
  /** Present when groupBy=supplier; identifies the stable supplier bucket for this row. */
  supplierGroup?: PurchaseOrderCompactSupplierGroup;
  status: string;
  currency: string;
  /** @nullable */
  purchaseDate?: string | null;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  total: number | null;
  /** @nullable */
  committed?: number | null;
  /** @nullable */
  inbound?: number | null;
  /** @nullable */
  outstanding?: number | null;
  /** @nullable */
  landed?: number | null;
  /** @nullable */
  resale?: number | null;
  /** @nullable */
  profit?: number | null;
  /** @nullable */
  receiving?: number | null;
  /** @nullable */
  paymentStatus?: string | null;
  /** @nullable */
  stockStage?: PurchaseOrderCompactStockStage;
  /** @nullable */
  lifecycleState?: string | null;
  /** @nullable */
  paymentState?: PurchaseOrderCompactPaymentState;
  /** @nullable */
  costingState?: PurchaseOrderCompactCostingState;
  needsReview?: boolean;
  /** @maxItems 20 */
  reviewReasons?: string[];
  /** @maxItems 20 */
  warnings?: string[];
  /** @nullable */
  nextAction?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  turnaroundDays?: number | null;
  /** @nullable */
  source?: string | null;
  /** @minimum 0 */
  lineCount?: number;
  /** @minimum 0 */
  allocatedLineCount: number;
  /** @minimum 0 */
  unallocatedLineCount: number;
  /** @minimum 0 */
  invoiceCount?: number;
  /** @maxItems 50 */
  invoiceNumbers?: string[];
  /** @nullable */
  courier?: string | null;
  /** @nullable */
  waybillNumber?: string | null;
  /** @nullable */
  trackingNumber?: string | null;
  /** @nullable */
  trackingLink?: string | null;
  /** @nullable */
  shipmentGroupId?: string | null;
  estimateMetadata: PurchaseOrderEstimateMetadata;
}

export type PurchaseOrderReconciliationReportMismatchCounts = {[key: string]: number};

export type PurchaseOrderReconciliationReportCause = typeof PurchaseOrderReconciliationReportCause[keyof typeof PurchaseOrderReconciliationReportCause];


export const PurchaseOrderReconciliationReportCause = {
  code: 'code',
  stale_summaries: 'stale summaries',
  stored_data: 'stored data',
  combination: 'combination',
  none: 'none',
} as const;

export type PurchaseOrderReconciliationReportBeforeState = { [key: string]: unknown };

export type PurchaseOrderReconciliationReportAmbiguousRecordsItem = { [key: string]: unknown };

export type PurchaseOrderReconciliationReportQueue = { [key: string]: unknown };

export interface PurchaseOrderReconciliationReport {
  tenantId: string;
  /** @minimum 0 */
  totalOrdersChecked: number;
  mismatchCounts: PurchaseOrderReconciliationReportMismatchCounts;
  cause: PurchaseOrderReconciliationReportCause;
  beforeState: PurchaseOrderReconciliationReportBeforeState;
  ambiguousRecords: PurchaseOrderReconciliationReportAmbiguousRecordsItem[];
  queue: PurchaseOrderReconciliationReportQueue;
}

export type PurchaseOrderOverviewMetricsCountsByStatus = {[key: string]: number};

export type PurchaseOrderOverviewMetricsCountsBySupplier = {[key: string]: number};

/**
 * Complete counts for every canonical quickFilter bucket under the other criteria, before the active quickFilter.
 */
export type PurchaseOrderOverviewMetricsQuickFilterCounts = {
  /** @minimum 0 */
  'paid-waiting-to-ship': number;
  /** @minimum 0 */
  'awaiting-payment': number;
  /** @minimum 0 */
  'in-transit': number;
  /** @minimum 0 */
  'awaiting-final-costing': number;
  /** @minimum 0 */
  'missing-waybill': number;
  /** @minimum 0 */
  'completed-awaiting-costs': number;
  /** @minimum 0 */
  finalised: number;
  /** @minimum 0 */
  all: number;
};

/**
 * Counts for all allocation buckets across the other base criteria, before the active allocation filter and quickFilter.
 */
export type PurchaseOrderOverviewMetricsAllocationCounts = {
  /** @minimum 0 */
  all: number;
  /** @minimum 0 */
  complete: number;
  /** @minimum 0 */
  needsSku: number;
};

/**
 * Page-authoritative supplier grouping metadata. key is supplierId, or unknown when supplierId is absent.
 */
export interface PurchaseOrderOverviewGroup {
  key: string;
  /** @minimum 0 */
  count: number;
  /** @nullable */
  total: number | null;
}

export interface PurchaseOrderOverviewMetrics {
  /** @minimum 0 */
  totalOrders: number;
  /** @nullable */
  totalValue: number | null;
  /** @nullable */
  committed?: number | null;
  /** @nullable */
  inbound?: number | null;
  /** @nullable */
  outstanding?: number | null;
  /** @nullable */
  landed?: number | null;
  /** @nullable */
  resale?: number | null;
  /** @nullable */
  profit?: number | null;
  /** @nullable */
  receiving?: number | null;
  /** @maxItems 20 */
  warnings?: string[];
  /** @nullable */
  nextAction?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  turnaroundDays?: number | null;
  /** @nullable */
  source?: string | null;
  countsByStatus: PurchaseOrderOverviewMetricsCountsByStatus;
  countsBySupplier?: PurchaseOrderOverviewMetricsCountsBySupplier;
  /** Complete counts for every canonical quickFilter bucket under the other criteria, before the active quickFilter. */
  quickFilterCounts: PurchaseOrderOverviewMetricsQuickFilterCounts;
  /** Counts for all allocation buckets across the other base criteria, before the active allocation filter and quickFilter. */
  allocationCounts: PurchaseOrderOverviewMetricsAllocationCounts;
  grouped?: PurchaseOrderOverviewGroup[];
  estimateMetadata: PurchaseOrderEstimateMetadata;
}

export type PurchaseOrderOverviewReadModelStatus = typeof PurchaseOrderOverviewReadModelStatus[keyof typeof PurchaseOrderOverviewReadModelStatus];


export const PurchaseOrderOverviewReadModelStatus = {
  preparing: 'preparing',
  ready: 'ready',
  stale: 'stale',
  fallback: 'fallback',
  unavailable: 'unavailable',
  failed: 'failed',
} as const;

export type PurchaseOrderOverviewReadModel = {
  status: PurchaseOrderOverviewReadModelStatus;
  /** @nullable */
  message: string | null;
  retryable: boolean;
  /** @minimum 0 */
  attempts: number;
};

export interface PurchaseOrderOverview {
  /** @maxItems 100 */
  items: PurchaseOrderCompact[];
  /** @nullable */
  nextCursor: string | null;
  hasMore: boolean;
  criteria: PurchaseOrderOverviewCriteria;
  /** True while the tenant-scoped read model is being prepared. */
  preparing?: boolean;
  readModel?: PurchaseOrderOverviewReadModel;
  metrics?: PurchaseOrderOverviewMetrics | null;
}

export type PurchaseOrderQuickSummaryCounts = {
  /** @minimum 0 */
  lines: number;
  /** @minimum 0 */
  allocatedLineCount: number;
  /** @minimum 0 */
  unallocatedLineCount: number;
  /** @minimum 0 */
  invoices: number;
  /** @minimum 0 */
  notes: number;
  /** @minimum 0 */
  documents: number;
};

export interface PurchaseOrderQuickSummary {
  id: string;
  orderNumber: string;
  status: string;
  /** @nullable */
  paymentState?: string | null;
  /** @nullable */
  total: number | null;
  /** @nullable */
  committed?: number | null;
  /** @nullable */
  inbound?: number | null;
  /** @nullable */
  outstanding?: number | null;
  /** @nullable */
  landed?: number | null;
  /** @nullable */
  resale?: number | null;
  /** @nullable */
  profit?: number | null;
  /** @nullable */
  receiving?: number | null;
  /** @maxItems 20 */
  warnings?: string[];
  /** @nullable */
  nextAction?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  turnaroundDays?: number | null;
  /** @nullable */
  source?: string | null;
  currency: string;
  counts: PurchaseOrderQuickSummaryCounts;
  estimateMetadata: PurchaseOrderEstimateMetadata;
}

export interface PurchaseOrderInvoiceOverview {
  id: string;
  /** @nullable */
  invoiceNumber: string | null;
  /** @nullable */
  total: number | null;
  currency?: string;
  /** @nullable */
  invoiceDate?: string | null;
}

export interface PurchaseOrderLineOverview {
  id: string;
  /** @nullable */
  sku?: string | null;
  description: string;
  /** @minimum 0 */
  quantity: number;
  /** @minimum 0 */
  quantityReceived: number;
  /** @nullable */
  unitCost: number | null;
  /** @nullable */
  inventoryItemId: string | null;
  /** @nullable */
  destinationSkuCode: string | null;
  /** @nullable */
  destinationSkuName: string | null;
  /** @nullable */
  destinationSkuCompositeImageUrl: string | null;
  /** @nullable */
  destinationSkuPrimaryImageUrl: string | null;
  /** @nullable */
  destinationSkuImageRevision: string | null;
  /** @nullable */
  landedCost?: number | null;
  /** @nullable */
  resaleValue?: number | null;
  /** @nullable */
  profit?: number | null;
  estimateMetadata?: PurchaseOrderEstimateMetadata;
  currency?: string;
}

export interface PurchaseOrderSectionPage {
  /** @nullable */
  nextCursor: string | null;
  hasMore: boolean;
}

export type PurchaseOrderInvoiceSection = PurchaseOrderSectionPage & {
  /** @maxItems 100 */
  items: PurchaseOrderInvoiceOverview[];
};

export type PurchaseOrderLineSection = PurchaseOrderSectionPage & {
  /** @maxItems 100 */
  items: PurchaseOrderLineOverview[];
};

export type PurchaseOrderShippingSectionShipmentsItem = {
  id: string;
  /** @nullable */
  carrier?: string | null;
  /** @nullable */
  trackingNumber?: string | null;
  status: string;
  /** @nullable */
  shippedAt?: string | null;
  /** @nullable */
  deliveredAt?: string | null;
};

export interface PurchaseOrderShippingSection {
  /** @maxItems 100 */
  shipments: PurchaseOrderShippingSectionShipmentsItem[];
  estimateMetadata: PurchaseOrderEstimateMetadata;
}

export type PurchaseOrderNoteSectionItemsItem = {
  id: string;
  body: string;
  createdAt: string;
  /** @nullable */
  authorName?: string | null;
};

export type PurchaseOrderNoteSection = PurchaseOrderSectionPage & {
  /** @maxItems 100 */
  items: PurchaseOrderNoteSectionItemsItem[];
};

export type PurchaseOrderDocumentSectionItemsItem = {
  id: string;
  filename: string;
  contentType: string;
  /**
     * @minimum 0
     * @nullable
     */
  sizeBytes?: number | null;
  createdAt: string;
};

export type PurchaseOrderDocumentSection = PurchaseOrderSectionPage & {
  /** @maxItems 100 */
  items: PurchaseOrderDocumentSectionItemsItem[];
};

export interface PurchaseOrderProfitability {
  /** @nullable */
  revenue: number | null;
  /** @nullable */
  cost: number | null;
  /** @nullable */
  grossProfit: number | null;
  /** @nullable */
  margin: number | null;
  /** @nullable */
  committed?: number | null;
  /** @nullable */
  inbound?: number | null;
  /** @nullable */
  outstanding?: number | null;
  /** @nullable */
  landed?: number | null;
  /** @nullable */
  resale?: number | null;
  /** @nullable */
  profit?: number | null;
  /** @nullable */
  receiving?: number | null;
  /** @maxItems 20 */
  warnings?: string[];
  /** @nullable */
  nextAction?: string | null;
  /** @nullable */
  source?: string | null;
  estimateMetadata: PurchaseOrderEstimateMetadata;
}

export interface PurchaseOrderSupplierPerformance {
  /** @nullable */
  supplierId: string | null;
  /** @nullable */
  supplierName?: string | null;
  /**
     * @minimum 0
     * @maximum 1
     * @nullable
     */
  deliveryReliability: number | null;
  /**
     * @minimum 0
     * @nullable
     */
  averageLeadTimeDays?: number | null;
  /**
     * @minimum 0
     * @maximum 1
     * @nullable
     */
  onTimeRate?: number | null;
  /**
     * @minimum 0
     * @nullable
     */
  benchmarkLeadTimeDays?: number | null;
  /**
     * @minimum 0
     * @maximum 1
     * @nullable
     */
  benchmarkOnTimeRate?: number | null;
  /**
     * @minimum 0
     * @maximum 1
     * @nullable
     */
  benchmarkReliability?: number | null;
  /**
     * @minimum 0
     * @nullable
     */
  turnaroundDays?: number | null;
  /** @nullable */
  source?: string | null;
  estimateMetadata: PurchaseOrderEstimateMetadata;
}

export type PurchaseOrderAuditSectionItemsItemChanges = { [key: string]: unknown };

export type PurchaseOrderAuditSectionItemsItem = {
  id: string;
  action: string;
  /** @nullable */
  actorName?: string | null;
  createdAt: string;
  changes?: PurchaseOrderAuditSectionItemsItemChanges;
};

export interface PurchaseOrderAuditSection {
  /** @maxItems 50 */
  items: PurchaseOrderAuditSectionItemsItem[];
  /** @nullable */
  nextCursor: string | null;
  hasMore: boolean;
}

export type PurchaseOrderExportRequestFormat = typeof PurchaseOrderExportRequestFormat[keyof typeof PurchaseOrderExportRequestFormat];


export const PurchaseOrderExportRequestFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export interface PurchaseOrderExportRequest {
  criteria: PurchaseOrderOverviewCriteria;
  format: PurchaseOrderExportRequestFormat;
  /**
     * @minimum 1
     * @maximum 10000
     */
  maxRows?: number;
}

export type PurchaseOrderExportStatus = typeof PurchaseOrderExportStatus[keyof typeof PurchaseOrderExportStatus];


export const PurchaseOrderExportStatus = {
  queued: 'queued',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
} as const;

export type PurchaseOrderExportFormat = typeof PurchaseOrderExportFormat[keyof typeof PurchaseOrderExportFormat];


export const PurchaseOrderExportFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type PurchaseOrderExportSummary = {
  /** @nullable */
  committed?: number | null;
  /** @nullable */
  inbound?: number | null;
  /** @nullable */
  outstanding?: number | null;
  /** @nullable */
  landed?: number | null;
  /** @nullable */
  resale?: number | null;
  /** @nullable */
  profit?: number | null;
  /** @nullable */
  receiving?: number | null;
  /** @maxItems 20 */
  warnings?: string[];
  /** @nullable */
  nextAction?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  turnaroundDays?: number | null;
  /** @nullable */
  source?: string | null;
  estimateMetadata?: PurchaseOrderEstimateMetadata;
};

export interface PurchaseOrderExport {
  exportId: string;
  status: PurchaseOrderExportStatus;
  format: PurchaseOrderExportFormat;
  summary?: PurchaseOrderExportSummary;
  /** @nullable */
  downloadUrl?: string | null;
  /** @nullable */
  expiresAt?: string | null;
}

export type VatPlanningSettingsStartDate = typeof VatPlanningSettingsStartDate[keyof typeof VatPlanningSettingsStartDate];


export const VatPlanningSettingsStartDate = {
  '2026-09-09': '2026-09-09',
} as const;

export type VatPlanningSettingsTimezone = typeof VatPlanningSettingsTimezone[keyof typeof VatPlanningSettingsTimezone];


export const VatPlanningSettingsTimezone = {
  'Europe/London': 'Europe/London',
} as const;

export interface VatPlanningSettings {
  enabled: boolean;
  startDate: VatPlanningSettingsStartDate;
  timezone: VatPlanningSettingsTimezone;
  enabledAt?: string | null;
  enabledByUserId?: string | null;
}

export type VatPlanningCatchUpResultStatus = typeof VatPlanningCatchUpResultStatus[keyof typeof VatPlanningCatchUpResultStatus];


export const VatPlanningCatchUpResultStatus = {
  RUNNING: 'RUNNING',
  PARTIAL: 'PARTIAL',
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
} as const;

export interface VatPlanningCatchUpResult {
  jobId: string;
  runEndAt: string;
  status: VatPlanningCatchUpResultStatus;
  examined: number;
  created: number;
  confirmedOutputVatPence: string;
  unresolvedCount: string;
  unresolvedConsiderationPence: string;
  hasMore: boolean;
  coverageStartAt: string;
  coverageEndAt?: string | null;
}

export type VatDueSummaryDisplayMode = typeof VatDueSummaryDisplayMode[keyof typeof VatDueSummaryDisplayMode];


export const VatDueSummaryDisplayMode = {
  PLANNING: 'PLANNING',
  STATUTORY: 'STATUTORY',
} as const;

export type VatDueSummaryCoverageStatus = typeof VatDueSummaryCoverageStatus[keyof typeof VatDueSummaryCoverageStatus];


export const VatDueSummaryCoverageStatus = {
  COMPLETE: 'COMPLETE',
  PARTIAL: 'PARTIAL',
  NOT_STARTED: 'NOT_STARTED',
} as const;

/**
 * @nullable
 */
export type VatDueSummaryPlanningJobStatus = typeof VatDueSummaryPlanningJobStatus[keyof typeof VatDueSummaryPlanningJobStatus] | null;


export const VatDueSummaryPlanningJobStatus = {
  RUNNING: 'RUNNING',
  PARTIAL: 'PARTIAL',
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
} as const;

export type VatDueSummaryUncoveredDateRange = {
  start?: string;
  end?: string;
} | null;

export interface VatDueSummary {
  periodStart: string;
  periodEnd: string;
  tenantTimezone: string;
  registrationEffectiveDate?: string | null;
  postingEnabled?: boolean;
  postingStatus?: string;
  /** Internal VAT planning mode is enabled */
  planningMode: boolean;
  displayMode: VatDueSummaryDisplayMode;
  postingEnabledAt?: string | null;
  schemaReady?: boolean;
  coverageStatus?: VatDueSummaryCoverageStatus;
  coverageStartDate?: string | null;
  /** Exclusive end of the latest successfully completed planning catch-up watermark */
  coverageEndDate?: string | null;
  /** @nullable */
  planningJobStatus?: VatDueSummaryPlanningJobStatus;
  planningQueueRemaining?: string;
  unresolvedHoldCount?: string;
  uncoveredDateRange?: VatDueSummaryUncoveredDateRange;
  isComplete: boolean;
  /** Minor currency units */
  confirmedOutputVat: string;
  standardVat: string;
  marginSchemeVat: string;
  exemptGrossValue?: string;
  outsideScopeGrossValue?: string;
  outsideRegistrationGrossValue?: string;
  unresolvedCount?: string;
  unresolvedValue?: string;
  pendingAllocationCount?: string;
  pendingAllocationValue?: string;
  grossRecognisedConsideration?: string;
  refundsCredits?: string;
  netRecognisedConsideration?: string;
}

export interface VatDueEntry {
  id: string;
  taxDate: string;
  orderReference?: string | null;
  channel?: string | null;
  sku?: string | null;
  item?: string | null;
  quantity?: number;
  vatTreatment: string;
  grossSellingConsideration: string;
  qualifyingPurchasePrice?: string;
  margin?: string;
  outputVat: string;
  calculationStatus: string;
  eventId?: string;
}

export type VatDueEntryPageDisplayMode = typeof VatDueEntryPageDisplayMode[keyof typeof VatDueEntryPageDisplayMode];


export const VatDueEntryPageDisplayMode = {
  PLANNING: 'PLANNING',
  STATUTORY: 'STATUTORY',
} as const;

export type VatDueEntryPageFilteredTotals = {
  outputVat?: string;
  consideration?: string;
};

export interface VatDueEntryPage {
  page: number;
  pageSize: number;
  total: string;
  /** Internal VAT planning mode is enabled */
  planningMode: boolean;
  displayMode: VatDueEntryPageDisplayMode;
  entries: VatDueEntry[];
  filteredTotals?: VatDueEntryPageFilteredTotals;
}

export type VatDueEntryDetailEvidenceSnapshot = { [key: string]: unknown };

export type VatDueEntryDetailDisplayMode = typeof VatDueEntryDetailDisplayMode[keyof typeof VatDueEntryDetailDisplayMode];


export const VatDueEntryDetailDisplayMode = {
  PLANNING: 'PLANNING',
  STATUTORY: 'STATUTORY',
} as const;

export type VatDueEntryDetailLineage = { [key: string]: unknown };

export interface VatDueEntryDetail {
  id: string;
  taxDate: string;
  taxPointAt?: string;
  orderReference?: string | null;
  channel?: string | null;
  eventId: string;
  eventType: string;
  saleOrderId?: string | null;
  saleOrderItemId?: string | null;
  allocationId?: string | null;
  lotId?: string | null;
  registrationPeriodId?: string | null;
  treatment: string;
  evidenceSnapshot?: VatDueEntryDetailEvidenceSnapshot;
  quantity: number;
  considerationPence: string;
  discountPence?: string;
  shippingPence?: string;
  qualifyingPurchasePricePence?: string;
  marginPence?: string;
  vatRateBasisPoints?: string;
  outputVatPence: string;
  status: string;
  /** Internal VAT planning mode is enabled */
  planningMode: boolean;
  displayMode: VatDueEntryDetailDisplayMode;
  lineage?: VatDueEntryDetailLineage;
  missingInformation?: string[];
  recommendedNextAction?: string | null;
  explanation?: string | null;
}

export type InventoryLotVatTreatment = typeof InventoryLotVatTreatment[keyof typeof InventoryLotVatTreatment];


export const InventoryLotVatTreatment = {
  VAT_EXEMPT_GOLD: 'VAT_EXEMPT_GOLD',
  MARGIN_SCHEME: 'MARGIN_SCHEME',
  STANDARD_VAT: 'STANDARD_VAT',
} as const;

export interface InventoryLotVatReview {
  id: string;
  lotRef: string;
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  quantityAvailable: number;
  treatment: InventoryLotVatTreatment | null;
  reviewStatus: string | null;
  effectiveUnitCost: string | null;
}

export interface InventoryLotVatReviewPage {
  page: number;
  pageSize: number;
  total: string;
  lots: InventoryLotVatReview[];
}

export interface InventoryLotVatClassificationInput {
  treatment: InventoryLotVatTreatment;
}

export interface InventoryLotVatClassification {
  id: string;
  treatment: InventoryLotVatTreatment;
  reviewStatus: string;
}

export interface InventoryLotVatBulkClassificationInput {
  /**
     * @minItems 1
     * @maxItems 100
     */
  lotIds: string[];
  treatment: InventoryLotVatTreatment;
}

export interface InventoryLotVatBulkClassificationResult {
  updated: number;
  lots: InventoryLotVatClassification[];
}

export type CanonicalMarketQuoteMetal = typeof CanonicalMarketQuoteMetal[keyof typeof CanonicalMarketQuoteMetal];


export const CanonicalMarketQuoteMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
  copper: 'copper',
} as const;

export type CanonicalMarketQuoteCurrency = typeof CanonicalMarketQuoteCurrency[keyof typeof CanonicalMarketQuoteCurrency];


export const CanonicalMarketQuoteCurrency = {
  GBP: 'GBP',
  USD: 'USD',
  EUR: 'EUR',
  CAD: 'CAD',
  AUD: 'AUD',
} as const;

export type CanonicalMarketQuoteCanonicalUnit = typeof CanonicalMarketQuoteCanonicalUnit[keyof typeof CanonicalMarketQuoteCanonicalUnit];


export const CanonicalMarketQuoteCanonicalUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

export type CanonicalMarketQuoteSource = typeof CanonicalMarketQuoteSource[keyof typeof CanonicalMarketQuoteSource];


export const CanonicalMarketQuoteSource = {
  twelve_data: 'twelve_data',
  yahoo: 'yahoo',
} as const;

export type CanonicalMarketQuoteQuality = typeof CanonicalMarketQuoteQuality[keyof typeof CanonicalMarketQuoteQuality];


export const CanonicalMarketQuoteQuality = {
  LIVE: 'LIVE',
  DELAYED: 'DELAYED',
  STALE: 'STALE',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type CanonicalMarketQuoteProvenance = { [key: string]: unknown };

export interface CanonicalMarketQuote {
  metal: CanonicalMarketQuoteMetal;
  currency: CanonicalMarketQuoteCurrency;
  /** @nullable */
  value: number | null;
  canonicalUnit: CanonicalMarketQuoteCanonicalUnit;
  source: CanonicalMarketQuoteSource;
  sourceSymbol: string;
  /** @nullable */
  sourceTimestamp: string | null;
  retrievedAt: string;
  quality: CanonicalMarketQuoteQuality;
  /** @minimum 0 */
  sequence: number;
  provenance: CanonicalMarketQuoteProvenance;
}

export type CanonicalMarketSnapshotQuality = typeof CanonicalMarketSnapshotQuality[keyof typeof CanonicalMarketSnapshotQuality];


export const CanonicalMarketSnapshotQuality = {
  LIVE: 'LIVE',
  DELAYED: 'DELAYED',
  STALE: 'STALE',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export interface CanonicalMarketSnapshot {
  /** @minimum 0 */
  sequence: number;
  retrievedAt: string;
  quality: CanonicalMarketSnapshotQuality;
  quotes: CanonicalMarketQuote[];
}

export type IntelligenceFoundationResponseNamespace = typeof IntelligenceFoundationResponseNamespace[keyof typeof IntelligenceFoundationResponseNamespace];


export const IntelligenceFoundationResponseNamespace = {
  operations: 'operations',
  'customer-journey': 'customer-journey',
} as const;

export type IntelligenceFoundationResponseLimits = {
  /** @minimum 1 */
  defaultBatchSize: number;
  /**
     * @minimum 1
     * @maximum 500
     */
  maxBatchSize: number;
};

export interface IntelligenceFoundationResponse {
  namespace: IntelligenceFoundationResponseNamespace;
  enabledFeatures: string[];
  jobs: string[];
  limits: IntelligenceFoundationResponseLimits;
  contractsVersion: string;
}

export type OperationsActionReferencePriorityBand = typeof OperationsActionReferencePriorityBand[keyof typeof OperationsActionReferencePriorityBand];


export const OperationsActionReferencePriorityBand = {
  NOW: 'NOW',
  NEXT: 'NEXT',
  LATER: 'LATER',
} as const;

/**
 * Lightweight reference to a canonical record; never a duplicate business record.
 */
export interface OperationsActionReference {
  /** @maxLength 48 */
  sourceModule: string;
  /** @maxLength 64 */
  sourceType: string;
  sourceId: string;
  /** @maxLength 64 */
  actionType: string;
  title: string;
  /** @nullable */
  summary?: string | null;
  priorityScore?: number;
  priorityBand: OperationsActionReferencePriorityBand;
  reasonCodes?: string[];
  /** deterministic or approved_model */
  generatedBy: string;
  provenance: string;
  ruleVersion: string;
  sourceProvenance?: string;
}

export type OperationsEventActorType = typeof OperationsEventActorType[keyof typeof OperationsEventActorType];


export const OperationsEventActorType = {
  staff: 'staff',
  system: 'system',
  integration: 'integration',
  customer: 'customer',
} as const;

export type OperationsEventVisibilityScope = typeof OperationsEventVisibilityScope[keyof typeof OperationsEventVisibilityScope];


export const OperationsEventVisibilityScope = {
  TENANT: 'TENANT',
  TEAM: 'TEAM',
  PRIVATE: 'PRIVATE',
  MANAGERS: 'MANAGERS',
} as const;

/**
 * Allow-listed non-sensitive metadata only; never passwords, tokens, card data, keystrokes or raw form contents.
 */
export type OperationsEventMetadata = { [key: string]: unknown };

/**
 * Curated staff activity, separate from the append-only forensic audit log.
 */
export interface OperationsEvent {
  /** @maxLength 64 */
  eventType: string;
  /** @maxLength 48 */
  module: string;
  /** @nullable */
  entityType?: string | null;
  /** @nullable */
  entityId?: string | null;
  actorType: OperationsEventActorType;
  /** @nullable */
  actorUserId?: string | null;
  title: string;
  /**
     * Human-safe summary; credentials and confidential field values are forbidden.
     * @nullable
     */
  summary?: string | null;
  occurredAt: string;
  source: string;
  provenance: string;
  ruleVersion: string;
  /** @nullable */
  dedupeKey?: string | null;
  visibilityScope: OperationsEventVisibilityScope;
  /** @nullable */
  retentionUntil?: string | null;
  /** @nullable */
  correlationId?: string | null;
  /** Allow-listed non-sensitive metadata only; never passwords, tokens, card data, keystrokes or raw form contents. */
  metadata?: OperationsEventMetadata;
}

export type CustomerBehaviourEventEventCategory = typeof CustomerBehaviourEventEventCategory[keyof typeof CustomerBehaviourEventEventCategory];


export const CustomerBehaviourEventEventCategory = {
  SESSION: 'SESSION',
  NAVIGATION: 'NAVIGATION',
  PRODUCT_INTEREST: 'PRODUCT_INTEREST',
  SEARCH: 'SEARCH',
  BOX: 'BOX',
  WISHLIST: 'WISHLIST',
  CHECKOUT: 'CHECKOUT',
  ORDER: 'ORDER',
  PAYMENT: 'PAYMENT',
  FULFILMENT: 'FULFILMENT',
  PRE_ORDER: 'PRE_ORDER',
  SUPPORT: 'SUPPORT',
  PORTFOLIO: 'PORTFOLIO',
  MESSAGING: 'MESSAGING',
} as const;

export type CustomerBehaviourEventSource = typeof CustomerBehaviourEventSource[keyof typeof CustomerBehaviourEventSource];


export const CustomerBehaviourEventSource = {
  first_party: 'first_party',
  server: 'server',
  import: 'import',
} as const;

export type CustomerBehaviourEventVisibilityScope = typeof CustomerBehaviourEventVisibilityScope[keyof typeof CustomerBehaviourEventVisibilityScope];


export const CustomerBehaviourEventVisibilityScope = {
  TENANT: 'TENANT',
  TEAM: 'TEAM',
  PRIVATE: 'PRIVATE',
  MANAGERS: 'MANAGERS',
} as const;

export type CustomerBehaviourEventConsentState = typeof CustomerBehaviourEventConsentState[keyof typeof CustomerBehaviourEventConsentState];


export const CustomerBehaviourEventConsentState = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  GRANTED: 'GRANTED',
  DENIED: 'DENIED',
  WITHDRAWN: 'WITHDRAWN',
  UNKNOWN: 'UNKNOWN',
} as const;

/**
 * Allow-listed non-sensitive metadata only.
 */
export type CustomerBehaviourEventMetadata = { [key: string]: unknown };

/**
 * First-party intent/behaviour signal. ORDER_PAID is a reference to, not a replacement for, the canonical sale.
 */
export interface CustomerBehaviourEvent {
  /** @nullable */
  customerId?: string | null;
  /** @nullable */
  sessionId?: string | null;
  /** @nullable */
  anonymousVisitorId?: string | null;
  /** Source-scoped idempotency key. */
  sourceEventId: string;
  eventType: string;
  eventCategory: CustomerBehaviourEventEventCategory;
  occurredAt: string;
  source: CustomerBehaviourEventSource;
  provenance: string;
  ruleVersion: string;
  visibilityScope: CustomerBehaviourEventVisibilityScope;
  consentState: CustomerBehaviourEventConsentState;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  orderId?: string | null;
  /**
     * One-way hash only; raw search text is not retained here.
     * @nullable
     */
  searchQueryHash?: string | null;
  /** @nullable */
  retentionUntil?: string | null;
  /** Allow-listed non-sensitive metadata only. */
  metadata?: CustomerBehaviourEventMetadata;
}

export interface CustomerBehaviourSummary {
  customerId: string;
  summaryPeriodStart: string;
  summaryPeriodEnd: string;
  /** @minimum 0 */
  orderCount?: number;
  /** @nullable */
  averageIntervalDays?: number | null;
  /** @nullable */
  medianIntervalDays?: number | null;
  calculationVersion: string;
  generatedAt: string;
}

export interface OperationsChecklist {
  name: string;
  category: string;
  frequency: string;
  triggerType: string;
  /** @minimum 1 */
  version: number;
  active: boolean;
  /** @nullable */
  appliesToRole?: string | null;
  /** @nullable */
  appliesToTeam?: string | null;
  /** @nullable */
  appliesToLocation?: string | null;
}

export type ExceptionSeverity = typeof ExceptionSeverity[keyof typeof ExceptionSeverity];


export const ExceptionSeverity = {
  P0: 'P0',
  P1: 'P1',
  P2: 'P2',
  P3: 'P3',
  P4: 'P4',
  P5: 'P5',
} as const;

export type ExceptionCategory = typeof ExceptionCategory[keyof typeof ExceptionCategory];


export const ExceptionCategory = {
  inventory: 'inventory',
  sales: 'sales',
  marketplace: 'marketplace',
  packing: 'packing',
  returns: 'returns',
  finance: 'finance',
  compliance: 'compliance',
  infrastructure: 'infrastructure',
} as const;

export type ExceptionStatus = typeof ExceptionStatus[keyof typeof ExceptionStatus];


export const ExceptionStatus = {
  open: 'open',
  acknowledged: 'acknowledged',
  snoozed: 'snoozed',
  waiting_external: 'waiting_external',
  waiting_customer: 'waiting_customer',
  resolved: 'resolved',
  dismissed: 'dismissed',
} as const;

export interface ExceptionAffectedRecord {
  type: string;
  id: string;
  label?: string | null;
  href?: string | null;
}

export type OpsExceptionScoreFactors = { [key: string]: unknown };

export type OpsExceptionResolutionKind = typeof OpsExceptionResolutionKind[keyof typeof OpsExceptionResolutionKind] | null;


export const OpsExceptionResolutionKind = {
  manual: 'manual',
  auto: 'auto',
} as const;

export interface OpsException {
  id: string;
  dedupeKey: string;
  category: ExceptionCategory;
  severity: ExceptionSeverity;
  status: ExceptionStatus;
  title: string;
  description?: string | null;
  sourceDetector: string;
  affectedRecords: ExceptionAffectedRecord[];
  scoreFactors?: OpsExceptionScoreFactors;
  urgencyScore: number;
  occurrenceCount: number;
  firstSeenAt: string;
  lastSeenAt: string;
  slaAcknowledgeBy?: string | null;
  slaActionBy?: string | null;
  slaResolveBy?: string | null;
  assignedUserId?: string | null;
  acknowledgedAt?: string | null;
  acknowledgedBy?: string | null;
  resolvedAt?: string | null;
  resolvedBy?: string | null;
  resolutionKind?: OpsExceptionResolutionKind;
  resolutionNote?: string | null;
  snoozedUntil?: string | null;
  escalationLevel: number;
  escalatedAt?: string | null;
  matchedRuleId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type ExceptionListResponseSeverityCounts = {[key: string]: number};

export interface ExceptionListResponse {
  exceptions: OpsException[];
  total: number;
  severityCounts: ExceptionListResponseSeverityCounts;
}

export type ExceptionOccurrencePayload = { [key: string]: unknown };

export interface ExceptionOccurrence {
  id: string;
  occurredAt: string;
  detail?: string | null;
  payload?: ExceptionOccurrencePayload;
}

export interface ExceptionDetailResponse {
  exception: OpsException;
  occurrences: ExceptionOccurrence[];
}

export interface ExceptionResponse {
  exception: OpsException;
}

export type ExceptionActionInputAction = typeof ExceptionActionInputAction[keyof typeof ExceptionActionInputAction];


export const ExceptionActionInputAction = {
  assign: 'assign',
  acknowledge: 'acknowledge',
  resolve: 'resolve',
  dismiss: 'dismiss',
  snooze: 'snooze',
  waiting_external: 'waiting_external',
  waiting_customer: 'waiting_customer',
  reopen: 'reopen',
} as const;

export interface ExceptionActionInput {
  action: ExceptionActionInputAction;
  /** For `assign` — target user id; omit to self-assign, null/empty to unassign. */
  assignedUserId?: string | null;
  note?: string | null;
  snoozeUntil?: string | null;
}

export interface ExceptionRule {
  id: string;
  name: string;
  enabled: boolean;
  matchCategory?: ExceptionCategory | null;
  matchDetector?: string | null;
  matchKeyword?: string | null;
  minUrgencyScore?: number | null;
  setSeverity?: ExceptionSeverity | null;
  assignUserId?: string | null;
  notify: boolean;
  autoResolveAfterHours?: number | null;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface ExceptionRuleInput {
  /** @maxLength 200 */
  name: string;
  enabled?: boolean;
  matchCategory?: ExceptionCategory | null;
  matchDetector?: string | null;
  matchKeyword?: string | null;
  minUrgencyScore?: number | null;
  setSeverity?: ExceptionSeverity | null;
  assignUserId?: string | null;
  notify?: boolean;
  autoResolveAfterHours?: number | null;
  sortOrder?: number;
}

export interface ExceptionRuleResponse {
  rule: ExceptionRule;
}

export interface ExceptionRuleListResponse {
  rules: ExceptionRule[];
}

export interface ExceptionRuleTestResponse {
  testedAgainst: number;
  matched: number;
  sample: OpsException[];
}

/**
 * Full StudioSettings snapshot (background, reflection, shadows, enhance/adjust).
 */
export type CompositePresetSettings = { [key: string]: unknown };

export interface CompositePreset {
  id: string;
  tenant_id: string;
  /** @maxLength 200 */
  name: string;
  /** Full StudioSettings snapshot (background, reflection, shadows, enhance/adjust). */
  settings: CompositePresetSettings;
  platform_default: boolean;
  created_at: string;
}

export interface ListCompositePresetsResponse {
  presets: CompositePreset[];
}

export interface CompositePresetResponse {
  preset: CompositePreset;
}

export type CreateCompositePresetBodySettings = { [key: string]: unknown };

export interface CreateCompositePresetBody {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  settings: CreateCompositePresetBodySettings;
}

export type UpdateCompositePresetBodySettings = { [key: string]: unknown };

export interface UpdateCompositePresetBody {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name?: string;
  settings?: UpdateCompositePresetBodySettings;
}

export interface DashboardAccessAck {
  ok: boolean;
}

export interface AccountTenantInfo {
  id: string;
  name: string;
  slug?: string | null;
  status?: string | null;
  createdAt?: string | null;
}

export interface AccountFeatureItem {
  key: string;
  label: string;
  description?: string | null;
  enabled: boolean;
  platformOwnerOnly?: boolean;
}

export type AccountSubscriptionStatus = typeof AccountSubscriptionStatus[keyof typeof AccountSubscriptionStatus];


export const AccountSubscriptionStatus = {
  active: 'active',
  trial: 'trial',
  expired: 'expired',
  none: 'none',
} as const;

export type AccountSubscriptionFeatures = {[key: string]: boolean};

export type AccountSubscriptionLimits = {[key: string]: number};

export interface AccountSubscription {
  plan: string;
  status: AccountSubscriptionStatus;
  validUntil?: string | null;
  features?: AccountSubscriptionFeatures;
  limits?: AccountSubscriptionLimits;
}

export type AccountServiceNoteCategory = typeof AccountServiceNoteCategory[keyof typeof AccountServiceNoteCategory];


export const AccountServiceNoteCategory = {
  announcement: 'announcement',
  maintenance: 'maintenance',
  incident: 'incident',
  info: 'info',
} as const;

export type AccountServiceNoteSeverity = typeof AccountServiceNoteSeverity[keyof typeof AccountServiceNoteSeverity];


export const AccountServiceNoteSeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;

export interface AccountServiceNote {
  id: string;
  title: string;
  body: string;
  category: AccountServiceNoteCategory;
  severity: AccountServiceNoteSeverity;
  pinned: boolean;
  publishedAt?: string | null;
  expiresAt?: string | null;
}

export interface AccountSupportContact {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  url?: string | null;
}

export interface AccountSettings {
  accountContactName?: string | null;
  accountContactEmail?: string | null;
  accountContactPhone?: string | null;
  companyNote?: string | null;
  onboardingCompleted: boolean;
  onboardingCompletedSteps: string[];
  onboardingCompletedAt?: string | null;
  brandingSelfServiceEnabled: boolean;
}

export interface AccountOnboardingStep {
  key: string;
  label: string;
  done: boolean;
}

export interface AccountSummary {
  tenant: AccountTenantInfo;
  subscription: AccountSubscription;
  features: AccountFeatureItem[];
  announcements: AccountServiceNote[];
  support: AccountSupportContact;
  settings: AccountSettings;
  onboardingSteps: AccountOnboardingStep[];
  canManage: boolean;
  canRequestFeature: boolean;
  brandingSelfServiceEnabled: boolean;
}

export type FeatureCatalogueOpenRequestStatus = typeof FeatureCatalogueOpenRequestStatus[keyof typeof FeatureCatalogueOpenRequestStatus];


export const FeatureCatalogueOpenRequestStatus = {
  submitted: 'submitted',
  under_review: 'under_review',
  approved: 'approved',
  rejected: 'rejected',
  planned: 'planned',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export interface FeatureCatalogueOpenRequest {
  id: string;
  status: FeatureCatalogueOpenRequestStatus;
  createdAt?: string | null;
}

export interface FeatureCatalogueItem {
  key: string;
  label: string;
  description?: string | null;
  emoji?: string | null;
  benefits: string[];
  enabled: boolean;
  platformOwnerOnly: boolean;
  openRequest?: FeatureCatalogueOpenRequest | null;
}

export interface FeatureCatalogue {
  items: FeatureCatalogueItem[];
  canRequestFeature: boolean;
}

export interface AccountPlanFeature {
  key: string;
  label: string;
}

export type AccountPlanOptionRelation = typeof AccountPlanOptionRelation[keyof typeof AccountPlanOptionRelation];


export const AccountPlanOptionRelation = {
  current: 'current',
  upgrade: 'upgrade',
  downgrade: 'downgrade',
  available: 'available',
} as const;

export interface AccountPlanOption {
  id: string;
  slug: string;
  name: string;
  tagline?: string | null;
  description?: string | null;
  monthlyPricePence?: number | null;
  yearlyPricePence?: number | null;
  setupFeePence?: number | null;
  trialDays: number;
  userLimit?: number | null;
  orderLimit?: number | null;
  storageLimitMb?: number | null;
  supportLevel?: string | null;
  ctaText?: string | null;
  highlights: string[];
  features: AccountPlanFeature[];
  isFeatured: boolean;
  isCurrent: boolean;
  relation: AccountPlanOptionRelation;
}

export type AccountSubscriptionPendingRequestRequestType = typeof AccountSubscriptionPendingRequestRequestType[keyof typeof AccountSubscriptionPendingRequestRequestType];


export const AccountSubscriptionPendingRequestRequestType = {
  upgrade: 'upgrade',
  downgrade: 'downgrade',
  renewal: 'renewal',
  cancellation: 'cancellation',
} as const;

export type AccountSubscriptionPendingRequestBillingFrequency = typeof AccountSubscriptionPendingRequestBillingFrequency[keyof typeof AccountSubscriptionPendingRequestBillingFrequency] | null;


export const AccountSubscriptionPendingRequestBillingFrequency = {
  monthly: 'monthly',
  yearly: 'yearly',
} as const;

export interface AccountSubscriptionPendingRequest {
  requestType: AccountSubscriptionPendingRequestRequestType;
  targetPlanSlug?: string | null;
  targetPlanName?: string | null;
  billingFrequency?: AccountSubscriptionPendingRequestBillingFrequency;
  note?: string | null;
  requestedAt: string;
}

export type AccountSubscriptionDetailStatus = typeof AccountSubscriptionDetailStatus[keyof typeof AccountSubscriptionDetailStatus];


export const AccountSubscriptionDetailStatus = {
  active: 'active',
  trial: 'trial',
  past_due: 'past_due',
  cancelled: 'cancelled',
  expired: 'expired',
  none: 'none',
} as const;

export type AccountSubscriptionDetailBillingFrequency = typeof AccountSubscriptionDetailBillingFrequency[keyof typeof AccountSubscriptionDetailBillingFrequency];


export const AccountSubscriptionDetailBillingFrequency = {
  monthly: 'monthly',
  yearly: 'yearly',
} as const;

export type AccountSubscriptionDetailFeatures = {[key: string]: boolean};

export type AccountSubscriptionDetailLimits = {[key: string]: number};

export interface AccountSubscriptionDetail {
  status: AccountSubscriptionDetailStatus;
  planId?: string | null;
  planSlug?: string | null;
  planName?: string | null;
  billingFrequency: AccountSubscriptionDetailBillingFrequency;
  currentPricePence?: number | null;
  currentPeriodStart?: string | null;
  currentPeriodEnd?: string | null;
  nextBillingAt?: string | null;
  trialEndsAt?: string | null;
  trialDays?: number | null;
  cancelAtPeriodEnd: boolean;
  validUntil?: string | null;
  supportLevel?: string | null;
  features: AccountSubscriptionDetailFeatures;
  limits: AccountSubscriptionDetailLimits;
  pendingRequest?: AccountSubscriptionPendingRequest | null;
}

export interface AccountSubscriptionView {
  subscription: AccountSubscriptionDetail;
  currentPlan?: AccountPlanOption | null;
  availablePlans: AccountPlanOption[];
  canRequestPlanChange: boolean;
  allowOnlineUpgrade: boolean;
}

export type AccountUsageMetricUnit = typeof AccountUsageMetricUnit[keyof typeof AccountUsageMetricUnit];


export const AccountUsageMetricUnit = {
  count: 'count',
  mb: 'mb',
} as const;

export type AccountUsageMetricStatus = typeof AccountUsageMetricStatus[keyof typeof AccountUsageMetricStatus];


export const AccountUsageMetricStatus = {
  safe: 'safe',
  approaching: 'approaching',
  limit_reached: 'limit_reached',
  over: 'over',
} as const;

export interface AccountUsageMetric {
  key: string;
  label: string;
  description: string;
  used: number;
  limit?: number | null;
  unlimited: boolean;
  unit: AccountUsageMetricUnit;
  period?: string | null;
  percent?: number | null;
  status: AccountUsageMetricStatus;
}

export interface AccountUsageView {
  generatedAt: string;
  planName?: string | null;
  planSlug?: string | null;
  supportLevel?: string | null;
  metrics: AccountUsageMetric[];
  nearLimitKeys: string[];
  hasWarnings: boolean;
  canRequestIncrease: boolean;
}

export type TrialViewStatus = typeof TrialViewStatus[keyof typeof TrialViewStatus];


export const TrialViewStatus = {
  active: 'active',
  ending_soon: 'ending_soon',
  expired: 'expired',
  converted: 'converted',
  cancelled: 'cancelled',
} as const;

export type TrialExtensionRequestStatus = typeof TrialExtensionRequestStatus[keyof typeof TrialExtensionRequestStatus];


export const TrialExtensionRequestStatus = {
  pending: 'pending',
  approved: 'approved',
  declined: 'declined',
} as const;

export interface TrialExtensionRequest {
  status: TrialExtensionRequestStatus;
  requestedDays: number;
  requestedByUserId?: string | null;
  requestedByEmail?: string | null;
  note?: string | null;
  requestedAt: string;
  resolvedAt?: string | null;
  resolvedByUserId?: string | null;
}

export type TrialViewMetadata = { [key: string]: unknown };

export interface TrialView {
  id: string;
  tenantId?: string | null;
  planId?: string | null;
  status: string;
  viewStatus: TrialViewStatus;
  startsAt: string;
  expiresAt?: string | null;
  daysRemaining?: number | null;
  totalDays?: number | null;
  isEndingSoon: boolean;
  isExpired: boolean;
  notes?: string | null;
  metadata?: TrialViewMetadata;
}

export interface AccountTrialFeature {
  key: string;
  label: string;
  description?: string | null;
  enabled: boolean;
}

export interface AccountTrialPlan {
  id: string;
  slug: string;
  name: string;
  monthlyPricePence?: number | null;
  yearlyPricePence?: number | null;
  trialDays?: number | null;
}

export interface AccountTrialView {
  trial: TrialView | null;
  plan?: AccountTrialPlan | null;
  includedFeatures?: AccountTrialFeature[];
  usage?: AccountUsageView;
  extensionRequest?: TrialExtensionRequest | null;
  canRequestExtension?: boolean;
}

export interface RequestTrialExtensionInput {
  /**
     * @minimum 1
     * @maximum 90
     */
  requestedDays?: number;
  note?: string;
}

export interface RequestTrialExtensionResult {
  extensionRequest: TrialExtensionRequest;
  alreadyRequested: boolean;
}

export type BillingInvoiceStatus = typeof BillingInvoiceStatus[keyof typeof BillingInvoiceStatus];


export const BillingInvoiceStatus = {
  draft: 'draft',
  issued: 'issued',
  partially_paid: 'partially_paid',
  paid: 'paid',
  overdue: 'overdue',
  cancelled: 'cancelled',
  refunded: 'refunded',
  written_off: 'written_off',
} as const;

export interface AccountBillingContact {
  id: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  role?: string | null;
  isPrimary: boolean;
}

export interface AccountBillingInvoiceItem {
  id: string;
  description: string;
  quantity: number;
  unitPricePence: number;
  vatRate: number;
  lineSubtotalPence: number;
  lineVatPence: number;
  lineTotalPence: number;
}

export interface AccountBillingInvoice {
  id: string;
  invoiceNumber: string;
  status: BillingInvoiceStatus;
  currency: string;
  issueDate?: string | null;
  dueDate?: string | null;
  subtotalPence: number;
  vatPence: number;
  totalPence: number;
  amountPaidPence: number;
  balancePence: number;
  notes?: string | null;
  periodStart?: string | null;
  periodEnd?: string | null;
  paidAt?: string | null;
  createdAt: string;
}

export type AccountBillingInvoiceDetail = AccountBillingInvoice & ({
  tenantId?: string | null;
  items: AccountBillingInvoiceItem[];
});

export interface AccountBillingInvoiceList {
  invoices: AccountBillingInvoice[];
  total: number;
}

export interface AccountBillingPayment {
  id: string;
  invoiceId?: string | null;
  invoiceNumber?: string | null;
  amountPence: number;
  currency: string;
  method: string;
  status: string;
  reference?: string | null;
  paidAt?: string | null;
  createdAt: string;
}

export interface AccountBillingPaymentList {
  payments: AccountBillingPayment[];
  total: number;
}

export type AccountBillingPaymentMethodType = typeof AccountBillingPaymentMethodType[keyof typeof AccountBillingPaymentMethodType];


export const AccountBillingPaymentMethodType = {
  paypal: 'paypal',
  card: 'card',
  bank_account: 'bank_account',
} as const;

export interface AccountBillingPaymentMethod {
  id: string;
  type: AccountBillingPaymentMethodType;
  label?: string | null;
  brand?: string | null;
  last4?: string | null;
  isDefault: boolean;
}

export interface AccountBillingPaymentMethodList {
  paymentMethods: AccountBillingPaymentMethod[];
}

export type AccountBillingPaypalConfigMode = typeof AccountBillingPaypalConfigMode[keyof typeof AccountBillingPaypalConfigMode] | null;


export const AccountBillingPaypalConfigMode = {
  sandbox: 'sandbox',
  live: 'live',
} as const;

export interface AccountBillingPaypalConfig {
  configured: boolean;
  mode?: AccountBillingPaypalConfigMode;
}

export interface CreateAccountBillingPaypalOrderBody {
  /** @minItems 1 */
  invoiceIds: string[];
}

export interface AccountBillingPaypalOrder {
  orderId: string;
  approveUrl: string;
  amountPence: number;
  invoiceIds: string[];
}

export interface CaptureAccountBillingPaypalOrderBody {
  orderId: string;
}

export type AccountBillingPaypalCaptureResultStatus = typeof AccountBillingPaypalCaptureResultStatus[keyof typeof AccountBillingPaypalCaptureResultStatus];


export const AccountBillingPaypalCaptureResultStatus = {
  paid: 'paid',
} as const;

export interface AccountBillingPaypalCaptureResult {
  status: AccountBillingPaypalCaptureResultStatus;
  paidInvoiceIds: string[];
  amountPence: number;
  alreadyCaptured: boolean;
}

export interface AccountSecurityOverview {
  passwordEnabled: boolean;
  twoFactorEnabled: boolean;
  totpEnabled: boolean;
  backupCodeEnabled: boolean;
  email?: string | null;
  /** In-app Clerk profile route the FE deep-links to for password / 2FA management. */
  manageUrl: string;
}

export interface AccountSecuritySession {
  id: string;
  status: string;
  current: boolean;
  lastActiveAt?: string | null;
  createdAt?: string | null;
  expireAt?: string | null;
  deviceType?: string | null;
  isMobile?: boolean | null;
  browserName?: string | null;
  browserVersion?: string | null;
  ipAddress?: string | null;
  city?: string | null;
  country?: string | null;
}

export interface AccountSecuritySessionList {
  sessions: AccountSecuritySession[];
  currentSessionId?: string | null;
}

export interface RevokeSessionInput {
  /** @minLength 1 */
  sessionId: string;
}

export interface RevokeSessionResult {
  revoked: boolean;
}

export interface RevokeOtherSessionsResult {
  revoked: number;
  failed: number;
}

export type AccountSecurityActivityEntryDetail = { [key: string]: unknown };

export interface AccountSecurityActivityEntry {
  id: string;
  /** Full audit action, e.g. `account_security.sign_in`. */
  action: string;
  detail: AccountSecurityActivityEntryDetail;
  createdAt: string;
}

export interface AccountSecurityActivityList {
  entries: AccountSecurityActivityEntry[];
}

export type AccountBillingAccountStatus = typeof AccountBillingAccountStatus[keyof typeof AccountBillingAccountStatus];


export const AccountBillingAccountStatus = {
  active: 'active',
  past_due: 'past_due',
  suspended: 'suspended',
  closed: 'closed',
} as const;

export interface AccountBillingAccount {
  status: AccountBillingAccountStatus;
  billingEmail?: string | null;
  currency: string;
  paymentTermsDays: number;
  companyName?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  vatNumber?: string | null;
  companyRegNumber?: string | null;
}

export interface AccountBillingSummary {
  account: AccountBillingAccount;
  currency: string;
  outstandingBalancePence: number;
  overdueBalancePence: number;
  nextPaymentDate?: string | null;
  openInvoiceCount: number;
  overdueInvoiceCount: number;
  contacts: AccountBillingContact[];
  recentInvoices: AccountBillingInvoice[];
  recentPayments: AccountBillingPayment[];
  paymentMethods: AccountBillingPaymentMethod[];
  canPay: boolean;
  canManagePaymentMethods: boolean;
}

export interface CreatePlatformBillingInvoiceItemInput {
  /**
     * @minLength 1
     * @maxLength 500
     */
  description: string;
  /** @minimum 1 */
  quantity: number;
  unitPricePence: number;
  /**
     * @minimum 0
     * @maximum 100
     */
  vatRate?: number;
}

export interface CreatePlatformBillingInvoiceInput {
  issue?: boolean;
  /** When issuing, email the invoice (PDF + Account Portal link) to the tenant's billing email / primary contact. Ignored when saving a draft. */
  sendEmail?: boolean;
  currency?: string;
  issueDate?: string | null;
  dueDate?: string | null;
  /** @maxLength 2000 */
  notes?: string | null;
  periodStart?: string | null;
  periodEnd?: string | null;
  /** @minItems 1 */
  items: CreatePlatformBillingInvoiceItemInput[];
}

export interface IssuePlatformBillingInvoiceInput {
  /** Email the issued invoice (PDF + Account Portal link) to the tenant's billing email / primary contact. */
  sendEmail?: boolean;
}

export type MarkPlatformBillingInvoicePaidInputMethod = typeof MarkPlatformBillingInvoicePaidInputMethod[keyof typeof MarkPlatformBillingInvoicePaidInputMethod];


export const MarkPlatformBillingInvoicePaidInputMethod = {
  manual: 'manual',
  bank_transfer: 'bank_transfer',
  card: 'card',
  paypal: 'paypal',
  other: 'other',
} as const;

export interface MarkPlatformBillingInvoicePaidInput {
  amountPence?: number | null;
  method?: MarkPlatformBillingInvoicePaidInputMethod;
  /** @maxLength 200 */
  reference?: string | null;
  paidAt?: string | null;
  /** @maxLength 2000 */
  notes?: string | null;
}

export interface UpdatePlatformBillingInvoiceInput {
  currency?: string;
  dueDate?: string | null;
  /** @maxLength 2000 */
  notes?: string | null;
  periodStart?: string | null;
  periodEnd?: string | null;
  /** @minItems 1 */
  items: CreatePlatformBillingInvoiceItemInput[];
}

export interface DeletePlatformBillingInvoiceResult {
  ok: boolean;
  id: string;
}

export type RequestPlanChangeInputRequestType = typeof RequestPlanChangeInputRequestType[keyof typeof RequestPlanChangeInputRequestType];


export const RequestPlanChangeInputRequestType = {
  upgrade: 'upgrade',
  downgrade: 'downgrade',
  renewal: 'renewal',
  cancellation: 'cancellation',
} as const;

export type RequestPlanChangeInputBillingFrequency = typeof RequestPlanChangeInputBillingFrequency[keyof typeof RequestPlanChangeInputBillingFrequency] | null;


export const RequestPlanChangeInputBillingFrequency = {
  monthly: 'monthly',
  yearly: 'yearly',
} as const;

export interface RequestPlanChangeInput {
  requestType: RequestPlanChangeInputRequestType;
  targetPlanSlug?: string | null;
  billingFrequency?: RequestPlanChangeInputBillingFrequency;
  /** @maxLength 2000 */
  note?: string | null;
}

export type RequestPlanChangeResultMode = typeof RequestPlanChangeResultMode[keyof typeof RequestPlanChangeResultMode];


export const RequestPlanChangeResultMode = {
  online: 'online',
  review: 'review',
} as const;

export interface RequestPlanChangeResult {
  mode: RequestPlanChangeResultMode;
  message: string;
  view: AccountSubscriptionView;
}

export interface FeatureRequestAttachment {
  name: string;
  url: string;
  contentType?: string | null;
  size?: number | null;
}

export type FeatureRequestSummaryRequestType = typeof FeatureRequestSummaryRequestType[keyof typeof FeatureRequestSummaryRequestType];


export const FeatureRequestSummaryRequestType = {
  enable_module: 'enable_module',
  build_feature: 'build_feature',
  increase_limits: 'increase_limits',
  add_integration: 'add_integration',
  custom_work: 'custom_work',
} as const;

export type FeatureRequestSummaryPriority = typeof FeatureRequestSummaryPriority[keyof typeof FeatureRequestSummaryPriority];


export const FeatureRequestSummaryPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type FeatureRequestSummaryStatus = typeof FeatureRequestSummaryStatus[keyof typeof FeatureRequestSummaryStatus];


export const FeatureRequestSummaryStatus = {
  submitted: 'submitted',
  under_review: 'under_review',
  approved: 'approved',
  rejected: 'rejected',
  planned: 'planned',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export interface FeatureRequestSummary {
  id: string;
  requestType: FeatureRequestSummaryRequestType;
  featureKey?: string | null;
  title: string;
  priority: FeatureRequestSummaryPriority;
  status: FeatureRequestSummaryStatus;
  requestedByEmail?: string | null;
  adminResponse?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type FeatureRequestCommentAuthorType = typeof FeatureRequestCommentAuthorType[keyof typeof FeatureRequestCommentAuthorType];


export const FeatureRequestCommentAuthorType = {
  tenant: 'tenant',
  platform: 'platform',
  system: 'system',
} as const;

export interface FeatureRequestComment {
  id: string;
  authorType: FeatureRequestCommentAuthorType;
  authorEmail?: string | null;
  body: string;
  createdAt: string;
}

export type FeatureRequestActivityActorType = typeof FeatureRequestActivityActorType[keyof typeof FeatureRequestActivityActorType];


export const FeatureRequestActivityActorType = {
  tenant: 'tenant',
  platform: 'platform',
  system: 'system',
} as const;

export type FeatureRequestActivityDetail = { [key: string]: unknown };

export interface FeatureRequestActivity {
  id: string;
  action: string;
  actorType: FeatureRequestActivityActorType;
  actorEmail?: string | null;
  fromStatus?: string | null;
  toStatus?: string | null;
  detail?: FeatureRequestActivityDetail;
  createdAt: string;
}

export type FeatureRequestDetail = FeatureRequestSummary & ({
  businessReason?: string | null;
  details?: string | null;
  resolvedAt?: string | null;
  attachments: FeatureRequestAttachment[];
  comments: FeatureRequestComment[];
  activity: FeatureRequestActivity[];
});

export interface FeatureRequestList {
  items: FeatureRequestSummary[];
  total: number;
}

export type CreateFeatureRequestInputRequestType = typeof CreateFeatureRequestInputRequestType[keyof typeof CreateFeatureRequestInputRequestType];


export const CreateFeatureRequestInputRequestType = {
  enable_module: 'enable_module',
  build_feature: 'build_feature',
  increase_limits: 'increase_limits',
  add_integration: 'add_integration',
  custom_work: 'custom_work',
} as const;

export type CreateFeatureRequestInputPriority = typeof CreateFeatureRequestInputPriority[keyof typeof CreateFeatureRequestInputPriority];


export const CreateFeatureRequestInputPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface CreateFeatureRequestInput {
  requestType: CreateFeatureRequestInputRequestType;
  featureKey?: string | null;
  /**
     * @minLength 1
     * @maxLength 200
     */
  title: string;
  priority?: CreateFeatureRequestInputPriority;
  businessReason?: string | null;
  details?: string | null;
  attachments?: FeatureRequestAttachment[];
}

export interface AddFeatureRequestCommentInput {
  /**
     * @minLength 1
     * @maxLength 5000
     */
  body: string;
}

export interface UpdateAccountSettingsInput {
  accountContactName?: string | null;
  accountContactEmail?: string | null;
  accountContactPhone?: string | null;
  companyNote?: string | null;
  onboardingCompleted?: boolean;
  onboardingCompletedSteps?: string[];
}

export interface ShopifyMappingOkResponse {
  ok: boolean;
}

/**
 * A transform rule applied to a mapping's resolved value. `kind` selects the transform; remaining properties are kind-specific (e.g. prefix.value, combine.template, price_markup_pct.percent). Unknown kinds pass through.
 */
export interface ShopifyMappingTransform {
  kind: string;
  [key: string]: unknown;
 }

export type ShopifyMappingSourceFieldGroup = typeof ShopifyMappingSourceFieldGroup[keyof typeof ShopifyMappingSourceFieldGroup];


export const ShopifyMappingSourceFieldGroup = {
  core: 'core',
  pricing: 'pricing',
  specs: 'specs',
  dimensions: 'dimensions',
  stock: 'stock',
  description: 'description',
  computed: 'computed',
} as const;

export interface ShopifyMappingSourceField {
  key: string;
  label: string;
  group: ShopifyMappingSourceFieldGroup;
}

export interface ShopifyMappingSourceCatalog {
  sourceFields: ShopifyMappingSourceField[];
  nativeTargets: string[];
  transformKinds: string[];
  metafieldTypes: string[];
}

export type ShopifyFieldMappingRowTargetType = typeof ShopifyFieldMappingRowTargetType[keyof typeof ShopifyFieldMappingRowTargetType];


export const ShopifyFieldMappingRowTargetType = {
  native: 'native',
  metafield: 'metafield',
} as const;

export interface ShopifyFieldMappingRow {
  id: string;
  sourceField: string;
  targetType: ShopifyFieldMappingRowTargetType;
  targetField: string;
  nativeTarget?: string | null;
  metafieldNamespace?: string | null;
  metafieldKey?: string | null;
  metafieldType?: string | null;
  enabled: boolean;
  required: boolean;
  fallbackValue?: string | null;
  transform?: ShopifyMappingTransform | null;
  sortOrder: number;
}

export type ShopifyFieldMappingInputTargetType = typeof ShopifyFieldMappingInputTargetType[keyof typeof ShopifyFieldMappingInputTargetType];


export const ShopifyFieldMappingInputTargetType = {
  native: 'native',
  metafield: 'metafield',
} as const;

export interface ShopifyFieldMappingInput {
  sourceField: string;
  targetType: ShopifyFieldMappingInputTargetType;
  nativeTarget?: string | null;
  metafieldNamespace?: string | null;
  metafieldKey?: string | null;
  metafieldType?: string | null;
  enabled: boolean;
  required: boolean;
  fallbackValue?: string | null;
  transform?: ShopifyMappingTransform | null;
  sortOrder: number;
}

export interface ShopifyMappingProfileSummary {
  id: string;
  name: string;
  description?: string | null;
  isDefault: boolean;
  isActive: boolean;
  mappingCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface ShopifyMappingProfileList {
  profiles: ShopifyMappingProfileSummary[];
}

export interface ShopifyMappingProfileDetail {
  id: string;
  name: string;
  description?: string | null;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  mappings: ShopifyFieldMappingRow[];
}

export interface ShopifyCreateProfileBody {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
  description?: string | null;
  /** When set, copy this profile's mappings into the new profile; otherwise seed with the built-in default mappings. */
  copyFromProfileId?: string | null;
}

export interface ShopifyUpdateProfileBody {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name?: string;
  description?: string | null;
  isActive?: boolean;
}

export interface ShopifyDuplicateProfileBody {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
}

export interface ShopifyReplaceMappingsBody {
  mappings: ShopifyFieldMappingInput[];
}

export interface ShopifyMappingMetafield {
  namespace: string;
  key: string;
  type: string;
  value: string;
}

export type ShopifyMappingScope = typeof ShopifyMappingScope[keyof typeof ShopifyMappingScope];


export const ShopifyMappingScope = {
  all: 'all',
  price: 'price',
  stock: 'stock',
  images: 'images',
  description: 'description',
  metafields: 'metafields',
} as const;

export interface ShopifyMappingPreviewBody {
  inventoryItemId: string;
  /** Profile to preview. Defaults to the tenant's active profile, or the default profile when none is active. */
  profileId?: string | null;
  scope?: ShopifyMappingScope;
}

export type ShopifyMappingPreviewResultProduct = { [key: string]: unknown };

export type ShopifyMappingPreviewResultVariant = { [key: string]: unknown };

export type ShopifyMappingPreviewResultFieldsSent = { [key: string]: unknown };

export type ShopifyMappingPreviewResultSource = { [key: string]: unknown };

export interface ShopifyMappingPreviewResult {
  profileId: string | null;
  profileName: string;
  scope: ShopifyMappingScope;
  product: ShopifyMappingPreviewResultProduct;
  variant: ShopifyMappingPreviewResultVariant;
  metafields: ShopifyMappingMetafield[];
  warnings: string[];
  missingRequired: string[];
  fieldsSent: ShopifyMappingPreviewResultFieldsSent;
  source: ShopifyMappingPreviewResultSource;
}

export interface ShopifyMappingPushBody {
  inventoryItemId: string;
  scope?: ShopifyMappingScope;
}

export type ShopifyMappingPushResultStatus = typeof ShopifyMappingPushResultStatus[keyof typeof ShopifyMappingPushResultStatus];


export const ShopifyMappingPushResultStatus = {
  success: 'success',
  error: 'error',
  skipped: 'skipped',
} as const;

export interface ShopifyMappingPushResult {
  ok: boolean;
  status: ShopifyMappingPushResultStatus;
  message?: string | null;
  shopifyProductId?: string | null;
  shopifyVariantId?: string | null;
  logId?: string | null;
  missingRequired: string[];
  warnings: string[];
}

export type ShopifyMappingLogFieldsSent = { [key: string]: unknown } | null;

export interface ShopifyMappingLog {
  id: string;
  inventoryItemId?: string | null;
  sku?: string | null;
  profileId?: string | null;
  profileName?: string | null;
  scope: string;
  shopifyProductId?: string | null;
  shopifyVariantId?: string | null;
  fieldsSent?: ShopifyMappingLogFieldsSent;
  warnings?: string[] | null;
  status: string;
  error?: string | null;
  createdByUserId?: string | null;
  createdAt: string;
}

export interface ShopifyMappingLogList {
  logs: ShopifyMappingLog[];
}

export interface ReturnOkResponse {
  ok: boolean;
}

export interface ReturnItemInput {
  saleOrderItemId?: string | null;
  inventoryItemId?: string | null;
  sku?: string | null;
  title?: string | null;
  /** @minimum 1 */
  quantity?: number;
  unitPriceGbp?: number | null;
  reason?: string | null;
  conditionDescription?: string | null;
  disposition?: string | null;
  notes?: string | null;
}

export interface ReturnItemUpdate {
  /** @minimum 1 */
  quantity?: number;
  unitPriceGbp?: number | null;
  reason?: string | null;
  conditionDescription?: string | null;
  disposition?: string | null;
  notes?: string | null;
}

export interface ReturnItemRow {
  id: string;
  returnId: string;
  saleOrderItemId?: string | null;
  inventoryItemId?: string | null;
  sku?: string | null;
  title?: string | null;
  quantity: number;
  unitPriceGbp?: number | null;
  reason?: string | null;
  conditionDescription?: string | null;
  disposition?: string | null;
  notes?: string | null;
  createdAt?: string | null;
}

export type ReturnInputSource = typeof ReturnInputSource[keyof typeof ReturnInputSource];


export const ReturnInputSource = {
  ebay: 'ebay',
  tiktok_shop: 'tiktok_shop',
  website: 'website',
  manual: 'manual',
} as const;

export interface ReturnInput {
  source: ReturnInputSource;
  saleOrderId?: string | null;
  ebayOrderId?: string | null;
  ebayReturnId?: string | null;
  ebayUsername?: string | null;
  tiktokOrderId?: string | null;
  tiktokReturnId?: string | null;
  externalOrderNumber?: string | null;
  websiteOrderNumber?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  reason?: string | null;
  reasonCode?: string | null;
  conditionDescription?: string | null;
  buyerComments?: string | null;
  notes?: string | null;
  trackingNumber?: string | null;
  carrier?: string | null;
  items?: ReturnItemInput[];
}

export interface ReturnUpdate {
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  reason?: string | null;
  reasonCode?: string | null;
  conditionDescription?: string | null;
  buyerComments?: string | null;
  notes?: string | null;
  trackingNumber?: string | null;
  carrier?: string | null;
  outcome?: string | null;
  saleOrderId?: string | null;
}

export interface ReturnStatusTransitionInput {
  status: string;
  note?: string | null;
  outcome?: string | null;
}

export interface ReturnRow {
  id: string;
  returnSeq?: number;
  returnReference: string;
  source: string;
  status: string;
  outcome: string;
  refundStatus: string;
  saleOrderId?: string | null;
  ebayOrderId?: string | null;
  ebayReturnId?: string | null;
  ebayUsername?: string | null;
  tiktokOrderId?: string | null;
  tiktokReturnId?: string | null;
  externalOrderNumber?: string | null;
  websiteOrderNumber?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  reason?: string | null;
  reasonCode?: string | null;
  conditionDescription?: string | null;
  buyerComments?: string | null;
  notes?: string | null;
  trackingNumber?: string | null;
  carrier?: string | null;
  requestedAt?: string | null;
  receivedAt?: string | null;
  receivedBy?: string | null;
  inspectedAt?: string | null;
  inspectedBy?: string | null;
  resolvedAt?: string | null;
  returnValueGbp?: number | null;
  refundAmountGbp?: number | null;
  highValue?: boolean;
  videoRequired?: boolean;
  evidenceCount?: number | null;
  createdBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ReturnListResponse {
  items: ReturnRow[];
  total: number;
}

export type PreOrderBatchStatus = typeof PreOrderBatchStatus[keyof typeof PreOrderBatchStatus];


export const PreOrderBatchStatus = {
  draft: 'draft',
  confirmed_incoming: 'confirmed_incoming',
  open_for_pre_order: 'open_for_pre_order',
  sold_out: 'sold_out',
  delayed: 'delayed',
  partially_received: 'partially_received',
  received_awaiting_final_cost: 'received_awaiting_final_cost',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type PreOrderDepositBasis = typeof PreOrderDepositBasis[keyof typeof PreOrderDepositBasis];


export const PreOrderDepositBasis = {
  full: 'full',
  fixed_per_invoice: 'fixed_per_invoice',
  fixed_per_unit: 'fixed_per_unit',
  percentage: 'percentage',
  manual: 'manual',
} as const;

export type PreOrderVatTreatment = typeof PreOrderVatTreatment[keyof typeof PreOrderVatTreatment];


export const PreOrderVatTreatment = {
  MARGIN_SCHEME: 'MARGIN_SCHEME',
  STANDARD_VAT: 'STANDARD_VAT',
  VAT_EXEMPT_GOLD: 'VAT_EXEMPT_GOLD',
  OUTSIDE_SCOPE: 'OUTSIDE_SCOPE',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
} as const;

/**
 * Pricing method for a batch item's purchase or selling side. `fixed` = a fixed GBP price (existing behaviour). `spot_linked` = the price resolves from a metal-spot formula only once the market is locked; until then it is displayed as "awaiting spot lock", never £0.
 */
export type PreOrderPricingMethod = typeof PreOrderPricingMethod[keyof typeof PreOrderPricingMethod];


export const PreOrderPricingMethod = {
  fixed: 'fixed',
  spot_linked: 'spot_linked',
} as const;

export interface PreOrderSpotSellingFields {
  sellingPricingMethod?: PreOrderPricingMethod;
  /** @minimum 0 */
  sellSpotLoosePremiumGbp?: number | null;
  /** @minimum 1 */
  sellSpotFullPackSize?: number | null;
  /** @minimum 0 */
  sellSpotFullPackPremiumGbp?: number | null;
  spotMetal?: string | null;
  /** @minimum 0 */
  fineWeightOztPerUnit?: number | null;
}

export interface PreOrderSpotPurchaseFields {
  purchasePricingMethod?: PreOrderPricingMethod;
  purchaseSupplierCurrency?: string | null;
  /** @minimum 0 */
  purchaseSpotLoosePremium?: number | null;
  /** @minimum 1 */
  purchaseSpotFullPackSize?: number | null;
  /** @minimum 0 */
  purchaseSpotFullPackPremium?: number | null;
  /** @minimum 0 */
  purchaseEstimatedPremiumGbp?: number | null;
  /** @minimum 0 */
  referenceSpotGbpPerOzt?: number | null;
}

export interface PreOrderSpotLockState {
  sellLockedSpotGbpPerOzt?: number | null;
  sellLockedAt?: string | null;
  sellLockNote?: string | null;
  purchaseLockedSpotSupplier?: number | null;
  purchaseLockedFxRate?: number | null;
  purchaseLockedUnitPriceGbp?: number | null;
  purchaseLockedAt?: string | null;
  purchaseLockNote?: string | null;
}

export type PreOrderAllocationPolicy = typeof PreOrderAllocationPolicy[keyof typeof PreOrderAllocationPolicy];


export const PreOrderAllocationPolicy = {
  first_requested: 'first_requested',
  customer_priority: 'customer_priority',
  pricing_group_priority: 'pricing_group_priority',
  manual: 'manual',
  contractual: 'contractual',
} as const;

export type PreOrderBatchRowReservationExpiryPolicy = typeof PreOrderBatchRowReservationExpiryPolicy[keyof typeof PreOrderBatchRowReservationExpiryPolicy];


export const PreOrderBatchRowReservationExpiryPolicy = {
  automatic: 'automatic',
  manual_only: 'manual_only',
} as const;

export interface PreOrderSummaryFreshness {
  stale: boolean;
  staleSince: string | null;
  refreshedAt: string | null;
  sourceUpdatedAt: string | null;
  refreshError: string | null;
}

export interface PreOrderBatchRow {
  id: string;
  supplierId?: string | null;
  supplierName?: string | null;
  linkedPurchaseOrderId?: string | null;
  linkedPurchaseOrderNumber?: string | null;
  defaultDepositBasis: PreOrderDepositBasis;
  defaultDepositValue: number;
  defaultReservationDurationHours: number;
  reservationExpiryPolicy: PreOrderBatchRowReservationExpiryPolicy;
  allocationPolicy: PreOrderAllocationPolicy;
  paymentTerms?: string | null;
  customerFacingTerms?: string | null;
  notes?: string | null;
  status: PreOrderBatchStatus;
  earliestEtaDate?: string | null;
  itemCount: number;
  productTitles: string[];
  qtyConfirmedTotal: number;
  qtyReservedTotal: number;
  qtyAvailableTotal: number;
  supplierCancelledOrShortfallTotal: number;
  provisionalCostTotalGbp: number | null;
  estimatedFixedRevenueTotalGbp: number | null;
  estimatedFixedProfitTotalGbp: number | null;
  summaryFreshness: PreOrderSummaryFreshness;
  createdAt: string;
  updatedAt: string;
}

export type PreOrderDirectorySummaryStatusCounts = {[key: string]: number};

export interface PreOrderDirectorySummary {
  totalBatches: number;
  totalCustomers: number;
  totalItemsReserved: number;
  totalItemsAvailable: number;
  awaitingStock: number;
  confirmedItems: number;
  openBatchesAwaitingStock: number;
  statusCounts: PreOrderDirectorySummaryStatusCounts;
}

/**
 * Counts by batch status under the same filters as the list, excluding the selected status.
 */
export type PreOrderBatchListResponseStatusCounts = {[key: string]: number};

export interface PreOrderBatchListResponse {
  items: PreOrderBatchRow[];
  total: number;
  /** Count of batches matching search and other filters, excluding the selected status. */
  allStatusTotal: number;
  /** Counts by batch status under the same filters as the list, excluding the selected status. */
  statusCounts: PreOrderBatchListResponseStatusCounts;
  summary: PreOrderDirectorySummary;
}

export interface PreOrderInventoryChoice {
  id: string;
  sku: string;
  productTitle: string;
}

export type PreOrderAllocationType = typeof PreOrderAllocationType[keyof typeof PreOrderAllocationType];


export const PreOrderAllocationType = {
  B2B: 'B2B',
  B2C: 'B2C',
  B2C_PRE_SALE: 'B2C_PRE_SALE',
  B2B_PRE_SALE: 'B2B_PRE_SALE',
} as const;

export interface PreOrderAllocationTypeCount {
  allocationType: PreOrderAllocationType | null;
  /** @minimum 0 */
  allocationRows: number;
  /** @minimum 0 */
  units: number;
}

export interface PreOrderBatchItemRow {
  id: string;
  batchId: string;
  inventoryItemId?: string | null;
  inventoryItemSku?: string | null;
  /** True while the real inventory SKU still needs linking — the item is either unlinked or linked only to an auto-created pre-order placeholder lot. Allocations are allowed either way; use the link-sku operation to attach the real SKU later. */
  skuLinkPending?: boolean;
  purchaseOrderId?: string | null;
  purchaseOrderItemId?: string | null;
  productTitle: string;
  imageUrl?: string | null;
  qtyConfirmed: number;
  supplierCancelledOrShortfallQty: number;
  qtyReserved: number;
  qtyAvailable: number;
  reservedByType?: PreOrderAllocationTypeCount[];
  etaDate?: string | null;
  etaDateTo?: string | null;
  etaNotConfirmed: boolean;
  sellingPriceGbp: number;
  provisionalUnitCostGbp?: number | null;
  costState: string;
  vatTreatmentSnapshot: PreOrderVatTreatment;
  sellingPricingMethod?: PreOrderPricingMethod;
  sellSpotLoosePremiumGbp?: number | null;
  sellSpotFullPackSize?: number | null;
  sellSpotFullPackPremiumGbp?: number | null;
  spotMetal?: string | null;
  fineWeightOztPerUnit?: number | null;
  purchasePricingMethod?: PreOrderPricingMethod;
  purchaseSupplierCurrency?: string | null;
  purchaseSpotLoosePremium?: number | null;
  purchaseSpotFullPackSize?: number | null;
  purchaseSpotFullPackPremium?: number | null;
  purchaseEstimatedPremiumGbp?: number | null;
  referenceSpotGbpPerOzt?: number | null;
  sellLockedSpotGbpPerOzt?: number | null;
  sellLockedAt?: string | null;
  sellLockNote?: string | null;
  purchaseLockedSpotSupplier?: number | null;
  purchaseLockedFxRate?: number | null;
  purchaseLockedUnitPriceGbp?: number | null;
  purchaseLockedAt?: string | null;
  purchaseLockNote?: string | null;
  /** True when the spot-linked selling formula is complete enough to open the batch. */
  spotSellingComplete?: boolean;
  /** True once the batch selling market price has been locked for this item. */
  sellPriceLocked?: boolean;
  createdAt: string;
  updatedAt: string;
}

export type PreOrderBatchDetail = PreOrderBatchRow & {
  items: PreOrderBatchItemRow[];
};

export interface PreOrderStockAssignmentWarning {
  batchId: string;
  batchItemId: string;
  inventoryItemId: string;
  inventoryItemSku: string | null;
}

export type PreOrderBatchSkuLinkResponse = PreOrderBatchDetail & ({
  assignmentWarning: null | PreOrderStockAssignmentWarning;
});

export interface PreOrderBatchProductPage {
  items: PreOrderBatchItemRow[];
  nextCursor: string | null;
}

export interface PreOrderOperatorAllocationCount {
  userId: string | null;
  firstName: string | null;
  /** @minimum 0 */
  allocationRows: number;
  /** @minimum 0 */
  units: number;
}

export interface PreOrderBatchAllocationSummary {
  /** @minimum 0 */
  activeAllocationRows: number;
  /** @minimum 0 */
  activeReservationUnits: number;
  /** @minimum 0 */
  pendingAllocationRows: number;
  /** @minimum 0 */
  confirmedAllocationRows: number;
  /** @minimum 0 */
  allAllocationRows: number;
  /** @minimum 0 */
  confirmedIncomingUnits: number;
  /** @minimum 0 */
  supplierShortfallUnits: number;
  /** @minimum 0 */
  allocatableIncomingUnits: number;
  availableUnits: number;
  /** @minimum 0 */
  allocatedPercent: number | null;
  byType?: PreOrderAllocationTypeCount[];
  byOperator?: PreOrderOperatorAllocationCount[];
}

export interface PreOrderEtaUpdateInput {
  itemId?: string;
  etaDate: string | null;
  etaDateTo: string | null;
  etaNotConfirmed: boolean;
  /** @maxLength 500 */
  message?: string;
}

export type PreOrderEtaChannelStatusEmail = typeof PreOrderEtaChannelStatusEmail[keyof typeof PreOrderEtaChannelStatusEmail];


export const PreOrderEtaChannelStatusEmail = {
  available: 'available',
  not_configured: 'not_configured',
} as const;

export type PreOrderEtaChannelStatusSms = typeof PreOrderEtaChannelStatusSms[keyof typeof PreOrderEtaChannelStatusSms];


export const PreOrderEtaChannelStatusSms = {
  not_supported: 'not_supported',
} as const;

export type PreOrderEtaChannelStatusWhatsapp = typeof PreOrderEtaChannelStatusWhatsapp[keyof typeof PreOrderEtaChannelStatusWhatsapp];


export const PreOrderEtaChannelStatusWhatsapp = {
  not_supported: 'not_supported',
} as const;

export interface PreOrderEtaChannelStatus {
  email: PreOrderEtaChannelStatusEmail;
  sms: PreOrderEtaChannelStatusSms;
  whatsapp: PreOrderEtaChannelStatusWhatsapp;
}

export interface PreOrderEtaUpdateResponse {
  updateId: string;
  itemIds: string[];
  /** @minimum 0 */
  affectedReservationRows: number;
  /** @minimum 0 */
  recipientCount: number;
  notification: PreOrderEtaChannelStatus;
}

export interface PreOrderEtaUpdateSnapshot {
  updateId: string;
  etaDate: string | null;
  etaDateTo: string | null;
  etaNotConfirmed: boolean;
  message: string;
  updatedAt: string;
}

export type PreOrderEtaUpdatePreviewRecipientEmailStatus = typeof PreOrderEtaUpdatePreviewRecipientEmailStatus[keyof typeof PreOrderEtaUpdatePreviewRecipientEmailStatus];


export const PreOrderEtaUpdatePreviewRecipientEmailStatus = {
  ready: 'ready',
  missing_or_invalid: 'missing_or_invalid',
} as const;

export interface PreOrderEtaUpdatePreviewRecipient {
  customerId: string;
  customerName: string;
  orderNumbers: string[];
  productTitles: string[];
  /** @minimum 0 */
  activeReservationCount: number;
  emailStatus: PreOrderEtaUpdatePreviewRecipientEmailStatus;
}

export interface PreOrderEtaUpdatePreview {
  update: PreOrderEtaUpdateSnapshot;
  /** @minimum 0 */
  recipientCount: number;
  /** @minimum 0 */
  activeReservationCount: number;
  channelStatus: PreOrderEtaChannelStatus;
  recipients: PreOrderEtaUpdatePreviewRecipient[];
}

export interface PreOrderEtaNotificationResponse {
  /** @minimum 0 */
  recipientCount: number;
  /** @minimum 0 */
  sent: number;
  /** @minimum 0 */
  failed: number;
  /** @minimum 0 */
  missingEmail: number;
  /** @minimum 0 */
  alreadyAttempted: number;
  channelStatus: PreOrderEtaChannelStatus;
}

export interface PreOrderBatchInput {
  supplierId?: string | null;
  linkedPurchaseOrderId?: string | null;
  defaultDepositBasis?: PreOrderDepositBasis;
  /** @minimum 0 */
  defaultDepositValue?: number;
  /** @minimum 1 */
  defaultReservationDurationHours?: number;
  allocationPolicy?: PreOrderAllocationPolicy;
  paymentTerms?: string | null;
  customerFacingTerms?: string | null;
  notes?: string | null;
}

export interface PreOrderBatchUpdate {
  supplierId?: string | null;
  linkedPurchaseOrderId?: string | null;
  defaultDepositBasis?: PreOrderDepositBasis;
  /** @minimum 0 */
  defaultDepositValue?: number;
  /** @minimum 1 */
  defaultReservationDurationHours?: number;
  allocationPolicy?: PreOrderAllocationPolicy;
  paymentTerms?: string | null;
  customerFacingTerms?: string | null;
  notes?: string | null;
}

export interface PreOrderBatchStatusInput {
  status: PreOrderBatchStatus;
}

export type PreOrderBatchItemInput = PreOrderSpotSellingFields & PreOrderSpotPurchaseFields & ({
  /** @minLength 1 */
  productTitle: string;
  imageUrl?: string | null;
  inventoryItemId?: string | null;
  purchaseOrderId?: string | null;
  purchaseOrderItemId?: string | null;
  /** @minimum 0 */
  qtyConfirmed?: number;
  /** @minimum 0 */
  supplierCancelledOrShortfallQty?: number;
  etaDate?: string | null;
  etaDateTo?: string | null;
  etaNotConfirmed?: boolean;
  /** @minimum 0 */
  sellingPriceGbp?: number;
  /** @minimum 0 */
  provisionalUnitCostGbp?: number | null;
  vatTreatmentSnapshot?: PreOrderVatTreatment;
});

export type PreOrderBatchItemUpdate = PreOrderSpotSellingFields & PreOrderSpotPurchaseFields & ({
  /** @minLength 1 */
  productTitle?: string;
  imageUrl?: string | null;
  inventoryItemId?: string | null;
  purchaseOrderId?: string | null;
  purchaseOrderItemId?: string | null;
  /** @minimum 0 */
  qtyConfirmed?: number;
  /** @minimum 0 */
  supplierCancelledOrShortfallQty?: number;
  etaDate?: string | null;
  etaDateTo?: string | null;
  etaNotConfirmed?: boolean;
  /** @minimum 0 */
  sellingPriceGbp?: number;
  /** @minimum 0 */
  provisionalUnitCostGbp?: number | null;
  vatTreatmentSnapshot?: PreOrderVatTreatment;
});

export interface PreOrderBatchItemPricingCorrection {
  sellingPricingMethod: PreOrderPricingMethod;
  /** @minimum 0 */
  sellingPriceGbp: number;
  /** @minimum 0 */
  sellSpotLoosePremiumGbp?: number | null;
  /** @minimum 1 */
  sellSpotFullPackSize?: number | null;
  /** @minimum 0 */
  sellSpotFullPackPremiumGbp?: number | null;
  spotMetal?: string | null;
  /** @minimum 0 */
  fineWeightOztPerUnit?: number | null;
  purchasePricingMethod: PreOrderPricingMethod;
  /** @minimum 0 */
  provisionalUnitCostGbp?: number | null;
  purchaseSupplierCurrency?: string | null;
  /** @minimum 0 */
  purchaseSpotLoosePremium?: number | null;
  /** @minimum 1 */
  purchaseSpotFullPackSize?: number | null;
  /** @minimum 0 */
  purchaseSpotFullPackPremium?: number | null;
  /** @minimum 0 */
  purchaseEstimatedPremiumGbp?: number | null;
  /** @minimum 0 */
  referenceSpotGbpPerOzt?: number | null;
}

export interface LinkPreOrderBatchItemSkuInput {
  /**
     * The real inventory item to link. Must be a standalone lot (no shared-pool master link). On-hand stock is allowed — pre-order lines never touch normal inventory counters.
     * @minLength 1
     */
  inventoryItemId: string;
}

export type PreOrderAllocationRowStatus = typeof PreOrderAllocationRowStatus[keyof typeof PreOrderAllocationRowStatus];


export const PreOrderAllocationRowStatus = {
  active: 'active',
  confirmed: 'confirmed',
  cancelled: 'cancelled',
  expired: 'expired',
} as const;

export interface PreOrderAllocationRow {
  id: string;
  batchItemId: string;
  saleOrderId: string;
  saleOrderItemId: string;
  allocationType?: PreOrderAllocationType | null;
  assignedOperatorUserId?: string | null;
  assignedOperatorFirstName?: string | null;
  createdByUserId?: string | null;
  createdByFirstName?: string | null;
  saleOrderNumber?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  productTitle?: string;
  quantity: number;
  sellingPrice: number | null;
  vatTreatment?: string | null;
  etaDate?: string | null;
  sellingPricingMethod?: PreOrderPricingMethod;
  resolvedSellingPriceGbp: number | null;
  resolvedSpotGbpPerOzt: number | null;
  priceLockedAt?: string | null;
  paymentReleasedAt?: string | null;
  reservationExpiresAt?: string | null;
  paymentRequestIssuedAt?: string | null;
  paymentRequestDeliveryStatus?: string | null;
  awaitingSpotLock?: boolean;
  allocationStatus: string;
  fulfilmentStatus?: string;
  qtyReceivedAssigned?: number;
  qtyFulfilled?: number;
  status: PreOrderAllocationRowStatus;
  salePaymentStatus?: string | null;
  saleBalanceDue: number | null;
  saleCreditDue?: number | null;
  createdAt: string;
  cancelledAt?: string | null;
}

export interface PreOrderContextNoteInput {
  /**
     * @minLength 1
     * @maxLength 5000
     */
  note: string;
  allocationId?: string | null;
}

export interface PreOrderContextNote {
  id: string;
  note: string;
  allocationId: string | null;
  productTitle: string | null;
  customerName: string | null;
  actorUserId: string | null;
  actorFirstName: string | null;
  createdAt: string;
}

export interface PreOrderBatchNotesResponse {
  note: string | null;
  notes: PreOrderContextNote[];
}

export interface PreOrderAllocationMetadata {
  allocationId: string;
  allocationType: PreOrderAllocationType | null;
  assignedOperatorUserId: string | null;
  assignedOperatorFirstName: string | null;
  createdByUserId: string | null;
  createdByFirstName: string | null;
}

export interface PreOrderAllocationMetadataUpdate {
  allocationType?: PreOrderAllocationType;
  assignedOperatorUserId?: string | null;
}

export interface PreOrderOperator {
  userId: string;
  firstName: string;
  avatarUrl?: string | null;
}

export interface PreOrderOperatorListResponse {
  items: PreOrderOperator[];
}

export interface PreOrderAllocationListResponse {
  items: PreOrderAllocationRow[];
  nextCursor: string | null;
  /** @minimum 0 */
  totalCount?: number;
}

export interface PreOrderBulkInvoiceRow {
  saleOrderId: string;
  saleOrderNumber?: string | null;
  customerName?: string | null;
  invoiceId: string;
  invoiceNumber: number;
  alreadyExisted: boolean;
}

export interface PreOrderBulkConvertResponse {
  converted: number;
  alreadyConfirmed: number;
  failed: number;
  invoicesCreated: number;
  invoices: PreOrderBulkInvoiceRow[];
}

export interface PreOrderReinstateExpiredSkipReasonCounts {
  /** @minimum 0 */
  invoiceProtected: number;
  /** @minimum 0 */
  paid: number;
  /** @minimum 0 */
  cancelled: number;
  /** @minimum 0 */
  crossBatch: number;
  /** @minimum 0 */
  assigned: number;
  /** @minimum 0 */
  fulfilled: number;
  /** @minimum 0 */
  capacityConflict: number;
  /** @minimum 0 */
  otherwiseIneligible: number;
}

export type PreOrderReinstateExpiredReviewItemReason = typeof PreOrderReinstateExpiredReviewItemReason[keyof typeof PreOrderReinstateExpiredReviewItemReason];


export const PreOrderReinstateExpiredReviewItemReason = {
  invoiceProtected: 'invoiceProtected',
  paid: 'paid',
  cancelled: 'cancelled',
  crossBatch: 'crossBatch',
  assigned: 'assigned',
  fulfilled: 'fulfilled',
  capacityConflict: 'capacityConflict',
  otherwiseIneligible: 'otherwiseIneligible',
} as const;

export interface PreOrderReinstateExpiredReviewItem {
  allocationId: string;
  batchId: string;
  reason: PreOrderReinstateExpiredReviewItemReason;
}

export interface PreOrderReinstateExpiredResponse {
  /** @minimum 0 */
  reinstated: number;
  /** @minimum 0 */
  skipped: number;
  /** @minimum 0 */
  failed: number;
  skipReasonCounts: PreOrderReinstateExpiredSkipReasonCounts;
  reviewItems: PreOrderReinstateExpiredReviewItem[];
  reviewItemsTruncated: boolean;
}

export interface PreOrderManualExpiryResponse {
  reservationId: string;
  saleOrderId: string;
  expiredAllocationCount: number;
}

export type PreOrderAllocationInputItemsItem = {
  /** @minLength 1 */
  batchItemId: string;
  /** @minimum 1 */
  quantity: number;
  /**
     * Optional per-unit price for this staff-created reservation (requires pre_orders.manage). If omitted, uses the published offer price when applicable, otherwise the batch item price.
     * @minimum 0
     */
  sellingPriceGbp?: number;
  /** @minimum 0 */
  customerPriority?: number;
  /** @minimum 0 */
  pricingGroupPriority?: number;
  /** @minimum 0 */
  manualPriority?: number;
  contractualDeadline?: string | null;
};

export interface PreOrderAllocationInput {
  /** @minLength 1 */
  customerId: string;
  allocationType?: PreOrderAllocationType;
  assignedOperatorUserId?: string | null;
  /** @minItems 1 */
  items: PreOrderAllocationInputItemsItem[];
}

export interface PreOrderAllocationCreateResponse {
  saleOrderId: string;
  allocationIds: string[];
}

export interface PreOrderAllocationQuantityUpdate {
  /** @minimum 1 */
  expectedQuantity: number;
  /** @minimum 1 */
  quantity: number;
}

export interface PreOrderAllocationQuantityUpdateResponse {
  allocationId: string;
  saleOrderId: string;
  saleOrderItemId: string;
  batchItemId: string;
  previousQuantity: number;
  quantity: number;
  total: number;
  amountPaid: number;
  balanceDue: number;
  creditDue: number;
  idempotent: boolean;
}

export interface PreOrderAllocationPriceUpdate {
  /**
     * Current GBP unit price shown to the operator, or null before a spot-linked allocation is locked; used to reject stale edits.
     * @maximum 999999999.99
     * @exclusiveMinimum 0
     */
  expectedSellingPriceGbp: number | null;
  /**
     * New agreed GBP unit price for this allocation only.
     * @maximum 999999999.99
     * @exclusiveMinimum 0
     */
  sellingPriceGbp: number;
}

export interface PreOrderAllocationPriceUpdateResponse {
  allocationId: string;
  saleOrderId: string;
  saleOrderItemId: string;
  batchItemId: string;
  previousSellingPriceGbp: number | null;
  sellingPriceGbp: number;
  total: number;
  amountPaid: number;
  balanceDue: number;
  creditDue: number;
  idempotent: boolean;
}

export type PreOrderAllocationStatusResponseStatus = typeof PreOrderAllocationStatusResponseStatus[keyof typeof PreOrderAllocationStatusResponseStatus];


export const PreOrderAllocationStatusResponseStatus = {
  active: 'active',
  confirmed: 'confirmed',
  cancelled: 'cancelled',
  expired: 'expired',
} as const;

export interface PreOrderAllocationStatusResponse {
  id: string;
  allocationStatus: string;
  status: PreOrderAllocationStatusResponseStatus;
  saleCancelled?: boolean;
  saleOrderNumber?: string | null;
}

export interface PreOrderConvertResponse {
  saleOrderId: string;
  allocationId: string;
}

export interface PreOrderLockPriceInput {
  /** @minimum 0 */
  sellLockedSpotGbpPerOzt: number;
  sellLockNote?: string | null;
  /** @minimum 0 */
  purchaseLockedSpotSupplier?: number | null;
  /** @minimum 0 */
  purchaseLockedFxRate?: number | null;
  /** @minimum 0 */
  purchaseLockedUnitPriceGbp?: number | null;
  purchaseLockNote?: string | null;
  lockedAt?: string | null;
}

export interface PreOrderLockPriceResponse {
  itemsLocked: number;
  allocationsResolved: number;
  alreadyLocked: number;
}

export interface PreOrderConvertAndPayResponse {
  saleOrderId: string;
  allocationId: string;
  /** true when this call performed the Reserved→Sold conversion (false = already confirmed). */
  converted: boolean;
  /** Payment status after the action (normally "Paid"). */
  paymentStatus: string;
}

export interface ReturnLinkedOrder {
  id?: string;
  orderNumber?: string | null;
  channel?: string | null;
  saleDate?: string | null;
  totalGbp?: number | null;
  customerName?: string | null;
}

export interface ReturnEvidenceItem {
  id: string;
  returnId: string;
  saleOrderId?: string | null;
  ebayOrderId?: string | null;
  ebayReturnId?: string | null;
  customerId?: string | null;
  sku?: string | null;
  trackingNumber?: string | null;
  objectPath: string;
  fileName?: string | null;
  contentType?: string | null;
  mediaType: string;
  category: string;
  sortOrder?: number;
  capturedBy?: string | null;
  capturedAt?: string | null;
  createdAt?: string | null;
}

export interface ReturnRefundRow {
  id: string;
  returnId: string;
  amountGbp: number;
  reason?: string | null;
  method: string;
  marketplaceRefundId?: string | null;
  processorRefundId?: string | null;
  orderAdjustmentId?: string | null;
  quickbooksSyncStatus?: string | null;
  status: string;
  approvedBy?: string | null;
  approvedAt?: string | null;
  issuedBy?: string | null;
  issuedAt?: string | null;
  error?: string | null;
  createdBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ReturnInventoryActionRow {
  id: string;
  returnId: string;
  returnItemId?: string | null;
  inventoryItemId?: string | null;
  newInventoryItemId?: string | null;
  disposition: string;
  quantity: number;
  stockMovementId?: string | null;
  notes?: string | null;
  performedBy?: string | null;
  performedAt?: string | null;
  createdAt?: string | null;
}

export interface ReturnMessageRow {
  id: string;
  returnId: string;
  channel: string;
  direction: string;
  templateKey?: string | null;
  subject?: string | null;
  body?: string | null;
  toAddress?: string | null;
  ebayMessageId?: string | null;
  status: string;
  error?: string | null;
  sentBy?: string | null;
  sentAt?: string | null;
  createdAt?: string | null;
}

export type ReturnDetail = ReturnRow & {
  items?: ReturnItemRow[];
  evidence?: ReturnEvidenceItem[];
  refunds?: ReturnRefundRow[];
  inventoryActions?: ReturnInventoryActionRow[];
  messages?: ReturnMessageRow[];
  linkedOrder?: ReturnLinkedOrder;
};

export type ReturnEvidenceInputMediaType = typeof ReturnEvidenceInputMediaType[keyof typeof ReturnEvidenceInputMediaType];


export const ReturnEvidenceInputMediaType = {
  image: 'image',
  video: 'video',
} as const;

export interface ReturnEvidenceInput {
  objectPath: string;
  fileName?: string | null;
  contentType?: string | null;
  mediaType: ReturnEvidenceInputMediaType;
  category?: string | null;
  sku?: string | null;
  trackingNumber?: string | null;
}

export interface ReturnShareLinkInput {
  label?: string | null;
  expiresInHours?: number | null;
}

export interface ReturnShareLink {
  id: string;
  returnId: string;
  label?: string | null;
  createdBy?: string | null;
  expiresAt?: string | null;
  revokedAt?: string | null;
  revoked: boolean;
  viewCount?: number;
  lastViewedAt?: string | null;
  createdAt?: string | null;
}

export type ReturnShareLinkMinted = ReturnShareLink & {
  url: string;
};

export type ReturnRefundInputMethod = typeof ReturnRefundInputMethod[keyof typeof ReturnRefundInputMethod];


export const ReturnRefundInputMethod = {
  ebay: 'ebay',
  tiktok_shop: 'tiktok_shop',
  website: 'website',
  manual: 'manual',
} as const;

export interface ReturnRefundInput {
  amountGbp: number;
  reason?: string | null;
  method: ReturnRefundInputMethod;
}

export type ReturnRefundUpdateStatus = typeof ReturnRefundUpdateStatus[keyof typeof ReturnRefundUpdateStatus];


export const ReturnRefundUpdateStatus = {
  requested: 'requested',
  approved: 'approved',
  issued: 'issued',
  failed: 'failed',
  rejected: 'rejected',
} as const;

export interface ReturnRefundUpdate {
  status: ReturnRefundUpdateStatus;
  marketplaceRefundId?: string | null;
  processorRefundId?: string | null;
  error?: string | null;
}

export interface ReturnInventoryActionInput {
  returnItemId?: string | null;
  inventoryItemId?: string | null;
  disposition: string;
  /** @minimum 1 */
  quantity?: number;
  notes?: string | null;
}

export type ReturnMessageInputChannel = typeof ReturnMessageInputChannel[keyof typeof ReturnMessageInputChannel];


export const ReturnMessageInputChannel = {
  ebay: 'ebay',
  email: 'email',
  whatsapp: 'whatsapp',
  sms: 'sms',
} as const;

export interface ReturnMessageInput {
  channel: ReturnMessageInputChannel;
  templateKey?: string | null;
  subject?: string | null;
  body?: string | null;
  toAddress?: string | null;
}

export interface ReturnAuditRow {
  id: string;
  returnId?: string | null;
  actorUserId?: string | null;
  action: string;
  entityType: string;
  entityId?: string | null;
  note?: string | null;
  createdAt?: string | null;
}

export interface ReturnEbayPullResult {
  imported: number;
  updated: number;
  skipped: number;
  errors?: string[];
  available?: boolean;
  message?: string;
}

export interface ReturnsOverview {
  open: number;
  awaitingReturn: number;
  received: number;
  inspecting: number;
  awaitingDecision: number;
  refundPending: number;
  completed: number;
  rejected: number;
  highValueOpen?: number;
  missingEvidence?: number;
}

export type ReturnsReportSummaryBySourceItem = {
  key: string;
  count: number;
};

export type ReturnsReportSummaryByReasonItem = {
  key: string;
  count: number;
};

export type ReturnsReportSummaryByOutcomeItem = {
  key: string;
  count: number;
};

export interface ReturnsReportSummary {
  totalReturns: number;
  totalRefundedGbp: number;
  restockedCount?: number;
  writeOffCount?: number;
  bySource: ReturnsReportSummaryBySourceItem[];
  byReason: ReturnsReportSummaryByReasonItem[];
  byOutcome: ReturnsReportSummaryByOutcomeItem[];
}

export interface ReturnsSettings {
  videoRequiredForRefund: boolean;
  highValueThresholdGbp: number;
  videoRequiredHighValueOnly?: boolean;
  requiredPhotos?: string[];
  inspectionChecklist?: string[];
  approverRoles?: string[];
  rejecterRoles?: string[];
  shareLinkRoles?: string[];
  evidenceRetentionDays?: number | null;
  shareLinkExpiryHours?: number;
  ebaySyncEnabled?: boolean;
  ebaySyncFrequencyMinutes?: number;
  ebayAllowedActions?: string[];
  lastEbaySyncAt?: string | null;
  tiktokSyncEnabled?: boolean;
  tiktokSyncFrequencyMinutes?: number;
  tiktokAllowedActions?: string[];
  lastTiktokSyncAt?: string | null;
}

export interface ReturnsSettingsInput {
  videoRequiredForRefund?: boolean;
  highValueThresholdGbp?: number;
  videoRequiredHighValueOnly?: boolean;
  requiredPhotos?: string[];
  inspectionChecklist?: string[];
  approverRoles?: string[];
  rejecterRoles?: string[];
  shareLinkRoles?: string[];
  evidenceRetentionDays?: number | null;
  shareLinkExpiryHours?: number;
  ebaySyncEnabled?: boolean;
  ebaySyncFrequencyMinutes?: number;
  ebayAllowedActions?: string[];
  tiktokSyncEnabled?: boolean;
  tiktokSyncFrequencyMinutes?: number;
  tiktokAllowedActions?: string[];
}

export interface AssetOkResponse {
  ok: boolean;
}

export interface AssetInput {
  name: string;
  assetType?: string | null;
  make?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  barcode?: string | null;
  purchaseDate?: string | null;
  purchaseCost?: number | null;
  currency?: string | null;
  vendor?: string | null;
  warrantyExpiry?: string | null;
  condition?: string | null;
  status?: string | null;
  location?: string | null;
  notes?: string | null;
  assignedToUserId?: string | null;
  assignedToStaffId?: string | null;
}

export interface AssetUpdate {
  name?: string;
  assetType?: string | null;
  make?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  barcode?: string | null;
  purchaseDate?: string | null;
  purchaseCost?: number | null;
  currency?: string | null;
  vendor?: string | null;
  warrantyExpiry?: string | null;
  condition?: string | null;
  location?: string | null;
  notes?: string | null;
}

export interface AssetRow {
  id: string;
  assetSeq?: number;
  reference: string;
  name: string;
  assetType?: string | null;
  make?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  barcode?: string | null;
  purchaseDate?: string | null;
  purchaseCost?: number | null;
  currency?: string | null;
  vendor?: string | null;
  warrantyExpiry?: string | null;
  warrantyExpiringSoon?: boolean;
  condition?: string | null;
  status: string;
  assignedToUserId?: string | null;
  assignedToStaffId?: string | null;
  assignedToName?: string | null;
  assignedToLeaver?: boolean;
  assignedAt?: string | null;
  location?: string | null;
  notes?: string | null;
  primaryPhotoPath?: string | null;
  documentCount?: number | null;
  archivedAt?: string | null;
  createdBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AssetListResponse {
  items: AssetRow[];
  total: number;
}

export interface AssetAssignmentRow {
  id: string;
  assetId: string;
  assignedToUserId?: string | null;
  assignedToStaffId?: string | null;
  assignedToName?: string | null;
  location?: string | null;
  conditionOnAssign?: string | null;
  conditionOnReturn?: string | null;
  assignedBy?: string | null;
  assignedAt?: string | null;
  returnedBy?: string | null;
  returnedAt?: string | null;
  notes?: string | null;
  active: boolean;
  createdAt?: string | null;
}

export type AssetActivityRowChangesItem = { [key: string]: unknown };

export interface AssetActivityRow {
  id: string;
  assetId: string;
  action: string;
  actorUserId?: string | null;
  actorName?: string | null;
  fromStatus?: string | null;
  toStatus?: string | null;
  changes?: AssetActivityRowChangesItem[];
  note?: string | null;
  createdAt?: string | null;
}

export type AssetDocumentInputKind = typeof AssetDocumentInputKind[keyof typeof AssetDocumentInputKind];


export const AssetDocumentInputKind = {
  photo: 'photo',
  document: 'document',
} as const;

export interface AssetDocumentInput {
  objectPath: string;
  kind?: AssetDocumentInputKind;
  fileName?: string | null;
  contentType?: string | null;
  sizeBytes?: number | null;
  isPrimary?: boolean;
}

export interface AssetDocumentRow {
  id: string;
  assetId: string;
  kind: string;
  fileName?: string | null;
  contentType?: string | null;
  objectPath: string;
  sizeBytes?: number | null;
  isPrimary?: boolean;
  uploadedBy?: string | null;
  uploadedAt?: string | null;
  createdAt?: string | null;
}

export type AssetDetail = AssetRow & {
  assignments?: AssetAssignmentRow[];
  activity?: AssetActivityRow[];
  documents?: AssetDocumentRow[];
};

export interface AssetAssignInput {
  assignedToUserId?: string | null;
  assignedToStaffId?: string | null;
  location?: string | null;
  conditionOnAssign?: string | null;
  notes?: string | null;
}

export interface AssetReturnInput {
  conditionOnReturn?: string | null;
  location?: string | null;
  notes?: string | null;
}

export interface AssetTransferInput {
  location: string;
  notes?: string | null;
}

export interface AssetStatusTransitionInput {
  status: string;
  note?: string | null;
  condition?: string | null;
}

export interface AssetLabel {
  reference: string;
  name: string;
  serialNumber?: string | null;
  barcode?: string | null;
  qrData: string;
  barcodeData?: string | null;
}

export type AssetStaffCountsCounts = {[key: string]: number};

export interface AssetStaffCounts {
  counts: AssetStaffCountsCounts;
}

export interface AssetsOverview {
  total: number;
  assigned: number;
  available: number;
  inUse: number;
  inRepair: number;
  lost: number;
  retired: number;
  disposed: number;
  archived: number;
  warrantyExpiringSoon: number;
  assignedToLeavers: number;
}

export type AssetsReportSummaryByStatusItem = {
  key: string;
  count: number;
};

export type AssetsReportSummaryByTypeItem = {
  key: string;
  count: number;
};

export type AssetsReportSummaryByConditionItem = {
  key: string;
  count: number;
};

export interface AssetsReportSummary {
  total: number;
  totalPurchaseCostGbp: number;
  warrantyExpiringSoon: number;
  byStatus?: AssetsReportSummaryByStatusItem[];
  byType?: AssetsReportSummaryByTypeItem[];
  byCondition?: AssetsReportSummaryByConditionItem[];
}

export interface ComplianceOkResponse {
  ok: boolean;
}

export type ComplianceProfileInputSubjectType = typeof ComplianceProfileInputSubjectType[keyof typeof ComplianceProfileInputSubjectType];


export const ComplianceProfileInputSubjectType = {
  customer: 'customer',
  supplier: 'supplier',
} as const;

export interface ComplianceProfileInput {
  subjectType: ComplianceProfileInputSubjectType;
  subjectId: string;
  subjectName?: string | null;
  status?: string | null;
  riskRating?: string | null;
  nextReviewDate?: string | null;
  notes?: string | null;
}

export interface ComplianceProfileUpdate {
  subjectName?: string | null;
  status?: string | null;
  riskRating?: string | null;
  nextReviewDate?: string | null;
  lastReviewedAt?: string | null;
  notes?: string | null;
}

export interface ComplianceProfileRow {
  id: string;
  subjectType: string;
  subjectId: string;
  subjectName?: string | null;
  status: string;
  riskRating: string;
  nextReviewDate?: string | null;
  lastReviewedAt?: string | null;
  reviewOverdue?: boolean;
  reviewCount?: number | null;
  documentCount?: number | null;
  openTaskCount?: number | null;
  notes?: string | null;
  createdBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ComplianceProfileListResponse {
  items: ComplianceProfileRow[];
  total: number;
}

export interface ComplianceReviewInput {
  checkType: string;
  outcome?: string | null;
  method?: string | null;
  reference?: string | null;
  checkedAt?: string | null;
  expiresAt?: string | null;
  notes?: string | null;
}

export interface ComplianceReviewUpdate {
  checkType?: string;
  outcome?: string | null;
  method?: string | null;
  reference?: string | null;
  checkedAt?: string | null;
  expiresAt?: string | null;
  notes?: string | null;
}

export interface ComplianceReviewRow {
  id: string;
  profileId: string;
  checkType: string;
  outcome: string;
  method?: string | null;
  reference?: string | null;
  checkedAt?: string | null;
  expiresAt?: string | null;
  checkedBy?: string | null;
  notes?: string | null;
  createdBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ComplianceDocumentInput {
  objectPath: string;
  kind?: string | null;
  reviewId?: string | null;
  fileName?: string | null;
  contentType?: string | null;
  sizeBytes?: number | null;
  expiresAt?: string | null;
}

export interface ComplianceDocumentRow {
  id: string;
  profileId: string;
  reviewId?: string | null;
  kind: string;
  fileName?: string | null;
  contentType?: string | null;
  objectPath: string;
  sizeBytes?: number | null;
  expiresAt?: string | null;
  uploadedBy?: string | null;
  uploadedAt?: string | null;
  createdAt?: string | null;
}

export interface ComplianceTaskInput {
  title: string;
  description?: string | null;
  profileId?: string | null;
  status?: string | null;
  priority?: string | null;
  dueDate?: string | null;
  assignedToUserId?: string | null;
}

export interface ComplianceTaskUpdate {
  title?: string;
  description?: string | null;
  status?: string | null;
  priority?: string | null;
  dueDate?: string | null;
  assignedToUserId?: string | null;
}

export interface ComplianceTaskRow {
  id: string;
  profileId?: string | null;
  title: string;
  description?: string | null;
  status: string;
  priority: string;
  dueDate?: string | null;
  assignedToUserId?: string | null;
  assignedToName?: string | null;
  completedAt?: string | null;
  completedBy?: string | null;
  notes?: string | null;
  createdBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ComplianceTaskListResponse {
  items: ComplianceTaskRow[];
  total: number;
}

export type ComplianceAuditRowChangesItem = { [key: string]: unknown };

export interface ComplianceAuditRow {
  id: string;
  action: string;
  entityType?: string | null;
  entityId?: string | null;
  actorUserId?: string | null;
  actorName?: string | null;
  changes?: ComplianceAuditRowChangesItem[];
  note?: string | null;
  createdAt?: string | null;
}

export type ComplianceProfileDetail = ComplianceProfileRow & {
  reviews?: ComplianceReviewRow[];
  documents?: ComplianceDocumentRow[];
  tasks?: ComplianceTaskRow[];
};

export interface ComplianceOverview {
  totalProfiles: number;
  verified: number;
  inProgress: number;
  notStarted: number;
  reviewDue: number;
  highRisk: number;
  prohibited: number;
  openTasks: number;
  documentsCount: number;
}

export interface HrAttachment {
  objectPath: string;
  fileName: string;
  contentType?: string | null;
  sizeBytes?: number | null;
}

export interface HrOverview {
  totalStaff: number;
  activeStaff: number;
  onboardingInProgress: number;
  pendingTimeOff: number;
  pendingChangeRequests: number;
  pendingHours: number;
  openIncidents: number;
  expiringDocuments: number;
}

export type HrStaffSummaryEmploymentStatus = typeof HrStaffSummaryEmploymentStatus[keyof typeof HrStaffSummaryEmploymentStatus];


export const HrStaffSummaryEmploymentStatus = {
  applicant: 'applicant',
  active: 'active',
  probation: 'probation',
  suspended: 'suspended',
  on_leave: 'on_leave',
  left: 'left',
  archived: 'archived',
} as const;

export interface HrStaffSummary {
  id: string;
  staffReference: string;
  firstName: string;
  lastName: string;
  preferredName?: string | null;
  employmentStatus: HrStaffSummaryEmploymentStatus;
  jobTitle?: string | null;
  department?: string | null;
  workEmail?: string | null;
  mobilePhone?: string | null;
  staffPhoto?: string | null;
  startDate?: string | null;
  rightToWorkExpiry?: string | null;
  nextReviewDate?: string | null;
  linkedUserId?: string | null;
  createdAt: string;
}

export interface HrStaffListResponse {
  items: HrStaffSummary[];
  total: number;
  limit: number;
  offset: number;
  rightToWorkReminderDays: number;
  /** Effective tenant document-expiry reminder window (days) used by the performance-review-due alert, surfaced so the "Review due"/"Overdue" badge mirrors the alert's threshold without needing hr.settings.manage. Falls back to 30. */
  documentExpiryReminderDays: number;
}

export type HrStaffDetailEmploymentStatus = typeof HrStaffDetailEmploymentStatus[keyof typeof HrStaffDetailEmploymentStatus];


export const HrStaffDetailEmploymentStatus = {
  applicant: 'applicant',
  active: 'active',
  probation: 'probation',
  suspended: 'suspended',
  on_leave: 'on_leave',
  left: 'left',
  archived: 'archived',
} as const;

export type HrStaffDetailRightToWorkStatus = typeof HrStaffDetailRightToWorkStatus[keyof typeof HrStaffDetailRightToWorkStatus] | null;


export const HrStaffDetailRightToWorkStatus = {
  not_checked: 'not_checked',
  verified: 'verified',
  follow_up_required: 'follow_up_required',
  expired: 'expired',
  restricted: 'restricted',
} as const;

export type HrStaffDetailContractType = typeof HrStaffDetailContractType[keyof typeof HrStaffDetailContractType] | null;


export const HrStaffDetailContractType = {
  permanent: 'permanent',
  fixed_term: 'fixed_term',
  temporary: 'temporary',
  zero_hours: 'zero_hours',
  contractor: 'contractor',
  apprentice: 'apprentice',
  other: 'other',
} as const;

export type HrStaffDetailEmploymentType = typeof HrStaffDetailEmploymentType[keyof typeof HrStaffDetailEmploymentType] | null;


export const HrStaffDetailEmploymentType = {
  full_time: 'full_time',
  part_time: 'part_time',
  casual: 'casual',
  seasonal: 'seasonal',
  other: 'other',
} as const;

export interface HrStaffDetail {
  id: string;
  staffReference: string;
  staffSeq?: number;
  linkedUserId?: string | null;
  employmentStatus: HrStaffDetailEmploymentStatus;
  firstName: string;
  lastName: string;
  preferredName?: string | null;
  staffPhoto?: string | null;
  jobTitle?: string | null;
  department?: string | null;
  manager?: string | null;
  managerStaffId?: string | null;
  workEmail?: string | null;
  personalEmail?: string | null;
  mobilePhone?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactRelationship?: string | null;
  homeAddress?: string | null;
  dateOfBirth?: string | null;
  nationality?: string | null;
  rightToWorkStatus?: HrStaffDetailRightToWorkStatus;
  rightToWorkExpiry?: string | null;
  /** Effective tenant reminder window (days) used by the right-to-work compliance alert, surfaced so the Profile badge mirrors the alert's threshold without needing hr.settings.manage. Falls back to 30. */
  rightToWorkReminderDays?: number;
  /** Effective tenant document-expiry reminder window (days) used by the performance-review-due alert, surfaced so the "Review due"/"Overdue" badge mirrors the alert's threshold without needing hr.settings.manage. Falls back to 30. */
  documentExpiryReminderDays?: number;
  startDate?: string | null;
  endDate?: string | null;
  probationEndDate?: string | null;
  contractType?: HrStaffDetailContractType;
  employmentType?: HrStaffDetailEmploymentType;
  notes?: string | null;
  nextReviewDate?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type HrStaffInputEmploymentStatus = typeof HrStaffInputEmploymentStatus[keyof typeof HrStaffInputEmploymentStatus];


export const HrStaffInputEmploymentStatus = {
  applicant: 'applicant',
  active: 'active',
  probation: 'probation',
  suspended: 'suspended',
  on_leave: 'on_leave',
  left: 'left',
  archived: 'archived',
} as const;

export type HrStaffInputRightToWorkStatus = typeof HrStaffInputRightToWorkStatus[keyof typeof HrStaffInputRightToWorkStatus] | null;


export const HrStaffInputRightToWorkStatus = {
  not_checked: 'not_checked',
  verified: 'verified',
  follow_up_required: 'follow_up_required',
  expired: 'expired',
  restricted: 'restricted',
} as const;

export type HrStaffInputContractType = typeof HrStaffInputContractType[keyof typeof HrStaffInputContractType] | null;


export const HrStaffInputContractType = {
  permanent: 'permanent',
  fixed_term: 'fixed_term',
  temporary: 'temporary',
  zero_hours: 'zero_hours',
  contractor: 'contractor',
  apprentice: 'apprentice',
  other: 'other',
} as const;

export type HrStaffInputEmploymentType = typeof HrStaffInputEmploymentType[keyof typeof HrStaffInputEmploymentType] | null;


export const HrStaffInputEmploymentType = {
  full_time: 'full_time',
  part_time: 'part_time',
  casual: 'casual',
  seasonal: 'seasonal',
  other: 'other',
} as const;

export interface HrStaffInput {
  /**
     * @minLength 1
     * @maxLength 200
     */
  firstName: string;
  /**
     * @minLength 1
     * @maxLength 200
     */
  lastName: string;
  preferredName?: string | null;
  linkedUserId?: string | null;
  employmentStatus?: HrStaffInputEmploymentStatus;
  staffPhoto?: string | null;
  jobTitle?: string | null;
  department?: string | null;
  manager?: string | null;
  managerStaffId?: string | null;
  workEmail?: string | null;
  personalEmail?: string | null;
  mobilePhone?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactRelationship?: string | null;
  homeAddress?: string | null;
  dateOfBirth?: string | null;
  nationality?: string | null;
  rightToWorkStatus?: HrStaffInputRightToWorkStatus;
  rightToWorkExpiry?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  probationEndDate?: string | null;
  contractType?: HrStaffInputContractType;
  employmentType?: HrStaffInputEmploymentType;
  notes?: string | null;
  nextReviewDate?: string | null;
}

export type HrStaffUpdate = HrStaffInput;

export type HrPayDetailsPayFrequency = typeof HrPayDetailsPayFrequency[keyof typeof HrPayDetailsPayFrequency] | null;


export const HrPayDetailsPayFrequency = {
  per_hour: 'per_hour',
  per_week: 'per_week',
  per_month: 'per_month',
  per_year: 'per_year',
  fixed: 'fixed',
  custom: 'custom',
} as const;

export type HrPayDetailsStudentLoanPlan = typeof HrPayDetailsStudentLoanPlan[keyof typeof HrPayDetailsStudentLoanPlan] | null;


export const HrPayDetailsStudentLoanPlan = {
  none: 'none',
  plan_1: 'plan_1',
  plan_2: 'plan_2',
  plan_4: 'plan_4',
  postgraduate: 'postgraduate',
} as const;

export type HrPayDetailsStarterDeclaration = typeof HrPayDetailsStarterDeclaration[keyof typeof HrPayDetailsStarterDeclaration] | null;


export const HrPayDetailsStarterDeclaration = {
  a: 'a',
  b: 'b',
  c: 'c',
} as const;

export interface HrPayDetails {
  id?: string | null;
  staffId: string;
  payAmount?: number | null;
  payFrequency?: HrPayDetailsPayFrequency;
  normalHoursPerWeek?: number | null;
  overtimeRate?: number | null;
  bankAccountName?: string | null;
  bankName?: string | null;
  sortCode?: string | null;
  accountNumber?: string | null;
  payrollReference?: string | null;
  taxCode?: string | null;
  nationalInsuranceNumber?: string | null;
  niCategory?: string | null;
  studentLoanPlan?: HrPayDetailsStudentLoanPlan;
  starterDeclaration?: HrPayDetailsStarterDeclaration;
  pensionDetails?: string | null;
  notes?: string | null;
  bankDetailsRedacted?: boolean;
  updatedAt?: string | null;
}

export type HrPayDetailsInputPayFrequency = typeof HrPayDetailsInputPayFrequency[keyof typeof HrPayDetailsInputPayFrequency] | null;


export const HrPayDetailsInputPayFrequency = {
  per_hour: 'per_hour',
  per_week: 'per_week',
  per_month: 'per_month',
  per_year: 'per_year',
  fixed: 'fixed',
  custom: 'custom',
} as const;

export type HrPayDetailsInputNiCategory = typeof HrPayDetailsInputNiCategory[keyof typeof HrPayDetailsInputNiCategory] | null;


export const HrPayDetailsInputNiCategory = {
  A: 'A',
  B: 'B',
  C: 'C',
  F: 'F',
  H: 'H',
  I: 'I',
  J: 'J',
  L: 'L',
  M: 'M',
  N: 'N',
  S: 'S',
  V: 'V',
  X: 'X',
  Z: 'Z',
} as const;

export type HrPayDetailsInputStudentLoanPlan = typeof HrPayDetailsInputStudentLoanPlan[keyof typeof HrPayDetailsInputStudentLoanPlan] | null;


export const HrPayDetailsInputStudentLoanPlan = {
  none: 'none',
  plan_1: 'plan_1',
  plan_2: 'plan_2',
  plan_4: 'plan_4',
  postgraduate: 'postgraduate',
} as const;

export type HrPayDetailsInputStarterDeclaration = typeof HrPayDetailsInputStarterDeclaration[keyof typeof HrPayDetailsInputStarterDeclaration] | null;


export const HrPayDetailsInputStarterDeclaration = {
  a: 'a',
  b: 'b',
  c: 'c',
} as const;

export interface HrPayDetailsInput {
  payAmount?: number | null;
  payFrequency?: HrPayDetailsInputPayFrequency;
  normalHoursPerWeek?: number | null;
  overtimeRate?: number | null;
  bankAccountName?: string | null;
  bankName?: string | null;
  /**
     * UK sort code. Six digits, accepted as NN-NN-NN, NNNNNN or with spaces; stored canonicalised as six digits with no separators. This loose pattern only documents the rough shape (digits + optional separators); the server performs the authoritative six-digit check.
     * @pattern ^[0-9\s-]*$
     */
  sortCode?: string | null;
  /**
     * UK bank account number. Eight digits (separators/spaces are stripped). This loose pattern only documents the rough shape (digits + optional separators); the server performs the authoritative eight-digit check.
     * @pattern ^[0-9\s-]*$
     */
  accountNumber?: string | null;
  payrollReference?: string | null;
  /**
     * UK tax code such as 1257L, BR, K475, NT or D0. Stored canonicalised (upper-cased, whitespace stripped). This loose pattern documents the rough shape; the server performs the authoritative validation.
     * @pattern ^\s*[A-Za-z]?[A-Za-z0-9]{1,6}\s?[A-Za-z0-9]{0,2}\s*$
     */
  taxCode?: string | null;
  /**
     * UK National Insurance number. Two prefix letters, six digits, one suffix letter (A–D). Stored canonicalised (upper-cased, whitespace stripped). Disallowed prefix letters/combinations are rejected server-side. This loose pattern documents the rough shape; the server performs the authoritative validation.
     * @pattern ^\s*[A-Za-z]{2}\s?[0-9]{2}\s?[0-9]{2}\s?[0-9]{2}\s?[A-Za-z]\s*$
     */
  nationalInsuranceNumber?: string | null;
  niCategory?: HrPayDetailsInputNiCategory;
  studentLoanPlan?: HrPayDetailsInputStudentLoanPlan;
  starterDeclaration?: HrPayDetailsInputStarterDeclaration;
  pensionDetails?: string | null;
  notes?: string | null;
}

export type HrHoursEntryStatus = typeof HrHoursEntryStatus[keyof typeof HrHoursEntryStatus];


export const HrHoursEntryStatus = {
  draft: 'draft',
  submitted: 'submitted',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export interface HrHoursEntry {
  id: string;
  staffId: string;
  periodStart: string;
  periodEnd: string;
  hoursWorked: number;
  overtimeHours: number;
  notes?: string | null;
  status: HrHoursEntryStatus;
  approvedBy?: string | null;
  approvedAt?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type HrHoursInputStatus = typeof HrHoursInputStatus[keyof typeof HrHoursInputStatus];


export const HrHoursInputStatus = {
  draft: 'draft',
  submitted: 'submitted',
} as const;

export interface HrHoursInput {
  periodStart: string;
  periodEnd: string;
  hoursWorked?: number;
  overtimeHours?: number;
  notes?: string | null;
  status?: HrHoursInputStatus;
}

export type HrHoursUpdateStatus = typeof HrHoursUpdateStatus[keyof typeof HrHoursUpdateStatus];


export const HrHoursUpdateStatus = {
  draft: 'draft',
  submitted: 'submitted',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export interface HrHoursUpdate {
  periodStart?: string;
  periodEnd?: string;
  hoursWorked?: number;
  overtimeHours?: number;
  notes?: string | null;
  status?: HrHoursUpdateStatus;
}

export type HrDocumentDocumentType = typeof HrDocumentDocumentType[keyof typeof HrDocumentDocumentType];


export const HrDocumentDocumentType = {
  employment_contract: 'employment_contract',
  nda: 'nda',
  proof_of_address: 'proof_of_address',
  passport: 'passport',
  driving_licence: 'driving_licence',
  national_id: 'national_id',
  bank_details: 'bank_details',
  payroll_document: 'payroll_document',
  training_certificate: 'training_certificate',
  right_to_work: 'right_to_work',
  policy_acknowledgement: 'policy_acknowledgement',
  performance_review: 'performance_review',
  disciplinary_document: 'disciplinary_document',
  other: 'other',
} as const;

export type HrDocumentStatus = typeof HrDocumentStatus[keyof typeof HrDocumentStatus];


export const HrDocumentStatus = {
  uploaded: 'uploaded',
  pending_review: 'pending_review',
  approved: 'approved',
  rejected: 'rejected',
  expired: 'expired',
  archived: 'archived',
} as const;

export interface HrDocument {
  id: string;
  staffId: string;
  documentType: HrDocumentDocumentType;
  title: string;
  objectPath: string;
  fileName?: string | null;
  contentType?: string | null;
  sizeBytes?: number | null;
  expiryDate?: string | null;
  status: HrDocumentStatus;
  notes?: string | null;
  visibleToStaff: boolean;
  createdAt: string;
  updatedAt?: string;
}

export type HrDocumentInputDocumentType = typeof HrDocumentInputDocumentType[keyof typeof HrDocumentInputDocumentType];


export const HrDocumentInputDocumentType = {
  employment_contract: 'employment_contract',
  nda: 'nda',
  proof_of_address: 'proof_of_address',
  passport: 'passport',
  driving_licence: 'driving_licence',
  national_id: 'national_id',
  bank_details: 'bank_details',
  payroll_document: 'payroll_document',
  training_certificate: 'training_certificate',
  right_to_work: 'right_to_work',
  policy_acknowledgement: 'policy_acknowledgement',
  performance_review: 'performance_review',
  disciplinary_document: 'disciplinary_document',
  other: 'other',
} as const;

export interface HrDocumentInput {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  objectPath: string;
  documentType?: HrDocumentInputDocumentType;
  fileName?: string | null;
  contentType?: string | null;
  sizeBytes?: number | null;
  expiryDate?: string | null;
  notes?: string | null;
  visibleToStaff?: boolean;
}

export type HrDocumentUpdateDocumentType = typeof HrDocumentUpdateDocumentType[keyof typeof HrDocumentUpdateDocumentType];


export const HrDocumentUpdateDocumentType = {
  employment_contract: 'employment_contract',
  nda: 'nda',
  proof_of_address: 'proof_of_address',
  passport: 'passport',
  driving_licence: 'driving_licence',
  national_id: 'national_id',
  bank_details: 'bank_details',
  payroll_document: 'payroll_document',
  training_certificate: 'training_certificate',
  right_to_work: 'right_to_work',
  policy_acknowledgement: 'policy_acknowledgement',
  performance_review: 'performance_review',
  disciplinary_document: 'disciplinary_document',
  other: 'other',
} as const;

export type HrDocumentUpdateStatus = typeof HrDocumentUpdateStatus[keyof typeof HrDocumentUpdateStatus];


export const HrDocumentUpdateStatus = {
  uploaded: 'uploaded',
  pending_review: 'pending_review',
  approved: 'approved',
  rejected: 'rejected',
  expired: 'expired',
  archived: 'archived',
} as const;

export interface HrDocumentUpdate {
  title?: string;
  documentType?: HrDocumentUpdateDocumentType;
  expiryDate?: string | null;
  status?: HrDocumentUpdateStatus;
  notes?: string | null;
  visibleToStaff?: boolean;
}

export type HrMyDocumentInputDocumentType = typeof HrMyDocumentInputDocumentType[keyof typeof HrMyDocumentInputDocumentType];


export const HrMyDocumentInputDocumentType = {
  employment_contract: 'employment_contract',
  nda: 'nda',
  proof_of_address: 'proof_of_address',
  passport: 'passport',
  driving_licence: 'driving_licence',
  national_id: 'national_id',
  bank_details: 'bank_details',
  payroll_document: 'payroll_document',
  training_certificate: 'training_certificate',
  right_to_work: 'right_to_work',
  policy_acknowledgement: 'policy_acknowledgement',
  performance_review: 'performance_review',
  disciplinary_document: 'disciplinary_document',
  other: 'other',
} as const;

export interface HrMyDocumentInput {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  objectPath: string;
  documentType?: HrMyDocumentInputDocumentType;
  fileName?: string | null;
  contentType?: string | null;
  sizeBytes?: number | null;
}

export type HrAbsenceAbsenceType = typeof HrAbsenceAbsenceType[keyof typeof HrAbsenceAbsenceType];


export const HrAbsenceAbsenceType = {
  sickness: 'sickness',
  holiday: 'holiday',
  unpaid_leave: 'unpaid_leave',
  lateness: 'lateness',
  authorised: 'authorised',
  unauthorised: 'unauthorised',
  compassionate: 'compassionate',
  appointment: 'appointment',
  other: 'other',
} as const;

export type HrAbsenceStatus = typeof HrAbsenceStatus[keyof typeof HrAbsenceStatus];


export const HrAbsenceStatus = {
  requested: 'requested',
  approved: 'approved',
  rejected: 'rejected',
  logged: 'logged',
  cancelled: 'cancelled',
} as const;

export interface HrAbsence {
  id: string;
  staffId: string;
  absenceType: HrAbsenceAbsenceType;
  startDate: string;
  endDate?: string | null;
  totalDays?: number | null;
  totalHours?: number | null;
  reason?: string | null;
  evidencePath?: string | null;
  status: HrAbsenceStatus;
  approvedBy?: string | null;
  visibleToStaff: boolean;
  notes?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type HrAbsenceInputAbsenceType = typeof HrAbsenceInputAbsenceType[keyof typeof HrAbsenceInputAbsenceType];


export const HrAbsenceInputAbsenceType = {
  sickness: 'sickness',
  holiday: 'holiday',
  unpaid_leave: 'unpaid_leave',
  lateness: 'lateness',
  authorised: 'authorised',
  unauthorised: 'unauthorised',
  compassionate: 'compassionate',
  appointment: 'appointment',
  other: 'other',
} as const;

export type HrAbsenceInputStatus = typeof HrAbsenceInputStatus[keyof typeof HrAbsenceInputStatus];


export const HrAbsenceInputStatus = {
  requested: 'requested',
  approved: 'approved',
  rejected: 'rejected',
  logged: 'logged',
  cancelled: 'cancelled',
} as const;

export interface HrAbsenceInput {
  absenceType: HrAbsenceInputAbsenceType;
  startDate: string;
  endDate?: string | null;
  totalDays?: number | null;
  totalHours?: number | null;
  reason?: string | null;
  evidencePath?: string | null;
  status?: HrAbsenceInputStatus;
  visibleToStaff?: boolean;
  notes?: string | null;
}

export type HrAbsenceUpdate = HrAbsenceInput;

export type HrTimeOffRequestAbsenceType = typeof HrTimeOffRequestAbsenceType[keyof typeof HrTimeOffRequestAbsenceType];


export const HrTimeOffRequestAbsenceType = {
  holiday: 'holiday',
  sickness: 'sickness',
  unpaid_leave: 'unpaid_leave',
  compassionate_leave: 'compassionate_leave',
  medical_appointment: 'medical_appointment',
  other: 'other',
} as const;

export type HrTimeOffRequestStatus = typeof HrTimeOffRequestStatus[keyof typeof HrTimeOffRequestStatus];


export const HrTimeOffRequestStatus = {
  requested: 'requested',
  approved: 'approved',
  rejected: 'rejected',
  cancelled: 'cancelled',
  info_requested: 'info_requested',
} as const;

export interface HrTimeOffRequest {
  id: string;
  staffId: string;
  staffName?: string | null;
  requestedByUserId?: string;
  absenceType: HrTimeOffRequestAbsenceType;
  startDate: string;
  endDate: string;
  totalDays?: number | null;
  totalHours?: number | null;
  reason?: string | null;
  evidencePath?: string | null;
  notes?: string | null;
  status: HrTimeOffRequestStatus;
  reviewedByUserId?: string | null;
  reviewedAt?: string | null;
  adminNotes?: string | null;
  adminNotesVisibleToStaff?: boolean;
  rejectionReason?: string | null;
  convertedAbsenceId?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type HrTimeOffInputAbsenceType = typeof HrTimeOffInputAbsenceType[keyof typeof HrTimeOffInputAbsenceType];


export const HrTimeOffInputAbsenceType = {
  holiday: 'holiday',
  sickness: 'sickness',
  unpaid_leave: 'unpaid_leave',
  compassionate_leave: 'compassionate_leave',
  medical_appointment: 'medical_appointment',
  other: 'other',
} as const;

export interface HrTimeOffInput {
  absenceType: HrTimeOffInputAbsenceType;
  startDate: string;
  endDate: string;
  totalDays?: number | null;
  totalHours?: number | null;
  reason?: string | null;
  evidencePath?: string | null;
  notes?: string | null;
}

export type HrMyTimeOffInput = HrTimeOffInput;

export type HrTimeOffReviewAction = typeof HrTimeOffReviewAction[keyof typeof HrTimeOffReviewAction];


export const HrTimeOffReviewAction = {
  approve: 'approve',
  reject: 'reject',
  request_info: 'request_info',
  cancel: 'cancel',
} as const;

export interface HrTimeOffReview {
  action: HrTimeOffReviewAction;
  adminNotes?: string | null;
  adminNotesVisibleToStaff?: boolean;
  rejectionReason?: string | null;
  /** On approve, also log an absence row. */
  createAbsence?: boolean;
}

export type HrChangeRequestStatus = typeof HrChangeRequestStatus[keyof typeof HrChangeRequestStatus];


export const HrChangeRequestStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  cancelled: 'cancelled',
} as const;

export interface HrChangeRequest {
  id: string;
  staffId: string;
  staffName?: string | null;
  requestedByUserId?: string;
  fieldName: string;
  oldValue?: string | null;
  requestedValue?: string | null;
  status: HrChangeRequestStatus;
  reviewedByUserId?: string | null;
  reviewedAt?: string | null;
  rejectionReason?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export interface HrMyChangeRequestInput {
  /**
     * @minLength 1
     * @maxLength 64
     */
  fieldName: string;
  requestedValue: string | null;
}

export type HrChangeRequestReviewAction = typeof HrChangeRequestReviewAction[keyof typeof HrChangeRequestReviewAction];


export const HrChangeRequestReviewAction = {
  approve: 'approve',
  reject: 'reject',
} as const;

export interface HrChangeRequestReview {
  action: HrChangeRequestReviewAction;
  rejectionReason?: string | null;
  /** On approve, write the requested value onto the staff record. */
  applyChange?: boolean;
}

export type HrCommunicationCommunicationType = typeof HrCommunicationCommunicationType[keyof typeof HrCommunicationCommunicationType];


export const HrCommunicationCommunicationType = {
  email: 'email',
  call: 'call',
  whatsapp: 'whatsapp',
  sms: 'sms',
  meeting: 'meeting',
  letter: 'letter',
  other: 'other',
} as const;

export interface HrCommunication {
  id: string;
  staffId: string;
  communicationType: HrCommunicationCommunicationType;
  subject?: string | null;
  content?: string | null;
  sentBy?: string | null;
  recipient?: string | null;
  occurredAt: string;
  attachments?: HrAttachment[];
  notes?: string | null;
  visibleToStaff: boolean;
  createdAt: string;
}

export type HrCommunicationInputCommunicationType = typeof HrCommunicationInputCommunicationType[keyof typeof HrCommunicationInputCommunicationType];


export const HrCommunicationInputCommunicationType = {
  email: 'email',
  call: 'call',
  whatsapp: 'whatsapp',
  sms: 'sms',
  meeting: 'meeting',
  letter: 'letter',
  other: 'other',
} as const;

export interface HrCommunicationInput {
  communicationType: HrCommunicationInputCommunicationType;
  subject?: string | null;
  content?: string | null;
  recipient?: string | null;
  occurredAt?: string | null;
  attachments?: HrAttachment[];
  notes?: string | null;
  visibleToStaff?: boolean;
}

export type HrTrainingRecordStatus = typeof HrTrainingRecordStatus[keyof typeof HrTrainingRecordStatus];


export const HrTrainingRecordStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
  expired: 'expired',
  refresher_due: 'refresher_due',
} as const;

export interface HrTrainingRecord {
  id: string;
  staffId: string;
  trainingName: string;
  trainingType?: string | null;
  trainer?: string | null;
  completionDate?: string | null;
  expiryDate?: string | null;
  evidencePath?: string | null;
  notes?: string | null;
  status: HrTrainingRecordStatus;
  visibleToStaff: boolean;
  createdAt: string;
  updatedAt?: string;
}

export type HrTrainingInputStatus = typeof HrTrainingInputStatus[keyof typeof HrTrainingInputStatus];


export const HrTrainingInputStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
  expired: 'expired',
  refresher_due: 'refresher_due',
} as const;

export interface HrTrainingInput {
  /** @minLength 1 */
  trainingName: string;
  trainingType?: string | null;
  trainer?: string | null;
  completionDate?: string | null;
  expiryDate?: string | null;
  evidencePath?: string | null;
  notes?: string | null;
  status?: HrTrainingInputStatus;
  visibleToStaff?: boolean;
}

export type HrTrainingUpdate = HrTrainingInput;

export type HrOnboardingItemCategory = typeof HrOnboardingItemCategory[keyof typeof HrOnboardingItemCategory] | null;


export const HrOnboardingItemCategory = {
  Documents: 'Documents',
  Payroll: 'Payroll',
  'Health_&_Safety': 'Health & Safety',
  Systems: 'Systems',
  Training: 'Training',
  Equipment: 'Equipment',
  Policies: 'Policies',
  Probation: 'Probation',
} as const;

export interface HrOnboardingItem {
  id: string;
  staffId: string;
  templateId?: string | null;
  title: string;
  description?: string | null;
  category?: HrOnboardingItemCategory;
  required: boolean;
  dueDate?: string | null;
  completed: boolean;
  completedBy?: string | null;
  completedDate?: string | null;
  evidencePath?: string | null;
  notes?: string | null;
  visibleToStaff: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt?: string;
}

export type HrOnboardingItemInputCategory = typeof HrOnboardingItemInputCategory[keyof typeof HrOnboardingItemInputCategory] | null;


export const HrOnboardingItemInputCategory = {
  Documents: 'Documents',
  Payroll: 'Payroll',
  'Health_&_Safety': 'Health & Safety',
  Systems: 'Systems',
  Training: 'Training',
  Equipment: 'Equipment',
  Policies: 'Policies',
  Probation: 'Probation',
} as const;

export interface HrOnboardingItemInput {
  /** @minLength 1 */
  title: string;
  description?: string | null;
  category?: HrOnboardingItemInputCategory;
  required?: boolean;
  dueDate?: string | null;
  notes?: string | null;
  visibleToStaff?: boolean;
  sortOrder?: number;
}

export type HrOnboardingItemUpdateCategory = typeof HrOnboardingItemUpdateCategory[keyof typeof HrOnboardingItemUpdateCategory] | null;


export const HrOnboardingItemUpdateCategory = {
  Documents: 'Documents',
  Payroll: 'Payroll',
  'Health_&_Safety': 'Health & Safety',
  Systems: 'Systems',
  Training: 'Training',
  Equipment: 'Equipment',
  Policies: 'Policies',
  Probation: 'Probation',
} as const;

export interface HrOnboardingItemUpdate {
  title?: string;
  description?: string | null;
  category?: HrOnboardingItemUpdateCategory;
  required?: boolean;
  dueDate?: string | null;
  completed?: boolean;
  evidencePath?: string | null;
  notes?: string | null;
  visibleToStaff?: boolean;
  sortOrder?: number;
}

export interface HrApplyOnboardingTemplate {
  templateId: string;
}

export type HrOnboardingTemplateItemCategory = typeof HrOnboardingTemplateItemCategory[keyof typeof HrOnboardingTemplateItemCategory];


export const HrOnboardingTemplateItemCategory = {
  Documents: 'Documents',
  Payroll: 'Payroll',
  'Health_&_Safety': 'Health & Safety',
  Systems: 'Systems',
  Training: 'Training',
  Equipment: 'Equipment',
  Policies: 'Policies',
  Probation: 'Probation',
} as const;

export interface HrOnboardingTemplateItem {
  title: string;
  description?: string | null;
  category: HrOnboardingTemplateItemCategory;
  required: boolean;
  dueDateOffsetDays?: number | null;
  visibleToStaff: boolean;
}

export interface HrOnboardingTemplate {
  id: string;
  name: string;
  description?: string | null;
  isDefault: boolean;
  items: HrOnboardingTemplateItem[];
  createdAt: string;
  updatedAt?: string;
}

export interface HrOnboardingTemplateInput {
  /** @minLength 1 */
  name: string;
  description?: string | null;
  isDefault?: boolean;
  items: HrOnboardingTemplateItem[];
}

export type HrIncidentRecordType = typeof HrIncidentRecordType[keyof typeof HrIncidentRecordType];


export const HrIncidentRecordType = {
  incident: 'incident',
  verbal_warning: 'verbal_warning',
  written_warning: 'written_warning',
  final_warning: 'final_warning',
  grievance: 'grievance',
  performance_issue: 'performance_issue',
  investigation: 'investigation',
  absence_issue: 'absence_issue',
  general_report: 'general_report',
} as const;

export type HrIncidentSeverity = typeof HrIncidentSeverity[keyof typeof HrIncidentSeverity];


export const HrIncidentSeverity = {
  low: 'low',
  medium: 'medium',
  high: 'high',
  critical: 'critical',
} as const;

export type HrIncidentStatus = typeof HrIncidentStatus[keyof typeof HrIncidentStatus];


export const HrIncidentStatus = {
  open: 'open',
  under_review: 'under_review',
  action_required: 'action_required',
  resolved: 'resolved',
  closed: 'closed',
  archived: 'archived',
} as const;

export interface HrIncident {
  id: string;
  staffId: string;
  recordType: HrIncidentRecordType;
  title: string;
  description?: string | null;
  severity: HrIncidentSeverity;
  status: HrIncidentStatus;
  incidentDate?: string | null;
  outcome?: string | null;
  followUpDate?: string | null;
  attachments?: HrAttachment[];
  notes?: string | null;
  visibleToStaff: boolean;
  createdAt: string;
  updatedAt?: string;
}

export type HrIncidentInputRecordType = typeof HrIncidentInputRecordType[keyof typeof HrIncidentInputRecordType];


export const HrIncidentInputRecordType = {
  incident: 'incident',
  verbal_warning: 'verbal_warning',
  written_warning: 'written_warning',
  final_warning: 'final_warning',
  grievance: 'grievance',
  performance_issue: 'performance_issue',
  investigation: 'investigation',
  absence_issue: 'absence_issue',
  general_report: 'general_report',
} as const;

export type HrIncidentInputSeverity = typeof HrIncidentInputSeverity[keyof typeof HrIncidentInputSeverity];


export const HrIncidentInputSeverity = {
  low: 'low',
  medium: 'medium',
  high: 'high',
  critical: 'critical',
} as const;

export type HrIncidentInputStatus = typeof HrIncidentInputStatus[keyof typeof HrIncidentInputStatus];


export const HrIncidentInputStatus = {
  open: 'open',
  under_review: 'under_review',
  action_required: 'action_required',
  resolved: 'resolved',
  closed: 'closed',
  archived: 'archived',
} as const;

export interface HrIncidentInput {
  recordType?: HrIncidentInputRecordType;
  /** @minLength 1 */
  title: string;
  description?: string | null;
  severity?: HrIncidentInputSeverity;
  status?: HrIncidentInputStatus;
  incidentDate?: string | null;
  outcome?: string | null;
  followUpDate?: string | null;
  attachments?: HrAttachment[];
  notes?: string | null;
  visibleToStaff?: boolean;
}

export type HrIncidentUpdate = HrIncidentInput;

export type HrTimelineEventDetail = { [key: string]: unknown };

export interface HrTimelineEvent {
  id: string;
  staffId: string;
  eventType: string;
  title: string;
  detail?: HrTimelineEventDetail;
  visibleToStaff?: boolean;
  actorId?: string | null;
  occurredAt: string;
}

export interface HrSettings {
  staffSelfServiceEnabled: boolean;
  staffCanViewOwnRecord?: boolean;
  staffCanRequestAmendments?: boolean;
  staffCanRequestTimeOff?: boolean;
  staffCanViewOwnDocuments?: boolean;
  staffCanUploadDocuments?: boolean;
  staffCanViewOwnOnboarding?: boolean;
  staffCanViewOwnTraining?: boolean;
  staffCanViewOwnAbsences?: boolean;
  staffCanViewOwnCommunications?: boolean;
  staffCanSeeVisibleIncidents?: boolean;
  staffCanViewPay?: boolean;
  staffCanViewBankDetails?: boolean;
  staffCanRequestBankChanges?: boolean;
  staffPhotoChangesRequireApproval?: boolean;
  amendmentsRequireApproval?: boolean;
  visibleFields?: string[];
  amendableFields?: string[];
  requiredDocumentTypes?: string[];
  requiredOnboardingItems?: string[];
  trainingRequirements?: string[];
  documentExpiryReminderDays?: number;
  rightToWorkReminderDays?: number | null;
  probationDefaultDays?: number;
  retentionDays?: number | null;
  paymentAuthoriserUserId?: string | null;
  paymentReminderLeadDays?: number;
  /**
     * @minimum 1
     * @maximum 7
     */
  paymentDigestWeekday?: number;
  updatedAt?: string | null;
}

export interface HrSettingsInput {
  staffSelfServiceEnabled?: boolean;
  staffCanViewOwnRecord?: boolean;
  staffCanRequestAmendments?: boolean;
  staffCanRequestTimeOff?: boolean;
  staffCanViewOwnDocuments?: boolean;
  staffCanUploadDocuments?: boolean;
  staffCanViewOwnOnboarding?: boolean;
  staffCanViewOwnTraining?: boolean;
  staffCanViewOwnAbsences?: boolean;
  staffCanViewOwnCommunications?: boolean;
  staffCanSeeVisibleIncidents?: boolean;
  staffCanViewPay?: boolean;
  staffCanViewBankDetails?: boolean;
  staffCanRequestBankChanges?: boolean;
  staffPhotoChangesRequireApproval?: boolean;
  amendmentsRequireApproval?: boolean;
  visibleFields?: string[];
  amendableFields?: string[];
  requiredDocumentTypes?: string[];
  requiredOnboardingItems?: string[];
  trainingRequirements?: string[];
  documentExpiryReminderDays?: number;
  rightToWorkReminderDays?: number | null;
  probationDefaultDays?: number;
  retentionDays?: number | null;
  paymentAuthoriserUserId?: string | null;
  paymentReminderLeadDays?: number;
  /**
     * @minimum 1
     * @maximum 7
     */
  paymentDigestWeekday?: number;
}

export type HrPayCadenceCadence = typeof HrPayCadenceCadence[keyof typeof HrPayCadenceCadence];


export const HrPayCadenceCadence = {
  monthly: 'monthly',
  weekly: 'weekly',
  fortnightly: 'fortnightly',
  ad_hoc: 'ad_hoc',
} as const;

export type HrPayCadenceDefaultMethod = typeof HrPayCadenceDefaultMethod[keyof typeof HrPayCadenceDefaultMethod] | null;


export const HrPayCadenceDefaultMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  cheque: 'cheque',
  other: 'other',
} as const;

export interface HrPayCadence {
  id?: string | null;
  staffId: string;
  cadence: HrPayCadenceCadence;
  /**
     * @minimum 1
     * @maximum 31
     */
  dayOfMonth?: number | null;
  /**
     * @minimum 1
     * @maximum 7
     */
  weekday?: number | null;
  anchorDate?: string | null;
  defaultAmount?: string | null;
  defaultMethod?: HrPayCadenceDefaultMethod;
  authoriserUserId?: string | null;
  active: boolean;
  note?: string | null;
  nextDueDate?: string | null;
  updatedAt?: string | null;
}

export type HrPayCadenceInputCadence = typeof HrPayCadenceInputCadence[keyof typeof HrPayCadenceInputCadence];


export const HrPayCadenceInputCadence = {
  monthly: 'monthly',
  weekly: 'weekly',
  fortnightly: 'fortnightly',
  ad_hoc: 'ad_hoc',
} as const;

export type HrPayCadenceInputDefaultMethod = typeof HrPayCadenceInputDefaultMethod[keyof typeof HrPayCadenceInputDefaultMethod] | null;


export const HrPayCadenceInputDefaultMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  cheque: 'cheque',
  other: 'other',
} as const;

export interface HrPayCadenceInput {
  cadence: HrPayCadenceInputCadence;
  /**
     * @minimum 1
     * @maximum 31
     */
  dayOfMonth?: number | null;
  /**
     * @minimum 1
     * @maximum 7
     */
  weekday?: number | null;
  anchorDate?: string | null;
  defaultAmount?: string | null;
  defaultMethod?: HrPayCadenceInputDefaultMethod;
  authoriserUserId?: string | null;
  active?: boolean;
  note?: string | null;
}

export type HrPaymentStatus = typeof HrPaymentStatus[keyof typeof HrPaymentStatus];


export const HrPaymentStatus = {
  due: 'due',
  paid: 'paid',
  cancelled: 'cancelled',
} as const;

export type HrPaymentMethod = typeof HrPaymentMethod[keyof typeof HrPaymentMethod] | null;


export const HrPaymentMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  cheque: 'cheque',
  other: 'other',
} as const;

export interface HrPayment {
  id: string;
  staffId: string;
  staffName?: string | null;
  cadenceId?: string | null;
  status: HrPaymentStatus;
  dueDate?: string | null;
  amount?: string | null;
  method?: HrPaymentMethod;
  note?: string | null;
  authoriserUserId?: string | null;
  reminderTaskId?: string | null;
  paidAt?: string | null;
  paidBy?: string | null;
  isOverdue?: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export type HrPaymentCreateInputStatus = typeof HrPaymentCreateInputStatus[keyof typeof HrPaymentCreateInputStatus];


export const HrPaymentCreateInputStatus = {
  due: 'due',
  paid: 'paid',
  cancelled: 'cancelled',
} as const;

export type HrPaymentCreateInputMethod = typeof HrPaymentCreateInputMethod[keyof typeof HrPaymentCreateInputMethod] | null;


export const HrPaymentCreateInputMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  cheque: 'cheque',
  other: 'other',
} as const;

export interface HrPaymentCreateInput {
  staffId: string;
  status?: HrPaymentCreateInputStatus;
  dueDate?: string | null;
  amount?: string | null;
  method?: HrPaymentCreateInputMethod;
  note?: string | null;
}

export type HrPaymentUpdateInputStatus = typeof HrPaymentUpdateInputStatus[keyof typeof HrPaymentUpdateInputStatus];


export const HrPaymentUpdateInputStatus = {
  due: 'due',
  paid: 'paid',
  cancelled: 'cancelled',
} as const;

export type HrPaymentUpdateInputMethod = typeof HrPaymentUpdateInputMethod[keyof typeof HrPaymentUpdateInputMethod] | null;


export const HrPaymentUpdateInputMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  cheque: 'cheque',
  other: 'other',
} as const;

export interface HrPaymentUpdateInput {
  status?: HrPaymentUpdateInputStatus;
  dueDate?: string | null;
  amount?: string | null;
  method?: HrPaymentUpdateInputMethod;
  note?: string | null;
}

export type HrPaymentMarkPaidInputMethod = typeof HrPaymentMarkPaidInputMethod[keyof typeof HrPaymentMarkPaidInputMethod] | null;


export const HrPaymentMarkPaidInputMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  cheque: 'cheque',
  other: 'other',
} as const;

export interface HrPaymentMarkPaidInput {
  paidDate?: string | null;
  amount?: string | null;
  method?: HrPaymentMarkPaidInputMethod;
  note?: string | null;
}

export interface HrPaymentListResponse {
  items: HrPayment[];
  total: number;
  totalAmount: string;
  limit: number;
  offset: number;
}

export type HrAuditEntryAction = typeof HrAuditEntryAction[keyof typeof HrAuditEntryAction];


export const HrAuditEntryAction = {
  VIEW: 'VIEW',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  UPLOAD: 'UPLOAD',
  DOWNLOAD: 'DOWNLOAD',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  SUBMIT: 'SUBMIT',
  CANCEL: 'CANCEL',
  ARCHIVE: 'ARCHIVE',
} as const;

export interface HrAuditEntry {
  id: string;
  staffId?: string | null;
  actorUserId?: string | null;
  actorEmail?: string | null;
  action: HrAuditEntryAction;
  entityType: string;
  entityId?: string | null;
  note?: string | null;
  createdAt: string;
}

export interface HrAuditListResponse {
  items: HrAuditEntry[];
  total: number;
  limit: number;
  offset: number;
}

export interface HrSelfRecord {
  hasRecord: boolean;
  staff?: HrStaffDetail | null;
  pay?: HrPayDetails | null;
  settings: HrSettings;
}

export interface HrStaffSchedule {
  staffId: string;
  expectedStartTime?: string | null;
  expectedEndTime?: string | null;
  /**
     * @items.minimum 1
     * @items.maximum 7
     */
  expectedWorkDays: number[];
  expectedHoursPerDay?: string | null;
  timekeepingGraceMinutes: number;
}

export interface HrStaffScheduleInput {
  expectedStartTime?: string | null;
  expectedEndTime?: string | null;
  /**
     * @items.minimum 1
     * @items.maximum 7
     */
  expectedWorkDays?: number[] | null;
  expectedHoursPerDay?: number | null;
  /**
     * @minimum 0
     * @maximum 240
     */
  timekeepingGraceMinutes?: number | null;
}

export type HrClockEventEventType = typeof HrClockEventEventType[keyof typeof HrClockEventEventType];


export const HrClockEventEventType = {
  clock_in: 'clock_in',
  clock_out: 'clock_out',
} as const;

export type HrClockEventSource = typeof HrClockEventSource[keyof typeof HrClockEventSource];


export const HrClockEventSource = {
  self: 'self',
  admin: 'admin',
} as const;

export interface HrClockEvent {
  id: string;
  staffId: string;
  eventType: HrClockEventEventType;
  eventTime: string;
  source: HrClockEventSource;
  note?: string | null;
  createdAt: string;
}

export type HrClockEventInputEventType = typeof HrClockEventInputEventType[keyof typeof HrClockEventInputEventType];


export const HrClockEventInputEventType = {
  clock_in: 'clock_in',
  clock_out: 'clock_out',
} as const;

export type HrClockEventInputSource = typeof HrClockEventInputSource[keyof typeof HrClockEventInputSource] | null;


export const HrClockEventInputSource = {
  self: 'self',
  admin: 'admin',
} as const;

export interface HrClockEventInput {
  staffId: string;
  eventType: HrClockEventInputEventType;
  eventTime: string;
  source?: HrClockEventInputSource;
  note?: string | null;
}

export type HrClockEventUpdateEventType = typeof HrClockEventUpdateEventType[keyof typeof HrClockEventUpdateEventType] | null;


export const HrClockEventUpdateEventType = {
  clock_in: 'clock_in',
  clock_out: 'clock_out',
} as const;

export interface HrClockEventUpdate {
  eventType?: HrClockEventUpdateEventType;
  eventTime?: string | null;
  note?: string | null;
}

export type HrShiftStatus = typeof HrShiftStatus[keyof typeof HrShiftStatus];


export const HrShiftStatus = {
  scheduled: 'scheduled',
  cancelled: 'cancelled',
} as const;

export type HrTimeOffOverlapSource = typeof HrTimeOffOverlapSource[keyof typeof HrTimeOffOverlapSource];


export const HrTimeOffOverlapSource = {
  time_off: 'time_off',
  absence: 'absence',
} as const;

export interface HrTimeOffOverlap {
  id: string;
  source: HrTimeOffOverlapSource;
  absenceType: string;
  startDate: string;
  endDate: string;
}

export interface HrShift {
  id: string;
  staffId: string;
  staffName?: string | null;
  shiftDate: string;
  startTime?: string | null;
  endTime?: string | null;
  role?: string | null;
  notes?: string | null;
  status: HrShiftStatus;
  createdAt: string;
  updatedAt: string;
  leaveConflicts?: HrTimeOffOverlap[];
}

export type HrShiftInputStatus = typeof HrShiftInputStatus[keyof typeof HrShiftInputStatus] | null;


export const HrShiftInputStatus = {
  scheduled: 'scheduled',
  cancelled: 'cancelled',
} as const;

export interface HrShiftInput {
  staffId: string;
  shiftDate: string;
  startTime?: string | null;
  endTime?: string | null;
  role?: string | null;
  notes?: string | null;
  status?: HrShiftInputStatus;
}

export type HrShiftUpdateStatus = typeof HrShiftUpdateStatus[keyof typeof HrShiftUpdateStatus] | null;


export const HrShiftUpdateStatus = {
  scheduled: 'scheduled',
  cancelled: 'cancelled',
} as const;

export interface HrShiftUpdate {
  staffId?: string | null;
  shiftDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  role?: string | null;
  notes?: string | null;
  status?: HrShiftUpdateStatus;
}

export interface HrLossAttributionInput {
  staffId?: string | null;
}

export type HrPerformanceLossRowAttributionSource = typeof HrPerformanceLossRowAttributionSource[keyof typeof HrPerformanceLossRowAttributionSource];


export const HrPerformanceLossRowAttributionSource = {
  manual: 'manual',
  packing_auto: 'packing_auto',
  unattributed: 'unattributed',
} as const;

export interface HrPerformanceLossRow {
  id: string;
  orderId: string;
  orderReference?: string | null;
  type: string;
  status: string;
  note?: string | null;
  lossAmountGbp: string;
  recoveredAmountGbp: string;
  netCostGbp: string;
  attributedStaffId?: string | null;
  attributedStaffName?: string | null;
  attributionSource: HrPerformanceLossRowAttributionSource;
  createdAt: string;
}

export interface HrSicknessRow {
  id: string;
  absenceType: string;
  startDate: string;
  endDate?: string | null;
  totalDays?: string | null;
  reason?: string | null;
  status: string;
}

export type HrTimekeepingDayActualStartSource = typeof HrTimekeepingDayActualStartSource[keyof typeof HrTimekeepingDayActualStartSource];


export const HrTimekeepingDayActualStartSource = {
  clock: 'clock',
  packing: 'packing',
  none: 'none',
} as const;

export type HrTimekeepingDayStatus = typeof HrTimekeepingDayStatus[keyof typeof HrTimekeepingDayStatus];


export const HrTimekeepingDayStatus = {
  on_time: 'on_time',
  late: 'late',
  absent: 'absent',
  no_schedule: 'no_schedule',
  no_data: 'no_data',
} as const;

export interface HrTimekeepingDay {
  date: string;
  isWorkingDay?: boolean;
  expectedStart?: string | null;
  actualStart?: string | null;
  actualStartSource?: HrTimekeepingDayActualStartSource;
  clockIn?: string | null;
  clockOut?: string | null;
  status: HrTimekeepingDayStatus;
  minutesLate?: number | null;
  hoursWorked?: number | null;
  parcels: number;
}

export interface HrPerformanceTrendPoint {
  date: string;
  parcels: number;
  lossCount: number;
  hoursWorked?: number | null;
}

export interface HrPerformanceMetrics {
  parcels: number;
  parcelsPerHour?: number | null;
  parcelsPerDay?: number | null;
  hoursWorked?: number | null;
  activeDays?: number;
  lossCount: number;
  lossCostGbp: string;
  accuracyRate?: number | null;
  onTimeCount: number;
  lateCount: number;
  onTimeRate?: number | null;
  sickDays: number;
}

export interface HrPerformanceLeaderboardRow {
  staffId: string;
  staffReference: string;
  firstName: string;
  lastName: string;
  jobTitle?: string | null;
  staffPhoto?: string | null;
  metrics: HrPerformanceMetrics;
}

export interface HrPerformanceSummary {
  from: string;
  to: string;
  team: HrPerformanceMetrics;
  staff: HrPerformanceLeaderboardRow[];
}

export interface HrPerformanceStaffDetail {
  staff: HrStaffSummary;
  schedule: HrStaffSchedule;
  from: string;
  to: string;
  metrics: HrPerformanceMetrics;
  throughputTrend: HrPerformanceTrendPoint[];
  timekeeping: HrTimekeepingDay[];
  losses: HrPerformanceLossRow[];
  sickness: HrSicknessRow[];
  clockEvents: HrClockEvent[];
}

export interface ScrapSpotPrices {[key: string]: number}

export type ScrapPurchaseItemInputMetal = typeof ScrapPurchaseItemInputMetal[keyof typeof ScrapPurchaseItemInputMetal];


export const ScrapPurchaseItemInputMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
} as const;

export interface ScrapPurchaseItemInput {
  metal: ScrapPurchaseItemInputMetal;
  grossG: number;
  assumedPurityPct: number;
  pricePaidGbp: number;
  /** @nullable */
  notes?: string | null;
}

export interface ScrapPurchaseItemView {
  id: string;
  purchaseId: string;
  metal: string;
  grossG: number;
  assumedPurityPct: number;
  assumedFineG: number;
  spotPriceGbpPerG: number;
  pricePaidGbp: number;
  /** @nullable */
  notes?: string | null;
}

export interface ScrapPhoto {
  url: string;
  type?: string;
}

export interface ScrapPurchaseInput {
  idempotencyKey: string;
  /** @nullable */
  supplierId?: string | null;
  purchaseDate: string;
  spotPricesGbpPerG: ScrapSpotPrices;
  /** @nullable */
  notes?: string | null;
  photos?: ScrapPhoto[];
  items: ScrapPurchaseItemInput[];
}

export interface ScrapPurchaseUpdate {
  /** @nullable */
  supplierId?: string | null;
  purchaseDate?: string;
  spotPricesGbpPerG?: ScrapSpotPrices;
  /** @nullable */
  notes?: string | null;
  photos?: ScrapPhoto[];
}

export interface ScrapPurchaseSummary {
  id: string;
  reference: string;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  supplierName?: string | null;
  purchaseDate: string;
  totalPricePaidGbp: number;
  itemCount: number;
  /** @nullable */
  notes?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export interface ScrapPurchaseDetail {
  id: string;
  reference: string;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  supplierName?: string | null;
  purchaseDate: string;
  spotPricesGbpPerG: ScrapSpotPrices;
  totalPricePaidGbp: number;
  /** @nullable */
  notes?: string | null;
  photos: ScrapPhoto[];
  items: ScrapPurchaseItemView[];
  createdAt: string;
  updatedAt?: string;
}

export type ScrapInventoryItemViewStatus = typeof ScrapInventoryItemViewStatus[keyof typeof ScrapInventoryItemViewStatus];


export const ScrapInventoryItemViewStatus = {
  IN_STOCK: 'IN_STOCK',
  IN_REFINING: 'IN_REFINING',
  REFINED: 'REFINED',
  SOLD: 'SOLD',
  WRITTEN_OFF: 'WRITTEN_OFF',
  CONVERTED: 'CONVERTED',
} as const;

export interface ScrapInventoryItemView {
  id: string;
  purchaseItemId: string;
  /** @nullable */
  purchaseReference?: string | null;
  metal: string;
  grossG: number;
  fineG: number;
  status: ScrapInventoryItemViewStatus;
  /** @nullable */
  location?: string | null;
  unitCostGbp: number;
  photos?: ScrapPhoto[];
  /** @nullable */
  notes?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type ScrapInventoryItemUpdateStatus = typeof ScrapInventoryItemUpdateStatus[keyof typeof ScrapInventoryItemUpdateStatus];


export const ScrapInventoryItemUpdateStatus = {
  IN_STOCK: 'IN_STOCK',
  IN_REFINING: 'IN_REFINING',
  REFINED: 'REFINED',
  SOLD: 'SOLD',
  WRITTEN_OFF: 'WRITTEN_OFF',
  CONVERTED: 'CONVERTED',
} as const;

export interface ScrapInventoryItemUpdate {
  status?: ScrapInventoryItemUpdateStatus;
  /** @nullable */
  location?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface ConvertScrapLotInput {
  productTitle: string;
  /** @nullable */
  productType?: string | null;
  /** @nullable */
  sku?: string | null;
  /** @minimum 1 */
  quantity?: number;
  /** @nullable */
  estimatedResalePrice?: number | null;
  /** @nullable */
  storageLocation?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface ConvertScrapLotResult {
  inventoryItemId: string;
  sku: string;
  landedUnitCost: number;
  refiningFeeAllocatedGbp?: number;
  scrapInventoryItem: ScrapInventoryItemView;
}

export interface RefiningBatchInput {
  /** @nullable */
  refinerName?: string | null;
  /** @nullable */
  notes?: string | null;
  scrapInventoryItemIds: string[];
}

export interface ReceiveRefiningBatchInput {
  totalPayoutGbp: number;
  feeGbp?: number;
  /** @nullable */
  receivedAt?: string | null;
}

export type RefiningBatchUpdateStatus = typeof RefiningBatchUpdateStatus[keyof typeof RefiningBatchUpdateStatus];


export const RefiningBatchUpdateStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  RESULTS_PENDING: 'RESULTS_PENDING',
  FINALISED: 'FINALISED',
  RECEIVED: 'RECEIVED',
} as const;

export type RefiningResultInputMetal = typeof RefiningResultInputMetal[keyof typeof RefiningResultInputMetal];


export const RefiningResultInputMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
} as const;

export interface RefiningResultInput {
  metal: RefiningResultInputMetal;
  returnedFineG: number;
  payoutGbp: number;
}

export interface RefiningBatchUpdate {
  status?: RefiningBatchUpdateStatus;
  /** @nullable */
  refinerName?: string | null;
  /** @nullable */
  sentAt?: string | null;
  /** @nullable */
  receivedAt?: string | null;
  feeGbp?: number;
  /** @nullable */
  notes?: string | null;
  results?: RefiningResultInput[];
}

export interface RefiningResultView {
  id: string;
  batchId: string;
  metal: string;
  returnedFineG: number;
  payoutGbp: number;
}

export interface RefiningBatchFinaliseInput {
  feeGbp?: number;
  /** @nullable */
  receivedAt?: string | null;
  results: RefiningResultInput[];
}

export interface RefiningMetalRollup {
  metal: string;
  batchCount: number;
  totalPurchaseCostGbp: number;
  totalPayoutGbp: number;
  totalAllocatedFeeGbp: number;
  netPnlGbp: number;
  totalReturnedFineG: number;
}

export type RefiningBatchSummaryStatus = typeof RefiningBatchSummaryStatus[keyof typeof RefiningBatchSummaryStatus];


export const RefiningBatchSummaryStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  RESULTS_PENDING: 'RESULTS_PENDING',
  FINALISED: 'FINALISED',
  RECEIVED: 'RECEIVED',
} as const;

export interface RefiningBatchSummary {
  id: string;
  reference: string;
  status: RefiningBatchSummaryStatus;
  /** @nullable */
  refinerName?: string | null;
  /** @nullable */
  sentAt?: string | null;
  /** @nullable */
  receivedAt?: string | null;
  feeGbp: number;
  itemCount: number;
  createdAt: string;
  updatedAt?: string;
  /** Dominant metal by payout value (only present for FINALISED/RECEIVED batches with results) */
  topMetal?: string;
  /** Percentage share of total payout attributed to topMetal (0-100) */
  topMetalSharePct?: number;
}

export type RefiningBatchDetailStatus = typeof RefiningBatchDetailStatus[keyof typeof RefiningBatchDetailStatus];


export const RefiningBatchDetailStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  RESULTS_PENDING: 'RESULTS_PENDING',
  FINALISED: 'FINALISED',
  RECEIVED: 'RECEIVED',
} as const;

export interface RefiningBatchDetail {
  id: string;
  reference: string;
  status: RefiningBatchDetailStatus;
  /** @nullable */
  refinerName?: string | null;
  /** @nullable */
  sentAt?: string | null;
  /** @nullable */
  receivedAt?: string | null;
  feeGbp: number;
  /** @nullable */
  notes?: string | null;
  items: ScrapInventoryItemView[];
  results: RefiningResultView[];
  createdAt: string;
  updatedAt?: string;
}

export interface ScrapMetalAgg {
  metal: string;
  lotCount: number;
  grossG: number;
  fineG: number;
  realisedPurchaseCostGbp: number;
  realisedRevenueGbp: number;
  realisedPnlGbp: number;
  openStockLotCount: number;
  openStockFineG: number;
  openStockCostGbp: number;
  openStockSpotValueGbp: number;
  openStockUnrealisedPnlGbp: number;
  spotGbpPerG: number;
}

export interface ScrapStatusAgg {
  status: string;
  lotCount: number;
}

export type ScrapReportSummarySpotPricesGbpPerG = {[key: string]: number};

export interface ScrapReportSummary {
  purchaseCount: number;
  totalPurchaseCostGbp: number;
  refiningFeesGbp: number;
  refiningRevenueGbp: number;
  realisedPurchaseCostGbp: number;
  realisedRefiningFeesGbp: number;
  realisedRefiningRevenueGbp: number;
  realisedPnlGbp: number;
  openStockCostGbp: number;
  openStockFineG: number;
  openStockSpotValueGbp: number;
  openStockUnrealisedPnlGbp: number;
  inRefiningLotCount: number;
  inRefiningFineG: number;
  inRefiningCostGbp: number;
  writtenOffCostGbp: number;
  pendingBatchCount: number;
  pendingBatchLotCount: number;
  pendingBatchCostGbp: number;
  spotPricesGbpPerG: ScrapReportSummarySpotPricesGbpPerG;
  byMetal: ScrapMetalAgg[];
  byStatus: ScrapStatusAgg[];
}

export interface ScrapSettings {
  /** @nullable */
  defaultRefinerName?: string | null;
  /** @nullable */
  defaultLocation?: string | null;
  defaultAssumedPurityPct: ScrapSpotPrices;
  /** @nullable */
  notes?: string | null;
  /**
     * Task #1289 — when true (default), realised scrap P&L is folded into
     * the main Profit & Loss report (totals, cards, chart, table) with a
     * distinct scrap breakdown. Only takes effect when the scrap module is
     * enabled for the tenant.
     */
  combinePnlWithScrap: boolean;
  /** @nullable */
  updatedAt?: string | null;
}

export interface ScrapSettingsInput {
  /** @nullable */
  defaultRefinerName?: string | null;
  /** @nullable */
  defaultLocation?: string | null;
  defaultAssumedPurityPct?: ScrapSpotPrices;
  /** @nullable */
  notes?: string | null;
  combinePnlWithScrap?: boolean;
}

export interface TmAssignableUser {
  userId: string;
  /** @nullable */
  fullName?: string | null;
  email: string;
  /** @nullable */
  imageUrl?: string | null;
  role: string;
}

export interface TmChecklistItem {
  id: string;
  taskId: string;
  title: string;
  done: boolean;
  sortOrder: number;
}

export interface TmChecklistItemInput {
  /** @minLength 1 */
  title: string;
}

export interface TmChecklistItemUpdate {
  /** @minLength 1 */
  title?: string;
  done?: boolean;
  sortOrder?: number;
}

export interface TmComment {
  id: string;
  authorId: string;
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  authorImageUrl?: string | null;
  body: string;
  mentions: string[];
  createdAt: string;
}

export interface TmCommentInput {
  /** @minLength 1 */
  body: string;
  mentions?: string[];
}

export interface TmAttachment {
  id: string;
  taskId: string;
  uploadedBy?: string;
  fileName: string;
  objectPath: string;
  /** @nullable */
  contentType?: string | null;
  /** @nullable */
  sizeBytes?: number | null;
  /** @nullable */
  url?: string | null;
  createdAt: string;
}

export interface TmAttachmentInput {
  /** @minLength 1 */
  fileName: string;
  /** @minLength 1 */
  objectPath: string;
  contentType?: string;
  sizeBytes?: number;
}

export type TmActivityLogDetail = { [key: string]: unknown };

export interface TmActivityLog {
  id: string;
  actorId: string;
  /** @nullable */
  actorName?: string | null;
  action: string;
  detail: TmActivityLogDetail;
  createdAt: string;
}

export type TmTaskDetailPriority = typeof TmTaskDetailPriority[keyof typeof TmTaskDetailPriority];


export const TmTaskDetailPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type TmTaskDetailStatus = typeof TmTaskDetailStatus[keyof typeof TmTaskDetailStatus];


export const TmTaskDetailStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  waiting: 'waiting',
  blocked: 'blocked',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type TmTaskDetailRecurrence = typeof TmTaskDetailRecurrence[keyof typeof TmTaskDetailRecurrence];


export const TmTaskDetailRecurrence = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export interface TmTaskDetail {
  id: string;
  title: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  projectId?: string | null;
  /** @nullable */
  customerId?: string | null;
  /** @nullable */
  projectName?: string | null;
  createdBy: string;
  /** @nullable */
  createdByName?: string | null;
  priority: TmTaskDetailPriority;
  status: TmTaskDetailStatus;
  /** @nullable */
  dueDate?: string | null;
  /** @nullable */
  dueTime?: string | null;
  /** @nullable */
  reminderAt?: string | null;
  recurrence: TmTaskDetailRecurrence;
  /** @nullable */
  recurrenceRule?: string | null;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  completedBy?: string | null;
  sortOrder: number;
  assignees: TmAssignableUser[];
  checklist: TmChecklistItem[];
  commentCount?: number;
  attachmentCount?: number;
  createdAt: string;
  updatedAt: string;
}

export type TmTaskInputPriority = typeof TmTaskInputPriority[keyof typeof TmTaskInputPriority];


export const TmTaskInputPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type TmTaskInputStatus = typeof TmTaskInputStatus[keyof typeof TmTaskInputStatus];


export const TmTaskInputStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  waiting: 'waiting',
  blocked: 'blocked',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type TmTaskInputRecurrence = typeof TmTaskInputRecurrence[keyof typeof TmTaskInputRecurrence];


export const TmTaskInputRecurrence = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export interface TmTaskInput {
  /** @minLength 1 */
  title: string;
  description?: string;
  /** @nullable */
  projectId?: string | null;
  /** @nullable */
  customerId?: string | null;
  priority?: TmTaskInputPriority;
  status?: TmTaskInputStatus;
  /** @nullable */
  dueDate?: string | null;
  /** @nullable */
  dueTime?: string | null;
  /** @nullable */
  reminderAt?: string | null;
  recurrence?: TmTaskInputRecurrence;
  /** @nullable */
  recurrenceRule?: string | null;
  assigneeIds?: string[];
  checklist?: string[];
}

export type TmTaskUpdatePriority = typeof TmTaskUpdatePriority[keyof typeof TmTaskUpdatePriority];


export const TmTaskUpdatePriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type TmTaskUpdateStatus = typeof TmTaskUpdateStatus[keyof typeof TmTaskUpdateStatus];


export const TmTaskUpdateStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  waiting: 'waiting',
  blocked: 'blocked',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type TmTaskUpdateRecurrence = typeof TmTaskUpdateRecurrence[keyof typeof TmTaskUpdateRecurrence];


export const TmTaskUpdateRecurrence = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export interface TmTaskUpdate {
  /** @minLength 1 */
  title?: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  projectId?: string | null;
  /** @nullable */
  customerId?: string | null;
  priority?: TmTaskUpdatePriority;
  status?: TmTaskUpdateStatus;
  /** @nullable */
  dueDate?: string | null;
  /** @nullable */
  dueTime?: string | null;
  /** @nullable */
  reminderAt?: string | null;
  recurrence?: TmTaskUpdateRecurrence;
  /** @nullable */
  recurrenceRule?: string | null;
  sortOrder?: number;
  assigneeIds?: string[];
}

export type TmTaskTemplateDetailPriority = typeof TmTaskTemplateDetailPriority[keyof typeof TmTaskTemplateDetailPriority];


export const TmTaskTemplateDetailPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type TmTaskTemplateDetailRecurrence = typeof TmTaskTemplateDetailRecurrence[keyof typeof TmTaskTemplateDetailRecurrence];


export const TmTaskTemplateDetailRecurrence = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export interface TmTaskTemplateDetail {
  id: string;
  name: string;
  /** @nullable */
  description?: string | null;
  title: string;
  /** @nullable */
  taskDescription?: string | null;
  priority: TmTaskTemplateDetailPriority;
  recurrence: TmTaskTemplateDetailRecurrence;
  /** @nullable */
  recurrenceRule?: string | null;
  /** @nullable */
  dueInDays?: number | null;
  checklist: string[];
  createdBy: string;
  /** @nullable */
  createdByName?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type TmTaskTemplateInputPriority = typeof TmTaskTemplateInputPriority[keyof typeof TmTaskTemplateInputPriority];


export const TmTaskTemplateInputPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type TmTaskTemplateInputRecurrence = typeof TmTaskTemplateInputRecurrence[keyof typeof TmTaskTemplateInputRecurrence];


export const TmTaskTemplateInputRecurrence = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export interface TmTaskTemplateInput {
  /** @minLength 1 */
  name: string;
  /** @nullable */
  description?: string | null;
  /** @minLength 1 */
  title: string;
  /** @nullable */
  taskDescription?: string | null;
  priority?: TmTaskTemplateInputPriority;
  recurrence?: TmTaskTemplateInputRecurrence;
  /** @nullable */
  recurrenceRule?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  dueInDays?: number | null;
  checklist?: string[];
}

export type TmTaskTemplateUpdatePriority = typeof TmTaskTemplateUpdatePriority[keyof typeof TmTaskTemplateUpdatePriority];


export const TmTaskTemplateUpdatePriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type TmTaskTemplateUpdateRecurrence = typeof TmTaskTemplateUpdateRecurrence[keyof typeof TmTaskTemplateUpdateRecurrence];


export const TmTaskTemplateUpdateRecurrence = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export interface TmTaskTemplateUpdate {
  /** @minLength 1 */
  name?: string;
  /** @nullable */
  description?: string | null;
  /** @minLength 1 */
  title?: string;
  /** @nullable */
  taskDescription?: string | null;
  priority?: TmTaskTemplateUpdatePriority;
  recurrence?: TmTaskTemplateUpdateRecurrence;
  /** @nullable */
  recurrenceRule?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  dueInDays?: number | null;
  checklist?: string[];
}

export interface TmSaveAsTemplateInput {
  /** @minLength 1 */
  name: string;
  /** @nullable */
  description?: string | null;
}

/**
 * @nullable
 */
export type TmTemplateInstantiateInputPriority = typeof TmTemplateInstantiateInputPriority[keyof typeof TmTemplateInstantiateInputPriority] | null;


export const TmTemplateInstantiateInputPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface TmTemplateInstantiateInput {
  /** @nullable */
  projectId?: string | null;
  /** @nullable */
  dueDate?: string | null;
  assigneeIds?: string[];
  /** @nullable */
  title?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  priority?: TmTemplateInstantiateInputPriority;
}

export type TmReminderRepeat = typeof TmReminderRepeat[keyof typeof TmReminderRepeat];


export const TmReminderRepeat = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export type TmReminderAlertMethod = typeof TmReminderAlertMethod[keyof typeof TmReminderAlertMethod];


export const TmReminderAlertMethod = {
  in_app: 'in_app',
  email: 'email',
  both: 'both',
} as const;

export type TmReminderStatus = typeof TmReminderStatus[keyof typeof TmReminderStatus];


export const TmReminderStatus = {
  pending: 'pending',
  done: 'done',
  dismissed: 'dismissed',
} as const;

export interface TmReminder {
  id: string;
  title: string;
  /** @nullable */
  note?: string | null;
  createdBy: string;
  userId: string;
  /** @nullable */
  userName?: string | null;
  remindAt: string;
  repeat: TmReminderRepeat;
  /** @nullable */
  repeatRule?: string | null;
  /** @nullable */
  linkedTaskId?: string | null;
  /** @nullable */
  projectId?: string | null;
  alertMethod: TmReminderAlertMethod;
  status: TmReminderStatus;
  /** @nullable */
  snoozedUntil?: string | null;
  /** @nullable */
  lastFiredAt?: string | null;
  /** @nullable */
  doneAt?: string | null;
  createdAt: string;
  /** @nullable */
  updatedAt?: string | null;
}

export type TmReminderInputRepeat = typeof TmReminderInputRepeat[keyof typeof TmReminderInputRepeat];


export const TmReminderInputRepeat = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export type TmReminderInputAlertMethod = typeof TmReminderInputAlertMethod[keyof typeof TmReminderInputAlertMethod];


export const TmReminderInputAlertMethod = {
  in_app: 'in_app',
  email: 'email',
  both: 'both',
} as const;

export interface TmReminderInput {
  /** @minLength 1 */
  title: string;
  note?: string;
  remindAt: string;
  repeat?: TmReminderInputRepeat;
  /** @nullable */
  repeatRule?: string | null;
  /** @nullable */
  linkedTaskId?: string | null;
  /** @nullable */
  projectId?: string | null;
  alertMethod?: TmReminderInputAlertMethod;
  /** Recipients. Empty + projectId set = all project members. Empty + no projectId = self. */
  userIds?: string[];
}

export type TmReminderUpdateRepeat = typeof TmReminderUpdateRepeat[keyof typeof TmReminderUpdateRepeat];


export const TmReminderUpdateRepeat = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  custom: 'custom',
} as const;

export type TmReminderUpdateAlertMethod = typeof TmReminderUpdateAlertMethod[keyof typeof TmReminderUpdateAlertMethod];


export const TmReminderUpdateAlertMethod = {
  in_app: 'in_app',
  email: 'email',
  both: 'both',
} as const;

export type TmReminderUpdateStatus = typeof TmReminderUpdateStatus[keyof typeof TmReminderUpdateStatus];


export const TmReminderUpdateStatus = {
  pending: 'pending',
  done: 'done',
  dismissed: 'dismissed',
} as const;

export interface TmReminderUpdate {
  /** @minLength 1 */
  title?: string;
  /** @nullable */
  note?: string | null;
  remindAt?: string;
  repeat?: TmReminderUpdateRepeat;
  /** @nullable */
  repeatRule?: string | null;
  /** @nullable */
  linkedTaskId?: string | null;
  /** @nullable */
  projectId?: string | null;
  alertMethod?: TmReminderUpdateAlertMethod;
  status?: TmReminderUpdateStatus;
}

export interface TmReminderSnoozeInput {
  /** @minimum 1 */
  snoozeMinutes: number;
}

export interface TmMilestone {
  id: string;
  title: string;
  /** @nullable */
  dueDate?: string | null;
  done: boolean;
}

export interface TmMilestoneInput {
  id?: string;
  /** @minLength 1 */
  title: string;
  /** @nullable */
  dueDate?: string | null;
  done?: boolean;
}

export type TmProjectMemberRole = typeof TmProjectMemberRole[keyof typeof TmProjectMemberRole];


export const TmProjectMemberRole = {
  owner: 'owner',
  member: 'member',
} as const;

export interface TmProjectMember {
  id: string;
  projectId: string;
  userId: string;
  role: TmProjectMemberRole;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  imageUrl?: string | null;
  /** @nullable */
  addedAt?: string | null;
}

export type TmProjectMemberInputRole = typeof TmProjectMemberInputRole[keyof typeof TmProjectMemberInputRole];


export const TmProjectMemberInputRole = {
  owner: 'owner',
  member: 'member',
} as const;

export interface TmProjectMemberInput {
  userId: string;
  role?: TmProjectMemberInputRole;
}

export type TmProjectDetailStatus = typeof TmProjectDetailStatus[keyof typeof TmProjectDetailStatus];


export const TmProjectDetailStatus = {
  planning: 'planning',
  active: 'active',
  on_hold: 'on_hold',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type TmProjectDetailPriority = typeof TmProjectDetailPriority[keyof typeof TmProjectDetailPriority];


export const TmProjectDetailPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface TmProjectDetail {
  id: string;
  name: string;
  /** @nullable */
  description?: string | null;
  ownerId: string;
  /** @nullable */
  ownerName?: string | null;
  status: TmProjectDetailStatus;
  priority: TmProjectDetailPriority;
  /** @nullable */
  dueDate?: string | null;
  milestones: TmMilestone[];
  members: TmProjectMember[];
  /** @nullable */
  completedAt?: string | null;
  taskCount?: number;
  openTaskCount?: number;
  createdAt: string;
  updatedAt: string;
}

export type TmProjectInputStatus = typeof TmProjectInputStatus[keyof typeof TmProjectInputStatus];


export const TmProjectInputStatus = {
  planning: 'planning',
  active: 'active',
  on_hold: 'on_hold',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type TmProjectInputPriority = typeof TmProjectInputPriority[keyof typeof TmProjectInputPriority];


export const TmProjectInputPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface TmProjectInput {
  /** @minLength 1 */
  name: string;
  description?: string;
  status?: TmProjectInputStatus;
  priority?: TmProjectInputPriority;
  /** @nullable */
  dueDate?: string | null;
  milestones?: TmMilestoneInput[];
  memberIds?: string[];
}

export type TmProjectUpdateStatus = typeof TmProjectUpdateStatus[keyof typeof TmProjectUpdateStatus];


export const TmProjectUpdateStatus = {
  planning: 'planning',
  active: 'active',
  on_hold: 'on_hold',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type TmProjectUpdatePriority = typeof TmProjectUpdatePriority[keyof typeof TmProjectUpdatePriority];


export const TmProjectUpdatePriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface TmProjectUpdate {
  /** @minLength 1 */
  name?: string;
  /** @nullable */
  description?: string | null;
  status?: TmProjectUpdateStatus;
  priority?: TmProjectUpdatePriority;
  /** @nullable */
  dueDate?: string | null;
  milestones?: TmMilestoneInput[];
}

export type TmPreferencesDefaultView = typeof TmPreferencesDefaultView[keyof typeof TmPreferencesDefaultView];


export const TmPreferencesDefaultView = {
  my_tasks: 'my_tasks',
  team_tasks: 'team_tasks',
  projects: 'projects',
  reminders: 'reminders',
  calendar: 'calendar',
} as const;

export interface TmPreferences {
  defaultView: TmPreferencesDefaultView;
  defaultReminderLeadMinutes: number;
  notifyInApp: boolean;
  notifyEmail: boolean;
  calendarToken: string;
  calendarFeedUrl: string;
}

export type TmPreferencesUpdateDefaultView = typeof TmPreferencesUpdateDefaultView[keyof typeof TmPreferencesUpdateDefaultView];


export const TmPreferencesUpdateDefaultView = {
  my_tasks: 'my_tasks',
  team_tasks: 'team_tasks',
  projects: 'projects',
  reminders: 'reminders',
  calendar: 'calendar',
} as const;

export interface TmPreferencesUpdate {
  defaultView?: TmPreferencesUpdateDefaultView;
  /** @minimum 0 */
  defaultReminderLeadMinutes?: number;
  notifyInApp?: boolean;
  notifyEmail?: boolean;
}

export type TmCalendarEventType = typeof TmCalendarEventType[keyof typeof TmCalendarEventType];


export const TmCalendarEventType = {
  task_due: 'task_due',
  task_overdue: 'task_overdue',
  reminder: 'reminder',
  project_due: 'project_due',
} as const;

export interface TmCalendarEvent {
  id: string;
  type: TmCalendarEventType;
  title: string;
  date: string;
  allDay: boolean;
  refId?: string;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  priority?: string | null;
}

export type TmDashboardSummaryCounts = {
  myOpenTasks: number;
  myOverdueTasks: number;
  myRemindersToday: number;
  teamTasksDueToday: number;
  projectsInProgress: number;
  tasksWaitingOnMe: number;
  recentlyCompleted: number;
};

export interface TmDashboardSummary {
  counts: TmDashboardSummaryCounts;
  myOpenTasks: TmTaskDetail[];
  myOverdueTasks: TmTaskDetail[];
  myRemindersToday: TmReminder[];
  teamTasksDueToday: TmTaskDetail[];
  projectsInProgress: TmProjectDetail[];
  tasksWaitingOnMe: TmTaskDetail[];
  recentlyCompleted: TmTaskDetail[];
}

/**
 * Canonical MetalUI feature flag key. Keep in sync with
 * `FEATURE_KEYS` in `lib/db/src/schema/tenantFeatures.ts`.
 */
export type FeatureKey = typeof FeatureKey[keyof typeof FeatureKey];


export const FeatureKey = {
  scrap_module_enabled: 'scrap_module_enabled',
  ebay_feedback_enabled: 'ebay_feedback_enabled',
  tasks_module_enabled: 'tasks_module_enabled',
  packing_module_enabled: 'packing_module_enabled',
  packing_courier_handoff_enabled: 'packing_courier_handoff_enabled',
  notification_centre_enabled: 'notification_centre_enabled',
  hr_module_enabled: 'hr_module_enabled',
  quickbooks_integration_enabled: 'quickbooks_integration_enabled',
  xero_integration_enabled: 'xero_integration_enabled',
  returns_module_enabled: 'returns_module_enabled',
  tiktok_shop_integration_enabled: 'tiktok_shop_integration_enabled',
  advanced_analytics_enabled: 'advanced_analytics_enabled',
  customer_lifetime_value_enabled: 'customer_lifetime_value_enabled',
  customer_merge_enabled: 'customer_merge_enabled',
  forecasting_demand_planning_enabled: 'forecasting_demand_planning_enabled',
  intelligence_centre_enabled: 'intelligence_centre_enabled',
  purchasing_automation_enabled: 'purchasing_automation_enabled',
  document_generation_enabled: 'document_generation_enabled',
  asset_tracking_enabled: 'asset_tracking_enabled',
  compliance_vault_enabled: 'compliance_vault_enabled',
  postage_module_enabled: 'postage_module_enabled',
  social_module_enabled: 'social_module_enabled',
  ai_assistant_enabled: 'ai_assistant_enabled',
  customer_360_enabled: 'customer_360_enabled',
  wms_enabled: 'wms_enabled',
  evidence_centre_enabled: 'evidence_centre_enabled',
  mobile_operations_enabled: 'mobile_operations_enabled',
  automation_builder_enabled: 'automation_builder_enabled',
  dynamic_pricing_enabled: 'dynamic_pricing_enabled',
  platform_perks_enabled: 'platform_perks_enabled',
  affiliate_payouts: 'affiliate_payouts',
  consignment_profit_splits: 'consignment_profit_splits',
  ai_product_copy_enabled: 'ai_product_copy_enabled',
  advanced_inventory_valuation_enabled: 'advanced_inventory_valuation_enabled',
  image_studio: 'image_studio',
  image_studio_ai: 'image_studio_ai',
  unified_badge_poll_disabled: 'unified_badge_poll_disabled',
  pre_orders_enabled: 'pre_orders_enabled',
  exception_management_enabled: 'exception_management_enabled',
  ai_agents_enabled: 'ai_agents_enabled',
  customer_portal_enabled: 'customer_portal_enabled',
  inventory_cost_layers_v2: 'inventory_cost_layers_v2',
  customer_commerce_portal: 'customer_commerce_portal',
  customer_portfolios_enabled: 'customer_portfolios_enabled',
  market_tools_enabled: 'market_tools_enabled',
  operations_workspace: 'operations_workspace',
  customer_journey_analytics: 'customer_journey_analytics',
  operations_next_action: 'operations_next_action',
  operations_universal_search: 'operations_universal_search',
  operations_checklists: 'operations_checklists',
  operations_feed: 'operations_feed',
  operations_status_board: 'operations_status_board',
  operations_autofill: 'operations_autofill',
  operations_friction_analytics: 'operations_friction_analytics',
  customer_behaviour_events: 'customer_behaviour_events',
  customer_order_timing: 'customer_order_timing',
  customer_dynamic_segments: 'customer_dynamic_segments',
  customer_reorder_intelligence: 'customer_reorder_intelligence',
  product_performance_enabled: 'product_performance_enabled',
  demand_intelligence_enabled: 'demand_intelligence_enabled',
} as const;

export type CustomerPortfolioMetal = typeof CustomerPortfolioMetal[keyof typeof CustomerPortfolioMetal];


export const CustomerPortfolioMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  copper: 'copper',
} as const;

export type PortfolioProductScope = typeof PortfolioProductScope[keyof typeof PortfolioProductScope];


export const PortfolioProductScope = {
  global: 'global',
  tenant: 'tenant',
} as const;

export type CustomerPortfolioUnit = typeof CustomerPortfolioUnit[keyof typeof CustomerPortfolioUnit];


export const CustomerPortfolioUnit = {
  troy_ounce: 'troy_ounce',
  gram: 'gram',
  kilogram: 'kilogram',
  piece: 'piece',
} as const;

export interface PortfolioProduct {
  id: string;
  scope: PortfolioProductScope;
  name: string;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  mint?: string | null;
  /** @nullable */
  year?: number | null;
  /** @nullable */
  variant?: string | null;
  productType: string;
  metal: CustomerPortfolioMetal;
  grossWeight: string;
  weightUnit: CustomerPortfolioUnit;
  purity: string;
  fineWeightGrams: string;
  /** @nullable */
  imageUrl?: string | null;
  isActive: boolean;
  /** @nullable */
  inventoryItemId?: string | null;
  /** @nullable */
  inventorySku?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PortfolioProductInput {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  mint?: string | null;
  /**
     * @minimum 1
     * @maximum 9999
     * @nullable
     */
  year?: number | null;
  /** @nullable */
  variant?: string | null;
  productType?: string;
  metal: CustomerPortfolioMetal;
  /** @pattern ^(?:0|[1-9]\d{0,10})(?:\.\d{1,9})?$ */
  grossWeight: string;
  weightUnit: CustomerPortfolioUnit;
  purity: string;
  /** @pattern ^(?:0|[1-9]\d{0,10})(?:\.\d{1,9})?$ */
  fineWeightGrams: string;
  /** @nullable */
  imageUrl?: string | null;
  isActive?: boolean;
}

export interface PortfolioProductUpdateInput {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name?: string;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  mint?: string | null;
  /**
     * @minimum 1
     * @maximum 9999
     * @nullable
     */
  year?: number | null;
  /** @nullable */
  variant?: string | null;
  productType?: string;
  metal?: CustomerPortfolioMetal;
  /** @pattern ^(?:0|[1-9]\d{0,10})(?:\.\d{1,9})?$ */
  grossWeight?: string;
  weightUnit?: CustomerPortfolioUnit;
  purity?: string;
  /** @pattern ^(?:0|[1-9]\d{0,10})(?:\.\d{1,9})?$ */
  fineWeightGrams?: string;
  /** @nullable */
  imageUrl?: string | null;
  isActive?: boolean;
}

export interface PortfolioProductMappingInput {
  inventoryItemId?: string;
  inventorySku?: string;
}

export type CustomerPortfolioCurrency = typeof CustomerPortfolioCurrency[keyof typeof CustomerPortfolioCurrency];


export const CustomerPortfolioCurrency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type CustomerPortfolioTransactionType = typeof CustomerPortfolioTransactionType[keyof typeof CustomerPortfolioTransactionType];


export const CustomerPortfolioTransactionType = {
  purchase: 'purchase',
  sale: 'sale',
  transfer_in: 'transfer_in',
  transfer_out: 'transfer_out',
  adjustment: 'adjustment',
  reversal: 'reversal',
  fee: 'fee',
  storage_fee: 'storage_fee',
  disposal: 'disposal',
} as const;

export type CustomerPortfolioAllocationStrategy = typeof CustomerPortfolioAllocationStrategy[keyof typeof CustomerPortfolioAllocationStrategy];


export const CustomerPortfolioAllocationStrategy = {
  FIFO: 'FIFO',
  LIFO: 'LIFO',
  WEIGHTED_AVERAGE: 'WEIGHTED_AVERAGE',
  SPECIFIC_LOT: 'SPECIFIC_LOT',
} as const;

export type CustomerPortfolioStatus = typeof CustomerPortfolioStatus[keyof typeof CustomerPortfolioStatus];


export const CustomerPortfolioStatus = {
  active: 'active',
  archived: 'archived',
} as const;

export interface CustomerPortfolio {
  id: string;
  tenantId: string;
  customerId: string;
  name: string;
  status: CustomerPortfolioStatus;
  baseCurrency: CustomerPortfolioCurrency;
  /** @nullable */
  notes?: string | null;
}

export interface CustomerPortfolioCreateInput {
  customerId: string;
  /** @maxLength 160 */
  name?: string;
  baseCurrency?: CustomerPortfolioCurrency;
  notes?: string;
}

export type CustomerPortfolioProductType = typeof CustomerPortfolioProductType[keyof typeof CustomerPortfolioProductType];


export const CustomerPortfolioProductType = {
  coin: 'coin',
  bar: 'bar',
  round: 'round',
  scrap: 'scrap',
  jewellery: 'jewellery',
  other: 'other',
} as const;

export interface CustomerPortfolioPurchaseInput {
  metal: CustomerPortfolioMetal;
  unit: CustomerPortfolioUnit;
  /** @pattern ^\d+(\.\d{1,6})?$ */
  quantity: string;
  /** @pattern ^0?\.\d{1,6}$|^1(\.0{1,6})?$ */
  purity?: string;
  /** @pattern ^\d+(\.\d{1,6})?$ */
  unitPrice?: string;
  /** @pattern ^\d+(\.\d{1,4})?$ */
  grossAmount?: string;
  /** @pattern ^\d+(\.\d{1,4})?$ */
  feeAmount?: string;
  /**
     * Operator-only manual canonical spot override; the calculated historical quote is preserved.
     * @pattern ^\d+(\.\d{1,8})?$
     */
  manualSpotPrice?: string;
  currency?: CustomerPortfolioCurrency;
  occurredAt?: string;
  /** Active visible catalogue product whose authoritative specifications will be snapshotted onto the purchase. */
  catalogueProductId?: string;
  productType?: CustomerPortfolioProductType;
  /** @maxLength 200 */
  productName?: string;
  /** @maxLength 160 */
  dealer?: string;
  /** @pattern ^\d+(\.\d{1,9})?$ */
  fineWeightGramsPerUnit?: string;
}

export interface CustomerPortfolioSaleInput {
  holdingId: string;
  /** @pattern ^\d+(\.\d{1,6})?$ */
  quantity: string;
  /** @pattern ^\d+(\.\d{1,6})?$ */
  unitPrice?: string;
  /** @pattern ^\d+(\.\d{1,4})?$ */
  grossAmount?: string;
  /** @pattern ^\d+(\.\d{1,4})?$ */
  feeAmount?: string;
  allocationStrategy?: CustomerPortfolioAllocationStrategy;
  requestedLotIds?: string[];
}

export interface CustomerPortfolioTransferInput {
  targetPortfolioId: string;
  holdingId: string;
  /** @pattern ^\d+(\.\d{1,6})?$ */
  quantity: string;
  allocationStrategy?: CustomerPortfolioAllocationStrategy;
  requestedLotIds?: string[];
}

export type CustomerPortfolioPurchasePreviewQuoteFreshness = typeof CustomerPortfolioPurchasePreviewQuoteFreshness[keyof typeof CustomerPortfolioPurchasePreviewQuoteFreshness];


export const CustomerPortfolioPurchasePreviewQuoteFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export type CustomerPortfolioPurchasePreviewQuote = {
  /** @nullable */
  value?: string | null;
  unit?: string;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  sourceTimestamp?: string | null;
  /** @nullable */
  retrievedAt?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  distanceMs?: number | null;
  freshness: CustomerPortfolioPurchasePreviewQuoteFreshness;
};

export interface CustomerPortfolioPurchasePreview {
  fineWeightGrams: string;
  totalPaid: string;
  /** @nullable */
  spotValue?: string | null;
  /** @nullable */
  premiumPaid?: string | null;
  /** @nullable */
  premiumPercentage?: string | null;
  costPerGram: string;
  costPerTroyOunce: string;
  quote: CustomerPortfolioPurchasePreviewQuote;
}

export type CustomerPortfolioTransactionBulkInputAction = typeof CustomerPortfolioTransactionBulkInputAction[keyof typeof CustomerPortfolioTransactionBulkInputAction];


export const CustomerPortfolioTransactionBulkInputAction = {
  move: 'move',
  dealer: 'dealer',
  archive: 'archive',
  delete: 'delete',
} as const;

export interface CustomerPortfolioTransactionBulkInput {
  /**
     * @minItems 1
     * @maxItems 100
     */
  transactionIds: string[];
  action: CustomerPortfolioTransactionBulkInputAction;
  targetPortfolioId?: string;
  /** @maxLength 160 */
  dealer?: string;
}

/**
 * @nullable
 */
export type CustomerPortfolioTransactionSpotPriceUnit = typeof CustomerPortfolioTransactionSpotPriceUnit[keyof typeof CustomerPortfolioTransactionSpotPriceUnit] | null;


export const CustomerPortfolioTransactionSpotPriceUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

/**
 * @nullable
 */
export type CustomerPortfolioTransactionSpotPriceFreshness = typeof CustomerPortfolioTransactionSpotPriceFreshness[keyof typeof CustomerPortfolioTransactionSpotPriceFreshness] | null;


export const CustomerPortfolioTransactionSpotPriceFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export interface CustomerPortfolioTransaction {
  id: string;
  portfolioId: string;
  /** @nullable */
  holdingId?: string | null;
  transactionType: string;
  status: string;
  /** @nullable */
  metal?: string | null;
  productType?: CustomerPortfolioProductType | null;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  dealer?: string | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  quantity?: string | null;
  /** @nullable */
  unitPrice?: string | null;
  /** @nullable */
  grossAmount?: string | null;
  feeAmount?: string;
  /** @nullable */
  netAmount?: string | null;
  /** @nullable */
  realizedPnl?: string | null;
  /** @nullable */
  calculatedSpotPrice?: string | null;
  /** @nullable */
  manualSpotPrice?: string | null;
  /** @nullable */
  spotPriceUnit?: CustomerPortfolioTransactionSpotPriceUnit;
  /** @nullable */
  spotPriceSource?: string | null;
  /** @nullable */
  spotPriceTimestamp?: string | null;
  /**
     * @minimum 0
     * @nullable
     */
  spotPriceDistanceMs?: number | null;
  /** @nullable */
  spotPriceFreshness?: CustomerPortfolioTransactionSpotPriceFreshness;
  spotPriceOverridden?: boolean;
  /** @nullable */
  spotOverrideAt?: string | null;
  /** @nullable */
  premiumAmount?: string | null;
  /** @nullable */
  premiumPercentage?: string | null;
  /** @nullable */
  relatedTransactionId?: string | null;
  /** @nullable */
  reversalOfTransactionId?: string | null;
  /** @nullable */
  archivedAt?: string | null;
  currency: string;
  occurredAt: string;
  createdAt?: string;
}

export interface CustomerPortfolioTransactionPage {
  transactions: CustomerPortfolioTransaction[];
  /** @minimum 0 */
  total: number;
  /** @minimum 1 */
  page: number;
  /** @minimum 0 */
  pageSize: number;
}

export type CustomerPortfolioAllocationPreviewAllocationsItem = {
  lotId: string;
  quantity: string;
  allocatedCost: string;
};

export interface CustomerPortfolioAllocationPreview {
  holdingId: string;
  quantity: string;
  allocationStrategy: CustomerPortfolioAllocationStrategy;
  allocations: CustomerPortfolioAllocationPreviewAllocationsItem[];
  costBasis: string;
  /** @nullable */
  proceeds?: string | null;
  /** @nullable */
  realizedPnl?: string | null;
  metal: string;
  unit: string;
}

export type CustomerPortfolioTransactionBulkResultAction = typeof CustomerPortfolioTransactionBulkResultAction[keyof typeof CustomerPortfolioTransactionBulkResultAction];


export const CustomerPortfolioTransactionBulkResultAction = {
  move: 'move',
  dealer: 'dealer',
  archive: 'archive',
  delete: 'delete',
} as const;

export type CustomerPortfolioTransactionBulkResultResultsItem = {
  id: string;
  ok: boolean;
  reason?: string;
};

export interface CustomerPortfolioTransactionBulkResult {
  action: CustomerPortfolioTransactionBulkResultAction;
  /** @minimum 0 */
  affected: number;
  results: CustomerPortfolioTransactionBulkResultResultsItem[];
}

export interface CustomerPortfolioAdjustmentInput {
  holdingId?: string;
  metal: CustomerPortfolioMetal;
  unit: CustomerPortfolioUnit;
  /** @pattern ^-?\d+(\.\d{1,6})?$ */
  quantityDelta: string;
  purity?: string;
  costPerUnit?: string;
  /** @minLength 1 */
  reason: string;
  allocationStrategy?: CustomerPortfolioAllocationStrategy;
  requestedLotIds?: string[];
}

/**
 * @nullable
 */
export type CustomerPortfolioSummaryHoldingsItemPurchaseTimeSpotPriceUnit = typeof CustomerPortfolioSummaryHoldingsItemPurchaseTimeSpotPriceUnit[keyof typeof CustomerPortfolioSummaryHoldingsItemPurchaseTimeSpotPriceUnit] | null;


export const CustomerPortfolioSummaryHoldingsItemPurchaseTimeSpotPriceUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

export type CustomerPortfolioSummaryHoldingsItemBreakEvenSpotPriceUnit = typeof CustomerPortfolioSummaryHoldingsItemBreakEvenSpotPriceUnit[keyof typeof CustomerPortfolioSummaryHoldingsItemBreakEvenSpotPriceUnit];


export const CustomerPortfolioSummaryHoldingsItemBreakEvenSpotPriceUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

export type CustomerPortfolioSummaryHoldingsItem = {
  /** @nullable */
  acquisitionCost?: string | null;
  /** @nullable */
  grossWeightGrams?: string | null;
  fineWeightGrams?: string;
  fineWeightTroyOunces?: string;
  /** @nullable */
  purchaseTimeSpotValue?: string | null;
  /** @nullable */
  purchaseTimeSpotPrice?: string | null;
  /** @nullable */
  purchaseTimeSpotPriceUnit?: CustomerPortfolioSummaryHoldingsItemPurchaseTimeSpotPriceUnit;
  /** @nullable */
  currentSpotValue?: string | null;
  /** @nullable */
  premiumPaid?: string | null;
  /** @nullable */
  premiumPercentage?: string | null;
  /** @nullable */
  gainLoss?: string | null;
  /** @nullable */
  gainLossPercentage?: string | null;
  /** @nullable */
  breakEvenSpotPrice?: string | null;
  breakEvenSpotPriceUnit?: CustomerPortfolioSummaryHoldingsItemBreakEvenSpotPriceUnit;
  /** @nullable */
  allocationPercentage?: string | null;
  [key: string]: unknown;
 };

export type CustomerPortfolioSummaryReturnAttribution = { [key: string]: unknown };

export type CustomerPortfolioSummaryMetalTotals = {[key: string]: { [key: string]: unknown }};

export type CustomerPortfolioSummaryValuationFreshness = { [key: string]: unknown };

export interface CustomerPortfolioSummary {
  portfolio: CustomerPortfolio;
  holdings: CustomerPortfolioSummaryHoldingsItem[];
  totalCostBasis: string;
  totalInvested: string;
  /** @nullable */
  totalMarketValue?: string | null;
  /** @nullable */
  totalCurrentSpotValue?: string | null;
  realizedPnl: string;
  /** @nullable */
  unrealizedPnl?: string | null;
  /** @nullable */
  totalPnl?: string | null;
  /** @nullable */
  performancePercentage?: string | null;
  totalFineWeightGrams: string;
  totalFineWeightTroyOunces: string;
  /** @nullable */
  spotMovementValue?: string | null;
  /** @nullable */
  spotMovementPercentage?: string | null;
  returnAttribution?: CustomerPortfolioSummaryReturnAttribution;
  metalTotals: CustomerPortfolioSummaryMetalTotals;
  currency: CustomerPortfolioCurrency;
  valuationFreshness: CustomerPortfolioSummaryValuationFreshness;
}

export type CustomerPortfolioValuationState = typeof CustomerPortfolioValuationState[keyof typeof CustomerPortfolioValuationState];


export const CustomerPortfolioValuationState = {
  pending: 'pending',
  valued: 'valued',
  stale: 'stale',
  unavailable: 'unavailable',
  error: 'error',
} as const;

export interface CustomerPortfolioFoundation {
  metals: CustomerPortfolioMetal[];
  units: CustomerPortfolioUnit[];
  currencies: CustomerPortfolioCurrency[];
  transactionTypes: CustomerPortfolioTransactionType[];
  allocationStrategies: CustomerPortfolioAllocationStrategy[];
  valuationStates: CustomerPortfolioValuationState[];
}

export interface CustomerPortfolioSettingsInput {
  defaultCurrency: CustomerPortfolioCurrency;
  defaultUnit: CustomerPortfolioUnit;
  /**
     * @minimum 1
     * @maximum 43200
     */
  valuationStalenessMinutes: number;
  /** @minItems 1 */
  allowedMetals?: CustomerPortfolioMetal[];
  /** @minItems 1 */
  supportedUnits?: CustomerPortfolioUnit[];
  defaultAllocationStrategy?: CustomerPortfolioAllocationStrategy;
  /** @maxLength 240 */
  stalePriceMessage?: string;
  /**
     * @minLength 80
     * @maxLength 1200
     */
  disclaimer?: string;
}

export type CustomerPortfolioSettingsMetadata = { [key: string]: unknown };

export type CustomerPortfolioSettings = CustomerPortfolioSettingsInput & ({
  tenantId: string;
  enabled: boolean;
  defaultAllocationStrategy?: CustomerPortfolioAllocationStrategy;
  metadata: CustomerPortfolioSettingsMetadata;
  /** @nullable */
  updatedByUserId?: string | null;
  createdAt?: string;
  updatedAt?: string;
});

export interface CustomerPortfolioPortalConfig {
  /**
     * @minLength 80
     * @maxLength 1200
     */
  disclaimer: string;
}

export interface StatusSummaryResponse {
  /** ISO-8601 timestamp of when this response was assembled (for debugging). */
  generatedAt: string;
  /** Unread alert count for the current user. Always present. */
  unreadAlerts: number;
  /** Unread eBay/TikTok messages. Omitted when integrations are not visible. */
  unreadMessages?: number;
  /** Pending social-post approvals for the tenant. Omitted when social module is disabled or user lacks the approval permission. */
  pendingSocialApprovals?: number;
  /** Unread social inbox count. Omitted when social module is disabled or user lacks the inbox permission. */
  unreadSocialInbox?: number;
  /** Active packing jobs (pending + in_progress). Omitted when packing module is disabled or user lacks view_packing. */
  pendingPacking?: number;
  /** Open returns count. Omitted when returns module is disabled or user lacks returns.view. */
  openReturns?: number;
  /** Overdue tasks for the current user. Omitted when tasks module is disabled or user lacks tasks.view. */
  overdueTasks?: number;
}

export type PlatformTenantStatus = typeof PlatformTenantStatus[keyof typeof PlatformTenantStatus];


export const PlatformTenantStatus = {
  active: 'active',
  suspended: 'suspended',
} as const;

export interface PlatformTenant {
  id: string;
  slug: string;
  name: string;
  status: PlatformTenantStatus;
  isPlatform: boolean;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}

export type PlatformTenantFeatureMetadata = { [key: string]: unknown };

export interface PlatformTenantFeature {
  tenantId: string;
  featureKey: FeatureKey;
  /** Friendly human-readable name for the feature. Falls back to the raw key when unmapped. */
  label: string;
  /** Short explanation of what the feature add-on provides. */
  description: string;
  /** When true, this feature may only be toggled by an operator who is a member of the canonical platform OWNER tenant. The FE disables the switch for non-owner operators; the server enforces it on write. */
  platformOwnerOnly: boolean;
  enabled: boolean;
  enabledBy?: string | null;
  enabledAt?: string | null;
  expiresAt?: string | null;
  planName?: string | null;
  usageLimit?: number | null;
  metadata: PlatformTenantFeatureMetadata;
  createdAt?: string;
  updatedAt?: string;
}

export type PlatformTenantFeatureUpdateMetadata = { [key: string]: unknown } | null;

export interface PlatformTenantFeatureUpdate {
  enabled: boolean;
  expiresAt?: string | null;
  /** @maxLength 64 */
  planName?: string | null;
  /** @minimum 0 */
  usageLimit?: number | null;
  metadata?: PlatformTenantFeatureUpdateMetadata;
}

export type PublicPageStatus = typeof PublicPageStatus[keyof typeof PublicPageStatus];


export const PublicPageStatus = {
  draft: 'draft',
  published: 'published',
} as const;

export type PublicPageBlockType = typeof PublicPageBlockType[keyof typeof PublicPageBlockType];


export const PublicPageBlockType = {
  hero: 'hero',
  text: 'text',
  image: 'image',
  video: 'video',
  feature_cards: 'feature_cards',
  pricing_cards: 'pricing_cards',
  testimonial: 'testimonial',
  logo_strip: 'logo_strip',
  service_cards: 'service_cards',
  faq: 'faq',
  contact_form: 'contact_form',
  trial_request_form: 'trial_request_form',
  cta: 'cta',
  comparison_table: 'comparison_table',
  integration_cards: 'integration_cards',
  screenshot_gallery: 'screenshot_gallery',
  stats: 'stats',
  image_text_split: 'image_text_split',
  accordion: 'accordion',
  carousel: 'carousel',
  footer: 'footer',
  button: 'button',
  custom_html: 'custom_html',
  reusable_section: 'reusable_section',
  feature_grid: 'feature_grid',
  feature_spotlight: 'feature_spotlight',
  timeline: 'timeline',
  industry_cards: 'industry_cards',
  security_statement: 'security_statement',
  release_notes: 'release_notes',
} as const;

export type PublicPageAiSuggestRequestTarget = typeof PublicPageAiSuggestRequestTarget[keyof typeof PublicPageAiSuggestRequestTarget];


export const PublicPageAiSuggestRequestTarget = {
  seo: 'seo',
  block: 'block',
} as const;

export interface PublicPageAiSuggestRequest {
  target: PublicPageAiSuggestRequestTarget;
  /**
     * Required when target=block — the 0-based block position to improve.
     * @minimum 0
     */
  blockIndex?: number;
}

export type PublicPageAiSuggestResponseTarget = typeof PublicPageAiSuggestResponseTarget[keyof typeof PublicPageAiSuggestResponseTarget];


export const PublicPageAiSuggestResponseTarget = {
  seo: 'seo',
  block: 'block',
} as const;

/**
 * Present when target=seo.
 */
export type PublicPageAiSuggestResponseSeo = {
  metaTitle: string;
  metaDescription: string;
  seoKeywords: string;
};

/**
 * Present when target=block — improved values keyed by block field name.
 */
export type PublicPageAiSuggestResponseFields = {[key: string]: string};

export interface PublicPageAiSuggestResponse {
  target: PublicPageAiSuggestResponseTarget;
  /** Short human-readable explanation of the suggestion. */
  summary: string;
  /** Present when target=seo. */
  seo?: PublicPageAiSuggestResponseSeo;
  /** Present when target=block — improved values keyed by block field name. */
  fields?: PublicPageAiSuggestResponseFields;
}

export type PublicPageBlockData = { [key: string]: unknown };

export interface PublicPageBlock {
  id: string;
  blockType: PublicPageBlockType;
  position: number;
  hidden?: boolean;
  data: PublicPageBlockData;
}

export type PublicPageBlockInputData = { [key: string]: unknown };

export interface PublicPageBlockInput {
  blockType: PublicPageBlockType;
  hidden?: boolean;
  data: PublicPageBlockInputData;
}

export interface PublicPageSummary {
  id: string;
  slug: string;
  title: string;
  status: PublicPageStatus;
  metaTitle?: string | null;
  metaDescription?: string | null;
  seoKeywords?: string | null;
  ogImage?: string | null;
  canonicalUrl?: string | null;
  blockCount?: number;
  hasRawHtmlOverride?: boolean;
  publishedAt?: string | null;
  updatedBy?: string | null;
  updatedAt: string;
}

export interface PublicPage {
  id: string;
  slug: string;
  title: string;
  status: PublicPageStatus;
  metaTitle?: string | null;
  metaDescription?: string | null;
  seoKeywords?: string | null;
  ogImage?: string | null;
  canonicalUrl?: string | null;
  rawHtmlOverride?: string | null;
  headCode?: string | null;
  blocks: PublicPageBlock[];
  publishedAt?: string | null;
  publishedBy?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SeoPageStatus {
  id: string;
  slug: string;
  title: string;
  canonicalUrl: string | null;
  publishedAt: string | null;
  lastSeoNotifiedAt?: string | null;
  lastSeoNotifiedStatus?: string | null;
  lastSeoNotifiedError?: string | null;
  lastSeoNotifiedByEmail?: string | null;
}

export interface SeoOverview {
  sitemapUrl: string;
  googleConnected: boolean;
  lastSitemapSubmittedAt?: string | null;
  lastSitemapSubmittedStatus?: string | null;
  lastSitemapSubmittedError?: string | null;
  lastSitemapSubmittedByEmail?: string | null;
  pages: SeoPageStatus[];
}

export type SeoUrlInspectionIndexingState = typeof SeoUrlInspectionIndexingState[keyof typeof SeoUrlInspectionIndexingState] | null;


export const SeoUrlInspectionIndexingState = {
  INDEXED: 'INDEXED',
  NOT_INDEXED: 'NOT_INDEXED',
} as const;

export interface SeoUrlInspection {
  canonicalUrl: string;
  verdict: string | null;
  coverageState: string | null;
  indexingState: SeoUrlInspectionIndexingState;
  lastCrawlTime: string | null;
  pageFetchState: string | null;
  robotsTxtState: string | null;
  sitemap: string[];
}

export interface SeoSearchAnalyticsRow {
  query: string;
  clicks: number;
  impressions: number;
  ctr: number;
  position: number;
}

export interface SeoSearchAnalytics {
  startDate: string;
  endDate: string;
  rows: SeoSearchAnalyticsRow[];
}

export interface SeoSearchTrendPoint {
  capturedAt: string;
  startDate: string;
  endDate: string;
  totalClicks: number;
  totalImpressions: number;
  avgCtr: number;
  avgPosition: number;
}

export interface SeoSearchTrend {
  days?: number;
  points: SeoSearchTrendPoint[];
}

export interface SeoIndexingTrendPoint {
  capturedAt: string;
  indexedCount: number;
  notIndexedCount: number;
  totalCount: number;
}

export interface SeoIndexingTrend {
  days?: number;
  points: SeoIndexingTrendPoint[];
}

export interface PublicPageCreate {
  /**
     * @minLength 1
     * @maxLength 128
     */
  slug: string;
  /**
     * @minLength 1
     * @maxLength 256
     */
  title: string;
  /** @maxLength 256 */
  metaTitle?: string | null;
  metaDescription?: string | null;
  seoKeywords?: string | null;
  ogImage?: string | null;
  canonicalUrl?: string | null;
}

export interface PublicPageUpdate {
  /**
     * @minLength 1
     * @maxLength 128
     */
  slug?: string;
  /**
     * @minLength 1
     * @maxLength 256
     */
  title?: string;
  /** @maxLength 256 */
  metaTitle?: string | null;
  metaDescription?: string | null;
  seoKeywords?: string | null;
  ogImage?: string | null;
  canonicalUrl?: string | null;
  rawHtmlOverride?: string | null;
  headCode?: string | null;
  blocks?: PublicPageBlockInput[];
}

export interface PublicPageVersionSummary {
  id: string;
  versionNumber: number;
  status: PublicPageStatus;
  label?: string | null;
  createdBy?: string | null;
  createdAt: string;
}

export type PublicPageVersionDetailSnapshotPage = { [key: string]: unknown };

export type PublicPageVersionDetailSnapshotBlocksItemData = { [key: string]: unknown };

export type PublicPageVersionDetailSnapshotBlocksItem = {
  blockType: string;
  position: number;
  hidden: boolean;
  data: PublicPageVersionDetailSnapshotBlocksItemData;
};

export type PublicPageVersionDetailSnapshot = {
  page: PublicPageVersionDetailSnapshotPage;
  blocks: PublicPageVersionDetailSnapshotBlocksItem[];
};

export interface PublicPageVersionDetail {
  id: string;
  versionNumber: number;
  status: PublicPageStatus;
  label?: string | null;
  createdBy?: string | null;
  createdAt: string;
  snapshot: PublicPageVersionDetailSnapshot;
}

export type SiteSettingKey = typeof SiteSettingKey[keyof typeof SiteSettingKey];


export const SiteSettingKey = {
  theme: 'theme',
  nav: 'nav',
  footer: 'footer',
  logos: 'logos',
  forms: 'forms',
  head: 'head',
} as const;

export type SiteSettingDraftData = { [key: string]: unknown };

export type SiteSettingPublishedData = { [key: string]: unknown };

export interface SiteSetting {
  key: SiteSettingKey;
  draftData: SiteSettingDraftData;
  publishedData: SiteSettingPublishedData;
  publishedAt?: string | null;
  publishedBy?: string | null;
  updatedBy?: string | null;
  updatedAt: string;
}

export type SiteSettingUpdateData = { [key: string]: unknown };

export interface SiteSettingUpdate {
  key: SiteSettingKey;
  data: SiteSettingUpdateData;
}

export interface SiteSettingPublish {
  key?: SiteSettingKey;
}

export interface SiteSettingVersionSummary {
  id: string;
  key: SiteSettingKey;
  versionNumber: number;
  label?: string | null;
  createdBy?: string | null;
  createdAt: string;
}

export interface CombinePurchaseOrdersInput {
  /** @minItems 2 */
  poIds: string[];
}

export interface CombinedPurchaseOrderResult {
  id: string;
  poNumber: string;
  mergedFrom: string[];
}

export interface InventoryCounters {
  quantity?: number;
  quantitySold?: number;
  quantityReserved?: number;
  quantityDamaged?: number;
  available?: number;
}

export type AlertSeverity = typeof AlertSeverity[keyof typeof AlertSeverity];


export const AlertSeverity = {
  info: 'info',
  warning: 'warning',
  error: 'error',
} as const;

export type AlertPriority = typeof AlertPriority[keyof typeof AlertPriority];


export const AlertPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface Alert {
  id: string;
  alertType: string;
  severity: AlertSeverity;
  category: string;
  priority: AlertPriority;
  sourceModule?: string | null;
  sourceEntityType?: string | null;
  sourceEntityId?: string | null;
  title: string;
  body?: string | null;
  link?: string | null;
  payload?: unknown | null;
  metadata?: unknown | null;
  createdAt: string;
  readAt?: string | null;
  read: boolean;
  dismissedAt?: string | null;
  dismissed: boolean;
}

export interface AlertListResponse {
  items: Alert[];
  unreadCount: number;
  total?: number;
}

export type AlertPreferencePriority = typeof AlertPreferencePriority[keyof typeof AlertPreferencePriority];


export const AlertPreferencePriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type AlertPreferenceChannelsItem = typeof AlertPreferenceChannelsItem[keyof typeof AlertPreferenceChannelsItem];


export const AlertPreferenceChannelsItem = {
  in_app: 'in_app',
  email: 'email',
  push: 'push',
  digest: 'digest',
} as const;

export type AlertPreferenceDefaultConfig = { [key: string]: unknown } | null;

export type AlertPreferenceConfig = { [key: string]: unknown };

export interface AlertPreference {
  alertType: string;
  label: string;
  description: string;
  inAppEnabled: boolean;
  emailEnabled: boolean;
  adminOnly: boolean;
  pushEnabled?: boolean;
  digestEnabled?: boolean;
  mutedUntil?: string | null;
  category?: string;
  priority?: AlertPreferencePriority;
  module?: string;
  channels?: AlertPreferenceChannelsItem[];
  locked?: boolean;
  defaultConfig?: AlertPreferenceDefaultConfig;
  config: AlertPreferenceConfig;
}

export interface PushOkResponse {
  ok: boolean;
}

export type PushSubscribeBodyKeys = {
  p256dh: string;
  auth: string;
};

export interface PushSubscribeBody {
  endpoint: string;
  keys: PushSubscribeBodyKeys;
  userAgent?: string | null;
}

export interface PushUnsubscribeBody {
  endpoint: string;
}

export interface PushSubscriptionRow {
  id: string;
  endpoint: string;
  userAgent?: string | null;
  createdAt: string;
  lastUsedAt?: string | null;
}

export type AlertPreferenceUpdateConfig = { [key: string]: unknown } | null;

export interface AlertPreferenceUpdate {
  alertType: string;
  inAppEnabled?: boolean;
  emailEnabled?: boolean;
  pushEnabled?: boolean;
  digestEnabled?: boolean;
  mutedUntil?: string | null;
  config?: AlertPreferenceUpdateConfig;
}

export interface NotificationCategory {
  key: string;
  label: string;
  description: string;
  sortOrder: number;
}

export type NotificationCatalogueTypePriority = typeof NotificationCatalogueTypePriority[keyof typeof NotificationCatalogueTypePriority];


export const NotificationCatalogueTypePriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type NotificationCatalogueTypeChannelsItem = typeof NotificationCatalogueTypeChannelsItem[keyof typeof NotificationCatalogueTypeChannelsItem];


export const NotificationCatalogueTypeChannelsItem = {
  in_app: 'in_app',
  email: 'email',
  push: 'push',
  digest: 'digest',
} as const;

export type NotificationCatalogueTypeDefaultConfig = { [key: string]: unknown } | null;

export interface NotificationCatalogueType {
  key: string;
  label: string;
  description: string;
  category: string;
  priority: NotificationCatalogueTypePriority;
  module: string;
  adminOnly: boolean;
  lockable: boolean;
  channels: NotificationCatalogueTypeChannelsItem[];
  defaultConfig?: NotificationCatalogueTypeDefaultConfig;
}

export interface NotificationCatalogue {
  categories: NotificationCategory[];
  types: NotificationCatalogueType[];
}

export type NotificationUserSettingsDigestCadence = typeof NotificationUserSettingsDigestCadence[keyof typeof NotificationUserSettingsDigestCadence];


export const NotificationUserSettingsDigestCadence = {
  immediate: 'immediate',
  daily: 'daily',
} as const;

export interface NotificationUserSettings {
  quietHoursEnabled: boolean;
  /** HH:MM 24h local */
  quietHoursStart: string;
  /** HH:MM 24h local */
  quietHoursEnd: string;
  timezone: string;
  digestCadence: NotificationUserSettingsDigestCadence;
  /**
     * @minimum 0
     * @maximum 23
     */
  digestHour: number;
}

export type NotificationUserSettingsUpdateDigestCadence = typeof NotificationUserSettingsUpdateDigestCadence[keyof typeof NotificationUserSettingsUpdateDigestCadence];


export const NotificationUserSettingsUpdateDigestCadence = {
  immediate: 'immediate',
  daily: 'daily',
} as const;

export interface NotificationUserSettingsUpdate {
  quietHoursEnabled?: boolean;
  quietHoursStart?: string;
  quietHoursEnd?: string;
  timezone?: string;
  digestCadence?: NotificationUserSettingsUpdateDigestCadence;
  /**
     * @minimum 0
     * @maximum 23
     */
  digestHour?: number;
}

export interface TenantNotificationDefault {
  role: string;
  alertType: string;
  inAppEnabled: boolean;
  emailEnabled: boolean;
  pushEnabled: boolean;
  digestEnabled: boolean;
  locked: boolean;
}

export interface TenantNotificationDefaultUpdate {
  role: string;
  alertType: string;
  inAppEnabled?: boolean;
  emailEnabled?: boolean;
  pushEnabled?: boolean;
  digestEnabled?: boolean;
  locked?: boolean;
}

export interface NotificationThreshold {
  module: string;
  settingKey: string;
  settingValue: string | null;
}

export interface NotificationThresholdUpdate {
  module: string;
  settingKey: string;
  settingValue?: string | null;
}

export type NotificationDeliveryLogRowChannel = typeof NotificationDeliveryLogRowChannel[keyof typeof NotificationDeliveryLogRowChannel];


export const NotificationDeliveryLogRowChannel = {
  in_app: 'in_app',
  email: 'email',
  push: 'push',
  digest: 'digest',
} as const;

export type NotificationDeliveryLogRowStatus = typeof NotificationDeliveryLogRowStatus[keyof typeof NotificationDeliveryLogRowStatus];


export const NotificationDeliveryLogRowStatus = {
  sent: 'sent',
  failed: 'failed',
  skipped: 'skipped',
  queued: 'queued',
} as const;

export interface NotificationDeliveryLogRow {
  id: string;
  userId: string;
  alertType: string;
  channel: NotificationDeliveryLogRowChannel;
  status: NotificationDeliveryLogRowStatus;
  target?: string | null;
  error?: string | null;
  createdAt: string;
}

export interface NotificationDeliveryLogResponse {
  items: NotificationDeliveryLogRow[];
  total?: number;
}

export type NotificationManualSendPriority = typeof NotificationManualSendPriority[keyof typeof NotificationManualSendPriority];


export const NotificationManualSendPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export interface NotificationManualSend {
  alertType: string;
  title: string;
  body?: string | null;
  link?: string | null;
  priority?: NotificationManualSendPriority;
  targetUserId?: string | null;
  targetRole?: string | null;
}

export interface NotificationManualSendResult {
  ok: boolean;
  recipients: number;
}

export interface NotificationBulkReadBody {
  ids?: string[];
}

export interface WhatsappTrackingTemplateVariableMap {
  /**
     * @minLength 1
     * @maxLength 32
     */
  customerName: string;
  /**
     * @minLength 1
     * @maxLength 32
     */
  orderNumber: string;
  /**
     * @minLength 1
     * @maxLength 32
     */
  trackingNumber: string;
  /**
     * @minLength 1
     * @maxLength 32
     */
  trackingUrl: string;
}

export interface WhatsappIntegrationStatus {
  configured: boolean;
  /**
     * True when an encrypted auth-token blob exists on the saved
     * credentials row. The token itself is never returned.
     */
  hasAuthToken: boolean;
  accountSid?: string | null;
  senderPhone?: string | null;
  packingConfirmationTemplateSid?: string | null;
  orderReceivedTemplateSid?: string | null;
  paymentReceivedTemplateSid?: string | null;
  orderPackedTemplateSid?: string | null;
  orderShippedTemplateSid?: string | null;
  orderShippedUtilityTemplateSid?: string | null;
  orderShippedUtilityVariableMap?: WhatsappTrackingTemplateVariableMap | null;
  senderStatusVerified?: boolean;
  senderStatusVerifiedAt?: string | null;
  /**
     * @maxLength 500
     * @nullable
     */
  senderStatusEvidence?: string | null;
  orderDeliveredTemplateSid?: string | null;
  /**
     * Optional Twilio Content SID (HX...) for a media-header template
     * used to attach the packing video directly to the WhatsApp
     * message. Null = no media template; sends fall back to the
     * secure link.
     */
  packingMediaTemplateSid?: string | null;
  /**
     * Optional Twilio Content SID (HX...) for a GENERAL approved
     * template used to message a customer over WhatsApp outside the
     * 24h customer-service window (where free-form sends fail with
     * code 63016). Null = no ad-hoc template configured. Redacted to
     * null for the packing.confirm-only caller.
     */
  adHocTemplateSid?: string | null;
  /**
     * Optional SMS sender in E.164 (Task #127). Used as the `From`
     * when no Messaging Service SID is set. Redacted to null for the
     * packing.confirm-only caller.
     */
  smsFromNumber?: string | null;
  /**
     * Optional Twilio Messaging Service SID (MG + 32 hex) for SMS
     * (Task #127). Takes precedence over `smsFromNumber` when set.
     * Redacted to null for the packing.confirm-only caller.
     */
  smsMessagingServiceSid?: string | null;
  /**
     * True when at least one SMS sender (from-number or Messaging
     * Service SID) is configured, so the SMS channel is usable.
     */
  smsConfigured?: boolean;
  credentialsInvalid: boolean;
  credentialsInvalidAt?: string | null;
}

export interface WhatsappIntegrationUpdate {
  /** Twilio Account SID (AC + 32 hex). */
  accountSid: string;
  /** Empty string = keep existing token. */
  authToken?: string;
  /** Sender in E.164 (e.g. +14155551234). */
  senderPhone?: string;
  /** Twilio Content SID (HX + 32 hex). */
  packingConfirmationTemplateSid?: string;
  /** Optional Twilio Content SID (HX + 32 hex) for the Order Received notice. Empty string clears it. */
  orderReceivedTemplateSid?: string;
  /** Optional Twilio Content SID (HX + 32 hex) for the Payment Received notice. Empty string clears it. */
  paymentReceivedTemplateSid?: string;
  /** Optional Twilio Content SID (HX + 32 hex) for the Order Packed notice. Empty string clears it; older integrations fall back to packingConfirmationTemplateSid. */
  orderPackedTemplateSid?: string;
  /** Optional Twilio Content SID (HX + 32 hex) for the Order Shipped notice. Empty string clears it. */
  orderShippedTemplateSid?: string;
  /** Optional separately approved Utility Content SID for Royal Mail tracking notifications. Empty string clears it. */
  orderShippedUtilityTemplateSid?: string;
  /** Explicit semantic-to-placeholder mapping; required before Utility tracking sends. */
  orderShippedUtilityVariableMap?: WhatsappTrackingTemplateVariableMap;
  /** Admin attestation that the configured WhatsApp sender is active and verified in Twilio. Defaults false. */
  senderStatusVerified?: boolean;
  /**
     * Operator note/reference to the external Twilio Console evidence checked before attesting.
     * @maxLength 500
     */
  senderStatusEvidence?: string;
  /** Optional Twilio Content SID (HX + 32 hex) for the Order Delivered notice. Empty string clears it. */
  orderDeliveredTemplateSid?: string;
  /** Optional Twilio media-header Content SID (HX + 32 hex) for direct video attach. Empty string clears it. */
  packingMediaTemplateSid?: string;
  /** Optional Twilio Content SID (HX + 32 hex) for ad-hoc customer messages outside the 24h window. Empty string clears it. */
  adHocTemplateSid?: string;
  /** Optional SMS sender in E.164 (Task #127). Empty string clears it. */
  smsFromNumber?: string;
  /** Optional Twilio Messaging Service SID (MG + 32 hex) for SMS (Task #127). Empty string clears it. */
  smsMessagingServiceSid?: string;
}

export interface WhatsappIntegrationTestResult {
  ok: boolean;
  /** Twilio account `friendly_name` returned on a successful probe. */
  friendlyName?: string | null;
  /** Twilio account `status` (e.g. `active`, `suspended`) returned on a successful probe. */
  status?: string | null;
  error?: string | null;
}

/**
 * Legacy single-channel field. Defaults to `email` for back-compat
 * with the original single-channel endpoint. `both` means email +
 * WhatsApp (NOT SMS). Ignored when `channels` is present.
 */
export type PackingConfirmationRequestChannel = typeof PackingConfirmationRequestChannel[keyof typeof PackingConfirmationRequestChannel];


export const PackingConfirmationRequestChannel = {
  email: 'email',
  whatsapp: 'whatsapp',
  sms: 'sms',
  both: 'both',
} as const;

export type PackingConfirmationRequestChannelsItem = typeof PackingConfirmationRequestChannelsItem[keyof typeof PackingConfirmationRequestChannelsItem];


export const PackingConfirmationRequestChannelsItem = {
  email: 'email',
  whatsapp: 'whatsapp',
  sms: 'sms',
} as const;

export interface PackingConfirmationRequest {
  /**
     * Legacy single-channel field. Defaults to `email` for back-compat
     * with the original single-channel endpoint. `both` means email +
     * WhatsApp (NOT SMS). Ignored when `channels` is present.
     */
  channel?: PackingConfirmationRequestChannel;
  /**
     * Explicit multi-channel selection (Task #127). When present it
     * takes precedence over `channel` and is the way to combine SMS
     * with email and/or WhatsApp.
     * @minItems 1
     */
  channels?: PackingConfirmationRequestChannelsItem[];
}

/**
 * Body for PATCH /inventory/{id}/composite-archive/order. The entryIds
 * array MUST be an exact permutation of the existing archive ids — no
 * adds, removes, or duplicates. Defined as a named schema (not inline)
 * because orval emits inline `Body` types as `export type` which collide
 * with the same-named zod schema in the api-zod barrel.
 */
export interface ReorderCompositeArchiveRequest {
  /** Exact permutation of the existing archive entry ids, in the desired display order. */
  entryIds: string[];
}

/**
 * Composition baseline used by this archived output; absent on legacy stored JSON is interpreted as single_coin.
 */
export type CompositeArchiveEntryLayout = typeof CompositeArchiveEntryLayout[keyof typeof CompositeArchiveEntryLayout];


export const CompositeArchiveEntryLayout = {
  single_coin: 'single_coin',
  shared_hero: 'shared_hero',
} as const;

/**
 * One previously-generated composite for an inventory item. Captured
 * every time the operator regenerates a composite, so the listing's
 * marketplace gallery can keep historical variants alongside the
 * current primary. Pinned to the template id+version it was rendered
 * against so the audit trail stays meaningful even after the
 * operator activates a new template.
 */
export interface CompositeArchiveEntry {
  /** UUIDv4 minted when the entry was archived. Used as the entryId path param on DELETE. */
  id: string;
  /** Object path of the archived composite PNG (resolves through /api/storage/objects/* via AuthedImage). */
  url: string;
  /** image_templates.id this composite was rendered against; null on legacy entries that pre-date pinning. */
  templateId: string | null;
  /** image_templates.version pin; null on legacy entries. */
  templateVersion: number | null;
  /** Composition baseline used by this archived output; absent on legacy stored JSON is interpreted as single_coin. */
  layout: CompositeArchiveEntryLayout;
  /** When the archived composite was originally rendered. */
  generatedAt: string;
}

export type RepairIssueSeverity = typeof RepairIssueSeverity[keyof typeof RepairIssueSeverity];


export const RepairIssueSeverity = {
  critical: 'critical',
  warning: 'warning',
  info: 'info',
} as const;

export type RepairIssueExpectedValues = {
  expectedSold?: number;
  expectedReserved?: number;
  expectedReturned?: number;
};

export type RepairIssueDiscrepancy = {
  soldDiff?: number;
  reservedDiff?: number;
};

export interface RepairIssue {
  id?: string;
  inventoryItemId?: string;
  sku?: string;
  productTitle?: string;
  stockType?: string;
  issueType?: string;
  severity?: RepairIssueSeverity;
  message?: string;
  currentValues?: InventoryCounters;
  expectedValues?: RepairIssueExpectedValues;
  discrepancy?: RepairIssueDiscrepancy;
}

export type RepairActionRequestAction = typeof RepairActionRequestAction[keyof typeof RepairActionRequestAction];


export const RepairActionRequestAction = {
  sync_sold_counter: 'sync_sold_counter',
  sync_reserved_counter: 'sync_reserved_counter',
  adjust_quantity_received: 'adjust_quantity_received',
  manual_adjustment: 'manual_adjustment',
  mark_reviewed: 'mark_reviewed',
} as const;

export interface RepairActionRequest {
  inventoryItemId: string;
  action: RepairActionRequestAction;
  value?: number;
  reason?: string;
  notes?: string;
}

export type RepairPreviewResultImpact = {
  stockChange?: number;
  newAvailability?: number;
  willBeNegative?: boolean;
};

export interface RepairPreviewResult {
  sku?: string;
  productTitle?: string;
  action?: string;
  before?: InventoryCounters;
  after?: InventoryCounters;
  impact?: RepairPreviewResultImpact;
}

export type RepairLogBeforeValues = { [key: string]: unknown };

export type RepairLogAfterValues = { [key: string]: unknown };

export interface RepairLog {
  id?: string;
  sku?: string;
  productTitle?: string;
  issueType?: string;
  actionTaken?: string;
  userEmail?: string | null;
  beforeValues?: RepairLogBeforeValues;
  afterValues?: RepairLogAfterValues;
  reason?: string | null;
  notes?: string | null;
  createdAt?: string;
}

export type CustomerOrderEmailNotificationEventType = typeof CustomerOrderEmailNotificationEventType[keyof typeof CustomerOrderEmailNotificationEventType];


export const CustomerOrderEmailNotificationEventType = {
  order_created: 'order_created',
  order_status_changed: 'order_status_changed',
  payment_status_changed: 'payment_status_changed',
} as const;

export type CustomerOrderEmailNotificationChangeKind = typeof CustomerOrderEmailNotificationChangeKind[keyof typeof CustomerOrderEmailNotificationChangeKind];


export const CustomerOrderEmailNotificationChangeKind = {
  order_status: 'order_status',
  payment_status: 'payment_status',
  both: 'both',
  created: 'created',
  tracking_status: 'tracking_status',
} as const;

export type CustomerOrderEmailNotificationDeliveryState = typeof CustomerOrderEmailNotificationDeliveryState[keyof typeof CustomerOrderEmailNotificationDeliveryState];


export const CustomerOrderEmailNotificationDeliveryState = {
  queued: 'queued',
  processing: 'processing',
  retry_wait: 'retry_wait',
  provider_accepted: 'provider_accepted',
  permanent_failure: 'permanent_failure',
  exhausted: 'exhausted',
  superseded: 'superseded',
} as const;

export interface CustomerOrderEmailNotification {
  id: string;
  saleOrderId: string;
  /** @nullable */
  orderNumber?: string | null;
  eventType: CustomerOrderEmailNotificationEventType;
  changeKind: CustomerOrderEmailNotificationChangeKind;
  /** @nullable */
  previousOrderStatus?: string | null;
  currentOrderStatus: string;
  /** @nullable */
  previousPaymentStatus?: string | null;
  currentPaymentStatus: string;
  deliveryState: CustomerOrderEmailNotificationDeliveryState;
  /** @minimum 0 */
  attemptCount: number;
  nextAttemptAt: string;
  /** @nullable */
  lastAttemptAt?: string | null;
  /** @nullable */
  lastErrorCode?: string | null;
  createdAt: string;
}

export interface CustomerOrderEmailNotificationsPage {
  items: CustomerOrderEmailNotification[];
  /** @minimum 0 */
  total: number;
}

export type CustomerOrderEmailNotificationRetryResultState = typeof CustomerOrderEmailNotificationRetryResultState[keyof typeof CustomerOrderEmailNotificationRetryResultState];


export const CustomerOrderEmailNotificationRetryResultState = {
  queued: 'queued',
} as const;

export interface CustomerOrderEmailNotificationRetryResult {
  ok: true;
  state: CustomerOrderEmailNotificationRetryResultState;
}

/**
 * Tenant DB pool registry status (Task
 */
export type HealthStatusPool = {
  size?: number;
  maxPools?: number;
  utilization?: number;
  evictionsLastHour?: number;
};

/**
 * Main scheduler tick heartbeat summary (Task
 */
export type HealthStatusScheduler = {
  consecutiveFailures?: number;
  lastCycleDurationMs?: number | null;
  secondsSinceLastSuccess?: number | null;
  maxTenantLagSeconds?: number | null;
};

/**
 * Rate limiter Redis-fallback status (Task
 */
export type HealthStatusRateLimiter = {
  redisConfigured?: boolean;
  fallbackActive?: boolean;
  consecutiveFailures?: number;
};

/**
 * Independent bounded Redis PING health and latency; contains only safe status codes.
 */
export type HealthStatusRedisProbe = {
  configured: boolean;
  available: boolean;
  /** Time spent establishing the shared connection and completing PING; null when Redis is not configured. */
  latencyMs?: number | null;
  /** Bounded diagnostic code; never contains a URL or credentials. */
  errorCode?: string | null;
};

/**
 * Slow/over-budget report query capture (Task
 */
export type HealthStatusQueryBudgets = {
  slowLastHour?: number;
  timeoutsLastHour?: number;
  totalSlow?: number;
  totalTimeouts?: number;
};

export type HealthStatusMarketDataRedisState = typeof HealthStatusMarketDataRedisState[keyof typeof HealthStatusMarketDataRedisState];


export const HealthStatusMarketDataRedisState = {
  not_configured: 'not_configured',
  connecting: 'connecting',
  available: 'available',
  unavailable: 'unavailable',
} as const;

export type HealthStatusMarketDataHistoryPersistenceState = typeof HealthStatusMarketDataHistoryPersistenceState[keyof typeof HealthStatusMarketDataHistoryPersistenceState];


export const HealthStatusMarketDataHistoryPersistenceState = {
  idle: 'idle',
  ok: 'ok',
  retrying: 'retrying',
} as const;

/**
 * Durable market-history persistence status; contains bounded safe error codes only.
 */
export type HealthStatusMarketDataHistoryPersistence = {
  state?: HealthStatusMarketDataHistoryPersistenceState;
  lastAttemptAt?: string | null;
  lastSuccessAt?: string | null;
  lastErrorCode?: string | null;
};

/**
 * Non-sensitive singleton market-ingestion health summary.
 */
export type HealthStatusMarketData = {
  state?: string;
  leader?: boolean;
  reconnects?: number;
  restFallbacks?: number;
  secondsSinceLastTick?: number | null;
  redisConfigured?: boolean;
  redisState?: HealthStatusMarketDataRedisState;
  /** Bounded Redis configuration or connection code; never contains a URL or credentials. */
  redisErrorCode?: string | null;
  reason?: string | null;
  lastProvider?: string | null;
  lastObservationAt?: string | null;
  activeProviders?: string[];
  activeRoutes?: string[];
  fallbackActive?: boolean;
  connectionStatus?: string;
  lastError?: string | null;
  staleMetals?: string[];
  /** Durable market-history persistence status; contains bounded safe error codes only. */
  historyPersistence?: HealthStatusMarketDataHistoryPersistence;
};

export interface HealthStatus {
  status: string;
  /** Non-sensitive sortable identifier for the deployed web/API release. */
  releaseId: string;
  /**
     * SHA-256 fingerprint of the production API entry bundle.
     * @pattern ^[a-f0-9]{64}$
     */
  apiBundleSha256: string;
  /** Tenant DB pool registry status (Task */
  pool?: HealthStatusPool;
  /** Main scheduler tick heartbeat summary (Task */
  scheduler?: HealthStatusScheduler;
  /** Rate limiter Redis-fallback status (Task */
  rateLimiter?: HealthStatusRateLimiter;
  /** Independent bounded Redis PING health and latency; contains only safe status codes. */
  redisProbe?: HealthStatusRedisProbe;
  /** Slow/over-budget report query capture (Task */
  queryBudgets?: HealthStatusQueryBudgets;
  /** Non-sensitive singleton market-ingestion health summary. */
  marketData?: HealthStatusMarketData;
}

export type SectionId = typeof SectionId[keyof typeof SectionId];


export const SectionId = {
  dashboard: 'dashboard',
  inventory: 'inventory',
  purchase_orders: 'purchase_orders',
  sales: 'sales',
  messages: 'messages',
  packing: 'packing',
  print_pack: 'print_pack',
  customers: 'customers',
  suppliers: 'suppliers',
  channels: 'channels',
  social: 'social',
  integrations: 'integrations',
  expenses: 'expenses',
  stationery: 'stationery',
  reports: 'reports',
  settings: 'settings',
  admin: 'admin',
  activity_log: 'activity_log',
  documents: 'documents',
  dropshipping: 'dropshipping',
  consignment: 'consignment',
  tasks: 'tasks',
  hr: 'hr',
  returns: 'returns',
  asset_tracking: 'asset_tracking',
  compliance: 'compliance',
  postage: 'postage',
  intelligence: 'intelligence',
  warehouse: 'warehouse',
  account: 'account',
  evidence: 'evidence',
  automations: 'automations',
  dynamic_pricing: 'dynamic_pricing',
  ai_agents: 'ai_agents',
  perks: 'perks',
  exceptions: 'exceptions',
} as const;

/**
 * Map of UI section id → boolean. A section absent from the map for a per-user override means "fall through to role default".
 */
export interface SectionAccessMap {[key: string]: boolean}

export interface SectionDef {
  id: SectionId;
  label: string;
  paths: string[];
}

export interface RoleSectionAccess {
  role: string;
  sections: SectionAccessMap;
}

export interface SectionAccessConfig {
  sections: SectionDef[];
  roles: RoleSectionAccess[];
}

export interface SectionAccessUpdate {
  sections: SectionAccessMap;
}

export interface UserSectionOverrideUpdate {
  overrides?: SectionAccessMap | null;
}

export interface AccountContactAddress {
  /** @maxLength 150 */
  line1: string;
  /**
     * @maxLength 150
     * @nullable
     */
  line2: string | null;
  /** @maxLength 100 */
  city: string;
  /**
     * @maxLength 100
     * @nullable
     */
  region: string | null;
  /** @maxLength 32 */
  postalCode: string;
  /**
     * ISO 3166-1 alpha-2 country code.
     * @pattern ^[A-Z]{2}$
     */
  countryCode: string;
}

export interface AccountProfile {
  /**
     * @maxLength 32
     * @nullable
     */
  phoneNumber: string | null;
  /**
     * @nullable
     * @pattern ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
     */
  dateOfBirth: string | null;
  address: AccountContactAddress | null;
}

export interface AccountProfileError {
  error: string;
}

export interface AccountContactAddressInput {
  /**
     * @minLength 1
     * @maxLength 150
     */
  line1: string;
  /**
     * @maxLength 150
     * @nullable
     */
  line2?: string | null;
  /**
     * @minLength 1
     * @maxLength 100
     */
  city: string;
  /**
     * @maxLength 100
     * @nullable
     */
  region?: string | null;
  /**
     * @minLength 1
     * @maxLength 32
     */
  postalCode: string;
  /**
     * ISO 3166-1 alpha-2 country code.
     * @pattern ^[A-Z]{2}$
     */
  countryCode: string;
}

export interface AccountProfileUpdate {
  /**
     * Pass null to clear the saved phone number.
     * @maxLength 32
     * @nullable
     * @pattern ^\+?[0-9][0-9 .()\-]{5,30}$
     */
  phoneNumber?: string | null;
  /**
     * Pass null to clear the saved date of birth.
     * @nullable
     * @pattern ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
     */
  dateOfBirth?: string | null;
  /** Pass null to clear all contact-address fields. */
  address?: AccountContactAddressInput | null;
}

export type AuthedUserThemePreference = typeof AuthedUserThemePreference[keyof typeof AuthedUserThemePreference];


export const AuthedUserThemePreference = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export type FloatingButtonPosition = typeof FloatingButtonPosition[keyof typeof FloatingButtonPosition];


export const FloatingButtonPosition = {
  'bottom-right': 'bottom-right',
  'bottom-left': 'bottom-left',
  'top-right': 'top-right',
  'top-left': 'top-left',
  'center-right': 'center-right',
  'center-left': 'center-left',
} as const;

export interface AuthedUserTenant {
  id: string;
  slug: string;
  name: string;
  role: string;
}

export interface AuthedUser {
  id: string;
  email: string;
  fullName?: string | null;
  role: string;
  /**
     * Cross-tenant super-admin flag. Independent of `role` (which is
     * tenant-scoped). True grants access to tenant CRUD, sending
     * invitations, and the cross-tenant admin views.
     */
  isSuperAdmin: boolean;
  permissions: string[];
  sections: SectionAccessMap;
  themePreference: AuthedUserThemePreference;
  /** Whether the floating Ask AI button shows on desktop (>=768px). */
  floatingButtonVisible: boolean;
  /** Whether the floating Ask AI button shows on mobile (<768px). */
  floatingButtonVisibleMobile: boolean;
  floatingButtonPosition: FloatingButtonPosition;
  /**
     * Active tenant memberships for this user. When the user belongs to
     * more than one tenant the frontend must persist a selection and
     * send `X-Tenant-Id` on every business-data request. Empty array is
     * possible for a pending user with no membership yet.
     */
  tenants?: AuthedUserTenant[];
}

export interface FloatingButtonUpdate {
  floatingButtonVisible?: boolean;
  floatingButtonVisibleMobile?: boolean;
  floatingButtonPosition?: FloatingButtonPosition;
}

export interface UserOut {
  id: string;
  email: string;
  fullName?: string | null;
  imageUrl?: string | null;
  role: string;
  lastSeenAt?: string | null;
  createdAt: string;
  sectionAccessOverride?: SectionAccessMap | null;
  /**
     * Per-user permission override. When non-null, replaces the role's
     * default permissions entirely (auth middleware: `permissionsOverride
     * ?? ROLE_PERMISSIONS[role]`). Null = inherit from role.
     */
  permissionsOverride?: string[] | null;
}

export interface LiveStockExportOverrideUpdate {
  /**
     * Ordered field keys. null resets the member to the tenant default;
     * [] is an explicit legacy four-column export override.
     */
  liveStockExportFieldsOverride: string[] | null;
}

export interface LiveStockExportMember {
  userId: string;
  email: string;
  fullName?: string | null;
  role: string;
  /** null means inherit the tenant default; [] is explicit. */
  liveStockExportFieldsOverride: string[] | null;
  effectiveLiveStockExportFields?: string[];
}

export interface LiveStockExportMembersResponse {
  tenantDefaultFields: string[];
  members: LiveStockExportMember[];
}

export interface UserPermissionsOverrideUpdate {
  /** Array of permission strings, or null to clear the override and inherit from role. */
  permissions: string[] | null;
}

export interface RoleSpec {
  id: string;
  label: string;
  permissions: string[];
}

export interface RoleList {
  roles: RoleSpec[];
}

export interface RoleUpdate {
  role: string;
}

export interface TenantUserInviteCreate {
  email: string;
  /** Role to grant in the caller's tenant when the invite is accepted. Defaults to "pending". */
  role?: string;
  /**
     * @minimum 1
     * @maximum 365
     */
  expiresInDays?: number;
}

export type TenantUserInviteResultInvitation = {
  id: string;
  emailAddress: string;
  status: string;
  createdAt?: number | null;
};

export interface TenantUserInviteResult {
  invitation: TenantUserInviteResultInvitation;
}

export interface TenantUserDirectCreate {
  email: string;
  /** @minLength 8 */
  password: string;
  /** Role to grant in the caller's tenant. Defaults to "pending". */
  role?: string;
  fullName?: string;
}

export type TenantUserDirectResultMember = {
  userId: string;
  email: string;
  role: string;
};

export interface TenantUserDirectResult {
  member: TenantUserDirectResultMember;
}

export interface TenantMember {
  tenantId: string;
  userId: string;
  email: string;
  fullName?: string | null;
  role: string;
  roleLabel: string;
  /** Effective permissions for this user in this tenant (override OR role default). */
  permissions: string[];
  /** Raw per-tenant override; null = inherit from role default. */
  permissionsOverride: string[] | null;
  createdAt: string;
  updatedAt: string;
}

export type TenantMemberListTenant = {
  id: string;
  slug: string;
  name: string;
};

export interface TenantMemberList {
  tenant: TenantMemberListTenant;
  members: TenantMember[];
}

export interface TenantMemberResponse {
  member: TenantMember | null;
}

export interface BulkIdRequest {
  /**
     * @minItems 1
     * @maxItems 200
     */
  ids: string[];
}

export interface BulkInventoryDeleteSkip {
  id: string;
  sku?: string | null;
  reason: string;
}

export interface BulkInventoryDeleteResult {
  requested: number;
  deleted: number;
  skipped: BulkInventoryDeleteSkip[];
  /** Number of empty stock lots removed alongside deleted inventory items. */
  lotsRemoved?: number;
}

/**
 * Per-channel listing source: channel key (e.g. shopify,
 * ebay, woocommerce) -> lot id whose external listing the
 * survivor keeps for that channel. Specifying a channel here
 * RESOLVES a listing_conflict without blocking; the displaced
 * listings on that channel are taken down.
 */
export type MergeInventoryRequestFieldSourcesListings = {[key: string]: string} | null;

/**
 * Optional per-group source selection for the survivor. Each
 * value is the lot id (survivor or a loser) whose value the
 * merged survivor adopts for that group. Omitting a group keeps
 * the default behaviour: survivor wins identity; photos/listings
 * union with survivor priority; landed cost weighted-average;
 * ownership auto-resolved (consignment always wins — a mixed
 * OWNED+CONSIGNMENT merge yields a CONSIGNMENT survivor whose
 * owned units fold into quantityOwned).
 */
export type MergeInventoryRequestFieldSources = {
  /** Lot whose title / brand / description the survivor adopts. */
  identity?: string | null;
  /**
     * Lot id to take photos / composite / gallery solely from,
     * or the literal "merge" to union all lots (default).
     */
  images?: string | null;
  /**
     * Per-channel listing source: channel key (e.g. shopify,
     * ebay, woocommerce) -> lot id whose external listing the
     * survivor keeps for that channel. Specifying a channel here
     * RESOLVES a listing_conflict without blocking; the displaced
     * listings on that channel are taken down.
     */
  listings?: MergeInventoryRequestFieldSourcesListings;
  /**
     * Lot id to pin the survivor's landed cost to, or "weighted"
     * (default weighted-average). Ignored when the merge resolves
     * to CONSIGNMENT — the consignment base cost governs the
     * profit-split floor.
     */
  cost?: string | null;
} | null;

export interface MergeInventoryRequest {
  /** The lot that keeps its id, title, listings, etc. */
  survivorId: string;
  /**
     * Lots to fold into the survivor. Capped at 19 (so the largest
     * possible merge is 20 rows) to keep the single-tx FOR UPDATE
     * footprint bounded.
     * @minItems 1
     * @maxItems 19
     */
  loserIds: string[];
  /**
     * When true, validation + cost math run but no writes happen.
     * The response payload (cost, basis, blockers, moved sale-line
     * count) is identical to a real apply.
     */
  dryRun?: boolean;
  /**
     * Optional per-group source selection for the survivor. Each
     * value is the lot id (survivor or a loser) whose value the
     * merged survivor adopts for that group. Omitting a group keeps
     * the default behaviour: survivor wins identity; photos/listings
     * union with survivor priority; landed cost weighted-average;
     * ownership auto-resolved (consignment always wins — a mixed
     * OWNED+CONSIGNMENT merge yields a CONSIGNMENT survivor whose
     * owned units fold into quantityOwned).
     */
  fieldSources?: MergeInventoryRequestFieldSources;
}

export type MergeInventoryBlockerKind = typeof MergeInventoryBlockerKind[keyof typeof MergeInventoryBlockerKind];


export const MergeInventoryBlockerKind = {
  not_found: 'not_found',
  survivor_in_losers: 'survivor_in_losers',
  duplicate_loser_ids: 'duplicate_loser_ids',
  too_many_losers: 'too_many_losers',
  stock_type_mismatch: 'stock_type_mismatch',
  consignment_batch_mismatch: 'consignment_batch_mismatch',
  different_consignor: 'different_consignor',
  consignment_terms_mismatch: 'consignment_terms_mismatch',
  currency_mismatch: 'currency_mismatch',
  in_open_shipment_group: 'in_open_shipment_group',
  listing_conflict: 'listing_conflict',
  has_transformations: 'has_transformations',
  is_variant_master: 'is_variant_master',
  has_consignment_payouts: 'has_consignment_payouts',
} as const;

export interface MergeInventoryBlocker {
  kind: MergeInventoryBlockerKind;
  /** The inventory id the blocker is about (survivor or loser). */
  itemId?: string | null;
  /** Operator-facing context (channel + ids on a listing conflict, etc.). */
  details?: string | null;
}

/**
 * Which weighting was used. `available` = weighted by remaining
 * available qty (preferred). `total` = fallback when every lot
 * is sold out. `single` = only one lot effectively contributed.
 */
export type MergeInventoryResultCostBasis = typeof MergeInventoryResultCostBasis[keyof typeof MergeInventoryResultCostBasis];


export const MergeInventoryResultCostBasis = {
  available: 'available',
  total: 'total',
  single: 'single',
} as const;

/**
 * How the survivor's ownership was resolved. `all_owned` keeps
 * OWNED. `mixed_folds_into_consignment` flips the survivor to
 * CONSIGNMENT and folds the OWNED lots' units into quantityOwned.
 * `all_consignment` keeps CONSIGNMENT (lots must share consignor
 * + batch + terms).
 */
export type MergeInventoryResultOwnershipResolution = typeof MergeInventoryResultOwnershipResolution[keyof typeof MergeInventoryResultOwnershipResolution] | null;


export const MergeInventoryResultOwnershipResolution = {
  all_owned: 'all_owned',
  mixed_folds_into_consignment: 'mixed_folds_into_consignment',
  all_consignment: 'all_consignment',
} as const;

/**
 * The stock type the survivor will have after the merge.
 */
export type MergeInventoryResultResultingStockType = typeof MergeInventoryResultResultingStockType[keyof typeof MergeInventoryResultResultingStockType] | null;


export const MergeInventoryResultResultingStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export interface MergeInventoryResult {
  ok: true;
  dryRun: boolean;
  survivorId: string;
  /** Present on a dry-run response (the lots that WOULD be merged). */
  loserIds?: string[];
  /** Present on a real apply response (the lots that WERE merged). */
  mergedLoserIds?: string[];
  /** New per-unit landed cost on the survivor (numeric string, 4dp). */
  newLandedUnitCost: string;
  /**
     * Which weighting was used. `available` = weighted by remaining
     * available qty (preferred). `total` = fallback when every lot
     * is sold out. `single` = only one lot effectively contributed.
     */
  costBasis: MergeInventoryResultCostBasis;
  /** Count of sale_order_items repointed from loser → survivor. */
  movedSaleLines: number;
  /** Audit batchId shared by every row written by this merge. */
  batchId?: string | null;
  /**
     * How the survivor's ownership was resolved. `all_owned` keeps
     * OWNED. `mixed_folds_into_consignment` flips the survivor to
     * CONSIGNMENT and folds the OWNED lots' units into quantityOwned.
     * `all_consignment` keeps CONSIGNMENT (lots must share consignor
     * + batch + terms).
     */
  ownershipResolution?: MergeInventoryResultOwnershipResolution;
  /** The stock type the survivor will have after the merge. */
  resultingStockType?: MergeInventoryResultResultingStockType;
  /** Consignor on the merged survivor (null when OWNED). */
  resultingConsignmentSupplierId?: string | null;
  /** Consignor display name on the merged survivor (null when OWNED). */
  resultingConsignmentSupplierName?: string | null;
  /** Consignment batch on the merged survivor (null when OWNED/none). */
  resultingConsignmentBatchId?: string | null;
  /**
     * Units the business outright owns on the merged CONSIGNMENT
     * survivor (folded-in OWNED units + any pre-existing owned
     * portion). 0/absent when the survivor stays OWNED.
     */
  resultingQuantityOwned?: number | null;
  /**
     * Weighted per-unit cost of the owned portion on a CONSIGNMENT
     * survivor (numeric string, 4dp). Null when there is no owned
     * portion.
     */
  resultingOwnedUnitCost?: string | null;
}

export interface MergeInventoryBlockedResult {
  ok: false;
  blockers: MergeInventoryBlocker[];
  movedSaleLines: number;
}

export type BulkInventoryEditPatchStockType = typeof BulkInventoryEditPatchStockType[keyof typeof BulkInventoryEditPatchStockType];


export const BulkInventoryEditPatchStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type BulkInventoryEditPatchConsignmentPayoutType = typeof BulkInventoryEditPatchConsignmentPayoutType[keyof typeof BulkInventoryEditPatchConsignmentPayoutType] | null;


export const BulkInventoryEditPatchConsignmentPayoutType = {
  FIXED_PER_UNIT: 'FIXED_PER_UNIT',
  PROFIT_SPLIT_PCT: 'PROFIT_SPLIT_PCT',
} as const;

/**
 * Set of fields to apply to every selected item. All fields optional —
 * unset fields are left untouched. Send `null` to explicitly CLEAR a
 * nullable column (e.g. unlink a supplier or remove a payout price);
 * omit the property entirely to leave the existing value alone.
 */
export interface BulkInventoryEditPatch {
  stockType?: BulkInventoryEditPatchStockType;
  /** UUID of a row in `suppliers`; `null` unlinks. */
  consignmentSupplierId?: string | null;
  supplierName?: string | null;
  /** Fixed per-unit payout in GBP (used when payout type is FIXED_PER_UNIT). */
  supplierPayoutPrice?: number | null;
  consignmentPayoutType?: BulkInventoryEditPatchConsignmentPayoutType;
  /**
     * @minimum 0
     * @maximum 100
     */
  consignmentSupplierSplitPct?: number | null;
  /**
     * @minimum 0
     * @maximum 100
     */
  consignmentBusinessSplitPct?: number | null;
  /** Batch Recovery Consignment batch link. `null` clears. */
  consignmentBatchId?: string | null;
}

export interface BulkInventoryEditRequest {
  /**
     * @minItems 1
     * @maxItems 200
     */
  ids: string[];
  patch: BulkInventoryEditPatch;
  /**
     * When false (default) items with quantitySold > 0 are skipped to
     * protect historical P&L. Set true to override — use with care: a
     * stockType change on a sold-through item retroactively shifts the
     * cost basis of past sales' profit math.
     */
  includeSold?: boolean;
}

export interface BulkInventoryEditSkip {
  id: string;
  sku?: string | null;
  reason: string;
}

export interface BulkInventoryEditResult {
  requested: number;
  updated: number;
  skipped: BulkInventoryEditSkip[];
}

export interface BulkSalesDeleteError {
  id: string;
  reason: string;
}

export interface BulkSalesDeleteResult {
  requested: number;
  /** Sales whose row was hard-deleted (no consignment payout / statement history blocked the cascade). */
  deleted: number;
  /** Sales kept and marked `status="Reversed"` because at least one consignment line had been paid out (or other accounting history existed). */
  reversed: number;
  errors: BulkSalesDeleteError[];
}

export interface ConsignmentConversionItem {
  saleOrderItemId: string;
  /**
     * The SAME inventory row the line was originally consumed from —
     * stock returns here and is now owned by you.
     */
  inventoryItemId: string;
  sku: string;
  /** Units converted from consignment to owned on this row. */
  qtyConverted: number;
  /** Per-unit amount the supplier was paid (= consignment_supplier_paid_gbp ÷ quantity). */
  costPerUnitGbp: number;
  /**
     * Updated weighted-average `ownedUnitCost` on the inventory row
     * after this conversion is applied.
     */
  newOwnedUnitCost: number;
}

/**
 * "deleted" — sale row removed and inventory restored.
 * "reversed" — sale row kept and marked `status="Reversed"` because
 * at least one consignment line was converted to owned, or other
 * consignment payout / statement history forced it.
 */
export type SaleReversalResultDisposition = typeof SaleReversalResultDisposition[keyof typeof SaleReversalResultDisposition];


export const SaleReversalResultDisposition = {
  deleted: 'deleted',
  reversed: 'reversed',
} as const;

export interface SaleReversalResult {
  /**
     * "deleted" — sale row removed and inventory restored.
     * "reversed" — sale row kept and marked `status="Reversed"` because
     * at least one consignment line was converted to owned, or other
     * consignment payout / statement history forced it.
     */
  disposition: SaleReversalResultDisposition;
  /** Human-readable reasons the sale was kept rather than deleted. */
  reversedReasons: string[];
  /**
     * Paid-consignment lines whose stock returned to the SAME SKU but
     * is now owned by you. Each entry bumps the row's `quantityOwned`
     * and weighted-averages `ownedUnitCost`. NO new SKU is created.
     */
  consignmentConversions: ConsignmentConversionItem[];
}

export interface SaleCostChange {
  saleOrderId: string;
  orderNumber: string;
  saleOrderItemId: string;
  sku?: string | null;
  productTitle: string;
  quantity: number;
  previousUnitCost: number;
  newUnitCost: number;
  /** (newUnitCost - previousUnitCost) * quantity. Negative means profit improved (cost was overstated). */
  costDeltaGbp: number;
}

export interface SalesRecalculateCostsResult {
  itemsScanned: number;
  itemsUpdated: number;
  ordersAffected: number;
  skippedAlreadyPaid: number;
  skippedMissingInventory: number;
  /** Sum of (new - prev) * qty across all updated lines. Negative = total profit improved. */
  totalCostDeltaGbp: number;
  /** Up to 25 corrections, sorted by largest absolute cost delta first. */
  topChanges: SaleCostChange[];
}

export interface PeriodAggregate {
  revenue: number;
  cost: number;
  fees: number;
  profit: number;
  margin: number;
  /** Output VAT (GBP) owed to HMRC across this aggregate's sale lines (Task */
  outputVat?: number;
  /** profit minus outputVat. Parallel to profit — never replaces it. */
  vatAdjustedProfit?: number;
  /** vatAdjustedProfit / revenue × 100, one decimal. 0 when revenue is 0. */
  vatAdjustedMargin?: number;
  /** True when any non-empty line lacked a usable VAT treatment, so outputVat under-estimates. */
  vatTreatmentFlagged?: boolean;
  orders: number;
  units: number;
}

export type PeriodComparisonEntryDeltas = {
  revenue: number;
  profit: number;
  /** Percentage change in vatAdjustedProfit vs the prior period (Task */
  vatAdjustedProfit?: number;
  orders: number;
};

export interface PeriodComparisonEntry {
  /** day | week | month */
  period: string;
  current: PeriodAggregate;
  prior: PeriodAggregate;
  deltas: PeriodComparisonEntryDeltas;
}

export interface PeriodComparisonReport {
  periods: PeriodComparisonEntry[];
}

export interface SkuChannelBreakdown {
  channel: string;
  qty: number;
  revenue: number;
  profit: number;
}

export interface SkuByChannelRow {
  sku: string;
  productName: string;
  channel: string;
  qty: number;
  revenue: number;
  profit: number;
  metal?: string | null;
}

export interface SkuRollup {
  sku: string;
  productName: string;
  metal?: string | null;
  qty: number;
  revenue: number;
  profit: number;
  channels: SkuChannelBreakdown[];
}

export interface SkuByChannelReport {
  rows: SkuByChannelRow[];
  topSkus: SkuRollup[];
}

export interface SendPurchaseOrderInput {
  /** Override recipient email */
  to?: string;
}

export type Ga4StatsTopPagesItem = {
  path: string;
  views: number;
};

export interface Ga4Stats {
  configured: boolean;
  propertyId?: string | null;
  windowDays?: number | null;
  users?: number | null;
  sessions?: number | null;
  pageviews?: number | null;
  topPages?: Ga4StatsTopPagesItem[] | null;
  message?: string | null;
}

export interface MobileDashboardOrder {
  id: string;
  orderNumber: string;
  channel: string;
  status: string;
  saleDate: string;
  /**
     * Null without view_sale_price.
     * @nullable
     */
  amount: number | null;
}

export type MobileDashboardAttentionSeverity = typeof MobileDashboardAttentionSeverity[keyof typeof MobileDashboardAttentionSeverity];


export const MobileDashboardAttentionSeverity = {
  critical: 'critical',
  warning: 'warning',
  info: 'info',
} as const;

export interface MobileDashboardAttention {
  id: string;
  label: string;
  count: number;
  severity: MobileDashboardAttentionSeverity;
  href: string;
}

export interface MobileDashboardProduct {
  id: string;
  title: string;
  sku: string;
  units: number;
  /**
     * Null without view_sale_price.
     * @nullable
     */
  revenue: number | null;
}

export interface MobileDashboardTask {
  id: string;
  title: string;
  status: string;
  /** @nullable */
  dueDate: string | null;
}

export type MobileDashboardSecondaryOrderStatus = {
  /** @minimum 0 */
  processing: number;
  /** @minimum 0 */
  shipped: number;
  /** @minimum 0 */
  onHold: number;
  /** @minimum 0 */
  refunds: number;
};

export type MobileDashboardSecondaryAvailability = {
  recentOrders: boolean;
  orderStatus: boolean;
  attention: boolean;
  products: boolean;
  tasks: boolean;
};

export interface MobileDashboardSecondary {
  generatedAt: string;
  /** @maxItems 5 */
  recentOrders: MobileDashboardOrder[];
  orderStatus: MobileDashboardSecondaryOrderStatus;
  /** @maxItems 6 */
  attention: MobileDashboardAttention[];
  /** @maxItems 5 */
  topProducts: MobileDashboardProduct[];
  /** @maxItems 5 */
  topTasks: MobileDashboardTask[];
  availability: MobileDashboardSecondaryAvailability;
}

/**
 * Set to "stale" when no spot price row exists or the latest is more than 30 minutes old. Null when spot data is fresh or valuation is not enabled.
 */
export type DashboardSummarySpotDataWarning = typeof DashboardSummarySpotDataWarning[keyof typeof DashboardSummarySpotDataWarning] | null;


export const DashboardSummarySpotDataWarning = {
  stale: 'stale',
} as const;

export interface InventoryPortfolioSplit {
  commodityValue?: number | null;
  premiumValue?: number | null;
  hybridMetalValue?: number | null;
  hybridPremiumValue?: number | null;
  excludedValue?: number | null;
  totalValue?: number | null;
  commodityPct?: number | null;
  premiumPct?: number | null;
}

export interface InventoryPortfolioSnapshot {
  commoditySilverOz?: number | null;
  commoditySilverCost?: number | null;
  commoditySilverAvgCostPerOz?: number | null;
  commoditySilverUnitCount?: number | null;
  commoditySilverSkuCount?: number | null;
  premiumTotalValuation?: number | null;
  premiumAcquisitionCost?: number | null;
  premiumUnitCount?: number | null;
  premiumSkuCount?: number | null;
  portfolioCommodityValue?: number | null;
  portfolioPremiumValue?: number | null;
  portfolioHybridMetalValue?: number | null;
  portfolioHybridPremiumValue?: number | null;
  portfolioExcludedValue?: number | null;
  portfolioTotalValue?: number | null;
  totalItemCount?: number | null;
  classifiedItemCount?: number | null;
  unclassifiedItemCount?: number | null;
  migrationConfirmedAt?: string | null;
  lastRecalculatedAt: string;
  isStale: boolean;
}

export interface DashboardSummary {
  inventoryValueAtCost: number;
  inventoryEstimatedResale: number;
  liveStockCount: number;
  totalSoldItems: number;
  monthlyRevenue: number;
  monthlyGrossProfit: number;
  /** Month-to-date platform fees in GBP, including Shopify's configured percentage estimate. Null without P&L permission. */
  monthlyPlatformFees: number | null;
  /** Month-to-date profit after platform fees in GBP. Null without P&L permission. */
  monthlyNetProfit: number | null;
  itemsNotListed: number;
  itemsReservedUnpaid: number;
  upcomingDeliveries: number;
  goldUnits: number;
  silverUnits: number;
  otherUnits: number;
  /** Distinct sellable inventory SKUs (rows with quantityAvailable > 0, excluding mirrored Shopify rows). Same source as the dashboard "Live In-Stock Sellable" card. */
  liveSellableSkus?: number;
  /** Sum of (availableUnits * effectiveUnitCost) across live sellable rows, with consignment buckets valued at supplier payout / base cost. Equal to inventoryValueAtCost; provided for clarity at the call site. */
  liveSellableValueAtCost?: number;
  /** Sum of `quantity_coming_soon` across non-mirrored rows. EXCLUDED from `inventoryValueAtCost` / `liveSellableValueAtCost` — coming-soon stock is committed-but-not-on-hand and surfaced as its own dashboard tile. */
  comingSoonUnits?: number;
  /** Sum of (quantityComingSoon * effectiveUnitCost) across non-mirrored rows. Same per-row cost rule as the live-sellable math (owned cost for OWNED rows, supplier-payout / base cost for CONSIGNMENT rows). */
  comingSoonValueAtCost?: number;
  /** Distinct SKUs with quantityComingSoon > 0 (excluding mirrored Shopify rows). */
  comingSoonSkus?: number;
  /** Weighted-average landed cost per troy ounce across OWNED silver stock physically in hand (available > 0, not Shopify-mirrored, not needsSkuReview, OWNED only — consignment excluded). GBP. Null when caller lacks finance.product_margin.view. */
  silverAvgCostPerOz?: number | null;
  /** Total troy ounces of silver across the same population as silverAvgCostPerOz. Operational counter — visible to all dashboard viewers. */
  silverTotalOunces?: number | null;
  /** Total landed cost (GBP) of the silver inventory that backs silverAvgCostPerOz. Null when caller lacks finance.product_margin.view. */
  silverTotalCost?: number | null;
  /** Weighted-average landed cost per troy ounce across OWNED silver stock that is on order (quantity_coming_soon > 0). Same per-row weight resolution (structured weight → weight_grams → product-title parse) and filters (not Shopify-mirrored, not needsSkuReview, OWNED only) as silverAvgCostPerOz. GBP. Null when caller lacks finance.product_margin.view. */
  silverComingSoonAvgCostPerOz?: number | null;
  /** Total troy ounces of OWNED silver currently on order (quantity_coming_soon > 0). Operational counter — visible to all dashboard viewers. */
  silverComingSoonOunces?: number | null;
  /** Total landed cost (GBP) of the OWNED silver on order that backs silverComingSoonAvgCostPerOz. Null when caller lacks finance.product_margin.view. */
  silverComingSoonCost?: number | null;
  /** Count of sale orders whose saleDate falls within the current UK calendar day (Europe/London). Operational counter — visible to all dashboard viewers regardless of finance permissions. */
  ordersToday?: number;
  /** True when the advanced_inventory_valuation_enabled feature flag is ON for this tenant. */
  valuationEnabled?: boolean;
  /** True when the operator has clicked "Confirm & Activate" in the migration flow. Until this is true the corrected silver average is not used for the main widget. */
  valuationMigrationConfirmed?: boolean;
  /**
     * Valuation-corrected weighted-average silver cost per troy oz (GBP).
     * Only commodity (spot_tracked + metal part of hybrid) items included.
     * Present only when valuationEnabled=true AND valuationMigrationConfirmed=true.
     * Requires finance.product_margin.view permission — null otherwise.
     */
  commoditySilverAvgCostPerOz?: number | null;
  /** Total troy oz in the commodity silver population (valuationEnabled only). */
  commoditySilverTotalOz?: number | null;
  /** Total landed cost of commodity silver. Requires finance.product_margin.view. (valuationEnabled only). */
  commoditySilverTotalCost?: number | null;
  /** Sum of acquisition cost / manual valuation across Premium, Hybrid-premium-component, and Custom items. Requires view_premium_inventory_value permission. */
  premiumInventoryValue?: number | null;
  /** Unit count in the premium/hybrid/custom population. */
  premiumUnitCount?: number | null;
  /** Portfolio value breakdown by classification segment. Requires view_portfolio_split permission. */
  portfolioSplit?: InventoryPortfolioSplit | null;
  /** Full cached portfolio snapshot. Included when requested and user has relevant permissions. */
  valuationSnapshot?: InventoryPortfolioSnapshot | null;
  /** Timestamp of last background portfolio recalculation. */
  lastValuationRecalculatedAt?: string | null;
  /** Age in minutes of the most recent spot price row for this tenant. Null when no spot price data has ever been fetched. Present only when valuationEnabled=true. */
  spotDataFreshnessMinutes?: number | null;
  /** Set to "stale" when no spot price row exists or the latest is more than 30 minutes old. Null when spot data is fresh or valuation is not enabled. */
  spotDataWarning?: DashboardSummarySpotDataWarning;
}

export type ActivityItemType = typeof ActivityItemType[keyof typeof ActivityItemType];


export const ActivityItemType = {
  purchase: 'purchase',
  sale: 'sale',
} as const;

export interface ActivityItem {
  id: string;
  type: ActivityItemType;
  title: string;
  subtitle?: string | null;
  date: string;
  amount: number;
  status?: string | null;
}

export interface AlertsSummary {
  missingResalePrice: number;
  missingCost: number;
  missingSupplier: number;
  reservedUnpaid: number;
  soldNotShipped: number;
  overduePurchases: number;
  lowMargin: number;
  highValueNotListed: number;
  missingPhotos: number;
  lowStationery: number;
  /** Count of eBay orders the live scheduler is failing to import (status='pending' in ebay_sync_issues). */
  unmatchedEbayOrders: number;
}

export interface EbayRescanRequest {
  /**
     * @minimum 1
     * @maximum 90
     */
  lookbackDays?: number;
  triggeredByUser?: string | null;
  /** eBay account key to rescan; omit to rescan every enabled account. */
  accountKey?: string;
}

/**
 * Which eBay API to use for fetching the order. `fulfillment`
 * (default) hits the modern Sell/Fulfillment API and expects a
 * standard `NN-NNNNN-NNNNN` order id. `trading` hits the legacy
 * Trading API (used for offline-paid orders the modern API
 * silently omits) and expects a legacy `<itemId>-<transId>` id.
 */
export type EbayImportOrderRequestSource = typeof EbayImportOrderRequestSource[keyof typeof EbayImportOrderRequestSource];


export const EbayImportOrderRequestSource = {
  fulfillment: 'fulfillment',
  trading: 'trading',
} as const;

export interface EbayImportOrderRequest {
  ebayOrderId: string;
  /**
     * Which eBay API to use for fetching the order. `fulfillment`
     * (default) hits the modern Sell/Fulfillment API and expects a
     * standard `NN-NNNNN-NNNNN` order id. `trading` hits the legacy
     * Trading API (used for offline-paid orders the modern API
     * silently omits) and expects a legacy `<itemId>-<transId>` id.
     */
  source?: EbayImportOrderRequestSource;
  /** eBay account key that owns the order. */
  accountKey?: string;
}

export type EbaySyncRunErrorsItem = {
  ebayOrderId?: string;
  message?: string;
};

export interface EbaySyncRun {
  id: string;
  startedAt: string;
  completedAt?: string | null;
  lookbackDays?: number | null;
  sinceISO?: string | null;
  scope: string;
  triggeredBy: string;
  triggeredByUser?: string | null;
  accountKey: string;
  ordersChecked: number;
  ordersImported: number;
  ordersUpdated: number;
  duplicatesSkipped: number;
  latePaidImported: number;
  errorsCount: number;
  errors?: EbaySyncRunErrorsItem[] | null;
  status: string;
  message?: string | null;
}

export type EbayRescanResultErrorsItem = {
  ebayOrderId: string;
  message: string;
};

export interface EbayRescanResult {
  ok: boolean;
  runId: string;
  lookbackDays: number;
  sinceISO: string;
  ordersChecked: number;
  ordersImported: number;
  ordersUpdated: number;
  duplicatesSkipped: number;
  latePaidImported: number;
  errorsCount: number;
  errors: EbayRescanResultErrorsItem[];
  message?: string | null;
  summary: string;
}

/**
 * Which eBay API surfaced this hit. `fulfillment` = modern
 * Sell/Fulfillment API. `trading` = legacy Trading API (catches
 * offline-paid orders the modern API silently omits — bank
 * transfers, in-person collection, etc.). The Import button
 * MUST round-trip this back so the server uses the right API.
 */
export type FindEbayOrderHitSource = typeof FindEbayOrderHitSource[keyof typeof FindEbayOrderHitSource];


export const FindEbayOrderHitSource = {
  fulfillment: 'fulfillment',
  trading: 'trading',
} as const;

export interface FindEbayOrderHit {
  ebayOrderId: string;
  accountKey: string;
  creationDate: string;
  buyerUsername?: string | null;
  buyerFullName?: string | null;
  paymentStatus: string;
  fulfillmentStatus: string;
  totalAmount: number;
  currency: string;
  inDb: boolean;
  localSaleOrderId?: string | null;
  localOrderNumber?: string | null;
  localStatus?: string | null;
  /**
     * Which eBay API surfaced this hit. `fulfillment` = modern
     * Sell/Fulfillment API. `trading` = legacy Trading API (catches
     * offline-paid orders the modern API silently omits — bank
     * transfers, in-person collection, etc.). The Import button
     * MUST round-trip this back so the server uses the right API.
     */
  source: FindEbayOrderHitSource;
}

export interface FindEbayOrdersResult {
  ok: boolean;
  query: string;
  daysBack: number;
  scanned: number;
  hits: FindEbayOrderHit[];
  message?: string | null;
}

export type EbayImportOrderResultKind = typeof EbayImportOrderResultKind[keyof typeof EbayImportOrderResultKind];


export const EbayImportOrderResultKind = {
  imported: 'imported',
  duplicate: 'duplicate',
  not_found: 'not_found',
  failed: 'failed',
} as const;

export interface EbayImportOrderResult {
  ok: boolean;
  kind: EbayImportOrderResultKind;
  saleOrderId?: string | null;
  message?: string | null;
}

export type EbaySyncIssueStatus = typeof EbaySyncIssueStatus[keyof typeof EbaySyncIssueStatus];


export const EbaySyncIssueStatus = {
  pending: 'pending',
  skipped: 'skipped',
  resolved: 'resolved',
} as const;

export type EbaySyncIssueReason = typeof EbaySyncIssueReason[keyof typeof EbaySyncIssueReason];


export const EbaySyncIssueReason = {
  customer_lookup: 'customer_lookup',
  malformed_order: 'malformed_order',
  inventory_mapping: 'inventory_mapping',
  import_failure: 'import_failure',
} as const;

export type EbaySyncIssueRetryState = typeof EbaySyncIssueRetryState[keyof typeof EbaySyncIssueRetryState];


export const EbaySyncIssueRetryState = {
  ready: 'ready',
  quarantine_only: 'quarantine_only',
  complete: 'complete',
} as const;

export type EbaySyncIssueRawPayload = { [key: string]: unknown };

export interface EbaySyncIssue {
  id: string;
  ebayOrderId: string;
  accountKey: string;
  status: EbaySyncIssueStatus;
  attempts: number;
  reason: EbaySyncIssueReason;
  retryState: EbaySyncIssueRetryState;
  lastError?: string | null;
  parsedSku?: string | null;
  buyerUsername?: string | null;
  totalAmount?: number | null;
  currency?: string | null;
  rawPayload?: EbaySyncIssueRawPayload;
  firstSeenAt: string;
  lastSeenAt: string;
  resolvedAt?: string | null;
  resolvedBy?: string | null;
  resolutionNotes?: string | null;
}

export type EbaySyncIssuesListCounts = {
  pending: number;
  skipped: number;
  resolved: number;
};

export interface EbaySyncIssuesList {
  items: EbaySyncIssue[];
  counts: EbaySyncIssuesListCounts;
}

export interface EbaySyncIssueBulkBody {
  ids: string[];
  notes?: string | null;
}

export interface EbaySyncIssueBulkResult {
  ok: boolean;
  updated: number;
  quarantined?: number;
}

export type EbaySyncIssueRetryResultKind = typeof EbaySyncIssueRetryResultKind[keyof typeof EbaySyncIssueRetryResultKind];


export const EbaySyncIssueRetryResultKind = {
  imported: 'imported',
  duplicate: 'duplicate',
  resolved: 'resolved',
  skipped: 'skipped',
  quarantined: 'quarantined',
  already_quarantined: 'already_quarantined',
} as const;

export type EbaySyncIssueRetryResultRetryState = typeof EbaySyncIssueRetryResultRetryState[keyof typeof EbaySyncIssueRetryResultRetryState];


export const EbaySyncIssueRetryResultRetryState = {
  ready: 'ready',
  complete: 'complete',
} as const;

export interface EbaySyncIssueRetryResult {
  ok: boolean;
  kind: EbaySyncIssueRetryResultKind;
  retryState: EbaySyncIssueRetryResultRetryState;
  saleOrderId?: string | null;
  message?: string | null;
}

export type EbaySyncIssueSuggestionLineCandidatesItem = {
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  confidence: number;
  source: string;
};

export interface EbaySyncIssueSuggestionLine {
  rawTitle: string;
  quantity?: number | null;
  unitPrice?: number | null;
  cleanedTitle?: string | null;
  candidates: EbaySyncIssueSuggestionLineCandidatesItem[];
}

export interface EbaySyncIssueSuggestionsResult {
  issueId: string;
  ebayOrderId: string;
  lines: EbaySyncIssueSuggestionLine[];
}

export type EbaySyncIssueConfirmMappingsBodyMappingsItem = {
  /** @minimum 0 */
  lineIndex: number;
  rawTitle: string;
  inventoryItemId: string;
};

export interface EbaySyncIssueConfirmMappingsBody {
  /** @minItems 1 */
  mappings: EbaySyncIssueConfirmMappingsBodyMappingsItem[];
}

export interface EbaySyncIssueConfirmMappingsResult {
  ok: boolean;
  mappingsSaved: number;
  retryQueued: boolean;
}

export interface EbayDiagnosePullBody {
  sinceISO?: string | null;
}

export type EbayDiagnosePullResultSampleItem = {
  orderId?: string;
  creationDate?: string;
  buyerUsername?: string | null;
  totalAmount?: number;
  currency?: string;
  lineCount?: number;
  status?: string;
  paymentStatus?: string;
};

export interface EbayDiagnosePullResult {
  ok: boolean;
  sinceISO: string;
  count: number;
  message?: string | null;
  sample?: EbayDiagnosePullResultSampleItem[];
}

export interface ChannelPerformance {
  channel: string;
  orders: number;
  revenue: number;
  profit: number;
  margin: number;
}

/**
 * Which consignment workflow this supplier uses for ALL of their stock:
 * PER_ITEM = classic per-line payout snapshot.
 * BATCH_RECOVERY = capital-recovery batches; payouts tracked as a
 * supplier-level liability on the Batch Consignment dashboard, not per sale line.
 */
export type SupplierInputConsignmentMode = typeof SupplierInputConsignmentMode[keyof typeof SupplierInputConsignmentMode];


export const SupplierInputConsignmentMode = {
  PER_ITEM: 'PER_ITEM',
  BATCH_RECOVERY: 'BATCH_RECOVERY',
} as const;

export interface SupplierInput {
  name: string;
  contactPerson?: string | null;
  email?: string | null;
  phone?: string | null;
  country?: string | null;
  website?: string | null;
  supplierType?: string | null;
  paymentTerms?: string | null;
  defaultCurrency?: string | null;
  defaultShippingMethod?: string | null;
  rating?: number | null;
  active?: boolean;
  autoSendPo?: boolean;
  notes?: string | null;
  /** Whether this supplier acts as a consignor. */
  isConsignmentSupplier?: boolean;
  /**
     * Which consignment workflow this supplier uses for ALL of their stock:
     * PER_ITEM = classic per-line payout snapshot.
     * BATCH_RECOVERY = capital-recovery batches; payouts tracked as a
     * supplier-level liability on the Batch Consignment dashboard, not per sale line.
     */
  consignmentMode?: SupplierInputConsignmentMode;
}

export type Supplier = SupplierInput & {
  id: string;
  createdAt: string;
};

export type SupplierWithStats = Supplier & ({
  totalSpend: number | null;
  totalItems: number | null;
  openOrders: number | null;
  avgMargin?: number | null;
});

export type SupplierPurchaseOrderFeeAllocation = { [key: string]: unknown } | null;

export interface SupplierPurchaseOrder {
  id: string;
  poNumber: string;
  supplierId: string | null;
  purchaseDate: string;
  expectedDeliveryDate: string | null;
  actualDeliveryDate: string | null;
  currency: string | null;
  paymentMethod?: string | null;
  paymentStatus?: string | null;
  orderStatus: string;
  exchangeRateGbp?: number | null;
  shippingCost?: number | null;
  insuranceCost?: number | null;
  importVat?: number | null;
  customsFee?: number | null;
  otherFees?: number | null;
  feeAllocation?: SupplierPurchaseOrderFeeAllocation;
  subtotal: number | null;
  totalFees: number | null;
  grandTotal: number | null;
  itemCount: number | null;
  notes?: string | null;
}

export type SupplierDetail = SupplierWithStats & {
  recentPurchases?: SupplierPurchaseOrder[];
};

export type SupplierDirectoryPagePeriod = typeof SupplierDirectoryPagePeriod[keyof typeof SupplierDirectoryPagePeriod];


export const SupplierDirectoryPagePeriod = {
  '30d': '30d',
  '90d': '90d',
  year: 'year',
  lifetime: 'lifetime',
} as const;

export type SupplierDirectoryPagePreparationState = typeof SupplierDirectoryPagePreparationState[keyof typeof SupplierDirectoryPagePreparationState];


export const SupplierDirectoryPagePreparationState = {
  ready: 'ready',
  insufficient_data: 'insufficient_data',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type SupplierDirectoryPagePreparationAvailability = typeof SupplierDirectoryPagePreparationAvailability[keyof typeof SupplierDirectoryPagePreparationAvailability];


export const SupplierDirectoryPagePreparationAvailability = {
  available: 'available',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type SupplierDirectoryPagePreparation = {
  state: SupplierDirectoryPagePreparationState;
  availability: SupplierDirectoryPagePreparationAvailability;
};

export type SupplierDirectoryPageSummary = {
  totalSuppliers: number;
  activeSuppliers: number;
  periodSpend: number | null;
  periodItems: number | null;
  openPoCount: number | null;
  openPoValue: number | null;
};

export type SupplierDirectoryRowPeriod = typeof SupplierDirectoryRowPeriod[keyof typeof SupplierDirectoryRowPeriod];


export const SupplierDirectoryRowPeriod = {
  '30d': '30d',
  '90d': '90d',
  year: 'year',
  lifetime: 'lifetime',
} as const;

export type SupplierDirectoryRow = Supplier & ({
  poCount?: number | null;
  openOrders?: number | null;
  completedCount?: number | null;
  totalSpend?: number | null;
  totalItems?: number | null;
  period?: SupplierDirectoryRowPeriod;
  periodSpend?: number | null;
  periodItems?: number | null;
  periodOpenOrders?: number | null;
  openPoValue?: number | null;
  onTimeRate?: number | null;
  deliveryReliability?: string;
  state: string;
  availability: string;
  refreshedAt?: string | null;
  /** Latest purchase-order date across the supplier lifetime; independent of the selected period. */
  lastOrderAt: string | null;
});

export interface SupplierDirectoryPage {
  data: SupplierDirectoryRow[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
  period: SupplierDirectoryPagePeriod;
  preparation: SupplierDirectoryPagePreparation;
  summary: SupplierDirectoryPageSummary;
}

export type SupplierSummaryResponseSummaryHealth = typeof SupplierSummaryResponseSummaryHealth[keyof typeof SupplierSummaryResponseSummaryHealth];


export const SupplierSummaryResponseSummaryHealth = {
  healthy: 'healthy',
  insufficient_data: 'insufficient_data',
} as const;

export type SupplierSummaryResponseSummaryState = typeof SupplierSummaryResponseSummaryState[keyof typeof SupplierSummaryResponseSummaryState];


export const SupplierSummaryResponseSummaryState = {
  ready: 'ready',
  insufficient_data: 'insufficient_data',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type SupplierSummaryResponseSummaryAvailability = typeof SupplierSummaryResponseSummaryAvailability[keyof typeof SupplierSummaryResponseSummaryAvailability];


export const SupplierSummaryResponseSummaryAvailability = {
  available: 'available',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type SupplierSummaryResponseSummary = {
  totalSpend: number | null;
  totalItems: number | null;
  poCount: number | null;
  openOrders: number | null;
  completedCount: number | null;
  totalOrdered: number | null;
  totalReceived: number | null;
  averageLeadTimeDays: number | null;
  onTimeRate: number | null;
  health: SupplierSummaryResponseSummaryHealth;
  state: SupplierSummaryResponseSummaryState;
  availability: SupplierSummaryResponseSummaryAvailability;
  refreshedAt: string | null;
  lastOrderAt: string | null;
};

export type SupplierMonthlyFactAvailability = typeof SupplierMonthlyFactAvailability[keyof typeof SupplierMonthlyFactAvailability];


export const SupplierMonthlyFactAvailability = {
  available: 'available',
  unavailable: 'unavailable',
} as const;

export interface SupplierMonthlyFact {
  month: string;
  poCount: number;
  completedCount: number;
  itemCount: number;
  totalOrdered: number;
  totalReceived: number;
  spendGbp: number | null;
  averageLeadTimeDays: number | null;
  onTimeRate: number | null;
  availability: SupplierMonthlyFactAvailability;
  refreshedAt: string;
}

export interface SupplierSummaryResponse {
  supplier: Supplier | null;
  summary: SupplierSummaryResponseSummary;
  recentOrders: SupplierPurchaseOrder[];
  monthly: SupplierMonthlyFact[];
}

export interface SupplierMonthlyPage {
  data: SupplierMonthlyFact[];
  page: number;
  pageSize: number;
  total: number;
}

export interface SupplierProduct {
  id: string;
  purchaseOrderId: string;
  poNumber: string;
  purchaseDate: string;
  productTitle: string;
  sku: string | null;
  quantity: number;
  quantityReceived: number;
  currency: string | null;
  unitCost: number | null;
  gbpUnitCostManual: number | null;
}

export type SupplierDocumentAction = typeof SupplierDocumentAction[keyof typeof SupplierDocumentAction];


export const SupplierDocumentAction = {
  download: 'download',
  unavailable: 'unavailable',
} as const;

export interface SupplierDocument {
  id: string;
  documentType: string;
  documentNumber: string | null;
  title: string;
  sourceRecordId: string;
  outputFormat: string;
  status: string;
  objectPath: string | null;
  downloadUrl: string | null;
  action: SupplierDocumentAction;
  createdAt: string;
}

export interface SupplierConsignment {
  id: string;
  sku: string | null;
  productTitle: string;
  quantity: number;
  quantityAvailable: number;
  supplierPayoutPrice: number | null;
  landedUnitCost: number | null;
}

export interface SupplierPurchaseOrderPage {
  data: SupplierPurchaseOrder[];
  page: number;
  pageSize: number;
  total: number;
}

export interface SupplierProductPage {
  data: SupplierProduct[];
  page: number;
  pageSize: number;
  total: number;
}

export interface SupplierPricingPage {
  data: SupplierProduct[];
  page: number;
  pageSize: number;
  total: number;
}

export interface SupplierDocumentPage {
  data: SupplierDocument[];
  page: number;
  pageSize: number;
  total: number;
}

export interface SupplierConsignmentPage {
  data: SupplierConsignment[];
  page: number;
  pageSize: number;
  total: number;
}

export interface SupplierSettings {
  autoSendPo: boolean;
  defaultCurrency: string | null;
  defaultShippingMethod: string | null;
  paymentTerms: string | null;
  isConsignmentSupplier: boolean;
  consignmentMode: string;
}

export interface PurchaseOrderItemInput {
  productTitle: string;
  brand?: string | null;
  /** Normalized server-resolved group brand key. Linked children use their master's key. */
  groupBrandKey?: string;
  /** Normalized server-resolved group title key. Linked children use their master's key. */
  groupTitleKey?: string;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  purity?: string | null;
  /** @minimum 1 */
  quantity: number;
  unitCost: number;
  estimatedResalePrice?: number | null;
  /** Manual GBP unit-cost override (used when useManualGbp is true) */
  gbpUnitCostManual?: number | null;
  useManualGbp?: boolean | null;
  sku?: string | null;
  /** Existing product master selected for this PO line. Null keeps the legacy free-text path. */
  inventoryItemId?: string | null;
  serialNumber?: string | null;
  /** Positive whole-number maximum mintage; paired with structuredProductFields.maximumMintage on write. Blank clears both. */
  mintage?: string | null;
  /** Year of issue (for coins / dated bullion). */
  year?: number | null;
  condition?: string | null;
  conditionFlags?: string[] | null;
  notes?: string | null;
}

export type PurchaseOrderItem = PurchaseOrderItemInput & ({
  id: string;
  /** ID of the supplier invoice this line came from. Always populated for items created after the multi-invoice feature shipped. */
  sourceInvoiceId?: string | null;
  totalCost: number;
  allocatedFees: number;
  /** Landed unit cost in PO currency (legacy) */
  landedUnitCost: number;
  /** Final landed unit cost in GBP (null until landed-cost is finalised) */
  landedUnitCostGbp?: number | null;
  quantityReceived: number;
  /** @nullable */
  destinationSkuCode: string | null;
  /** @nullable */
  destinationSkuName: string | null;
  /** @nullable */
  destinationSkuCompositeImageUrl: string | null;
  /** @nullable */
  destinationSkuPrimaryImageUrl: string | null;
  /** @nullable */
  destinationSkuImageRevision: string | null;
});

export interface PurchaseOrderInvoiceInput {
  invoiceNumber?: string | null;
  invoiceDate?: string | null;
  currency?: string | null;
  subtotal?: number | null;
  total?: number | null;
  fileUrl?: string | null;
  /** Sealed short-lived invoice upload reference used only while creating a new purchase order. */
  uploadReference?: string | null;
  notes?: string | null;
  /** Raw OCR/Claude extraction JSON, kept for audit only. */
  rawExtractedData?: unknown | null;
  items: PurchaseOrderItemInput[];
}

export interface PurchaseOrderInput {
  supplierId: string;
  purchaseDate: string;
  expectedDeliveryDate?: string | null;
  actualDeliveryDate?: string | null;
  currency?: string | null;
  exchangeRateGbp?: number | null;
  paymentMethod?: string | null;
  paymentStatus?: string | null;
  orderStatus?: string | null;
  shippingCost?: number | null;
  insuranceCost?: number | null;
  importVat?: number | null;
  customsFee?: number | null;
  otherFees?: number | null;
  /** even | by_value | manual */
  feeAllocation?: string | null;
  notes?: string | null;
  /** When true, this PO uses an international courier; surfaces the international shipping section. */
  isInternational?: boolean | null;
  courier?: string | null;
  waybillNumber?: string | null;
  trackingNumber?: string | null;
  trackingLink?: string | null;
  internationalNotes?: string | null;
  /**
     * Top-level items for backwards compatibility. When `invoices` is
     * provided, items inside each invoice take precedence and the
     * top-level array is ignored.
     */
  items: PurchaseOrderItemInput[];
  /**
     * Multi-invoice POs: one PO can group N supplier invoices. When
     * provided, each invoice carries its own metadata + items, and the
     * backend wires every item's source_invoice_id automatically. If
     * omitted, the backend creates one synthetic invoice from the PO
     * header so the invariant "every item has a source invoice" still
     * holds.
     */
  invoices?: PurchaseOrderInvoiceInput[] | null;
}

export interface PurchaseOrderInvoice {
  id: string;
  purchaseOrderId: string;
  supplierId?: string | null;
  invoiceNumber?: string | null;
  invoiceDate?: string | null;
  currency: string;
  subtotal: number;
  total: number;
  fileUrl?: string | null;
  notes?: string | null;
  itemCount: number;
  createdAt?: string | null;
}

/**
 * Partial update for an existing PO. All fields optional; only provided fields are mutated.
 */
export interface PurchaseOrderUpdateInput {
  supplierId?: string;
  purchaseDate?: string;
  expectedDeliveryDate?: string | null;
  actualDeliveryDate?: string | null;
  currency?: string | null;
  exchangeRateGbp?: number | null;
  paymentMethod?: string | null;
  paymentStatus?: string | null;
  orderStatus?: string | null;
  shippingCost?: number | null;
  insuranceCost?: number | null;
  importVat?: number | null;
  customsFee?: number | null;
  otherFees?: number | null;
  feeAllocation?: string | null;
  notes?: string | null;
  isInternational?: boolean | null;
  courier?: string | null;
  waybillNumber?: string | null;
  trackingNumber?: string | null;
  trackingLink?: string | null;
  internationalNotes?: string | null;
}

/**
 * Status of the linked shipment group, for the PO list badge.
 */
export type PurchaseOrderShipmentGroupStatus = typeof PurchaseOrderShipmentGroupStatus[keyof typeof PurchaseOrderShipmentGroupStatus] | null;


export const PurchaseOrderShipmentGroupStatus = {
  AWAITING_SHIP: 'AWAITING_SHIP',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  FINALISED: 'FINALISED',
} as const;

export interface PurchaseOrder {
  id: string;
  poNumber: string;
  supplierId: string;
  supplierName?: string | null;
  /** Supplier's country at the time the PO is read. Used to auto-suggest international shipping. */
  supplierCountry?: string | null;
  purchaseDate: string;
  expectedDeliveryDate?: string | null;
  actualDeliveryDate?: string | null;
  currency: string;
  exchangeRateGbp?: number | null;
  paymentMethod?: string | null;
  paymentStatus: string;
  orderStatus: string;
  shippingCost?: number;
  insuranceCost?: number;
  importVat?: number;
  customsFee?: number;
  otherFees?: number;
  feeAllocation?: string;
  subtotal: number;
  totalFees: number;
  grandTotal: number;
  itemCount?: number;
  notes?: string | null;
  /** ISO timestamp when this PO was last emailed to the supplier. */
  sentAt?: string | null;
  /** Email address the PO was last sent to. */
  sentTo?: string | null;
  /** Provider message ID (Gmail) of the last successful send. */
  sentMessageId?: string | null;
  /** True when GBP fees have been modified since last cost recalculation. */
  needsCostRecalc?: boolean;
  /** ISO timestamp when late costs were last modified on this PO. */
  lateCostModifiedAt?: string | null;
  gbpPaid?: number | null;
  paidAt?: string | null;
  gbpShipping?: number | null;
  gbpInsurance?: number | null;
  gbpImportVat?: number | null;
  gbpCustoms?: number | null;
  gbpBankFees?: number | null;
  gbpOtherCosts?: number | null;
  /** even | by_value | manual */
  landedAllocation?: string | null;
  landedAt?: string | null;
  /** gbpPaid / foreign-currency invoice subtotal (computed) */
  effectiveFxRate?: number | null;
  /** Final landed cost in GBP (sum of GBP unit costs × qty + GBP fees), null until finalised */
  grandTotalGbp?: number | null;
  /** When true, the PO uses an international courier and the international shipping section is shown. */
  isInternational?: boolean;
  courier?: string | null;
  waybillNumber?: string | null;
  trackingNumber?: string | null;
  trackingLink?: string | null;
  internationalNotes?: string | null;
  /** Invoice numbers associated with this PO (list endpoint only). */
  invoiceNumbers?: string[];
  /** When set, this PO is part of a shipment group; per-PO GBP cost fields are zeroed until the group is finalised. */
  shipmentGroupId?: string | null;
  /** Denormalised shipment group reference (e.g. SG-00012) for the PO list badge. */
  shipmentGroupReference?: string | null;
  /** Status of the linked shipment group, for the PO list badge. */
  shipmentGroupStatus?: PurchaseOrderShipmentGroupStatus;
}

export type PurchaseOrderListItem = PurchaseOrder & {
  /** @minimum 0 */
  allocatedLineCount: number;
  /** @minimum 0 */
  unallocatedLineCount: number;
};

/**
 * One of: Draft, Invoice Logged, Paid, Shipped, In Transit, Landed, Completed
 */
export type PurchaseOrderStatusInputOrderStatus = typeof PurchaseOrderStatusInputOrderStatus[keyof typeof PurchaseOrderStatusInputOrderStatus];


export const PurchaseOrderStatusInputOrderStatus = {
  Draft: 'Draft',
  Invoice_Logged: 'Invoice Logged',
  Paid: 'Paid',
  Shipped: 'Shipped',
  In_Transit: 'In Transit',
  Landed: 'Landed',
  Completed: 'Completed',
} as const;

export interface PurchaseOrderStatusInput {
  /** One of: Draft, Invoice Logged, Paid, Shipped, In Transit, Landed, Completed */
  orderStatus: PurchaseOrderStatusInputOrderStatus;
}

/**
 * Patch payload for editing one PO line item. Every field is optional;
 * only fields actually present are touched. Pass `confirmFinalisedEdit`
 * when the parent PO is in "Landed" or "Completed" status.
 */
export interface PurchaseOrderLineItemUpdate {
  productTitle?: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  purity?: string | null;
  /** New ordered quantity. Must be >= quantityReceived. */
  quantity?: number;
  unitCost?: number;
  estimatedResalePrice?: number | null;
  gbpUnitCostManual?: number | null;
  useManualGbp?: boolean | null;
  sku?: string | null;
  serialNumber?: string | null;
  mintage?: string | null;
  condition?: string | null;
  conditionFlags?: string[] | null;
  notes?: string | null;
  /** Required (true) when the parent PO is Landed or Completed. */
  confirmFinalisedEdit?: boolean | null;
}

export interface PurchaseOrderDestinationSkuUpdate {
  /** @nullable */
  inventoryItemId: string | null;
}

export interface PurchaseOrderRecentDestinationSku {
  id: string;
  sku: string;
  productTitle: string;
  /** @nullable */
  compositePhotoUrl: string | null;
  /** @nullable */
  photoUrl: string | null;
  /** @nullable */
  imageRevision: string | null;
}

export interface PurchaseOrderRecentDestinationSkus {
  /** @maxItems 6 */
  items: PurchaseOrderRecentDestinationSku[];
}

export interface PurchaseOrderDestinationSkuRecommendation {
  /**
     * @minimum 1
     * @maximum 3
     */
  rank: number;
  inventoryItemId: string;
  skuCode: string;
  name: string;
  /** @maxLength 240 */
  rationale: string;
  /** @nullable */
  compositeImageUrl: string | null;
  /** @nullable */
  primaryImageUrl: string | null;
}

export interface PurchaseOrderDestinationSkuRecommendations {
  purchaseOrderItemId: string;
  /** @maxItems 3 */
  recommendations: PurchaseOrderDestinationSkuRecommendation[];
}

export type LandedCostInputItemsItem = {
  id: string;
  gbpUnitCostManual?: number | null;
  useManualGbp?: boolean | null;
};

export interface LandedCostInput {
  gbpPaid?: number | null;
  paidAt?: string | null;
  gbpShipping?: number | null;
  gbpInsurance?: number | null;
  gbpImportVat?: number | null;
  gbpCustoms?: number | null;
  gbpBankFees?: number | null;
  gbpOtherCosts?: number | null;
  /** even | by_value | manual */
  landedAllocation?: string | null;
  /** If true, advance orderStatus to "Landed". */
  markLanded?: boolean | null;
  /** Optional per-item GBP overrides */
  items?: LandedCostInputItemsItem[] | null;
}

/**
 * @nullable
 */
export type PurchaseOrderReceiptLotAllocationVatSnapshot = { [key: string]: unknown } | null;

export interface PurchaseOrderReceiptLotAllocation {
  id: string;
  receiptId: string;
  purchaseOrderItemId: string;
  inventoryItemId: string;
  lotId: string;
  /** @nullable */
  lotRef?: string | null;
  /** @minimum 1 */
  quantityReceived: number;
  mergedIntoExistingLot: boolean;
  supplierCurrency: string;
  /** @nullable */
  originalSupplierUnitCost?: number | null;
  /** @nullable */
  landedUnitCostGbp: number | null;
  /** @nullable */
  allocatedShippingGbp?: number | null;
  /** @nullable */
  allocatedInsuranceGbp?: number | null;
  /** @nullable */
  allocatedCustomsGbp?: number | null;
  /** @nullable */
  allocatedImportVatGbp?: number | null;
  /** @nullable */
  allocatedBankFeesGbp?: number | null;
  /** @nullable */
  allocatedOtherCostsGbp?: number | null;
  allocationMethod: string;
  /** @nullable */
  vatSnapshot?: PurchaseOrderReceiptLotAllocationVatSnapshot;
  createdAt: string;
}

export interface PurchaseOrderCurrencyEvidence {
  id: string;
  fromCurrency: string;
  toCurrency: string;
  /**
     * Amount of toCurrency represented by one fromCurrency unit.
     * @exclusiveMinimum 0
     */
  rate: number;
  effectiveAt: string;
  source: string;
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  createdAt?: string | null;
}

export type PurchaseOrderDetail = PurchaseOrder & {
  items: PurchaseOrderItem[];
  invoices: PurchaseOrderInvoice[];
  /** Immutable lot outcomes for new receipts. Empty for legacy receipts. */
  receiptLotAllocations: PurchaseOrderReceiptLotAllocation[];
  /** Authoritative PO-scoped conversion evidence for legacy payment comparisons. */
  currencyEvidence?: PurchaseOrderCurrencyEvidence[];
};

export interface PurchaseOrderCurrencyEvidenceInput {
  /**
     * @minLength 3
     * @maxLength 8
     */
  fromCurrency: string;
  /**
     * @minLength 3
     * @maxLength 8
     */
  toCurrency: string;
  /** @exclusiveMinimum 0 */
  rate: number;
  effectiveAt: string;
  /**
     * @minLength 1
     * @maxLength 500
     */
  source: string;
  /**
     * @maxLength 500
     * @nullable
     */
  reference?: string | null;
  /**
     * @maxLength 2000
     * @nullable
     */
  note?: string | null;
}

/**
 * `VAT_EXEMPT_GOLD` — "VAT EXEMPT" (investment gold).
 * `MARGIN_SCHEME` — "MARGIN SCHEME — VAT ON MARGIN" (20% of the
 * margin; requires a qualifying purchase price).
 * `STANDARD_VAT` — "VATABLE — 20%".
 */
export type AcquisitionVatInputTreatment = typeof AcquisitionVatInputTreatment[keyof typeof AcquisitionVatInputTreatment];


export const AcquisitionVatInputTreatment = {
  VAT_EXEMPT_GOLD: 'VAT_EXEMPT_GOLD',
  MARGIN_SCHEME: 'MARGIN_SCHEME',
  STANDARD_VAT: 'STANDARD_VAT',
} as const;

/**
 * The VAT position an operator confirms for ONE physical acquisition
 * (VAT Phase 2A). The product-level VAT fields are only ever a
 * *suggested default* used to prefill this — the acquisition's own
 * confirmed values are what the books are built from, and they are
 * never changed retrospectively by editing the product.
 *
 * Required when the tenant has "Require VAT classification before new
 * stock becomes available" switched on. While that setting is off the
 * field is optional and an incomplete payload is returned as a warning
 * instead of blocking the receipt.
 */
export interface AcquisitionVatInput {
  /**
     * `VAT_EXEMPT_GOLD` — "VAT EXEMPT" (investment gold).
     * `MARGIN_SCHEME` — "MARGIN SCHEME — VAT ON MARGIN" (20% of the
     * margin; requires a qualifying purchase price).
     * `STANDARD_VAT` — "VATABLE — 20%".
     */
  treatment: AcquisitionVatInputTreatment;
  /**
     * Must be `true`. A prefilled suggestion is NOT a confirmation: the
     * operator has to actively accept it, so a payload echoed back
     * unchanged with `confirmed: false` is refused.
     */
  confirmed: boolean;
  /**
     * Basis points (2000 = 20%). Defaults to the rate implied by the
     * treatment. Supplying a contradictory rate is always an error,
     * even while enforcement is off.
     * @minimum 0
     * @maximum 10000
     */
  vatRateBasisPoints?: number | null;
  /**
     * Margin Scheme only, and required for it: the qualifying purchase
     * price per unit in whole pence. This is the price actually paid for
     * the goods — it is never derived from landed cost and never
     * includes fees, courier, refurbishment or overhead.
     * @minimum 0
     */
  qualifyingVatUnitPurchasePricePence?: number | null;
  /**
     * Where the goods came from (Margin Scheme requires a source).
     * @maxLength 200
     */
  purchaseSource?: string | null;
  /**
     * Who they were bought from (Margin Scheme requires a seller).
     * @maxLength 500
     */
  sellerName?: string | null;
  /**
     * @maxLength 64
     * @nullable
     */
  sellerVatStatus?: string | null;
  /**
     * Invoice / receipt / PO reference proving the position. On a PO
     * receipt the PO number already satisfies this.
     * @maxLength 500
     */
  evidenceReference?: string | null;
  /**
     * Required for `VAT_EXEMPT_GOLD` — why the goods are exempt.
     * @maxLength 1000
     */
  exemptionReason?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  invoiceReference?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  purchaseOrderNumber?: string | null;
  /** @maxLength 2000 */
  note?: string | null;
  /** @nullable */
  imported?: boolean | null;
  /**
     * @minimum 0
     * @nullable
     */
  importVatPaidPence?: number | null;
}

export type ReceiveStockInputItemVatItem = {
  purchaseOrderItemId: string;
  vat: AcquisitionVatInput;
};

export type ReceiveStockInputItemDestinationsItemNewSku = {
  /**
     * @minLength 1
     * @maxLength 200
     */
  sku: string;
  /**
     * @minLength 1
     * @maxLength 500
     */
  productTitle?: string;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  productType?: string | null;
  /** @nullable */
  metal?: string | null;
};

export type ReceiveStockInputItemDestinationsItem = {
  purchaseOrderItemId: string;
  inventoryItemId?: string;
  newSku?: ReceiveStockInputItemDestinationsItemNewSku;
};

export type ReceiveStockInputItemsItem = {
  purchaseOrderItemId: string;
  /** @minimum 1 */
  quantityReceived: number;
  storageLocation?: string | null;
  serialNumber?: string | null;
  conditionFlags?: string[] | null;
  notes?: string | null;
  lengthCm?: number | null;
  widthCm?: number | null;
  heightCm?: number | null;
  weightGrams?: number | null;
};

export interface ReceiveStockInput {
  /**
     * Client-generated idempotency key for this receipt submission.
     * @maxLength 120
     */
  receiptKey?: string | null;
  actualDeliveryDate?: string | null;
  /** Must be true when this receipt makes a line's total received quantity exceed its original ordered quantity. */
  confirmOverDelivery?: boolean;
  /**
     * VAT Phase 2A — the VAT treatment the operator confirmed for each
     * receipt line, keyed by `purchaseOrderItemId`. The PO line's
     * suggested treatment only prefills the form; what lands on the lot
     * is what was confirmed here. Required for every positive line when
     * the tenant enforces acquisition VAT classification — a refusal
     * rolls back the whole receipt, which can then be retried with the
     * same `receiptKey`.
     */
  itemVat?: ReceiveStockInputItemVatItem[] | null;
  /** Optional receipt-time product destinations. Each line may choose an existing product or atomically create one new parent SKU. */
  itemDestinations?: ReceiveStockInputItemDestinationsItem[] | null;
  items: ReceiveStockInputItemsItem[];
}

export interface ParsedInvoiceItem {
  productTitle: string;
  brand?: string | null;
  metal?: string | null;
  quantity: number;
  unitCost: number;
}

/**
 * How the currency was determined. Only "explicit" is fully trustworthy without user review.
 */
export type ParsedInvoiceCurrencyConfidence = typeof ParsedInvoiceCurrencyConfidence[keyof typeof ParsedInvoiceCurrencyConfidence];


export const ParsedInvoiceCurrencyConfidence = {
  explicit: 'explicit',
  inferred_from_supplier: 'inferred_from_supplier',
  inferred_from_symbol: 'inferred_from_symbol',
  fallback: 'fallback',
} as const;

export interface ParsedInvoice {
  supplierName?: string | null;
  supplierEmail?: string | null;
  supplierCountry?: string | null;
  /** ID of the matching supplier in the database, if one was found by fuzzy name match. */
  matchedSupplierId?: string | null;
  invoiceNumber?: string | null;
  invoiceDate?: string | null;
  currency: string;
  /** How the currency was determined. Only "explicit" is fully trustworthy without user review. */
  currencyConfidence: ParsedInvoiceCurrencyConfidence;
  paymentMethod?: string | null;
  items: ParsedInvoiceItem[];
  shippingCost: number;
  insuranceCost: number;
  importVat: number;
  customsFee: number;
  otherFees: number;
  subtotal?: number | null;
  grandTotal?: number | null;
  notes?: string | null;
  warnings: string[];
}

/**
 * OWNED = we paid for the stock (profit = sale - landed cost).
 * CONSIGNMENT = supplier-owned, we owe supplierPayoutPrice on sale (profit = sale - supplierPayoutPrice).
 * Defaults to OWNED.
 */
export type InventoryItemInputStockType = typeof InventoryItemInputStockType[keyof typeof InventoryItemInputStockType] | null;


export const InventoryItemInputStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

/**
 * How the supplier is paid when this consignment item sells. Required when stockType = CONSIGNMENT.
 * FIXED_PER_UNIT  → supplier owed = supplierPayoutPrice * quantity sold.
 * PROFIT_SPLIT_PCT → supplier owed per unit = landedUnitCost + supplierSplit% * max(0, salePrice - landedUnitCost).
 * Snapshotted onto every sale line so changing terms later only affects future sales.
 * Post-May 2026: the PROFIT_SPLIT supplier floor / base cost is `landedUnitCost` (single source of truth — the dedicated `consignmentBaseCostGbp` inventory column was retired). Historic sale_order_items snapshots retain their original `consignmentBaseCostGbp`.
 */
export type InventoryItemInputConsignmentPayoutType = typeof InventoryItemInputConsignmentPayoutType[keyof typeof InventoryItemInputConsignmentPayoutType] | null;


export const InventoryItemInputConsignmentPayoutType = {
  FIXED_PER_UNIT: 'FIXED_PER_UNIT',
  PROFIT_SPLIT_PCT: 'PROFIT_SPLIT_PCT',
} as const;

export type StructuredProductDimensionUnit = typeof StructuredProductDimensionUnit[keyof typeof StructuredProductDimensionUnit];


export const StructuredProductDimensionUnit = {
  mm: 'mm',
  cm: 'cm',
  in: 'in',
} as const;

export interface StructuredProductDimension {
  /** @exclusiveMinimum 0 */
  value: number;
  unit: StructuredProductDimensionUnit;
}

export interface InventorySeoContent {
  /** @maxLength 320 */
  shortDescription?: string | null;
  /** @maxLength 200 */
  subtitle?: string | null;
  /**
     * @maxItems 20
     * @items.minLength 1
     * @items.maxLength 80
     */
  keywords?: string[] | null;
  /** @maxLength 120 */
  urlSlug?: string | null;
  /** @maxLength 200 */
  seoTitle?: string | null;
  /** @maxLength 500 */
  seoDescription?: string | null;
}

export type InventorySeoReadinessImageAltStatus = typeof InventorySeoReadinessImageAltStatus[keyof typeof InventorySeoReadinessImageAltStatus];


export const InventorySeoReadinessImageAltStatus = {
  unavailable: 'unavailable',
} as const;

export type InventorySeoReadinessBreakdownItem = {
  label: string;
  /** @minimum 0 */
  score: number;
  /** @minimum 0 */
  maxScore: number;
  reason: string;
};

export interface InventorySeoReadiness {
  /**
     * @minimum 0
     * @maximum 100
     */
  score: number;
  /** @minimum 1 */
  productInformationVersion: number;
  analyzedAt: string;
  breakdown: InventorySeoReadinessBreakdownItem[];
  reasons: string[];
  recommendations: string[];
  imageAltStatus: InventorySeoReadinessImageAltStatus;
}

export interface StructuredProductFields {
  mint?: string | null;
  metalContent?: string | null;
  series?: string | null;
  finish?: string | null;
  specialFeatures?: string[];
  issuingCountry?: string | null;
  faceValue?: string | null;
  diameter?: StructuredProductDimension | null;
  /** @minimum 1 */
  maximumMintage?: number | null;
  packagingSummary?: string | null;
  highlights?: string | null;
  designDetails?: string | null;
  seriesBackground?: string | null;
  packaging?: string | null;
  conditionNotes?: string | null;
  careStorage?: string | null;
  thickness?: StructuredProductDimension | null;
  length?: StructuredProductDimension | null;
  width?: StructuredProductDimension | null;
  /** @minimum 0 */
  grossWeightG?: number | null;
  /** @minimum 0 */
  setQuantity?: number | null;
  /** @minimum 0 */
  editionLimit?: number | null;
  privyMark?: string | null;
  designer?: string | null;
  gradingCompany?: string | null;
  grade?: string | null;
  certificationNumber?: string | null;
  seoContent?: InventorySeoContent | null;
  readonly seoReadiness?: InventorySeoReadiness | null;
}

export interface ShopifyMetafield {
  /** Shopify metafield namespace (e.g. "custom", "specs"). */
  namespace: string;
  /** Shopify metafield key (must be unique within namespace). */
  key: string;
  /** Shopify metafield type (e.g. single_line_text_field, number_integer, url, json, file_reference). */
  type: string;
  /** Stringified metafield value. JSON / number values are still stringified per Shopify's API contract. */
  value: string;
}

/**
 * Per-item WooCommerce push overrides. Any field left null/omitted/empty
 * falls back to the inventory row's default (productTitle, descriptionHtml,
 * composite+photoUrls, no categories/brands/tags). `photoUrls` here
 * REPLACES the default composite+photoUrls when non-empty.
 */
export interface WooOverrides {
  /** WC-only product name. Falls back to `productTitle` when null/empty. */
  nameOverride?: string | null;
  /** WC-only description (HTML). Falls back to `descriptionHtml` / `shopifyBodyHtml` when null/empty. */
  descriptionOverride?: string | null;
  /** When set and non-empty, REPLACES the default composite+photoUrls for the WC push. */
  photoUrls?: string[] | null;
  /** WC product category IDs (taxonomy `product_cat`). */
  categoryIds?: number[] | null;
  /** WC brand taxonomy term IDs (native WC 9.6+ brands taxonomy). */
  brandIds?: number[] | null;
  /** WC product tag names (sent by name; WC creates missing tags on the fly). */
  tags?: string[] | null;
  /** WC-only spec override. Falls back to the inventory-row `metal` when null/empty. */
  metal?: string | null;
  /** WC-only spec override. Falls back to the inventory-row `purity` when null/empty. */
  purity?: string | null;
  /** WC-only spec override. Falls back to the inventory-row `productType` when null/empty. */
  productType?: string | null;
  /** WC-only spec override (also drives the WC product "Brand" attribute). Falls back to the inventory-row `brand` when null/empty. */
  brand?: string | null;
  /** WC-only spec override. Falls back to the inventory-row `mintage` when null/empty. */
  mintage?: string | null;
  /** WC-only spec override. Falls back to the inventory-row `condition`/`stockCondition` when null/empty. */
  condition?: string | null;
  /** WC-only spec override. Falls back to the inventory-row `serialNumber` when null/empty. */
  serialNumber?: string | null;
  /** WC-only spec override. Falls back to the inventory-row `assayNumber` when null/empty. */
  assayNumber?: string | null;
  /** WC-only spec override (display weight). Falls back to the inventory-row `weight` when null. */
  weight?: number | null;
  /** WC-only spec override (weight unit, e.g. g/oz). Falls back to the inventory-row `weightUnit` when null/empty. */
  weightUnit?: string | null;
  /** WC-only spec override (shipping weight in grams → native WC product weight). Falls back to the inventory-row `weightGrams` when null. */
  weightGrams?: number | null;
  /** WC-only spec override (native WC product length, cm). Falls back to the inventory-row `lengthCm` when null. */
  lengthCm?: number | null;
  /** WC-only spec override (native WC product width, cm). Falls back to the inventory-row `widthCm` when null. */
  widthCm?: number | null;
  /** WC-only spec override (native WC product height, cm). Falls back to the inventory-row `heightCm` when null. */
  heightCm?: number | null;
  /** WC-only spec override. Falls back to the inventory-row `year` when null. */
  year?: number | null;
}

/**
 * Per-item Shopify-only spec overrides (Task #361). Any field left
 * null/omitted/empty falls back to the inventory row's value. Drives the
 * Shopify variant weight, product vendor/type, the auto-built `custom.*`
 * metafields, and the Google & YouTube channel (`mm-google-shopping.*`)
 * metafields.
 */
export interface ShopifySpecOverrides {
  /** Shopify-only spec override. Falls back to the inventory-row `metal` when null/empty. */
  metal?: string | null;
  /** Shopify-only spec override. Falls back to the inventory-row `purity` when null/empty. */
  purity?: string | null;
  /** Shopify-only spec override (product type). Falls back to the inventory-row `productType` when null/empty. */
  productType?: string | null;
  /** Shopify-only spec override (brand metafield + vendor fallback). Falls back to the inventory-row `brand` when null/empty. */
  brand?: string | null;
  /** Shopify-only spec override. Falls back to the inventory-row `mintage` when null/empty. */
  mintage?: string | null;
  /** Shopify-only spec override. Falls back to the inventory-row `condition`/`stockCondition` when null/empty. */
  condition?: string | null;
  /** Shopify-only spec override. Falls back to the inventory-row `serialNumber` when null/empty. */
  serialNumber?: string | null;
  /** Shopify-only spec override. Falls back to the inventory-row `assayNumber` when null/empty. */
  assayNumber?: string | null;
  /** Shopify-only spec override (variant weight). Falls back to the inventory-row `weight` when null. */
  weight?: number | null;
  /** Shopify-only spec override (variant weight unit). Falls back to the inventory-row `weightUnit` when null/empty. */
  weightUnit?: string | null;
  /** Shopify-only spec override (shipping weight in grams metafield). Falls back to the inventory-row `weightGrams` when null. */
  weightGrams?: number | null;
  /** Shopify-only spec override (length cm metafield). Falls back to the inventory-row `lengthCm` when null. */
  lengthCm?: number | null;
  /** Shopify-only spec override (width cm metafield). Falls back to the inventory-row `widthCm` when null. */
  widthCm?: number | null;
  /** Shopify-only spec override (height cm metafield). Falls back to the inventory-row `heightCm` when null. */
  heightCm?: number | null;
  /** Shopify-only spec override. Falls back to the inventory-row `year` when null. */
  year?: number | null;
}

export type ShopifyFieldStatesVersion = typeof ShopifyFieldStatesVersion[keyof typeof ShopifyFieldStatesVersion];


export const ShopifyFieldStatesVersion = {
  NUMBER_1: 1,
} as const;

/**
 * Explicit source state for a Shopify-mapped field.
 */
export type ShopifyFieldStateMode = typeof ShopifyFieldStateMode[keyof typeof ShopifyFieldStateMode];


export const ShopifyFieldStateMode = {
  inherit: 'inherit',
  override: 'override',
  clear: 'clear',
} as const;

export interface ShopifyFieldState {
  /** Explicit source state for a Shopify-mapped field. */
  mode: ShopifyFieldStateMode;
  /**
     * Required for override; ignored for inherit and clear.
     * @nullable
     */
  value?: string | null | number | boolean;
}

export type ShopifyFieldStatesFields = {[key: string]: ShopifyFieldState};

export interface ShopifyFieldStates {
  version: ShopifyFieldStatesVersion;
  fields: ShopifyFieldStatesFields;
}

/**
 * Record<attributeId, value> of TikTok category-specific attribute values.
 */
export type TikTokOverridesAttributes = {[key: string]: string} | null;

/**
 * Record<attributeId, valueId> of TikTok enumerable value IDs for DROPDOWN/MULTI_SELECT attributes. Parallel to attributes; used to include the value id in product_attributes on push.
 */
export type TikTokOverridesAttributeValueIds = {[key: string]: string} | null;

/**
 * Per-item TikTok Shop listing overrides. Any field left null/omitted falls back to
 * the inventory row's default (productTitle, descriptionHtml, currentAskingPrice). Pass
 * `null` for the whole object to clear all TikTok overrides. `attributes` is a
 * Record<attributeId, value> where keys are TikTok category attribute IDs (as strings)
 * and values are the operator-chosen string values.
 */
export interface TikTokOverrides {
  /** TikTok listing title override. Falls back to `productTitle` when null/empty. */
  title?: string | null;
  /** TikTok listing description override. Falls back to `descriptionHtml` when null/empty. */
  description?: string | null;
  /** TikTok SKU price override in GBP. Falls back to `currentAskingPrice` when null. */
  priceOverride?: number | null;
  /** Record<attributeId, value> of TikTok category-specific attribute values. */
  attributes?: TikTokOverridesAttributes;
  /** Record<attributeId, valueId> of TikTok enumerable value IDs for DROPDOWN/MULTI_SELECT attributes. Parallel to attributes; used to include the value id in product_attributes on push. */
  attributeValueIds?: TikTokOverridesAttributeValueIds;
  /** Explicit image URL ordering override for the TikTok listing. */
  imageOrder?: string[] | null;
  /** Package weight override in kg for TikTok shipping. Falls back to the item weightGrams/1000 when null. */
  packageWeightKg?: number | null;
  /** Package length override in cm for TikTok shipping dimensions. */
  packageLengthCm?: number | null;
  /** Package width override in cm for TikTok shipping dimensions. */
  packageWidthCm?: number | null;
  /** Package height override in cm for TikTok shipping dimensions. */
  packageHeightCm?: number | null;
  /** Brand name to send in the TikTok product payload. TikTok requires a brand on most categories; use "No Brand" when unbranded. */
  brand?: string | null;
  /**
     * Saved selling-format choice for the regular product API. true requests
     * FIXED_PRICE_AND_LIVE_AUCTION; false explicitly requests FIXED_PRICE.
     * Omitted/null preserves the remote format when editing an existing listing and
     * defaults a new listing to FIXED_PRICE. The response-only LIVE_AUCTION value is
     * never accepted as a write choice.
     */
  auctionEnabled?: boolean | null;
  /** Positive GBP starting bid sent as a decimal string when auctionEnabled is true. */
  auctionStartingBid?: number | null;
  /**
     * Pre-order (pre-sale) control for the TikTok listing. When null/omitted the
     * listing is a normal product. Set "auto" to derive pre-order behavior from an
     * active batch, true to force pre-order for items not in a batch (requires
     * preOrderReleaseDate or preOrderHandlingDays), or false to force a normal
     * listing even when a batch link exists.
     */
  preOrderEnabled?: boolean | 'auto' | null;
  /** Expected ship/release date (YYYY-MM-DD) sent in the TikTok pre_sale block. Falls back to the linked pre-order batch item's ETA when null. */
  preOrderReleaseDate?: string | null;
  /** Alternative to preOrderReleaseDate — pre-sale handling window in days (TikTok fulfillment_type.handling_duration_days). */
  preOrderHandlingDays?: number | null;
}

/**
 * Server-derived gate for whether an inventory item can be pushed to
 * Shopify. Used by the inventory list (greys out the bulk-push action
 * per row) and by the synced-products counter (separates "ready to
 * push" from "needs more data"). Server uses the SAME helper to
 * validate before pushing, so a buggy FE can't slip an incomplete
 * item past the gate.
 */
export interface ShopifyEligibility {
  eligible: boolean;
  /** Human-readable labels of fields that need to be filled. Empty when `eligible=true`. */
  missing: string[];
}

/**
 * Position label for a structured product photo.
 *   front      - primary listing image (required when any photos exist)
 *   left       - left side view
 *   right      - right side view
 *   rear       - back of the product
 *   additional - any extra angle / detail / packaging shot
 */
export type InventoryPhotoType = typeof InventoryPhotoType[keyof typeof InventoryPhotoType];


export const InventoryPhotoType = {
  front: 'front',
  left: 'left',
  right: 'right',
  rear: 'rear',
  additional: 'additional',
} as const;

/**
 * Media kind for the photo entry. Defaults to `image`. `video` and `360`
 * are reserved for future support so the photos array can carry mixed
 * media types without another schema migration.
 */
export type InventoryPhotoMediaKind = typeof InventoryPhotoMediaKind[keyof typeof InventoryPhotoMediaKind];


export const InventoryPhotoMediaKind = {
  image: 'image',
  video: 'video',
  NUMBER_360: '360',
} as const;

export interface InventoryPhoto {
  /** Object path returned by the storage upload endpoint (e.g. `/objects/<uuid>`). */
  url: string;
  type: InventoryPhotoType;
  /** Display order within the type group. Lower = earlier. */
  sortOrder: number;
  mediaKind?: InventoryPhotoMediaKind | null;
}

export interface InventoryItemInput {
  /** Canonical MetalUI structured product information. Optional; null clears it. */
  structuredProductFields?: StructuredProductFields | null;
  /**
     * Physical length in cm. Must be > 0 when provided.
     * @minimum 0
     * @exclusiveMinimum
     */
  lengthCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  widthCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  heightCm?: number | null;
  /**
     * Shipping weight in grams. Must be > 0 when provided.
     * @minimum 0
     * @exclusiveMinimum
     */
  weightGrams?: number | null;
  /**
     * OWNED = we paid for the stock (profit = sale - landed cost).
     * CONSIGNMENT = supplier-owned, we owe supplierPayoutPrice on sale (profit = sale - supplierPayoutPrice).
     * Defaults to OWNED.
     */
  stockType?: InventoryItemInputStockType;
  /** Free-text supplier name used for consignment grouping in reports. Independent of supplierId. */
  supplierName?: string | null;
  /** GBP amount owed to the supplier per unit when sold. Required when stockType = CONSIGNMENT and consignmentPayoutType = FIXED_PER_UNIT. */
  supplierPayoutPrice?: number | null;
  /**
     * How the supplier is paid when this consignment item sells. Required when stockType = CONSIGNMENT.
     * FIXED_PER_UNIT  → supplier owed = supplierPayoutPrice * quantity sold.
     * PROFIT_SPLIT_PCT → supplier owed per unit = landedUnitCost + supplierSplit% * max(0, salePrice - landedUnitCost).
     * Snapshotted onto every sale line so changing terms later only affects future sales.
     * Post-May 2026: the PROFIT_SPLIT supplier floor / base cost is `landedUnitCost` (single source of truth — the dedicated `consignmentBaseCostGbp` inventory column was retired). Historic sale_order_items snapshots retain their original `consignmentBaseCostGbp`.
     */
  consignmentPayoutType?: InventoryItemInputConsignmentPayoutType;
  /**
     * Supplier's share of the profit pool (0–100). Required when consignmentPayoutType = PROFIT_SPLIT_PCT. Must sum with consignmentBusinessSplitPct to 100.
     * @minimum 0
     * @maximum 100
     */
  consignmentSupplierSplitPct?: number | null;
  /**
     * Business's share of the profit pool (0–100). Required when consignmentPayoutType = PROFIT_SPLIT_PCT. Must sum with consignmentSupplierSplitPct to 100.
     * @minimum 0
     * @maximum 100
     */
  consignmentBusinessSplitPct?: number | null;
  /**
     * Batch Recovery Consignment: link this item to a capital-recovery batch
     * on a BATCH_RECOVERY-mode supplier. When set, the item's per-unit payout
     * fields are ignored — repayment is tracked on the batch ledger and gross
     * profit accrues to the company in P&L (snapshot path keeps unit cost =
     * landedUnitCost). Required when supplier is BATCH_RECOVERY mode.
     */
  consignmentBatchId?: string | null;
  /** Informational target sale price agreed with the supplier. Used by the inventory form to preview supplier owed and business profit at the agreed price. */
  consignmentTargetSalePriceGbp?: number | null;
  /** Shopify-only override for the product's "Vendor" field. Falls back to `brand` when null. */
  shopifyVendor?: string | null;
  /** Shopify-only comma-separated tag list written verbatim into Shopify's `tags` field. When null, derived from `metal, brand`. */
  shopifyTags?: string | null;
  /** Shopify-only product metafields. Merged with the auto-derived `custom.*` set; user values win on namespace+key collision. */
  shopifyMetafields?: ShopifyMetafield[] | null;
  /** Per-item WooCommerce push overrides. When `photoUrls` is set and non-empty it REPLACES the default composite+photoUrls for the WC push only. Other fields fall back to the inventory-row defaults when null/empty. */
  woocommerceOverrides?: WooOverrides | null;
  /** Per-item Shopify-only spec overrides. Each field wins over the inventory-row value on push; null/empty falls back to the inventory-row value. */
  shopifyOverrides?: ShopifySpecOverrides | null;
  /** Versioned Shopify field states. Use inherit, override, or clear explicitly; this is preferred over legacy shopifyOverrides. */
  shopifyFieldStates?: ShopifyFieldStates | null;
  /** Per-item TikTok Shop listing overrides. Each field wins over the inventory-row value on push; null/missing falls back to the inventory-row value. */
  tiktokOverrides?: TikTokOverrides | null;
  /** Default product description (rich-text HTML). Used by every marketplace push as the body unless that channel has its own override populated. Single source of truth for product copy. */
  descriptionHtml?: string | null;
  /** Shopify-specific description override (HTML). When set, pushed verbatim into `product.body_html`; when null/empty, falls back to `descriptionHtml`. */
  shopifyBodyHtml?: string | null;
  /** eBay-specific description override (HTML). When set, will be used as the eBay listing description on the next push; when null/empty, falls back to `descriptionHtml`. */
  ebayDescriptionHtml?: string | null;
  /** Agoro theme narrative block 1 — pushed as `custom.line_1_description` metafield. */
  shopifyLine1Description?: string | null;
  /** Agoro theme narrative block 2 — pushed as `custom.line_2_description` metafield. */
  shopifyLine2Description?: string | null;
  /** Agoro theme narrative block 3 — pushed as `custom.line_3_description` metafield. */
  shopifyLine3Description?: string | null;
  /** Local category UUIDs. The server mirrors changes to Shopify custom_collections (assign / remove) when a Shopify product id is known for the item. */
  categoryIds?: string[] | null;
  sku?: string | null;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  purity?: string | null;
  /** @minimum 0 */
  quantity: number;
  /**
     * Optional count of units flagged as "Coming Soon" (preorder /
     * committed-but-not-on-hand). Excluded from the live-sellable
     * inventory value cards but surfaced on its own dashboard tile
     * and pushable to Shopify as backorder stock. Use the dedicated
     * `POST /inventory/{id}/coming-soon/mark-arrived` endpoint to move
     * units from `quantityComingSoon` into `quantity` when stock
     * physically arrives — that path also writes per-field audit rows.
     */
  quantityComingSoon?: number | null;
  /**
     * Shopify CUSTOM collection IDs this item belongs to. Smart
     * collections are read-only (Shopify auto-populates them by rule)
     * and are NOT stored here — the FE picker shows them as disabled
     * chips. The next Shopify push will reconcile the `collects`
     * table to match this list.
     */
  shopifyCollectionIds?: string[] | null;
  /**
     * Server-derived. Whether this item passes the bulk-push gate
     * (sku, productTitle, brand, askingPrice>0, ≥1 photo, body html)
     * and a list of any missing fields. Read-only — populated only on
     * list/detail responses, ignored on writes.
     */
  shopifyEligibility?: ShopifyEligibility | null;
  landedUnitCost: number;
  estimatedResalePrice?: number | null;
  currentAskingPrice?: number | null;
  minimumAcceptablePrice?: number | null;
  /** ISO currency code for listing prices (asking / resale / minimum). Cost basis is always GBP. Defaults to GBP. */
  currency?: string | null;
  serialNumber?: string | null;
  assayNumber?: string | null;
  mintage?: string | null;
  /** Year of issue (for coins / dated bullion). */
  year?: number | null;
  condition?: string | null;
  conditionFlags?: string[] | null;
  storageLocation?: string | null;
  status?: string | null;
  salesChannel?: string | null;
  listingUrl?: string | null;
  photoUrl?: string | null;
  /**
     * Legacy flat photo gallery. Prefer `photos` (structured). When `photos`
     * is provided, the server derives `photoUrls` from it for back-compat
     * and ignores anything sent here.
     */
  photoUrls?: string[] | null;
  /**
     * Structured product photos. Use `front` for the primary listing
     * image. At most one entry per `front`/`left`/`right`/`rear`. If any
     * photos are provided, exactly one `front` is required.
     */
  photos?: InventoryPhoto[] | null;
  /**
     * Marketplace slugs (e.g. shopify, ebay, whatnot, tiktok-shop, woocommerce) this item should be synced to when a sync job runs.
     *
     * Including `"shopify"` opts the item in to the auto-push: every create / quantity change / Shopify-field change enqueues a Shopify upsert. The price written to Shopify is the operator's `currentAskingPrice` marked up by 3.8% — internal pricing is never modified. Items missing every kind of photo (`photos`, `photoUrls`, `photoUrl`) are rejected at create/update time with `Add at least one product photo before pushing this item to Shopify.`
     */
  syncChannels?: string[] | null;
  /** When true, quantity changes on this item are auto-pushed to eBay (requires the eBay integration enabled and the item to already have an eBay listing tracked in externalListings.ebay). */
  syncToEbay?: boolean | null;
  /**
     * eBay leaf category id (e.g. `"39482"` for Bullion Bars UK,
     * `"39482"` etc.). Pushed as `offer.categoryId` by the next
     * eBay listing push. When null, the server falls back to
     * `"39482"` (Bullion Bars UK) for backwards compatibility.
     */
  ebayCategoryId?: string | null;
  supplierId?: string | null;
  purchaseOrderId?: string | null;
  notes?: string | null;
  /** Standing instruction shown prominently to the packer every time this product is packed (e.g. "privy — check it exists and film it", "has milking on the side — show to camera"). Travels with the item, distinct from the per-sale-order ad-hoc packing notes. */
  packerNote?: string | null;
  /** Country or region of origin for this product. Populated by the TikTok product-data pull (from a "Country/Region of origin" or equivalent category attribute), or entered manually. */
  regionOfOrigin?: string | null;
}

/**
 * SKU role for the breakdown / transformation feature. `sellable`
 * (default) hides the "Break down" CTA; `source` exposes it but
 * removes the SKU from output pickers; `both` exposes it and keeps
 * the SKU sellable. Patching this lets operators upgrade an
 * existing item so it can be linked to child SKUs.
 */
export type InventoryItemUpdateProductKind = typeof InventoryItemUpdateProductKind[keyof typeof InventoryItemUpdateProductKind];


export const InventoryItemUpdateProductKind = {
  source: 'source',
  sellable: 'sellable',
  both: 'both',
} as const;

/**
 * Switching to OWNED automatically clears supplierPayoutPrice, supplierName, and all consignmentPayout* fields.
 */
export type InventoryItemUpdateStockType = typeof InventoryItemUpdateStockType[keyof typeof InventoryItemUpdateStockType];


export const InventoryItemUpdateStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type InventoryItemUpdateConsignmentPayoutType = typeof InventoryItemUpdateConsignmentPayoutType[keyof typeof InventoryItemUpdateConsignmentPayoutType] | null;


export const InventoryItemUpdateConsignmentPayoutType = {
  FIXED_PER_UNIT: 'FIXED_PER_UNIT',
  PROFIT_SPLIT_PCT: 'PROFIT_SPLIT_PCT',
} as const;

export type ExternalListingStockSyncStatus = typeof ExternalListingStockSyncStatus[keyof typeof ExternalListingStockSyncStatus] | null;


export const ExternalListingStockSyncStatus = {
  synced: 'synced',
  error: 'error',
  unmapped: 'unmapped',
} as const;

export type ExternalListingPublicationStatus = typeof ExternalListingPublicationStatus[keyof typeof ExternalListingPublicationStatus];


export const ExternalListingPublicationStatus = {
  active: 'active',
  draft: 'draft',
  unavailable: 'unavailable',
} as const;

/**
 * Last verified Online Store observation, not proof of current publication.
 */
export type ExternalListingPublication = {
  productId?: string;
  shopDomain?: string | null;
  status?: ExternalListingPublicationStatus;
  checkedAt?: string;
};

export interface ExternalListing {
  offerId?: string | null;
  listingId?: string | null;
  sku?: string | null;
  url?: string | null;
  lastSyncedAt?: string | null;
  lastError?: string | null;
  lastStockQuantity?: number | null;
  stockSyncStatus?: ExternalListingStockSyncStatus;
  productId?: string | null;
  /** Last verified Online Store observation, not proof of current publication. */
  publication?: ExternalListingPublication;
  /** True when the last push failed because the stored Shopify product id no longer exists at that id (404 on update). Signals a recoverable "dead link" — the operator can re-send to reconnect by SKU. Cleared on the next successful push. */
  staleLink?: boolean | null;
}

/**
 * Map of channel slug to external listing metadata (offerId/listingId/url/lastError).
 */
export type InventoryItemUpdateExternalListings = {[key: string]: ExternalListing} | null;

/**
 * Partial update for an inventory item — all fields optional. Columns that are NOT NULL in the database (productTitle, quantity, landedUnitCost) cannot be set to null when included.
 */
export interface InventoryItemUpdate {
  /**
     * Optimistic concurrency token returned on the inventory item. Required to reject stale Product Information / Shopify-state saves when supplied.
     * @minimum 1
     */
  expectedProductInformationVersion?: number;
  /** Canonical MetalUI structured product information. Optional; null clears it. */
  structuredProductFields?: StructuredProductFields | null;
  /** Audited reason for pushing a price through a Dynamic Pricing hard block. Only honoured together with `confirmOverride: true` and only for users holding the margin-override permission; recorded in the margin-override history. Ignored when the save does not breach a hard-block rule. */
  overrideReason?: string;
  /** Explicit confirmation that accompanies `overrideReason` when saving a price that breaches a margin hard block. */
  confirmOverride?: boolean;
  /**
     * SKU role for the breakdown / transformation feature. `sellable`
     * (default) hides the "Break down" CTA; `source` exposes it but
     * removes the SKU from output pickers; `both` exposes it and keeps
     * the SKU sellable. Patching this lets operators upgrade an
     * existing item so it can be linked to child SKUs.
     */
  productKind?: InventoryItemUpdateProductKind;
  /**
     * Retroactive "linked SKU" pointer to a master inventory item.
     * Pass a UUID to link, pass `null` to unlink. Pure reporting tag —
     * no stock moves. The master's lineage panel and P&L roll up the
     * child's realized sales / margin.
     *
     * Server enforces (returns 409): cannot link to self; master must
     * exist in the same tenant; one level only (master cannot itself
     * be linked); and a SKU that is already a master of other items
     * cannot itself be linked.
     */
  masterInventoryItemId?: string | null;
  /** @minimum 0 */
  lengthCm?: number | null;
  /** @minimum 0 */
  widthCm?: number | null;
  /** @minimum 0 */
  heightCm?: number | null;
  /** @minimum 0 */
  weightGrams?: number | null;
  /** Switching to OWNED automatically clears supplierPayoutPrice, supplierName, and all consignmentPayout* fields. */
  stockType?: InventoryItemUpdateStockType;
  supplierName?: string | null;
  supplierPayoutPrice?: number | null;
  consignmentPayoutType?: InventoryItemUpdateConsignmentPayoutType;
  /**
     * @minimum 0
     * @maximum 100
     */
  consignmentSupplierSplitPct?: number | null;
  /**
     * @minimum 0
     * @maximum 100
     */
  consignmentBusinessSplitPct?: number | null;
  /** Batch Recovery Consignment batch link. Pass `null` to unlink. */
  consignmentBatchId?: string | null;
  consignmentTargetSalePriceGbp?: number | null;
  /** Shopify-only override for the product's "Vendor" field. Falls back to `brand` when null. */
  shopifyVendor?: string | null;
  /** Shopify-only comma-separated tag list written verbatim into Shopify's `tags` field. */
  shopifyTags?: string | null;
  /** Shopify-only product metafields. Replaces the existing list verbatim when provided. */
  shopifyMetafields?: ShopifyMetafield[] | null;
  /** Per-item WooCommerce push overrides. Pass `null` (or an empty object) to clear all overrides for this item. */
  woocommerceOverrides?: WooOverrides | null;
  /** Per-item Shopify-only spec overrides. Pass `null` (or an empty object) to clear all overrides for this item. */
  shopifyOverrides?: ShopifySpecOverrides | null;
  /** Versioned Shopify field states. Each field must explicitly use inherit, override, or clear. */
  shopifyFieldStates?: ShopifyFieldStates | null;
  /** Per-item TikTok Shop listing overrides. Pass `null` (or an empty object) to clear all overrides for this item. */
  tiktokOverrides?: TikTokOverrides | null;
  /** Default product description (rich-text HTML). Used by every marketplace push as the body unless that channel has its own override populated. */
  descriptionHtml?: string | null;
  /** Shopify-specific description override (HTML). When set, pushed verbatim into `product.body_html`; when null/empty, falls back to `descriptionHtml`. */
  shopifyBodyHtml?: string | null;
  /** eBay-specific description override (HTML). When null/empty, falls back to `descriptionHtml`. */
  ebayDescriptionHtml?: string | null;
  /** Agoro theme narrative block 1 — pushed as `custom.line_1_description` metafield. */
  shopifyLine1Description?: string | null;
  /** Agoro theme narrative block 2 — pushed as `custom.line_2_description` metafield. */
  shopifyLine2Description?: string | null;
  /** Agoro theme narrative block 3 — pushed as `custom.line_3_description` metafield. */
  shopifyLine3Description?: string | null;
  /** Replace the item's local category assignments. Server mirrors changes to Shopify custom_collections. */
  categoryIds?: string[] | null;
  sku?: string;
  productTitle?: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  purity?: string | null;
  quantity?: number;
  /**
     * Optional count of units flagged as "Coming Soon" (preorder /
     * committed-but-not-on-hand). Excluded from the live-sellable
     * inventory value cards but surfaced on its own dashboard tile
     * and pushable to Shopify as backorder stock. Use the dedicated
     * `POST /inventory/{id}/coming-soon/mark-arrived` endpoint to move
     * units from `quantityComingSoon` into `quantity` when stock
     * physically arrives — that path also writes per-field audit rows.
     */
  quantityComingSoon?: number | null;
  /**
     * Shopify CUSTOM collection IDs this item belongs to. Smart
     * collections are read-only (Shopify auto-populates them by rule)
     * and are NOT stored here — the FE picker shows them as disabled
     * chips. The next Shopify push will reconcile the `collects`
     * table to match this list.
     */
  shopifyCollectionIds?: string[] | null;
  /**
     * Server-derived. Whether this item passes the bulk-push gate
     * (sku, productTitle, brand, askingPrice>0, ≥1 photo, body html)
     * and a list of any missing fields. Read-only — populated only on
     * list/detail responses, ignored on writes.
     */
  shopifyEligibility?: ShopifyEligibility | null;
  landedUnitCost?: number;
  estimatedResalePrice?: number | null;
  currentAskingPrice?: number | null;
  minimumAcceptablePrice?: number | null;
  currency?: string | null;
  serialNumber?: string | null;
  assayNumber?: string | null;
  mintage?: string | null;
  /** Year of issue (for coins / dated bullion). */
  year?: number | null;
  condition?: string | null;
  conditionFlags?: string[] | null;
  storageLocation?: string | null;
  status?: string | null;
  salesChannel?: string | null;
  listingUrl?: string | null;
  photoUrl?: string | null;
  /**
     * Legacy flat photo gallery — see `photos` for the structured form.
     * When `photos` is provided, the server derives this from it.
     */
  photoUrls?: string[] | null;
  /**
     * Replace the structured product photos. Same validation as on
     * create — `front` is required when any photos are provided.
     */
  photos?: InventoryPhoto[] | null;
  syncChannels?: string[] | null;
  /**
     * Existing Whatnot Seller API listing ID to map to this item for
     * quantity-only stock sync. Pass null or an empty string to clear.
     * The listing is never created by this field.
     */
  whatnotListingId?: string | null;
  /**
     * Fresh completed account-wide scan proof for mapping an existing Whatnot listing.
     * @maxLength 90000
     */
  whatnotScanToken?: string;
  syncToEbay?: boolean | null;
  /**
     * eBay leaf category id used by the next listing push. Pass an
     * empty string to clear the override and fall back to the
     * server default (`"39482"`, Bullion Bars UK).
     */
  ebayCategoryId?: string | null;
  /**
     * TikTok Shop leaf category id sent as `category_id` on the next
     * product push. When null the push engine falls back to the tenant's
     * global category mapping keyed by `productType`, then to TikTok's
     * default assignment. Pass an empty string to clear the per-item
     * override and revert to the mapping fallback.
     */
  tiktokCategoryId?: string | null;
  /**
     * Human-readable category path stored alongside tiktokCategoryId
     * (e.g. "Jewelry > Rings > Wedding Rings"). Populated automatically
     * from category_chains.local_name when a product is linked or pulled
     * from TikTok, so the UI can display the category label without a
     * live TikTok API call.
     */
  tiktokCategoryName?: string | null;
  supplierId?: string | null;
  purchaseOrderId?: string | null;
  notes?: string | null;
  /** Standing instruction shown prominently to the packer every time this product is packed. Travels with the item. */
  packerNote?: string | null;
  /** Country or region of origin for this product. */
  regionOfOrigin?: string | null;
  /** Map of channel slug to external listing metadata (offerId/listingId/url/lastError). */
  externalListings?: InventoryItemUpdateExternalListings;
}

export type ShopifyPublicationObservationStatus = typeof ShopifyPublicationObservationStatus[keyof typeof ShopifyPublicationObservationStatus];


export const ShopifyPublicationObservationStatus = {
  active: 'active',
  draft: 'draft',
  unavailable: 'unavailable',
} as const;

export type ShopifyPublicationObservationLastKnownStatus = typeof ShopifyPublicationObservationLastKnownStatus[keyof typeof ShopifyPublicationObservationLastKnownStatus] | null;


export const ShopifyPublicationObservationLastKnownStatus = {
  active: 'active',
  draft: 'draft',
  unavailable: 'unavailable',
} as const;

export type ShopifyChannelPublicationObservationStatus = typeof ShopifyChannelPublicationObservationStatus[keyof typeof ShopifyChannelPublicationObservationStatus];


export const ShopifyChannelPublicationObservationStatus = {
  active: 'active',
  draft: 'draft',
  unavailable: 'unavailable',
} as const;

export type ShopifyChannelPublicationObservationLastKnownStatus = typeof ShopifyChannelPublicationObservationLastKnownStatus[keyof typeof ShopifyChannelPublicationObservationLastKnownStatus] | null;


export const ShopifyChannelPublicationObservationLastKnownStatus = {
  active: 'active',
  draft: 'draft',
  unavailable: 'unavailable',
} as const;

export interface ShopifyChannelPublicationObservation {
  status: ShopifyChannelPublicationObservationStatus;
  checkedAt: string | null;
  stale: boolean;
  lastKnownStatus: ShopifyChannelPublicationObservationLastKnownStatus;
  reason: string | null;
}

export type ShopifyPublicationObservationChannels = {
  googleYouTube: ShopifyChannelPublicationObservation;
  whatnot: ShopifyChannelPublicationObservation;
};

export type ShopifyGoogleFeedObservationStatus = typeof ShopifyGoogleFeedObservationStatus[keyof typeof ShopifyGoogleFeedObservationStatus];


export const ShopifyGoogleFeedObservationStatus = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  needs_action: 'needs_action',
  unavailable: 'unavailable',
} as const;

export type ShopifyGoogleFeedObservationLastKnownStatus = typeof ShopifyGoogleFeedObservationLastKnownStatus[keyof typeof ShopifyGoogleFeedObservationLastKnownStatus] | null;


export const ShopifyGoogleFeedObservationLastKnownStatus = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  needs_action: 'needs_action',
  unavailable: 'unavailable',
} as const;

export interface ShopifyGoogleFeedObservation {
  status: ShopifyGoogleFeedObservationStatus;
  checkedAt: string | null;
  stale: boolean;
  lastKnownStatus: ShopifyGoogleFeedObservationLastKnownStatus;
  reason: string | null;
}

export interface ShopifyPublicationObservation {
  productId: string | null;
  shopDomain: string | null;
  status: ShopifyPublicationObservationStatus;
  checkedAt: string | null;
  stale: boolean;
  lastKnownStatus: ShopifyPublicationObservationLastKnownStatus;
  reason: string | null;
  channels: ShopifyPublicationObservationChannels;
  googleFeed: ShopifyGoogleFeedObservation;
}

export type AnalyticsOverviewTotals = {
  sessions: number;
  totalUsers: number;
  screenPageViews: number;
  conversions: number;
  /** Avg session duration in seconds. */
  averageSessionDuration: number;
};

/**
 * Compares the requested window to the same-length prior window. Null if not configured.
 */
export type AnalyticsOverviewDeltas = {
  sessionsPct?: number;
  usersPct?: number;
} | null;

export type AnalyticsOverviewDailyItem = {
  /** YYYY-MM-DD */
  date: string;
  sessions: number;
  totalUsers?: number;
};

export type AnalyticsOverviewTopPagesItem = {
  path: string;
  title?: string | null;
  sessions: number;
  screenPageViews?: number;
};

export type AnalyticsOverviewTopSourcesItem = {
  source: string;
  sessions: number;
  totalUsers?: number;
};

export interface AnalyticsOverview {
  /** False if Google Analytics is not yet configured. */
  configured: boolean;
  days: number;
  totals: AnalyticsOverviewTotals;
  /** Compares the requested window to the same-length prior window. Null if not configured. */
  deltas?: AnalyticsOverviewDeltas;
  /** Daily series of sessions for the requested window. */
  daily: AnalyticsOverviewDailyItem[];
  topPages: AnalyticsOverviewTopPagesItem[];
  topSources: AnalyticsOverviewTopSourcesItem[];
}

export interface ShopifyTestResult {
  ok: boolean;
  shopName?: string | null;
  domain?: string | null;
  message?: string | null;
}

/**
 * `custom` collections are operator-curated and assignable from the inventory editor.
 * `smart` collections are rule-driven and surfaced read-only in the UI — Shopify rejects manual `collects` against them.
 */
export type ShopifyCollectionKind = typeof ShopifyCollectionKind[keyof typeof ShopifyCollectionKind];


export const ShopifyCollectionKind = {
  custom: 'custom',
  smart: 'smart',
} as const;

export interface ShopifyCollection {
  id: string;
  /** Shopify numeric collection id (string). */
  shopifyId: string;
  title: string | null;
  handle?: string | null;
  /**
     * `custom` collections are operator-curated and assignable from the inventory editor.
     * `smart` collections are rule-driven and surfaced read-only in the UI — Shopify rejects manual `collects` against them.
     */
  kind: ShopifyCollectionKind;
  bodyHtml?: string | null;
  updatedShopifyAt?: string | null;
  lastSyncedAt: string;
}

export interface ShopifyCollectionsSyncResult {
  ok: boolean;
  message?: string | null;
  /** Custom collections upserted into the local mirror. */
  custom: number;
  /** Smart collections upserted into the local mirror. */
  smart: number;
  /** Stale local rows pruned because Shopify no longer returns them. */
  removed: number;
}

export interface RemoveBackgroundRequest {
  /** Object path of the source image (e.g. `/objects/uploads/<uuid>`). Must be currently in the item's photos / photoUrl / photoUrls or its pinned composite source. */
  sourcePhotoUrl: string;
}

export interface RemoveBackgroundResult {
  ok: boolean;
  /** New `/objects/uploads/<uuid>` path of the transparent PNG. The FE sets this as the composite source. */
  objectPath: string;
  /** Size of the transparent PNG in bytes (for diagnostics / quota tracking). */
  bytes?: number;
}

export interface AcquisitionVatWarning {
  code: string;
  message: string;
}

export type InventoryStockInInputStockInReason = typeof InventoryStockInInputStockInReason[keyof typeof InventoryStockInInputStockInReason];


export const InventoryStockInInputStockInReason = {
  new_stock: 'new_stock',
  extra_delivery: 'extra_delivery',
  correction: 'correction',
} as const;

export interface InventoryStockInInput {
  /**
     * @minimum 1
     * @maximum 100000
     */
  stockInQuantity: number;
  stockInReason: InventoryStockInInputStockInReason;
  /**
     * @maxLength 2000
     * @nullable
     */
  stockInNotes?: string | null;
  /** Optional acquisition VAT classification; tenant enforcement determines whether it is required. */
  vat?: AcquisitionVatInput | null;
}

export type InventoryStockInResultMovement = {
  id: string;
  createdAt: string;
  action: string;
  changeType: string;
  previousQuantity: number;
  newQuantity: number;
  delta: number;
  /** @nullable */
  userEmail: string | null;
  /** @nullable */
  notes: string | null;
};

export type FlagPriority = typeof FlagPriority[keyof typeof FlagPriority];


export const FlagPriority = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

export interface CompactFlagRef {
  id: string;
  name: string;
  colour: string;
  priority: FlagPriority;
}

export type InventoryListItemStockType = typeof InventoryListItemStockType[keyof typeof InventoryListItemStockType];


export const InventoryListItemStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

/**
 * Per-line payout method for CONSIGNMENT stock. Snapshotted onto sale lines.
 */
export type InventoryListItemConsignmentPayoutType = typeof InventoryListItemConsignmentPayoutType[keyof typeof InventoryListItemConsignmentPayoutType] | null;


export const InventoryListItemConsignmentPayoutType = {
  FIXED_PER_UNIT: 'FIXED_PER_UNIT',
  PROFIT_SPLIT_PCT: 'PROFIT_SPLIT_PCT',
} as const;

export interface InventoryMarketplaceAccountLabel {
  label: string;
}

/**
 * Persisted composition baseline. Legacy rows are represented as single_coin.
 */
export type InventoryListItemCompositeLayout = typeof InventoryListItemCompositeLayout[keyof typeof InventoryListItemCompositeLayout];


export const InventoryListItemCompositeLayout = {
  single_coin: 'single_coin',
  shared_hero: 'shared_hero',
} as const;

/**
 * SKU role for the breakdown / transformation feature.
 * * `source` — raw mixed lot (e.g. MIX-XXXXX) that operators
 *   decompose into N child sellable SKUs. Cannot itself be sold.
 * * `sellable` — downstream child SKU. Default for everything
 *   created the normal way.
 * * `both` — bridge row that can act as either source or output.
 * Frontend gates the "Break down" CTA on this; backend
 * `executeBreakdown` rejects mismatches with HTTP 422.
 */
export type InventoryListItemProductKind = typeof InventoryListItemProductKind[keyof typeof InventoryListItemProductKind];


export const InventoryListItemProductKind = {
  source: 'source',
  sellable: 'sellable',
  both: 'both',
} as const;

/**
 * VAT treatment chosen for this stock line. `null` = unclassified (badged amber until set).
 */
export type InventoryListItemVatTreatment = typeof InventoryListItemVatTreatment[keyof typeof InventoryListItemVatTreatment] | null;


export const InventoryListItemVatTreatment = {
  MARGIN_SCHEME: 'MARGIN_SCHEME',
  STANDARD_VAT: 'STANDARD_VAT',
  VAT_EXEMPT_GOLD: 'VAT_EXEMPT_GOLD',
  OUTSIDE_SCOPE: 'OUTSIDE_SCOPE',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
} as const;

export type InventoryListItemPurchaseSource = typeof InventoryListItemPurchaseSource[keyof typeof InventoryListItemPurchaseSource] | null;


export const InventoryListItemPurchaseSource = {
  PUBLIC: 'PUBLIC',
  UK_DEALER: 'UK_DEALER',
  OVERSEAS_DEALER: 'OVERSEAS_DEALER',
  CONSIGNMENT: 'CONSIGNMENT',
  MINT_MANUFACTURER: 'MINT_MANUFACTURER',
  OTHER: 'OTHER',
} as const;

export type InventoryListItemStockCondition = typeof InventoryListItemStockCondition[keyof typeof InventoryListItemStockCondition] | null;


export const InventoryListItemStockCondition = {
  SECOND_HAND: 'SECOND_HAND',
  NEW: 'NEW',
  COLLECTIBLE: 'COLLECTIBLE',
  BULLION: 'BULLION',
  SCRAP_MELT: 'SCRAP_MELT',
  UNKNOWN: 'UNKNOWN',
} as const;

export type InventoryListItemSellerVatStatus = typeof InventoryListItemSellerVatStatus[keyof typeof InventoryListItemSellerVatStatus] | null;


export const InventoryListItemSellerVatStatus = {
  NON_VAT_REGISTERED: 'NON_VAT_REGISTERED',
  VAT_REGISTERED: 'VAT_REGISTERED',
  MARGIN_SCHEME_DEALER: 'MARGIN_SCHEME_DEALER',
  UNKNOWN: 'UNKNOWN',
} as const;

/**
 * Operator-set review state. Backed by a partial GIN index for the Phase 3 backfill queue.
 */
export type InventoryListItemVatReviewStatus = typeof InventoryListItemVatReviewStatus[keyof typeof InventoryListItemVatReviewStatus] | null;


export const InventoryListItemVatReviewStatus = {
  CONFIRMED: 'CONFIRMED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  MISSING_EVIDENCE: 'MISSING_EVIDENCE',
} as const;

export interface VatEvidenceFile {
  url: string;
  /**
     * Read-side: free-form string for forward-compat with legacy rows.
     * Writes (PATCH /inventory/{id}/vat) constrain `kind` to the
     * VatEvidenceKind enum below — the server rejects anything else
     * with a 400.
     */
  kind: string;
  uploadedAt: string;
  uploadedByUserId?: string;
  uploadedByUserEmail?: string;
  note?: string;
}

/**
 * Per-item valuation classification used by the Inventory Valuation
 * Engine (feature flag: advanced_inventory_valuation_enabled).
 * * `spot_tracked` — Standard bullion; eligible for commodity silver average.
 * * `premium`      — Premium/Collectible; excluded from average.
 * * `hybrid`       — Both metal and premium components; metal part included in average.
 * * `excluded`     — Non-metal item (certificates, cases); excluded.
 * * `custom`       — Custom valuation basis; excluded from average.
 * `null` = unclassified (treated as spot_tracked for backward compat).
 */
export type InventoryListItemValuationMethod = typeof InventoryListItemValuationMethod[keyof typeof InventoryListItemValuationMethod] | null;


export const InventoryListItemValuationMethod = {
  spot_tracked: 'spot_tracked',
  premium: 'premium',
  hybrid: 'hybrid',
  excluded: 'excluded',
  custom: 'custom',
} as const;

export type InventoryValuationProfileValuationMethod = typeof InventoryValuationProfileValuationMethod[keyof typeof InventoryValuationProfileValuationMethod];


export const InventoryValuationProfileValuationMethod = {
  spot_tracked: 'spot_tracked',
  premium: 'premium',
  hybrid: 'hybrid',
  excluded: 'excluded',
  custom: 'custom',
} as const;

export type InventoryValuationProfileValuationSource = typeof InventoryValuationProfileValuationSource[keyof typeof InventoryValuationProfileValuationSource] | null;


export const InventoryValuationProfileValuationSource = {
  cost: 'cost',
  market: 'market',
  appraised: 'appraised',
  manual: 'manual',
  other: 'other',
} as const;

export type InventoryValuationProfileApprovalStatus = typeof InventoryValuationProfileApprovalStatus[keyof typeof InventoryValuationProfileApprovalStatus];


export const InventoryValuationProfileApprovalStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export interface InventoryValuationProfile {
  id: string;
  inventoryItemId: string;
  valuationMethod: InventoryValuationProfileValuationMethod;
  metalType?: string | null;
  /** Fine metal weight in troy ounces (for spot_tracked and hybrid items). */
  fineMetalWeightOzt?: number | null;
  /** GBP value of the metal component in a hybrid item. */
  hybridMetalComponent?: number | null;
  /** GBP value of the premium component in a hybrid item. */
  hybridPremiumComponent?: number | null;
  acquisitionCost?: number | null;
  currentSellingPrice?: number | null;
  manualValuation?: number | null;
  valuationSource?: InventoryValuationProfileValuationSource;
  valuationNotes?: string | null;
  reviewDate?: string | null;
  valuationExpiresAt?: string | null;
  approvalStatus: InventoryValuationProfileApprovalStatus;
  approvedByUserId?: string | null;
  approvedAt?: string | null;
  exclusionReason?: string | null;
  customValuationBasis?: string | null;
  customValuationValue?: number | null;
  migratedViaBulkFlow?: boolean;
  classificationNote?: string | null;
  effectiveFrom: string;
  effectiveTo?: string | null;
  createdAt?: string;
}

/**
 * Map of channel slug to external listing metadata (offerId/listingId/url/lastError).
 */
export type InventoryListItemExternalListings = {[key: string]: ExternalListing} | null;

export interface InventoryListItem {
  flags?: CompactFlagRef[];
  stockType: InventoryListItemStockType;
  /** GBP amount owed per unit on sale (consignment only). Used when consignmentPayoutType is FIXED_PER_UNIT or null. */
  supplierPayoutPrice?: number | null;
  /** Per-line payout method for CONSIGNMENT stock. Snapshotted onto sale lines. */
  consignmentPayoutType?: InventoryListItemConsignmentPayoutType;
  /** Supplier's share of the profit pool (0–100). */
  consignmentSupplierSplitPct?: number | null;
  /** Business's share of the profit pool (0–100). */
  consignmentBusinessSplitPct?: number | null;
  /** Informational target sale price agreed with the supplier. */
  consignmentTargetSalePriceGbp?: number | null;
  /** Batch Recovery Consignment batch link (when supplier is BATCH_RECOVERY mode). */
  consignmentBatchId?: string | null;
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  /** Physical length in cm — used by the smart packaging recommendation engine. */
  lengthCm?: number | null;
  /** Physical width in cm. */
  widthCm?: number | null;
  /** Physical height in cm. */
  heightCm?: number | null;
  /** Shipping weight in grams (whole-product, including item packaging). */
  weightGrams?: number | null;
  purity?: string | null;
  quantity: number;
  quantityReserved: number;
  quantitySold: number;
  quantityDamaged?: number;
  quantityAvailable: number;
  /** Units committed as Coming Soon (preorder). Excluded from `quantityAvailable` and the dashboard live-sellable value. */
  quantityComingSoon?: number | null;
  /** Number of linked child variants (e.g. year-variants) whose `masterInventoryItemId` points to this item. 0 when this item has no children. Display-only roll-up used to surface COMBINED parent figures; pair with the `childQuantity*` sums below. */
  childCount?: number | null;
  /** Sum of `quantity` across all linked child variants (0 if none). Add to this item's own `quantity` for the parent's combined total stock. */
  childQuantity?: number | null;
  /** Sum of `quantityReserved` across all linked child variants (0 if none). */
  childQuantityReserved?: number | null;
  /** Sum of `quantitySold` across all linked child variants (0 if none). Add to this item's own `quantitySold` for the parent's combined units-sold figure. */
  childQuantitySold?: number | null;
  /** Sum of `quantityDamaged` across all linked child variants (0 if none). */
  childQuantityDamaged?: number | null;
  /** Sum of each child variant's derived available units (clamped at 0 per child, 0 if none). Add to this item's own `quantityAvailable` for the parent's combined remaining-stock figure. */
  childQuantityAvailable?: number | null;
  /** Sum of `quantityComingSoon` across all linked child variants (0 if none). */
  childQuantityComingSoon?: number | null;
  /** Shopify CUSTOM collection IDs this item belongs to (mirrored locally for picker display). */
  shopifyCollectionIds?: string[] | null;
  /** Server-derived push gate (read-only). See helper at lib/shopify/eligibility.ts. */
  shopifyEligibility?: ShopifyEligibility | null;
  /** Of the available units, how many are owned outright (vs held on consignment). 0 for pure OWNED rows; for CONSIGNMENT rows the consignment portion is `quantityAvailable - quantityOwned`. */
  quantityOwned?: number;
  /** Weighted-average unit cost of the owned portion on a CONSIGNMENT row (when reversed-paid units have been bought outright). Null for pure OWNED rows. */
  ownedUnitCost?: number | null;
  landedUnitCost: number;
  totalCost: number;
  estimatedResalePrice?: number | null;
  currentAskingPrice?: number | null;
  minimumAcceptablePrice?: number | null;
  /** ISO currency code for listing prices (asking / resale / minimum). Cost basis is always GBP. */
  currency?: string;
  serialNumber?: string | null;
  assayNumber?: string | null;
  mintage?: string | null;
  /** Year of issue (for coins / dated bullion). */
  year?: number | null;
  condition?: string | null;
  conditionFlags?: string[] | null;
  storageLocation?: string | null;
  status: string;
  salesChannel?: string | null;
  listingUrl?: string | null;
  photoUrl?: string | null;
  /**
     * Flat list of photo URLs derived from `photos` (sorted: front, left,
     * right, rear, then additional by sortOrder), with the legacy single
     * `photoUrl` appended when no structured photos exist. Kept for
     * back-compat with consumers that haven't moved to `photos` yet.
     */
  photoUrls?: string[];
  /**
     * Structured product photos in display order. The `front` entry, if
     * present, is the primary image used by every external integration.
     */
  photos?: InventoryPhoto[];
  /**
     * Human-readable advisories about the current photo set (e.g.
     * "Missing front image", "Only 1 photo — listing quality may be
     * affected"). Surfaced in the UI before pushing to marketplaces.
     */
  photoWarnings?: string[];
  /** Marketplace slugs this item is opted in to. `"shopify"` triggers the auto-push pipeline (image-required, price marked up 3.8% on the Shopify variant only). */
  syncChannels: string[];
  /** When true, quantity changes auto-push to eBay. */
  syncToEbay?: boolean;
  /**
     * eBay leaf category id used by the next listing push
     * (`offer.categoryId`). Null when the operator has not set an
     * override, in which case the server falls back to `"39482"`
     * (Bullion Bars UK).
     */
  ebayCategoryId?: string | null;
  /**
     * TikTok Shop leaf category id used by the next product push
     * (`category_id`). Null when the operator has not set a per-item
     * override, in which case the push engine falls back to the tenant's
     * global productType mapping, then to TikTok auto-assignment.
     */
  tiktokCategoryId?: string | null;
  /**
     * Human-readable category path (e.g. "Jewelry > Rings > Wedding
     * Rings"). Stored alongside tiktokCategoryId so the UI can show a
     * label without a live TikTok API call.
     */
  tiktokCategoryName?: string | null;
  supplierId?: string | null;
  supplierName?: string | null;
  purchaseOrderId?: string | null;
  purchaseOrderNumber?: string | null;
  notes?: string | null;
  /** Standing instruction shown prominently to the packer every time this product is packed. Travels with the item. */
  packerNote?: string | null;
  /** Country or region of origin for this product. */
  regionOfOrigin?: string | null;
  marginPct?: number | null;
  /**
     * Lifetime realised profit in GBP from every past sale line linked
     * to this inventory item: SUM(qty * salePrice − qty * effectiveUnitCost)
     * where effectiveUnitCost = COALESCE(consignment_supplier_payout_per_unit_gbp, unit_cost).
     * This is the BUSINESS's own net share — consignment profit-split
     * (if any) is already deducted. Gross of customer refunds. Nulled
     * for callers without `finance.business_pnl.view`. 0 if the item
     * has never sold. Null when any realised sale has unresolved source
     * COGS and the aggregate profit cannot be confirmed.
     */
  realizedProfitGbp?: number | null;
  /**
     * Lifetime GROSS profit in GBP before any consignment profit-split:
     * SUM(qty * salePrice − qty * unit_cost). Equal to realizedProfitGbp
     * for OWNED stock (no split). Nulled for callers without
     * `finance.business_pnl.view`. 0 if the item has never sold. Null
     * when any realised sale has unresolved source COGS and the
     * aggregate profit cannot be confirmed.
     */
  realizedGrossProfitGbp?: number | null;
  /**
     * Lifetime portion of gross profit paid out to the consignment
     * supplier via profit-split (realizedGrossProfitGbp minus
     * realizedProfitGbp). Always 0 for OWNED stock or FIXED_PER_UNIT
     * consignment payouts. Nulled for callers without
     * `finance.business_pnl.view`.
     */
  realizedConsignorShareGbp?: number | null;
  /** Map of channel slug to external listing metadata (offerId/listingId/url/lastError). */
  externalListings?: InventoryListItemExternalListings;
  /** Tenant-authorized marketplace account labels with a broken link under the active broken-link filter. */
  brokenLinkAccounts?: InventoryMarketplaceAccountLabel[];
  /** Shopify-only override for the product's "Vendor" field. Falls back to `brand` when null. */
  shopifyVendor?: string | null;
  /** Shopify-only comma-separated tag list written verbatim into Shopify's `tags` field. */
  shopifyTags?: string | null;
  /** Shopify-only product metafields. Merged with the auto-derived `custom.*` set on push. */
  shopifyMetafields?: ShopifyMetafield[] | null;
  /** Agoro theme narrative block 1 — pushed as `custom.line_1_description` metafield. */
  shopifyLine1Description?: string | null;
  /** Agoro theme narrative block 2 — pushed as `custom.line_2_description` metafield. */
  shopifyLine2Description?: string | null;
  /** Agoro theme narrative block 3 — pushed as `custom.line_3_description` metafield. */
  shopifyLine3Description?: string | null;
  /** Local category UUIDs assigned to this item. */
  categoryIds?: string[];
  /** Operator-uploaded transparent product PNG kept as the source for re-rendering the composite. Set together with compositePhotoUrl by POST /inventory/{id}/composite. */
  compositeSourcePhotoUrl?: string | null;
  /** Generated composite (transparent source laid over the active branded template). When set, becomes the primary image used by the inventory list thumbnail and marketplace push pipelines. */
  compositePhotoUrl?: string | null;
  compositeTemplateId?: string | null;
  compositeTemplateVersion?: number | null;
  /** Persisted composition baseline. Legacy rows are represented as single_coin. */
  compositeLayout?: InventoryListItemCompositeLayout;
  /** Horizontal nudge in [-1, 1] as a fraction of the template's width (0 = centered). */
  compositeOffsetX?: number | null;
  /** Vertical nudge in [-1, 1] as a fraction of the template's height (0 = centered). */
  compositeOffsetY?: number | null;
  /** Scale multiplier in (0, 2]; 1 = auto-fit (source's longer side spans 70% of the template's smaller side). */
  compositeScale?: number | null;
  compositeGeneratedAt?: string | null;
  /**
     * SKU role for the breakdown / transformation feature.
     * * `source` — raw mixed lot (e.g. MIX-XXXXX) that operators
     *   decompose into N child sellable SKUs. Cannot itself be sold.
     * * `sellable` — downstream child SKU. Default for everything
     *   created the normal way.
     * * `both` — bridge row that can act as either source or output.
     * Frontend gates the "Break down" CTA on this; backend
     * `executeBreakdown` rejects mismatches with HTTP 422.
     */
  productKind?: InventoryListItemProductKind;
  /**
     * When non-null, this SKU is "linked" to a master inventory item
     * — used for after-the-fact attribution of mixed-batch children
     * back to the master they descended from. Reporting only; no
     * stock or cost on either side moves on link/unlink. See PATCH
     * /inventory/{id} `masterInventoryItemId` for the rules.
     * Past + future sales of this SKU roll up under the master
     * (GET /inventory/{id}/linked-children on the master returns
     * this item plus its realized-sales rollup).
     */
  masterInventoryItemId?: string | null;
  /** VAT treatment chosen for this stock line. `null` = unclassified (badged amber until set). */
  vatTreatment?: InventoryListItemVatTreatment;
  purchaseSource?: InventoryListItemPurchaseSource;
  stockCondition?: InventoryListItemStockCondition;
  sellerVatStatus?: InventoryListItemSellerVatStatus;
  /** Tri-state. `null` = operator hasn't answered. `true`/`false` = answered. The validator only fires contradiction warnings when both relevant sides are actively answered. */
  invoiceShowsMarginScheme?: boolean | null;
  /** Tri-state. See invoiceShowsMarginScheme for the null semantics. */
  vatShownOnInvoice?: boolean | null;
  /** Tri-state. See invoiceShowsMarginScheme for the null semantics. */
  imported?: boolean | null;
  /** Tri-state. See invoiceShowsMarginScheme for the null semantics. */
  importVatPaid?: boolean | null;
  /** Operator-set review state. Backed by a partial GIN index for the Phase 3 backfill queue. */
  vatReviewStatus?: InventoryListItemVatReviewStatus;
  vatReviewNotes?: string | null;
  /** Evidence file references (purchase invoice scan, import declaration, etc.). Mirrors the `photos` JSONB pattern — no separate join table. */
  vatEvidenceFiles?: VatEvidenceFile[] | null;
  /**
     * Server-derived. True iff treatment + source + condition + sellerStatus
     * are all non-null, all four tri-state booleans are answered (true OR
     * false, not null), AND vatReviewStatus = "CONFIRMED". Phase 1 surfaces
     * this as the badge state on the inventory list.
     */
  vatClassificationComplete?: boolean;
  /**
     * True when this item is an eBay soft-import placeholder — auto-minted
     * by the eBay sync when an order's SKU couldn't be resolved to a real
     * inventory row. These items are normally hidden from the inventory list
     * and excluded from the TikTok Shop export. Pass showTiktokExcluded=true
     * to GET /inventory to surface them alongside Shopify-mirrored items so
     * operators can decide whether to relist them as native items.
     */
  needsSkuReview?: boolean;
  /**
     * Per-item valuation classification used by the Inventory Valuation
     * Engine (feature flag: advanced_inventory_valuation_enabled).
     * * `spot_tracked` — Standard bullion; eligible for commodity silver average.
     * * `premium`      — Premium/Collectible; excluded from average.
     * * `hybrid`       — Both metal and premium components; metal part included in average.
     * * `excluded`     — Non-metal item (certificates, cases); excluded.
     * * `custom`       — Custom valuation basis; excluded from average.
     * `null` = unclassified (treated as spot_tracked for backward compat).
     */
  valuationMethod?: InventoryListItemValuationMethod;
  /**
     * Cached computed flag set by the valuation engine. `true` = this item's
     * stock is counted in the commodity silver average. `false` = operator
     * override exclusion. `null` = unclassified / migration pending.
     */
  includeInMetalAverage?: boolean | null;
  /** Active valuation profile for this item. Null when the feature is off or the item is unclassified. */
  valuationProfile?: InventoryValuationProfile | null;
  createdAt: string;
}

/**
 * Full inventory item — the narrow list shape plus the heavy rich-text /
 * override / composite-archive fields. Returned by the single-item detail,
 * create and update endpoints. The list endpoint (GET /inventory) returns
 * InventoryListItem only, so these heavy fields must be loaded from the
 * detail endpoint when an item is opened.
 */
export type InventoryItem = InventoryListItem & ({
  /** Per-item WooCommerce push overrides. When `photoUrls` is set and non-empty it REPLACES the default composite+photoUrls for the WC push only. */
  woocommerceOverrides?: WooOverrides | null;
  /** Per-item Shopify-only spec overrides. Each field wins over the inventory-row value on push; null/empty falls back to the inventory-row value. */
  shopifyOverrides?: ShopifySpecOverrides | null;
  /** Versioned Shopify field states. Use inherit, override, or clear explicitly. */
  shopifyFieldStates?: ShopifyFieldStates | null;
  /** Per-item TikTok Shop listing overrides. Each field wins over the inventory-row value on push; null/missing falls back to the inventory-row value. */
  tiktokOverrides?: TikTokOverrides | null;
  /** Default product description (rich-text HTML). Used by every marketplace push as the body unless that channel has its own override populated. */
  descriptionHtml?: string | null;
  /** Canonical MetalUI structured product information. */
  structuredProductFields?: StructuredProductFields | null;
  /**
     * Optimistic concurrency token for Product Information and Shopify state saves.
     * @minimum 1
     */
  productInformationVersion?: number;
  /** Shopify-specific description override (HTML). When set, pushed verbatim into `product.body_html`; when null/empty, falls back to `descriptionHtml`. */
  shopifyBodyHtml?: string | null;
  /** eBay-specific description override (HTML). When null/empty, falls back to `descriptionHtml`. */
  ebayDescriptionHtml?: string | null;
  /**
     * History of previously-generated composites for this item, newest-first.
     * Every regenerate (per-item POST + admin bulk regen) prepends the
     * outgoing compositePhotoUrl with its template pin; capped at 10
     * entries, FIFO drop oldest. Marketplace push pipelines (Shopify,
     * eBay) slot these BETWEEN the primary composite and the operator's
     * raw photos so the listing keeps every accepted variant. Operators
     * can prune individual entries via DELETE
     * /inventory/{id}/composite-archive/{entryId}, or wipe everything
     * (primary + archive) via DELETE /inventory/{id}/composite.
     */
  compositeArchive?: CompositeArchiveEntry[];
});

export interface InventoryStockInResult {
  item: InventoryItem;
  movement: InventoryStockInResultMovement;
  vatWarnings: AcquisitionVatWarning[];
}

/**
 * READY — everything needed is present. NOT_READY — the structure is
 * reachable but incomplete. RECONCILIATION_FAILED — the check itself
 * could not be completed.
 */
export type VatAcquisitionEnforcementStateSchemaStatus = typeof VatAcquisitionEnforcementStateSchemaStatus[keyof typeof VatAcquisitionEnforcementStateSchemaStatus];


export const VatAcquisitionEnforcementStateSchemaStatus = {
  READY: 'READY',
  NOT_READY: 'NOT_READY',
  RECONCILIATION_FAILED: 'RECONCILIATION_FAILED',
} as const;

export type VatAcquisitionEnforcementStateSchemaDetail = {
  lotsTablePresent?: boolean;
  missingColumns?: string[];
  missingIndexes?: string[];
} | null;

export interface VatAcquisitionEnforcementState {
  /**
     * When true, new stock cannot become available until its VAT
     * treatment has been confirmed for that acquisition.
     */
  enabled: boolean;
  /**
     * When enforcement was last switched on. Cleared on disable so a
     * later re-enable never claims coverage for the gap in between.
     */
  startedAt: string | null;
  /**
     * Whether this business's database can actually store VAT
     * classifications. False means the requirement CANNOT be switched on
     * — distinct from it merely being switched off.
     */
  schemaReady?: boolean;
  /**
     * READY — everything needed is present. NOT_READY — the structure is
     * reachable but incomplete. RECONCILIATION_FAILED — the check itself
     * could not be completed.
     */
  schemaStatus?: VatAcquisitionEnforcementStateSchemaStatus;
  /**
     * Set when the requirement's own state could not be read, so
     * `enabled` is not trustworthy. Never a raw database error.
     */
  error?: string | null;
  /**
     * Set when the state is known but the requirement cannot be switched
     * on yet.
     */
  warning?: string | null;
  schemaDetail?: VatAcquisitionEnforcementStateSchemaDetail;
}

export interface VatSalesPostingReadiness {
  ready: boolean;
  recognitionReady: boolean;
  acquisitionEnforcementEnabled: boolean;
  activeRegistrationPeriod: boolean;
  /** @nullable */
  timezone: string | null;
  timezoneValid: boolean;
  /** @nullable */
  message: string | null;
}

export interface VatSalesPostingState {
  enabled: boolean;
  /** @nullable */
  enabledAt: string | null;
  /** @nullable */
  enabledByUserId: string | null;
  /** @nullable */
  enabledByUserEmail: string | null;
  /** @nullable */
  cutoverLocalDate: string | null;
  /** @nullable */
  registrationPeriodId: string | null;
  readiness: VatSalesPostingReadiness;
}

export type VatRegistrationPeriodStatus = typeof VatRegistrationPeriodStatus[keyof typeof VatRegistrationPeriodStatus];


export const VatRegistrationPeriodStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
} as const;

export type VatRegistrationPeriodJurisdiction = typeof VatRegistrationPeriodJurisdiction[keyof typeof VatRegistrationPeriodJurisdiction];


export const VatRegistrationPeriodJurisdiction = {
  GB: 'GB',
} as const;

export interface VatRegistrationPeriod {
  id: string;
  status: VatRegistrationPeriodStatus;
  jurisdiction: VatRegistrationPeriodJurisdiction;
  /** @nullable */
  vatRegistrationNumber: string | null;
  /** @pattern ^\d{4}-\d{2}-\d{2}$ */
  effectiveFrom: string;
  /**
     * @nullable
     * @pattern ^\d{4}-\d{2}-\d{2}$
     */
  effectiveTo: string | null;
  /**
     * @minimum 0
     * @maximum 10000
     */
  vatRateBasisPoints: number;
  pricesIncludeVat: boolean;
  /** @nullable */
  activatedByUserId: string | null;
  /** @nullable */
  activatedAt: string | null;
  /** @nullable */
  endedByUserId: string | null;
  /** @nullable */
  endedAt: string | null;
  createdAt: string;
}

export type VatRegistrationPeriodsStateSchemaStatus = typeof VatRegistrationPeriodsStateSchemaStatus[keyof typeof VatRegistrationPeriodsStateSchemaStatus];


export const VatRegistrationPeriodsStateSchemaStatus = {
  READY: 'READY',
  NOT_READY: 'NOT_READY',
  RECONCILIATION_FAILED: 'RECONCILIATION_FAILED',
} as const;

export interface VatRegistrationPeriodsState {
  schemaReady: boolean;
  schemaStatus: VatRegistrationPeriodsStateSchemaStatus;
  /** @nullable */
  error: string | null;
  /** @nullable */
  warning: string | null;
  periods: VatRegistrationPeriod[];
}

export type VatRegistrationPeriodInputJurisdiction = typeof VatRegistrationPeriodInputJurisdiction[keyof typeof VatRegistrationPeriodInputJurisdiction];


export const VatRegistrationPeriodInputJurisdiction = {
  GB: 'GB',
} as const;

export interface VatRegistrationPeriodInput {
  jurisdiction: VatRegistrationPeriodInputJurisdiction;
  /**
     * @minLength 1
     * @maxLength 32
     */
  vatRegistrationNumber: string;
  /** @pattern ^\d{4}-\d{2}-\d{2}$ */
  effectiveFrom: string;
  /**
     * @nullable
     * @pattern ^\d{4}-\d{2}-\d{2}$
     */
  effectiveTo?: string | null;
  /**
     * @minimum 0
     * @maximum 10000
     */
  vatRateBasisPoints: number;
  pricesIncludeVat: boolean;
}

export interface VatRegistrationPeriodEndInput {
  /** @pattern ^\d{4}-\d{2}-\d{2}$ */
  effectiveTo: string;
}

export type VatSchemaUnavailableErrorCode = typeof VatSchemaUnavailableErrorCode[keyof typeof VatSchemaUnavailableErrorCode];


export const VatSchemaUnavailableErrorCode = {
  VAT_SCHEMA_UNAVAILABLE: 'VAT_SCHEMA_UNAVAILABLE',
} as const;

export interface VatSchemaUnavailableError {
  code: VatSchemaUnavailableErrorCode;
  error: string;
  schemaReady?: boolean;
  schemaStatus?: string;
  enabled?: boolean;
}

export interface VatAcquisitionEnforcementInput {
  enabled: boolean;
}

export interface ComingSoonMarkArrivedRequest {
  /**
     * Units to move from `quantityComingSoon` to `quantity`. Must not exceed the item's current `quantityComingSoon`.
     * @minimum 1
     */
  quantity: number;
  /**
     * Coming-soon units becoming physical stock IS the acquisition, so
     * this is where their VAT treatment is confirmed.
     */
  vat?: AcquisitionVatInput | null;
}

export interface MarkComingSoonArrivedResult {
  ok: boolean;
  id: string;
  quantity: number;
  quantityComingSoon: number;
  movedUnits: number;
}

export interface ShopifyCustomerPullResult {
  pulled: number;
  created: number;
  updated: number;
  errors: string[];
}

export interface CompanyImportFailure {
  shopifyCompanyId?: string | null;
  companyName?: string | null;
  reason: string;
}

export type CompanyImportLogStatus = typeof CompanyImportLogStatus[keyof typeof CompanyImportLogStatus];


export const CompanyImportLogStatus = {
  in_progress: 'in_progress',
  success: 'success',
  partial: 'partial',
  failed: 'failed',
} as const;

export type CompanyImportLogProgress = {
  page?: number;
  processed?: number;
  total?: number | null;
  message?: string;
} | null;

export interface CompanyImportLog {
  id: string;
  /** Always 'shopify' for now. */
  source: string;
  status: CompanyImportLogStatus;
  startedAt: string;
  finishedAt?: string | null;
  companiesImported: number;
  companiesLinkedToExisting: number;
  newCustomersCreated: number;
  failedMatches: number;
  errorMessage?: string | null;
  failures: CompanyImportFailure[];
  progress?: CompanyImportLogProgress;
  createdBy?: string | null;
}

export interface ShopifyWebhook {
  id: number;
  topic: string;
  address: string;
}

export interface ShopifyWebhookRegistrationResult {
  callbackBase?: string;
  /** Topics newly registered on this call. */
  created: string[];
  /** Topics that already pointed at the correct callback URL. */
  existing: string[];
  errors: string[];
}

export type ShopifySyncStatusWebhookSubscriptionsItem = {
  topic: string;
  address: string;
};

export type ShopifySyncStatusRecentDeliveriesItem = {
  id: string;
  topic: string;
  status: string;
  error?: string | null;
  payloadId?: string | null;
  createdAt: string;
};

export type ShopifySyncStatusRecentSaleOrdersItem = {
  id: string;
  orderNumber: string;
  externalOrderNumber?: string | null;
  saleDate?: string | null;
  paymentStatus?: string | null;
  customerName?: string | null;
};

export type ShopifySyncStatusRecentImportLogsItem = {
  id: string;
  kind: string;
  filename?: string | null;
  status: string;
  totalRows?: number | null;
  failedRows?: number | null;
  createdAt?: string | null;
};

export type ShopifySyncStatusDiagnosisItemSeverity = typeof ShopifySyncStatusDiagnosisItemSeverity[keyof typeof ShopifySyncStatusDiagnosisItemSeverity];


export const ShopifySyncStatusDiagnosisItemSeverity = {
  ok: 'ok',
  warn: 'warn',
  error: 'error',
} as const;

export type ShopifySyncStatusDiagnosisItem = {
  severity: ShopifySyncStatusDiagnosisItemSeverity;
  code: string;
  message: string;
  /** Hint for the UI: which button to highlight (configure | enable | test_connection | register_webhooks | backfill | pull_now). */
  action?: string | null;
};

export interface ShopifySyncStatus {
  configured: boolean;
  enabled: boolean;
  lastSyncedAt?: string | null;
  shopDomain?: string | null;
  webhookSubscriptions?: ShopifySyncStatusWebhookSubscriptionsItem[] | null;
  webhookSubscriptionError?: string | null;
  expectedTopics: string[];
  missingTopics: string[];
  recentDeliveries: ShopifySyncStatusRecentDeliveriesItem[];
  recentSaleOrders: ShopifySyncStatusRecentSaleOrdersItem[];
  conflictCount24h: number;
  recentImportLogs: ShopifySyncStatusRecentImportLogsItem[];
  diagnosis: ShopifySyncStatusDiagnosisItem[];
}

/**
 * Which Shopify order timestamp to filter by. Defaults to updated.
 */
export type ChannelPullOrdersRequestDateBasis = typeof ChannelPullOrdersRequestDateBasis[keyof typeof ChannelPullOrdersRequestDateBasis];


export const ChannelPullOrdersRequestDateBasis = {
  updated: 'updated',
  created: 'created',
} as const;

export interface ChannelPullOrdersRequest {
  /** ISO timestamp lower bound for the selected date basis. */
  sinceISO?: string | null;
  /** Which Shopify order timestamp to filter by. Defaults to updated. */
  dateBasis?: ChannelPullOrdersRequestDateBasis;
  /** Pull all Shopify orders from the epoch; cannot be combined with the created date basis. */
  backfill?: boolean;
}

export type ChannelPullOrdersResultErrorsItem = {
  externalOrderId?: string;
  message?: string;
};

export interface ChannelPullOrdersResult {
  imported: number;
  /** Orders already imported (matched by externalOrderNumber + channel). */
  skipped: number;
  failed: number;
  sinceISO?: string;
  salesCreatedIds: string[];
  errors?: ChannelPullOrdersResultErrorsItem[];
  /** True when the pull stopped at its safety page limit and more orders may remain. */
  pageCapReached?: boolean;
}

export interface EbayPullOrdersRequest {
  /** ISO timestamp; defaults to integration.lastSyncedAt or 14 days ago. */
  sinceISO?: string | null;
  /** Which eBay account key to pull from. Defaults to "primary". */
  accountKey?: string | null;
}

export type EbayPullOrdersResultErrorsItem = {
  ebayOrderId?: string;
  message?: string;
};

export interface EbayPullOrdersResult {
  imported: number;
  /** Orders already imported (matched by externalOrderNumber + channel=ebay). */
  skipped: number;
  failed: number;
  sinceISO?: string;
  salesCreatedIds: string[];
  errors?: EbayPullOrdersResultErrorsItem[];
}

export interface EbayTestRequest {
  /** Which eBay account key to test. Defaults to "primary". */
  accountKey: string;
}

export interface EbayTestResult {
  ok: boolean;
  accountKey: string;
  sellerUsername?: string | null;
  marketplaceId?: string | null;
  message?: string | null;
}

export type EbayConnectionSweepClassification = typeof EbayConnectionSweepClassification[keyof typeof EbayConnectionSweepClassification];


export const EbayConnectionSweepClassification = {
  not_configured: 'not_configured',
  disabled: 'disabled',
  demo_skipped: 'demo_skipped',
  invalid_credentials: 'invalid_credentials',
  provider_failure: 'provider_failure',
  internal_failure: 'internal_failure',
  success: 'success',
} as const;

export interface EbayConnectionSweepResult {
  tenantId: string;
  tenantSlug: string;
  tenantName: string;
  accountKey: string | null;
  classification: EbayConnectionSweepClassification;
  checkedAt: string;
  marketplaceId: string | null;
  diagnostic: string;
}

export interface EbayConnectionSweepCounts {
  not_configured: number;
  disabled: number;
  demo_skipped: number;
  invalid_credentials: number;
  provider_failure: number;
  internal_failure: number;
  success: number;
}

export interface EbayConnectionSweepResultSet {
  startedAt: string;
  completedAt: string;
  totalTenants: number;
  totalAccounts: number;
  checkedAccounts: number;
  counts: EbayConnectionSweepCounts;
  results: EbayConnectionSweepResult[];
}

export type EbayConnectionSweepJobState = typeof EbayConnectionSweepJobState[keyof typeof EbayConnectionSweepJobState];


export const EbayConnectionSweepJobState = {
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type EbayConnectionSweepJobResult = { [key: string]: unknown };

export interface EbayConnectionSweepJob {
  id: string;
  state: EbayConnectionSweepJobState;
  status: string;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
  result: EbayConnectionSweepJobResult;
  error: string | null;
}

/**
 * @nullable
 */
export type EbayConnectionSweepResultsResponseState = typeof EbayConnectionSweepResultsResponseState[keyof typeof EbayConnectionSweepResultsResponseState] | null;


export const EbayConnectionSweepResultsResponseState = {
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export interface EbayConnectionSweepResultsResponse {
  /** @nullable */
  jobId: string | null;
  /** @nullable */
  state: EbayConnectionSweepResultsResponseState;
  results: EbayConnectionSweepResult[];
}

export interface EbayConnectionSweepJobResponse {
  job: EbayConnectionSweepJob | null;
}

export interface EbayCategorySuggestion {
  /** eBay leaf category id (numeric string, up to ~12 digits). Saved verbatim into `inventory_items.ebay_category_id`. */
  categoryId: string;
  /** Display name of the leaf category, e.g. "Bullion Coins". */
  categoryName: string;
  /** Full ancestor chain root → leaf joined by " › ", e.g. "Coins & Paper Money › Coins › Bullion Coins". */
  categoryPath: string;
  /** Always true — `get_category_suggestions` only returns leaves. Flag is kept so the UI can defend if eBay ever changes that. */
  leafCategory: boolean;
}

export type EbayMessageDirection = typeof EbayMessageDirection[keyof typeof EbayMessageDirection];


export const EbayMessageDirection = {
  in: 'in',
  out: 'out',
} as const;

export interface EbayMessage {
  id: string;
  externalMessageId: string;
  subject?: string | null;
  sender?: string | null;
  snippet?: string | null;
  body?: string | null;
  externalOrderId?: string | null;
  receivedAt?: string | null;
  readAt?: string | null;
  threadId: string;
  parentExternalId?: string | null;
  direction: EbayMessageDirection;
  sentAt?: string | null;
}

export interface EbayMessageThread {
  threadId: string;
  messages: EbayMessage[];
}

export interface EbayMessageReplyRequest {
  /** Plain-text reply body. eBay caps at 2000 characters; longer input is truncated server-side. */
  body: string;
}

export interface EbayMessageReplyResult {
  ok: boolean;
  replyId?: string | null;
  threadId?: string | null;
}

export interface EbayMessageSyncResult {
  ok: boolean;
  fetched?: number | null;
  upserted?: number | null;
  message?: string | null;
}

export interface EbayMessageMarkReadResult {
  ok: boolean;
  alreadyRead?: boolean | null;
}

export type PushChannelResultChannel = typeof PushChannelResultChannel[keyof typeof PushChannelResultChannel];


export const PushChannelResultChannel = {
  shopify: 'shopify',
  ebay: 'ebay',
  woocommerce: 'woocommerce',
} as const;

export interface PushChannelResult {
  channel: PushChannelResultChannel;
  ok: boolean;
  message?: string | null;
}

/**
 * Unsaved master product information patch; never persisted by this operation.
 */
export type ProductInformationImpactInputPatch = { [key: string]: unknown };

export interface ProductInformationImpactInput {
  /** Unsaved master product information patch; never persisted by this operation. */
  patch?: ProductInformationImpactInputPatch;
}

export type ProductInformationImpactFieldSource = typeof ProductInformationImpactFieldSource[keyof typeof ProductInformationImpactFieldSource];


export const ProductInformationImpactFieldSource = {
  inherited: 'inherited',
  override: 'override',
  skipped: 'skipped',
} as const;

export interface ProductInformationImpactField {
  field: string;
  label?: string;
  source: ProductInformationImpactFieldSource;
  reason?: string;
  value?: unknown;
  changed: boolean;
}

export interface ProductInformationImpactChannel {
  channel: string;
  status?: string;
  fields: ProductInformationImpactField[];
}

export interface ProductInformationImpactResult {
  channels: ProductInformationImpactChannel[];
}

export interface PushToMarketplacesResult {
  results: PushChannelResult[];
}

/**
 * `reconnected` — rebound to an existing Shopify product by SKU; `created` — no SKU match, a new product was created; `failed` — recovery did not succeed (see `message`).
 */
export type ShopifyRecoverLinkResultOutcome = typeof ShopifyRecoverLinkResultOutcome[keyof typeof ShopifyRecoverLinkResultOutcome];


export const ShopifyRecoverLinkResultOutcome = {
  reconnected: 'reconnected',
  created: 'created',
  failed: 'failed',
} as const;

export interface ShopifyRecoverLinkResult {
  ok: boolean;
  /** `reconnected` — rebound to an existing Shopify product by SKU; `created` — no SKU match, a new product was created; `failed` — recovery did not succeed (see `message`). */
  outcome: ShopifyRecoverLinkResultOutcome;
  message: string;
}

export interface ShopifyStaleLinkItem {
  id: string;
  sku: string;
  productTitle: string;
  /** The last Shopify sync error recorded for this item, if any. */
  lastError?: string | null;
}

export interface ShopifyStaleLinkList {
  items: ShopifyStaleLinkItem[];
  /** Total number of stale-linked items. */
  total: number;
}

export interface ShopifyRecoverLinksBody {
  /** Explicit inventory item ids to recover. Only ids that are actually stale-linked are processed; the rest are ignored. Omit (or send null/empty) to recover every stale item. */
  ids?: string[] | null;
}

export type ShopifyBulkRecoverLinkItemOutcome = typeof ShopifyBulkRecoverLinkItemOutcome[keyof typeof ShopifyBulkRecoverLinkItemOutcome];


export const ShopifyBulkRecoverLinkItemOutcome = {
  reconnected: 'reconnected',
  created: 'created',
  failed: 'failed',
} as const;

export interface ShopifyBulkRecoverLinkItem {
  id: string;
  sku: string;
  ok: boolean;
  outcome: ShopifyBulkRecoverLinkItemOutcome;
  message: string;
}

export interface ShopifyBulkRecoverLinkResult {
  /** Number of items the run actually processed. */
  total: number;
  /** Items rebound to an existing Shopify product by SKU. */
  reconnected: number;
  /** Items for which a new Shopify product was created. */
  created: number;
  /** Items whose recovery did not succeed. */
  failed: number;
  results: ShopifyBulkRecoverLinkItem[];
}

export interface EbayPushItemResult {
  ok: boolean;
  message?: string | null;
  sku?: string | null;
  quantity?: number | null;
}

export type MarketplaceSummaryRecentByChannelItem = {
  channel: string;
  count: number;
};

export interface MarketplaceSummary {
  /** Sale orders created in the last 7 days, across all channels. */
  totalRecentOrders: number;
  /** Sale orders with paymentStatus = "Awaiting payment". */
  awaitingPayment: number;
  /** Cached eBay messages that have not been marked read. */
  unreadMessages: number;
  /** Timestamp of the most recent successful eBay order sync. */
  lastSyncAt?: string | null;
  ebayConfigured: boolean;
  ebayEnabled: boolean;
  recentByChannel: MarketplaceSummaryRecentByChannelItem[];
}

/**
 * A representative existing inventory item for a brand + title group.
 * Returned by `/inventory/match` to power the "Map to existing product"
 * panel on PO receive. `lotCount` and `totalAvailable` summarise the
 * whole group; the other fields come from the most recently received
 * member of the group.
 */
export interface InventoryMatchSuggestion {
  /** ID of the most-recently-received inventory item in this group. */
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  /** Decimal string (matches `InventoryItem.weightGrams`). */
  weightGrams?: string | null;
  /**
     * Alias of `latestLandedCost`, kept for back-compat. Prefer
     * `latestLandedCost` for "most recent receipt" and
     * `weightedAvgLandedCost` for a blended group cost.
     */
  landedUnitCost?: number | null;
  /**
     * Landed cost (GBP) from the most-recently-created lot in this
     * group that has a non-null cost. `null` if no lot has a cost.
     */
  latestLandedCost?: number | null;
  /**
     * Weighted-avg landed cost (GBP) across the group. Weighted by
     * AVAILABLE qty (operator rule) when any lot still has stock;
     * falls back to total-qty weighting when the whole group is sold
     * out so the historical paid cost still shows.
     */
  weightedAvgLandedCost?: number | null;
  /** Number of inventory_items rows in this brand+title group. */
  lotCount: number;
  /** Sum of `quantityAvailable` across all lots in this group. */
  totalAvailable: number;
}

export interface InventoryFilterMetadata {
  /** Distinct non-empty product types across the tenant catalogue. */
  productTypes: string[];
}

export type InventoryMintageReviewItemReason = typeof InventoryMintageReviewItemReason[keyof typeof InventoryMintageReviewItemReason];


export const InventoryMintageReviewItemReason = {
  conflict: 'conflict',
  invalid: 'invalid',
} as const;

export interface InventoryMintageReviewItem {
  id: string;
  sku: string;
  productTitle: string;
  /**
     * Original legacy text
     * @nullable
     */
  mintage: string | null;
  /**
     * JSON representation of the original structured value
     * @nullable
     */
  maximumMintage: string | null;
  reason: InventoryMintageReviewItemReason;
}

export interface InventoryMintageReviewPage {
  total: number;
  page: number;
  pageSize: number;
  items: InventoryMintageReviewItem[];
}

export type MobileInventoryListItemStockType = typeof MobileInventoryListItemStockType[keyof typeof MobileInventoryListItemStockType];


export const MobileInventoryListItemStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type MobileInventoryListItemChannelsItem = {
  channel: string;
  state: string;
  listingId?: string | null;
  offerId?: string | null;
  productId?: string | null;
  url?: string | null;
  lastSyncedAt?: string | null;
  lastError?: string | null;
  staleLink?: boolean;
};

/**
 * Narrow mobile card projection. It includes asking price, permission-gated
 * landed cost, exact item channel selections, and compact listing status;
 * it excludes profit, rich text, cost lots, sales history, and marketplace payload.
 */
export interface MobileInventoryListItem {
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  purity?: string | null;
  barcode?: string | null;
  quantity: number;
  quantityReserved: number;
  quantitySold: number;
  quantityDamaged: number;
  quantityAvailable: number;
  quantityComingSoon: number;
  status: string;
  stockType: MobileInventoryListItemStockType;
  currency: string;
  currentAskingPrice?: number | null;
  /** Null unless the caller has landed-cost permission. */
  landedUnitCost: number | null;
  /** Prepared base asking-price movement percentage over the last 30 days. Null when unavailable or stale. */
  priceChange30d?: number | null;
  salesChannel?: string | null;
  listingUrl?: string | null;
  /**
     * Authenticated mobile thumbnail endpoint. It reads the tenant-owned
     * source and returns a bounded 160x160 WebP derivative; if a legacy
     * source cannot be transformed it may fall back to the original
     * authenticated image path.
     */
  thumbnailUrl?: string | null;
  storageLocation?: string | null;
  supplierName?: string | null;
  /** Exact Listings & Channels selections from the inventory item; not inferred from external listing state or legacy salesChannel. */
  selectedChannels: string[];
  /** Tenant-authorized marketplace account labels with a broken link under the active broken-link filter. */
  brokenLinkAccounts?: InventoryMarketplaceAccountLabel[];
  /** Compact channel identity/state projection; never includes marketplace payloads. */
  channels: MobileInventoryListItemChannelsItem[];
  /** @maxItems 2 */
  flags?: CompactFlagRef[];
  /** @minimum 0 */
  flagOverflowCount: number;
  createdAt?: string;
}

export interface MobileInventoryListResponse {
  /** @maxItems 30 */
  items: MobileInventoryListItem[];
  /** @minimum 0 */
  total: number;
  /** @minimum 1 */
  page: number;
  /**
     * @minimum 1
     * @maximum 30
     */
  pageSize: number;
  hasNextPage: boolean;
  /**
     * Opaque cursor for the next stable page, or null when the catalogue is exhausted.
     * @nullable
     */
  nextCursor: string | null;
}

export type InventoryOperatorSnapshotQuantities = {
  onHand: number;
  reserved: number;
  sold: number;
  damaged: number;
  available: number;
  comingSoon: number;
};

export type InventoryOperatorSnapshotOwnershipStockType = typeof InventoryOperatorSnapshotOwnershipStockType[keyof typeof InventoryOperatorSnapshotOwnershipStockType];


export const InventoryOperatorSnapshotOwnershipStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type InventoryOperatorSnapshotOwnership = {
  stockType: InventoryOperatorSnapshotOwnershipStockType;
  quantityOwned: number;
  consignmentQuantity: number;
  supplierPayoutPrice?: number | null;
  consignmentPayoutType?: string | null;
  supplierSplitPct?: number | null;
  businessSplitPct?: number | null;
};

export type InventoryOperatorSnapshotPricing = {
  currency: string;
  askingPrice: number | null;
  estimatedResalePrice: number | null;
  minimumAcceptablePrice: number | null;
  landedUnitCost: number | null;
  ownedUnitCost: number | null;
  /** Available units multiplied by landed cost; null without cost permission. */
  inventoryValueGbp: number | null;
  /** Estimated resale less landed cost; never realised/True Profit. */
  estimatedProfitGbp: number | null;
  /** Estimated resale margin; never realised/True Margin. */
  estimatedMarginPct: number | null;
};

export type InventoryOperatorSnapshotSupplier = {
  id: string | null;
  name: string | null;
};

export type InventoryOperatorSnapshotLocation = {
  storageLocation: string | null;
};

export type InventoryOperatorSnapshotIncoming = {
  quantityComingSoon: number;
  purchaseOrderNumber: string | null;
};

export type InventoryOperatorSnapshotListingsItem = {
  channel: string;
  listingId?: string | null;
  offerId?: string | null;
  productId?: string | null;
  url?: string | null;
  status?: string | null;
};

export type InventoryOperatorSnapshotSparkline30dItem = {
  date: string;
  available: number;
};

/**
 * Compact on-demand information for an expanded mobile inventory card.
 * Monetary fields are nullable and are server-redacted by permission.
 */
export interface InventoryOperatorSnapshot {
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  purity?: string | null;
  barcode?: string | null;
  status?: string;
  quantities: InventoryOperatorSnapshotQuantities;
  ownership: InventoryOperatorSnapshotOwnership;
  pricing?: InventoryOperatorSnapshotPricing;
  supplier: InventoryOperatorSnapshotSupplier;
  location: InventoryOperatorSnapshotLocation;
  incoming: InventoryOperatorSnapshotIncoming;
  listings: InventoryOperatorSnapshotListingsItem[];
  flags: CompactFlagRef[];
  /** Optional cheap pre-aggregated movement rollup; omitted when unavailable. */
  sparkline30d?: InventoryOperatorSnapshotSparkline30dItem[] | null;
}

export type LiveStockExportItemStockType = typeof LiveStockExportItemStockType[keyof typeof LiveStockExportItemStockType];


export const LiveStockExportItemStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export interface LiveStockExportItem {
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  purity?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  lengthCm?: number | null;
  widthCm?: number | null;
  heightCm?: number | null;
  weightGrams?: number | null;
  barcode?: string | null;
  quantity: number;
  quantityReserved: number;
  quantitySold: number;
  quantityDamaged: number;
  quantityAvailable: number;
  landedUnitCost: number | null;
  estimatedResalePrice?: number | null;
  currentAskingPrice?: number | null;
  minimumAcceptablePrice?: number | null;
  currency: string;
  serialNumber?: string | null;
  assayNumber?: string | null;
  /** Positive whole-number maximum mintage; an explicit edit updates both representations and requires expectedProductInformationVersion. */
  mintage?: string | null;
  year?: number | null;
  condition?: string | null;
  storageLocation?: string | null;
  status: string;
  stockType: LiveStockExportItemStockType;
  supplierId?: string | null;
  supplierName?: string | null;
  purchaseOrderNumber?: string | null;
  salesChannel?: string | null;
  listingUrl?: string | null;
  syncChannels?: string[];
  notes?: string | null;
  packerNote?: string | null;
  regionOfOrigin?: string | null;
  descriptionHtml?: string | null;
  structuredProductFields?: StructuredProductFields | null;
}

export interface LiveStockExportResponse {
  /** Effective ordered field keys for the authenticated member. Empty means the legacy four-column export. */
  liveStockExportFields: string[];
  /** True when the member has an explicit override, including an explicit empty list. */
  hasUserOverride: boolean;
  items: LiveStockExportItem[];
}

export interface InventorySummary {
  totalSkus: number;
  unitsInStock: number;
  onHoldUnits: number;
  ownedUnits: number;
  consignmentUnits: number;
}

export type InventoryGridItemStockType = typeof InventoryGridItemStockType[keyof typeof InventoryGridItemStockType];


export const InventoryGridItemStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

/**
 * Per-line payout method for CONSIGNMENT stock. Snapshotted onto sale lines.
 */
export type InventoryGridItemConsignmentPayoutType = typeof InventoryGridItemConsignmentPayoutType[keyof typeof InventoryGridItemConsignmentPayoutType] | null;


export const InventoryGridItemConsignmentPayoutType = {
  FIXED_PER_UNIT: 'FIXED_PER_UNIT',
  PROFIT_SPLIT_PCT: 'PROFIT_SPLIT_PCT',
} as const;

/**
 * Explains the lifetime realised-profit value in this grid row.
 * `no_sales` means the value is zero because there are no realised
 * sale lines. `unresolved_source_cogs` means at least one realised
 * sale has unresolved source cost, so no aggregate is reported and
 * no replacement cost is inferred. `enrichment_deferred` means this
 * page did not request the optional profit aggregate.
 * `finance_permission_redacted` means the caller cannot view P&L.
 * `available` means a confirmed aggregate is present.
 */
export type InventoryGridItemRealizedProfitStatus = typeof InventoryGridItemRealizedProfitStatus[keyof typeof InventoryGridItemRealizedProfitStatus];


export const InventoryGridItemRealizedProfitStatus = {
  available: 'available',
  no_sales: 'no_sales',
  unresolved_source_cogs: 'unresolved_source_cogs',
  enrichment_deferred: 'enrichment_deferred',
  finance_permission_redacted: 'finance_permission_redacted',
} as const;

/**
 * Map of channel slug to external listing metadata (offerId/listingId/url/lastError).
 */
export type InventoryGridItemExternalListings = {[key: string]: ExternalListing} | null;

/**
 * SKU role for the breakdown / transformation feature.
 * * `source` — raw mixed lot (e.g. MIX-XXXXX) that operators
 *   decompose into N child sellable SKUs. Cannot itself be sold.
 * * `sellable` — downstream child SKU. Default for everything
 *   created the normal way.
 * * `both` — bridge row that can act as either source or output.
 * Frontend gates the "Break down" CTA on this; backend
 * `executeBreakdown` rejects mismatches with HTTP 422.
 */
export type InventoryGridItemProductKind = typeof InventoryGridItemProductKind[keyof typeof InventoryGridItemProductKind];


export const InventoryGridItemProductKind = {
  source: 'source',
  sellable: 'sellable',
  both: 'both',
} as const;

/**
 * VAT treatment chosen for this stock line. `null` = unclassified (badged amber until set).
 */
export type InventoryGridItemVatTreatment = typeof InventoryGridItemVatTreatment[keyof typeof InventoryGridItemVatTreatment] | null;


export const InventoryGridItemVatTreatment = {
  MARGIN_SCHEME: 'MARGIN_SCHEME',
  STANDARD_VAT: 'STANDARD_VAT',
  VAT_EXEMPT_GOLD: 'VAT_EXEMPT_GOLD',
  OUTSIDE_SCOPE: 'OUTSIDE_SCOPE',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
} as const;

export type InventoryGridItemPurchaseSource = typeof InventoryGridItemPurchaseSource[keyof typeof InventoryGridItemPurchaseSource] | null;


export const InventoryGridItemPurchaseSource = {
  PUBLIC: 'PUBLIC',
  UK_DEALER: 'UK_DEALER',
  OVERSEAS_DEALER: 'OVERSEAS_DEALER',
  CONSIGNMENT: 'CONSIGNMENT',
  MINT_MANUFACTURER: 'MINT_MANUFACTURER',
  OTHER: 'OTHER',
} as const;

export type InventoryGridItemStockCondition = typeof InventoryGridItemStockCondition[keyof typeof InventoryGridItemStockCondition] | null;


export const InventoryGridItemStockCondition = {
  SECOND_HAND: 'SECOND_HAND',
  NEW: 'NEW',
  COLLECTIBLE: 'COLLECTIBLE',
  BULLION: 'BULLION',
  SCRAP_MELT: 'SCRAP_MELT',
  UNKNOWN: 'UNKNOWN',
} as const;

export type InventoryGridItemSellerVatStatus = typeof InventoryGridItemSellerVatStatus[keyof typeof InventoryGridItemSellerVatStatus] | null;


export const InventoryGridItemSellerVatStatus = {
  NON_VAT_REGISTERED: 'NON_VAT_REGISTERED',
  VAT_REGISTERED: 'VAT_REGISTERED',
  MARGIN_SCHEME_DEALER: 'MARGIN_SCHEME_DEALER',
  UNKNOWN: 'UNKNOWN',
} as const;

/**
 * Operator-set review state. Backed by a partial GIN index for the Phase 3 backfill queue.
 */
export type InventoryGridItemVatReviewStatus = typeof InventoryGridItemVatReviewStatus[keyof typeof InventoryGridItemVatReviewStatus] | null;


export const InventoryGridItemVatReviewStatus = {
  CONFIRMED: 'CONFIRMED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  MISSING_EVIDENCE: 'MISSING_EVIDENCE',
} as const;

/**
 * Per-item valuation classification used by the Inventory Valuation
 * Engine (feature flag: advanced_inventory_valuation_enabled).
 * * `spot_tracked` — Standard bullion; eligible for commodity silver average.
 * * `premium`      — Premium/Collectible; excluded from average.
 * * `hybrid`       — Both metal and premium components; metal part included in average.
 * * `excluded`     — Non-metal item (certificates, cases); excluded.
 * * `custom`       — Custom valuation basis; excluded from average.
 * `null` = unclassified (treated as spot_tracked for backward compat).
 */
export type InventoryGridItemValuationMethod = typeof InventoryGridItemValuationMethod[keyof typeof InventoryGridItemValuationMethod] | null;


export const InventoryGridItemValuationMethod = {
  spot_tracked: 'spot_tracked',
  premium: 'premium',
  hybrid: 'hybrid',
  excluded: 'excluded',
  custom: 'custom',
} as const;

/**
 * Compact row for the desktop Inventory grid. It retains the standard
 * list fields needed for stock display, permissions, redaction, and row
 * actions, but omits galleries, notes, composite history, and marketplace
 * editor metadata. Those values remain available from the full list,
 * export, and item-detail contracts.
 */
export interface InventoryGridItem {
  flags?: CompactFlagRef[];
  stockType: InventoryGridItemStockType;
  /** Exact item channel selections from Listings & Channels. */
  syncChannels: string[];
  supplierPayoutPrice?: number | null;
  consignmentPayoutType?: InventoryGridItemConsignmentPayoutType;
  consignmentSupplierSplitPct?: number | null;
  consignmentBusinessSplitPct?: number | null;
  consignmentTargetSalePriceGbp?: number | null;
  consignmentBatchId?: string | null;
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  productType?: string | null;
  metal?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  lengthCm?: number | null;
  widthCm?: number | null;
  heightCm?: number | null;
  weightGrams?: number | null;
  purity?: string | null;
  quantity: number;
  quantityReserved: number;
  quantitySold: number;
  quantityDamaged?: number;
  quantityAvailable: number;
  quantityComingSoon?: number | null;
  childCount?: number | null;
  childQuantity?: number | null;
  childQuantityReserved?: number | null;
  childQuantitySold?: number | null;
  childQuantityDamaged?: number | null;
  childQuantityAvailable?: number | null;
  childQuantityComingSoon?: number | null;
  shopifyEligibility?: ShopifyEligibility | null;
  quantityOwned?: number;
  ownedUnitCost?: number | null;
  landedUnitCost: number;
  totalCost: number;
  estimatedResalePrice?: number | null;
  currentAskingPrice?: number | null;
  minimumAcceptablePrice?: number | null;
  currency?: string;
  serialNumber?: string | null;
  assayNumber?: string | null;
  mintage?: string | null;
  year?: number | null;
  condition?: string | null;
  conditionFlags?: string[] | null;
  storageLocation?: string | null;
  status: string;
  salesChannel?: string | null;
  listingUrl?: string | null;
  photoUrl?: string | null;
  syncToEbay?: boolean;
  supplierId?: string | null;
  supplierName?: string | null;
  purchaseOrderId?: string | null;
  purchaseOrderNumber?: string | null;
  marginPct?: number | null;
  realizedProfitGbp?: number | null;
  realizedGrossProfitGbp?: number | null;
  realizedConsignorShareGbp?: number | null;
  /**
     * Explains the lifetime realised-profit value in this grid row.
     * `no_sales` means the value is zero because there are no realised
     * sale lines. `unresolved_source_cogs` means at least one realised
     * sale has unresolved source cost, so no aggregate is reported and
     * no replacement cost is inferred. `enrichment_deferred` means this
     * page did not request the optional profit aggregate.
     * `finance_permission_redacted` means the caller cannot view P&L.
     * `available` means a confirmed aggregate is present.
     */
  realizedProfitStatus: InventoryGridItemRealizedProfitStatus;
  externalListings?: InventoryGridItemExternalListings;
  brokenLinkAccounts?: InventoryMarketplaceAccountLabel[];
  categoryIds?: string[];
  productKind?: InventoryGridItemProductKind;
  masterInventoryItemId?: string | null;
  vatTreatment?: InventoryGridItemVatTreatment;
  purchaseSource?: InventoryGridItemPurchaseSource;
  stockCondition?: InventoryGridItemStockCondition;
  sellerVatStatus?: InventoryGridItemSellerVatStatus;
  invoiceShowsMarginScheme?: boolean | null;
  vatShownOnInvoice?: boolean | null;
  imported?: boolean | null;
  importVatPaid?: boolean | null;
  vatReviewStatus?: InventoryGridItemVatReviewStatus;
  vatClassificationComplete?: boolean;
  needsSkuReview?: boolean;
  valuationMethod?: InventoryGridItemValuationMethod;
  includeInMetalAverage?: boolean | null;
  createdAt: string;
  /** The image URL rendered by the grid, resolved from the composite or photo gallery. */
  gridImageUrl: string | null;
}

export interface InventoryGridResponse {
  items: InventoryGridItem[];
  /** Total number of items matching the current filters (before pagination). */
  total: number;
}

export type CatalogueIntelligenceFoundationNamespace = typeof CatalogueIntelligenceFoundationNamespace[keyof typeof CatalogueIntelligenceFoundationNamespace];


export const CatalogueIntelligenceFoundationNamespace = {
  'catalogue-intelligence': 'catalogue-intelligence',
} as const;

export type CatalogueIntelligenceFoundationAsynchronousStatesItem = typeof CatalogueIntelligenceFoundationAsynchronousStatesItem[keyof typeof CatalogueIntelligenceFoundationAsynchronousStatesItem];


export const CatalogueIntelligenceFoundationAsynchronousStatesItem = {
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
} as const;

export interface CatalogueIntelligenceFoundation {
  namespace: CatalogueIntelligenceFoundationNamespace;
  contractsVersion: string;
  enabledFeatures: string[];
  asynchronousStates: CatalogueIntelligenceFoundationAsynchronousStatesItem[];
}

export interface CatalogueCheckInput {
  /**
     * @maxItems 500
     * @items.maxLength 200
     */
  productKeys?: string[];
  /**
     * @maxItems 50
     * @items.maxLength 120
     */
  fields?: string[];
}

export type CatalogueAsyncJobStatus = typeof CatalogueAsyncJobStatus[keyof typeof CatalogueAsyncJobStatus];


export const CatalogueAsyncJobStatus = {
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
} as const;

export interface CatalogueAsyncJob {
  /** @nullable */
  jobId: string | null;
  status: CatalogueAsyncJobStatus;
}

export type CatalogueStatusState = typeof CatalogueStatusState[keyof typeof CatalogueStatusState];


export const CatalogueStatusState = {
  idle: 'idle',
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  degraded: 'degraded',
  unavailable: 'unavailable',
} as const;

export interface CatalogueStatus {
  enabled: boolean;
  state: CatalogueStatusState;
  /** @nullable */
  lastCheckedAt: string | null;
  /** @nullable */
  completeness?: number | null;
  /** @nullable */
  verification?: number | null;
  /** @minimum 0 */
  missing?: number;
  /** @minimum 0 */
  suggestions?: number;
  /** @minimum 0 */
  conflicts?: number;
}

export interface CatalogueItemHealth {
  productKey: string;
  /** @nullable */
  completeness: number | null;
  /** @nullable */
  verification: number | null;
  /** @minimum 0 */
  missing: number;
  /** @minimum 0 */
  suggestions: number;
  /** @minimum 0 */
  conflicts: number;
  /** @nullable */
  lastChecked: string | null;
  /** @nullable */
  sourceWatermark?: string | null;
  /** @nullable */
  lastGoodAt?: string | null;
  freshnessStatus?: string;
}

export interface CatalogueEvidence {
  id: string;
  factId?: string;
  fieldKey: string;
  fieldValue: unknown;
  status: string;
  /** @nullable */
  confidence: number | null;
  /** @nullable */
  source: string | null;
  /** @nullable */
  retrievedAt: string | null;
  decisionReason: unknown;
}

export interface CatalogueReviewInput {
  /** @minimum 1 */
  expectedVersion: number;
  /** @maxLength 64 */
  decisionKey?: string;
}

export interface CatalogueRecheckInput {
  /** @maxLength 64 */
  decisionKey?: string;
}

export interface CatalogueLockInput {
  /** @maxLength 200 */
  productKey: string;
  /** @maxLength 120 */
  fieldKey: string;
  /** @maxLength 500 */
  reason?: string | null;
}

export type CatalogueBulkReviewResultResultsItem = { [key: string]: unknown };

export interface CatalogueBulkReviewResult {
  results: CatalogueBulkReviewResultResultsItem[];
  /** @minimum 0 */
  accepted: number;
}

export type CataloguePageItemsItem = { [key: string]: unknown };

export interface CataloguePage {
  items: CataloguePageItemsItem[];
  /** @minimum 1 */
  page: number;
  /**
     * @minimum 1
     * @maximum 100
     */
  pageSize: number;
  /** @minimum 0 */
  total: number;
  hasMore: boolean;
}

export interface CatalogueReportItem {
  id: string;
  productKey: string;
  fieldKey: string;
  value?: unknown;
  normalizedValue?: unknown;
  /** @nullable */
  confidence?: number | null;
  status: string;
  /** @nullable */
  valueOrigin?: string | null;
  version?: number;
  /** @nullable */
  updatedAt: string | null;
}

export interface CatalogueReportPage {
  items: CatalogueReportItem[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}

export interface CatalogueEvidencePage {
  items: CatalogueEvidence[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}

export interface CatalogueSuggestion {
  id: string;
  productKey: string;
  fieldKey: string;
  status: string;
  version?: number;
  [key: string]: unknown;
 }

export interface CatalogueSuggestionPage {
  items: CatalogueSuggestion[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}

export interface CatalogueAudit {
  id: string;
  action: string;
  entityType: string;
  /** @nullable */
  entityId?: string | null;
  createdAt: string;
}

export interface CatalogueAuditPage {
  items: CatalogueAudit[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}

export interface CatalogueSettings {
  /**
     * @minimum 1
     * @maximum 100000
     */
  monthlyLimit: number;
  /** @minimum 0 */
  usedCount: number;
  /** @nullable */
  updatedAt: string | null;
}

export interface CatalogueSettingsInput {
  /**
     * @minimum 1
     * @maximum 100000
     */
  monthlyLimit: number;
}

export interface CatalogueLockAction {
  id: string;
  locked: boolean;
}

export type CatalogueBulkReviewInputDecision = typeof CatalogueBulkReviewInputDecision[keyof typeof CatalogueBulkReviewInputDecision];


export const CatalogueBulkReviewInputDecision = {
  approve: 'approve',
  reject: 'reject',
} as const;

export type CatalogueBulkReviewInputExpectedVersions = {[key: string]: number};

export interface CatalogueBulkReviewInput {
  /**
     * @minItems 1
     * @maxItems 100
     */
  suggestionIds: string[];
  decision: CatalogueBulkReviewInputDecision;
  expectedVersions: CatalogueBulkReviewInputExpectedVersions;
}

export type UpsertValuationProfileBodyValuationMethod = typeof UpsertValuationProfileBodyValuationMethod[keyof typeof UpsertValuationProfileBodyValuationMethod];


export const UpsertValuationProfileBodyValuationMethod = {
  spot_tracked: 'spot_tracked',
  premium: 'premium',
  hybrid: 'hybrid',
  excluded: 'excluded',
  custom: 'custom',
} as const;

export type UpsertValuationProfileBodyValuationSource = typeof UpsertValuationProfileBodyValuationSource[keyof typeof UpsertValuationProfileBodyValuationSource] | null;


export const UpsertValuationProfileBodyValuationSource = {
  cost: 'cost',
  market: 'market',
  appraised: 'appraised',
  manual: 'manual',
  other: 'other',
} as const;

export interface UpsertValuationProfileBody {
  valuationMethod: UpsertValuationProfileBodyValuationMethod;
  metalType?: string | null;
  fineMetalWeightOzt?: number | null;
  hybridMetalComponent?: number | null;
  hybridPremiumComponent?: number | null;
  acquisitionCost?: number | null;
  currentSellingPrice?: number | null;
  manualValuation?: number | null;
  valuationSource?: UpsertValuationProfileBodyValuationSource;
  valuationNotes?: string | null;
  reviewDate?: string | null;
  valuationExpiresAt?: string | null;
  exclusionReason?: string | null;
  customValuationBasis?: string | null;
  customValuationValue?: number | null;
  classificationNote?: string | null;
}

export type ValuationProfileHistoryPreviousMethod = typeof ValuationProfileHistoryPreviousMethod[keyof typeof ValuationProfileHistoryPreviousMethod] | null;


export const ValuationProfileHistoryPreviousMethod = {
  spot_tracked: 'spot_tracked',
  premium: 'premium',
  hybrid: 'hybrid',
  excluded: 'excluded',
  custom: 'custom',
} as const;

export type ValuationProfileHistoryNewMethod = typeof ValuationProfileHistoryNewMethod[keyof typeof ValuationProfileHistoryNewMethod];


export const ValuationProfileHistoryNewMethod = {
  spot_tracked: 'spot_tracked',
  premium: 'premium',
  hybrid: 'hybrid',
  excluded: 'excluded',
  custom: 'custom',
} as const;

export type ValuationProfileHistoryChangeSource = typeof ValuationProfileHistoryChangeSource[keyof typeof ValuationProfileHistoryChangeSource];


export const ValuationProfileHistoryChangeSource = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  BULK_MIGRATION: 'BULK_MIGRATION',
  IMPORT: 'IMPORT',
} as const;

export interface ValuationProfileHistory {
  id: string;
  inventoryItemId: string;
  previousMethod?: ValuationProfileHistoryPreviousMethod;
  newMethod: ValuationProfileHistoryNewMethod;
  changedByUserId?: string | null;
  changedByUserEmail?: string | null;
  changeSource: ValuationProfileHistoryChangeSource;
  note?: string | null;
  createdAt: string;
}

/**
 * Classification health metrics for the advanced_inventory_valuation_enabled
 * feature. Counts items that are mis-classified or incomplete so operators
 * can fix them before they skew the commodity average cost.
 */
export interface ValuationHealthSummary {
  /** Items with no valuation_method set (NULL). These fall back to spot_tracked behaviour but aren't explicitly classified, so they can skew the commodity average with wrong weights. */
  unclassifiedCount: number;
  /** Items deliberately excluded from all portfolio calculations. High counts here may indicate mis-classified bullion that should be spot_tracked or hybrid. */
  excludedCount: number;
  /** Items classified as spot_tracked but whose active valuation profile has no fine_metal_weight_ozt — the engine cannot include them in the commodity average without a weight. */
  spotTrackedMissingWeightCount: number;
  /** ISO timestamp of the last successful portfolio recalculation. Null if no snapshot has ever been taken. */
  lastSnapshotAt?: string | null;
  /** How many hours ago the last portfolio snapshot was taken. Null if no snapshot exists. Values above 24 suggest a stale portfolio. */
  snapshotAgeHours?: number | null;
  /** True when the portfolio snapshot has been marked stale (a classification was changed since the last recalculation). */
  snapshotIsStale?: boolean | null;
}

export type VatEvidenceKind = typeof VatEvidenceKind[keyof typeof VatEvidenceKind];


export const VatEvidenceKind = {
  PURCHASE_INVOICE: 'PURCHASE_INVOICE',
  MARGIN_SCHEME_INVOICE: 'MARGIN_SCHEME_INVOICE',
  IMPORT_DOCUMENT: 'IMPORT_DOCUMENT',
  SELLER_COMMUNICATION: 'SELLER_COMMUNICATION',
  OTHER: 'OTHER',
} as const;

export type UpdateVatClassificationBodyVatTreatment = typeof UpdateVatClassificationBodyVatTreatment[keyof typeof UpdateVatClassificationBodyVatTreatment] | null;


export const UpdateVatClassificationBodyVatTreatment = {
  MARGIN_SCHEME: 'MARGIN_SCHEME',
  STANDARD_VAT: 'STANDARD_VAT',
  VAT_EXEMPT_GOLD: 'VAT_EXEMPT_GOLD',
  OUTSIDE_SCOPE: 'OUTSIDE_SCOPE',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
} as const;

export type UpdateVatClassificationBodyPurchaseSource = typeof UpdateVatClassificationBodyPurchaseSource[keyof typeof UpdateVatClassificationBodyPurchaseSource] | null;


export const UpdateVatClassificationBodyPurchaseSource = {
  PUBLIC: 'PUBLIC',
  UK_DEALER: 'UK_DEALER',
  OVERSEAS_DEALER: 'OVERSEAS_DEALER',
  CONSIGNMENT: 'CONSIGNMENT',
  MINT_MANUFACTURER: 'MINT_MANUFACTURER',
  OTHER: 'OTHER',
} as const;

export type UpdateVatClassificationBodyStockCondition = typeof UpdateVatClassificationBodyStockCondition[keyof typeof UpdateVatClassificationBodyStockCondition] | null;


export const UpdateVatClassificationBodyStockCondition = {
  SECOND_HAND: 'SECOND_HAND',
  NEW: 'NEW',
  COLLECTIBLE: 'COLLECTIBLE',
  BULLION: 'BULLION',
  SCRAP_MELT: 'SCRAP_MELT',
  UNKNOWN: 'UNKNOWN',
} as const;

export type UpdateVatClassificationBodySellerVatStatus = typeof UpdateVatClassificationBodySellerVatStatus[keyof typeof UpdateVatClassificationBodySellerVatStatus] | null;


export const UpdateVatClassificationBodySellerVatStatus = {
  NON_VAT_REGISTERED: 'NON_VAT_REGISTERED',
  VAT_REGISTERED: 'VAT_REGISTERED',
  MARGIN_SCHEME_DEALER: 'MARGIN_SCHEME_DEALER',
  UNKNOWN: 'UNKNOWN',
} as const;

export type UpdateVatClassificationBodyVatReviewStatus = typeof UpdateVatClassificationBodyVatReviewStatus[keyof typeof UpdateVatClassificationBodyVatReviewStatus] | null;


export const UpdateVatClassificationBodyVatReviewStatus = {
  CONFIRMED: 'CONFIRMED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  MISSING_EVIDENCE: 'MISSING_EVIDENCE',
} as const;

export type UpdateVatClassificationBodyVatEvidenceFilesItem = {
  url: string;
  kind: VatEvidenceKind;
  uploadedAt: string;
  uploadedByUserId?: string;
  uploadedByUserEmail?: string;
  note?: string;
};

/**
 * Partial PATCH body for VAT classification. Every field is optional;
 * only fields explicitly present are updated. Pass `null` on a
 * scalar to CLEAR back to "unanswered". For tri-state booleans pass
 * `true`, `false`, or `null` — `false` and `null` are NOT
 * interchangeable (validator depends on the distinction).
 *
 * Evidence files use replace-the-array semantics: pass the entire
 * new list. To remove a file, omit it from the array. Audit logs a
 * single `vatEvidenceFiles` field-change row capturing the old
 * array vs the new array (not per-file diffs — operators can
 * reconstruct what changed from the JSON snapshots).
 */
export interface UpdateVatClassificationBody {
  vatTreatment?: UpdateVatClassificationBodyVatTreatment;
  purchaseSource?: UpdateVatClassificationBodyPurchaseSource;
  stockCondition?: UpdateVatClassificationBodyStockCondition;
  sellerVatStatus?: UpdateVatClassificationBodySellerVatStatus;
  invoiceShowsMarginScheme?: boolean | null;
  vatShownOnInvoice?: boolean | null;
  imported?: boolean | null;
  importVatPaid?: boolean | null;
  vatReviewStatus?: UpdateVatClassificationBodyVatReviewStatus;
  vatReviewNotes?: string | null;
  vatEvidenceFiles?: UpdateVatClassificationBodyVatEvidenceFilesItem[] | null;
}

export type VatValidationWarningSeverity = typeof VatValidationWarningSeverity[keyof typeof VatValidationWarningSeverity];


export const VatValidationWarningSeverity = {
  info: 'info',
  warn: 'warn',
  error: 'error',
} as const;

export interface VatValidationWarning {
  code: string;
  message: string;
  severity: VatValidationWarningSeverity;
  field?: string | null;
}

export interface CreateInventoryVariationBody {
  /**
     * The coin year for this variant (e.g. 1966).
     * @minimum 1000
     * @maximum 9999
     */
  year: number;
  /**
     * Optional full SKU for the child. When omitted the server generates
     * `{PARENT_SKU}-{year}` and checks uniqueness. When supplied it is
     * used verbatim (uniqueness still checked).
     */
  sku?: string | null;
  /**
     * Starting stock on hand for this variant.
     * @minimum 0
     */
  quantity?: number;
  /**
     * Cost price per unit (GBP). Defaults to the parent's `landedUnitCost`
     * when omitted.
     */
  landedUnitCost?: number | null;
  /**
     * Required when the variant is created WITH opening stock and the
     * tenant enforces acquisition VAT classification. Ignored when
     * `quantity` is 0 (nothing has been acquired yet).
     */
  vat?: AcquisitionVatInput | null;
}

export interface BulkVariationRow {
  /**
     * The coin year for this variant (e.g. 1966).
     * @minimum 1000
     * @maximum 9999
     */
  year: number;
  /**
     * Optional full SKU for the child. Defaults to `{PARENT_SKU}-{year}`
     * when omitted.
     */
  sku?: string | null;
  /**
     * Starting stock on hand for this variant.
     * @minimum 0
     */
  quantity?: number;
  /** Cost price per unit (GBP). Defaults to parent's when omitted. */
  landedUnitCost?: number | null;
}

export interface BulkCreateInventoryVariationsBody {
  /**
     * Ordered list of year-variant rows to create.
     * @minItems 1
     * @maxItems 200
     */
  rows: BulkVariationRow[];
  /**
     * One confirmed VAT treatment covering the whole batch — every row is
     * acquired together on a single decision. Required when any row has
     * opening stock and the tenant enforces acquisition VAT
     * classification.
     */
  vat?: AcquisitionVatInput | null;
}

export interface BulkCreateInventoryVariationsResponse {
  /** Number of variants created. */
  created: number;
  /** The newly-created inventory items (same shape as GET /inventory/:id). */
  items: InventoryItem[];
}

export type BulkCreateInventoryVariationsErrorRowErrorsItem = {
  /** 0-based row index. */
  row: number;
  /** Human-readable reason this row failed validation. */
  error: string;
};

export interface BulkCreateInventoryVariationsError {
  /** Top-level error (e.g. parent not found, grandchild attempt). */
  error?: string;
  rowErrors?: BulkCreateInventoryVariationsErrorRowErrorsItem[];
}

export interface InventoryLinkedChildSummary {
  id: string;
  sku: string;
  productTitle: string;
  /** Set on year-variant children created via POST /inventory/{id}/variations. */
  year?: number | null;
  /** Drizzle numeric → string, decimal pounds (e.g. "12.3456") */
  landedUnitCost: string;
  quantity: number;
  /** quantity - reserved - sold - damaged (same formula as the inventory list) */
  quantityAvailable?: number;
  quantitySold: number;
  /** Realized sold units across all time (same definition as `getOutputRollups`) */
  unitsSold: number;
  /** Realized gross revenue, decimal GBP (2dp) */
  grossRevenueGbp: string;
  /** unitsSold × landedUnitCost, decimal GBP (2dp) */
  costOfSoldGbp: string;
  /** grossRevenueGbp − costOfSoldGbp, decimal GBP (2dp) */
  realizedMarginGbp: string;
  /** Marketplace slugs this child is opted in to (mirrors InventoryItem.syncChannels). */
  syncChannels?: string[] | null;
  /** eBay offer/listing id if the child has ever been pushed to eBay. */
  ebayListingId?: string | null;
  /** ISO timestamp of the most recent successful eBay sync for this child. */
  ebayLastSyncedAt?: string | null;
  /** Shopify product id if the child has been pushed to Shopify. */
  shopifyProductId?: string | null;
  /** ISO timestamp of the most recent successful Shopify sync for this child. */
  shopifyLastSyncedAt?: string | null;
}

export type InventoryLinkedChildrenResponseMaster = {
  id: string;
  sku: string;
  productTitle: string;
  /** Finance-class; null for callers lacking the landed-cost permission. */
  landedUnitCost: string | null;
  quantity: number;
  quantitySold: number;
};

export type InventoryLinkedChildrenResponseTotals = {
  unitsSold: number;
  /** P&L-class; null for callers lacking P&L visibility. */
  grossRevenueGbp: string | null;
  /** Finance-class; null for callers lacking the landed-cost permission. */
  costOfSoldGbp: string | null;
  /** Margin-class; null for callers lacking margin visibility. */
  realizedMarginGbp: string | null;
};

export interface InventoryLinkedChildrenResponse {
  master: InventoryLinkedChildrenResponseMaster;
  children: InventoryLinkedChildSummary[];
  totals: InventoryLinkedChildrenResponseTotals;
}

export interface ShopifyPreviewLink {
  /** Opaque nonce identifying the link; used to revoke it. */
  nonce: string;
  itemId: string;
  /** SKU of the item the link previews; null if the item was deleted. */
  sku: string | null;
  /** Product title of the item; null if the item was deleted. */
  title: string | null;
  /** When the link auto-expires (15 min after mint). */
  expiresAt: string;
}

export interface ShopifyPreviewLinksResponse {
  links: ShopifyPreviewLink[];
}

export type InventoryItemDetail = InventoryItem & {
  /**
     * Server-side output of `validateVatClassification()` for this
     * item's current classification. Phase 1 detail view renders
     * these read-only; Phase 2 edit form will recompute live as
     * the operator types.
     */
  vatWarnings?: VatValidationWarning[];
};

export interface InventoryLot {
  id?: string;
  lotRef?: string;
  receivedAt?: string;
  ownershipType?: string;
  status?: string;
  quantityReceived?: number;
  quantityAvailable?: number;
  quantityReserved?: number;
  quantitySold?: number;
  quantityQuarantined?: number;
  supplierName?: string | null;
  purchaseOrderId?: string | null;
  originalUnitCost?: number | null;
  landedUnitCost?: number | null;
  effectiveUnitCost?: number | null;
  remainingValue?: number | null;
  allocationPriority?: string | null;
  storageLocation?: string | null;
  binLocation?: string | null;
}

export type InventoryLotSummaryStock = {[key: string]: number};

export type InventoryLotSummaryValues = {[key: string]: number | null};

export type InventoryLotSummaryCosts = {[key: string]: number | null};

export type InventoryLotSummarySales = {[key: string]: number | null};

export interface InventoryLotSummary {
  stock: InventoryLotSummaryStock;
  values: InventoryLotSummaryValues;
  costs: InventoryLotSummaryCosts;
  sales: InventoryLotSummarySales;
  financeVisible: boolean;
}

export type InventoryLotDetailAdjustmentsItem = { [key: string]: unknown };

export type InventoryLotDetailSalesItem = { [key: string]: unknown };

export interface InventoryLotDetail {
  lot: InventoryLot;
  adjustments: InventoryLotDetailAdjustmentsItem[];
  sales: InventoryLotDetailSalesItem[];
  financeVisible: boolean;
}

export type InventoryCostingSettingsAllocationMethod = typeof InventoryCostingSettingsAllocationMethod[keyof typeof InventoryCostingSettingsAllocationMethod];


export const InventoryCostingSettingsAllocationMethod = {
  FIFO: 'FIFO',
  WEIGHTED_AVERAGE: 'WEIGHTED_AVERAGE',
  SPECIFIC_LOT: 'SPECIFIC_LOT',
} as const;

export type InventoryCostingSettingsOwnershipPriority = typeof InventoryCostingSettingsOwnershipPriority[keyof typeof InventoryCostingSettingsOwnershipPriority];


export const InventoryCostingSettingsOwnershipPriority = {
  STRICT_FIFO: 'STRICT_FIFO',
  OWNED_FIRST: 'OWNED_FIRST',
  CONSIGNMENT_FIRST: 'CONSIGNMENT_FIRST',
  OLDEST_CONSIGNMENT_FIRST: 'OLDEST_CONSIGNMENT_FIRST',
  MANUAL_PRIORITY: 'MANUAL_PRIORITY',
} as const;

export type InventoryCostingSettingsPoReceiptLotBehaviour = typeof InventoryCostingSettingsPoReceiptLotBehaviour[keyof typeof InventoryCostingSettingsPoReceiptLotBehaviour];


export const InventoryCostingSettingsPoReceiptLotBehaviour = {
  LOT_PER_RECEIPT: 'LOT_PER_RECEIPT',
  LOT_PER_PO_LINE: 'LOT_PER_PO_LINE',
} as const;

export type InventoryCostingSettingsDefaultLandedCostMethod = typeof InventoryCostingSettingsDefaultLandedCostMethod[keyof typeof InventoryCostingSettingsDefaultLandedCostMethod];


export const InventoryCostingSettingsDefaultLandedCostMethod = {
  LANDED_ON_RECEIPT: 'LANDED_ON_RECEIPT',
  SUPPLIER_UNIT_ONLY: 'SUPPLIER_UNIT_ONLY',
} as const;

export type InventoryCostingSettingsDuplicateSkuPolicy = typeof InventoryCostingSettingsDuplicateSkuPolicy[keyof typeof InventoryCostingSettingsDuplicateSkuPolicy];


export const InventoryCostingSettingsDuplicateSkuPolicy = {
  CONSOLIDATE: 'CONSOLIDATE',
  ALLOW_DUPLICATE: 'ALLOW_DUPLICATE',
} as const;

export type InventoryCostingSettingsAdjustmentAllocationMethod = typeof InventoryCostingSettingsAdjustmentAllocationMethod[keyof typeof InventoryCostingSettingsAdjustmentAllocationMethod];


export const InventoryCostingSettingsAdjustmentAllocationMethod = {
  PRESERVE_ORIGINATING: 'PRESERVE_ORIGINATING',
  FIFO: 'FIFO',
  LIFO: 'LIFO',
} as const;

export interface InventoryCostingSettings {
  allocationMethod: InventoryCostingSettingsAllocationMethod;
  ownershipPriority: InventoryCostingSettingsOwnershipPriority;
  manualLotSelectionAllowed: boolean;
  methodEffectiveDate?: string | null;
  poReceiptLotBehaviour?: InventoryCostingSettingsPoReceiptLotBehaviour;
  defaultLandedCostMethod?: InventoryCostingSettingsDefaultLandedCostMethod;
  duplicateSkuPolicy?: InventoryCostingSettingsDuplicateSkuPolicy;
  requireSupplierOnReceipt?: boolean;
  requirePurchaseOrderOnReceipt?: boolean;
  adjustmentAllocationMethod?: InventoryCostingSettingsAdjustmentAllocationMethod;
}

export type InventoryCostingSettingsInput = InventoryCostingSettings;

export interface BreakdownInventoryLineInput {
  /**
     * Existing inventory_items.id to receive the units. Must belong
     * to the same tenant and have product_kind in ('sellable','both').
     */
  outputInventoryItemId: string;
  /**
     * Units produced into the child SKU.
     * @minimum 1
     */
  quantity: number;
  /**
     * Units removed from the source SKU to produce this line. Usually
     * equals `quantity` (1:1 split) but kept separate for future N:M
     * workflows (melt-down, consolidate, regrade).
     * @minimum 1
     */
  sourceQuantityConsumed: number;
  /**
     * GBP unit cost transferred to the child SKU. When null/omitted,
     * defaults to the source item's `landedUnitCost`.
     * @minimum 0
     */
  allocatedUnitCost?: number | null;
}

export interface BreakdownInventoryBody {
  /**
     * Existing inventory_items.id being consumed. Must belong to the
     * same tenant and have product_kind in ('source','both').
     */
  sourceInventoryItemId: string;
  /**
     * Optional traceability: which PO line the consumed units came
     * from. Server also fills purchaseOrderId from this.
     */
  purchaseOrderItemId?: string | null;
  /** Optional traceability for consignment-sourced lots. */
  consignmentSupplierId?: string | null;
  /** @maxLength 2000 */
  notes?: string | null;
  /** @minItems 1 */
  lines: BreakdownInventoryLineInput[];
}

export interface InventoryTransformationLine {
  id: string;
  transformationId: string;
  outputInventoryItemId: string;
  outputSku: string;
  quantity: number;
  sourceQuantityConsumed: number;
  /** GBP unit cost as numeric string (Drizzle numeric). */
  allocatedUnitCost: string;
  createdAt: string;
  /**
     * Realized-sales rollup. Units of this output SKU that have been
     * sold (payment_status='Paid' AND status NOT IN
     * ('Cancelled','Refunded')), reconciling 1:1 with
     * inventory_items.quantity_sold. Reflects ALL sales of the output
     * SKU since the breakdown was recorded — if the same output was
     * also stocked from another source, this number includes those
     * units. Lifetime cumulative; ignores the line's `quantity`.
     */
  unitsSold?: number;
  /**
     * Realized-sales rollup. Total GBP revenue from `unitsSold`, summed
     * from sale_order_items.sale_price. Decimal string.
     */
  grossRevenueGbp?: string;
  /**
     * Realized-sales rollup. `unitsSold * allocatedUnitCost` — the
     * portion of the source bar's cost that has flowed through to
     * actual sales of this child SKU. Decimal string.
     */
  allocatedCostOfSoldGbp?: string;
  /**
     * Realized-sales rollup. `grossRevenueGbp - allocatedCostOfSoldGbp`.
     * Decimal string; can be negative.
     */
  realizedMarginGbp?: string;
}

export interface InventoryTransformation {
  id: string;
  sourceInventoryItemId: string;
  sourceSku: string;
  purchaseOrderId?: string | null;
  purchaseOrderItemId?: string | null;
  consignmentSupplierId?: string | null;
  createdBy?: string | null;
  notes?: string | null;
  createdAt: string;
  /**
     * Live read of the SOURCE item's `landed_unit_cost` at the time of
     * this response (not a frozen snapshot). Decimal string. Used to
     * compute `sourceCostConsumedGbp` for the cost-flow display.
     */
  sourceLandedUnitCostSnapshot?: string;
  /**
     * Sum across child lines of `line.quantity * line.allocatedUnitCost`
     * — the total cost the breakdown PUSHED INTO child SKUs. Decimal
     * string.
     */
  totalAllocatedCostGbp?: string;
  /**
     * Sum across child lines of `line.sourceQuantityConsumed *
     * sourceLandedUnitCostSnapshot` — the total cost the breakdown
     * PULLED OUT OF the source SKU. Decimal string.
     */
  sourceCostConsumedGbp?: string;
  /**
     * `sourceCostConsumedGbp - totalAllocatedCostGbp`. Positive means
     * cost left the source bar but did not land on any child
     * (= unaccounted-for breakdown loss). Negative means the children
     * were costed up at re-allocation time. Decimal string.
     */
  breakdownCostVarianceGbp?: string;
  /**
     * Sum of `line.grossRevenueGbp` across all child lines. Decimal
     * string.
     */
  totalRealizedRevenueGbp?: string;
  /**
     * Sum of `line.realizedMarginGbp` across all child lines. Decimal
     * string; can be negative.
     */
  totalRealizedMarginGbp?: string;
}

export type InventoryTransformationDetail = InventoryTransformation & {
  lines: InventoryTransformationLine[];
};

export interface StockMovement {
  id: string;
  action: string;
  changeType?: string | null;
  previousQuantity: number;
  newQuantity: number;
  userId?: string | null;
  userEmail?: string | null;
  notes?: string | null;
  createdAt: string;
}

export interface StockAuditEntry {
  id: string;
  inventoryItemId?: string | null;
  sku?: string | null;
  productTitle?: string | null;
  action: string;
  changeType?: string | null;
  previousQuantity: number;
  newQuantity: number;
  delta?: number;
  userId?: string | null;
  userEmail?: string | null;
  notes?: string | null;
  createdAt: string;
}

export type ActivityLogEntryMetadata = { [key: string]: unknown } | null;

export interface ActivityLogEntry {
  id: string;
  userId?: string | null;
  userEmail?: string | null;
  action: string;
  entityType: string;
  entityId?: string | null;
  entityLabel?: string | null;
  productTitle?: string | null;
  sku?: string | null;
  marketplace?: string | null;
  metadata?: ActivityLogEntryMetadata;
  createdAt: string;
}

export interface AuditLogEntry {
  id: string;
  entityType: string;
  entityId: string;
  actionType: string;
  fieldChanged?: string | null;
  oldValue?: unknown | null;
  newValue?: unknown | null;
  changedByUserId?: string | null;
  changedByUserEmail?: string | null;
  changeSource: string;
  note?: string | null;
  /** Optional grouping tag. Rows minted by the same logical bulk write tx (e.g. /inventory/bulk-edit, Coming-Soon mark-arrived, a multi-field PATCH) share a batchId. The audit-history UI prefers this for exact grouping and falls back to the (actor + note + minute) heuristic when null. */
  batchId?: string | null;
  createdAt: string;
}

export interface EntityAuditLogPage {
  entries: AuditLogEntry[];
  nextBefore?: string | null;
  nextCursor?: string | null;
}

export type AuditLogListFiltersUsersItem = {
  id: string;
  email: string;
};

export type AuditLogListFilters = {
  entityTypes: string[];
  actionTypes: string[];
  changeSources: string[];
  fieldsChanged: string[];
  users: AuditLogListFiltersUsersItem[];
};

export interface AuditLogList {
  entries: AuditLogEntry[];
  nextBefore?: string | null;
  filters: AuditLogListFilters;
}

export interface InventoryStatusUpdate {
  status: string;
  salesChannel?: string | null;
  listingUrl?: string | null;
  currentAskingPrice?: number | null;
  notes?: string | null;
}

export interface CustomerInput {
  name: string;
  email?: string | null;
  phone?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  customerType?: string | null;
  source?: string | null;
  /** External system handle, e.g. "shopify:<email>". Used for two-way customer sync. */
  externalRef?: string | null;
  /** Denormalised eBay buyer username (mirrored from `ebay:<username>` form in externalRef). Powers customer-intelligence joins. */
  ebayUsername?: string | null;
  tags?: string[];
  notes?: string | null;
}

export type Customer = CustomerInput & {
  id: string;
  createdAt: string;
};

/**
 * Bucketed risk indicator derived from `riskScore` (0-20 LOW, 21-50 MEDIUM, 51+ HIGH).
 */
export type CustomerRiskLevel = typeof CustomerRiskLevel[keyof typeof CustomerRiskLevel];


export const CustomerRiskLevel = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
} as const;

/**
 * Reasons currently contributing to the risk score. Surfaced in the Risk badge tooltip and the Risk card on the customer page. Mirror of the CUSTOMER_RISK_FLAGS const exported from the db schema.
 */
export type CustomerRiskFlag = typeof CustomerRiskFlag[keyof typeof CustomerRiskFlag];


export const CustomerRiskFlag = {
  MULTIPLE_ADDRESSES: 'MULTIPLE_ADDRESSES',
  FREQUENT_ADDRESS_CHANGE: 'FREQUENT_ADDRESS_CHANGE',
  HAS_ISSUES: 'HAS_ISSUES',
  HIGH_ADJUSTMENTS: 'HIGH_ADJUSTMENTS',
  HIGH_VELOCITY: 'HIGH_VELOCITY',
} as const;

export interface CustomerAddress {
  id: string;
  customerId: string;
  fullName?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  /** Number of distinct sale orders that have shipped to this address. Bumped on every recordAddress call. */
  usageCount: number;
  lastUsedAt?: string | null;
  /** True for the address mirrored onto the inline customers row (highest usageCount, ties broken by most-recent lastUsedAt). */
  isPrimary: boolean;
  createdAt: string;
}

/**
 * Prepared summary state for this directory row.
 */
export type CustomerWithStatsReadModelState = typeof CustomerWithStatsReadModelState[keyof typeof CustomerWithStatsReadModelState];


export const CustomerWithStatsReadModelState = {
  ready: 'ready',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export interface CustomerSpendVisibility {
  spend: boolean;
  profit: boolean;
}

export type CustomerWithStats = Customer & ({
  financeVisibility?: CustomerSpendVisibility;
  totalSpend: number | null;
  totalProfit: number | null;
  /**
     * Null while a customer summary is unavailable; zero means a prepared summary confirms no recognized orders.
     * @nullable
     */
  orderCount: number | null;
  /**
     * Number of recognized order item lines, matching the customer detail total-items figure.
     * @nullable
     */
  itemCount?: number | null;
  /**
     * Sum of quantities across recognized order item lines; null while the prepared summary is unavailable.
     * @nullable
     */
  itemUnitCount?: number | null;
  /** Prepared summary state for this directory row. */
  readModelState?: CustomerWithStatsReadModelState;
  /** Preparation failed; retained metrics remain visible where a successful snapshot exists. */
  preparationFailed?: boolean;
  /**
     * Last successful prepared snapshot time. Null means metrics have never been prepared.
     * @nullable
     */
  preparedAt?: string | null;
  avgOrderValue?: number | null;
  lastOrderDate?: string | null;
  /** customer_addresses.id of the address currently mirrored onto the inline customer row. */
  primaryAddressId?: string | null;
  /** Numeric risk score 0-100, recomputed on order/address/note/adjustment write paths. */
  riskScore: number;
  riskLevel: CustomerRiskLevel;
  riskFlags: CustomerRiskFlag[];
  riskUpdatedAt?: string | null;
  /**
     * Buyer's TikTok @handle (without the leading @) from this
     * customer's most recent TikTok order, joined from packing_jobs.
     * Null when none captured. Surfaced on list rows so a (frequently
     * masked) TikTok buyer is recognisable. Render as-is.
     */
  tiktokUsername?: string | null;
  /**
     * Buyer's TikTok display alias from the same order. Null when
     * absent or masked. Pairs with tiktokUsername as "@username · alias".
     */
  tiktokNickname?: string | null;
  companyName?: string | null;
  status?: string;
});

export interface CustomerPickerOption {
  id: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
}

export interface CustomerDirectorySummary {
  totalCustomers: number;
  customersWithOrders: number;
  totalSpend: number | null;
  averageCustomerSpend: number | null;
  newCustomers30Days: number;
}

export type CustomerExportInputHasOrders = typeof CustomerExportInputHasOrders[keyof typeof CustomerExportInputHasOrders];


export const CustomerExportInputHasOrders = {
  has: 'has',
  none: 'none',
} as const;

export interface CustomerExportInput {
  search?: string;
  type?: string;
  risk?: CustomerRiskLevel;
  hasOrders?: CustomerExportInputHasOrders;
  createdAfter?: string;
  createdBefore?: string;
}

export interface CustomerExportInline {
  csv: string;
  filename: string;
  rowCount: number;
  visibility: CustomerSpendVisibility;
}

export type CustomerExportQueuedStatus = typeof CustomerExportQueuedStatus[keyof typeof CustomerExportQueuedStatus];


export const CustomerExportQueuedStatus = {
  queued: 'queued',
} as const;

export interface CustomerExportQueued {
  jobId: string;
  status: CustomerExportQueuedStatus;
  rowCount: number;
}

export interface CustomerPlatformHandle {
  id: string;
  customerId: string;
  /** Saved platform identifier; existing legacy values remain readable */
  platform: string;
  handle: string;
  tenantId?: string | null;
  createdAt: string;
}

export type CustomerPlatformHandleInputPlatform = typeof CustomerPlatformHandleInputPlatform[keyof typeof CustomerPlatformHandleInputPlatform];


export const CustomerPlatformHandleInputPlatform = {
  ebay: 'ebay',
  tiktok: 'tiktok',
  whatnot: 'whatnot',
  other: 'other',
} as const;

export interface CustomerPlatformHandleInput {
  platform: CustomerPlatformHandleInputPlatform;
  /**
     * @minLength 1
     * @maxLength 255
     */
  handle: string;
}

export interface GeneratedSaleInvoice {
  id: string;
  invoiceNumber: number;
}

/**
 * Shopify draft lifecycle; completed means Shopify converted the draft into a standard order.
 */
export type SaleOrderShopifyOrderLifecycle = typeof SaleOrderShopifyOrderLifecycle[keyof typeof SaleOrderShopifyOrderLifecycle] | null;


export const SaleOrderShopifyOrderLifecycle = {
  open: 'open',
  invoice_sent: 'invoice_sent',
  completed: 'completed',
} as const;

export type OrderLossType = typeof OrderLossType[keyof typeof OrderLossType];


export const OrderLossType = {
  NOT_SENT: 'NOT_SENT',
  LOST_IN_TRANSIT: 'LOST_IN_TRANSIT',
  SENT_TO_WRONG_PERSON: 'SENT_TO_WRONG_PERSON',
  DAMAGED: 'DAMAGED',
  REFUNDED: 'REFUNDED',
  FRAUD: 'FRAUD',
  STOCK_ERROR: 'STOCK_ERROR',
  OTHER: 'OTHER',
} as const;

export type OrderLossStatus = typeof OrderLossStatus[keyof typeof OrderLossStatus];


export const OrderLossStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
} as const;

export interface SaleOrderLossSummary {
  id: string;
  type: OrderLossType;
  status: OrderLossStatus;
  estimatedLossAmount: number;
  recoveredAmount: number;
  /** Amount deducted from True Profit. = max(0, estimatedLossAmount − recoveredAmount). */
  netLossDeduction: number;
  note: string;
  resolvedAt?: string | null;
}

/**
 * TikTok Shop settlement-fee state for this order. `confirmed` means
 * platformFees came from TikTok's finance statement transaction API.
 * `unavailable` means TikTok has not returned settlement data yet or
 * the connection lacks the finance scope; this must not be rendered
 * as a confirmed zero fee.
 */
export type SaleOrderTiktokPlatformFeeStatus = typeof SaleOrderTiktokPlatformFeeStatus[keyof typeof SaleOrderTiktokPlatformFeeStatus] | null;


export const SaleOrderTiktokPlatformFeeStatus = {
  confirmed: 'confirmed',
  unavailable: 'unavailable',
} as const;

/**
 * FX conversion state; unavailable never represents a guessed zero.
 */
export type SaleOrderTiktokPlatformFeeFxStatus = typeof SaleOrderTiktokPlatformFeeFxStatus[keyof typeof SaleOrderTiktokPlatformFeeFxStatus] | null;


export const SaleOrderTiktokPlatformFeeFxStatus = {
  not_required: 'not_required',
  converted: 'converted',
  unavailable: 'unavailable',
} as const;

/**
 * Manual-order payment status (Task #1232). "Outstanding" is DERIVED at
 * read time (open balance past the due date) and is NEVER stored — it only
 * appears as the effective `SalePaymentBlock.status`, never as a stored
 * `baseStatus` or as a create/transition input.
 */
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


export const PaymentStatus = {
  Unpaid: 'Unpaid',
  Part_Paid: 'Part Paid',
  Paid: 'Paid',
  Outstanding: 'Outstanding',
  Refunded: 'Refunded',
  Part_Refunded: 'Part Refunded',
  Cancelled: 'Cancelled',
  Written_Off: 'Written Off',
} as const;

/**
 * Manual-order payment state for a sale (Task #1232). `status` is the
 * EFFECTIVE status and may be the derived "Outstanding"; `baseStatus` is
 * the stored status (never "Outstanding"). The payment ledger is the money
 * source of truth — `amountPaid` is the signed sum of ledger entries and
 * `balanceDue` = max(0, total − amountPaid).
 */
export interface SalePaymentBlock {
  /** True when this order originated as a manual (non-marketplace) sale, so payment actions are editable. */
  isManualOrder: boolean;
  /** Effective payment status, including the derived "Outstanding". */
  status: PaymentStatus;
  /** Stored payment status (never "Outstanding"). */
  baseStatus: PaymentStatus;
  /** Legacy free-text `payment_status` column value, for back-compat display. */
  rawStatus?: string | null;
  total: number;
  /** Signed sum of payment-ledger entries (the money source of truth). */
  amountPaid: number;
  /** max(0, total − amountPaid). */
  balanceDue: number;
  /** True when the effective status is the derived "Outstanding". */
  isOutstanding: boolean;
  /** Whole days past the due date (Europe/London), 0 when not overdue. */
  daysOverdue: number;
  /** True when the due date is today (Europe/London) with a balance remaining. */
  isDueToday: boolean;
  /** ISO date the balance is due, or null. */
  dueDate?: string | null;
  /** ISO timestamp the order became fully Paid, or null. */
  paidAt?: string | null;
  /** ISO timestamp the order first became Outstanding, or null. */
  outstandingSince?: string | null;
  partPaidAt?: string | null;
  writtenOffAt?: string | null;
  paymentReference?: string | null;
  paymentNotes?: string | null;
  paymentMethod?: string | null;
}

/**
 * Provider-supplied fee components; empty when settlement data is unavailable or redacted.
 */
export type SaleOrderTiktokPlatformFeeBreakdown = {[key: string]: string};

/**
 * Non-secret conversion evidence; raw TikTok payload remains separate.
 */
export type SaleOrderTiktokPlatformFeeFxEvidence = { [key: string]: unknown };

export interface SaleOrder {
  flags?: CompactFlagRef[];
  id: string;
  orderNumber: string;
  /**
     * Active invoice generated from this sale, or null when none exists.
     * The invoice ID is safe to use for opening the existing invoice; this
     * association never starts invoice generation.
     */
  generatedInvoice?: GeneratedSaleInvoice | null;
  customerId: string;
  customerName?: string | null;
  /**
     * Order-scoped actual name from exact tenant and marketplace order evidence
     * for TikTok, eBay, and Shopify (including Shopify-origin Whatnot).
     * Purchaser evidence takes precedence over a postal-recipient fallback.
     * Never a username or nickname; separate from the canonical profile and contacts.
     */
  marketplaceBuyerName?: string | null;
  /** Snapshotted from the linked customer for shipping/posting use on the sale detail page. */
  customerEmail?: string | null;
  customerPhone?: string | null;
  customerAddressLine1?: string | null;
  customerAddressLine2?: string | null;
  customerCity?: string | null;
  customerPostcode?: string | null;
  customerCountry?: string | null;
  /** Risk bucket of the linked customer at read time. Joined from the inline customer row so the sales list can render a badge without a second round-trip. */
  customerRiskLevel?: CustomerRiskLevel | null;
  /** Numeric risk score of the linked customer, included alongside customerRiskLevel for the badge tooltip. */
  customerRiskScore?: number | null;
  channel: string;
  saleDate: string;
  /** ISO currency code for revenue / fees / charges on this order. */
  currency: string;
  discount?: number;
  shippingCharged?: number;
  shippingCost?: number;
  platformFees?: number;
  /**
     * Lightweight manual profit-adjustment in GBP for edge-case costs the
     * rest of the app doesn't model (e.g. eBay final-value fees on a
     * bank-transfer payment). Subtracted from grossProfit to produce
     * `trueProfit`. Defaults to 0. Audited on PATCH /sales/{id}.
     */
  additionalCostsGbp: number;
  /** Free-text note describing what the additionalCostsGbp adjustment covers. */
  additionalCostsReason?: string | null;
  /**
     * TikTok-funded platform voucher total (GBP) for this order, already
     * included in line revenue. Informational only — surfaced on the sale
     * detail Adjustments card. Set on TikTok imports / live sync only.
     */
  tiktokVoucherAmount?: number | null;
  paymentMethod?: string | null;
  paymentStatus: string;
  status: string;
  /**
     * Authoritative tenant-scoped packing-job fulfilment state for this
     * order, or null when no packing job is linked.
     */
  fulfilmentStatus?: string | null;
  /**
     * Assigned tenant-scoped packing operator user id from the
     * authoritative packing job, or null when unassigned/unlinked.
     */
  assignedTo?: string | null;
  /**
     * Tenant-member display name for assignedTo. Falls back to the
     * assigned user id when a historical member no longer has a profile.
     */
  assignedToName?: string | null;
  trackingNumber?: string | null;
  /** Carrier reported by eBay (or set manually) for the tracking number. Surfaced so the sales list can render a dispatched icon with carrier tooltip. */
  shippingCarrier?: string | null;
  /** ISO timestamp this order was cancelled. Surfaced so the sales list can render a cancelled icon without a second fetch. */
  cancelledAt?: string | null;
  /** ISO timestamp of the last eBay-side modification observed by the update sync. Surfaced so the sales list can render a "recently synced" indicator. */
  ebayLastModifiedAt?: string | null;
  /** True when at least one line on this order was drawn from the inventory's `quantity_coming_soon` (preorder) bucket. Cleared automatically by the mark-arrived endpoint once every coming-soon line has converted to physical stock. Drives the "Order Coming Soon" badge in the sales list/detail. */
  isComingSoon?: boolean;
  /** True when the order was created through the pre-order flow. Pre-order units are commitments, not on-hand physical stock, until they are assigned or fulfilled. */
  isPreOrder?: boolean;
  /**
     * Purchased units from this sale currently stored in the customer's Box; never an unpaid basket quantity.
     * @minimum 0
     */
  boxStoredQuantity: number;
  externalOrderNumber?: string | null;
  /** Shopify draft ID retained when a draft is imported or converted into a standard order. */
  shopifyDraftOrderId?: string | null;
  /** Shopify draft lifecycle; completed means Shopify converted the draft into a standard order. */
  shopifyOrderLifecycle?: SaleOrderShopifyOrderLifecycle;
  /** eBay's long-form Order ID (distinct from the shorter Sales record number stored in externalOrderNumber). */
  ebayOrderId?: string | null;
  /** Which eBay account this order came from (primary, secondary, etc.). Null for non-eBay channels or legacy orders created before dual-account support. */
  ebayAccountKey?: string | null;
  /** Snapshotted eBay buyer username at order time. Null for non-eBay channels. */
  ebayUsername?: string | null;
  /** FK to order_groups when this sale is part of an eBay combined-postage group. Null for unlinked single orders. */
  orderGroupId?: string | null;
  /** True when this sale carries the postage charge for its order group (or when ungrouped). Siblings with combined postage have this false and shippingCharged=0. */
  isPrimaryPostageOrder?: boolean;
  /** Postage attributed to this order — equals shippingCharged for ungrouped orders or for the primary of a group; 0 for non-primary siblings. Aggregators should SUM(postageAllocated) to avoid double-counting combined postage. */
  postageAllocated?: number;
  /** Order value. Null when the caller lacks `view_sale_price` (e.g. packer role). */
  totalRevenue: number | null;
  totalCost: number;
  grossProfit: number;
  netProfit: number;
  /**
     * netProfit minus additionalCostsGbp (i.e. revenue minus COGS,
     * discount, shippingCost, platformFees, and the manual
     * additionalCostsGbp adjustment, plus postageAllocated — which is
     * shippingCharged for primary/single orders and 0 for combined-
     * postage siblings, so phantom sibling postage isn't double-booked).
     * Same as netProfit when no manual adjustment has been applied.
     * Surfaced so the sales list + order detail can show "true" /
     * net-of-manual-fees profit without the client recomputing, and so
     * the value matches what /reports aggregations report for the same
     * order.
     */
  trueProfit: number;
  /** trueProfit / totalRevenue × 100, rounded to 1 decimal place. 0 when revenue is 0. */
  trueMargin: number;
  margin: number;
  /**
     * Output VAT (GBP) owed to HMRC on this order's sale lines (Task
     * #1057). Margin-scheme lines charge VAT on the margin
     * (max(0, revenue−cost)); standard-rated lines on the VAT-inclusive
     * revenue; VAT-exempt-investment-gold / outside-scope lines contribute
     * 0. Informational — sits ALONGSIDE netProfit/trueProfit, never
     * replaces them. Null when the caller lacks `view_sale_price`.
     */
  outputVat?: number | null;
  /**
     * trueProfit minus outputVat — the profit retained after settling
     * output VAT with HMRC. Null when the caller lacks `view_sale_price`.
     */
  vatAdjustedProfit?: number | null;
  /**
     * True when at least one non-empty sale line lacked a usable VAT
     * treatment (NEEDS_REVIEW or unset), so outputVat is an under-estimate
     * and the figure should be shown with a "needs review" badge.
     */
  vatTreatmentFlagged?: boolean;
  itemCount?: number;
  /** Total quantity (sum of `quantity`) across line items on this order whose stockType is CONSIGNMENT. Comparable directly to `itemCount` (which is also a quantity sum) so the sales list can show a "C" / "Mixed" badge without fetching full sale details. */
  consignmentItemCount?: number;
  notes?: string | null;
  /** Object-storage path to the uploaded postage-label PDF for this order, or null if no label has been uploaded. */
  labelObjectPath?: string | null;
  labelFileName?: string | null;
  /** Carrier the uploaded label is for (e.g. "Royal Mail", "DHL", "Other"). */
  labelCarrier?: string | null;
  /** ISO timestamp the postage-label PDF was uploaded. */
  labelUploadedAt?: string | null;
  /** ISO timestamp the order was confirmed packed (deducts packaging materials). Idempotency sentinel — once set, packing cannot be re-run. */
  packedAt?: string | null;
  /** ISO timestamp the customer dispatch email was sent via Google Mail. Idempotency sentinel — once set, the email won't be re-sent on subsequent Shipped transitions. */
  shipmentEmailSentAt?: string | null;
  /** Loss / incident summary attached to this order, or null. When non-null, True Profit / True Margin already deduct max(0, estimatedLossAmount − recoveredAmount). */
  loss?: SaleOrderLossSummary | null;
  /**
     * Buyer's TikTok @handle (without the leading @), captured at label
     * import and joined back from packing_jobs. Null for non-TikTok orders
     * or when no usable handle was captured. Surfaced on list rows so a
     * (frequently masked) TikTok buyer is recognisable without opening the
     * order. Already cleaned of junk/masked placeholders — render as-is.
     */
  tiktokUsername?: string | null;
  /**
     * Buyer's TikTok display alias, joined from packing_jobs. Null when
     * absent or masked. Pairs with tiktokUsername as "@username · alias".
     */
  tiktokNickname?: string | null;
  /**
     * TikTok Shop refund state mirrored from tiktok_shop_orders.refund_status
     * (Task #1416). Non-null when a refund has been recorded against the
     * order. Surfaced on list rows so a refunded order is recognisable
     * without opening it. Null for non-TikTok orders or when no refund
     * state is recorded. Non-monetary, so it stays visible for all roles.
     */
  tiktokRefundStatus?: string | null;
  /**
     * TikTok Shop refund amount (Task #1416). Monetary — null for callers
     * lacking `view_sale_price` (e.g. packer role), and null when no refund
     * is recorded.
     */
  tiktokRefundAmount?: number | null;
  /** ISO currency code for tiktokRefundAmount. Null when redacted or absent. */
  tiktokRefundCurrency?: string | null;
  /**
     * TikTok Shop settlement-fee state for this order. `confirmed` means
     * platformFees came from TikTok's finance statement transaction API.
     * `unavailable` means TikTok has not returned settlement data yet or
     * the connection lacks the finance scope; this must not be rendered
     * as a confirmed zero fee.
     */
  tiktokPlatformFeeStatus?: SaleOrderTiktokPlatformFeeStatus;
  /** Authoritative TikTok platform fee in the provider currency; redacted without view_sale_price. */
  tiktokPlatformFeeAmount?: number | null;
  /** ISO currency for the authoritative TikTok fee. */
  tiktokPlatformFeeCurrency?: string | null;
  /** Provider-supplied fee components; empty when settlement data is unavailable or redacted. */
  tiktokPlatformFeeBreakdown?: SaleOrderTiktokPlatformFeeBreakdown;
  /** Authoritative TikTok net settlement in the provider currency; redacted without view_sale_price. */
  tiktokNetSettlementAmount?: number | null;
  /** Provider statement transaction or settlement identifier. */
  tiktokSettlementId?: string | null;
  /** Provider payout/statement identifier when supplied. */
  tiktokPayoutId?: string | null;
  /** Provider timestamp for the settlement evidence. */
  tiktokFeeSourceTimestamp?: string | null;
  /** GBP fee projection after an authoritative canonical FX conversion. */
  tiktokPlatformFeeGbp?: number | null;
  /** FX conversion state; unavailable never represents a guessed zero. */
  tiktokPlatformFeeFxStatus?: SaleOrderTiktokPlatformFeeFxStatus;
  /** GBP per provider-currency unit used for the conversion. */
  tiktokPlatformFeeFxRate?: number | null;
  /** Canonical provider/source identifier for the conversion. */
  tiktokPlatformFeeFxSource?: string | null;
  /** Timestamp of the canonical FX observation used for the conversion. */
  tiktokPlatformFeeFxTimestamp?: string | null;
  /** Non-secret conversion evidence; raw TikTok payload remains separate. */
  tiktokPlatformFeeFxEvidence?: SaleOrderTiktokPlatformFeeFxEvidence;
  /**
     * Carrier tracking number pushed for the TikTok Shop fulfilment
     * (Task #1416), mirrored from tiktok_shop_orders. Surfaced on list rows
     * so a dispatched TikTok order shows a fulfilment indicator without
     * opening it. Non-monetary — visible for all roles.
     */
  tiktokTrackingNumber?: string | null;
  /**
     * ISO timestamp the TikTok Shop order was marked shipped (Task #1416).
     * Non-monetary — visible for all roles. Null when not yet shipped.
     */
  tiktokShippedAt?: string | null;
  /** Carrier reported for the TikTok Shop fulfilment (Task */
  tiktokCarrier?: string | null;
  /**
     * Manual-order payment state (Task #1232). Effective status (may be the
     * derived "Outstanding"), balance, ledger totals, and due/overdue flags.
     * Null when money fields are redacted for a caller lacking
     * `view_sale_price` (e.g. packer role), or on an older cached row.
     */
  payment?: SalePaymentBlock | null;
}

export type CustomerDetail = CustomerWithStats & ({
  /**
     * Buyer's TikTok @handle (without the leading @) from this
     * customer's most recent TikTok order, joined from packing_jobs.
     * Null when none captured. Already cleaned of junk/masked
     * placeholders at import — render as-is.
     */
  tiktokUsername?: string | null;
  /**
     * Buyer's TikTok display alias from the same order. Null when
     * absent or masked. Pairs with tiktokUsername as "@username · alias".
     */
  tiktokNickname?: string | null;
  recentSales?: SaleOrder[];
  /** Number of customer_notes rows with type=WARNING. Drives the red banner on the customer detail page. */
  warningCount?: number;
  /** Number of customer_notes rows with type=ISSUE. */
  issueCount?: number;
  /** Total number of customer_notes rows. */
  noteCount?: number;
  /** Full address history for the customer, sorted by usageCount desc then lastUsedAt desc. Includes the primary address as well as all secondary addresses captured by recordAddress. */
  addresses?: CustomerAddress[];
  /** Marketplace/social platform handles linked to this customer (one per platform). */
  platformHandles?: CustomerPlatformHandle[];
});

export interface SaleItemInput {
  inventoryItemId: string;
  quantity: number;
  salePrice: number;
  /** Optional sale-time override of the supplier-owed amount per unit. Only honoured for CONSIGNMENT items. Snapshotted with consignmentPayoutOverridden=true so the UI can flag it. */
  consignmentPayoutOverridePerUnit?: number | null;
  /**
     * Sale Safety Mode: explicit operator acknowledgement that this line
     * has a £0 effective unit cost (no landed cost on owned stock, or no
     * base cost / fixed payout on consignment stock). The server blocks
     * sales with missing cost data unless this is `true` per affected
     * line — treated as "loss-leader / sample" override.
     */
  confirmZeroCost?: boolean | null;
  /**
     * Inventory Lots (inventory_cost_layers_v2): explicit stock lots to
     * draw this line's units from, in priority order. Only accepted when
     * the tenant's costing policy is SPECIFIC_LOT with manual lot
     * selection enabled AND the caller holds the `lots.manual_allocate`
     * permission; otherwise the request is rejected with 403. Omit to
     * let the configured allocation method (FIFO by default) choose.
     */
  requestedLotIds?: string[] | null;
}

export type CreateSaleZeroCostErrorCode = typeof CreateSaleZeroCostErrorCode[keyof typeof CreateSaleZeroCostErrorCode];


export const CreateSaleZeroCostErrorCode = {
  ZERO_COST_NOT_CONFIRMED: 'ZERO_COST_NOT_CONFIRMED',
} as const;

export type CreateSaleZeroCostErrorZeroCostLinesItemStockType = typeof CreateSaleZeroCostErrorZeroCostLinesItemStockType[keyof typeof CreateSaleZeroCostErrorZeroCostLinesItemStockType];


export const CreateSaleZeroCostErrorZeroCostLinesItemStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type CreateSaleZeroCostErrorZeroCostLinesItem = {
  /** Zero-based index into the original `items` array. Used by the client to scope per-line `confirmZeroCost` acknowledgement so that duplicate inventory items on different lines remain individually addressable. */
  lineIndex: number;
  inventoryItemId: string;
  productTitle: string;
  sku: string | null;
  stockType: CreateSaleZeroCostErrorZeroCostLinesItemStockType;
};

/**
 * Returned with HTTP 422 when one or more lines have a £0 effective unit cost and `confirmZeroCost` was not set on those lines. The client should show each affected line in the confirmation modal with a "Confirm £0 cost (loss-leader / sample)" checkbox and resubmit with `confirmZeroCost=true` per acknowledged line.
 */
export interface CreateSaleZeroCostError {
  error: string;
  code: CreateSaleZeroCostErrorCode;
  zeroCostLines: CreateSaleZeroCostErrorZeroCostLinesItem[];
}

/**
 * Persisted cost provenance, not inferred from current batch prices. Uniform SKU lot estimates do not prove per-line lot consumption. Null when not applicable or restricted.
 * @nullable
 */
export type SaleItemPreOrderCostBasis = typeof SaleItemPreOrderCostBasis[keyof typeof SaleItemPreOrderCostBasis] | null;


export const SaleItemPreOrderCostBasis = {
  uniform_sku_lot_estimate: 'uniform_sku_lot_estimate',
  operator_batch_estimate: 'operator_batch_estimate',
  source_unrecorded: 'source_unrecorded',
  purchase_order_lot: 'purchase_order_lot',
  final_cost_snapshot: 'final_cost_snapshot',
} as const;

/**
 * Snapshotted at sale time. CONSIGNMENT items use supplierPayoutPrice as unitCost.
 */
export type SaleItemStockType = typeof SaleItemStockType[keyof typeof SaleItemStockType];


export const SaleItemStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

/**
 * Snapshotted payout method for consignment lines.
 */
export type SaleItemConsignmentPayoutType = typeof SaleItemConsignmentPayoutType[keyof typeof SaleItemConsignmentPayoutType] | null;


export const SaleItemConsignmentPayoutType = {
  FIXED_PER_UNIT: 'FIXED_PER_UNIT',
  PROFIT_SPLIT_PCT: 'PROFIT_SPLIT_PCT',
} as const;

export type SaleItem = SaleItemInput & ({
  /**
     * Whether this pre-order line still uses estimated COGS. Null for non-pre-order lines or when cost access is restricted; independent of payment and fulfilment status.
     * @nullable
     */
  costIsProvisional?: boolean | null;
  /**
     * Persisted cost provenance, not inferred from current batch prices. Uniform SKU lot estimates do not prove per-line lot consumption. Null when not applicable or restricted.
     * @nullable
     */
  preOrderCostBasis?: SaleItemPreOrderCostBasis;
  /**
     * Linked purchase-order lot identifier, when available and cost access is permitted.
     * @nullable
     */
  preOrderPurchaseOrderItemId?: string | null;
  /**
     * Timestamp of final cost application, when recorded and cost access is permitted.
     * @nullable
     */
  finalCostAppliedAt?: string | null;
  id: string;
  /** Display title — resolved from inventory_items.product_title when the line is matched to inventory (preferred — clean, app-entered SKU title), falling back to the line's own snapshotted title for unmatched lines. */
  productTitle: string;
  /** SKU joined from inventory_items via the line's inventory_item_id. Null when the line is not matched to an inventory row. */
  sku?: string | null;
  /** The line's own (often imported / messy eBay) title, surfaced separately only when it differs from the resolved productTitle so operators can still see the originally-imported text. */
  externalTitle?: string | null;
  /** Standard inventory photo (first of photos[]/photoUrl/photoUrls) for this line, joined from inventory_items. Fallback when no composite exists. Null for lines not matched to inventory. Render via AuthedImage. */
  photoUrl?: string | null;
  /** Template-background composite render — the canonical product image, ALWAYS preferred over photoUrl. Joined from inventory_items. Null when no composite. Render via AuthedImage. */
  compositePhotoUrl?: string | null;
  unitCost: number;
  /** Per-line value. Null when the caller lacks `view_sale_price`. */
  lineTotal: number | null;
  lineProfit: number;
  /** Snapshotted at sale time. CONSIGNMENT items use supplierPayoutPrice as unitCost. */
  stockType: SaleItemStockType;
  /**
     * How many of this line's `quantity` units were drawn from the inventory's `quantity_coming_soon` (preorder) bucket at sale time. 0 for the normal case. Decremented back to 0 by the mark-arrived endpoint as units physically arrive.
     * @minimum 0
     */
  qtyFromComingSoon?: number;
  /** Snapshotted at sale time for consignment lines. */
  supplierName?: string | null;
  /** Snapshotted payout method for consignment lines. */
  consignmentPayoutType?: SaleItemConsignmentPayoutType;
  /** Snapshotted base cost for PROFIT_SPLIT_PCT lines. */
  consignmentBaseCostGbp?: number | null;
  /** Snapshotted supplier % for PROFIT_SPLIT_PCT lines. */
  consignmentSupplierSplitPct?: number | null;
  /** Authoritative supplier owed per unit, computed from the snapshotted terms + sale price at the moment of sale. The Consignment payout workflow uses this (falling back to unitCost for legacy rows). */
  consignmentSupplierPayoutPerUnitGbp?: number | null;
  /** True when the operator manually overrode consignmentSupplierPayoutPerUnitGbp at sale entry (a warning is shown in the UI). */
  consignmentPayoutOverridden?: boolean | null;
  /** The unitCost as it was first snapshotted at sale time. Populated only after the line has been recalculated at least once via /inventory/{id}/recalculate-sale-costs. */
  originalUnitCost?: number | null;
  /** The consignment supplier per-unit owed amount as it was first snapshotted at sale time. Populated only after the line has been recalculated at least once. */
  originalConsignmentSupplierPayoutPerUnitGbp?: number | null;
  /** Timestamp of the most recent cost recalculation, or null if the line still uses its original snapshot. */
  costRecalculatedAt?: string | null;
  /** How many times this line's cost has been recalculated since sale. */
  costRecalculatedCount?: number | null;
  /** UUID of the inventory_serials row linked to this line at dispatch time. Null if no serial was assigned. */
  serialId?: string | null;
  /** Serial number of the linked inventory_serials row. Null if no serial assigned or the row has no serial number. */
  serialNumber?: string | null;
  /** Certificate number of the linked inventory_serials row. Null if no serial assigned or the row has no certificate number. */
  certificateNumber?: string | null;
});

export type ReturnToSupplierInputItemsItemReason = typeof ReturnToSupplierInputItemsItemReason[keyof typeof ReturnToSupplierInputItemsItemReason];


export const ReturnToSupplierInputItemsItemReason = {
  unsold_return: 'unsold_return',
  swap: 'swap',
  damaged: 'damaged',
  other: 'other',
} as const;

export type ReturnToSupplierInputItemsItem = {
  inventoryItemId: string;
  /** @minimum 1 */
  quantity: number;
  reason: ReturnToSupplierInputItemsItemReason;
  notes?: string | null;
};

export interface ReturnToSupplierInput {
  /**
     * @minItems 1
     * @maxItems 200
     */
  items: ReturnToSupplierInputItemsItem[];
}

export type ReturnToSupplierResultReturnedItem = {
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  supplierName?: string | null;
  quantity: number;
  reason: string;
  previousQuantity: number;
  newQuantity: number;
};

export type ReturnToSupplierResultErrorsItem = {
  inventoryItemId: string;
  sku?: string | null;
  error: string;
};

export type ReturnToSupplierResultSummary = {
  totalReturned: number;
  totalErrors: number;
  totalUnitsReturned: number;
};

export interface ReturnToSupplierResult {
  returned: ReturnToSupplierResultReturnedItem[];
  errors: ReturnToSupplierResultErrorsItem[];
  summary: ReturnToSupplierResultSummary;
}

/**
 * `open` — only sale lines on orders that are not yet fully paid
 * and not cancelled/refunded. `all` — every sale line for the SKU
 * that isn't otherwise locked. Lines paid out to a supplier,
 * refunded, cancelled, or manually-overridden are always skipped
 * regardless of scope.
 */
export type RecalcSaleCostsBodyScope = typeof RecalcSaleCostsBodyScope[keyof typeof RecalcSaleCostsBodyScope];


export const RecalcSaleCostsBodyScope = {
  open: 'open',
  all: 'all',
} as const;

export interface RecalcSaleCostsBody {
  /**
     * `open` — only sale lines on orders that are not yet fully paid
     * and not cancelled/refunded. `all` — every sale line for the SKU
     * that isn't otherwise locked. Lines paid out to a supplier,
     * refunded, cancelled, or manually-overridden are always skipped
     * regardless of scope.
     */
  scope: RecalcSaleCostsBodyScope;
  /** When true, returns the same summary shape as a real apply but performs no writes. Defaults to false. */
  dryRun?: boolean | null;
  /** Optional free-text note recorded on each updated line and on the audit log entry. */
  reason?: string | null;
}

export type RecalcSaleCostLineStatus = typeof RecalcSaleCostLineStatus[keyof typeof RecalcSaleCostLineStatus];


export const RecalcSaleCostLineStatus = {
  'would-update': 'would-update',
  updated: 'updated',
  skipped: 'skipped',
  unchanged: 'unchanged',
} as const;

export interface RecalcSaleCostLine {
  lineId: string;
  saleOrderId: string;
  orderNumber: string;
  productTitle: string;
  quantity: number;
  oldUnitCost: number;
  newUnitCost: number;
  oldLineCost: number;
  newLineCost: number;
  oldLineProfit: number;
  newLineProfit: number;
  status: RecalcSaleCostLineStatus;
  skipReason?: string | null;
}

export type RecalcSaleCostsResultScope = typeof RecalcSaleCostsResultScope[keyof typeof RecalcSaleCostsResultScope];


export const RecalcSaleCostsResultScope = {
  open: 'open',
  all: 'all',
} as const;

export type RecalcSaleCostsResultPostCommitProjection = typeof RecalcSaleCostsResultPostCommitProjection[keyof typeof RecalcSaleCostsResultPostCommitProjection];


export const RecalcSaleCostsResultPostCommitProjection = {
  'not-required': 'not-required',
  refreshed: 'refreshed',
  pending: 'pending',
} as const;

export type RecalcSaleCostsResultPostCommitCacheInvalidation = typeof RecalcSaleCostsResultPostCommitCacheInvalidation[keyof typeof RecalcSaleCostsResultPostCommitCacheInvalidation];


export const RecalcSaleCostsResultPostCommitCacheInvalidation = {
  'not-required': 'not-required',
  completed: 'completed',
  pending: 'pending',
} as const;

export type RecalcSaleCostsResultPostCommitAudit = typeof RecalcSaleCostsResultPostCommitAudit[keyof typeof RecalcSaleCostsResultPostCommitAudit];


export const RecalcSaleCostsResultPostCommitAudit = {
  'not-required': 'not-required',
  recorded: 'recorded',
  pending: 'pending',
} as const;

export type RecalcSaleCostsResultPostCommit = {
  sourceCommitted: boolean;
  projection: RecalcSaleCostsResultPostCommitProjection;
  cacheInvalidation: RecalcSaleCostsResultPostCommitCacheInvalidation;
  audit: RecalcSaleCostsResultPostCommitAudit;
  affectedProductPerformanceDays: string[];
  productPerformanceRowsRefreshed: number[];
  message?: string;
} | null;

export interface RecalcSaleCostsResult {
  inventoryItemId: string;
  sku?: string | null;
  productTitle?: string | null;
  scope: RecalcSaleCostsResultScope;
  dryRun: boolean;
  reason?: string | null;
  /** Total sale lines linked to this SKU. */
  found: number;
  /** Sale lines whose cost would change (excludes skipped + unchanged). */
  eligible: number;
  /** Lines actually written to the database. Always 0 when dryRun. */
  updated: number;
  skipped: number;
  unchanged: number;
  oldTotalCostGbp: number;
  newTotalCostGbp: number;
  oldTotalProfitGbp: number;
  newTotalProfitGbp: number;
  /** newTotalProfitGbp − oldTotalProfitGbp. Positive means profit grows after the recalc. */
  differenceGbp: number;
  lines: RecalcSaleCostLine[];
  postCommit?: RecalcSaleCostsResultPostCommit;
}

/**
 * Singleton walk-in customer returned by POST /customers/walk-in.
 */
export interface WalkInCustomerResponse {
  customerId: string;
  name: string;
  /** True if this call created the singleton; false if it already existed. */
  created: boolean;
}

/**
 * Inline customer payload sent with a sale create. The server reuses an existing customer matched by case-insensitive email; otherwise it creates a new customer row and uses the new id for the sale.
 */
export interface NewCustomerInline {
  name: string;
  email?: string | null;
  phone?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  /** Acquisition source for the customer (free-text). Frontend offers WhatsApp / Instagram / eBay / Shopify / Whatnot / Direct / Other but any string is accepted so legacy values stay valid. */
  source?: string | null;
  /** Free-text staff notes captured at sale time (e.g. "regular eBay buyer, prefers tracked"). */
  notes?: string | null;
}

/**
 * Shopify Payments fee provenance. `confirmed` means platformFees is
 * the signed provider-reported aggregate. `pending` means the order
 * is imported but settlement has not been found yet; `estimated` and
 * `unavailable` are never provider-confirmed values.
 */
export type SaleOrderInputShopifyPlatformFeeStatus = typeof SaleOrderInputShopifyPlatformFeeStatus[keyof typeof SaleOrderInputShopifyPlatformFeeStatus] | null;


export const SaleOrderInputShopifyPlatformFeeStatus = {
  estimated: 'estimated',
  pending: 'pending',
  confirmed: 'confirmed',
  unavailable: 'unavailable',
} as const;

/**
 * Explicit operator decision required when this create results in a fully paid sale. Does not create dispatch evidence unless shipped is selected.
 */
export type SaleOrderInputPaidFulfilmentChoice = typeof SaleOrderInputPaidFulfilmentChoice[keyof typeof SaleOrderInputPaidFulfilmentChoice] | null;


export const SaleOrderInputPaidFulfilmentChoice = {
  shipped: 'shipped',
  boxed: 'boxed',
} as const;

/**
 * Customer is required: provide either an existing `customerId` OR a `newCustomer` object. The server validates that exactly one is supplied.
 */
export interface SaleOrderInput {
  /** Existing customer id. Mutually exclusive with `newCustomer`. */
  customerId?: string | null;
  /** Inline customer payload. Mutually exclusive with `customerId`. Email-deduped against existing customers. */
  newCustomer?: NewCustomerInline | null;
  channel: string;
  saleDate: string;
  /** ISO currency code for the entire order (revenue, fees, costs charged on this invoice). Defaults to GBP. */
  currency?: string | null;
  discount?: number | null;
  shippingCharged?: number | null;
  shippingCost?: number | null;
  platformFees?: number;
  /**
     * Shopify Payments fee provenance. `confirmed` means platformFees is
     * the signed provider-reported aggregate. `pending` means the order
     * is imported but settlement has not been found yet; `estimated` and
     * `unavailable` are never provider-confirmed values.
     */
  shopifyPlatformFeeStatus?: SaleOrderInputShopifyPlatformFeeStatus;
  /** Timestamp of the latest matched Shopify Payments balance transaction. */
  shopifyPlatformFeeSourceTimestamp?: string | null;
  paymentMethod?: string | null;
  /**
     * Manual-order opening payment status (Task #1232). One of the stored
     * PaymentStatus values (never "Outstanding" — that is derived). Defaults
     * to "Unpaid" for manual orders. Creating an Unpaid/Part Paid order (or
     * supplying paymentDueDate) requires the `sales.payment.create_unpaid`
     * permission, enforced server-side.
     */
  paymentStatus?: string | null;
  /** Explicit operator decision required when this create results in a fully paid sale. Does not create dispatch evidence unless shipped is selected. */
  paidFulfilmentChoice?: SaleOrderInputPaidFulfilmentChoice;
  /**
     * Manual-order opening amount already paid (Task #1232). Clamped to the
     * order total server-side; drives the derived Part Paid / Paid status.
     * @minimum 0
     */
  amountPaid?: number | null;
  /** Manual-order payment due date (ISO date). Open-account orders past this date derive the "Outstanding" status. */
  paymentDueDate?: string | null;
  /**
     * Manual-order opening payment reference (e.g. bank transfer ref).
     * @maxLength 200
     */
  paymentReference?: string | null;
  /**
     * Manual-order opening payment note.
     * @maxLength 2000
     */
  paymentNotes?: string | null;
  status?: string | null;
  trackingNumber?: string | null;
  externalOrderNumber?: string | null;
  /** eBay's long-form Order ID (distinct from the shorter Sales record number stored in externalOrderNumber). */
  ebayOrderId?: string | null;
  notes?: string | null;
  items: SaleItemInput[];
}

export type ProfitBlockerReason = typeof ProfitBlockerReason[keyof typeof ProfitBlockerReason];


export const ProfitBlockerReason = {
  unresolved_acquisition_evidence: 'unresolved_acquisition_evidence',
  incomplete_allocations: 'incomplete_allocations',
  stale_derived_cost: 'stale_derived_cost',
  unconfirmed_platform_fees: 'unconfirmed_platform_fees',
  unsupported_currency: 'unsupported_currency',
} as const;

export interface SalesProfitBlockerOrder {
  saleOrderId: string;
  orderNumber: string;
  saleDate: string;
  channel: string;
  currency: string;
  blockerReason: ProfitBlockerReason;
  affectedLines: string[];
  nextAction: string;
  evidenceNeeded: string;
}

export interface SalesProfitBlockerReasonCount {
  blockerReason: ProfitBlockerReason;
  count: number;
}

export interface SalesProfitBlockersPage {
  items: SalesProfitBlockerOrder[];
  counts: SalesProfitBlockerReasonCount[];
  total: number;
  limit: number;
  offset: number;
}

export interface SalesAssignee {
  /** Tenant-member user ID used by packing assignments. */
  id: string;
  /** Display name, falling back to the member email address. */
  name: string;
}

export type EffectiveOrderFlagPriority = typeof EffectiveOrderFlagPriority[keyof typeof EffectiveOrderFlagPriority];


export const EffectiveOrderFlagPriority = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

export type EffectiveOrderFlagEntityType = typeof EffectiveOrderFlagEntityType[keyof typeof EffectiveOrderFlagEntityType];


export const EffectiveOrderFlagEntityType = {
  customer: 'customer',
  company: 'company',
  order: 'order',
} as const;

export type EffectiveOrderFlagScope = typeof EffectiveOrderFlagScope[keyof typeof EffectiveOrderFlagScope];


export const EffectiveOrderFlagScope = {
  order: 'order',
  customer: 'customer',
  company: 'company',
} as const;

export interface EffectiveOrderFlag {
  assignmentId: string;
  flagId: string;
  name: string;
  description: string | null;
  colour: string;
  priority: EffectiveOrderFlagPriority;
  isSystem: boolean;
  notes: string | null;
  assignedAt: string;
  entityType: EffectiveOrderFlagEntityType;
  entityId: string;
  scope: EffectiveOrderFlagScope;
  scopeLabel: string | null;
}

/**
 * Address provenance. Staff order-specific corrections take precedence for display; marketplace evidence remains separately stored.
 */
export type SaleOrderShipToSource = typeof SaleOrderShipToSource[keyof typeof SaleOrderShipToSource];


export const SaleOrderShipToSource = {
  packing_job: 'packing_job',
  shopify_order: 'shopify_order',
  customer_profile: 'customer_profile',
  order_override: 'order_override',
} as const;

export interface SaleOrderShipTo {
  name?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  phone?: string | null;
  email?: string | null;
  /** Address provenance. Staff order-specific corrections take precedence for display; marketplace evidence remains separately stored. */
  source: SaleOrderShipToSource;
}

export interface SaleOrderCustomerDeliveryDetails {
  name?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  phone?: string | null;
  email?: string | null;
}

export type SaleOrderDetail = SaleOrder & ({
  items: SaleItem[];
  /**
     * Order, customer, and linked-company flags that apply to this
     * sale, deduplicated by flag with the most specific scope kept.
     */
  effectiveFlags: EffectiveOrderFlag[];
  /**
     * Invoice already generated from this sale, or null when none
     * exists.
     */
  generatedInvoice: GeneratedSaleInvoice | null;
  /** Latest provider-supplied source timestamp among the Whatnot fee ledger entries attached to this sale. Null when the fee source did not provide one. */
  whatnotFeeSourceTimestamp?: string | null;
  /**
     * Buyer's TikTok @handle (without the leading @), captured at
     * label import and joined back from packing_jobs. Null for non-TikTok
     * orders or when no usable handle was captured. Already cleaned of
     * junk/masked placeholders at import — render as-is.
     */
  tiktokUsername?: string | null;
  /**
     * Buyer's TikTok display alias, captured at label import and joined
     * back from packing_jobs. Null when absent or masked. Pairs with
     * tiktokUsername as "@username · alias".
     */
  tiktokNickname?: string | null;
  /** Delivery/contact details preferring the Shopify sales-order address, then the linked customer's address on file. */
  shipTo?: SaleOrderShipTo | null;
  /**
     * Customer delivery details explicitly selected for this order.
     * Kept separate from marketplace-originated ship-to evidence and
     * used as a staff correction without changing that evidence.
     */
  customerDeliveryDetails?: SaleOrderCustomerDeliveryDetails | null;
  /** Billing contact name selected for this order, falling back to the linked customer's name. */
  customerBillingName: string | null;
  /**
     * Version of the order-specific contact and address snapshot.
     * Send this value when saving edits to reject stale writes.
     */
  customerDetailsVersion: string | null;
});

export type SaleOrderCustomerDetailsUpdateContact = {
  /** @maxLength 500 */
  email: string | null;
  /** @maxLength 500 */
  phone: string | null;
};

export type SaleOrderCustomerDetailsUpdateBilling = {
  /** @maxLength 500 */
  name: string | null;
  /** @maxLength 500 */
  addressLine1: string | null;
  /** @maxLength 500 */
  addressLine2: string | null;
  /** @maxLength 500 */
  city: string | null;
  /** @maxLength 500 */
  postcode: string | null;
  /** @maxLength 500 */
  country: string | null;
};

export type SaleOrderCustomerDetailsUpdateDelivery = {
  /** @maxLength 500 */
  name: string | null;
  /** @maxLength 500 */
  addressLine1: string | null;
  /** @maxLength 500 */
  addressLine2: string | null;
  /** @maxLength 500 */
  city: string | null;
  /** @maxLength 500 */
  postcode: string | null;
  /** @maxLength 500 */
  country: string | null;
  /** @maxLength 500 */
  phone: string | null;
  /** @maxLength 500 */
  email: string | null;
};

export type SaleOrderCustomerDetailsUpdate = (unknown & {
  /** Version returned by the sale detail response; null when no order-specific snapshot exists. */
  expectedVersion: string | null;
  contact?: SaleOrderCustomerDetailsUpdateContact;
  billing?: SaleOrderCustomerDetailsUpdateBilling;
  delivery?: SaleOrderCustomerDetailsUpdateDelivery;
});

export interface ShopifyDeliveryRecoveryRequest {
  /**
     * Numeric Shopify order id; must exactly match the sale's stored external order id.
     * @pattern ^\d{1,32}$
     */
  externalOrderId: string;
}

export type ShopifyDeliveryRecoveryResponseUpdatedFieldsItem = typeof ShopifyDeliveryRecoveryResponseUpdatedFieldsItem[keyof typeof ShopifyDeliveryRecoveryResponseUpdatedFieldsItem];


export const ShopifyDeliveryRecoveryResponseUpdatedFieldsItem = {
  name: 'name',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  postcode: 'postcode',
  country: 'country',
  phone: 'phone',
  email: 'email',
} as const;

export type ShopifyDeliveryRecoveryResponseVerificationDisplayedSource = typeof ShopifyDeliveryRecoveryResponseVerificationDisplayedSource[keyof typeof ShopifyDeliveryRecoveryResponseVerificationDisplayedSource] | null;


export const ShopifyDeliveryRecoveryResponseVerificationDisplayedSource = {
  packing_job: 'packing_job',
  shopify_order: 'shopify_order',
  customer_profile: 'customer_profile',
  order_override: 'order_override',
} as const;

export type ShopifyDeliveryRecoveryResponseVerificationPhoneStatus = typeof ShopifyDeliveryRecoveryResponseVerificationPhoneStatus[keyof typeof ShopifyDeliveryRecoveryResponseVerificationPhoneStatus];


export const ShopifyDeliveryRecoveryResponseVerificationPhoneStatus = {
  verified: 'verified',
  not_returned: 'not_returned',
  preserved_or_overridden: 'preserved_or_overridden',
} as const;

export type ShopifyDeliveryRecoveryResponseVerification = {
  displayedSource: ShopifyDeliveryRecoveryResponseVerificationDisplayedSource;
  addressMatchesShopify: boolean | null;
  phoneStatus: ShopifyDeliveryRecoveryResponseVerificationPhoneStatus;
  emailMatchesShopify: boolean | null;
};

export interface ShopifyDeliveryRecoveryResponse {
  saleOrderId: string;
  externalOrderId: string;
  updatedFields: ShopifyDeliveryRecoveryResponseUpdatedFieldsItem[];
  /** The verified order's delivery/contact fields returned by Shopify. */
  providerDelivery: SaleOrderShipTo;
  displayedDelivery: SaleOrderShipTo | null;
  verification: ShopifyDeliveryRecoveryResponseVerification;
  message: string;
}

export interface ShopifyDeliveryBackfillCandidate {
  saleOrderId: string;
  orderNumber: string;
  externalOrderId: string;
}

export interface ShopifyDeliveryBackfillPreview {
  /** @minimum 0 */
  eligibleCount: number;
  sample: ShopifyDeliveryBackfillCandidate[];
  /** @minimum 1 */
  maxOrdersPerRun: number;
  /** @minimum 1 */
  batchSize: number;
}

export type ShopifyDeliveryBackfillDetailOutcome = typeof ShopifyDeliveryBackfillDetailOutcome[keyof typeof ShopifyDeliveryBackfillDetailOutcome];


export const ShopifyDeliveryBackfillDetailOutcome = {
  provider_missing: 'provider_missing',
  skipped: 'skipped',
  failed: 'failed',
  restored: 'restored',
  already_complete: 'already_complete',
} as const;

export interface ShopifyDeliveryBackfillDetail {
  saleOrderId: string;
  orderNumber: string;
  externalOrderId: string;
  outcome: ShopifyDeliveryBackfillDetailOutcome;
  reason: string;
  restoredFields?: string[];
  missingFields?: string[];
}

export interface ShopifyDeliveryBackfillRetryInput {
  /**
     * @minItems 1
     * @maxItems 10
     */
  saleOrderIds: string[];
}

export type ShopifyDeliveryBackfillRunStatus = typeof ShopifyDeliveryBackfillRunStatus[keyof typeof ShopifyDeliveryBackfillRunStatus];


export const ShopifyDeliveryBackfillRunStatus = {
  running: 'running',
  rate_limited: 'rate_limited',
  completed: 'completed',
  partial: 'partial',
  limit_reached: 'limit_reached',
} as const;

export interface ShopifyDeliveryBackfillRun {
  id: string;
  status: ShopifyDeliveryBackfillRunStatus;
  maxOrders: number;
  processed: number;
  restored: number;
  alreadyComplete: number;
  providerMissing: number;
  skipped: number;
  failed: number;
  details: ShopifyDeliveryBackfillDetail[];
  message: string | null;
  createdAt: string;
  updatedAt: string;
  finishedAt: string | null;
  leaseUntil: string | null;
}

export interface ShopifyDeliveryBackfillRetryResult {
  run: ShopifyDeliveryBackfillRun;
  busy: boolean;
  rateLimited: boolean;
}

export type FlagEntityType = typeof FlagEntityType[keyof typeof FlagEntityType];


export const FlagEntityType = {
  customer: 'customer',
  company: 'company',
  order: 'order',
  inventory_item: 'inventory_item',
  sales_order: 'sales_order',
} as const;

export type FlagContext = typeof FlagContext[keyof typeof FlagContext];


export const FlagContext = {
  legacy: 'legacy',
  inventory: 'inventory',
  sales: 'sales',
} as const;

export interface FlagDefinition {
  id: string;
  name: string;
  description: string | null;
  colour: string;
  priority: FlagPriority;
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
  context: FlagContext;
  archivedAt?: string | null;
  sortOrder?: number;
  usageCount?: number;
  lastUsedAt?: string | null;
}

export interface FlagCreateInput {
  /**
     * @minLength 1
     * @maxLength 80
     */
  name: string;
  /** @maxLength 500 */
  description?: string | null;
  /** @pattern ^#[0-9a-fA-F]{6}$ */
  colour?: string;
  priority?: FlagPriority;
  context?: FlagContext;
}

export interface FlagUpdate {
  /**
     * @minLength 1
     * @maxLength 80
     */
  name?: string;
  /** @maxLength 500 */
  description?: string | null;
  /** @pattern ^#[0-9a-fA-F]{6}$ */
  colour?: string;
  priority?: FlagPriority;
  context?: FlagContext;
  archived?: boolean;
  /** @minimum 0 */
  sortOrder?: number;
}

export interface FlagAssignment {
  assignmentId: string;
  flagId: string;
  name: string;
  description: string | null;
  colour: string;
  priority: FlagPriority;
  isSystem: boolean;
  notes: string | null;
  assignedAt: string;
  entityType: FlagEntityType;
  entityId: string;
  context: FlagContext;
}

export interface FlagAssignmentInput {
  flagId: string;
  entityType: FlagEntityType;
  entityId: string;
  /** @maxLength 500 */
  notes?: string | null;
  context?: FlagContext;
}

export interface FlagAssignmentCreated {
  assignmentId: string;
  flagId: string;
  entityType: FlagEntityType;
  entityId: string;
  notes: string | null;
  assignedAt: string;
  context?: FlagContext;
}

export type FlagBulkAssignmentInputOperation = typeof FlagBulkAssignmentInputOperation[keyof typeof FlagBulkAssignmentInputOperation];


export const FlagBulkAssignmentInputOperation = {
  add: 'add',
  remove: 'remove',
} as const;

export interface FlagBulkAssignmentInput {
  flagId: string;
  entityType: FlagEntityType;
  /**
     * @minItems 1
     * @maxItems 1000
     */
  entityIds: string[];
  context?: FlagContext;
  operation: FlagBulkAssignmentInputOperation;
}

export interface FlagBulkAssignmentResult {
  changed: number;
  requested: number;
}

/**
 * Result of a payment mutation — `ok` plus the refreshed payment block.
 */
export interface SalePaymentActionResponse {
  ok: boolean;
  payment: SalePaymentBlock;
}

/**
 * Required when the operation makes the sale fully Paid.
 */
export type PaidSaleFulfilmentInputPaidFulfilmentChoice = typeof PaidSaleFulfilmentInputPaidFulfilmentChoice[keyof typeof PaidSaleFulfilmentInputPaidFulfilmentChoice] | null;


export const PaidSaleFulfilmentInputPaidFulfilmentChoice = {
  shipped: 'shipped',
  boxed: 'boxed',
} as const;

/**
 * Explicit full-payment fulfilment choice; tracking edits are optional and omitted values preserve existing tracking.
 */
export interface PaidSaleFulfilmentInput {
  /** Required when the operation makes the sale fully Paid. */
  paidFulfilmentChoice?: PaidSaleFulfilmentInputPaidFulfilmentChoice;
  /**
     * Optional tracking edit when shipped is explicitly selected.
     * @maxLength 200
     */
  trackingNumber?: string | null;
}

/**
 * Required when this payment makes the order fully Paid.
 */
export type RecordOrderPaymentBodyPaidFulfilmentChoice = typeof RecordOrderPaymentBodyPaidFulfilmentChoice[keyof typeof RecordOrderPaymentBodyPaidFulfilmentChoice] | null;


export const RecordOrderPaymentBodyPaidFulfilmentChoice = {
  shipped: 'shipped',
  boxed: 'boxed',
} as const;

/**
 * Record a payment (or, with a negative amount, a contra/adjustment) against a manual order.
 */
export interface RecordOrderPaymentBody {
  /** Payment amount in the order currency. Negative records a contra/adjustment entry. */
  amount: number;
  method?: string | null;
  /** @maxLength 200 */
  reference?: string | null;
  /** @maxLength 2000 */
  notes?: string | null;
  /** ISO date the payment was received. Defaults to now when omitted. */
  paymentDate?: string | null;
  /** Required when this payment makes the order fully Paid. */
  paidFulfilmentChoice?: RecordOrderPaymentBodyPaidFulfilmentChoice;
  /** Optional tracking edit when shipped is explicitly selected; omitted preserves existing tracking. */
  trackingNumber?: string | null;
}

/**
 * Set or clear the payment due date on a manual order.
 */
export interface OrderPaymentDueDateBody {
  /** ISO date the balance is due, or null to clear. */
  dueDate?: string | null;
}

export interface OrderPaymentLedgerEntry {
  id: string;
  amount: number;
  method?: string | null;
  reference?: string | null;
  notes?: string | null;
  paymentDate?: string | null;
  createdAt?: string | null;
}

export interface OrderPaymentHistoryEntry {
  id: string;
  oldStatus?: string | null;
  newStatus?: string | null;
  note?: string | null;
  createdAt?: string | null;
}

/**
 * Full payment ledger and status-change history for a manual order.
 */
export interface OrderPaymentLedger {
  payments: OrderPaymentLedgerEntry[];
  history: OrderPaymentHistoryEntry[];
}

/**
 * Per-tenant policy controlling whether unpaid manual orders may be packed/shipped (Task
 */
export interface PaymentFulfilmentSettings {
  allowPackingUnpaidOrders: boolean;
  allowShippingUnpaidOrders: boolean;
  requireAdminOverrideForUnpaidShipping: boolean;
}

/**
 * Order-only customer detail groups to copy during reassignment.
 */
export type SaleStatusUpdateCustomerSyncGroups = {
  contact?: boolean;
  billing?: boolean;
  delivery?: boolean;
};

/**
 * Required when this update makes the order fully Paid.
 */
export type SaleStatusUpdatePaidFulfilmentChoice = typeof SaleStatusUpdatePaidFulfilmentChoice[keyof typeof SaleStatusUpdatePaidFulfilmentChoice] | null;


export const SaleStatusUpdatePaidFulfilmentChoice = {
  shipped: 'shipped',
  boxed: 'boxed',
} as const;

export interface SaleStatusUpdate {
  /** New tenant customer for a dedicated customer reassignment request. */
  customerId?: string;
  /** Current customer ID required to reject stale reassignment requests. */
  expectedCustomerId?: string;
  /** Order-only customer detail groups to copy during reassignment. */
  customerSyncGroups?: SaleStatusUpdateCustomerSyncGroups;
  status?: string | null;
  paymentStatus?: string | null;
  /** Required when this update makes the order fully Paid. */
  paidFulfilmentChoice?: SaleStatusUpdatePaidFulfilmentChoice;
  trackingNumber?: string | null;
  ebayOrderId?: string | null;
  notes?: string | null;
  /**
     * Manual profit-adjustment in GBP. Set to 0 (or null/omit) to clear.
     * @minimum 0
     */
  additionalCostsGbp?: number | null;
  /** Free-text reason for the additionalCostsGbp adjustment. */
  additionalCostsReason?: string | null;
  /**
     * Postage charged to the customer, in the sale's currency. May only be
     * changed for manual orders and must remain on the primary order for a
     * combined-postage group. Changing it recalculates the outstanding
     * balance; it does not record a payment.
     * @minimum 0
     */
  shippingCharged?: number | null;
  /**
     * Carrier cost paid by us to ship this order, in the sale's currency.
     * For combined-postage groups, set on the PRIMARY order only — siblings
     * stay at 0 to avoid multi-counting (see docs/gotchas.md "Order profit math").
     * @minimum 0
     */
  shippingCost?: number | null;
}

export interface CreateRefundLine {
  saleOrderItemId: string;
  /** @minimum 0 */
  returnedQuantity: number;
  /** @minimum 0 */
  refundAmountGbp: number;
}

export interface CreateRefundInput {
  reason?: string | null;
  /** @minimum 0 */
  refundAmountGbp: number;
  refundMethod?: string | null;
  pushToShopify?: boolean;
  pushToEbay?: boolean;
  notes?: string | null;
  /** @minItems 1 */
  lines: CreateRefundLine[];
}

export interface OrderAdjustmentListRow {
  id: string;
  adjustmentNumber: string;
  saleOrderId: string;
  saleOrderNumber?: string | null;
  saleChannel?: string | null;
  type: string;
  refundAmountGbp: string;
  refundMethod?: string | null;
  pushToShopify: boolean;
  pushToEbay: boolean;
  refundedAt: string;
  createdByName?: string | null;
  reason?: string | null;
}

export interface OrderAdjustmentItemDetail {
  id: string;
  saleOrderItemId: string;
  productTitle?: string | null;
  originalSku?: string | null;
  returnedQuantity: number;
  refundAmountGbp: string;
  restockedInventoryItemId?: string | null;
  restockedSku?: string | null;
  restockUnitCostGbp?: string | null;
  shopifyRelistEnqueuedAt?: string | null;
  ebayRelistEnqueuedAt?: string | null;
}

export interface OrderAdjustmentDetail {
  id: string;
  adjustmentNumber: string;
  saleOrderId: string;
  saleOrderNumber?: string | null;
  saleChannel?: string | null;
  customerId?: string | null;
  type: string;
  reason?: string | null;
  refundAmountGbp: string;
  refundMethod?: string | null;
  refundedAt: string;
  pushToShopify: boolean;
  pushToEbay: boolean;
  notes?: string | null;
  createdByName?: string | null;
  createdAt?: string;
  items: OrderAdjustmentItemDetail[];
}

export interface SalesChannel {
  /** null for channels inferred from sale orders that have no explicit sales_channels row */
  id?: string | null;
  name: string;
  active: boolean;
  defaultFeePct: number;
  /** true when this channel exists only in sale_orders, not as an explicit sales_channels row */
  implicit: boolean;
  totalSales: number;
  totalProfit: number;
  orders: number;
  avgMargin: number;
}

export interface SalesChannelCreateInput {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
  active?: boolean;
  /**
     * @minimum 0
     * @maximum 100
     */
  defaultFeePct?: number;
}

export interface SalesChannelUpdateInput {
  active?: boolean;
  /**
     * @minimum 0
     * @maximum 100
     */
  defaultFeePct?: number;
}

/**
 * Stationery classification used by the smart packaging recommendation
 * engine. Only items in the box / envelope / padded_mailer / tube
 * families participate in the dimensional fit calculation.
 */
export type PackagingType = typeof PackagingType[keyof typeof PackagingType];


export const PackagingType = {
  box: 'box',
  envelope: 'envelope',
  padded_mailer: 'padded_mailer',
  tube: 'tube',
  insert: 'insert',
  consumable: 'consumable',
  other: 'other',
} as const;

export interface StationeryItemInput {
  name: string;
  sku?: string | null;
  unit?: string | null;
  /** Category for packaging usage: e.g. "envelope", "box", "wrap", "tape", "insert", "consumable". */
  usageType?: string | null;
  packagingType?: PackagingType | null;
  /**
     * Internal usable length (cm) of a packaging item. Required for the recommendation engine to consider this stationery as a candidate box.
     * @minimum 0
     * @exclusiveMinimum
     */
  internalLengthCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  internalWidthCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  internalHeightCm?: number | null;
  /**
     * Optional carrier weight cap (grams). When null, weight is not enforced.
     * @minimum 0
     * @exclusiveMinimum
     */
  maxWeightGrams?: number | null;
  /** @minimum 0 */
  currentQuantity: number;
  /**
     * Low-stock alert threshold. Stock at or below this triggers alerts.
     * @minimum 0
     */
  minQuantity?: number;
  /** @minimum 0 */
  targetQuantity: number;
  notes?: string | null;
}

export interface StationeryItemUpdate {
  name?: string;
  sku?: string | null;
  unit?: string | null;
  usageType?: string | null;
  packagingType?: PackagingType | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  internalLengthCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  internalWidthCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  internalHeightCm?: number | null;
  /**
     * @minimum 0
     * @exclusiveMinimum
     */
  maxWeightGrams?: number | null;
  /** @minimum 0 */
  currentQuantity?: number;
  /** @minimum 0 */
  minQuantity?: number;
  /** @minimum 0 */
  targetQuantity?: number;
  notes?: string | null;
}

export interface StationeryAdjustInput {
  /** Signed change applied to currentQuantity. Negative values decrement. */
  delta: number;
}

export interface StationeryItem {
  id: string;
  name: string;
  sku?: string | null;
  unit: string;
  usageType?: string | null;
  currentQuantity: number;
  minQuantity: number;
  targetQuantity: number;
  notes?: string | null;
  /** currentQuantity / targetQuantity (0–1+). Returns 1 when targetQuantity is 0. */
  percentRemaining: number;
  /** True when currentQuantity is at or below minQuantity (and minQuantity > 0); falls back to <25% of targetQuantity if minQuantity is 0. */
  lowStock: boolean;
  /** Average daily packaging consumption over the last 30 days. Null when no usage recorded. */
  usageRatePerDay?: number | null;
  /** Estimated days until stockout based on usageRatePerDay. Null when usage rate is 0. */
  daysRemaining?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface PackagingPreset {
  stationeryId: string;
  name: string;
  sku?: string | null;
  usageType?: string | null;
  /** @minimum 1 */
  quantity: number;
}

export type PackagingPresetInputPresetsItem = {
  stationeryId: string;
  /** @minimum 1 */
  quantity: number;
};

export interface PackagingPresetInput {
  presets: PackagingPresetInputPresetsItem[];
}

export interface PackagingMaterial {
  stationeryId: string;
  name: string;
  sku?: string | null;
  usageType?: string | null;
  /** @minimum 1 */
  quantity: number;
  /** Current stationery currentQuantity (snapshot at fetch time). */
  available: number;
}

export type SocialPlatform = typeof SocialPlatform[keyof typeof SocialPlatform];


export const SocialPlatform = {
  x: 'x',
  linkedin: 'linkedin',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  whatnot: 'whatnot',
  ebay_live: 'ebay_live',
  pinterest: 'pinterest',
  youtube: 'youtube',
  threads: 'threads',
  google_business: 'google_business',
} as const;

export interface SocialConnectionStatus {
  platform: SocialPlatform;
  label: string;
  connected: boolean;
  missingSecrets: string[];
  lastSyncAt: string | null;
  lastSyncStatus: string | null;
  lastSyncMessage: string | null;
  /** Whether composed posts can actually be published to this platform (false for connect-only platforms or when a required prerequisite, e.g. a Pinterest board, is missing). */
  publishSupported: boolean;
  /** Human-readable explanation shown when publishSupported is false. */
  publishNotice: string | null;
}

export interface SocialPost {
  id: string;
  platform: SocialPlatform;
  externalId: string;
  authorHandle?: string | null;
  postedAt?: string | null;
  text: string;
  mediaUrl?: string | null;
  permalink?: string | null;
  likes: number;
  comments: number;
  shares: number;
  views: number;
  fetchedAt: string;
}

export type SocialSyncLogStatus = typeof SocialSyncLogStatus[keyof typeof SocialSyncLogStatus];


export const SocialSyncLogStatus = {
  success: 'success',
  partial: 'partial',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface SocialSyncLog {
  id: string;
  platform: SocialPlatform;
  status: SocialSyncLogStatus;
  message: string;
  fetchedCount: number;
  durationMs: number;
  createdAt: string;
}

export type SocialEbaySummaryTopProductTypesItem = {
  productType: string;
  units: number;
  revenue: string;
};

export interface SocialEbaySummary {
  windowDays: number;
  orderCount: number;
  revenue: string;
  activeListings: number;
  topProductTypes: SocialEbaySummaryTopProductTypesItem[];
}

export interface SocialRecommendation {
  platform: SocialPlatform;
  insights: string[];
}

export interface SocialSyncRequest {
  platform: SocialPlatform;
}

export type SocialSettingsUpdateSettings = {
  /** @maxLength 5000 */
  xHandle?: string;
  /** @maxLength 5000 */
  requireApproval?: string;
  /** @maxLength 5000 */
  defaultTimezone?: string;
  /** @maxLength 5000 */
  autoRetryFailed?: string;
  /** @maxLength 5000 */
  maxRetryAttempts?: string;
  /** @maxLength 5000 */
  analyticsRefreshHours?: string;
  /** @maxLength 5000 */
  mediaUploadLimitMb?: string;
  /** @maxLength 5000 */
  postingQueueBehaviour?: string;
  /** @maxLength 5000 */
  brandVoice?: string;
  /** @maxLength 5000 */
  defaultHashtags?: string;
  /** @maxLength 5000 */
  trackingUtmSource?: string;
  /** @maxLength 5000 */
  trackingUtmMedium?: string;
  /** @maxLength 5000 */
  trackingUtmCampaign?: string;
  /** @maxLength 5000 */
  liveOverlayUrl?: string;
  /** @maxLength 5000 */
  overlayStudioUrl?: string;
  /** @maxLength 5000 */
  obsControlUrl?: string;
  /** @maxLength 5000 */
  liveRefreshSeconds?: string;
  /** @maxLength 5000 */
  aiSuggestionsEnabled?: string;
};

export interface SocialSettingsUpdate {
  settings: SocialSettingsUpdateSettings;
}

export type SocialPostResultStatus = typeof SocialPostResultStatus[keyof typeof SocialPostResultStatus];


export const SocialPostResultStatus = {
  pending: 'pending',
  ok: 'ok',
  failed: 'failed',
  skipped: 'skipped',
  not_configured: 'not_configured',
} as const;

export interface SocialPostResult {
  id: string;
  scheduledPostId: string;
  platform: SocialPlatform;
  status: SocialPostResultStatus;
  externalId?: string | null;
  externalUrl?: string | null;
  error?: string | null;
  attemptedAt: string;
}

export interface SocialPostReviewAction {
  /** @maxLength 2000 */
  note?: string;
}

/**
 * approve = mark post as approved; reject = prevent publish until revised
 */
export type SocialPostApprovalActionAction = typeof SocialPostApprovalActionAction[keyof typeof SocialPostApprovalActionAction];


export const SocialPostApprovalActionAction = {
  approve: 'approve',
  reject: 'reject',
} as const;

export interface SocialPostApprovalAction {
  /** approve = mark post as approved; reject = prevent publish until revised */
  action: SocialPostApprovalActionAction;
  /** @maxLength 2000 */
  note?: string;
}

export type SocialScheduledPostStatus = typeof SocialScheduledPostStatus[keyof typeof SocialScheduledPostStatus];


export const SocialScheduledPostStatus = {
  draft: 'draft',
  scheduled: 'scheduled',
  publishing: 'publishing',
  posted: 'posted',
  partial: 'partial',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export interface SocialScheduledPost {
  id: string;
  content: string;
  mediaUrl?: string | null;
  platforms: SocialPlatform[];
  /** IDs of connected social_accounts to post from (empty = all accounts for the platforms) */
  accountIds?: string[];
  /** Ordered media library asset IDs to attach to the post */
  mediaOrder?: string[];
  scheduledAt?: string | null;
  status: SocialScheduledPostStatus;
  lastError?: string | null;
  createdById?: string | null;
  createdAt: string;
  updatedAt: string;
  results: SocialPostResult[];
}

export type SocialScheduledPostCreateStatus = typeof SocialScheduledPostCreateStatus[keyof typeof SocialScheduledPostCreateStatus];


export const SocialScheduledPostCreateStatus = {
  draft: 'draft',
  scheduled: 'scheduled',
} as const;

/**
 * pending = submit for approval; not_required = default
 */
export type SocialScheduledPostCreateApprovalStatus = typeof SocialScheduledPostCreateApprovalStatus[keyof typeof SocialScheduledPostCreateApprovalStatus];


export const SocialScheduledPostCreateApprovalStatus = {
  not_required: 'not_required',
  pending: 'pending',
} as const;

export interface SocialScheduledPostCreate {
  /** @maxLength 5000 */
  content: string;
  mediaUrl?: string | null;
  /** @minItems 1 */
  platforms: SocialPlatform[];
  accountIds?: string[];
  mediaOrder?: string[];
  /** Link to a campaign */
  campaignId?: string | null;
  /** ISO timestamp; null/missing means save as draft. */
  scheduledAt?: string | null;
  status?: SocialScheduledPostCreateStatus;
  /** pending = submit for approval; not_required = default */
  approvalStatus?: SocialScheduledPostCreateApprovalStatus;
}

export type SocialScheduledPostUpdateStatus = typeof SocialScheduledPostUpdateStatus[keyof typeof SocialScheduledPostUpdateStatus];


export const SocialScheduledPostUpdateStatus = {
  draft: 'draft',
  scheduled: 'scheduled',
} as const;

export interface SocialScheduledPostUpdate {
  /** @maxLength 5000 */
  content?: string;
  mediaUrl?: string | null;
  platforms?: SocialPlatform[];
  accountIds?: string[];
  mediaOrder?: string[];
  campaignId?: string | null;
  scheduledAt?: string | null;
  status?: SocialScheduledPostUpdateStatus;
}

export type SocialOverviewPerPlatformItem = {
  platform: SocialPlatform;
  postCount: number;
  totalEngagement: number;
};

export type SocialOverviewFreshness = typeof SocialOverviewFreshness[keyof typeof SocialOverviewFreshness];


export const SocialOverviewFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
  reconciling: 'reconciling',
} as const;

export interface SocialOverview {
  recentPosts: SocialPost[];
  topPerformer: SocialPost | null;
  worstPerformer: SocialPost | null;
  perPlatform: SocialOverviewPerPlatformItem[];
  freshness?: SocialOverviewFreshness;
  generatedAt?: string | null;
  sourceWatermark?: string | null;
  unsupportedMetrics?: string[];
}

export type SocialPreparedOverviewFreshness = typeof SocialPreparedOverviewFreshness[keyof typeof SocialPreparedOverviewFreshness];


export const SocialPreparedOverviewFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
  reconciling: 'reconciling',
} as const;

export type SocialPreparedOverviewData = { [key: string]: unknown };

export interface SocialPreparedOverview {
  freshness: SocialPreparedOverviewFreshness;
  generatedAt: string | null;
  sourceWatermark: string | null;
  unsupportedMetrics: string[];
  data: SocialPreparedOverviewData;
}

export type SocialPreparedPostsPageFreshness = typeof SocialPreparedPostsPageFreshness[keyof typeof SocialPreparedPostsPageFreshness];


export const SocialPreparedPostsPageFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
  reconciling: 'reconciling',
} as const;

/**
 * Prepared post whose provider-unsupported engagement metrics are omitted or null.
 */
export interface SocialPreparedPost {
  id: string;
  platform: SocialPlatform;
  externalId: string;
  authorHandle?: string | null;
  postedAt?: string | null;
  text: string;
  mediaUrl?: string | null;
  permalink?: string | null;
  likes?: number | null;
  comments?: number | null;
  shares?: number | null;
  views?: number | null;
  fetchedAt: string;
}

export interface SocialPreparedPostsPage {
  items: SocialPreparedPost[];
  nextCursor: string | null;
  hasMore: boolean;
  limit: number;
  freshness: SocialPreparedPostsPageFreshness;
  sourceWatermark: string | null;
}

export type SocialCapabilityMetrics = {[key: string]: 'supported' | 'unsupported' | 'not_connected' | 'degraded'};

export interface SocialCapability {
  platform: SocialPlatform;
  metrics: SocialCapabilityMetrics;
  reason?: string;
}

export interface SocialAnalyticsSeriesPoint {
  date: string;
  likes?: number;
  comments?: number;
  shares?: number | null;
  views?: number | null;
}

export type SocialAnalyticsPerPlatformItem = {
  platform: SocialPlatform;
  posts: number;
  likes?: number;
  comments?: number;
  shares?: number | null;
  views?: number | null;
};

export type SocialAnalyticsBestPostingHoursItem = {
  hour: number;
  avgEngagement: number;
};

export type SocialAnalyticsFreshness = typeof SocialAnalyticsFreshness[keyof typeof SocialAnalyticsFreshness];


export const SocialAnalyticsFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
  reconciling: 'reconciling',
} as const;

export interface SocialAnalytics {
  windowDays: number;
  perPlatform: SocialAnalyticsPerPlatformItem[];
  dailySeries: SocialAnalyticsSeriesPoint[];
  /** 0–23 UTC hours ranked by average engagement, top first. */
  bestPostingHours: SocialAnalyticsBestPostingHoursItem[];
  freshness?: SocialAnalyticsFreshness;
  generatedAt?: string | null;
  sourceWatermark?: string | null;
  unsupportedMetrics?: string[];
}

export interface SocialAnalyticsSnapshotRow {
  platform: SocialPlatform;
  snapshotAt: string;
  totalPosts: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
}

export interface SocialMetricAvailability {
  value: number | null;
  available: boolean;
  reason: string | null;
}

export type SocialAnalyticsWorkspacePeriod = typeof SocialAnalyticsWorkspacePeriod[keyof typeof SocialAnalyticsWorkspacePeriod];


export const SocialAnalyticsWorkspacePeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
  '365d': '365d',
} as const;

export type SocialAnalyticsWorkspaceWindowDays = typeof SocialAnalyticsWorkspaceWindowDays[keyof typeof SocialAnalyticsWorkspaceWindowDays];


export const SocialAnalyticsWorkspaceWindowDays = {
  NUMBER_7: 7,
  NUMBER_30: 30,
  NUMBER_90: 90,
  NUMBER_365: 365,
} as const;

export type SocialAnalyticsWorkspaceRange = {
  days: number;
  timezone: string;
};

export type SocialAnalyticsWorkspaceFreshness = typeof SocialAnalyticsWorkspaceFreshness[keyof typeof SocialAnalyticsWorkspaceFreshness];


export const SocialAnalyticsWorkspaceFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
  reconciling: 'reconciling',
} as const;

export type SocialAnalyticsWorkspaceMetrics = {[key: string]: SocialMetricAvailability};

export type SocialAnalyticsWorkspaceSummary = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceComparison = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceByPlatformItem = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceChannelsItem = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceSeriesItem = {
  date: string | null;
  posts?: number | null;
  likes?: number | null;
  comments?: number | null;
  shares?: number | null;
  views?: number | null;
};

export type SocialAnalyticsWorkspaceHeatmapItem = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceTopContentItem = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceTrafficItem = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceCampaignsItemAttribution = { [key: string]: unknown };

export type SocialAnalyticsWorkspaceCampaignsItem = {
  id: string;
  title: string;
  attributionQualified: true;
  attribution: SocialAnalyticsWorkspaceCampaignsItemAttribution;
};

export interface SocialAnalyticsWorkspace {
  period: SocialAnalyticsWorkspacePeriod;
  windowDays?: SocialAnalyticsWorkspaceWindowDays;
  platform: string;
  metric: string;
  requestedMetrics?: string[];
  timezone?: string;
  range: SocialAnalyticsWorkspaceRange;
  freshness: SocialAnalyticsWorkspaceFreshness;
  generatedAt?: string | null;
  sourceWatermark?: string | null;
  metrics: SocialAnalyticsWorkspaceMetrics;
  summary?: SocialAnalyticsWorkspaceSummary;
  comparison?: SocialAnalyticsWorkspaceComparison;
  byPlatform: SocialAnalyticsWorkspaceByPlatformItem[];
  channels?: SocialAnalyticsWorkspaceChannelsItem[];
  series: SocialAnalyticsWorkspaceSeriesItem[];
  unsupportedMetrics: string[];
  heatmap?: SocialAnalyticsWorkspaceHeatmapItem[];
  topContent?: SocialAnalyticsWorkspaceTopContentItem[];
  traffic?: SocialAnalyticsWorkspaceTrafficItem[];
  campaigns?: SocialAnalyticsWorkspaceCampaignsItem[];
}

export type SocialBestTimeResponsePeriod = typeof SocialBestTimeResponsePeriod[keyof typeof SocialBestTimeResponsePeriod];


export const SocialBestTimeResponsePeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type SocialBestTimeResponseBucketsItem = {
  dayOfWeek?: number | null;
  hour?: number | null;
  avgEngagement?: number | null;
  postCount?: number | null;
};

export interface SocialBestTimeResponse {
  period: SocialBestTimeResponsePeriod;
  platform: string;
  timezone: string;
  sourceTimezone?: string | null;
  available: boolean;
  reason: string | null;
  freshness: string;
  generatedAt?: string | null;
  buckets: SocialBestTimeResponseBucketsItem[];
}

export type SocialTrafficResponsePeriod = typeof SocialTrafficResponsePeriod[keyof typeof SocialTrafficResponsePeriod];


export const SocialTrafficResponsePeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type SocialTrafficResponseMetrics = {[key: string]: SocialMetricAvailability};

export type SocialTrafficResponseSeriesItem = { [key: string]: unknown };

export interface SocialTrafficResponse {
  period: SocialTrafficResponsePeriod;
  available: boolean;
  source: string | null;
  metrics: SocialTrafficResponseMetrics;
  series: SocialTrafficResponseSeriesItem[];
}

export type SocialAttributionResponsePeriod = typeof SocialAttributionResponsePeriod[keyof typeof SocialAttributionResponsePeriod];


export const SocialAttributionResponsePeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type SocialAttributionResponseCampaignsItemAttribution = { [key: string]: unknown };

export type SocialAttributionResponseCampaignsItem = {
  id: string;
  title: string;
  attributionQualified: true;
  attribution: SocialAttributionResponseCampaignsItemAttribution;
};

export type SocialAttributionResponseTotals = {[key: string]: SocialMetricAvailability};

export interface SocialAttributionResponse {
  period: SocialAttributionResponsePeriod;
  available: boolean;
  attributionQualified: boolean;
  qualification: string;
  campaigns: SocialAttributionResponseCampaignsItem[];
  totals: SocialAttributionResponseTotals;
}

export type SocialLiveCapabilityLiveMonitoring = typeof SocialLiveCapabilityLiveMonitoring[keyof typeof SocialLiveCapabilityLiveMonitoring];


export const SocialLiveCapabilityLiveMonitoring = {
  supported: 'supported',
  unsupported: 'unsupported',
  not_connected: 'not_connected',
  degraded: 'degraded',
} as const;

export type SocialLiveCapabilityModeration = typeof SocialLiveCapabilityModeration[keyof typeof SocialLiveCapabilityModeration];


export const SocialLiveCapabilityModeration = {
  supported: 'supported',
  unsupported: 'unsupported',
  not_connected: 'not_connected',
  degraded: 'degraded',
} as const;

export type SocialLiveCapabilityProducts = typeof SocialLiveCapabilityProducts[keyof typeof SocialLiveCapabilityProducts];


export const SocialLiveCapabilityProducts = {
  supported: 'supported',
  unsupported: 'unsupported',
  not_connected: 'not_connected',
  degraded: 'degraded',
} as const;

export type SocialLiveCapabilityOffers = typeof SocialLiveCapabilityOffers[keyof typeof SocialLiveCapabilityOffers];


export const SocialLiveCapabilityOffers = {
  supported: 'supported',
  unsupported: 'unsupported',
  not_connected: 'not_connected',
  degraded: 'degraded',
} as const;

export interface SocialLiveCapability {
  platform: string;
  liveMonitoring: SocialLiveCapabilityLiveMonitoring;
  moderation: SocialLiveCapabilityModeration;
  products: SocialLiveCapabilityProducts;
  offers: SocialLiveCapabilityOffers;
  reason?: string | null;
}

export type SocialLiveLinkType = typeof SocialLiveLinkType[keyof typeof SocialLiveLinkType];


export const SocialLiveLinkType = {
  obs: 'obs',
  overlay: 'overlay',
} as const;

export interface SocialLiveLink {
  type: SocialLiveLinkType;
  /**
     * HTTPS URL or a single-slash internal application path.
     * @pattern ^(https://|/[^/])
     */
  url: string;
}

export type SocialLiveWorkspaceMetrics = { [key: string]: unknown };

export type SocialLiveWorkspaceAlertsItem = { [key: string]: unknown };

export type SocialLiveWorkspaceModeration = { [key: string]: unknown };

export type SocialLiveWorkspaceProducts = { [key: string]: unknown };

export type SocialLiveWorkspaceOffers = { [key: string]: unknown };

export type SocialLiveWorkspaceChannelsItem = { [key: string]: unknown };

export type SocialLiveEventPlatform = typeof SocialLiveEventPlatform[keyof typeof SocialLiveEventPlatform];


export const SocialLiveEventPlatform = {
  whatnot: 'whatnot',
  ebay_live: 'ebay_live',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  other: 'other',
} as const;

export type SocialLiveEventStatus = typeof SocialLiveEventStatus[keyof typeof SocialLiveEventStatus];


export const SocialLiveEventStatus = {
  scheduled: 'scheduled',
  live: 'live',
  ended: 'ended',
  cancelled: 'cancelled',
} as const;

export interface SocialLiveEvent {
  id: string;
  platform: SocialLiveEventPlatform;
  title: string;
  scheduledFor: string;
  url?: string | null;
  notes?: string | null;
  status: SocialLiveEventStatus;
  createdById?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SocialLiveWorkspace {
  events: SocialLiveEvent[];
  bounded: boolean;
  maxEvents: number;
  capabilities: SocialLiveCapability[];
  metrics: SocialLiveWorkspaceMetrics;
  alerts: SocialLiveWorkspaceAlertsItem[];
  moderation: SocialLiveWorkspaceModeration;
  products: SocialLiveWorkspaceProducts;
  offers: SocialLiveWorkspaceOffers;
  links: SocialLiveLink[];
  channels: SocialLiveWorkspaceChannelsItem[];
  freshness: string;
  generatedAt?: string | null;
  sourceWatermark?: string | null;
}

export type SocialCustomerContextCustomer = {
  id?: string;
  displayName?: string;
  customerType?: string | null;
  source?: string | null;
  createdAt?: string;
} | null;

export interface SocialCustomerContext {
  safe: boolean;
  customer: SocialCustomerContextCustomer;
  redactedFields?: string[];
}

export interface SocialDraftAiSuggestion {
  suggestion: string;
  draftOnly: true;
  persisted: false;
  requiresOperatorApproval: true;
}

export type SocialLiveEventCreatePlatform = typeof SocialLiveEventCreatePlatform[keyof typeof SocialLiveEventCreatePlatform];


export const SocialLiveEventCreatePlatform = {
  whatnot: 'whatnot',
  ebay_live: 'ebay_live',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  other: 'other',
} as const;

export type SocialLiveEventCreateStatus = typeof SocialLiveEventCreateStatus[keyof typeof SocialLiveEventCreateStatus];


export const SocialLiveEventCreateStatus = {
  scheduled: 'scheduled',
  live: 'live',
  ended: 'ended',
  cancelled: 'cancelled',
} as const;

export interface SocialLiveEventCreate {
  platform: SocialLiveEventCreatePlatform;
  /** @maxLength 200 */
  title: string;
  scheduledFor: string;
  url?: string | null;
  notes?: string | null;
  status?: SocialLiveEventCreateStatus;
}

export type SocialLiveEventUpdatePlatform = typeof SocialLiveEventUpdatePlatform[keyof typeof SocialLiveEventUpdatePlatform];


export const SocialLiveEventUpdatePlatform = {
  whatnot: 'whatnot',
  ebay_live: 'ebay_live',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  other: 'other',
} as const;

export type SocialLiveEventUpdateStatus = typeof SocialLiveEventUpdateStatus[keyof typeof SocialLiveEventUpdateStatus];


export const SocialLiveEventUpdateStatus = {
  scheduled: 'scheduled',
  live: 'live',
  ended: 'ended',
  cancelled: 'cancelled',
} as const;

export interface SocialLiveEventUpdate {
  platform?: SocialLiveEventUpdatePlatform;
  title?: string;
  scheduledFor?: string;
  url?: string | null;
  notes?: string | null;
  status?: SocialLiveEventUpdateStatus;
}

export type SocialCalendarEventSource = typeof SocialCalendarEventSource[keyof typeof SocialCalendarEventSource];


export const SocialCalendarEventSource = {
  planning: 'planning',
} as const;

export type SocialCalendarEventCategory = typeof SocialCalendarEventCategory[keyof typeof SocialCalendarEventCategory];


export const SocialCalendarEventCategory = {
  launch: 'launch',
  filming: 'filming',
  live_sale: 'live_sale',
  campaign: 'campaign',
  deadline: 'deadline',
  other: 'other',
} as const;

export interface SocialCalendarEvent {
  id: string;
  source: SocialCalendarEventSource;
  title: string;
  startAt: string;
  endAt: string | null;
  allDay: boolean;
  category: SocialCalendarEventCategory;
  notes?: string | null;
  campaignId?: string | null;
  platform?: SocialPlatform | null;
  timezone: string;
  createdById?: string | null;
  createdAt: string;
  updatedAt: string;
  editable: boolean;
}

export type SocialCalendarEventCreateCategory = typeof SocialCalendarEventCreateCategory[keyof typeof SocialCalendarEventCreateCategory];


export const SocialCalendarEventCreateCategory = {
  launch: 'launch',
  filming: 'filming',
  live_sale: 'live_sale',
  campaign: 'campaign',
  deadline: 'deadline',
  other: 'other',
} as const;

export interface SocialCalendarEventCreate {
  /**
     * @minLength 1
     * @maxLength 200
     */
  title: string;
  startAt: string;
  endAt?: string | null;
  allDay?: boolean;
  category?: SocialCalendarEventCreateCategory;
  /** @maxLength 4000 */
  notes?: string | null;
  campaignId?: string | null;
  platform?: SocialPlatform | null;
  /** IANA timezone used for entry and display */
  timezone?: string;
}

export type SocialCalendarEventUpdateCategory = typeof SocialCalendarEventUpdateCategory[keyof typeof SocialCalendarEventUpdateCategory];


export const SocialCalendarEventUpdateCategory = {
  launch: 'launch',
  filming: 'filming',
  live_sale: 'live_sale',
  campaign: 'campaign',
  deadline: 'deadline',
  other: 'other',
} as const;

export interface SocialCalendarEventUpdate {
  /**
     * @minLength 1
     * @maxLength 200
     */
  title?: string;
  startAt?: string;
  endAt?: string | null;
  allDay?: boolean;
  category?: SocialCalendarEventUpdateCategory;
  /** @maxLength 4000 */
  notes?: string | null;
  campaignId?: string | null;
  platform?: SocialPlatform | null;
  timezone?: string;
}

export interface SocialCalendarPost {
  id: string;
  content: string;
  platforms: SocialPlatform[];
  accountIds: string[];
  campaignId: string | null;
  mediaUrl: string | null;
  mediaOrder: string[];
  scheduledAt: string | null;
  status: string;
  approvalStatus: string;
  createdById?: string | null;
  createdAt: string;
}

export type SocialCalendarLiveEventSource = typeof SocialCalendarLiveEventSource[keyof typeof SocialCalendarLiveEventSource];


export const SocialCalendarLiveEventSource = {
  live: 'live',
} as const;

export type SocialCalendarLiveEventStatus = typeof SocialCalendarLiveEventStatus[keyof typeof SocialCalendarLiveEventStatus];


export const SocialCalendarLiveEventStatus = {
  scheduled: 'scheduled',
  live: 'live',
  ended: 'ended',
  cancelled: 'cancelled',
} as const;

export type SocialCalendarLiveEvent = SocialCalendarEvent & ({
  source?: SocialCalendarLiveEventSource;
  status?: SocialCalendarLiveEventStatus;
  url?: string | null;
});

export interface SocialCalendarResponse {
  timezone: string;
  posts: SocialCalendarPost[];
  events: (SocialCalendarEvent | SocialCalendarLiveEvent)[];
}

export type SocialAiSuggestRequestMode = typeof SocialAiSuggestRequestMode[keyof typeof SocialAiSuggestRequestMode];


export const SocialAiSuggestRequestMode = {
  title: 'title',
  caption: 'caption',
  description: 'description',
  hashtags: 'hashtags',
  posting_time: 'posting_time',
  analysis: 'analysis',
  rewrite: 'rewrite',
  rewrite_description: 'rewrite_description',
  add_emojis: 'add_emojis',
  fix_typos: 'fix_typos',
  score: 'score',
  best_practices: 'best_practices',
} as const;

export interface SocialAiSuggestRequest {
  mode: SocialAiSuggestRequestMode;
  platform?: SocialPlatform;
  /** @maxLength 2000 */
  prompt?: string;
  /** @maxLength 5000 */
  existingContent?: string;
}

export interface SocialAiSuggestResponse {
  text: string;
  hashtags?: string[];
  recommendedTimes?: string[];
  /**
     * Quality score 0-10 returned when mode=score
     * @minimum 0
     * @maximum 10
     */
  score?: number;
  /** Short bullet points explaining the score */
  scoreBreakdown?: string[];
}

export type SocialAiCheckRequestField = typeof SocialAiCheckRequestField[keyof typeof SocialAiCheckRequestField];


export const SocialAiCheckRequestField = {
  title: 'title',
  description: 'description',
} as const;

export interface SocialAiCheckRequest {
  field: SocialAiCheckRequestField;
  /** @maxLength 5000 */
  content: string;
  platform?: SocialPlatform;
}

export type SocialAiSuggestionType = typeof SocialAiSuggestionType[keyof typeof SocialAiSuggestionType];


export const SocialAiSuggestionType = {
  typo: 'typo',
  keyword: 'keyword',
  best_practice: 'best_practice',
  seo: 'seo',
} as const;

export interface SocialAiSuggestion {
  id: string;
  type: SocialAiSuggestionType;
  original: string;
  replacement: string;
  reason: string;
}

export interface SocialAiCheckResponse {
  suggestions: SocialAiSuggestion[];
}

export interface SocialBestTimesHeatmapCell {
  /**
     * ISO day of week: 1=Mon…7=Sun
     * @minimum 1
     * @maximum 7
     */
  dayOfWeek: number;
  /**
     * Hour 0–23 in Europe/London
     * @minimum 0
     * @maximum 23
     */
  hour: number;
  avgEngagement: number;
  postCount: number;
}

export interface SocialBestTimesRecommendedSlot {
  /**
     * @minimum 1
     * @maximum 7
     */
  dayOfWeek: number;
  /**
     * @minimum 0
     * @maximum 23
     */
  hour: number;
  dayLabel?: string;
  timeLabel?: string;
  reason: string;
}

export interface SocialBestTimesResponse {
  heatmapData: SocialBestTimesHeatmapCell[];
  recommendedSlots: SocialBestTimesRecommendedSlot[];
  hasHistoricalData: boolean;
  summary?: string;
}

export interface SocialSuggestTasksRequest {
  /** @maxLength 5000 */
  postContent: string;
  /** @maxLength 500 */
  productTitle?: string;
  platform?: SocialPlatform;
  /** @maxLength 500 */
  campaignGoal?: string;
}

export type SocialTaskSuggestionPriority = typeof SocialTaskSuggestionPriority[keyof typeof SocialTaskSuggestionPriority];


export const SocialTaskSuggestionPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
} as const;

export interface SocialTaskSuggestion {
  title: string;
  description: string;
  /** @minimum 0 */
  dueDaysFromNow: number;
  priority: SocialTaskSuggestionPriority;
}

export interface SocialSuggestTasksResponse {
  tasks: SocialTaskSuggestion[];
}

export interface SocialAiEnhanceImageRequest {
  /** @maxLength 500 */
  prompt: string;
  /** Optional base64-encoded source image (JPEG/PNG/WebP, max 10 MB). When provided the AI uses it as a reference. */
  sourceImageBase64?: string;
}

export interface SocialAiEnhanceImageVariant {
  index: number;
  /** Base64-encoded PNG of the generated variant. Display with data:image/png;base64,{b64Data}. */
  b64Data: string;
}

export interface SocialAiEnhanceImageResponse {
  variants: SocialAiEnhanceImageVariant[];
}

export interface SocialAiSaveEnhancedImageRequest {
  /** Base64-encoded PNG from a previous /ai-enhance-image call. */
  b64Data: string;
  /**
     * The prompt used to generate the variant (stored as alt text).
     * @maxLength 500
     */
  prompt: string;
}

export interface SocialAiSaveEnhancedImageResponse {
  assetId: string;
  publicUrl: string;
}

/**
 * Item fields used to ground the AI suggestion. All optional; empty fields are ignored (the model is told not to invent missing specs).
 */
export interface InventoryAiItemContext {
  /** @maxLength 300 */
  productTitle?: string;
  /** @maxLength 200 */
  brand?: string;
  /** @maxLength 100 */
  metal?: string;
  /** @maxLength 200 */
  productType?: string;
  /** @maxLength 20 */
  year?: string;
  /** @maxLength 100 */
  purity?: string;
  /** @maxLength 60 */
  weight?: string;
  /** @maxLength 20 */
  weightUnit?: string;
  /** @maxLength 60 */
  mintage?: string;
  /** @maxLength 100 */
  condition?: string;
  /** @maxLength 2000 */
  notes?: string;
}

export type InventoryAiAssistRequestMode = typeof InventoryAiAssistRequestMode[keyof typeof InventoryAiAssistRequestMode];


export const InventoryAiAssistRequestMode = {
  suggest: 'suggest',
  fix_typos: 'fix_typos',
  seo_check: 'seo_check',
} as const;

export interface InventoryAiAssistRequest {
  mode: InventoryAiAssistRequestMode;
  item?: InventoryAiItemContext;
  /** @maxLength 500 */
  currentTitle?: string;
  /** @maxLength 8000 */
  currentDescription?: string;
}

export interface InventoryAiAssistResponse {
  /** Suggested or corrected listing title (mode=suggest or fix_typos). */
  title?: string;
  /** Suggested or corrected listing description (mode=suggest or fix_typos). */
  description?: string;
  /** Notable corrections made (mode=fix_typos). */
  fixes?: string[];
  /**
     * SEO/discoverability score 0-100 (mode=seo_check).
     * @minimum 0
     * @maximum 100
     */
  seoScore?: number;
  /** Actionable SEO improvements (mode=seo_check). */
  seoSuggestions?: string[];
}

export interface InventoryProductImportAnalysisRequest {
  /** @maxLength 2048 */
  sourceUrl: string;
}

export type InventoryProductImportEvidenceFieldKey = typeof InventoryProductImportEvidenceFieldKey[keyof typeof InventoryProductImportEvidenceFieldKey];


export const InventoryProductImportEvidenceFieldKey = {
  productTitle: 'productTitle',
  description: 'description',
  brand: 'brand',
  metal: 'metal',
  productType: 'productType',
  year: 'year',
  weight: 'weight',
  purity: 'purity',
  finish: 'finish',
  denomination: 'denomination',
  mintage: 'mintage',
  condition: 'condition',
} as const;

export interface InventoryProductImportEvidenceField {
  key: InventoryProductImportEvidenceFieldKey;
  label: string;
  value: string;
  evidence: string;
}

export interface InventoryProductImportImage {
  url: string;
  /** @nullable */
  altText: string | null;
}

export interface InventoryProductImportAnalysisResponse {
  sourceUrl: string;
  supplierName: string;
  productTitle: string;
  description: string;
  fields: InventoryProductImportEvidenceField[];
  images: InventoryProductImportImage[];
  warnings: string[];
  missingFields: string[];
}

export type InventoryProductImporterCanvaFieldMappingSource = typeof InventoryProductImporterCanvaFieldMappingSource[keyof typeof InventoryProductImporterCanvaFieldMappingSource];


export const InventoryProductImporterCanvaFieldMappingSource = {
  title: 'title',
  description: 'description',
  brand: 'brand',
  metal: 'metal',
  year: 'year',
  weight: 'weight',
  purity: 'purity',
  photo: 'photo',
  skip: 'skip',
} as const;

export interface InventoryProductImporterCanvaFieldMapping {
  fieldKey: string;
  source: InventoryProductImporterCanvaFieldMappingSource;
}

export interface InventoryProductImporterCanvaTemplateSelection {
  templateId: string;
  mappings: InventoryProductImporterCanvaFieldMapping[];
}

export interface InventoryProductImporterCanvaTemplateConfig {
  fourByFive: InventoryProductImporterCanvaTemplateSelection;
  nineBySixteen: InventoryProductImporterCanvaTemplateSelection;
}

export interface InventoryProductImporterCanvaStatus {
  clientConfigured: boolean;
  connected: boolean;
  callbackUrl: string;
  scopes: string[];
  templateConfig: InventoryProductImporterCanvaTemplateConfig | null;
}

export interface InventoryProductImporterCanvaConnect {
  authorizationUrl: string;
  callbackUrl: string;
}

export interface InventoryProductImporterCanvaTemplate {
  id: string;
  title: string;
  /** @nullable */
  thumbnailUrl: string | null;
}

export interface InventoryProductImporterCanvaTemplateList {
  templates: InventoryProductImporterCanvaTemplate[];
  hasMore: boolean;
}

export type InventoryProductImporterCanvaTemplateFieldType = typeof InventoryProductImporterCanvaTemplateFieldType[keyof typeof InventoryProductImporterCanvaTemplateFieldType];


export const InventoryProductImporterCanvaTemplateFieldType = {
  text: 'text',
  image: 'image',
  video: 'video',
  chart: 'chart',
  sheet: 'sheet',
  unknown: 'unknown',
} as const;

export interface InventoryProductImporterCanvaTemplateField {
  key: string;
  label: string;
  type: InventoryProductImporterCanvaTemplateFieldType;
}

export interface InventoryProductImporterCanvaTemplateDataset {
  templateId: string;
  fields: InventoryProductImporterCanvaTemplateField[];
}

export interface InventoryProductImporterCanvaDesignRequest {
  /**
     * @minLength 1
     * @maxLength 300
     */
  productTitle: string;
  /** @maxLength 2000 */
  description: string;
  /** @maxLength 200 */
  brand?: string;
  /** @maxLength 100 */
  metal?: string;
  /** @maxLength 20 */
  year?: string;
  /** @maxLength 100 */
  weight?: string;
  /** @maxLength 100 */
  purity?: string;
  /** @maxLength 2048 */
  imageUrl: string;
}

export type InventoryProductImporterCanvaDesignResultAspectRatio = typeof InventoryProductImporterCanvaDesignResultAspectRatio[keyof typeof InventoryProductImporterCanvaDesignResultAspectRatio];


export const InventoryProductImporterCanvaDesignResultAspectRatio = {
  '4:5': '4:5',
  '9:16': '9:16',
} as const;

export type InventoryProductImporterCanvaDesignResultStatus = typeof InventoryProductImporterCanvaDesignResultStatus[keyof typeof InventoryProductImporterCanvaDesignResultStatus];


export const InventoryProductImporterCanvaDesignResultStatus = {
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

export interface InventoryProductImporterCanvaDesignResult {
  aspectRatio: InventoryProductImporterCanvaDesignResultAspectRatio;
  status: InventoryProductImporterCanvaDesignResultStatus;
  /** @nullable */
  designId: string | null;
  /** @nullable */
  editUrl: string | null;
  /** @nullable */
  error: string | null;
}

export interface InventoryProductImporterCanvaDesignResponse {
  results: InventoryProductImporterCanvaDesignResult[];
}

export interface SocialLinkCheckRequest {
  /** @maxLength 5000 */
  content: string;
}

export type SocialLinkCheckResultStatus = typeof SocialLinkCheckResultStatus[keyof typeof SocialLinkCheckResultStatus];


export const SocialLinkCheckResultStatus = {
  ok: 'ok',
  warning: 'warning',
  broken: 'broken',
} as const;

export interface SocialLinkCheckResult {
  url: string;
  status: SocialLinkCheckResultStatus;
  httpStatus?: number | null;
  finalUrl?: string | null;
  redirected: boolean;
  message: string;
}

export interface SocialLinkCheckResponse {
  results: SocialLinkCheckResult[];
  okCount: number;
  warningCount: number;
  brokenCount: number;
}

export type SocialAccountStatus = typeof SocialAccountStatus[keyof typeof SocialAccountStatus];


export const SocialAccountStatus = {
  active: 'active',
  expired: 'expired',
  disconnected: 'disconnected',
  error: 'error',
} as const;

export interface SocialAccount {
  id: string;
  platform: SocialPlatform;
  externalAccountId: string;
  displayName?: string | null;
  handle?: string | null;
  avatarUrl?: string | null;
  status: SocialAccountStatus;
  scopes: string[];
  tokenExpiresAt?: string | null;
  lastError?: string | null;
  /** Whether an inbound webhook subscription is currently active for this account. */
  webhookSubscribed: boolean;
  /** Last webhook-subscription error, if subscription failed. */
  webhookSubscriptionError?: string | null;
  /** Human-readable note about webhook subscription state (e.g. manual setup required). */
  webhookSubscriptionNote?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type SocialAccountConnectMetadata = { [key: string]: unknown };

export interface SocialAccountConnect {
  /** @maxLength 256 */
  externalAccountId: string;
  /** @maxLength 256 */
  displayName?: string;
  /** @maxLength 128 */
  handle?: string;
  avatarUrl?: string;
  scopes?: string[];
  accessToken: string;
  /** Optional OAuth refresh token. For X (Twitter), this field carries the OAuth 1.0a access token SECRET instead — it is stored as the account's refresh token and used (with accessToken) to sign the Account Activity webhook subscription, producing webhookSubscribed=true. */
  refreshToken?: string;
  /** ISO-8601 datetime */
  tokenExpiresAt?: string;
  metadata?: SocialAccountConnectMetadata;
}

export type SocialConnectionTestResultPlatform = typeof SocialConnectionTestResultPlatform[keyof typeof SocialConnectionTestResultPlatform];


export const SocialConnectionTestResultPlatform = {
  facebook: 'facebook',
  instagram: 'instagram',
  x: 'x',
  linkedin: 'linkedin',
} as const;

/**
 * Where the tested credentials came from.
 */
export type SocialConnectionTestResultSource = typeof SocialConnectionTestResultSource[keyof typeof SocialConnectionTestResultSource];


export const SocialConnectionTestResultSource = {
  db: 'db',
  env: 'env',
  missing: 'missing',
} as const;

export interface SocialConnectionTestResult {
  platform: SocialConnectionTestResultPlatform;
  ok: boolean;
  /** Friendly account/page name returned by the platform on success. */
  displayName: string | null;
  /** Human-readable success or error detail for inline display. */
  detail: string;
  /** Where the tested credentials came from. */
  source: SocialConnectionTestResultSource;
}

export type SocialMediaAssetAssetType = typeof SocialMediaAssetAssetType[keyof typeof SocialMediaAssetAssetType];


export const SocialMediaAssetAssetType = {
  image: 'image',
  video: 'video',
  gif: 'gif',
  document: 'document',
} as const;

export interface SocialMediaAsset {
  id: string;
  assetType: SocialMediaAssetAssetType;
  filename: string;
  storagePath: string;
  mimeType?: string | null;
  fileSizeBytes?: number | null;
  widthPx?: number | null;
  heightPx?: number | null;
  durationSeconds?: number | null;
  altText?: string | null;
  thumbnailUrl?: string | null;
  /** Stable public URL minted on demand. Once set it never changes. */
  publicUrl?: string | null;
  /** Optional tag indicating import origin, e.g. 'inventory'. */
  sourceTag?: string | null;
  tags: string[];
  isFavourite: boolean;
  uploadedById?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type SocialMediaAssetCreateAssetType = typeof SocialMediaAssetCreateAssetType[keyof typeof SocialMediaAssetCreateAssetType];


export const SocialMediaAssetCreateAssetType = {
  image: 'image',
  video: 'video',
  gif: 'gif',
  document: 'document',
} as const;

export interface SocialMediaAssetCreate {
  assetType: SocialMediaAssetCreateAssetType;
  /** @maxLength 500 */
  filename: string;
  /** @maxLength 2048 */
  storagePath: string;
  mimeType?: string;
  fileSizeBytes?: number;
  widthPx?: number;
  heightPx?: number;
  durationSeconds?: number;
  /** @maxLength 1000 */
  altText?: string;
  thumbnailUrl?: string;
  tags?: string[];
  isFavourite?: boolean;
}

export interface SocialMediaAssetUpdate {
  altText?: string | null;
  tags?: string[];
  isFavourite?: boolean;
  thumbnailUrl?: string | null;
}

export type SocialCampaignMetadata = { [key: string]: unknown };

export interface SocialCampaign {
  id: string;
  title: string;
  description?: string | null;
  startsAt?: string | null;
  endsAt?: string | null;
  status: string;
  targetPlatforms: SocialPlatform[];
  /** Campaign budget in GBP as a decimal string (e.g. '500.00'), null if no budget set */
  budgetGbp?: string | null;
  /** UUIDs of social_media_library assets attached to this campaign. */
  mediaAssetIds: string[];
  metadata?: SocialCampaignMetadata;
  createdById?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type SocialCampaignCreateMetadata = { [key: string]: unknown };

export interface SocialCampaignCreate {
  /** @maxLength 200 */
  title: string;
  /** @maxLength 2000 */
  description?: string;
  /** ISO-8601 datetime */
  startsAt?: string;
  /** ISO-8601 datetime */
  endsAt?: string;
  status?: string;
  targetPlatforms?: SocialPlatform[];
  /** Campaign budget in GBP as a decimal string (e.g. '500.00') */
  budgetGbp?: string;
  /** UUIDs of social_media_library assets to attach. */
  mediaAssetIds?: string[];
  metadata?: SocialCampaignCreateMetadata;
}

export type SocialCampaignUpdateMetadata = { [key: string]: unknown };

export interface SocialCampaignUpdate {
  /** @maxLength 200 */
  title?: string;
  description?: string | null;
  startsAt?: string | null;
  endsAt?: string | null;
  status?: string;
  targetPlatforms?: SocialPlatform[];
  /** Campaign budget in GBP as a decimal string, null to clear */
  budgetGbp?: string | null;
  /** Replace the campaign's attached asset UUIDs. */
  mediaAssetIds?: string[];
  metadata?: SocialCampaignUpdateMetadata;
}

export interface SocialHistoricSyncRequest {
  /** Platforms to sync. Defaults to all supported historic-sync platforms. */
  platformsToSync?: SocialPlatform[];
  /**
     * How many days of history to fetch (capped by each platform API).
     * @minimum 1
     * @maximum 90
     */
  windowDays?: number;
}

export type SocialHistoricSyncResultResultsItem = {
  platform: SocialPlatform;
  status: string;
  fetched: number;
  inserted: number;
  updated: number;
  error?: string | null;
  skippedReason?: string | null;
};

export interface SocialHistoricSyncResult {
  results: SocialHistoricSyncResultResultsItem[];
}

export type ImportRequestMode = typeof ImportRequestMode[keyof typeof ImportRequestMode];


export const ImportRequestMode = {
  append: 'append',
  update: 'update',
} as const;

/**
 * Sales-import preset. "ebay", "shopify" and "tiktok" are dedicated tab
 * presets that map a marketplace order key (Sales record number / Order
 * Name / Order ID) to the internal orderNumber and set the sale channel.
 * "ebay" and "tiktok" also parse the `SKU || qty || title` listing-title
 * format to resolve the SKU and per-unit price. "generic" lets the user
 * choose any column as the primary key. Defaults to "generic". Ignored
 * for inventory imports.
 */
export type ImportRequestImportType = typeof ImportRequestImportType[keyof typeof ImportRequestImportType];


export const ImportRequestImportType = {
  ebay: 'ebay',
  shopify: 'shopify',
  generic: 'generic',
  tiktok: 'tiktok',
} as const;

/**
 * How the import treats orders that ALREADY exist in the system
 * (matched by orderNumber or long-form marketplace order ID).
 * "update" (default) keeps current behaviour — matching orders are
 * refreshed from the file (this is what the TikTok always-upsert
 * carve-out does). "ignore" leaves every matching order completely
 * untouched — no line rewrite, no stock restore/consume, no
 * customer/address refresh — and only brand-new orders are created.
 * Ignored orders are counted in skippedRows / skippedKeys.
 */
export type ImportRequestExistingOrdersMode = typeof ImportRequestExistingOrdersMode[keyof typeof ImportRequestExistingOrdersMode];


export const ImportRequestExistingOrdersMode = {
  update: 'update',
  ignore: 'ignore',
} as const;

export type ImportRequestRowsItem = { [key: string]: unknown };

export interface ImportRequest {
  filename: string;
  mode: ImportRequestMode;
  /**
     * Sales-import preset. "ebay", "shopify" and "tiktok" are dedicated tab
     * presets that map a marketplace order key (Sales record number / Order
     * Name / Order ID) to the internal orderNumber and set the sale channel.
     * "ebay" and "tiktok" also parse the `SKU || qty || title` listing-title
     * format to resolve the SKU and per-unit price. "generic" lets the user
     * choose any column as the primary key. Defaults to "generic". Ignored
     * for inventory imports.
     */
  importType?: ImportRequestImportType;
  /**
     * When true (and mode == "append"), rows whose orderNumber already exists
     * in the database are SKIPPED (counted in skippedRows / skippedKeys) rather
     * than failing the import. When false, duplicates fail as before.
     */
  skipDuplicates?: boolean;
  /**
     * How the import treats orders that ALREADY exist in the system
     * (matched by orderNumber or long-form marketplace order ID).
     * "update" (default) keeps current behaviour — matching orders are
     * refreshed from the file (this is what the TikTok always-upsert
     * carve-out does). "ignore" leaves every matching order completely
     * untouched — no line rewrite, no stock restore/consume, no
     * customer/address refresh — and only brand-new orders are created.
     * Ignored orders are counted in skippedRows / skippedKeys.
     */
  existingOrdersMode?: ImportRequestExistingOrdersMode;
  /** Parsed spreadsheet rows. Keys must already match server field names (mapped client-side before submit). */
  rows: ImportRequestRowsItem[];
}

export interface ImportRowError {
  rowIndex: number;
  field?: string | null;
  message: string;
  sku?: string | null;
  code?: string | null;
}

export interface BackgroundJobAccepted {
  jobId: string | null;
  status: string;
  alreadyQueued?: boolean;
}

export type ImportSummaryStatus = typeof ImportSummaryStatus[keyof typeof ImportSummaryStatus];


export const ImportSummaryStatus = {
  success: 'success',
  partial: 'partial',
  failed: 'failed',
  in_progress: 'in_progress',
} as const;

export interface ImportSummary {
  logId: string;
  status: ImportSummaryStatus;
  totalRows: number;
  successRows: number;
  failedRows: number;
  /** Rows that imported successfully but had recoverable issues (missing SKU auto-created, missing customer, missing address, missing/invalid price, etc.) flagged into import_issues_log for later review. */
  withIssuesRows: number;
  /** Rows skipped because their primary key (orderNumber) already existed in the DB. Always 0 unless skipDuplicates was set. */
  skippedRows: number;
  /** Primary-key values (orderNumber) of the rows that were skipped as duplicates. */
  skippedKeys: string[];
  createdIds: string[];
  updatedIds: string[];
  /** SKUs of inventory items that were auto-created by handleMissingSKU during this import (placeholder products awaiting admin review). */
  autoCreatedSkus: string[];
  errors: ImportRowError[];
}

export type ImportProgressStage = typeof ImportProgressStage[keyof typeof ImportProgressStage];


export const ImportProgressStage = {
  starting: 'starting',
  fetching: 'fetching',
  processing: 'processing',
  publishing: 'publishing',
  complete: 'complete',
  complete_with_failures: 'complete_with_failures',
  failed: 'failed',
} as const;

/**
 * Live progress payload written by long-running imports (Shopify pull, etc.). Polled by the UI.
 */
export interface ImportProgress {
  stage: ImportProgressStage;
  page?: number;
  processed?: number;
  total?: number;
  skippedRows?: number;
  message?: string;
  startedAt?: string;
  finishedAt?: string;
}

export type ImportLogKind = typeof ImportLogKind[keyof typeof ImportLogKind];


export const ImportLogKind = {
  inventory: 'inventory',
  sales: 'sales',
  shopify_inventory: 'shopify_inventory',
} as const;

export type ImportLogMode = typeof ImportLogMode[keyof typeof ImportLogMode];


export const ImportLogMode = {
  append: 'append',
  update: 'update',
} as const;

export type ImportLogStatus = typeof ImportLogStatus[keyof typeof ImportLogStatus];


export const ImportLogStatus = {
  success: 'success',
  partial: 'partial',
  failed: 'failed',
  rolled_back: 'rolled_back',
  in_progress: 'in_progress',
} as const;

export interface ImportLog {
  id: string;
  kind: ImportLogKind;
  filename: string;
  mode: ImportLogMode;
  status: ImportLogStatus;
  totalRows: number;
  successRows: number;
  failedRows: number;
  withIssuesRows: number;
  progress?: ImportProgress | null;
  createdIds: string[];
  updatedIds: string[];
  errors: ImportRowError[];
  createdAt: string;
  createdBy?: string | null;
}

export type ImportIssueIssueType = typeof ImportIssueIssueType[keyof typeof ImportIssueIssueType];


export const ImportIssueIssueType = {
  missing_sku: 'missing_sku',
  unknown_sku: 'unknown_sku',
  missing_customer: 'missing_customer',
  missing_address: 'missing_address',
  missing_price: 'missing_price',
  invalid_quantity: 'invalid_quantity',
  invalid_date: 'invalid_date',
  missing_legal_timestamp: 'missing_legal_timestamp',
  missing_product_mapping: 'missing_product_mapping',
  auto_created_product: 'auto_created_product',
} as const;

export type ImportIssueOriginalRow = { [key: string]: unknown };

export interface ImportIssue {
  id: string;
  importLogId: string;
  rowIndex: number;
  orderNumber?: string | null;
  productName?: string | null;
  sku?: string | null;
  issueType: ImportIssueIssueType;
  fieldAffected?: string | null;
  suggestedFix?: string | null;
  originalRow: ImportIssueOriginalRow;
  saleOrderId?: string | null;
  saleOrderItemId?: string | null;
  customerId?: string | null;
  inventoryItemId?: string | null;
  resolvedAt?: string | null;
  resolvedBy?: string | null;
  resolutionNotes?: string | null;
  createdAt: string;
}

export interface AutoCreatedProduct {
  id: string;
  importLogId: string;
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  sourceOrderNumber?: string | null;
  reason?: string | null;
  createdAt: string;
}

export type ResolveImportIssueRequestCustomer = {
  name?: string;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postcode?: string | null;
  country?: string | null;
  phone?: string | null;
  email?: string | null;
};

/**
 * Payload for PATCH /import-issues/{id}. All fields optional; only provided fields are applied. Pass `inventoryItemId` to attach the sale line to a real product, or any subset of customer fields to fill in missing customer/address details.
 */
export interface ResolveImportIssueRequest {
  inventoryItemId?: string;
  /** @minimum 1 */
  quantity?: number;
  salePrice?: number;
  productTitle?: string;
  customer?: ResolveImportIssueRequestCustomer;
  /** @maxLength 2000 */
  resolutionNotes?: string;
}

/**
 * Stationery item exposed to packing-only users (no purchase-order permissions required).
 */
export interface PackagingMaterialOption {
  id: string;
  name: string;
  sku?: string | null;
  unit: string;
  usageType?: string | null;
  packagingType?: string | null;
  internalLengthCm?: number | null;
  internalWidthCm?: number | null;
  internalHeightCm?: number | null;
  maxWeightGrams?: number | null;
  currentQuantity: number;
}

/**
 * Visual fit indicator for the recommendation engine:
 *   perfect = used volume between 50%–85% of box volume
 *   tight   = used volume ≥ 85% of box volume (still fits)
 *   loose   = used volume between 25%–50% (works but wasteful)
 *   oversized = used volume < 25% (significant wasted space)
 *   no_fit  = at least one dimension or the weight exceeds the box
 */
export type PackagingFitLabel = typeof PackagingFitLabel[keyof typeof PackagingFitLabel];


export const PackagingFitLabel = {
  perfect: 'perfect',
  tight: 'tight',
  loose: 'loose',
  oversized: 'oversized',
  no_fit: 'no_fit',
} as const;

export interface PackagingRecommendationOption {
  stationeryId: string;
  name: string;
  sku?: string | null;
  packagingType: string | null;
  internalLengthCm?: number | null;
  internalWidthCm?: number | null;
  internalHeightCm?: number | null;
  maxWeightGrams?: number | null;
  currentQuantity: number;
  fits: boolean;
  fitLabel: PackagingFitLabel;
  inStock: boolean;
  usedVolumeCm3: number;
  boxVolumeCm3: number;
  /** boxVolume − usedVolume; clamped at 0 for non-fitting boxes. */
  wastedVolumeCm3: number;
  /** orderWeight / maxWeightGrams × 100, when both sides are known. */
  weightUtilisationPct?: number | null;
}

export type PackagingRecommendationOrderItemsItem = {
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  quantity: number;
  lengthCm?: number | null;
  widthCm?: number | null;
  heightCm?: number | null;
  weightGrams?: number | null;
  hasDimensions: boolean;
};

export type PackagingRecommendationOrderTotals = {
  totalVolumeCm3: number;
  totalWeightGrams: number;
  /** Longest single-item dimension across the order. */
  longestSideCm: number;
  /** Second-longest single-item dimension across the order. */
  secondLongestSideCm?: number;
  /** Smallest required side across the order. */
  shortestSideCm?: number;
};

export interface PackagingRecommendation {
  orderItems: PackagingRecommendationOrderItemsItem[];
  orderTotals: PackagingRecommendationOrderTotals;
  /** Smallest in-stock packaging that fits all items. Null when nothing fits or no candidates have dimensions. */
  recommended?: PackagingRecommendationOption | null;
  /** Best fitting option that is currently out of stock — returned so the UI can show "next best" guidance. */
  nextBest?: PackagingRecommendationOption | null;
  options: PackagingRecommendationOption[];
  warnings: string[];
}

export type ConfirmPackagingRequestMaterialsItem = {
  stationeryId: string;
  /** @minimum 1 */
  quantity: number;
};

/**
 * Snapshot of the engine's top recommendation at confirmation time. Persisted alongside the usage rows.
 */
export type ConfirmPackagingRequestRecommendationSnapshot = {
  stationeryId?: string | null;
  name?: string | null;
  fitLabel?: string | null;
  wastedVolumeCm3?: number | null;
} | null;

export interface ConfirmPackagingRequest {
  materials: ConfirmPackagingRequestMaterialsItem[];
  /** True when the packer chose a different box than the engine recommended. Persisted on every packaging_usage row for downstream packaging-efficiency analysis. */
  wasOverridden?: boolean | null;
  /** Snapshot of the engine's top recommendation at confirmation time. Persisted alongside the usage rows. */
  recommendationSnapshot?: ConfirmPackagingRequestRecommendationSnapshot;
}

export interface PackagingUsageEntry {
  stationeryId: string;
  name: string;
  sku?: string | null;
  quantity: number;
  wasOverridden?: boolean | null;
  createdAt: string;
}

export interface ConfirmPackagingResult {
  packedAt: string;
  materials: PackagingUsageEntry[];
}

export interface PackagingForecastItem {
  stationeryId: string;
  name: string;
  sku?: string | null;
  usageType?: string | null;
  currentQuantity: number;
  minQuantity: number;
  targetQuantity: number;
  usedLast30: number;
  usageRatePerDay: number;
  daysRemaining?: number | null;
  suggestedReorderQuantity: number;
  lowStock: boolean;
}

export interface CustomerPreferenceRank {
  value: string;
  units: number;
  /**
     * @minimum 0
     * @maximum 1
     */
  share: number;
}

export type CustomerPurchasingInsightRowConfidence = typeof CustomerPurchasingInsightRowConfidence[keyof typeof CustomerPurchasingInsightRowConfidence];


export const CustomerPurchasingInsightRowConfidence = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;

export type CustomerPurchasingInsightRowFavouriteProductsItem = {
  inventoryItemId: string;
  title: string;
  sku?: string | null;
  units: number;
};

export type CustomerPurchasingInsightRowChannelMixItem = {
  channel: string;
  orderCount: number;
  share: number;
};

export interface CustomerPurchasingInsightRow {
  customerId: string;
  customerName: string;
  email?: string | null;
  orderCount: number;
  unitsPurchased: number;
  mostRecentPurchase: string;
  preferredMint?: CustomerPreferenceRank | null;
  preferredMetal?: CustomerPreferenceRank | null;
  preferredDay?: CustomerPreferenceRank | null;
  preferredWindow?: CustomerPreferenceRank | null;
  confidence: CustomerPurchasingInsightRowConfidence;
  preferenceSampleSize: number;
  inactive: boolean;
  favouriteProducts: CustomerPurchasingInsightRowFavouriteProductsItem[];
  channelMix: CustomerPurchasingInsightRowChannelMixItem[];
  mintRanking: CustomerPreferenceRank[];
  metalRanking: CustomerPreferenceRank[];
  dayRanking: CustomerPreferenceRank[];
  windowRanking: CustomerPreferenceRank[];
}

export type CustomerPurchasingInsightsResponseSummary = {
  topMint?: string | null;
  topMetal?: string | null;
  busiestWindow?: string | null;
  repeatCustomerShare: number;
  becomingInactive: number;
};

export type CustomerPurchasingInsightsResponseOptions = {
  mints: string[];
  metals: string[];
  channels: string[];
};

export type CustomerPurchasingInsightsResponseFilters = { [key: string]: unknown };

export interface CustomerPurchasingInsightsResponse {
  rows: CustomerPurchasingInsightRow[];
  total: number;
  page: number;
  pageSize: number;
  truncated: boolean;
  timezone: string;
  summary: CustomerPurchasingInsightsResponseSummary;
  options: CustomerPurchasingInsightsResponseOptions;
  filters: CustomerPurchasingInsightsResponseFilters;
}

export interface CustomerInsightRow {
  id: string;
  name: string;
  email?: string | null;
  source: string;
  orderCount: number;
  totalSpend: number;
  lastOrderDate?: string | null;
}

export interface CustomerSourceSummary {
  source: string;
  orderCount: number;
  revenue: number;
}

export interface CustomerInsights {
  topSpenders: CustomerInsightRow[];
  atRiskCustomers: CustomerInsightRow[];
  topSourcesThisMonth: CustomerSourceSummary[];
  sources: string[];
}

export interface PackagingSummary {
  lowStockCount: number;
  /** Number of items at zero stock (cannot pack). */
  criticalCount: number;
  /** Top forecast items needing attention (low stock or daysRemaining ≤ 14), sorted by urgency. */
  items: PackagingForecastItem[];
}

export interface ExpenseInput {
  date: string;
  category: string;
  supplierVendor?: string | null;
  amount: number;
  currency?: string | null;
  purchaseOrderId?: string | null;
  saleOrderId?: string | null;
  notes?: string | null;
}

export type Expense = ExpenseInput & {
  id: string;
  createdAt: string;
};

export interface ReportBucket {
  label: string;
  value: number;
  count: number;
}

export interface InventoryReport {
  totalAtCost: number;
  totalEstimatedResale: number;
  liveStockCount?: number;
  byCategory: ReportBucket[];
  bySupplier: ReportBucket[];
  byMetal: ReportBucket[];
  /** Live stock value broken down by OWNED vs CONSIGNMENT. */
  byStockType?: ReportBucket[];
}

export type SalesReportByDateItem = {
  date: string;
  revenue: number;
  profit: number;
};

export interface SalesReport {
  grossRevenue: number;
  grossProfit: number;
  margin: number;
  orderCount?: number;
  /** Sum of (revenue - landed cost) across OWNED line items only. */
  ownedProfit: number;
  /** Sum of (revenue - supplierPayoutPrice) across CONSIGNMENT line items only. */
  consignmentProfit: number;
  /** Total GBP owed to consignment suppliers across the period (sum of qty * supplierPayoutPrice). */
  totalOwedToSuppliers: number;
  /** Task #1057: total output VAT owed to HMRC across the period (margin scheme + standard-rated). Shown alongside, never replacing, the existing profit figures. */
  outputVat?: number;
  /** Task #1057: grossProfit minus outputVat. The profit retained after the VAT owed to HMRC on these sales. */
  vatAdjustedProfit?: number;
  /** Task #1057: vatAdjustedProfit as a percentage of grossRevenue. */
  vatAdjustedMargin?: number;
  /** Task #1057: true when one or more sale lines lacked a usable VAT treatment, so the VAT-adjusted figures are an under-estimate and need review. */
  vatTreatmentFlagged?: boolean;
  /** Total owed grouped by supplierName (consignment lines only). */
  bySupplierOwed: ReportBucket[];
  byChannel: ReportBucket[];
  byProduct: ReportBucket[];
  byDate: SalesReportByDateItem[];
}

export interface ProfitLossRow {
  /**
     * Day → "YYYY-MM-DD", Week → "YYYY-Www" (ISO week), Month → "YYYY-MM".
     * All buckets are computed in Europe/London local time.
     */
  period: string;
  /** Sum of (quantity * salePrice) over all matching lines. */
  revenue: number;
  /**
     * Sum of (quantity * COALESCE(consignment_supplier_payout_per_unit_gbp, unit_cost))
     * — i.e. landed cost for owned lines and supplier-owed for consignment.
     * Null when source costs are unresolved.
     */
  cost: number | null;
  /**
     * Sum of `additional_costs_gbp` (the manual operator deduction recorded on each
     * sale order) for orders contributing to this bucket. Deduped per order so the
     * line-join doesn't multi-count.
     */
  additionalCosts: number;
  /** Confirmed GBP Whatnot platform fees deducted in this period. */
  whatnotFees?: number;
  /** Distinct identified Whatnot orders without confirmed GBP fee evidence. */
  whatnotFeesNeeded?: number;
  /** Whatnot-linked orders with no stored fee-ledger evidence. */
  whatnotFeesMissing?: number;
  /** Whatnot-linked orders whose available fee evidence is unresolved or unsupported. */
  whatnotFeesUnresolved?: number;
  /** Whatnot-channel orders without a persisted order link or fee evidence. */
  whatnotFeesNotIdentifiable?: number;
  /** revenue - cost - additionalCosts - confirmed Whatnot fees */
  profit: number | null;
  /** (profit / revenue) * 100, one decimal. Null when costs are unresolved or revenue is zero. */
  margin: number | null;
  /** Output VAT (GBP) owed to HMRC on this bucket's sale lines (Task */
  outputVat?: number;
  /** profit minus outputVat. Parallel term — `profit` is unchanged. */
  vatAdjustedProfit?: number;
  /** (vatAdjustedProfit / revenue) * 100, one decimal. 0 when revenue is 0. */
  vatAdjustedMargin?: number;
  /** True when any non-empty line in this bucket lacked a usable VAT treatment, so outputVat under-estimates. */
  vatTreatmentFlagged?: boolean;
  /** Distinct sale orders that contributed to this bucket. */
  orderCount: number;
  /** Sum of line quantities in this bucket. */
  unitsSold: number;
  /**
     * Task #1289 — realised scrap refining revenue (GBP) folded into this
     * bucket. Only present when the scrap module is enabled AND the tenant's
     * combinePnlWithScrap setting is on; omitted entirely otherwise so the
     * response is byte-identical to the scrap-off case. `revenue` already
     * includes this amount.
     */
  scrapRevenue?: number;
  /**
     * Task #1289 — realised scrap cost (purchase cost + refining fees, GBP)
     * folded into this bucket. Present under the same conditions as
     * scrapRevenue. `cost` already includes this amount.
     */
  scrapCost?: number;
  /**
     * Task #1289 — scrapRevenue - scrapCost for this bucket. Present under
     * the same conditions as scrapRevenue. Already included in `profit`.
     */
  scrapProfit?: number;
}

export type ProfitLossSummaryBestDay = {
  period: string;
  profit: number;
} | null;

export type ProfitLossSummaryWorstDay = {
  period: string;
  profit: number;
} | null;

export interface ProfitLossSummary {
  /** Profit for today (Europe/London midnight to now). Always reflects current date, regardless of date filter. */
  todayProfit: number;
  /** Profit for the full day yesterday (Europe/London 00:00 to today's 00:00). */
  yesterdayProfit: number;
  /** Profit since the start of the current ISO week (Mon 00:00 Europe/London). */
  weekProfit: number;
  /** Profit since the start of the current calendar month (Europe/London). */
  monthProfit: number;
  /** todayProfit minus output VAT owed in the today window (Task */
  todayVatAdjustedProfit?: number;
  /** yesterdayProfit minus output VAT owed in the yesterday window. */
  yesterdayVatAdjustedProfit?: number;
  /** weekProfit minus output VAT owed in the week window. */
  weekVatAdjustedProfit?: number;
  /** monthProfit minus output VAT owed in the month window. */
  monthVatAdjustedProfit?: number;
  totalRevenue: number;
  totalCost: number | null;
  /** Sum of per-order `additional_costs_gbp` across the filter range. */
  totalAdditionalCosts: number;
  /** Confirmed GBP Whatnot platform fees deducted across the filter range. */
  totalWhatnotFees?: number;
  /** Distinct identified Whatnot orders in the range without confirmed GBP fee evidence. */
  totalWhatnotFeesNeeded?: number;
  /** Whatnot-linked orders with no stored fee-ledger evidence. */
  totalWhatnotFeesMissing?: number;
  /** Whatnot-linked orders whose available fee evidence is unresolved or unsupported. */
  totalWhatnotFeesUnresolved?: number;
  /** Whatnot-channel orders without a persisted order link or fee evidence. */
  totalWhatnotFeesNotIdentifiable?: number;
  /** totalRevenue - totalCost - totalAdditionalCosts - totalWhatnotFees. */
  totalProfit: number | null;
  /** Weighted margin after confirmed Whatnot fee deductions across the filter range. */
  averageMargin: number | null;
  /** Total output VAT (GBP) owed to HMRC across the filter range (Task */
  totalOutputVat?: number;
  /** totalProfit minus totalOutputVat. Parallel to totalProfit. */
  totalVatAdjustedProfit?: number;
  /** Weighted VAT-adjusted margin (totalVatAdjustedProfit / totalRevenue * 100). */
  averageVatAdjustedMargin?: number;
  /** True when any bucket in the range had a line lacking a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
  /** Mean daily profit over the most recent 7 calendar days inside the filter range. */
  rolling7DayAverage: number;
  todayWhatnotFeesNeeded?: number;
  yesterdayWhatnotFeesNeeded?: number;
  weekWhatnotFeesNeeded?: number;
  monthWhatnotFeesNeeded?: number;
  /**
     * Task #1289 — true when realised scrap P&L has been folded into this
     * report (scrap module enabled AND the tenant's combinePnlWithScrap
     * setting on). When false/omitted, the report contains no scrap and is
     * byte-identical to the pre-feature shape. The frontend keys all scrap
     * UI (cards incl-line, Scrap table column, breakdown note) off this.
     */
  scrapCombined?: boolean;
  /** Realised scrap profit in the today window. Present only when scrapCombined. */
  todayScrapProfit?: number;
  /** Realised scrap profit in the yesterday window. Present only when scrapCombined. */
  yesterdayScrapProfit?: number;
  /** Realised scrap profit in the current-week window. Present only when scrapCombined. */
  weekScrapProfit?: number;
  /** Realised scrap profit in the current-month window. Present only when scrapCombined. */
  monthScrapProfit?: number;
  /** Total realised scrap refining revenue across the filter range. Present only when scrapCombined. */
  totalScrapRevenue?: number;
  /** Total realised scrap cost (purchase + refining fees) across the filter range. Present only when scrapCombined. */
  totalScrapCost?: number;
  /** totalScrapRevenue - totalScrapCost across the filter range. Present only when scrapCombined. */
  totalScrapProfit?: number;
  bestDay?: ProfitLossSummaryBestDay;
  worstDay?: ProfitLossSummaryWorstDay;
}

export type ProfitLossReportGranularity = typeof ProfitLossReportGranularity[keyof typeof ProfitLossReportGranularity];


export const ProfitLossReportGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type ProfitLossReportStockType = typeof ProfitLossReportStockType[keyof typeof ProfitLossReportStockType];


export const ProfitLossReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export interface ProfitLossReport {
  granularity: ProfitLossReportGranularity;
  /** ISO datetime that was actually used (echoes the resolved default if the caller omitted it). */
  from: string;
  /** ISO datetime that was actually used. */
  to: string;
  stockType?: ProfitLossReportStockType;
  supplierId?: string | null;
  rows: ProfitLossRow[];
  summary: ProfitLossSummary;
}

export type MobileProfitLossFreshnessStatus = typeof MobileProfitLossFreshnessStatus[keyof typeof MobileProfitLossFreshnessStatus];


export const MobileProfitLossFreshnessStatus = {
  ready: 'ready',
  partial: 'partial',
  preparing: 'preparing',
  failed: 'failed',
  not_ready: 'not_ready',
} as const;

export type MobileProfitLossFreshnessDataQuality = typeof MobileProfitLossFreshnessDataQuality[keyof typeof MobileProfitLossFreshnessDataQuality];


export const MobileProfitLossFreshnessDataQuality = {
  complete: 'complete',
  partial: 'partial',
  stale: 'stale',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export interface MobileProfitLossFreshness {
  status: MobileProfitLossFreshnessStatus;
  dataQuality: MobileProfitLossFreshnessDataQuality;
  lastCompletedDate?: string | null;
  refreshedAt?: string | null;
  ageSeconds?: number | null;
  message?: string | null;
}

export type MobileProfitLossSummaryRange = {
  from: string;
  to: string;
  previousFrom: string;
  previousTo: string;
};

export type MobileProfitLossSummaryFiltersOwnership = typeof MobileProfitLossSummaryFiltersOwnership[keyof typeof MobileProfitLossSummaryFiltersOwnership];


export const MobileProfitLossSummaryFiltersOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type MobileProfitLossSummaryFilters = {
  ownership: MobileProfitLossSummaryFiltersOwnership;
  channel?: string | null;
};

export type MobileProfitLossSummaryComparisonMode = typeof MobileProfitLossSummaryComparisonMode[keyof typeof MobileProfitLossSummaryComparisonMode];


export const MobileProfitLossSummaryComparisonMode = {
  none: 'none',
  previous_period: 'previous_period',
  year_over_year: 'year_over_year',
} as const;

export type MobileProfitLossSummaryGranularity = typeof MobileProfitLossSummaryGranularity[keyof typeof MobileProfitLossSummaryGranularity];


export const MobileProfitLossSummaryGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type MobileProfitLossSummaryDataQualityStatus = typeof MobileProfitLossSummaryDataQualityStatus[keyof typeof MobileProfitLossSummaryDataQualityStatus];


export const MobileProfitLossSummaryDataQualityStatus = {
  complete: 'complete',
  partial: 'partial',
  stale: 'stale',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type MobileProfitLossSummaryDataQualityOrderMetrics = typeof MobileProfitLossSummaryDataQualityOrderMetrics[keyof typeof MobileProfitLossSummaryDataQualityOrderMetrics];


export const MobileProfitLossSummaryDataQualityOrderMetrics = {
  available: 'available',
  unavailable_prepared_grain: 'unavailable_prepared_grain',
} as const;

export type MobileProfitLossSummaryDataQuality = {
  status: MobileProfitLossSummaryDataQualityStatus;
  /** @minimum 0 */
  unresolvedCostRows: number;
  vatTreatmentFlagged?: boolean;
  orderMetrics?: MobileProfitLossSummaryDataQualityOrderMetrics;
  source: string;
};

export type MobileProfitLossSummarySummary = {
  revenue: number;
  grossProfit: number | null;
  trueProfit: number | null;
  trueMargin: number | null;
  refunds: number;
  units: number;
  allocatedCogs: number | null;
  allocatedFees: number | null;
  orders: number | null;
  averageOrderValue: number | null;
  outputVat: number | null;
  profitAfterVat: number | null;
};

export type MobileProfitLossSummaryCostBreakdown = {
  platformFees: number | null;
  shipping: number | null;
  postage: number | null;
  discounts: number | null;
  otherApprovedCosts: number | null;
  allocatedFees: number | null;
  availability: string;
  packaging: number | null;
  packagingAvailability: string;
};

export type MobileProfitLossSummaryWhatnotFeeCompleteness = {
  /** @minimum 0 */
  confirmedOrders: number;
  /** @minimum 0 */
  missingOrders: number;
  /** @minimum 0 */
  unresolvedOrders: number;
  /** @minimum 0 */
  notIdentifiableOrders: number;
  /** @minimum 0 */
  ordersNeedingFees: number;
};

export type MobileProfitLossSummaryComparison = { [key: string]: unknown } | null;

export type MobileProfitLossSummaryInsightsItem = { [key: string]: unknown };

export type MobileProfitLossSummarySections = {[key: string]: 'deferred' | 'ready' | 'failed'};

export type MobileProfitLossSummaryCapabilities = {[key: string]: boolean};

export interface MobileProfitLossSummary {
  version: number;
  range: MobileProfitLossSummaryRange;
  filters: MobileProfitLossSummaryFilters;
  comparisonMode: MobileProfitLossSummaryComparisonMode;
  granularity?: MobileProfitLossSummaryGranularity;
  timezone?: string;
  freshness: MobileProfitLossFreshness;
  dataQuality: MobileProfitLossSummaryDataQuality;
  summary: MobileProfitLossSummarySummary;
  costBreakdown: MobileProfitLossSummaryCostBreakdown;
  whatnotFeeCompleteness: MobileProfitLossSummaryWhatnotFeeCompleteness;
  comparison?: MobileProfitLossSummaryComparison;
  insights?: MobileProfitLossSummaryInsightsItem[];
  sections: MobileProfitLossSummarySections;
  capabilities: MobileProfitLossSummaryCapabilities;
}

export type MobileProfitLossTrendRange = {
  from: string;
  to: string;
};

export type MobileProfitLossTrendGranularity = typeof MobileProfitLossTrendGranularity[keyof typeof MobileProfitLossTrendGranularity];


export const MobileProfitLossTrendGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type MobileProfitLossTrendSeriesItemQuality = typeof MobileProfitLossTrendSeriesItemQuality[keyof typeof MobileProfitLossTrendSeriesItemQuality];


export const MobileProfitLossTrendSeriesItemQuality = {
  complete: 'complete',
  partial: 'partial',
} as const;

export type MobileProfitLossTrendSeriesItem = {
  date: string;
  revenue: number;
  grossProfit: number | null;
  trueProfit: number | null;
  refunds: number;
  quality: MobileProfitLossTrendSeriesItemQuality;
};

export interface MobileProfitLossTrend {
  range: MobileProfitLossTrendRange;
  granularity: MobileProfitLossTrendGranularity;
  /** @maxItems 366 */
  series: MobileProfitLossTrendSeriesItem[];
  freshness: MobileProfitLossFreshness;
}

export type MobileProfitLossChannelsChannelsItemQuality = typeof MobileProfitLossChannelsChannelsItemQuality[keyof typeof MobileProfitLossChannelsChannelsItemQuality];


export const MobileProfitLossChannelsChannelsItemQuality = {
  complete: 'complete',
  partial: 'partial',
} as const;

export type MobileProfitLossChannelsChannelsItem = {
  channel: string;
  channelKey: string;
  href: string | null;
  revenue: number;
  grossProfit: number | null;
  trueProfit: number | null;
  orders: number | null;
  platformFees?: number | null;
  shippingNet?: number | null;
  discounts?: number | null;
  additionalCosts?: number | null;
  packagingCosts?: number | null;
  quality: MobileProfitLossChannelsChannelsItemQuality;
};

export interface MobileProfitLossChannels {
  /** @maxItems 20 */
  channels: MobileProfitLossChannelsChannelsItem[];
  freshness: MobileProfitLossFreshness;
}

export type MobileProfitLossProductQuality = typeof MobileProfitLossProductQuality[keyof typeof MobileProfitLossProductQuality];


export const MobileProfitLossProductQuality = {
  complete: 'complete',
  partial: 'partial',
} as const;

export interface MobileProfitLossProduct {
  productId: string;
  name: string;
  sku?: string | null;
  units: number;
  revenue: number;
  trueProfit: number | null;
  margin: number | null;
  quality: MobileProfitLossProductQuality;
  topRank: number;
  lowMarginRank: number;
}

export interface MobileProfitLossProducts {
  /** @maxItems 50 */
  products: MobileProfitLossProduct[];
  /** @maxItems 50 */
  topProfitProducts: MobileProfitLossProduct[];
  /** @maxItems 50 */
  lowestMarginProducts: MobileProfitLossProduct[];
  freshness: MobileProfitLossFreshness;
}

export type MobileProfitLossExceptionsExceptionsItem = { [key: string]: unknown };

export interface MobileProfitLossExceptions {
  /** @maxItems 50 */
  exceptions: MobileProfitLossExceptionsExceptionsItem[];
  freshness: MobileProfitLossFreshness;
}

export type MobileProfitLossCashRange = {
  from: string;
  to: string;
};

export type MobileProfitLossCashMarketplacePayouts = {
  settled: number;
  refunds: number;
  reversed: number;
  pending: number;
  unavailable: boolean;
};

export type MobileProfitLossCashQualityStatus = typeof MobileProfitLossCashQualityStatus[keyof typeof MobileProfitLossCashQualityStatus];


export const MobileProfitLossCashQualityStatus = {
  complete: 'complete',
  unavailable: 'unavailable',
} as const;

export type MobileProfitLossCashQualitySource = typeof MobileProfitLossCashQualitySource[keyof typeof MobileProfitLossCashQualitySource];


export const MobileProfitLossCashQualitySource = {
  product_performance_daily_cash: 'product_performance_daily_cash',
} as const;

export type MobileProfitLossCashQuality = {
  status: MobileProfitLossCashQualityStatus;
  unavailable: string[];
  message?: string;
  reason: string | null;
  source: MobileProfitLossCashQualitySource;
  /** @minimum 0 */
  sourceEventCount: number;
  reconciled: boolean;
  refreshedAt: string | null;
};

export interface MobileProfitLossCash {
  range: MobileProfitLossCashRange;
  netCashCollected: number | null;
  marketplacePayouts: MobileProfitLossCashMarketplacePayouts;
  purchaseSpend: number | null;
  expenses: number | null;
  consignmentPayouts: number | null;
  netCashPosition: number | null;
  quality: MobileProfitLossCashQuality;
  freshness: MobileProfitLossFreshness;
}

export interface SpendVsProfitRow {
  /** Day → "YYYY-MM-DD", Week → "YYYY-Www" (ISO week), Month → "YYYY-MM" (Europe/London). */
  period: string;
  revenue: number;
  /** Sum of (quantity * (salePrice - effectiveUnitCost)) across matching lines. */
  grossProfit: number;
  /** Output VAT (GBP) owed to HMRC on this bucket's sale lines (Task */
  outputVat?: number;
  /** grossProfit minus outputVat. Parallel term — `grossProfit` is unchanged. */
  vatAdjustedGrossProfit?: number;
  /** Sum of paid PO totals (gbp_paid + landed costs) bucketed by paid_at; plus unpaid POs by purchase_date when liabilities are included. */
  purchaseSpend: number;
  /** Sum of confirmed payouts bucketed by paid_at; plus consignment owed lines by sale_date when liabilities are included. */
  consignmentPayouts: number;
  /** Sum of GBP expense amounts bucketed by date. Always 0 when filtering by supplier. */
  expenses: number;
  /** purchaseSpend + consignmentPayouts + expenses for this bucket. */
  totalSpend: number;
  /** grossProfit - totalSpend for this bucket. */
  netCashPosition: number;
  /** vatAdjustedGrossProfit - totalSpend for this bucket (Task */
  vatAdjustedNetCashPosition?: number;
  /** True when any non-empty line in this bucket lacked a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
}

export interface SpendVsProfitSummary {
  revenue: number;
  grossProfit: number;
  /** Total output VAT (GBP) owed to HMRC across the range (Task */
  outputVat?: number;
  /** grossProfit minus outputVat. Parallel to grossProfit. */
  vatAdjustedGrossProfit?: number;
  purchaseSpend: number;
  consignmentPayouts: number;
  expenses: number;
  totalSpend: number;
  netCashPosition: number;
  /** vatAdjustedGrossProfit - totalSpend across the range (Task */
  vatAdjustedNetCashPosition?: number;
  /** True when any period in the range had a line lacking a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
  /** True when at least one included PO had a paid_at but no gbp_paid value, so its spend is partial / estimated from landed costs only. */
  hasEstimatedSpend: boolean;
  includesLiabilities: boolean;
}

export type SpendVsProfitCardsMonthWindow = {
  /** Inclusive UTC timestamp for London-local month start. */
  from: string;
  /** Response-time UTC timestamp. */
  to: string;
};

export interface SpendVsProfitCards {
  /** Spend since Monday 00:00 (Europe/London) up to now. Independent of the date filter. */
  spendThisWeek: number | null;
  profitThisWeek: number | null;
  /** profitThisWeek - spendThisWeek. */
  netCashThisWeek: number | null;
  spendThisMonth: number | null;
  profitThisMonth: number | null;
  netCashThisMonth: number | null;
  /** Current-month matching sale lines whose final cost is missing, excluding unresolved-source lines. */
  monthMissingCostLines: number;
  /** Current-month matching sale lines whose source cost is unresolved. */
  monthUnresolvedSourceCostLines: number;
  monthWindow: SpendVsProfitCardsMonthWindow;
}

export type SpendVsProfitReportGranularity = typeof SpendVsProfitReportGranularity[keyof typeof SpendVsProfitReportGranularity];


export const SpendVsProfitReportGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type SpendVsProfitReportStockType = typeof SpendVsProfitReportStockType[keyof typeof SpendVsProfitReportStockType];


export const SpendVsProfitReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export interface SpendVsProfitReport {
  granularity: SpendVsProfitReportGranularity;
  from: string;
  to: string;
  stockType?: SpendVsProfitReportStockType;
  supplierId?: string | null;
  includeLiabilities: boolean;
  cards: SpendVsProfitCards;
  summary: SpendVsProfitSummary;
  periods: SpendVsProfitRow[];
}

export interface SalesPerformanceDailyRow {
  /** Calendar day in Europe/London, formatted YYYY-MM-DD. */
  date: string;
  /** Net of refunds (line-level `order_adjustment_items.refund_amount_gbp` subtracted). */
  revenue: number;
  /** Net of cost reversed for returned-quantity items. */
  cost: number;
  profit: number;
  marginPct: number;
  /** Output VAT (GBP) owed to HMRC on this day's sale lines, net of refunds (Task */
  outputVat?: number;
  /** profit minus outputVat. Parallel term — `profit` is unchanged. */
  vatAdjustedProfit?: number;
  /** (vatAdjustedProfit / revenue) * 100, one decimal. 0 when revenue is 0. */
  vatAdjustedMarginPct?: number;
  /** True when any non-empty line this day lacked a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
  /** Gross — partial refunds do not decrement the order count. */
  orderCount: number;
  itemsSold: number;
  /** Net revenue / gross orders. */
  avgOrderValue: number;
  /** Total refund amount that hit this day (positive number). */
  refundsRefunded: number;
  /** Cost reversed because goods came back (positive number). */
  refundsCostReversed: number;
  topProductTitle?: string | null;
  topProductQty?: number | null;
  topCustomerName?: string | null;
  topCustomerId?: string | null;
  topCustomerSpend?: number | null;
}

export interface SalesPerformanceDailySummary {
  totalRevenue: number;
  totalCost: number;
  totalProfit: number;
  averageMarginPct: number;
  /** Total output VAT (GBP) owed to HMRC across the range, net of refunds (Task */
  totalOutputVat?: number;
  /** totalProfit minus totalOutputVat. Parallel to totalProfit. */
  totalVatAdjustedProfit?: number;
  /** Weighted VAT-adjusted margin (totalVatAdjustedProfit / totalRevenue * 100). */
  averageVatAdjustedMarginPct?: number;
  /** True when any row in the range had a line lacking a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
  totalOrders: number;
  totalItemsSold: number;
  avgOrderValue: number;
  totalRefundsRefunded: number;
  totalRefundsCostReversed: number;
}

export type SalesPerformanceDailyReportStockType = typeof SalesPerformanceDailyReportStockType[keyof typeof SalesPerformanceDailyReportStockType];


export const SalesPerformanceDailyReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type SalesPerformanceDailyReportRefundBasis = typeof SalesPerformanceDailyReportRefundBasis[keyof typeof SalesPerformanceDailyReportRefundBasis];


export const SalesPerformanceDailyReportRefundBasis = {
  refunded_at: 'refunded_at',
  sale_date: 'sale_date',
} as const;

export interface SalesPerformanceDailyReport {
  from: string;
  to: string;
  channel?: string | null;
  stockType: SalesPerformanceDailyReportStockType;
  customerId?: string | null;
  refundBasis?: SalesPerformanceDailyReportRefundBasis;
  rows: SalesPerformanceDailyRow[];
  summary: SalesPerformanceDailySummary;
}

export interface SalesPerformanceByChannelRow {
  /** Lowercased channel key (e.g. `ebay`, `shopify`, `whatsapp`, `direct`). Empty string for sales whose channel column is NULL. */
  channel: string;
  revenue: number;
  cost: number;
  profit: number;
  marginPct: number;
  /** Output VAT (GBP) owed to HMRC on this channel's sale lines, net of refunds (Task */
  outputVat?: number;
  /** profit minus outputVat. Parallel term — `profit` is unchanged. */
  vatAdjustedProfit?: number;
  /** (vatAdjustedProfit / revenue) * 100, one decimal. 0 when revenue is 0. */
  vatAdjustedMarginPct?: number;
  /** True when any non-empty line on this channel lacked a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
  orderCount: number;
  itemsSold: number;
  avgOrderValue: number;
  refundsRefunded: number;
  refundsCostReversed: number;
  revenueSharePct: number;
}

export type SalesPerformanceByChannelReportStockType = typeof SalesPerformanceByChannelReportStockType[keyof typeof SalesPerformanceByChannelReportStockType];


export const SalesPerformanceByChannelReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type SalesPerformanceByChannelReportRefundBasis = typeof SalesPerformanceByChannelReportRefundBasis[keyof typeof SalesPerformanceByChannelReportRefundBasis];


export const SalesPerformanceByChannelReportRefundBasis = {
  refunded_at: 'refunded_at',
  sale_date: 'sale_date',
} as const;

export interface SalesPerformanceByChannelReport {
  from: string;
  to: string;
  channel?: string | null;
  stockType: SalesPerformanceByChannelReportStockType;
  customerId?: string | null;
  refundBasis: SalesPerformanceByChannelReportRefundBasis;
  rows: SalesPerformanceByChannelRow[];
  summary: SalesPerformanceDailySummary;
}

export interface SellingSession {
  id: string;
  name: string;
  notes?: string | null;
  startedAt: string;
  endedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface SellingSessionInput {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  /** @maxLength 2000 */
  notes?: string | null;
  startedAt: string;
  endedAt: string;
}

export interface SellingSessionPatch {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name?: string;
  /** @maxLength 2000 */
  notes?: string | null;
  startedAt?: string;
  endedAt?: string;
}

export type SalesPerformanceSessionRowSource = typeof SalesPerformanceSessionRowSource[keyof typeof SalesPerformanceSessionRowSource];


export const SalesPerformanceSessionRowSource = {
  manual: 'manual',
  auto: 'auto',
} as const;

export interface SalesPerformanceSessionRow {
  /** Manual: uuid. Auto: synthetic key like `auto-3`. */
  id: string;
  source: SalesPerformanceSessionRowSource;
  /** Operator-set name for manual sessions; null for auto. */
  name?: string | null;
  notes?: string | null;
  startedAt: string;
  endedAt: string;
  durationMinutes: number;
  revenue: number;
  cost: number;
  profit: number;
  marginPct: number;
  orderCount: number;
  itemsSold: number;
  avgOrderValue: number;
  /** Net revenue divided by max(durationHours, 5/60). Single-sale sessions clamp to 5 minutes to avoid division explosions. */
  revenuePerHour: number;
  /** Same clamp as revenuePerHour. */
  itemsPerHour: number;
  refundsRefunded: number;
  refundsCostReversed: number;
  /** Lowercased channel key with the most revenue in this session. */
  topChannel?: string | null;
  topProductTitle?: string | null;
  topProductQty?: number | null;
}

export type SalesPerformanceSessionsReportStockType = typeof SalesPerformanceSessionsReportStockType[keyof typeof SalesPerformanceSessionsReportStockType];


export const SalesPerformanceSessionsReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type SalesPerformanceSessionsReportRefundBasis = typeof SalesPerformanceSessionsReportRefundBasis[keyof typeof SalesPerformanceSessionsReportRefundBasis];


export const SalesPerformanceSessionsReportRefundBasis = {
  refunded_at: 'refunded_at',
  sale_date: 'sale_date',
} as const;

export interface SalesPerformanceSessionsReport {
  from: string;
  to: string;
  channel?: string | null;
  stockType: SalesPerformanceSessionsReportStockType;
  customerId?: string | null;
  refundBasis: SalesPerformanceSessionsReportRefundBasis;
  minGapMinutes: number;
  rows: SalesPerformanceSessionRow[];
  summary: SalesPerformanceDailySummary;
}

/**
 * What to do on Shopify when a SKU's available stock hits 0.
 * `keep` (default) leaves the listing live with stock=0.
 * `archive` pushes 0 then sets product status=archived (hidden
 * from the storefront, kept in admin). `delete` pushes 0 then
 * permanently deletes the product on Shopify. Applied by
 * `applyOutOfStockPolicy()` — currently invoked by the inventory
 * merge endpoint when loser lots are removed.
 */
export type SettingsInputShopifyOutOfStockPolicy = typeof SettingsInputShopifyOutOfStockPolicy[keyof typeof SettingsInputShopifyOutOfStockPolicy] | null;


export const SettingsInputShopifyOutOfStockPolicy = {
  keep: 'keep',
  archive: 'archive',
  delete: 'delete',
} as const;

/**
 * What to do on WooCommerce when a SKU's available stock hits 0.
 * `keep` (default) leaves the product published with
 * stock_status=outofstock. `archive` pushes 0 then sets product
 * status=draft (closest WC equivalent — hidden from public).
 * `delete` pushes 0 then DELETE with force=true (skips trash).
 */
export type SettingsInputWoocommerceOutOfStockPolicy = typeof SettingsInputWoocommerceOutOfStockPolicy[keyof typeof SettingsInputWoocommerceOutOfStockPolicy] | null;


export const SettingsInputWoocommerceOutOfStockPolicy = {
  keep: 'keep',
  archive: 'archive',
  delete: 'delete',
} as const;

/**
 * Map of product type (free text, matches
 * `inventory_items.productType`) → default eBay leaf category id.
 * Applied when creating a new inventory item that has no per-item
 * override: the item's productType is looked up here and the
 * matching category id is baked into the item's `ebayCategoryId`.
 * Resolution order on listing: item override → product-type
 * default → global Bullion Bars (UK) fallback. Admin-editable.
 */
export type SettingsInputEbayCategoryDefaults = {[key: string]: string} | null;

export interface SettingsInput {
  businessName?: string | null;
  /**
     * Valid IANA business timezone (for example Europe/London or America/New_York).
     * @minLength 1
     * @maxLength 64
     */
  businessTimezone?: string | null;
  defaultCurrency?: string | null;
  vatTrackingEnabled?: boolean | null;
  defaultShippingCost?: number | null;
  defaultEbayFeePct?: number | null;
  defaultShopifyFeePct?: number | null;
  /**
     * Percentage added to Shopify product listing prices. Blank or null means 0%.
     * @minimum 0
     * @maximum 1000
     */
  shopifyProductPriceMarkupPct?: number | null;
  defaultWhatnotFeePct?: number | null;
  defaultMarginPct?: number | null;
  storageLocations?: string[];
  productCategories?: string[];
  paymentMethods?: string[];
  ebayFeedbackEnabled?: boolean | null;
  /** manual | auto | bulk */
  ebayFeedbackMode?: string | null;
  ebayFeedbackMessage?: string | null;
  ebayFeedbackDelayHours?: number | null;
  /**
     * Maximum allowed duration (seconds) for videos uploaded on the
     * /packing screen. NULL or 0 means unlimited. Enforced client-side
     * before upload via the <video> element metadata.
     */
  packingVideoMaxSeconds?: number | null;
  /**
     * When true, pressing "Start packing" on the job-detail screen
     * immediately begins an evidence video recording (no modal).
     */
  packingAutoStartRecording?: boolean | null;
  /**
     * When true, the operator cannot stop the auto-started recording
     * manually — it runs (across in-app navigation) until "Packing
     * complete" is pressed.
     */
  packingLockRecordingUntilComplete?: boolean | null;
  /**
     * When true, at least one media item must be attached before a job
     * can be marked completed (enforced server-side on the completed
     * transition, mirroring the evidence_captured guard).
     */
  packingRequireVideoToComplete?: boolean | null;
  /**
     * When true, capture audio alongside video on the auto-started
     * packing recording.
     */
  packingRecordAudio?: boolean | null;
  /**
     * When true, show the optional "Send confirmation" button in the
     * packing flow. Confirmations are never auto-sent regardless.
     */
  packingShowSendConfirmation?: boolean | null;
  /**
     * Per-tenant hard cutoff for eBay order import. Any eBay order
     * whose creationDate is strictly EARLIER than this timestamp is
     * silently skipped by both the scheduler and the manual import
     * endpoint. NULL = no cutoff. May be set to a future date to
     * pause new eBay imports altogether.
     */
  ebayMinOrderDate?: string | null;
  /**
     * What to do on Shopify when a SKU's available stock hits 0.
     * `keep` (default) leaves the listing live with stock=0.
     * `archive` pushes 0 then sets product status=archived (hidden
     * from the storefront, kept in admin). `delete` pushes 0 then
     * permanently deletes the product on Shopify. Applied by
     * `applyOutOfStockPolicy()` — currently invoked by the inventory
     * merge endpoint when loser lots are removed.
     */
  shopifyOutOfStockPolicy?: SettingsInputShopifyOutOfStockPolicy;
  /**
     * What to do on WooCommerce when a SKU's available stock hits 0.
     * `keep` (default) leaves the product published with
     * stock_status=outofstock. `archive` pushes 0 then sets product
     * status=draft (closest WC equivalent — hidden from public).
     * `delete` pushes 0 then DELETE with force=true (skips trash).
     */
  woocommerceOutOfStockPolicy?: SettingsInputWoocommerceOutOfStockPolicy;
  /**
     * When true (the default), the Shopify push derives extra product
     * tags from the listing title and the item's structured specs —
     * metal, weight/size, coin vs bar, mint/brand and year — and adds
     * them ALONGSIDE any tags the operator typed on the item (their
     * tags stay verbatim and first; de-duped case-insensitively).
     * Set false to keep the legacy behaviour: the operator's tags
     * exactly as entered, or the "metal, brand" fallback when the
     * field is blank.
     */
  shopifyAutoTagsEnabled?: boolean | null;
  /**
     * Map of product type (free text, matches
     * `inventory_items.productType`) → default eBay leaf category id.
     * Applied when creating a new inventory item that has no per-item
     * override: the item's productType is looked up here and the
     * matching category id is baked into the item's `ebayCategoryId`.
     * Resolution order on listing: item override → product-type
     * default → global Bullion Bars (UK) fallback. Admin-editable.
     */
  ebayCategoryDefaults?: SettingsInputEbayCategoryDefaults;
  /**
     * Admin-configurable ordered list of field keys included in the
     * "Export Live Stock (CSV)" download (dashboard + inventory page).
     * The CSV header + columns are built in exactly this order from the
     * shared field definitions (FE: `lib/live-stock-export-fields.ts`).
     * Only known field keys are accepted; unknown keys are rejected.
     * An EMPTY array (the default) preserves the legacy four-column
     * export (Item / Cost Price / Asking Price / Stock On Hand).
     */
  liveStockExportFields?: string[] | null;
  /**
     * Postage hold master switch (default on). While enabled, an eBay
     * order that is NOT yet shipped-or-later AND is less than
     * `postageHoldWindowHours` since its sale date has BOTH its
     * buyer-charged postage and its postage cost EXCLUDED from every
     * profit/performance figure. Settled / historical numbers are
     * unchanged. eBay-only scope for now.
     */
  postageHoldEnabled?: boolean | null;
  /**
     * How many hours after the sale date an unsettled eBay order's
     * postage stays held out of profit (default 4). Once this window
     * elapses — or the order ships — postage is counted normally.
     * @minimum 1
     * @maximum 2160
     */
  postageHoldWindowHours?: number | null;
  /**
     * When true, shows a "Download images for TikTok Live" icon button
     * on the inventory page toolbar. Clicking it downloads a ZIP of all
     * live, sellable product images for bulk upload to the TikTok Live
     * Seller Media Center. Defaults false — operators must explicitly
     * enable it.
     */
  tiktokLiveImageExportEnabled?: boolean | null;
}

export type Settings = SettingsInput & {
  id: string;
};

export interface UploadUrlRequest {
  /** @minLength 1 */
  name: string;
  /** @minimum 1 */
  size: number;
  /** @minLength 1 */
  contentType: string;
}

export interface UploadUrlResponse {
  uploadURL: string;
  objectPath: string;
}

export interface PublicUploadUrlResponse {
  uploadURL: string;
  /**
     * Canonical path stored on entities, shape `/public-objects/<tenantId>/<filename>`.
     * `resolvePhoto()` on the frontend handles this by prepending `${BASE_URL}api/storage`.
     */
  objectPath: string;
  /**
     * Absolute https URL external systems (Shopify, eBay, social media)
     * should fetch the file from. Resolves the host from PUBLIC_BASE_URL,
     * REPLIT_DOMAINS, or REPLIT_DEV_DOMAIN at mint time.
     */
  publicUrl: string;
}

export type MarketplaceIntegrationCredentialPreview = {[key: string]: string};

export interface CredentialField {
  key: string;
  label: string;
  required: boolean;
  secret: boolean;
  placeholder?: string | null;
}

export interface MarketplaceIntegration {
  slug: string;
  /** Public Shopify shop host only; null for other integrations. */
  shopDomain?: string | null;
  displayName: string;
  /** Per-account identifier within a slug. eBay supports multiple accounts per tenant; other slugs always use 'primary'. */
  accountKey: string;
  configured: boolean;
  enabled: boolean;
  lastSyncedAt?: string | null;
  notes?: string | null;
  credentialFields: CredentialField[];
  credentialPreview?: MarketplaceIntegrationCredentialPreview;
  /** For eBay: true when the OAuth flow has completed (refreshToken present in credentials). For TikTok Shop: true when the per-tenant shop is linked (tiktok_shop_connections status=CONNECTED with a shopId). Null for all other integrations. */
  connected?: boolean | null;
  /** TikTok Shop card only: connected shop's display name (shopName, falling back to sellerName) so operators can see WHICH shop is linked. */
  connectedShopName?: string | null;
  /** eBay only: ISO-8601 expiry date of the OAuth refresh token, stored at connect time. Null when absent (token never connected or expiry not yet stored). Past value means the token is expired. */
  tokenExpiresAt?: string | null;
}

export type IntegrationCardStatus = typeof IntegrationCardStatus[keyof typeof IntegrationCardStatus];


export const IntegrationCardStatus = {
  healthy: 'healthy',
  warning: 'warning',
  error: 'error',
  authentication_required: 'authentication_required',
  stale: 'stale',
  syncing: 'syncing',
  disabled: 'disabled',
  not_connected: 'not_connected',
} as const;

export type IntegrationCardMetricsItem = {
  key: string;
  label: string;
  value: number;
};

export interface IntegrationCard {
  id: string;
  slug: string;
  accountKey: string;
  displayName: string;
  category: string;
  status: IntegrationCardStatus;
  configured: boolean;
  enabled: boolean;
  /** @nullable */
  lastSyncAt?: string | null;
  /** @nullable */
  lastActivityAt?: string | null;
  /** @minimum 0 */
  issueCount: number;
  metrics: IntegrationCardMetricsItem[];
  allowedActions: string[];
  /** @nullable */
  issueSummary?: string | null;
}

export type IntegrationSummaryTotals = {
  integrations: number;
  connected: number;
  healthy: number;
  withIssues: number;
  healthPercent: number;
};

export type IntegrationSummaryCategoriesItem = {
  key: string;
  count: number;
};

export type IntegrationSummaryPage = {
  limit: number;
  /** @nullable */
  nextCursor: string | null;
};

export interface IntegrationSummary {
  generatedAt: string;
  totals: IntegrationSummaryTotals;
  categories: IntegrationSummaryCategoriesItem[];
  page: IntegrationSummaryPage;
  integrations: IntegrationCard[];
}

export type IntegrationPageItemsItem = { [key: string]: unknown };

export interface IntegrationPage {
  items: IntegrationPageItemsItem[];
  /** @nullable */
  nextCursor: string | null;
}

export type IntegrationQueuedActionStatus = typeof IntegrationQueuedActionStatus[keyof typeof IntegrationQueuedActionStatus];


export const IntegrationQueuedActionStatus = {
  queued: 'queued',
  processing: 'processing',
} as const;

export interface IntegrationQueuedAction {
  status: IntegrationQueuedActionStatus;
  /** @nullable */
  jobId: string | null;
  alreadyQueued: boolean;
}

export interface ReconcileChannelSummary {
  /** Items that had a valid listing and were successfully enqueued / handed off. */
  success: number;
  /** Items that had no listing for this channel, or whose integration gate was not met. */
  skipped: number;
  /** Items where a per-item error prevented the push from being submitted. */
  failed: number;
}

export type StockReconcileSummaryByChannel = {
  ebay: ReconcileChannelSummary;
  shopify: ReconcileChannelSummary;
  tiktok: ReconcileChannelSummary;
  woocommerce: ReconcileChannelSummary;
};

export interface StockReconcileSummary {
  /** Total inventory items scanned that had at least one external listing. */
  attempted: number;
  byChannel: StockReconcileSummaryByChannel;
}

export type IntegrationUpdateCredentials = {[key: string]: string};

export interface IntegrationUpdate {
  enabled?: boolean;
  notes?: string | null;
  /** Target account within the slug. Defaults to 'primary'. */
  accountKey?: string;
  credentials?: IntegrationUpdateCredentials;
}

export interface TriggerSyncBody {
  /** stock|listings|orders */
  kind?: string;
  /** Target account for multi-account integrations (eBay only). Defaults to 'primary'. */
  accountKey?: string;
  inventoryItemIds?: string[];
}

export interface StockSyncJob {
  id: string;
  integrationSlug: string;
  kind: string;
  status: string;
  message?: string | null;
  requestedItemCount: number;
  processedItemCount: number;
  createdAt: string;
  completedAt?: string | null;
}

export interface SaleLabelInput {
  /** Object-storage path returned from the upload-URL flow (e.g. "/objects/<uuid>"). */
  objectPath: string;
  fileName: string;
  /** Carrier label is for ("Royal Mail", "DHL", "Other", or any free text). */
  carrier: string;
  sizeBytes?: number | null;
}

export interface PrintSaleLabelsInput {
  /**
     * Sale-order IDs in the exact order they should appear in the merged PDF.
     * @minItems 1
     */
  saleIds: string[];
}

export interface SaleAttachment {
  id: string;
  saleOrderId: string;
  objectPath: string;
  fileName: string;
  contentType: string;
  mediaType: string;
  kind: string;
  sizeBytes: number;
  notes?: string | null;
  isInternal: boolean;
  uploadedAt: string;
  servingUrl: string;
}

export interface SaleAttachmentInput {
  objectPath: string;
  fileName: string;
  contentType: string;
  /** image|video */
  mediaType: string;
  kind?: string;
  sizeBytes?: number;
  notes?: string | null;
}

export interface AppBranding {
  appName: string;
  logoUrl?: string | null;
  /** Hex e.g. #F5BB00 */
  primaryColor: string;
  secondaryColor: string;
  /** Hex; colour of the app-name wordmark in the sidebar header */
  appNameColor?: string | null;
  accentColor?: string | null;
  destructiveColor?: string | null;
  successColor?: string | null;
  warningColor?: string | null;
  backgroundColor?: string | null;
  foregroundColor?: string | null;
  mutedColor?: string | null;
  borderColor?: string | null;
  sidebarColor?: string | null;
  sidebarForegroundColor?: string | null;
  sidebarAccentColor?: string | null;
  /** Hex; drives --chart-1 (e.g. P&L bars) */
  chartColor1?: string | null;
  chartColor2?: string | null;
  chartColor3?: string | null;
  chartColor4?: string | null;
  chartColor5?: string | null;
  /** Hex; CSS color for a:visited */
  linkVisitedColor?: string | null;
  companyAddress?: string | null;
  contactEmail?: string | null;
  contactWebsite?: string | null;
  paymentBankName?: string | null;
  paymentAccountName?: string | null;
  paymentSortCode?: string | null;
  paymentAccountNumber?: string | null;
  /** Hex; secondary accent for invoice PDFs (gradient end). Null = black. */
  invoiceAccentColor?: string | null;
  /** Footer sub-line under THANK YOU on invoice PDFs. */
  invoiceFooterText?: string | null;
  /** Payment terms / notes shown on invoice PDFs. */
  invoicePaymentTerms?: string | null;
  invoiceVatNumber?: string | null;
  invoiceCompanyRegNumber?: string | null;
  invoiceShowPaymentDetails?: boolean;
  invoiceShowRegistration?: boolean;
  updatedAt: string;
  updatedByUserId?: string | null;
}

export interface AppBrandingUpdate {
  appName?: string;
  logoUrl?: string | null;
  primaryColor?: string;
  secondaryColor?: string;
  appNameColor?: string | null;
  accentColor?: string | null;
  destructiveColor?: string | null;
  successColor?: string | null;
  warningColor?: string | null;
  backgroundColor?: string | null;
  foregroundColor?: string | null;
  mutedColor?: string | null;
  borderColor?: string | null;
  sidebarColor?: string | null;
  sidebarForegroundColor?: string | null;
  sidebarAccentColor?: string | null;
  chartColor1?: string | null;
  chartColor2?: string | null;
  chartColor3?: string | null;
  chartColor4?: string | null;
  chartColor5?: string | null;
  linkVisitedColor?: string | null;
  companyAddress?: string | null;
  contactEmail?: string | null;
  contactWebsite?: string | null;
  paymentBankName?: string | null;
  paymentAccountName?: string | null;
  paymentSortCode?: string | null;
  paymentAccountNumber?: string | null;
  invoiceAccentColor?: string | null;
  invoiceFooterText?: string | null;
  invoicePaymentTerms?: string | null;
  invoiceVatNumber?: string | null;
  invoiceCompanyRegNumber?: string | null;
  invoiceShowPaymentDetails?: boolean;
  invoiceShowRegistration?: boolean;
}

export type UserThemeUpdateTheme = typeof UserThemeUpdateTheme[keyof typeof UserThemeUpdateTheme];


export const UserThemeUpdateTheme = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export interface UserThemeUpdate {
  theme: UserThemeUpdateTheme;
}

export type DropshipCustomerStatus = typeof DropshipCustomerStatus[keyof typeof DropshipCustomerStatus];


export const DropshipCustomerStatus = {
  active: 'active',
  disabled: 'disabled',
} as const;

export interface DropshipCustomer {
  id: string;
  name: string;
  company?: string | null;
  contactEmail?: string | null;
  status: DropshipCustomerStatus;
  /** Public-safe prefix of the key (e.g. eb_live_AB12…) */
  apiKeyPrefix: string;
  /** Decimal as string */
  defaultPriceMarkupPct?: string;
  lastUsedAt?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt?: string;
  totalOrders: number;
  totalUnits: number;
  totalRevenue: string;
}

export type DropshipCustomerInputStatus = typeof DropshipCustomerInputStatus[keyof typeof DropshipCustomerInputStatus];


export const DropshipCustomerInputStatus = {
  active: 'active',
  disabled: 'disabled',
} as const;

export interface DropshipCustomerInput {
  name?: string;
  company?: string | null;
  contactEmail?: string | null;
  status?: DropshipCustomerInputStatus;
  defaultPriceMarkupPct?: string | number;
  notes?: string | null;
}

export type DropshipCustomerWithSecret = DropshipCustomer & {
  /** FULL API key — shown ONCE at creation/regeneration. Store securely. */
  apiKey: string;
};

export interface DropshipOrder {
  id: string;
  dropshipCustomerId: string;
  inventoryItemId?: string | null;
  sku: string;
  productTitle: string;
  quantity: number;
  unitPrice: string;
  total: string;
  currency: string;
  orderReference?: string | null;
  idempotencyKey?: string | null;
  createdAt: string;
  customerName?: string | null;
}

export interface DropshipStockItem {
  sku: string;
  productTitle: string;
  brand?: string | null;
  metal?: string | null;
  /** Units currently in stock and unreserved */
  available: number;
  /** Suggested unit price (GBP) including the customer's markup; null if no cost basis available */
  unitPrice?: string | null;
  currency?: string;
}

export interface DropshipStockResponse {
  generatedAt: string;
  currency?: string;
  items: DropshipStockItem[];
}

export type DropshipOrderInputItemsItem = {
  sku: string;
  /** @minimum 1 */
  quantity: number;
};

export interface DropshipOrderInput {
  orderReference?: string | null;
  idempotencyKey?: string | null;
  /** @minItems 1 */
  items: DropshipOrderInputItemsItem[];
}

export type DropshipOrderResponseTotals = {
  units: number;
  total: string;
  currency: string;
};

export interface DropshipOrderResponse {
  accepted: boolean;
  orderIds: string[];
  idempotent?: boolean;
  totals: DropshipOrderResponseTotals;
  items?: DropshipOrder[];
}

export interface DropshipDashboard {
  activeCustomers: number;
  totalCustomers: number;
  last30dUnits: number;
  last30dRevenue: string;
  currency: string;
  recentOrders: DropshipOrder[];
}

export type DropshipReportCustomerRowTopSkusItem = {
  sku: string;
  productTitle: string;
  units: number;
  revenue: string;
};

export interface DropshipReportCustomerRow {
  customerId: string;
  customerName: string;
  units: number;
  revenue: string;
  currency: string;
  topSkus: DropshipReportCustomerRowTopSkusItem[];
}

export type DropshipReportDailyItem = {
  date: string;
  units: number;
  revenue: string;
};

export interface DropshipReport {
  from: string;
  to: string;
  currency: string;
  totalUnits: number;
  totalRevenue: string;
  customers: DropshipReportCustomerRow[];
  daily: DropshipReportDailyItem[];
}

export interface Sales7daySummaryChannel {
  /** Normalized channel display label, e.g. 'TikTok Shop', 'eBay', 'Direct' */
  channel: string;
  total: number;
}

export interface Sales7daySummaryDay {
  /** YYYY-MM-DD (UK calendar day, Europe/London) */
  date: string;
  total: number;
  /** Per-channel breakdown of the day's total, largest first. */
  channels: Sales7daySummaryChannel[];
}

export interface Sales7daySummary {
  daily: Sales7daySummaryDay[];
  previousPeriod: Sales7daySummaryDay[];
  totalThisPeriod: number;
  totalPreviousPeriod: number;
  percentageChange: number;
  projection: number;
}

export type MetalQuoteCurrency = typeof MetalQuoteCurrency[keyof typeof MetalQuoteCurrency];


export const MetalQuoteCurrency = {
  GBP: 'GBP',
  USD: 'USD',
  EUR: 'EUR',
  CAD: 'CAD',
  AUD: 'AUD',
} as const;

/**
 * New shared copper quotes use troy_ounce; pound remains valid only for retained legacy observations.
 */
export type MetalQuoteCanonicalUnit = typeof MetalQuoteCanonicalUnit[keyof typeof MetalQuoteCanonicalUnit];


export const MetalQuoteCanonicalUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

export type MetalQuoteFreshness = typeof MetalQuoteFreshness[keyof typeof MetalQuoteFreshness];


export const MetalQuoteFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export type MetalQuoteQuality = typeof MetalQuoteQuality[keyof typeof MetalQuoteQuality];


export const MetalQuoteQuality = {
  LIVE: 'LIVE',
  DELAYED: 'DELAYED',
  STALE: 'STALE',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type MetalQuotePriceType = typeof MetalQuotePriceType[keyof typeof MetalQuotePriceType];


export const MetalQuotePriceType = {
  spot: 'spot',
} as const;

export type MetalQuoteProvenance = { [key: string]: unknown };

/**
 * Quoted unit. "oz" = troy ounce. New copper observations use oz; retained legacy copper observations may use lb.
 */
export type MetalQuoteUnit = typeof MetalQuoteUnit[keyof typeof MetalQuoteUnit];


export const MetalQuoteUnit = {
  oz: 'oz',
  lb: 'lb',
} as const;

export interface MetalQuote {
  /** Value in `currency` per quoted unit. The legacy field name is retained for backwards compatibility — use `unit` to distinguish troy ounces from retained pound observations. */
  gbpPerOz: number;
  /** @nullable */
  value: number | null;
  currency: MetalQuoteCurrency;
  /** New shared copper quotes use troy_ounce; pound remains valid only for retained legacy observations. */
  canonicalUnit: MetalQuoteCanonicalUnit;
  source: string;
  /** @nullable */
  sourceTimestamp?: string | null;
  retrievedAt: string;
  freshness: MetalQuoteFreshness;
  quality: MetalQuoteQuality;
  isFallback: boolean;
  /** @nullable */
  fallbackReason?: string | null;
  priceType: MetalQuotePriceType;
  calculationVersion: string;
  provenance: MetalQuoteProvenance;
  change: number;
  changePct: number;
  /** Quoted unit. "oz" = troy ounce. New copper observations use oz; retained legacy copper observations may use lb. */
  unit: MetalQuoteUnit;
}

export type MetalPricesResponseCurrency = typeof MetalPricesResponseCurrency[keyof typeof MetalPricesResponseCurrency];


export const MetalPricesResponseCurrency = {
  GBP: 'GBP',
  USD: 'USD',
  EUR: 'EUR',
  CAD: 'CAD',
  AUD: 'AUD',
} as const;

export type MetalPricesResponseFreshness = typeof MetalPricesResponseFreshness[keyof typeof MetalPricesResponseFreshness];


export const MetalPricesResponseFreshness = {
  fresh: 'fresh',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export type MetalPricesResponseQuality = typeof MetalPricesResponseQuality[keyof typeof MetalPricesResponseQuality];


export const MetalPricesResponseQuality = {
  LIVE: 'LIVE',
  DELAYED: 'DELAYED',
  STALE: 'STALE',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type MetalPricesResponseProvenance = { [key: string]: unknown };

export interface MetalPricesResponse {
  gold: MetalQuote;
  silver: MetalQuote;
  platinum: MetalQuote;
  palladium: MetalQuote;
  copper: MetalQuote;
  fetchedAt: string;
  retrievedAt: string;
  demo: boolean;
  provider: string;
  currency: MetalPricesResponseCurrency;
  freshness: MetalPricesResponseFreshness;
  quality: MetalPricesResponseQuality;
  calculationVersion: string;
  provenance: MetalPricesResponseProvenance;
}

export type SpotPriceSnapshotMetal = typeof SpotPriceSnapshotMetal[keyof typeof SpotPriceSnapshotMetal];


export const SpotPriceSnapshotMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
  copper: 'copper',
} as const;

/**
 * Value is projected per troy ounce. Use quoteValue and quoteUnit for the immutable source observation.
 */
export type SpotPriceSnapshotUnit = typeof SpotPriceSnapshotUnit[keyof typeof SpotPriceSnapshotUnit];


export const SpotPriceSnapshotUnit = {
  oz: 'oz',
} as const;

/**
 * Original unit stored with this quote; legacy pound observations remain pound-labelled.
 */
export type SpotPriceSnapshotQuoteUnit = typeof SpotPriceSnapshotQuoteUnit[keyof typeof SpotPriceSnapshotQuoteUnit];


export const SpotPriceSnapshotQuoteUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

export interface SpotPriceSnapshot {
  metal: SpotPriceSnapshotMetal;
  gbpPerOz: number;
  /** Value is projected per troy ounce. Use quoteValue and quoteUnit for the immutable source observation. */
  unit: SpotPriceSnapshotUnit;
  /** Original persisted observation value */
  quoteValue: number;
  /** Original unit stored with this quote; legacy pound observations remain pound-labelled. */
  quoteUnit: SpotPriceSnapshotQuoteUnit;
  /** Provider that supplied the price. yahoo|goldapi.io|metalpriceapi.com|demo|manual, or "live:<provider>" when served from the in-memory fallback on a cold tenant. */
  source: string;
  fetchedAt: string;
}

/**
 * Latest persisted spot snapshot per metal. Value is null only if both persistence AND the live fallback have nothing for that metal.
 */
export type CurrentSpotPricesResponsePrices = {
  gold: SpotPriceSnapshot | null;
  silver: SpotPriceSnapshot | null;
  platinum: SpotPriceSnapshot | null;
  palladium: SpotPriceSnapshot | null;
  copper: SpotPriceSnapshot | null;
};

export interface CurrentSpotPricesResponse {
  /** Latest persisted spot snapshot per metal. Value is null only if both persistence AND the live fallback have nothing for that metal. */
  prices: CurrentSpotPricesResponsePrices;
}

/**
 * Value is projected per troy ounce. Use quoteValue and quoteUnit for the immutable source observation.
 */
export type SpotPriceHistoryPointUnit = typeof SpotPriceHistoryPointUnit[keyof typeof SpotPriceHistoryPointUnit];


export const SpotPriceHistoryPointUnit = {
  oz: 'oz',
} as const;

/**
 * Original unit stored with this quote; legacy pound observations remain pound-labelled.
 */
export type SpotPriceHistoryPointQuoteUnit = typeof SpotPriceHistoryPointQuoteUnit[keyof typeof SpotPriceHistoryPointQuoteUnit];


export const SpotPriceHistoryPointQuoteUnit = {
  troy_ounce: 'troy_ounce',
  pound: 'pound',
} as const;

export interface SpotPriceHistoryPoint {
  gbpPerOz: number;
  /** Value is projected per troy ounce. Use quoteValue and quoteUnit for the immutable source observation. */
  unit: SpotPriceHistoryPointUnit;
  /** Original persisted observation value */
  quoteValue: number;
  /** Original unit stored with this quote; legacy pound observations remain pound-labelled. */
  quoteUnit: SpotPriceHistoryPointQuoteUnit;
  source: string;
  fetchedAt: string;
}

export type SpotPriceHistoryResponseMetal = typeof SpotPriceHistoryResponseMetal[keyof typeof SpotPriceHistoryResponseMetal];


export const SpotPriceHistoryResponseMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
  copper: 'copper',
} as const;

export interface SpotPriceHistoryResponse {
  metal: SpotPriceHistoryResponseMetal;
  /**
     * @minimum 1
     * @maximum 168
     */
  hours: number;
  points: SpotPriceHistoryPoint[];
}

export type AskAiHistoryEntryRole = typeof AskAiHistoryEntryRole[keyof typeof AskAiHistoryEntryRole];


export const AskAiHistoryEntryRole = {
  user: 'user',
  assistant: 'assistant',
} as const;

export interface AskAiHistoryEntry {
  role: AskAiHistoryEntryRole;
  content: string;
}

export interface AskAiRequest {
  /**
     * @minLength 1
     * @maxLength 2000
     */
  question: string;
  history?: AskAiHistoryEntry[];
}

export interface AskAiResponse {
  /** Background job id. Poll GET /ask-ai/jobs/{jobId} for the result. */
  jobId: string;
  /** Initial status — always "queued" on 202. */
  status: string;
}

export interface EbayOrdersSyncResponse {
  ok: boolean;
  imported: number;
  skipped: number;
  failed: number;
  message?: string | null;
}

export type ShopifySyncedProductsResultCounts = {
  /** Items currently mirrored to Shopify (have an externalListings.shopify.productId). */
  synced: number;
  /** Subset of `synced` whose last push errored (lastError is set). */
  failed: number;
  /** Items NOT yet on Shopify but ready to push (all required fields filled). */
  eligible: number;
  /** Total inventory items in the tenant (denominator for coverage display). */
  total: number;
  /** Shopify-linked inventory items opted into Shopify stock sync. */
  stockManaged: number;
  /** Items with recent provider-readback-confirmed stock matching desired quantity. */
  stockCurrent: number;
  /** Items whose last confirmed Shopify stock is older than two hours. */
  stockStale: number;
  /** Items whose latest stock update failed or remains pending. */
  stockFailed: number;
  /** Items opted into stock sync without a usable Shopify stock mapping. */
  stockUnmapped: number;
  /** Items whose Shopify state could not be read or verified. */
  stockUnavailable: number;
  /** Items without a confirmed stock outcome. */
  stockUnverified: number;
};

export type ShopifyStockSweepSummaryOutcome = typeof ShopifyStockSweepSummaryOutcome[keyof typeof ShopifyStockSweepSummaryOutcome];


export const ShopifyStockSweepSummaryOutcome = {
  running: 'running',
  complete: 'complete',
  partial: 'partial',
  failed: 'failed',
} as const;

export interface ShopifyStockSweepSummary {
  startedAt: string;
  /** @nullable */
  completedAt: string | null;
  outcome: ShopifyStockSweepSummaryOutcome;
  attempted: number;
  confirmed: number;
  failed: number;
  unmapped: number;
  unavailable: number;
}

export type ShopifySyncedProductStockStatus = typeof ShopifySyncedProductStockStatus[keyof typeof ShopifySyncedProductStockStatus];


export const ShopifySyncedProductStockStatus = {
  not_managed: 'not_managed',
  current: 'current',
  stale: 'stale',
  failed: 'failed',
  unmapped: 'unmapped',
  unavailable: 'unavailable',
  unverified: 'unverified',
} as const;

export type ShopifySyncedProductStockSaleProtection = typeof ShopifySyncedProductStockSaleProtection[keyof typeof ShopifySyncedProductStockSaleProtection] | null;


export const ShopifySyncedProductStockSaleProtection = {
  unlisted: 'unlisted',
  failed: 'failed',
} as const;

export interface ShopifySyncedProduct {
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  quantityAvailable?: number;
  currentAskingPrice?: number | null;
  /** Numeric Shopify product id (as a string). */
  shopifyProductId: string | null;
  /** Direct link to the product in the Shopify admin, when shop domain is known. */
  shopifyAdminUrl?: string | null;
  /** ISO timestamp of the most recent successful (or attempted) push. */
  lastSyncedAt: string | null;
  /** Error message from the last push, if it failed. */
  lastError?: string | null;
  stockManaged: boolean;
  stockStatus: ShopifySyncedProductStockStatus;
  lastStockAttemptAt: string | null;
  lastStockConfirmedAt: string | null;
  desiredStockQuantity: number | null;
  providerStockQuantity: number | null;
  stockSyncError: string | null;
  stockSaleProtection: ShopifySyncedProductStockSaleProtection;
  photoUrl?: string | null;
}

export interface ShopifySyncedProductsResult {
  /** Most recent durable Shopify stock reconcile sweep, if one has run. */
  stockSweep: ShopifyStockSweepSummary | null;
  counts: ShopifySyncedProductsResultCounts;
  items: ShopifySyncedProduct[];
}

export type WoocommerceSyncedProductsResultCounts = {
  /** Items currently mirrored to WooCommerce (have an externalListings.woocommerce.productId). */
  synced: number;
  /** Items whose last push errored (lastError is set, with or without a product id). */
  failed: number;
  /** Items NOT yet on WooCommerce but ready to push (all required fields filled). */
  eligible: number;
  /** Total inventory items in the tenant (denominator for coverage display). */
  total: number;
};

export interface WoocommerceSyncedProduct {
  id: string;
  sku: string;
  productTitle: string;
  brand?: string | null;
  quantityAvailable: number;
  currentAskingPrice?: number | null;
  /** WooCommerce numeric product id (as a string). Null when the push failed before a product was created. */
  wooProductId?: string | null;
  /** Public permalink of the product on the WooCommerce store, when known. */
  wooProductUrl?: string | null;
  /** ISO timestamp of the most recent push attempt. */
  lastSyncedAt: string | null;
  /** Error message from the last push, if it failed. */
  lastError?: string | null;
  photoUrl?: string | null;
}

export interface WoocommerceSyncedProductsResult {
  counts: WoocommerceSyncedProductsResultCounts;
  items: WoocommerceSyncedProduct[];
}

export interface WooTerm {
  /** WC taxonomy term id. */
  id: number;
  name: string;
  slug: string;
}

export interface CreateWooBrandInput {
  /**
     * Brand display name. WC slugifies it for the term slug.
     * @minLength 1
     */
  name: string;
}

export interface CreateWooCategoryInput {
  /**
     * Category display name. WC slugifies it for the term slug.
     * @minLength 1
     */
  name: string;
  /** Optional parent category id for nesting. Omit / null for a top-level category. */
  parent?: number | null;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  archived: boolean;
  /** Numeric Shopify custom_collection id (as a string), if mirroring succeeded. */
  shopifyCollectionId?: string | null;
  /** Stable Shopify handle (URL slug) for the mirrored collection. */
  shopifyCollectionHandle?: string | null;
  /** Last Shopify sync failure message, if any. Cleared on a successful sync. */
  lastSyncError?: string | null;
  lastSyncedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CategoryCreate {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
}

export interface CategoryUpdate {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name?: string;
  archived?: boolean;
}

export type ShopifyValidationProductSnapshotVariantsItem = {
  id: string;
  sku?: string | null;
  price?: string | null;
};

export interface ShopifyValidationProductSnapshot {
  id: string;
  title: string;
  vendor?: string | null;
  productType?: string | null;
  tags: string[];
  status?: string | null;
  variants: ShopifyValidationProductSnapshotVariantsItem[];
  imageCount: number;
  metafields: ShopifyMetafield[];
  collections: string[];
}

export interface ShopifyValidationDashboardSnapshot {
  id: string;
  sku: string;
  productTitle: string;
  vendor?: string | null;
  tags: string[];
  productType?: string | null;
  askingPrice?: string | null;
  imageCount: number;
  metafields: ShopifyMetafield[];
  collections: string[];
}

export type ShopifyValidationMismatchSeverity = typeof ShopifyValidationMismatchSeverity[keyof typeof ShopifyValidationMismatchSeverity];


export const ShopifyValidationMismatchSeverity = {
  info: 'info',
  warn: 'warn',
  error: 'error',
} as const;

export interface ShopifyValidationMismatch {
  field: string;
  shopify?: unknown;
  dashboard?: unknown;
  severity: ShopifyValidationMismatchSeverity;
}

/**
 * Populated when `ok: false`; tells the UI why no diff was produced.
 */
export type ShopifyValidationResultReason = typeof ShopifyValidationResultReason[keyof typeof ShopifyValidationResultReason] | null;


export const ShopifyValidationResultReason = {
  not_configured: 'not_configured',
  no_products: 'no_products',
  error: 'error',
} as const;

export interface ShopifyValidationResult {
  /** True when a Shopify product was successfully fetched and a diff produced. */
  ok: boolean;
  /** Populated when `ok: false`; tells the UI why no diff was produced. */
  reason?: ShopifyValidationResultReason;
  message?: string | null;
  /** ID of the persisted `shopify_product_validation_log` row, when `ok: true`. */
  logId?: string | null;
  shopify?: ShopifyValidationProductSnapshot | null;
  dashboard?: ShopifyValidationDashboardSnapshot | null;
  mismatches?: ShopifyValidationMismatch[] | null;
}

export type ShopifyDefinitionStatusStatus = typeof ShopifyDefinitionStatusStatus[keyof typeof ShopifyDefinitionStatusStatus];


export const ShopifyDefinitionStatusStatus = {
  available: 'available',
  missing: 'missing',
  incompatible: 'incompatible',
  disabled: 'disabled',
} as const;

export interface ShopifyDefinitionStatus {
  namespace: string;
  key: string;
  type: string;
  label: string;
  status: ShopifyDefinitionStatusStatus;
  /** @nullable */
  actualType?: string | null;
  /** @nullable */
  reason?: string | null;
}

/**
 * @nullable
 */
export type ShopifyDefinitionValidationResultReason = typeof ShopifyDefinitionValidationResultReason[keyof typeof ShopifyDefinitionValidationResultReason] | null;


export const ShopifyDefinitionValidationResultReason = {
  not_configured: 'not_configured',
  error: 'error',
} as const;

export interface ShopifyDefinitionValidationResult {
  ok: boolean;
  /** @nullable */
  reason?: ShopifyDefinitionValidationResultReason;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  definitions?: ShopifyDefinitionStatus[] | null;
  /** @nullable */
  discoveredCount?: number | null;
  /** @nullable */
  refreshedAt?: string | null;
}

export interface ShopifyValidationRunSummary {
  id: string;
  sku?: string | null;
  shopifyProductId?: string | null;
  shopifyProductTitle?: string | null;
  mismatchCount: number;
  createdAt: string;
}

/**
 * How the mapping was created. `manual` = operator confirmed; `auto` = ≥85% on import; others = matcher strategy.
 */
export type TitleMappingSource = typeof TitleMappingSource[keyof typeof TitleMappingSource];


export const TitleMappingSource = {
  manual: 'manual',
  auto: 'auto',
  sku_in_title: 'sku_in_title',
  exact_title: 'exact_title',
  fuzzy: 'fuzzy',
  keyword: 'keyword',
  saved: 'saved',
} as const;

export interface TitleMapping {
  id: string;
  /** The original raw listing title from the source system. */
  rawTitle: string;
  /** Normalised form used by the matcher (lowercased */
  cleanedTitle: string;
  inventoryItemId: string;
  /** Snapshot of the inventory item's SKU at save time. */
  sku: string;
  /** Snapshot of the inventory item's product title at save time (joined for display). */
  productTitle: string;
  /**
     * Snapshot of the match confidence at save time (0–100).
     * @minimum 0
     * @maximum 100
     */
  confidence: number;
  /** How the mapping was created. `manual` = operator confirmed; `auto` = ≥85% on import; others = matcher strategy. */
  source: TitleMappingSource;
  createdAt: string;
}

/**
 * Delete every mapping with this source. Most common use is `auto` to clean up matcher pollution.
 */
export type TitleMappingsBulkDeleteRequestSource = typeof TitleMappingsBulkDeleteRequestSource[keyof typeof TitleMappingsBulkDeleteRequestSource];


export const TitleMappingsBulkDeleteRequestSource = {
  manual: 'manual',
  auto: 'auto',
  saved: 'saved',
  sku_in_title: 'sku_in_title',
  exact_title: 'exact_title',
  fuzzy: 'fuzzy',
  keyword: 'keyword',
} as const;

/**
 * Filter scope for bulk delete. At least one of `source` or a non-empty `ids` must be provided, or the request is rejected with 400.
 */
export interface TitleMappingsBulkDeleteRequest {
  /** Delete every mapping with this source. Most common use is `auto` to clean up matcher pollution. */
  source?: TitleMappingsBulkDeleteRequestSource;
  /** @maxItems 1000 */
  ids?: string[];
}

export interface TitleMappingsBulkDeleteResponse {
  /** Number of mappings actually removed. */
  deleted: number;
}

/**
 * Optional — defaults to "manual".
 */
export type TitleMappingCreateSource = typeof TitleMappingCreateSource[keyof typeof TitleMappingCreateSource];


export const TitleMappingCreateSource = {
  manual: 'manual',
  auto: 'auto',
  sku_in_title: 'sku_in_title',
  exact_title: 'exact_title',
  fuzzy: 'fuzzy',
  keyword: 'keyword',
} as const;

export interface TitleMappingCreate {
  /**
     * @minLength 1
     * @maxLength 500
     */
  rawTitle: string;
  inventoryItemId: string;
  /**
     * Optional — defaults to 100 when omitted (manual confirmation).
     * @minimum 0
     * @maximum 100
     */
  confidence?: number;
  /** Optional — defaults to "manual". */
  source?: TitleMappingCreateSource;
}

export type TitleMatchCandidateSource = typeof TitleMatchCandidateSource[keyof typeof TitleMatchCandidateSource];


export const TitleMatchCandidateSource = {
  saved: 'saved',
  sku_in_title: 'sku_in_title',
  exact_title: 'exact_title',
  fuzzy: 'fuzzy',
  keyword: 'keyword',
} as const;

export interface TitleMatchCandidate {
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  /**
     * @minimum 0
     * @maximum 100
     */
  confidence: number;
  source: TitleMatchCandidateSource;
}

export interface TitleMatchRequest {
  /**
     * @minLength 1
     * @maxLength 500
     */
  rawTitle: string;
  /**
     * @minimum 1
     * @maximum 20
     */
  limit?: number;
}

/**
 * Classification of the top candidate ≥85=auto, 60–85=review, <60=none.
 */
export type TitleMatchResponseBucket = typeof TitleMatchResponseBucket[keyof typeof TitleMatchResponseBucket];


export const TitleMatchResponseBucket = {
  auto: 'auto',
  review: 'review',
  none: 'none',
} as const;

export type QuantityMultiplierSource = typeof QuantityMultiplierSource[keyof typeof QuantityMultiplierSource] | null;


export const QuantityMultiplierSource = {
  lot_of: 'lot_of',
  bundle_of: 'bundle_of',
  pack_of: 'pack_of',
  set_of: 'set_of',
  qty_label: 'qty_label',
  n_x: 'n_x',
  x_n: 'x_n',
} as const;

export interface QuantityMultiplier {
  /**
     * Detected per-purchase quantity. 1 = no multiplier found.
     * @minimum 1
     */
  quantity: number;
  source?: QuantityMultiplierSource;
  /** The exact substring of the raw title that matched the multiplier pattern. */
  matchedText?: string | null;
}

export interface TitleMatchResponse {
  rawTitle: string;
  cleanedTitle: string;
  candidates: TitleMatchCandidate[];
  multiplier: QuantityMultiplier;
  /** Classification of the top candidate ≥85=auto, 60–85=review, <60=none. */
  bucket?: TitleMatchResponseBucket;
}

export interface SystemHealthAuditSummary {
  total: number;
  critical: number;
  warning: number;
  info: number;
}

export interface SystemHealthAuditByArea {
  area: string;
  summary: SystemHealthAuditSummary;
}

export interface SystemHealthAudit {
  ok: boolean;
  generatedAt: string;
  total: SystemHealthAuditSummary;
  byArea: SystemHealthAuditByArea[];
}

/**
 * Per-tenant time-since-last-successful-sync snapshot for this tick (Task
 */
export type SystemHealthSchedulerTickTenantLag = {
  /** Number of tenants with at least one recorded successful sync. */
  trackedTenants: number;
  /** Worst (largest) time-since-last-success across tracked tenants, ms. */
  maxMs: number | null;
  /** Average time-since-last-success across tracked tenants, ms. */
  avgMs: number | null;
} | null;

export interface SystemHealthSchedulerTick {
  lastAttemptAt: string | null;
  lastSuccessAt: string | null;
  lastError: string | null;
  consecutiveFailures: number;
  /** Per-tenant failure count from the most recently completed pass. 0 = clean pass; positive = partial pass (some tenants errored). lastSuccessAt is only advanced on a clean (0-failure) pass. Present only on the reconcile tick. */
  tenantFailures?: number | null;
  /** Wall-clock duration (ms) of the most recently completed tick cycle (Task */
  lastCycleDurationMs?: number | null;
  /** Timestamp the most recent tick cycle finished (Task */
  lastCycleCompletedAt?: string | null;
  /** Per-tenant time-since-last-successful-sync snapshot for this tick (Task */
  tenantLag?: SystemHealthSchedulerTickTenantLag;
}

export interface SystemHealthScheduler {
  /** eBay/social main scheduler tick (ms). */
  mainTickIntervalMs: number;
  /** Dedicated Shopify tick (ms). */
  shopifyTickIntervalMs: number;
  /** Stock reconcile sweep tick (ms). */
  reconcileTickIntervalMs: number;
  main: SystemHealthSchedulerTick;
  shopify: SystemHealthSchedulerTick;
  /** Stock reconcile sweep heartbeat. tenantFailures > 0 indicates a partial pass. */
  reconcile: SystemHealthSchedulerTick;
}

/**
 * Tenant DB pool registry status (Task
 */
export interface SystemHealthPool {
  /** Currently-open per-tenant pools. */
  size: number;
  /** Configured cap (TENANT_POOL_MAX_POOLS). */
  maxPools: number;
  /** size / maxPools, 0-1. */
  utilization: number;
  /** Lifetime LRU evictions since process start. */
  evictionsTotal: number;
  /** LRU evictions in the trailing 60 minutes. */
  evictionsLastHour: number;
}

/**
 * Rate-limiter Redis-fallback status (Task
 */
export interface SystemHealthRateLimiter {
  /** Whether REDIS_URL is set. */
  redisConfigured: boolean;
  /** True when currently serving from the per-replica memory fallback. */
  fallbackActive: boolean;
  /** Consecutive Redis errors since the last success. */
  consecutiveFailures: number;
  /** Lifetime count of Redis failures since process start. */
  totalFallbackEvents: number;
  lastFailureAt: string | null;
  lastFailureMessage: string | null;
}

/**
 * Background-jobs queue health (Task
 */
export interface SystemHealthBackgroundJobs {
  /** Jobs waiting to run (queued + retry_scheduled). */
  queueDepth: number;
  /** Jobs currently claimed or processing. */
  inFlight: number;
  /** Age of the oldest waiting job in seconds; null when the queue is empty. */
  oldestQueuedAgeSeconds: number | null;
  /** Active jobs that have already failed at least twice and are still retrying. */
  retryLoopCount: number;
  /** Total rows in the dead-letter table. */
  deadLetterTotal: number;
  /** Rows dead-lettered in the trailing 60 minutes. */
  deadLetterLastHour: number;
  /** ISO timestamp of the most recent dead-letter row; null when the table is empty. */
  lastDeadLetteredAt: string | null;
}

export interface SystemHealthIntegration {
  slug: string;
  displayName: string;
  configured: boolean;
  enabled: boolean;
  lastSyncedAt: string | null;
  /** Seconds since lastSyncedAt; null when never synced. Reflects "last order arrival", not scheduler liveness. */
  inactiveForSeconds: number | null;
}

export interface SystemHealthRecentImport {
  id: string;
  kind: string;
  filename: string;
  status: string;
  totalRows: number;
  successRows: number;
  failedRows: number;
  withIssuesRows: number;
  createdAt: string;
  createdBy: string | null;
}

export interface SystemHealthStockSyncJob {
  id: string;
  integrationSlug: string;
  kind: string;
  status: string;
  message: string | null;
  requestedItemCount: number;
  processedItemCount: number;
  createdAt: string;
  completedAt: string | null;
}

export interface SystemHealthExternalServices {
  gmailConnected: boolean;
  openaiConfigured: boolean;
  anthropicConfigured: boolean;
}

export interface SystemHealthDashboard {
  generatedAt: string;
  audit: SystemHealthAudit;
  scheduler: SystemHealthScheduler;
  integrations: SystemHealthIntegration[];
  recentImports: SystemHealthRecentImport[];
  unresolvedImportIssueCount: number;
  recentStockSyncJobs: SystemHealthStockSyncJob[];
  externalServices: SystemHealthExternalServices;
  pool?: SystemHealthPool;
  rateLimiter?: SystemHealthRateLimiter;
  backgroundJobs?: SystemHealthBackgroundJobs | null;
}

export interface OrderGroupHeader {
  id: string;
  ebayUsername?: string | null;
  /** ISO timestamp at the start of the UTC calendar day the group covers. */
  groupDate: string;
  totalOrders: number;
  totalPostagePaid: number;
}

export interface LinkedOrderSibling {
  id: string;
  orderNumber: string;
  channel: string;
  saleDate: string;
  shippingCharged: number;
  postageAllocated: number;
  isPrimaryPostageOrder: boolean;
  status: string;
  paymentStatus: string;
  /** Customer display name — populated for packing-job siblings so the card can show who each order belongs to. */
  customerName?: string | null;
}

export interface LinkedOrdersResponse {
  group?: OrderGroupHeader | null;
  siblings: LinkedOrderSibling[];
  /** ID of the packing job this order belongs to, if any. Use to link through to /packing/:id. */
  packingJobId?: string | null;
  /** Other orders sharing the same physical packing job (TikTok combined parcel or any merged job). Includes the current order so the UI can highlight it. Empty when the job contains only this order. */
  packingSiblings?: LinkedOrderSibling[];
}

export interface CustomerOrderRow {
  id: string;
  orderNumber: string;
  saleDate: string;
  channel: string;
  status: string;
  paymentStatus: string;
  itemCount: number;
  revenue: number;
  cost: number;
  shippingCharged: number;
  shippingCost: number;
  postageAllocated: number;
  platformFees: number;
  profit: number;
  margin: number;
  /** Output VAT (GBP) owed to HMRC on this order's sale lines (Task */
  outputVat?: number;
  /** profit minus outputVat. Parallel term — `profit` is unchanged. */
  vatAdjustedProfit?: number;
  /** True when any non-empty line on this order lacked a usable VAT treatment. */
  vatTreatmentFlagged?: boolean;
  isPrimaryPostageOrder: boolean;
  orderGroupId?: string | null;
  groupSiblingCount: number;
}

export interface CustomerOrdersHeadline {
  /** @minimum 0 */
  orderCount: number;
  /** @minimum 0 */
  itemCount: number;
  /** @nullable */
  spend: number | null;
  /** @nullable */
  trueProfit: number | null;
  /** @nullable */
  trueMargin: number | null;
  /** @nullable */
  outputVat: number | null;
  /** @nullable */
  vatAdjustedProfit: number | null;
  /** @nullable */
  vatAdjustedMargin: number | null;
  /** @minimum 0 */
  refundCount: number;
  /** @nullable */
  refundAmount: number | null;
  /** @minimum 0 */
  returnCount: number;
}

export interface CustomerOrderActionMetadata {
  canOpen: boolean;
  canTrack: boolean;
  canCancel: boolean;
  canRefund: boolean;
}

export interface CustomerOrdersWorkspaceOrder {
  id: string;
  orderNumber: string;
  saleDate: string;
  channel: string;
  status: string;
  paymentStatus: string;
  itemCount: number;
  /** @nullable */
  revenue: number | null;
  /** @nullable */
  cost: number | null;
  /** @nullable */
  shippingCharged: number | null;
  /** @nullable */
  shippingCost: number | null;
  /** @nullable */
  postageAllocated: number | null;
  /** @nullable */
  platformFees: number | null;
  /** @nullable */
  profit: number | null;
  /** @nullable */
  margin: number | null;
  /** @nullable */
  outputVat: number | null;
  /** @nullable */
  vatAdjustedProfit: number | null;
  vatTreatmentFlagged: boolean;
  isPrimaryPostageOrder: boolean;
  /** @nullable */
  orderGroupId?: string | null;
  groupSiblingCount: number;
  /** @nullable */
  trackingNumber: string | null;
  /** @nullable */
  shippingCarrier: string | null;
  /** @nullable */
  labelCarrier: string | null;
  /** @nullable */
  packedAt: string | null;
  /** @minimum 0 */
  refundCount: number;
  /** @nullable */
  refundAmount: number | null;
  /** @minimum 0 */
  returnCount: number;
  actionMetadata: CustomerOrderActionMetadata;
}

export interface CustomerOrdersPayload {
  headline: CustomerOrdersHeadline;
  orders: CustomerOrdersWorkspaceOrder[];
  /** @minimum 0 */
  total: number;
  /** @nullable */
  nextCursor: string | null;
}

export type CustomerOrdersExportStateStatus = typeof CustomerOrdersExportStateStatus[keyof typeof CustomerOrdersExportStateStatus];


export const CustomerOrdersExportStateStatus = {
  queued: 'queued',
  running: 'running',
  done: 'done',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type CustomerOrdersExportStateState = typeof CustomerOrdersExportStateState[keyof typeof CustomerOrdersExportStateState];


export const CustomerOrdersExportStateState = {
  preparing: 'preparing',
  ready: 'ready',
  failed: 'failed',
} as const;

export interface CustomerOrdersExportState {
  jobId: string;
  status: CustomerOrdersExportStateStatus;
  state: CustomerOrdersExportStateState;
}

export interface CustomerSpendingTrendBucket {
  /** @pattern ^\d{4}-\d{2}$ */
  month: string;
  /** @nullable */
  spend: number | null;
  /** @minimum 0 */
  orders: number;
  /** @nullable */
  profit: number | null;
  /** @nullable */
  vatAdjustedProfit: number | null;
}

export type CustomerCommercialInsightKind = typeof CustomerCommercialInsightKind[keyof typeof CustomerCommercialInsightKind];


export const CustomerCommercialInsightKind = {
  commercial: 'commercial',
} as const;

export interface CustomerCommercialInsight {
  code: string;
  kind: CustomerCommercialInsightKind;
  /** @nullable */
  channel?: string | null;
  /** @nullable */
  category?: string | null;
}

export type CustomerSpendingWorkspaceState = typeof CustomerSpendingWorkspaceState[keyof typeof CustomerSpendingWorkspaceState];


export const CustomerSpendingWorkspaceState = {
  ready: 'ready',
  stale: 'stale',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type CustomerSpendingWorkspaceRefunds = {
  /** @nullable */
  amount: number | null;
  /** @minimum 0 */
  count: number;
  /** @minimum 0 */
  adjustmentCount: number;
};

export type CustomerSpendingWorkspaceReturns = {
  /** @minimum 0 */
  count: number;
  /** @minimum 0 */
  rate: number;
};

export interface CustomerSpendingChannelMix {
  /** @nullable */
  spend: number | null;
  /** @minimum 0 */
  orders: number;
}

/**
 * @nullable
 */
export type CustomerSpendingWorkspaceChannelMix = {[key: string]: CustomerSpendingChannelMix} | null;

export type CustomerSpendingWorkspaceMetalMixItem = {
  metal: string;
  /** @nullable */
  spend: number | null;
  /** @minimum 0 */
  orders: number;
};

export interface CustomerSpendingFreshness {
  state: string;
  /** @nullable */
  asOf: string | null;
  /** @nullable */
  staleSince: string | null;
}

export interface CustomerSpendingCategoryMix {
  category: string;
  /** @nullable */
  spend: number | null;
  /** @minimum 0 */
  orders: number;
}

export interface CustomerSpendingWorkspace {
  customerId: string;
  state: CustomerSpendingWorkspaceState;
  freshness: CustomerSpendingFreshness;
  /** @nullable */
  lifetimeSpend: number | null;
  /** @nullable */
  lifetimeTrueProfit: number | null;
  /** @nullable */
  trueMarginPct: number | null;
  /** @nullable */
  averageOrderValue: number | null;
  /** @minimum 0 */
  orderCount: number;
  /** @nullable */
  vatAdjustedTrueProfit: number | null;
  /** @nullable */
  vatAdjustedMarginPct: number | null;
  vatTreatmentFlagged: boolean;
  refunds: CustomerSpendingWorkspaceRefunds;
  returns: CustomerSpendingWorkspaceReturns;
  /** @maxItems 12 */
  trend: CustomerSpendingTrendBucket[];
  /** @nullable */
  categoryMix: CustomerSpendingCategoryMix[] | null;
  /** @nullable */
  channelMix: CustomerSpendingWorkspaceChannelMix;
  metalMix: CustomerSpendingWorkspaceMetalMixItem[];
  commercialInsights: CustomerCommercialInsight[];
  /** @nullable */
  jobId?: string | null;
}

export type CustomerSpendingPreparingState = typeof CustomerSpendingPreparingState[keyof typeof CustomerSpendingPreparingState];


export const CustomerSpendingPreparingState = {
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export interface CustomerSpendingPreparing {
  error: string;
  state: CustomerSpendingPreparingState;
  freshness: CustomerSpendingFreshness;
  jobId: string;
  retryAfterSeconds?: number;
}

export interface CommonPurchase {
  inventoryItemId: string;
  sku?: string | null;
  productTitle: string;
  totalQuantity: number;
  totalSpend: number;
  orderCount: number;
}

export interface ChannelBreakdown {
  channel: string;
  orderCount: number;
  revenue: number;
}

export interface CustomerAnalytics {
  revenue: number;
  cost: number;
  postagePaid: number;
  shippingCost: number;
  platformFees: number;
  profit: number;
  margin: number;
  /** Total output VAT (GBP) owed to HMRC across this customer's sale lines (Task */
  outputVat?: number;
  /** profit minus outputVat. Parallel term — `profit` is unchanged. */
  vatAdjustedProfit?: number;
  /** (vatAdjustedProfit / revenue) * 100. 0 when revenue is 0. */
  vatAdjustedMargin?: number;
  /** True when any non-empty line lacked a usable VAT treatment, so outputVat under-estimates. */
  vatTreatmentFlagged?: boolean;
  orderCount: number;
  itemCount: number;
  avgOrderValue: number;
  firstOrderDate?: string | null;
  lastOrderDate?: string | null;
  commonPurchases: CommonPurchase[];
  channelBreakdown: ChannelBreakdown[];
}

export type CustomerMessageChannel = typeof CustomerMessageChannel[keyof typeof CustomerMessageChannel];


export const CustomerMessageChannel = {
  email: 'email',
  sms: 'sms',
  whatsapp: 'whatsapp',
  portal: 'portal',
} as const;

/**
 * For a media-carrying SMS/WhatsApp send, which modality actually
 * reached the customer: `mms` / `whatsapp_media` = the image rode
 * inline; `text_link_fallback` = the carrier couldn't carry the image
 * so it fell back to a plain-text message with the image link. Null
 * when no media was attached, for email, or for older rows.
 */
export type CustomerMessageMediaDelivery = typeof CustomerMessageMediaDelivery[keyof typeof CustomerMessageMediaDelivery] | null;


export const CustomerMessageMediaDelivery = {
  mms: 'mms',
  whatsapp_media: 'whatsapp_media',
  text_link_fallback: 'text_link_fallback',
} as const;

export interface CustomerMessage {
  id: string;
  channel: CustomerMessageChannel;
  messageType: string;
  status: string;
  recipient: string;
  saleOrderId?: string | null;
  orderNumber?: string | null;
  error?: string | null;
  /**
     * For a media-carrying SMS/WhatsApp send, which modality actually
     * reached the customer: `mms` / `whatsapp_media` = the image rode
     * inline; `text_link_fallback` = the carrier couldn't carry the image
     * so it fell back to a plain-text message with the image link. Null
     * when no media was attached, for email, or for older rows.
     */
  mediaDelivery?: CustomerMessageMediaDelivery;
  createdAt: string;
  /**
     * Attachment URLs that were sent with this message (gallery media:
     * email inline, SMS MMS, WhatsApp media). Resolved via the tenant-public
     * / `/api/storage` conventions on the client. Empty when none.
     */
  mediaUrls?: string[];
  /**
     * The message text, when carried inline on the row. Currently only set
     * for inbound `portal` messages (whose content lives nowhere else);
     * notification rows (email/sms/whatsapp) keep their body in `payload`
     * and omit this.
     */
  body?: string | null;
}

export interface CustomerMessagesPayload {
  messages: CustomerMessage[];
  /** Cursor for the next older page, or null when complete. */
  nextCursor: string | null;
}

/**
 * WhatsApp-only. When present, the message is sent via the tenant's
 * approved ad-hoc Content Template (the only way to reach a customer
 * outside the 24h window) instead of a free-form message. Keyed by
 * the template's placeholder name (e.g. `{ "1": "Jane" }`). Ignored
 * for email/SMS.
 */
export type CustomerMessageSendBodyWhatsappTemplateVariables = {[key: string]: string} | null;

export interface CustomerMessageSendBody {
  channel: CustomerMessageChannel;
  /**
     * Subject line. Used for email; ignored for SMS/WhatsApp.
     * @maxLength 200
     */
  subject?: string | null;
  /**
     * Plain-text message body. Required for email/SMS and free-form
     * WhatsApp; may be empty/omitted for a WhatsApp template send
     * (`whatsappTemplateVariables` present).
     * @maxLength 4000
     */
  body?: string;
  /**
     * WhatsApp-only. When present, the message is sent via the tenant's
     * approved ad-hoc Content Template (the only way to reach a customer
     * outside the 24h window) instead of a free-form message. Keyed by
     * the template's placeholder name (e.g. `{ "1": "Jane" }`). Ignored
     * for email/SMS.
     */
  whatsappTemplateVariables?: CustomerMessageSendBodyWhatsappTemplateVariables;
}

export interface CustomerMessageSendResult {
  sent: boolean;
  channel: CustomerMessageChannel;
  /** Machine-readable failure reason when sent=false (no_email|no_phone|not_configured|no_sender|no_template|outside_window|error). */
  reason?: string | null;
  /** Human-readable detail (failure reason or provider error). */
  message?: string | null;
  /** Id of the notification-log row written for this attempt. */
  logId?: string | null;
  /** Underlying provider message id/SID on success. */
  providerMessageId?: string | null;
}

export interface CustomerMessagingCapabilities {
  /** Twilio credentials are present for the tenant. */
  twilioConfigured: boolean;
  /** Saved Twilio credentials have been flagged invalid (auth failure). */
  credentialsInvalid: boolean;
  /** A usable SMS sender (from-number or Messaging Service SID) is configured. */
  smsConfigured: boolean;
  /** A WhatsApp sender phone is configured. Never returns the number itself. */
  whatsappSenderConfigured: boolean;
  /** An approved ad-hoc WhatsApp template SID is configured, so out-of-window template sends are possible. */
  whatsappTemplateConfigured: boolean;
}

export type CustomerWhatsappTemplateVariablesItem = {
  /** Placeholder name as it appears in the template (e.g. "1", "name"). */
  key: string;
  /** Sample value Twilio stored at create time ("" when none) — used as a placeholder hint. */
  sample: string;
};

export interface CustomerWhatsappTemplate {
  /** True when a usable ad-hoc WhatsApp template (sender + template SID) is configured. */
  configured: boolean;
  /** The approved Content Template SID (HX...) when configured, else null. */
  contentSid?: string | null;
  /** Ordered placeholders the template declares; one input each in the Send Message dialog. */
  variables: CustomerWhatsappTemplateVariablesItem[];
}

/**
 * Filled placeholder values keyed by the template placeholder name (e.g. "1").
 */
export type CustomerWhatsappTemplatePresetVariables = {[key: string]: string};

export interface CustomerWhatsappTemplatePreset {
  /** Stable preset id. */
  id: string;
  /** Operator-chosen label for the scenario (e.g. "Order delayed"). */
  name: string;
  /** Filled placeholder values keyed by the template placeholder name (e.g. "1"). */
  variables: CustomerWhatsappTemplatePresetVariables;
  /** ISO timestamp the preset was saved. */
  createdAt: string;
}

/**
 * Filled placeholder values keyed by the template placeholder name.
 */
export type CustomerWhatsappTemplatePresetInputVariables = {[key: string]: string};

export interface CustomerWhatsappTemplatePresetInput {
  /**
     * Operator-chosen label for the scenario.
     * @minLength 1
     * @maxLength 80
     */
  name: string;
  /** Filled placeholder values keyed by the template placeholder name. */
  variables: CustomerWhatsappTemplatePresetInputVariables;
}

export interface CustomerWhatsappTemplatePresetRenameInput {
  /**
     * New operator-chosen label for the preset.
     * @minLength 1
     * @maxLength 80
     */
  name: string;
}

export interface CustomerWhatsappTemplatePresetReorderInput {
  /**
     * Every existing preset id in the desired display order. Unknown ids
     * are ignored; any omitted ids are appended in their previous order.
     */
  orderedIds: string[];
}

export interface CustomerWhatsappTemplatePresetsPayload {
  presets: CustomerWhatsappTemplatePreset[];
}

export type CustomerNoteType = typeof CustomerNoteType[keyof typeof CustomerNoteType];


export const CustomerNoteType = {
  NOTE: 'NOTE',
  ISSUE: 'ISSUE',
  WARNING: 'WARNING',
} as const;

export interface OrderInternalNote {
  id: string;
  saleOrderId: string;
  body: string;
  pinned: boolean;
  /**
     * Optimistic-concurrency version; increases on every edit/pin.
     * @minimum 1
     */
  version: number;
  createdByUserId?: string | null;
  createdByEmail?: string | null;
  updatedByUserId?: string | null;
  updatedByEmail?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OrderInternalNoteCreateInput {
  /**
     * @minLength 1
     * @maxLength 10000
     */
  body: string;
  pinned?: boolean;
  /** @maxLength 160 */
  idempotencyKey?: string;
}

export interface OrderInternalNoteUpdateInput {
  /**
     * @minLength 1
     * @maxLength 10000
     */
  body?: string;
  pinned?: boolean;
  /** @minimum 1 */
  expectedVersion: number;
}

export interface OrderInternalNotesPage {
  items: OrderInternalNote[];
  total: number;
  limit: number;
  offset: number;
}

export type CustomerOverviewStateStatus = typeof CustomerOverviewStateStatus[keyof typeof CustomerOverviewStateStatus];


export const CustomerOverviewStateStatus = {
  available: 'available',
  unavailable: 'unavailable',
  redacted: 'redacted',
} as const;

export interface CustomerOverviewState {
  status: CustomerOverviewStateStatus;
  reason: string | null;
}

export type CustomerOverviewIdentity = CustomerOverviewState & {
  canonicalCustomerId?: string;
  reportingCustomerIds?: string[];
};

export type CustomerOverviewProfile = {
  customerType: string | null;
  tier: string | null;
  customerSince: string | null;
};

export type CustomerOverviewSummary = CustomerOverviewState & ({
  orderCount?: number | null;
  lifetimeSpend?: number | null;
  averageOrderValue?: number | null;
  lifetimeProfit?: number | null;
  firstOrderAt?: string | null;
  lastOrderAt?: string | null;
  returnRate?: number | null;
});

export type CustomerOverviewChannelMixChannelsItem = {
  channel: string;
  orderCount: number;
  revenue: number | null;
  lastOrderAt: string | null;
};

export type CustomerOverviewChannelMix = CustomerOverviewState & {
  channels?: CustomerOverviewChannelMixChannelsItem[];
};

export type CustomerOverviewReturns = CustomerOverviewState & ({
  count?: number | null;
  refundAmount?: number | null;
});

export type CustomerOverviewOutstandingBalance = CustomerOverviewState & ({
  balance?: number | null;
  orderCount?: number | null;
});

export interface CustomerOverview {
  customerId: string;
  canonicalCustomerId: string;
  reportingCustomerIds: string[];
  identity: CustomerOverviewIdentity;
  profile: CustomerOverviewProfile;
  summary: CustomerOverviewSummary;
  channelMix: CustomerOverviewChannelMix;
  returns: CustomerOverviewReturns;
  outstandingBalance: CustomerOverviewOutstandingBalance;
}

export type CustomerActivityCategory = typeof CustomerActivityCategory[keyof typeof CustomerActivityCategory];


export const CustomerActivityCategory = {
  order: 'order',
  invoice: 'invoice',
  payment: 'payment',
  refund: 'refund',
  return: 'return',
  message: 'message',
  incident: 'incident',
  note: 'note',
  task: 'task',
  address: 'address',
  flag: 'flag',
  identity: 'identity',
  merge: 'merge',
  audit: 'audit',
  commerce: 'commerce',
} as const;

export interface CustomerActivityItem {
  id: string;
  category: CustomerActivityCategory;
  occurredAt: string | null;
  label: string;
  detail: string | null;
  status: string | null;
  recordUrl: string | null;
}

export type CustomerActivityPageState = typeof CustomerActivityPageState[keyof typeof CustomerActivityPageState];


export const CustomerActivityPageState = {
  ready: 'ready',
} as const;

export interface CustomerActivityPage {
  items: CustomerActivityItem[];
  nextCursor: string | null;
  state: CustomerActivityPageState;
}

export interface CustomerNoteInput {
  type: CustomerNoteType;
  /**
     * @minLength 1
     * @maxLength 4000
     */
  note: string;
}

export interface CustomerNote {
  id: string;
  customerId: string;
  type: CustomerNoteType;
  note: string;
  userId?: string | null;
  userName?: string | null;
  createdAt: string;
}

export interface CustomerNotesPayload {
  notes: CustomerNote[];
  total: number;
  hasMore: boolean;
  limit: number;
  offset: number;
}

export interface RegroupOrdersResult {
  groupsTouched: number;
  ordersTouched: number;
}

export interface OkResult {
  ok: boolean;
}

export type WorkflowConditionOp = typeof WorkflowConditionOp[keyof typeof WorkflowConditionOp];


export const WorkflowConditionOp = {
  eq: 'eq',
  neq: 'neq',
  gt: 'gt',
  gte: 'gte',
  lt: 'lt',
  lte: 'lte',
  contains: 'contains',
  in: 'in',
} as const;

export interface WorkflowCondition {
  field: string;
  op: WorkflowConditionOp;
  value?: unknown;
}

export type WorkflowActionType = typeof WorkflowActionType[keyof typeof WorkflowActionType];


export const WorkflowActionType = {
  send_email: 'send_email',
} as const;

export interface WorkflowAction {
  type: WorkflowActionType;
  to: string;
  templateKey: string;
  cc?: string | null;
  bcc?: string | null;
}

export type WorkflowTriggerType = typeof WorkflowTriggerType[keyof typeof WorkflowTriggerType];


export const WorkflowTriggerType = {
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_STATUS_CHANGED: 'ORDER_STATUS_CHANGED',
  STOCK_LEVEL_CHANGED: 'STOCK_LEVEL_CHANGED',
} as const;

export interface Workflow {
  id: string;
  name: string;
  triggerType: WorkflowTriggerType;
  conditions: WorkflowCondition[];
  actions: WorkflowAction[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export type WorkflowInputTriggerType = typeof WorkflowInputTriggerType[keyof typeof WorkflowInputTriggerType];


export const WorkflowInputTriggerType = {
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_STATUS_CHANGED: 'ORDER_STATUS_CHANGED',
  STOCK_LEVEL_CHANGED: 'STOCK_LEVEL_CHANGED',
} as const;

export interface WorkflowInput {
  name?: string;
  triggerType?: WorkflowInputTriggerType;
  conditions?: WorkflowCondition[];
  actions?: WorkflowAction[];
  isActive?: boolean;
}

export type WorkflowRunPayload = { [key: string]: unknown };

export type WorkflowRunStatus = typeof WorkflowRunStatus[keyof typeof WorkflowRunStatus];


export const WorkflowRunStatus = {
  matched: 'matched',
  skipped: 'skipped',
  success: 'success',
  error: 'error',
} as const;

export type WorkflowRunExecutedActionsItem = { [key: string]: unknown };

export interface WorkflowRun {
  id: string;
  workflowId: string;
  triggerType: string;
  payload?: WorkflowRunPayload;
  status: WorkflowRunStatus;
  error?: string | null;
  executedActions?: WorkflowRunExecutedActionsItem[];
  createdAt: string;
}

export type WorkflowTestInputPayload = { [key: string]: unknown };

export interface WorkflowTestInput {
  payload?: WorkflowTestInputPayload;
}

export type WorkflowTestResultExecutedItem = { [key: string]: unknown };

export interface WorkflowTestResult {
  matched: boolean;
  executed: WorkflowTestResultExecutedItem[];
  error?: string | null;
}

export type EmailTemplateType = typeof EmailTemplateType[keyof typeof EmailTemplateType];


export const EmailTemplateType = {
  ORDER_UPDATE: 'ORDER_UPDATE',
  INVOICE: 'INVOICE',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  MARKETING: 'MARKETING',
  TRANSACTIONAL: 'TRANSACTIONAL',
  CUSTOM: 'CUSTOM',
} as const;

export type EmailTemplateNumberedVariables = {[key: string]: string};

export interface EmailTemplate {
  id: string;
  key: string;
  name: string;
  type?: EmailTemplateType;
  category?: string | null;
  subject: string;
  previewText?: string | null;
  bodyHtml: string;
  bodyText?: string | null;
  isDefault?: boolean;
  archived?: boolean;
  numberedVariables?: EmailTemplateNumberedVariables;
  createdAt: string;
  updatedAt: string;
}

export type EmailTemplateInputType = typeof EmailTemplateInputType[keyof typeof EmailTemplateInputType];


export const EmailTemplateInputType = {
  ORDER_UPDATE: 'ORDER_UPDATE',
  INVOICE: 'INVOICE',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  MARKETING: 'MARKETING',
  TRANSACTIONAL: 'TRANSACTIONAL',
  CUSTOM: 'CUSTOM',
} as const;

export type EmailTemplateInputNumberedVariables = {[key: string]: string};

export interface EmailTemplateInput {
  key?: string;
  name?: string;
  type?: EmailTemplateInputType;
  category?: string | null;
  subject?: string;
  previewText?: string | null;
  bodyHtml?: string;
  bodyText?: string | null;
  isDefault?: boolean;
  archived?: boolean;
  numberedVariables?: EmailTemplateInputNumberedVariables;
}

export interface SmtpSettingsInput {
  host: string;
  port: number;
  user: string;
  pass: string;
  fromEmail?: string | null;
  fromName?: string | null;
  secure?: boolean | null;
}

export interface SmtpSettingsRedacted {
  host?: string;
  port?: number;
  user?: string;
  fromEmail?: string | null;
  fromName?: string | null;
  secure?: boolean | null;
  hasPassword?: boolean;
  updatedAt?: string;
}

export type RecalculateCostsInputScope = typeof RecalculateCostsInputScope[keyof typeof RecalculateCostsInputScope];


export const RecalculateCostsInputScope = {
  unsold_only: 'unsold_only',
  open: 'open',
  all: 'all',
} as const;

export interface RecalculateCostsInput {
  scope: RecalculateCostsInputScope;
  dryRun?: boolean;
  reason?: string | null;
}

export interface InventoryCostDelta {
  inventoryItemId?: string;
  sku?: string | null;
  productTitle?: string | null;
  purchaseOrderItemId?: string;
  oldLandedUnitCost?: number;
  newLandedUnitCost?: number;
  costDelta?: number;
  quantity?: number;
}

export type RecalcLineDetailStatus = typeof RecalcLineDetailStatus[keyof typeof RecalcLineDetailStatus];


export const RecalcLineDetailStatus = {
  'would-update': 'would-update',
  updated: 'updated',
  skipped: 'skipped',
  unchanged: 'unchanged',
} as const;

export interface RecalcLineDetail {
  lineId?: string;
  saleOrderId?: string;
  orderNumber?: string;
  productTitle?: string;
  quantity?: number;
  oldUnitCost?: number;
  newUnitCost?: number;
  oldLineCost?: number;
  newLineCost?: number;
  oldLineProfit?: number;
  newLineProfit?: number;
  status?: RecalcLineDetailStatus;
  skipReason?: string | null;
}

export interface SaleRecalcSummary {
  inventoryItemId?: string;
  sku?: string | null;
  productTitle?: string | null;
  scope?: string;
  dryRun?: boolean;
  reason?: string | null;
  found?: number;
  eligible?: number;
  updated?: number;
  skipped?: number;
  unchanged?: number;
  oldTotalCostGbp?: number;
  newTotalCostGbp?: number;
  oldTotalProfitGbp?: number;
  newTotalProfitGbp?: number;
  differenceGbp?: number;
  lines?: RecalcLineDetail[];
}

export interface PoRecalcResult {
  purchaseOrderId?: string;
  poNumber?: string | null;
  scope?: string;
  dryRun?: boolean;
  reason?: string | null;
  inventoryItemsFound?: number;
  inventoryItemsChanged?: number;
  totalCostAdded?: number;
  saleLinesFound?: number;
  saleLinesEligible?: number;
  saleLinesUpdated?: number;
  saleLinesSkipped?: number;
  saleLinesUnchanged?: number;
  oldTotalSaleCostGbp?: number;
  newTotalSaleCostGbp?: number;
  oldTotalSaleProfitGbp?: number;
  newTotalSaleProfitGbp?: number;
  profitDeltaGbp?: number;
  inventoryDeltas?: InventoryCostDelta[];
  saleRecalcSummaries?: SaleRecalcSummary[];
}

export type QuickBooksStatusStatus = typeof QuickBooksStatusStatus[keyof typeof QuickBooksStatusStatus];


export const QuickBooksStatusStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
} as const;

export interface QuickBooksStatus {
  status: QuickBooksStatusStatus;
  connected: boolean;
  credentialsConfigured: boolean;
  realmId?: string | null;
  companyName?: string | null;
  environment?: string | null;
  connectedAt?: string | null;
  connectedBy?: string | null;
  tokenExpiresAt?: string | null;
  lastRefreshedAt?: string | null;
  lastError?: string | null;
  lastSyncAt?: string | null;
}

export type QuickBooksSettingsSyncMode = typeof QuickBooksSettingsSyncMode[keyof typeof QuickBooksSettingsSyncMode];


export const QuickBooksSettingsSyncMode = {
  per_order: 'per_order',
  daily_summary: 'daily_summary',
  marketplace_summary: 'marketplace_summary',
  monthly_summary: 'monthly_summary',
} as const;

export type QuickBooksSettingsSalesDocType = typeof QuickBooksSettingsSalesDocType[keyof typeof QuickBooksSettingsSalesDocType];


export const QuickBooksSettingsSalesDocType = {
  sales_receipt: 'sales_receipt',
  invoice_payment: 'invoice_payment',
  journal: 'journal',
} as const;

export type QuickBooksSettingsSyncFrequency = typeof QuickBooksSettingsSyncFrequency[keyof typeof QuickBooksSettingsSyncFrequency];


export const QuickBooksSettingsSyncFrequency = {
  MANUAL: 'MANUAL',
  EVERY_5_MINUTES: 'EVERY_5_MINUTES',
  EVERY_15_MINUTES: 'EVERY_15_MINUTES',
  EVERY_30_MINUTES: 'EVERY_30_MINUTES',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
} as const;

export type QuickBooksSettingsItemSyncMode = typeof QuickBooksSettingsItemSyncMode[keyof typeof QuickBooksSettingsItemSyncMode];


export const QuickBooksSettingsItemSyncMode = {
  sync_items: 'sync_items',
  sku_only: 'sku_only',
  generic_item: 'generic_item',
} as const;

export type QuickBooksSettingsItemType = typeof QuickBooksSettingsItemType[keyof typeof QuickBooksSettingsItemType];


export const QuickBooksSettingsItemType = {
  inventory: 'inventory',
  non_inventory: 'non_inventory',
  service: 'service',
} as const;

export type QuickBooksSettingsCustomerSyncMode = typeof QuickBooksSettingsCustomerSyncMode[keyof typeof QuickBooksSettingsCustomerSyncMode];


export const QuickBooksSettingsCustomerSyncMode = {
  individual: 'individual',
  generic: 'generic',
  anonymised: 'anonymised',
} as const;

export type QuickBooksSettingsCustomerMatchStrategy = typeof QuickBooksSettingsCustomerMatchStrategy[keyof typeof QuickBooksSettingsCustomerMatchStrategy];


export const QuickBooksSettingsCustomerMatchStrategy = {
  email: 'email',
  marketplace_id: 'marketplace_id',
  ebay_username: 'ebay_username',
  qbo_id: 'qbo_id',
} as const;

export interface QuickBooksSettings {
  syncMode: QuickBooksSettingsSyncMode;
  salesDocType: QuickBooksSettingsSalesDocType;
  autoSyncEnabled: boolean;
  syncFrequency: QuickBooksSettingsSyncFrequency;
  /** Channel names eligible for scheduled auto-sync. Empty = all channels (preserves the original behaviour). */
  autoSyncChannels?: string[];
  vatRegistered: boolean;
  pricesIncludeVat: boolean;
  itemSyncMode: QuickBooksSettingsItemSyncMode;
  itemType: QuickBooksSettingsItemType;
  customerSyncMode: QuickBooksSettingsCustomerSyncMode;
  customerMatchStrategy: QuickBooksSettingsCustomerMatchStrategy;
  genericCustomerName?: string | null;
  syncRefunds: boolean;
  lastSyncAt?: string | null;
}

export type QuickBooksSettingsUpdateSyncMode = typeof QuickBooksSettingsUpdateSyncMode[keyof typeof QuickBooksSettingsUpdateSyncMode];


export const QuickBooksSettingsUpdateSyncMode = {
  per_order: 'per_order',
  daily_summary: 'daily_summary',
  marketplace_summary: 'marketplace_summary',
  monthly_summary: 'monthly_summary',
} as const;

export type QuickBooksSettingsUpdateSalesDocType = typeof QuickBooksSettingsUpdateSalesDocType[keyof typeof QuickBooksSettingsUpdateSalesDocType];


export const QuickBooksSettingsUpdateSalesDocType = {
  sales_receipt: 'sales_receipt',
  invoice_payment: 'invoice_payment',
  journal: 'journal',
} as const;

export type QuickBooksSettingsUpdateSyncFrequency = typeof QuickBooksSettingsUpdateSyncFrequency[keyof typeof QuickBooksSettingsUpdateSyncFrequency];


export const QuickBooksSettingsUpdateSyncFrequency = {
  MANUAL: 'MANUAL',
  EVERY_5_MINUTES: 'EVERY_5_MINUTES',
  EVERY_15_MINUTES: 'EVERY_15_MINUTES',
  EVERY_30_MINUTES: 'EVERY_30_MINUTES',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
} as const;

export type QuickBooksSettingsUpdateItemSyncMode = typeof QuickBooksSettingsUpdateItemSyncMode[keyof typeof QuickBooksSettingsUpdateItemSyncMode];


export const QuickBooksSettingsUpdateItemSyncMode = {
  sync_items: 'sync_items',
  sku_only: 'sku_only',
  generic_item: 'generic_item',
} as const;

export type QuickBooksSettingsUpdateItemType = typeof QuickBooksSettingsUpdateItemType[keyof typeof QuickBooksSettingsUpdateItemType];


export const QuickBooksSettingsUpdateItemType = {
  inventory: 'inventory',
  non_inventory: 'non_inventory',
  service: 'service',
} as const;

export type QuickBooksSettingsUpdateCustomerSyncMode = typeof QuickBooksSettingsUpdateCustomerSyncMode[keyof typeof QuickBooksSettingsUpdateCustomerSyncMode];


export const QuickBooksSettingsUpdateCustomerSyncMode = {
  individual: 'individual',
  generic: 'generic',
  anonymised: 'anonymised',
} as const;

export type QuickBooksSettingsUpdateCustomerMatchStrategy = typeof QuickBooksSettingsUpdateCustomerMatchStrategy[keyof typeof QuickBooksSettingsUpdateCustomerMatchStrategy];


export const QuickBooksSettingsUpdateCustomerMatchStrategy = {
  email: 'email',
  marketplace_id: 'marketplace_id',
  ebay_username: 'ebay_username',
  qbo_id: 'qbo_id',
} as const;

export interface QuickBooksSettingsUpdate {
  syncMode?: QuickBooksSettingsUpdateSyncMode;
  salesDocType?: QuickBooksSettingsUpdateSalesDocType;
  autoSyncEnabled?: boolean;
  syncFrequency?: QuickBooksSettingsUpdateSyncFrequency;
  /** Channel names eligible for scheduled auto-sync. Empty = all channels (preserves the original behaviour). */
  autoSyncChannels?: string[];
  vatRegistered?: boolean;
  pricesIncludeVat?: boolean;
  itemSyncMode?: QuickBooksSettingsUpdateItemSyncMode;
  itemType?: QuickBooksSettingsUpdateItemType;
  customerSyncMode?: QuickBooksSettingsUpdateCustomerSyncMode;
  customerMatchStrategy?: QuickBooksSettingsUpdateCustomerMatchStrategy;
  genericCustomerName?: string | null;
  syncRefunds?: boolean;
}

export interface QboRef {
  id: string;
  name: string;
  type?: string | null;
  active?: boolean | null;
  rate?: number | null;
}

export type QuickBooksAccountMappingAccountKey = typeof QuickBooksAccountMappingAccountKey[keyof typeof QuickBooksAccountMappingAccountKey];


export const QuickBooksAccountMappingAccountKey = {
  sales_income: 'sales_income',
  postage_income: 'postage_income',
  marketplace_fees: 'marketplace_fees',
  payment_account: 'payment_account',
  refund_account: 'refund_account',
  inventory_asset: 'inventory_asset',
  cogs: 'cogs',
  rounding: 'rounding',
  vat_control: 'vat_control',
} as const;

export interface QuickBooksAccountMapping {
  accountKey: QuickBooksAccountMappingAccountKey;
  qboAccountId: string;
  qboAccountName?: string | null;
}

export type QuickBooksTaxMappingTaxCode = typeof QuickBooksTaxMappingTaxCode[keyof typeof QuickBooksTaxMappingTaxCode];


export const QuickBooksTaxMappingTaxCode = {
  standard: 'standard',
  reduced: 'reduced',
  zero_rated: 'zero_rated',
  exempt: 'exempt',
  reverse_charge: 'reverse_charge',
  non_vat: 'non_vat',
} as const;

export interface QuickBooksTaxMapping {
  taxCode: QuickBooksTaxMappingTaxCode;
  qboTaxCodeId: string;
  qboTaxCodeName?: string | null;
  ratePercent?: string | null;
  inclusive?: boolean | null;
}

export interface QuickBooksMappings {
  accounts: QuickBooksAccountMapping[];
  taxes: QuickBooksTaxMapping[];
}

export interface QuickBooksMappingsUpdate {
  accounts?: QuickBooksAccountMapping[];
  taxes?: QuickBooksTaxMapping[];
}

export type QuickBooksSyncLogRecordType = typeof QuickBooksSyncLogRecordType[keyof typeof QuickBooksSyncLogRecordType];


export const QuickBooksSyncLogRecordType = {
  sale: 'sale',
  refund: 'refund',
  cancellation: 'cancellation',
  return: 'return',
  chargeback: 'chargeback',
  summary: 'summary',
  payout: 'payout',
} as const;

export type QuickBooksSyncLogTriggerType = typeof QuickBooksSyncLogTriggerType[keyof typeof QuickBooksSyncLogTriggerType];


export const QuickBooksSyncLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
} as const;

export type QuickBooksSyncLogStatus = typeof QuickBooksSyncLogStatus[keyof typeof QuickBooksSyncLogStatus];


export const QuickBooksSyncLogStatus = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface QuickBooksSyncLog {
  id: string;
  recordType: QuickBooksSyncLogRecordType;
  sourceRecordId?: string | null;
  triggerType: QuickBooksSyncLogTriggerType;
  triggeredBy?: string | null;
  syncMode?: string | null;
  qboEntityType?: string | null;
  qboEntityId?: string | null;
  status: QuickBooksSyncLogStatus;
  errorMessage?: string | null;
  amount?: string | null;
  vatAmount?: string | null;
  /** Number of sync attempts made for this record (initial push counts as 1). */
  attempts?: number;
  /** True when a FAILED sale record has used up its bounded auto-retry budget and will no longer retry on its own — it needs a manual retry. Only meaningful for sale records (refunds never auto-retry). */
  autoRetriesExhausted?: boolean;
  /** Cap on automatic retries before a failed sale gives up. */
  maxAutoRetries?: number;
  createdAt: string;
  updatedAt?: string;
}

export type DocumentTemplateStatus = typeof DocumentTemplateStatus[keyof typeof DocumentTemplateStatus];


export const DocumentTemplateStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const;

export type DocumentTemplateOutputFormat = typeof DocumentTemplateOutputFormat[keyof typeof DocumentTemplateOutputFormat];


export const DocumentTemplateOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export type DocumentTemplateMetadata = { [key: string]: unknown };

export interface DocumentTemplate {
  id: string;
  tenantId: string;
  templateGroupId: string;
  documentType: string;
  name: string;
  description?: string | null;
  version: number;
  isCurrent: boolean;
  status: DocumentTemplateStatus;
  outputFormat: DocumentTemplateOutputFormat;
  subject?: string | null;
  bodyHtml: string;
  metadata: DocumentTemplateMetadata;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type GeneratedDocumentOutputFormat = typeof GeneratedDocumentOutputFormat[keyof typeof GeneratedDocumentOutputFormat];


export const GeneratedDocumentOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export type GeneratedDocumentStatus = typeof GeneratedDocumentStatus[keyof typeof GeneratedDocumentStatus];


export const GeneratedDocumentStatus = {
  generated: 'generated',
  emailed: 'emailed',
  archived: 'archived',
  failed: 'failed',
} as const;

export type GeneratedDocumentBrandingSnapshot = { [key: string]: unknown } | null;

export type GeneratedDocumentVariablesSnapshot = { [key: string]: unknown } | null;

export type GeneratedDocumentMetadata = { [key: string]: unknown };

export interface GeneratedDocument {
  id: string;
  tenantId: string;
  templateId?: string | null;
  templateGroupId?: string | null;
  documentType: string;
  documentNumber?: string | null;
  title: string;
  sourceKind: string;
  sourceRecordId?: string | null;
  outputFormat: GeneratedDocumentOutputFormat;
  objectPath?: string | null;
  fileSize?: number | null;
  status: GeneratedDocumentStatus;
  brandingSnapshot?: GeneratedDocumentBrandingSnapshot;
  variablesSnapshot?: GeneratedDocumentVariablesSnapshot;
  metadata: GeneratedDocumentMetadata;
  generatedBy?: string | null;
  lastEmailedAt?: string | null;
  emailCount: number;
  createdAt: string;
  updatedAt: string;
}

export type DocumentGenerationLogAction = typeof DocumentGenerationLogAction[keyof typeof DocumentGenerationLogAction];


export const DocumentGenerationLogAction = {
  generate: 'generate',
  preview: 'preview',
  email: 'email',
  archive: 'archive',
  delete: 'delete',
} as const;

export type DocumentGenerationLogStatus = typeof DocumentGenerationLogStatus[keyof typeof DocumentGenerationLogStatus];


export const DocumentGenerationLogStatus = {
  success: 'success',
  failed: 'failed',
  pending: 'pending',
} as const;

export type DocumentGenerationLogTriggerType = typeof DocumentGenerationLogTriggerType[keyof typeof DocumentGenerationLogTriggerType];


export const DocumentGenerationLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
  system: 'system',
} as const;

export type DocumentGenerationLogMetadata = { [key: string]: unknown };

export interface DocumentGenerationLog {
  id: string;
  tenantId: string;
  documentId?: string | null;
  templateGroupId?: string | null;
  documentType?: string | null;
  action: DocumentGenerationLogAction;
  status: DocumentGenerationLogStatus;
  triggeredBy?: string | null;
  triggerType: DocumentGenerationLogTriggerType;
  sourceKind?: string | null;
  sourceRecordId?: string | null;
  message?: string | null;
  errorMessage?: string | null;
  metadata: DocumentGenerationLogMetadata;
  createdAt: string;
}

export type DocumentAutoRuleTrigger = typeof DocumentAutoRuleTrigger[keyof typeof DocumentAutoRuleTrigger];


export const DocumentAutoRuleTrigger = {
  sale_finalised: 'sale_finalised',
  order_packed: 'order_packed',
  return_processed: 'return_processed',
} as const;

export type DocumentAutoRuleOutputFormat = typeof DocumentAutoRuleOutputFormat[keyof typeof DocumentAutoRuleOutputFormat];


export const DocumentAutoRuleOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export interface DocumentAutoRule {
  id: string;
  tenantId: string;
  trigger: DocumentAutoRuleTrigger;
  documentType: string;
  templateGroupId?: string | null;
  outputFormat: DocumentAutoRuleOutputFormat;
  enabled: boolean;
  lastRunAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type PutDocumentAutoRulesRequestRulesItemTrigger = typeof PutDocumentAutoRulesRequestRulesItemTrigger[keyof typeof PutDocumentAutoRulesRequestRulesItemTrigger];


export const PutDocumentAutoRulesRequestRulesItemTrigger = {
  sale_finalised: 'sale_finalised',
  order_packed: 'order_packed',
  return_processed: 'return_processed',
} as const;

export type PutDocumentAutoRulesRequestRulesItemOutputFormat = typeof PutDocumentAutoRulesRequestRulesItemOutputFormat[keyof typeof PutDocumentAutoRulesRequestRulesItemOutputFormat];


export const PutDocumentAutoRulesRequestRulesItemOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export type PutDocumentAutoRulesRequestRulesItem = {
  trigger: PutDocumentAutoRulesRequestRulesItemTrigger;
  documentType: string;
  templateGroupId?: string | null;
  outputFormat?: PutDocumentAutoRulesRequestRulesItemOutputFormat;
  enabled: boolean;
};

export interface PutDocumentAutoRulesRequest {
  rules: PutDocumentAutoRulesRequestRulesItem[];
}

export interface DocumentTypeCatalogEntry {
  type: string;
  label: string;
  description?: string | null;
  sourceKinds: string[];
  requiredFeature?: string | null;
  available: boolean;
}

export type CreateDocumentTemplateOutputFormat = typeof CreateDocumentTemplateOutputFormat[keyof typeof CreateDocumentTemplateOutputFormat];


export const CreateDocumentTemplateOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export type CreateDocumentTemplateStatus = typeof CreateDocumentTemplateStatus[keyof typeof CreateDocumentTemplateStatus];


export const CreateDocumentTemplateStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const;

export type CreateDocumentTemplateMetadata = { [key: string]: unknown };

export interface CreateDocumentTemplate {
  documentType: string;
  name: string;
  description?: string | null;
  subject?: string | null;
  bodyHtml?: string;
  outputFormat?: CreateDocumentTemplateOutputFormat;
  status?: CreateDocumentTemplateStatus;
  metadata?: CreateDocumentTemplateMetadata;
}

export type UpdateDocumentTemplateOutputFormat = typeof UpdateDocumentTemplateOutputFormat[keyof typeof UpdateDocumentTemplateOutputFormat];


export const UpdateDocumentTemplateOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export type UpdateDocumentTemplateStatus = typeof UpdateDocumentTemplateStatus[keyof typeof UpdateDocumentTemplateStatus];


export const UpdateDocumentTemplateStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const;

export type UpdateDocumentTemplateMetadata = { [key: string]: unknown };

export interface UpdateDocumentTemplate {
  name?: string;
  description?: string | null;
  subject?: string | null;
  bodyHtml?: string;
  outputFormat?: UpdateDocumentTemplateOutputFormat;
  status?: UpdateDocumentTemplateStatus;
  metadata?: UpdateDocumentTemplateMetadata;
}

export type PreviewDocumentRequestManualVariables = { [key: string]: unknown } | null;

export interface PreviewDocumentRequest {
  documentType: string;
  bodyHtml: string;
  subject?: string | null;
  sourceKind?: string;
  sourceRecordId?: string | null;
  manualVariables?: PreviewDocumentRequestManualVariables;
}

export interface DocumentPreviewResult {
  html: string;
  text: string;
  missing: string[];
  warnings: string[];
  title?: string | null;
  documentNumber?: string | null;
}

export type GenerateDocumentRequestManualVariables = { [key: string]: unknown } | null;

export type GenerateDocumentRequestOutputFormat = typeof GenerateDocumentRequestOutputFormat[keyof typeof GenerateDocumentRequestOutputFormat];


export const GenerateDocumentRequestOutputFormat = {
  pdf: 'pdf',
  html: 'html',
} as const;

export interface GenerateDocumentRequest {
  templateGroupId?: string | null;
  documentType?: string;
  bodyHtml?: string;
  subject?: string | null;
  sourceKind?: string;
  sourceRecordId?: string | null;
  manualVariables?: GenerateDocumentRequestManualVariables;
  outputFormat?: GenerateDocumentRequestOutputFormat;
}

export interface GenerateDocumentResult {
  document: GeneratedDocument;
  missing: string[];
  warnings: string[];
}

export interface EmailDocumentRequest {
  to: string;
  cc?: string | null;
  subject?: string | null;
  message?: string | null;
}

export type PostageServiceCourier = typeof PostageServiceCourier[keyof typeof PostageServiceCourier];


export const PostageServiceCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export interface PostageService {
  code: string;
  courier: PostageServiceCourier;
  name: string;
  international: boolean;
  providerCode: string;
}

export type PostageSettingsDefaultCourier = typeof PostageSettingsDefaultCourier[keyof typeof PostageSettingsDefaultCourier] | null;


export const PostageSettingsDefaultCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export type PostageSettingsWeightHandling = typeof PostageSettingsWeightHandling[keyof typeof PostageSettingsWeightHandling];


export const PostageSettingsWeightHandling = {
  actual: 'actual',
  product: 'product',
  manual: 'manual',
} as const;

export type PostageSettingsTrackingUploadBehaviour = typeof PostageSettingsTrackingUploadBehaviour[keyof typeof PostageSettingsTrackingUploadBehaviour];


export const PostageSettingsTrackingUploadBehaviour = {
  automatic: 'automatic',
  manual: 'manual',
} as const;

export type PostageSettingsLabelFormat = typeof PostageSettingsLabelFormat[keyof typeof PostageSettingsLabelFormat];


export const PostageSettingsLabelFormat = {
  a4: 'a4',
  '4x6': '4x6',
  thermal: 'thermal',
  custom: 'custom',
} as const;

export type PostageSettingsPackageTypeDefsItem = { [key: string]: unknown };

export type PostageSettingsNotificationPrefs = { [key: string]: unknown };

export interface PostageSettings {
  id: string;
  tenantId: string;
  defaultCourier?: PostageSettingsDefaultCourier;
  defaultServiceCode?: string | null;
  defaultPackageType: string;
  weightHandling: PostageSettingsWeightHandling;
  trackingUploadBehaviour: PostageSettingsTrackingUploadBehaviour;
  labelFormat: PostageSettingsLabelFormat;
  defaultWeightGrams: number;
  packageTypeDefs: PostageSettingsPackageTypeDefsItem[];
  notificationPrefs: PostageSettingsNotificationPrefs;
  createdAt: string;
  updatedAt: string;
}

export type UpdatePostageSettingsDefaultCourier = typeof UpdatePostageSettingsDefaultCourier[keyof typeof UpdatePostageSettingsDefaultCourier] | null;


export const UpdatePostageSettingsDefaultCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export type UpdatePostageSettingsDefaultPackageType = typeof UpdatePostageSettingsDefaultPackageType[keyof typeof UpdatePostageSettingsDefaultPackageType];


export const UpdatePostageSettingsDefaultPackageType = {
  letter: 'letter',
  large_letter: 'large_letter',
  small_parcel: 'small_parcel',
  medium_parcel: 'medium_parcel',
  tube: 'tube',
  custom: 'custom',
} as const;

export type UpdatePostageSettingsWeightHandling = typeof UpdatePostageSettingsWeightHandling[keyof typeof UpdatePostageSettingsWeightHandling];


export const UpdatePostageSettingsWeightHandling = {
  actual: 'actual',
  product: 'product',
  manual: 'manual',
} as const;

export type UpdatePostageSettingsTrackingUploadBehaviour = typeof UpdatePostageSettingsTrackingUploadBehaviour[keyof typeof UpdatePostageSettingsTrackingUploadBehaviour];


export const UpdatePostageSettingsTrackingUploadBehaviour = {
  automatic: 'automatic',
  manual: 'manual',
} as const;

export type UpdatePostageSettingsLabelFormat = typeof UpdatePostageSettingsLabelFormat[keyof typeof UpdatePostageSettingsLabelFormat];


export const UpdatePostageSettingsLabelFormat = {
  a4: 'a4',
  '4x6': '4x6',
  thermal: 'thermal',
  custom: 'custom',
} as const;

export type UpdatePostageSettingsPackageTypeDefsItem = { [key: string]: unknown };

export type UpdatePostageSettingsNotificationPrefs = { [key: string]: unknown };

export interface UpdatePostageSettings {
  defaultCourier?: UpdatePostageSettingsDefaultCourier;
  defaultServiceCode?: string | null;
  defaultPackageType?: UpdatePostageSettingsDefaultPackageType;
  weightHandling?: UpdatePostageSettingsWeightHandling;
  trackingUploadBehaviour?: UpdatePostageSettingsTrackingUploadBehaviour;
  labelFormat?: UpdatePostageSettingsLabelFormat;
  defaultWeightGrams?: number;
  packageTypeDefs?: UpdatePostageSettingsPackageTypeDefsItem[];
  notificationPrefs?: UpdatePostageSettingsNotificationPrefs;
}

export type CourierIntegrationCourier = typeof CourierIntegrationCourier[keyof typeof CourierIntegrationCourier];


export const CourierIntegrationCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export type CourierIntegrationStatus = typeof CourierIntegrationStatus[keyof typeof CourierIntegrationStatus];


export const CourierIntegrationStatus = {
  connected: 'connected',
  disconnected: 'disconnected',
  error: 'error',
} as const;

export type CourierIntegrationAuthType = typeof CourierIntegrationAuthType[keyof typeof CourierIntegrationAuthType];


export const CourierIntegrationAuthType = {
  oauth: 'oauth',
  credentials: 'credentials',
} as const;

export type CourierIntegrationMetadata = { [key: string]: unknown };

export interface CourierIntegration {
  id: string;
  tenantId: string;
  courier: CourierIntegrationCourier;
  accountLabel?: string | null;
  status: CourierIntegrationStatus;
  authType: CourierIntegrationAuthType;
  metadata: CourierIntegrationMetadata;
  isDefault: boolean;
  hasCredentials: boolean;
  lastTestedAt?: string | null;
  lastError?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type CreateCourierIntegrationCourier = typeof CreateCourierIntegrationCourier[keyof typeof CreateCourierIntegrationCourier];


export const CreateCourierIntegrationCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export type CreateCourierIntegrationAuthType = typeof CreateCourierIntegrationAuthType[keyof typeof CreateCourierIntegrationAuthType];


export const CreateCourierIntegrationAuthType = {
  oauth: 'oauth',
  credentials: 'credentials',
} as const;

export type CreateCourierIntegrationMetadata = { [key: string]: unknown };

export interface CreateCourierIntegration {
  courier: CreateCourierIntegrationCourier;
  accountLabel?: string | null;
  authType?: CreateCourierIntegrationAuthType;
  apiKey?: string | null;
  apiSecret?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  accountNumber?: string | null;
  metadata?: CreateCourierIntegrationMetadata;
  isDefault?: boolean;
}

export type UpdateCourierIntegrationAuthType = typeof UpdateCourierIntegrationAuthType[keyof typeof UpdateCourierIntegrationAuthType];


export const UpdateCourierIntegrationAuthType = {
  oauth: 'oauth',
  credentials: 'credentials',
} as const;

export type UpdateCourierIntegrationMetadata = { [key: string]: unknown };

export interface UpdateCourierIntegration {
  accountLabel?: string | null;
  authType?: UpdateCourierIntegrationAuthType;
  apiKey?: string | null;
  apiSecret?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  accountNumber?: string | null;
  metadata?: UpdateCourierIntegrationMetadata;
  isDefault?: boolean;
}

export interface CourierTestResult {
  ok: boolean;
  message?: string | null;
}

export type RoyalMailConnectionInfoOauthGrant = typeof RoyalMailConnectionInfoOauthGrant[keyof typeof RoyalMailConnectionInfoOauthGrant];


export const RoyalMailConnectionInfoOauthGrant = {
  client_credentials: 'client_credentials',
} as const;

export type RoyalMailConnectionInfoProducts = { [key: string]: unknown };

export type RoyalMailConnectionInfoLimitations = { [key: string]: unknown };

export interface RoyalMailConnectionInfo {
  callbackUrl: string;
  oauthGrant: RoyalMailConnectionInfoOauthGrant;
  redirectRequired: boolean;
  tokenUrl: string;
  accessTokenPolicy: string;
  products: RoyalMailConnectionInfoProducts;
  limitations: RoyalMailConnectionInfoLimitations;
}

export interface ProShippingService {
  code: string;
  name: string;
}

export type ShipmentCourier = typeof ShipmentCourier[keyof typeof ShipmentCourier] | null;


export const ShipmentCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export type ShipmentStatus = typeof ShipmentStatus[keyof typeof ShipmentStatus];


export const ShipmentStatus = {
  pending: 'pending',
  label_generated: 'label_generated',
  label_failed: 'label_failed',
  in_transit: 'in_transit',
  delivered: 'delivered',
  cancelled: 'cancelled',
} as const;

export type ShipmentParcelSnapshot = { [key: string]: unknown };

export type ShipmentLabelOperationStatus = typeof ShipmentLabelOperationStatus[keyof typeof ShipmentLabelOperationStatus];


export const ShipmentLabelOperationStatus = {
  not_started: 'not_started',
  processing: 'processing',
  outcome_unknown: 'outcome_unknown',
  failed: 'failed',
  complete: 'complete',
} as const;

export type ShipmentDimensions = { [key: string]: unknown };

export type ShipmentRecipient = { [key: string]: unknown };

export type ShipmentChannel = typeof ShipmentChannel[keyof typeof ShipmentChannel] | null;


export const ShipmentChannel = {
  ebay: 'ebay',
  shopify: 'shopify',
  tiktok_shop: 'tiktok_shop',
  website: 'website',
  manual: 'manual',
} as const;

export type ShipmentLabelFormat = typeof ShipmentLabelFormat[keyof typeof ShipmentLabelFormat];


export const ShipmentLabelFormat = {
  a4: 'a4',
  '4x6': '4x6',
  thermal: 'thermal',
  custom: 'custom',
} as const;

export interface Shipment {
  id: string;
  tenantId: string;
  courierIntegrationId?: string | null;
  courier?: ShipmentCourier;
  serviceCode?: string | null;
  serviceName?: string | null;
  status: ShipmentStatus;
  parcelSnapshot?: ShipmentParcelSnapshot;
  labelOperationStatus?: ShipmentLabelOperationStatus;
  labelOperationStartedAt?: string | null;
  packageType: string;
  weightGrams?: number | null;
  dimensions: ShipmentDimensions;
  postageCost?: string | null;
  currency: string;
  trackingNumber?: string | null;
  trackingUrl?: string | null;
  recipient: ShipmentRecipient;
  saleOrderId?: string | null;
  saleOrderIds: string[];
  channel?: ShipmentChannel;
  combinedShipmentId?: string | null;
  isCombined: boolean;
  labelFormat: ShipmentLabelFormat;
  dispatchDate?: string | null;
  lastError?: string | null;
  notes?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PostageAddress {
  name: string;
  company?: string | null;
  line1: string;
  line2?: string | null;
  city?: string | null;
  county?: string | null;
  postcode: string;
  country?: string;
  email?: string | null;
  phone?: string | null;
}

export type CreateShipmentChannel = typeof CreateShipmentChannel[keyof typeof CreateShipmentChannel] | null;


export const CreateShipmentChannel = {
  ebay: 'ebay',
  shopify: 'shopify',
  tiktok_shop: 'tiktok_shop',
  website: 'website',
  manual: 'manual',
} as const;

export type CreateShipmentCourier = typeof CreateShipmentCourier[keyof typeof CreateShipmentCourier] | null;


export const CreateShipmentCourier = {
  royal_mail: 'royal_mail',
  dhl: 'dhl',
} as const;

export type CreateShipmentDirection = typeof CreateShipmentDirection[keyof typeof CreateShipmentDirection];


export const CreateShipmentDirection = {
  outbound: 'outbound',
  return: 'return',
} as const;

export type CreateShipmentPackageType = typeof CreateShipmentPackageType[keyof typeof CreateShipmentPackageType];


export const CreateShipmentPackageType = {
  letter: 'letter',
  large_letter: 'large_letter',
  small_parcel: 'small_parcel',
  medium_parcel: 'medium_parcel',
  tube: 'tube',
  custom: 'custom',
} as const;

export type CreateShipmentDimensions = { [key: string]: unknown };

/**
 * Customer delivery version shown for each linked sale order when the parcel was created.
 */
export type CreateShipmentExpectedDeliveryVersions = {[key: string]: string | null};

export interface CreateShipment {
  saleOrderId?: string | null;
  saleOrderIds?: string[];
  courierIntegrationId?: string | null;
  channel?: CreateShipmentChannel;
  courier?: CreateShipmentCourier;
  serviceCode?: string | null;
  serviceName?: string | null;
  direction?: CreateShipmentDirection;
  sender?: PostageAddress;
  packageType?: CreateShipmentPackageType;
  weightGrams?: number | null;
  dimensions?: CreateShipmentDimensions;
  recipient: PostageAddress;
  /** Customer delivery version shown for each linked sale order when the parcel was created. */
  expectedDeliveryVersions?: CreateShipmentExpectedDeliveryVersions;
  /**
     * Customer delivery version shown when the linked sale order was opened.
     * @deprecated
     */
  expectedDeliveryVersion?: string | null;
  notes?: string | null;
  combinedShipmentId?: string | null;
}

export type ShipmentLabelLabelFormat = typeof ShipmentLabelLabelFormat[keyof typeof ShipmentLabelLabelFormat];


export const ShipmentLabelLabelFormat = {
  a4: 'a4',
  '4x6': '4x6',
  thermal: 'thermal',
  custom: 'custom',
} as const;

export interface ShipmentLabel {
  id: string;
  tenantId: string;
  shipmentId: string;
  labelFormat: ShipmentLabelLabelFormat;
  objectPath: string;
  fileSize?: number | null;
  pageCount?: number | null;
  version: number;
  isCurrent: boolean;
  courierLabelRef?: string | null;
  generatedBy?: string | null;
  createdAt: string;
}

export type ShipmentTrackingChannel = typeof ShipmentTrackingChannel[keyof typeof ShipmentTrackingChannel] | null;


export const ShipmentTrackingChannel = {
  ebay: 'ebay',
  shopify: 'shopify',
  tiktok_shop: 'tiktok_shop',
  website: 'website',
  manual: 'manual',
} as const;

export type ShipmentTrackingUploadStatus = typeof ShipmentTrackingUploadStatus[keyof typeof ShipmentTrackingUploadStatus];


export const ShipmentTrackingUploadStatus = {
  pending: 'pending',
  uploaded: 'uploaded',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export type ShipmentTrackingLastEvent = { [key: string]: unknown };

export interface ShipmentTracking {
  id: string;
  tenantId: string;
  shipmentId: string;
  saleOrderId?: string | null;
  channel?: ShipmentTrackingChannel;
  trackingNumber?: string | null;
  carrier?: string | null;
  status?: string | null;
  uploadStatus: ShipmentTrackingUploadStatus;
  uploadError?: string | null;
  uploadedAt?: string | null;
  lastEvent: ShipmentTrackingLastEvent;
  createdAt: string;
  updatedAt: string;
}

export interface BatchLabelRequest {
  shipmentIds: string[];
}

export type BatchLabelResultResultsItem = {
  shipmentId: string;
  ok: boolean;
  message?: string | null;
};

export interface BatchLabelResult {
  succeeded: number;
  results: BatchLabelResultResultsItem[];
}

export type CombinedShipmentStatus = typeof CombinedShipmentStatus[keyof typeof CombinedShipmentStatus];


export const CombinedShipmentStatus = {
  suggested: 'suggested',
  confirmed: 'confirmed',
  excluded: 'excluded',
  shipped: 'shipped',
  cancelled: 'cancelled',
} as const;

export interface CombinedShipment {
  id: string;
  tenantId: string;
  status: CombinedShipmentStatus;
  customerId?: string | null;
  matchKey?: string | null;
  saleOrderIds: string[];
  shipmentId?: string | null;
  combinedWeightGrams?: number | null;
  combinedValue?: string | null;
  notes?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCombinedShipment {
  saleOrderIds: string[];
  customerId?: string | null;
  matchKey?: string | null;
  notes?: string | null;
}

export type PickListLabelFormat = typeof PickListLabelFormat[keyof typeof PickListLabelFormat];


export const PickListLabelFormat = {
  a4: 'a4',
  '4x6': '4x6',
  thermal: 'thermal',
  custom: 'custom',
} as const;

export type PickListLineItemsItem = { [key: string]: unknown };

export interface PickList {
  id: string;
  tenantId: string;
  shipmentId?: string | null;
  combinedShipmentId?: string | null;
  batchId?: string | null;
  labelFormat: PickListLabelFormat;
  objectPath?: string | null;
  lineItems: PickListLineItemsItem[];
  orderCount: number;
  generatedBy?: string | null;
  createdAt: string;
}

export type CreatePickListLineItemsItem = { [key: string]: unknown };

export interface CreatePickList {
  shipmentId?: string | null;
  combinedShipmentId?: string | null;
  batchId?: string | null;
  lineItems?: CreatePickListLineItemsItem[];
}

export type ShipmentAuditLogChanges = { [key: string]: unknown };

export type ShipmentAuditLogMetadata = { [key: string]: unknown };

export interface ShipmentAuditLog {
  id: string;
  tenantId: string;
  shipmentId?: string | null;
  combinedShipmentId?: string | null;
  action: string;
  actorId?: string | null;
  actorName?: string | null;
  changes: ShipmentAuditLogChanges;
  metadata: ShipmentAuditLogMetadata;
  createdAt: string;
}

export type PostageDashboardByStatus = {[key: string]: number};

export interface PostageDashboard {
  byStatus: PostageDashboardByStatus;
  pendingTrackingUploads: number;
}

export type PostageReportsByCourierItem = {
  courier?: string | null;
  count: number;
  totalPostage: string;
};

export interface PostageReports {
  byCourier: PostageReportsByCourierItem[];
}

export type TikTokShopStatusStatus = typeof TikTokShopStatusStatus[keyof typeof TikTokShopStatusStatus];


export const TikTokShopStatusStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
} as const;

/**
 * Which app credentials the integration will use: "tenant" = the
 * seller's own Partner Center app saved on this tenant, "platform" =
 * the platform-level env credentials. Null when neither is configured.
 */
export type TikTokShopStatusCredentialsSource = typeof TikTokShopStatusCredentialsSource[keyof typeof TikTokShopStatusCredentialsSource] | null;


export const TikTokShopStatusCredentialsSource = {
  tenant: 'tenant',
  platform: 'platform',
} as const;

export interface TikTokShopStatus {
  status: TikTokShopStatusStatus;
  connected: boolean;
  credentialsConfigured: boolean;
  /**
     * Which app credentials the integration will use: "tenant" = the
     * seller's own Partner Center app saved on this tenant, "platform" =
     * the platform-level env credentials. Null when neither is configured.
     */
  credentialsSource?: TikTokShopStatusCredentialsSource;
  /** True when the tenant has its own app credentials saved (all three fields). */
  hasTenantCredentials?: boolean;
  /** Masked app key (last 4 chars) of the tenant's saved app. Secret is never returned. */
  tenantAppKeyMasked?: string | null;
  tenantServiceId?: string | null;
  shopId?: string | null;
  shopName?: string | null;
  region?: string | null;
  sellerName?: string | null;
  connectedAt?: string | null;
  connectedBy?: string | null;
  tokenExpiresAt?: string | null;
  lastRefreshedAt?: string | null;
  lastError?: string | null;
  lastSyncAt?: string | null;
}

export type TikTokShopSettingsSyncFrequency = typeof TikTokShopSettingsSyncFrequency[keyof typeof TikTokShopSettingsSyncFrequency];


export const TikTokShopSettingsSyncFrequency = {
  MANUAL: 'MANUAL',
  EVERY_5_MINUTES: 'EVERY_5_MINUTES',
  EVERY_15_MINUTES: 'EVERY_15_MINUTES',
  EVERY_30_MINUTES: 'EVERY_30_MINUTES',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
} as const;

/**
 * Server-owned order search policy. Restricted policies cannot be widened by manual sync inputs.
 */
export type TikTokShopSettingsOrderImportWindow = typeof TikTokShopSettingsOrderImportWindow[keyof typeof TikTokShopSettingsOrderImportWindow];


export const TikTokShopSettingsOrderImportWindow = {
  default: 'default',
  europe_london_today: 'europe_london_today',
} as const;

export interface TikTokShopSettings {
  autoSyncEnabled: boolean;
  syncFrequency: TikTokShopSettingsSyncFrequency;
  importOrders: boolean;
  /** Server-owned order search policy. Restricted policies cannot be widened by manual sync inputs. */
  readonly orderImportWindow: TikTokShopSettingsOrderImportWindow;
  syncStock: boolean;
  pushTracking: boolean;
  pushProducts: boolean;
  /** True when the connected TikTok account lacks product-creation API access. */
  productPushUnavailable: boolean;
  productPushUnavailableReason?: string | null;
  productPushCheckedAt?: string | null;
  importMessages?: boolean;
  /** True when the connected TikTok account lacks Customer Service (messaging) API access. */
  messagesUnavailable?: boolean;
  messagesUnavailableReason?: string | null;
  messagesCheckedAt?: string | null;
  lastSyncAt?: string | null;
}

export interface TikTokShopCredentialsInput {
  /**
     * @minLength 1
     * @maxLength 256
     */
  appKey: string;
  /**
     * Stored encrypted; never returned by any endpoint.
     * @minLength 1
     * @maxLength 512
     */
  appSecret: string;
  /**
     * @minLength 1
     * @maxLength 256
     */
  serviceId: string;
}

export type TikTokDeveloperConnectionEnvironment = typeof TikTokDeveloperConnectionEnvironment[keyof typeof TikTokDeveloperConnectionEnvironment];


export const TikTokDeveloperConnectionEnvironment = {
  sandbox: 'sandbox',
  test: 'test',
  production: 'production',
} as const;

export type TikTokDeveloperConnectionCredentialStatus = typeof TikTokDeveloperConnectionCredentialStatus[keyof typeof TikTokDeveloperConnectionCredentialStatus];


export const TikTokDeveloperConnectionCredentialStatus = {
  unverified: 'unverified',
  valid: 'valid',
  invalid: 'invalid',
} as const;

export type TikTokDeveloperConnectionSetupStatus = typeof TikTokDeveloperConnectionSetupStatus[keyof typeof TikTokDeveloperConnectionSetupStatus];


export const TikTokDeveloperConnectionSetupStatus = {
  not_started: 'not_started',
  credentials_saved: 'credentials_saved',
  credentials_verified: 'credentials_verified',
  awaiting_authorisation: 'awaiting_authorisation',
  shops_linked: 'shops_linked',
  ready: 'ready',
  reauth_required: 'reauth_required',
} as const;

export type TikTokAuthorisedShopStatus = typeof TikTokAuthorisedShopStatus[keyof typeof TikTokAuthorisedShopStatus];


export const TikTokAuthorisedShopStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
} as const;

export interface TikTokAuthorisedShop {
  id: string;
  developerConnectionId: string;
  shopId: string;
  shopName?: string | null;
  region?: string | null;
  sellerName?: string | null;
  status: TikTokAuthorisedShopStatus;
  syncEnabled: boolean;
  tokenExpiresAt?: string | null;
  refreshTokenExpiresAt?: string | null;
  lastRefreshedAt?: string | null;
  lastSyncAt?: string | null;
  lastError?: string | null;
  authorisedAt?: string | null;
}

export interface TikTokDeveloperConnection {
  id: string;
  name: string;
  environment: TikTokDeveloperConnectionEnvironment;
  region?: string | null;
  notes?: string | null;
  /** True when app key + secret + service id are all saved. */
  hasCredentials: boolean;
  /** Masked app key (last 4 chars). Secret is never returned. */
  appKeyMasked?: string | null;
  serviceId?: string | null;
  /** True when a webhook secret is saved (value never returned). */
  webhookSecretSet?: boolean;
  credentialStatus: TikTokDeveloperConnectionCredentialStatus;
  credentialVerifiedAt?: string | null;
  credentialLastError?: string | null;
  setupStatus: TikTokDeveloperConnectionSetupStatus;
  shops: TikTokAuthorisedShop[];
  createdAt: string;
  updatedAt?: string | null;
}

export type TikTokDeveloperConnectionInputEnvironment = typeof TikTokDeveloperConnectionInputEnvironment[keyof typeof TikTokDeveloperConnectionInputEnvironment];


export const TikTokDeveloperConnectionInputEnvironment = {
  sandbox: 'sandbox',
  test: 'test',
  production: 'production',
} as const;

export interface TikTokDeveloperConnectionInput {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  environment?: TikTokDeveloperConnectionInputEnvironment;
  /** @maxLength 64 */
  region?: string | null;
  /** @maxLength 4000 */
  notes?: string | null;
  /** @maxLength 256 */
  appKey?: string;
  /**
     * Stored encrypted; never returned by any endpoint.
     * @maxLength 512
     */
  appSecret?: string;
  /** @maxLength 256 */
  serviceId?: string;
  /**
     * Stored encrypted; never returned by any endpoint.
     * @maxLength 512
     */
  webhookSecret?: string;
}

export type TikTokDeveloperConnectionUpdateEnvironment = typeof TikTokDeveloperConnectionUpdateEnvironment[keyof typeof TikTokDeveloperConnectionUpdateEnvironment];


export const TikTokDeveloperConnectionUpdateEnvironment = {
  sandbox: 'sandbox',
  test: 'test',
  production: 'production',
} as const;

export interface TikTokDeveloperConnectionUpdate {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name?: string;
  environment?: TikTokDeveloperConnectionUpdateEnvironment;
  /** @maxLength 64 */
  region?: string | null;
  /** @maxLength 4000 */
  notes?: string | null;
  /** @maxLength 256 */
  appKey?: string;
  /**
     * Stored encrypted; never returned. Rotating the secret resets credential status to unverified.
     * @maxLength 512
     */
  appSecret?: string;
  /** @maxLength 256 */
  serviceId?: string;
  /**
     * Stored encrypted; never returned. Send an empty string to clear.
     * @maxLength 512
     */
  webhookSecret?: string;
}

export type TikTokShopSettingsUpdateSyncFrequency = typeof TikTokShopSettingsUpdateSyncFrequency[keyof typeof TikTokShopSettingsUpdateSyncFrequency];


export const TikTokShopSettingsUpdateSyncFrequency = {
  MANUAL: 'MANUAL',
  EVERY_5_MINUTES: 'EVERY_5_MINUTES',
  EVERY_15_MINUTES: 'EVERY_15_MINUTES',
  EVERY_30_MINUTES: 'EVERY_30_MINUTES',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
} as const;

export interface TikTokShopSettingsUpdate {
  autoSyncEnabled?: boolean;
  syncFrequency?: TikTokShopSettingsUpdateSyncFrequency;
  importOrders?: boolean;
  syncStock?: boolean;
  pushTracking?: boolean;
  pushProducts?: boolean;
  importMessages?: boolean;
}

export interface TikTokCategoryMapping {
  /** The inventory product type (e.g. Gold Coin) */
  productType: string;
  /** The TikTok Shop numeric category ID */
  categoryId: string;
}

export interface TikTokCategoryMappings {
  mappings: TikTokCategoryMapping[];
}

export type TikTokCategoryAttributeValuesItem = {
  id: string;
  name: string;
};

/**
 * A single product attribute for a TikTok Shop leaf category.
 */
export interface TikTokCategoryAttribute {
  /** Attribute ID (numeric string) */
  id: string;
  /** Localised attribute name */
  name: string;
  /** Value input type: DROPDOWN, TEXT, NUMERIC, MULTI_SELECT, DATE, or other */
  type: string;
  /** Whether TikTok requires this attribute for a successful product push */
  required: boolean;
  /** When true, TikTok allows the operator to type a free-text value even though a dropdown list exists (is_customized_value in TikTok API). */
  isCustomizable?: boolean;
  /** Enumerable values for DROPDOWN/MULTI_SELECT types; empty for free-text. */
  values: TikTokCategoryAttributeValuesItem[];
}

export interface TikTokCategoryAttributeList {
  attributes: TikTokCategoryAttribute[];
  /** True when the TikTok API was unavailable; empty attributes list returned */
  fallback: boolean;
}

export interface TikTokCategoryNode {
  /** Numeric category ID as a string */
  id: string;
  /** Parent category ID, null for root categories */
  parentId?: string | null;
  /** Localised display name */
  name: string;
  /** True when this category has no children (product categories that can be assigned) */
  isLeaf: boolean;
  /** Depth in the tree, 1 = root */
  level: number;
}

export interface TikTokCategoryTree {
  categories: TikTokCategoryNode[];
  /** True when the TikTok API was unavailable; empty categories list returned so operators can still type IDs manually */
  fallback: boolean;
}

export type TikTokShopSyncLogRecordType = typeof TikTokShopSyncLogRecordType[keyof typeof TikTokShopSyncLogRecordType];


export const TikTokShopSyncLogRecordType = {
  connection: 'connection',
  order: 'order',
  stock: 'stock',
  tracking: 'tracking',
  product: 'product',
  message: 'message',
  return: 'return',
} as const;

export type TikTokShopSyncLogTriggerType = typeof TikTokShopSyncLogTriggerType[keyof typeof TikTokShopSyncLogTriggerType];


export const TikTokShopSyncLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
  system: 'system',
} as const;

export type TikTokShopSyncLogStatus = typeof TikTokShopSyncLogStatus[keyof typeof TikTokShopSyncLogStatus];


export const TikTokShopSyncLogStatus = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
  warning: 'warning',
} as const;

export interface TikTokShopSyncLog {
  id: string;
  recordType: TikTokShopSyncLogRecordType;
  sourceRecordId?: string | null;
  triggerType: TikTokShopSyncLogTriggerType;
  triggeredBy?: string | null;
  status: TikTokShopSyncLogStatus;
  message?: string | null;
  errorMessage?: string | null;
  /** Number of attempts made for this record. */
  attempts?: number;
  /** SKU extracted from the log payload (if present). */
  sku?: string | null;
  /** Inventory item ID extracted from the log payload (if present). */
  itemId?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type TikTokSyncJobJobType = typeof TikTokSyncJobJobType[keyof typeof TikTokSyncJobJobType];


export const TikTokSyncJobJobType = {
  credential_verify: 'credential_verify',
  seller_authorise: 'seller_authorise',
  token_refresh: 'token_refresh',
  shop_import: 'shop_import',
  capability_refresh: 'capability_refresh',
  product_import: 'product_import',
  order_import: 'order_import',
  order_reconcile: 'order_reconcile',
  inventory_push: 'inventory_push',
  inventory_reconcile: 'inventory_reconcile',
  product_create: 'product_create',
  product_update: 'product_update',
  image_sync: 'image_sync',
  price_push: 'price_push',
  fulfilment_push: 'fulfilment_push',
  tracking_push: 'tracking_push',
  return_sync: 'return_sync',
  message_sync: 'message_sync',
  webhook_process: 'webhook_process',
} as const;

export type TikTokSyncJobStatus = typeof TikTokSyncJobStatus[keyof typeof TikTokSyncJobStatus];


export const TikTokSyncJobStatus = {
  queued: 'queued',
  processing: 'processing',
  success: 'success',
  failed: 'failed',
  retry_scheduled: 'retry_scheduled',
  cancelled: 'cancelled',
} as const;

export type TikTokSyncJobTriggerType = typeof TikTokSyncJobTriggerType[keyof typeof TikTokSyncJobTriggerType];


export const TikTokSyncJobTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
  system: 'system',
} as const;

export interface TikTokSyncJob {
  id: string;
  developerConnectionId?: string | null;
  shopId?: string | null;
  jobType: TikTokSyncJobJobType;
  status: TikTokSyncJobStatus;
  triggerType: TikTokSyncJobTriggerType;
  triggeredBy?: string | null;
  entityType?: string | null;
  entityId?: string | null;
  idempotencyKey?: string | null;
  attempts: number;
  maxAttempts: number;
  nextRunAt?: string | null;
  retryAfterMs?: number | null;
  startedAt?: string | null;
  finishedAt?: string | null;
  durationMs?: number | null;
  message?: string | null;
  errorMessage?: string | null;
  createdAt: string;
  updatedAt?: string | null;
}

export interface TikTokSyncJobStatusCounts {
  queued: number;
  processing: number;
  success: number;
  failed: number;
  retry_scheduled: number;
  cancelled: number;
}

export type TikTokConnectionCapabilityCapability = typeof TikTokConnectionCapabilityCapability[keyof typeof TikTokConnectionCapabilityCapability];


export const TikTokConnectionCapabilityCapability = {
  seller_authorisation: 'seller_authorisation',
  shop_information: 'shop_information',
  products: 'products',
  categories: 'categories',
  brands: 'brands',
  product_images: 'product_images',
  inventory: 'inventory',
  warehouses: 'warehouses',
  orders: 'orders',
  order_details: 'order_details',
  fulfilment: 'fulfilment',
  packages: 'packages',
  tracking: 'tracking',
  returns: 'returns',
  refunds: 'refunds',
  finance: 'finance',
  customer_details: 'customer_details',
  customer_messages: 'customer_messages',
  webhooks: 'webhooks',
} as const;

export interface TikTokConnectionCapability {
  id: string;
  developerConnectionId: string;
  capability: TikTokConnectionCapabilityCapability;
  requiredScope?: string | null;
  scopeGranted?: boolean;
  appApproved?: boolean;
  marketSupported?: boolean;
  enabled: boolean;
  limitationMessage?: string | null;
  lastCheckedAt?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface TikTokShopDashboard {
  connectionCount: number;
  shopCount: number;
  connectedShopCount?: number;
  jobStatusCounts: TikTokSyncJobStatusCounts;
  capabilities: TikTokConnectionCapability[];
  recentJobs: TikTokSyncJob[];
  /** queued + processing + retry_scheduled. */
  openJobCount?: number;
  failuresLast24h?: number;
}

export interface TikTokShopOrderSyncResult {
  /** False when the pass was skipped (not connected / import disabled). */
  ran: boolean;
  attempted: number;
  imported: number;
  duplicate: number;
  failed: number;
  skipped: number;
  message?: string | null;
}

export interface TikTokShopTrackingPushResult {
  /** False when the pass was skipped (not connected / push tracking disabled). */
  ran: boolean;
  attempted: number;
  pushed: number;
  failed: number;
  skipped: number;
  message?: string | null;
}

export interface TikTokShopStockResyncResult {
  attempted: number;
  pushed: number;
  skipped: number;
  failed: number;
}

export interface TikTokShopStockPushResult {
  ok: boolean;
  skipped: boolean;
  reason?: string | null;
  message?: string | null;
  quantity?: number | null;
}

/**
 * "primary" = the push-managed listing; "auction" = a manually created live-auction listing linked to the same inventory item (content pushes never touch it, stock sync fans out to it).
 */
export type TikTokShopProductMappingListingRole = typeof TikTokShopProductMappingListingRole[keyof typeof TikTokShopProductMappingListingRole];


export const TikTokShopProductMappingListingRole = {
  primary: 'primary',
  auction: 'auction',
} as const;

export interface TikTokShopProductMapping {
  id: string;
  tiktokProductId?: string | null;
  tiktokSkuId?: string | null;
  listingTitle?: string | null;
  parsedSku?: string | null;
  parsedQuantity?: number | null;
  parsedDescription?: string | null;
  quantityMultiplier: number;
  inventoryItemId?: string | null;
  sku?: string | null;
  productTitle?: string | null;
  confidence?: number | null;
  matchSource?: string | null;
  matchMethod?: string | null;
  manuallyConfirmed: boolean;
  active: boolean;
  status?: string | null;
  lastPushedAt?: string | null;
  needsRelink?: boolean;
  /** "primary" = the push-managed listing; "auction" = a manually created live-auction listing linked to the same inventory item (content pushes never touch it, stock sync fans out to it). */
  listingRole?: TikTokShopProductMappingListingRole;
  lastStockSyncedAt?: string | null;
  lastStockError?: string | null;
  lastStockQuantity?: number | null;
  /** True when this listing is pushed to TikTok as a pre-order (pre-sale) product; stock sync then pushes remaining pre-order capacity instead of on-hand stock. */
  isPreOrder?: boolean;
  /** Expected ship date (YYYY-MM-DD) last sent in the TikTok pre_sale block. */
  preOrderReleaseDate?: string | null;
  /** Internal pre-order batch item the pre-order state derives from; null for a manual override. */
  preOrderBatchItemId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TikTokShopProductMappingList {
  mappings: TikTokShopProductMapping[];
}

export interface TikTokShopUnmappedList {
  mappings: TikTokShopProductMapping[];
  count: number;
}

export interface TikTokShopNeedsRelinkItem {
  inventoryItemId: string;
  sku?: string | null;
  productTitle?: string | null;
  tiktokProductId?: string | null;
  tiktokSkuId?: string | null;
}

export interface TikTokShopNeedsRelinkList {
  mappings: TikTokShopProductMapping[];
  items: TikTokShopNeedsRelinkItem[];
  count: number;
}

/**
 * Provide exactly one of mappingId (mapping-row link) or inventoryItemId (legacy externalListings link).
 */
export interface TikTokShopRefreshSkuRequest {
  mappingId?: string | null;
  inventoryItemId?: string | null;
}

export type TikTokShopRefreshSkuResultMatchedBy = typeof TikTokShopRefreshSkuResultMatchedBy[keyof typeof TikTokShopRefreshSkuResultMatchedBy];


export const TikTokShopRefreshSkuResultMatchedBy = {
  seller_sku: 'seller_sku',
  single_sku: 'single_sku',
} as const;

export interface TikTokShopRefreshSkuResult {
  ok: boolean;
  tiktokSkuId: string;
  matchedBy: TikTokShopRefreshSkuResultMatchedBy;
}

export interface TikTokShopMappingCandidate {
  inventoryItemId: string;
  sku: string;
  productTitle: string;
  confidence: number;
  source: string;
}

export interface TikTokShopParsedTitle {
  sku?: string | null;
  quantity: number;
  description: string;
  isStructured: boolean;
}

export type TikTokShopMatchSuggestionBucket = typeof TikTokShopMatchSuggestionBucket[keyof typeof TikTokShopMatchSuggestionBucket];


export const TikTokShopMatchSuggestionBucket = {
  auto: 'auto',
  review: 'review',
  none: 'none',
} as const;

export interface TikTokShopMatchSuggestion {
  cleanedTitle: string;
  parsed: TikTokShopParsedTitle;
  candidates: TikTokShopMappingCandidate[];
  bucket: TikTokShopMatchSuggestionBucket;
}

export interface TikTokShopMatchRequest {
  listingTitle: string;
}

export interface TikTokShopMappingUpsert {
  tiktokProductId?: string | null;
  tiktokSkuId?: string | null;
  listingTitle?: string | null;
  inventoryItemId?: string | null;
  sku?: string | null;
  quantityMultiplier?: number | null;
  confidence?: number | null;
  matchSource?: string | null;
  manuallyConfirmed?: boolean;
  active?: boolean;
}

export interface TikTokShopMappingPatch {
  inventoryItemId?: string | null;
  sku?: string | null;
  quantityMultiplier?: number;
  active?: boolean;
  manuallyConfirmed?: boolean;
  tiktokProductId?: string;
  tiktokSkuId?: string;
  listingTitle?: string;
}

export interface TikTokShopMappingImportRequest {
  csv: string;
}

export type TikTokShopMappingImportResultErrorsItem = {
  line: number;
  message: string;
};

export interface TikTokShopMappingImportResult {
  total: number;
  created: number;
  updated: number;
  autoMatched: number;
  unmatched: number;
  errors: TikTokShopMappingImportResultErrorsItem[];
}

export interface TikTokShopProductCapability {
  available: boolean;
  reason?: string | null;
}

export type TikTokShopProductPushOutcomeStatus = typeof TikTokShopProductPushOutcomeStatus[keyof typeof TikTokShopProductPushOutcomeStatus];


export const TikTokShopProductPushOutcomeStatus = {
  pushed: 'pushed',
  unavailable: 'unavailable',
  failed: 'failed',
  skipped: 'skipped',
} as const;

/**
 * Whether a successful push created a new listing or updated an existing one.
 */
export type TikTokShopProductPushOutcomeAction = typeof TikTokShopProductPushOutcomeAction[keyof typeof TikTokShopProductPushOutcomeAction] | null;


export const TikTokShopProductPushOutcomeAction = {
  created: 'created',
  updated: 'updated',
} as const;

/**
 * Format requested by this push. This is not a provider readback confirmation.
 */
export type TikTokShopProductPushOutcomeRequestedSellingFormat = typeof TikTokShopProductPushOutcomeRequestedSellingFormat[keyof typeof TikTokShopProductPushOutcomeRequestedSellingFormat] | null;


export const TikTokShopProductPushOutcomeRequestedSellingFormat = {
  FIXED_PRICE: 'FIXED_PRICE',
  FIXED_PRICE_AND_LIVE_AUCTION: 'FIXED_PRICE_AND_LIVE_AUCTION',
} as const;

/**
 * Format echoed by TikTok in the push response, when available.
 */
export type TikTokShopProductPushOutcomeObservedSellingFormat = typeof TikTokShopProductPushOutcomeObservedSellingFormat[keyof typeof TikTokShopProductPushOutcomeObservedSellingFormat] | null;


export const TikTokShopProductPushOutcomeObservedSellingFormat = {
  FIXED_PRICE: 'FIXED_PRICE',
  FIXED_PRICE_AND_LIVE_AUCTION: 'FIXED_PRICE_AND_LIVE_AUCTION',
  LIVE_AUCTION: 'LIVE_AUCTION',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface TikTokShopProductPushOutcome {
  inventoryItemId: string;
  sku: string;
  status: TikTokShopProductPushOutcomeStatus;
  message: string;
  tiktokProductId?: string | null;
  tiktokSkuId?: string | null;
  /** Whether a successful push created a new listing or updated an existing one. */
  action?: TikTokShopProductPushOutcomeAction;
  /** True when the push sent the listing as a TikTok pre-order (pre-sale) product. Eligibility failures surface TikTok's error in `message`. */
  preOrder?: boolean | null;
  /** Format requested by this push. This is not a provider readback confirmation. */
  requestedSellingFormat?: TikTokShopProductPushOutcomeRequestedSellingFormat;
  /** Format echoed by TikTok in the push response, when available. */
  observedSellingFormat?: TikTokShopProductPushOutcomeObservedSellingFormat;
}

export interface TikTokShopDuplicateListing {
  productId: string;
  skuId?: string | null;
  status?: string | null;
  title?: string | null;
}

export interface TikTokShopDuplicateListingsResponse {
  sku: string | null;
  listings: TikTokShopDuplicateListing[];
}

export interface TikTokShopResolveDuplicatesRequest {
  inventoryItemId: string;
  keepProductId: string;
}

export interface TikTokShopResolveDuplicatesResult {
  ok: boolean;
  keptProductId: string;
  keptSkuId?: string | null;
  deactivatedProductIds: string[];
}

export interface TikTokShopListingSyncRequest {
  inventoryItemId: string;
}

export type TikTokShopLinkedContentOutcomeResultsItem = {
  mappingId: string;
  tiktokProductId: string;
  ok: boolean;
  message?: string | null;
};

/**
 * Content (description/images/price) fan-out to manually linked auction-role listings via TikTok's partial-edit endpoint. attempted=0 means the item has no active linked auction listings.
 */
export interface TikTokShopLinkedContentOutcome {
  attempted: number;
  updated: number;
  failed: number;
  results: TikTokShopLinkedContentOutcomeResultsItem[];
}

export interface TikTokShopListingSyncResult {
  inventoryItemId: string;
  productPush: TikTokShopProductPushOutcome;
  stockSync: TikTokShopStockPushResult;
  linkedContent: TikTokShopLinkedContentOutcome;
}

export interface TikTokShopProductPushRequest {
  inventoryItemId: string;
  /** When true, skip the existing mapping / live SKU lookup and create a brand-new TikTok listing (re-list after TikTok removed the original). The new product id replaces the stored mapping. */
  forceNewListing?: boolean;
}

export interface TikTokShopProductPushBulkRequest {
  inventoryItemIds: string[];
  /** When true, skip the existing mapping / live SKU lookup and create a brand-new TikTok listing (re-list after TikTok removed the original). The new product id replaces the stored mapping. */
  forceNewListing?: boolean;
}

export interface TikTokShopProductPushBulkResult {
  attempted: number;
  pushed: number;
  failed: number;
  unavailable: number;
  skipped: number;
  outcomes: TikTokShopProductPushOutcome[];
}

export interface TikTokShopProductDeactivateRequest {
  productIds: string[];
}

export type TikTokShopImportedProductRawPayload = { [key: string]: unknown } | null;

export interface TikTokShopImportedProduct {
  id: string;
  developerConnectionId?: string | null;
  shopId?: string | null;
  tiktokProductId: string;
  title?: string | null;
  status?: string | null;
  brandName?: string | null;
  categoryId?: string | null;
  categoryName?: string | null;
  mainImageUrl?: string | null;
  variantCount: number;
  rawPayload?: TikTokShopImportedProductRawPayload;
  lastSyncedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TikTokShopImportedProductVariant {
  id: string;
  productId?: string;
  tiktokProductId?: string | null;
  tiktokSkuId: string;
  sellerSku?: string | null;
  title?: string | null;
  price?: string | null;
  currency?: string | null;
  stockQuantity?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface TikTokShopImportedProductImage {
  id: string;
  productId?: string;
  tiktokProductId?: string | null;
  imageUri?: string | null;
  imageUrl?: string | null;
  position?: number | null;
  isMain: boolean;
  syncedToInventory: boolean;
  inventoryItemId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TikTokShopImportedProductList {
  products: TikTokShopImportedProduct[];
  total: number;
}

export interface TikTokShopImportedProductDetail {
  product: TikTokShopImportedProduct;
  variants: TikTokShopImportedProductVariant[];
  images: TikTokShopImportedProductImage[];
  mappings: TikTokShopProductMapping[];
}

export type TikTokInventoryPushStatusItemPushStatus = typeof TikTokInventoryPushStatusItemPushStatus[keyof typeof TikTokInventoryPushStatusItemPushStatus];


export const TikTokInventoryPushStatusItemPushStatus = {
  not_pushed: 'not_pushed',
  in_review: 'in_review',
  live: 'live',
  rejected: 'rejected',
  failed: 'failed',
  unknown: 'unknown',
} as const;

export interface TikTokInventoryPushStatusItem {
  id: string;
  sku: string | null;
  title: string | null;
  photoUrl?: string | null;
  tiktokCategoryId?: string | null;
  tiktokCategoryName?: string | null;
  tiktokProductId?: string | null;
  tiktokSkuId?: string | null;
  tiktokStatus?: string | null;
  lastError?: string | null;
  pushStatus: TikTokInventoryPushStatusItemPushStatus;
  /** True when this item is currently flagged/pushed as a TikTok pre-order (pre-sale) listing. */
  preOrder?: boolean | null;
}

export interface TikTokInventoryPushStatusList {
  items: TikTokInventoryPushStatusItem[];
  total: number;
}

export interface TikTokShopProductImportResult {
  productsSeen: number;
  productsUpserted: number;
  variantsUpserted: number;
  imagesRecorded: number;
  mappingsAutoLinked: number;
  mappingsUnmapped: number;
  pages: number;
  imagesCopied?: number | null;
  imagesFailed?: number | null;
  itemsTouched?: number | null;
}

export interface TikTokShopImageSyncResult {
  imagesConsidered: number;
  imagesCopied: number;
  imagesSkipped: number;
  imagesFailed: number;
  itemsTouched: number;
}

export interface TikTokShopOrderTrackingPushResult {
  ok: boolean;
  skipped: boolean;
  reason?: string | null;
  message?: string | null;
  shipped?: number | null;
}

export interface TikTokLabelImportDetail {
  orderId: string;
  saleOrderId?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  nameUpdated: boolean;
  addressUpdated: boolean;
  trackingUpdated: boolean;
  trackingNumber?: string | null;
  matched: boolean;
}

export type TikTokLabelImportResultCustomerMergeCandidatesItem = {
  hashedCustomerId: string;
  existingCustomerId: string;
  existingCustomerName?: string | null;
  reason: string;
};

export interface TikTokLabelImportResult {
  /** Number of label orders matched to a sale_order in this tenant */
  matched: number;
  /** Number of customer records updated with the real name from the label */
  customersUpdated: number;
  /** Number of sale orders updated with the tracking number from the label */
  trackingUpdated: number;
  /** TikTok Order IDs from the label that had no matching sale_order */
  unmatched: string[];
  details: TikTokLabelImportDetail[];
  /** Non-fatal parser warnings (missing postcodes, unreadable sections, etc.) */
  warnings: string[];
  /** Potential duplicate pairs - existing customers whose address+postcode match a newly-enriched hashed customer. Operators should review and merge via the customer intelligence screen. */
  customerMergeCandidates?: TikTokLabelImportResultCustomerMergeCandidatesItem[];
}

export interface TikTokShopStatusSyncResult {
  ran: boolean;
  checked: number;
  updated: number;
  message?: string | null;
}

export interface TikTokShopSyncSummary {
  connected: boolean;
  syncStock: boolean;
  pushTracking: boolean;
  importOrders: boolean;
  linkedItemCount: number;
  openOrderCount: number;
  failuresLast24h: number;
  /** TikTok Shop orders that currently have an active (non-terminal) packing job — i.e. still awaiting packing. Drives the dashboard "awaiting packing" stat. */
  awaitingPackingCount?: number;
  /** TikTok Shop tracking-push failures (sync log recordType="tracking", status="failed") in the last 24h. Subset of failuresLast24h scoped to tracking sync. */
  trackingFailuresLast24h?: number;
  unreadMessages?: number;
  lastStockSyncAt?: string | null;
  lastTrackingSyncAt?: string | null;
  lastOrderSyncAt?: string | null;
}

export type TikTokShopMessageDirection = typeof TikTokShopMessageDirection[keyof typeof TikTokShopMessageDirection] | null;


export const TikTokShopMessageDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;

export interface TikTokShopMessage {
  id: string;
  conversationId?: string | null;
  messageId: string;
  direction: TikTokShopMessageDirection;
  sender?: string | null;
  body?: string | null;
  saleOrderId?: string | null;
  customerId?: string | null;
  tiktokOrderId?: string | null;
  isRead: boolean;
  sentAt?: string | null;
  createdAt: string;
}

export interface TikTokShopMessageCapability {
  /** True when the connected shop can read/reply to customer messages. */
  available: boolean;
  /** Human-readable read-only fallback reason when unavailable. */
  reason?: string | null;
  checkedAt?: string | null;
}

export interface TikTokShopMessageList {
  items: TikTokShopMessage[];
  capability: TikTokShopMessageCapability;
}

export interface TikTokShopMessageSyncResult {
  ran: boolean;
  conversations: number;
  imported: number;
  inbound: number;
  failed: number;
  message?: string | null;
  unavailable?: boolean | null;
}

export interface TikTokShopMessageReplyRequest {
  conversationId: string;
  /**
     * @minLength 1
     * @maxLength 4000
     */
  text: string;
}

export interface TikTokShopMessageReplyResult {
  ok: boolean;
  message?: string | null;
  messageId?: string | null;
}

export interface TikTokShopMessageMarkReadRequest {
  conversationId: string;
}

export type DemandForecastClassification = typeof DemandForecastClassification[keyof typeof DemandForecastClassification];


export const DemandForecastClassification = {
  fast_mover: 'fast_mover',
  steady: 'steady',
  slow_mover: 'slow_mover',
  dead_stock: 'dead_stock',
  no_history: 'no_history',
} as const;

export type DemandForecastChannelSplit = {[key: string]: number};

export interface DemandForecast {
  id: string;
  inventoryItemId: string;
  sku?: string | null;
  title?: string | null;
  categoryId?: string | null;
  quantityOnHand: number;
  quantityIncoming: number;
  unitsSold7d: number;
  unitsSold30d: number;
  unitsSold90d: number;
  avgDailySales: number;
  avgWeeklySales: number;
  daysOfStockRemaining?: number | null;
  reorderPoint: number;
  recommendedReorderQty: number;
  safetyStockUnits: number;
  leadTimeDays: number;
  seasonalityFactor: number;
  confidenceScore: number;
  classification: DemandForecastClassification;
  stockoutRisk: boolean;
  overstockRisk: boolean;
  demandSpike: boolean;
  decliningDemand: boolean;
  forecastedUnits: number;
  forecastedRevenue: number;
  forecastedProfit: number;
  lastSaleAt?: string | null;
  channelSplit: DemandForecastChannelSplit;
  computedAt: string;
}

export interface DemandForecastList {
  items: DemandForecast[];
  total: number;
}

export type ReorderRecommendationUrgency = typeof ReorderRecommendationUrgency[keyof typeof ReorderRecommendationUrgency];


export const ReorderRecommendationUrgency = {
  critical: 'critical',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export type ReorderRecommendationStatus = typeof ReorderRecommendationStatus[keyof typeof ReorderRecommendationStatus];


export const ReorderRecommendationStatus = {
  open: 'open',
  dismissed: 'dismissed',
  actioned: 'actioned',
} as const;

export interface ReorderRecommendation {
  id: string;
  inventoryItemId: string;
  sku?: string | null;
  title?: string | null;
  categoryId?: string | null;
  quantityOnHand: number;
  quantityIncoming: number;
  daysOfStockRemaining?: number | null;
  reorderPoint: number;
  recommendedQty: number;
  avgDailySales: number;
  leadTimeDays: number;
  urgency: ReorderRecommendationUrgency;
  reason?: string | null;
  status: ReorderRecommendationStatus;
  dismissedBy?: string | null;
  dismissedAt?: string | null;
  actionedBy?: string | null;
  actionedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ForecastingRunResult {
  ran: boolean;
  itemsProcessed: number;
  forecastsWritten: number;
  recommendationsCreated: number;
  runLogId?: string | null;
}

export type ForecastingRunLogTriggerType = typeof ForecastingRunLogTriggerType[keyof typeof ForecastingRunLogTriggerType];


export const ForecastingRunLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
  system: 'system',
} as const;

export type ForecastingRunLogStatus = typeof ForecastingRunLogStatus[keyof typeof ForecastingRunLogStatus];


export const ForecastingRunLogStatus = {
  running: 'running',
  success: 'success',
  failed: 'failed',
} as const;

export interface ForecastingRunLog {
  id: string;
  triggeredBy?: string | null;
  triggerType: ForecastingRunLogTriggerType;
  status: ForecastingRunLogStatus;
  itemsProcessed: number;
  forecastsWritten: number;
  recommendationsCreated: number;
  notificationsFired: number;
  message?: string | null;
  errorMessage?: string | null;
  durationMs?: number | null;
  startedAt: string;
  completedAt?: string | null;
}

export interface ForecastingSummary {
  totalForecasts: number;
  stockoutRisk: number;
  overstockRisk: number;
  deadStock: number;
  fastMovers: number;
  demandSpikes: number;
  forecastedRevenue: number;
  forecastedProfit: number;
  openRecommendations: number;
  criticalRecommendations: number;
  lastRun?: ForecastingRunLog | null;
}

export type ReorderRecommendationStatusUpdateStatus = typeof ReorderRecommendationStatusUpdateStatus[keyof typeof ReorderRecommendationStatusUpdateStatus];


export const ReorderRecommendationStatusUpdateStatus = {
  open: 'open',
  dismissed: 'dismissed',
  actioned: 'actioned',
} as const;

export interface ReorderRecommendationStatusUpdate {
  status: ReorderRecommendationStatusUpdateStatus;
}

export type ForecastingCategoryOverrideReorderMethod = typeof ForecastingCategoryOverrideReorderMethod[keyof typeof ForecastingCategoryOverrideReorderMethod] | null;


export const ForecastingCategoryOverrideReorderMethod = {
  lead_time_demand: 'lead_time_demand',
  target_days_cover: 'target_days_cover',
  fixed_batch: 'fixed_batch',
} as const;

export interface ForecastingCategoryOverride {
  categoryId: string;
  categoryName?: string | null;
  leadTimeDays?: number | null;
  safetyStockDays?: number | null;
  deadStockThresholdDays?: number | null;
  slowMoverThresholdDays?: number | null;
  reorderMethod?: ForecastingCategoryOverrideReorderMethod;
  targetDaysCover?: number | null;
}

export type ForecastingSettingsReorderMethod = typeof ForecastingSettingsReorderMethod[keyof typeof ForecastingSettingsReorderMethod];


export const ForecastingSettingsReorderMethod = {
  lead_time_demand: 'lead_time_demand',
  target_days_cover: 'target_days_cover',
  fixed_batch: 'fixed_batch',
} as const;

export interface ForecastingSettings {
  forecastWindowDays: number;
  minSalesHistoryDays: number;
  defaultLeadTimeDays: number;
  safetyStockDays: number;
  deadStockThresholdDays: number;
  slowMoverThresholdDays: number;
  fastMoverUnitsPerDay: number;
  reorderMethod: ForecastingSettingsReorderMethod;
  targetDaysCover: number;
  includeMarketplaces: boolean;
  includeReturns: boolean;
  seasonalityEnabled: boolean;
  categoryOverrides: ForecastingCategoryOverride[];
  lastRunAt?: string | null;
}

export type ForecastingSettingsUpdateReorderMethod = typeof ForecastingSettingsUpdateReorderMethod[keyof typeof ForecastingSettingsUpdateReorderMethod];


export const ForecastingSettingsUpdateReorderMethod = {
  lead_time_demand: 'lead_time_demand',
  target_days_cover: 'target_days_cover',
  fixed_batch: 'fixed_batch',
} as const;

export interface ForecastingSettingsUpdate {
  forecastWindowDays?: number;
  minSalesHistoryDays?: number;
  defaultLeadTimeDays?: number;
  safetyStockDays?: number;
  deadStockThresholdDays?: number;
  slowMoverThresholdDays?: number;
  fastMoverUnitsPerDay?: number;
  reorderMethod?: ForecastingSettingsUpdateReorderMethod;
  targetDaysCover?: number;
  includeMarketplaces?: boolean;
  includeReturns?: boolean;
  seasonalityEnabled?: boolean;
  categoryOverrides?: ForecastingCategoryOverride[];
}

export type IntelligenceInsightInsightType = typeof IntelligenceInsightInsightType[keyof typeof IntelligenceInsightInsightType];


export const IntelligenceInsightInsightType = {
  sales_spike: 'sales_spike',
  sales_drop: 'sales_drop',
  marketplace_change: 'marketplace_change',
  stockout_risk: 'stockout_risk',
  slow_moving_stock: 'slow_moving_stock',
  high_return_rate: 'high_return_rate',
  packing_delay: 'packing_delay',
  hr_warning: 'hr_warning',
  social_change: 'social_change',
  profit_warning: 'profit_warning',
  customer_behaviour_change: 'customer_behaviour_change',
} as const;

export type IntelligenceInsightSourceModule = typeof IntelligenceInsightSourceModule[keyof typeof IntelligenceInsightSourceModule];


export const IntelligenceInsightSourceModule = {
  sales: 'sales',
  marketplace: 'marketplace',
  inventory: 'inventory',
  returns: 'returns',
  packing: 'packing',
  hr: 'hr',
  social: 'social',
  finance: 'finance',
  customers: 'customers',
} as const;

export type IntelligenceInsightSeverity = typeof IntelligenceInsightSeverity[keyof typeof IntelligenceInsightSeverity];


export const IntelligenceInsightSeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;

export type IntelligenceInsightStatus = typeof IntelligenceInsightStatus[keyof typeof IntelligenceInsightStatus];


export const IntelligenceInsightStatus = {
  active: 'active',
  resolved: 'resolved',
} as const;

export type IntelligenceInsightData = { [key: string]: unknown };

export interface IntelligenceInsight {
  id: string;
  insightType: IntelligenceInsightInsightType;
  sourceModule: IntelligenceInsightSourceModule;
  severity: IntelligenceInsightSeverity;
  status: IntelligenceInsightStatus;
  title: string;
  body?: string | null;
  recommendedAction?: string | null;
  link?: string | null;
  metricValue?: number | null;
  metricLabel?: string | null;
  dedupKey: string;
  data: IntelligenceInsightData;
  assignedToUserId?: string | null;
  assignedAt?: string | null;
  assignedBy?: string | null;
  taskId?: string | null;
  dismissed: boolean;
  saved: boolean;
  firstDetectedAt: string;
  lastDetectedAt: string;
  resolvedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IntelligenceInsightList {
  items: IntelligenceInsight[];
  total: number;
}

export type IntelligenceSummaryBySeverity = {
  info: number;
  warning: number;
  critical: number;
};

export type IntelligenceSummaryBySource = {[key: string]: number};

export interface IntelligenceSummary {
  total: number;
  bySeverity: IntelligenceSummaryBySeverity;
  bySource: IntelligenceSummaryBySource;
  lastRunAt?: string | null;
}

export type IntelligenceInsightStateResultAction = typeof IntelligenceInsightStateResultAction[keyof typeof IntelligenceInsightStateResultAction];


export const IntelligenceInsightStateResultAction = {
  dismissed: 'dismissed',
  saved: 'saved',
} as const;

export interface IntelligenceInsightStateResult {
  ok: boolean;
  id: string;
  action: IntelligenceInsightStateResultAction;
  active: boolean;
}

export interface IntelligenceInsightAssign {
  userId?: string | null;
}

export interface IntelligenceRunResult {
  ran: boolean;
  insightsDetected: number;
  insightsWritten: number;
  insightsResolved: number;
  notificationsFired: number;
}

export type IntelligenceTypeSettingInsightType = typeof IntelligenceTypeSettingInsightType[keyof typeof IntelligenceTypeSettingInsightType];


export const IntelligenceTypeSettingInsightType = {
  sales_spike: 'sales_spike',
  sales_drop: 'sales_drop',
  marketplace_change: 'marketplace_change',
  stockout_risk: 'stockout_risk',
  slow_moving_stock: 'slow_moving_stock',
  high_return_rate: 'high_return_rate',
  packing_delay: 'packing_delay',
  hr_warning: 'hr_warning',
  social_change: 'social_change',
  profit_warning: 'profit_warning',
  customer_behaviour_change: 'customer_behaviour_change',
} as const;

export interface IntelligenceTypeSetting {
  insightType: IntelligenceTypeSettingInsightType;
  enabled?: boolean | null;
  threshold?: number | null;
  secondaryThreshold?: number | null;
}

export type IntelligenceSettingsNotifySeverity = typeof IntelligenceSettingsNotifySeverity[keyof typeof IntelligenceSettingsNotifySeverity];


export const IntelligenceSettingsNotifySeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;

export interface IntelligenceSettings {
  salesSpikePct: number;
  salesDropPct: number;
  marketplaceChangePct: number;
  stockoutDays: number;
  slowMoverDays: number;
  slowMoverMinValue: number;
  returnRatePct: number;
  packingDelayHours: number;
  profitDropPct: number;
  notifySeverity: IntelligenceSettingsNotifySeverity;
  typeSettings: IntelligenceTypeSetting[];
  lastRunAt?: string | null;
}

export type IntelligenceSettingsUpdateNotifySeverity = typeof IntelligenceSettingsUpdateNotifySeverity[keyof typeof IntelligenceSettingsUpdateNotifySeverity];


export const IntelligenceSettingsUpdateNotifySeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;

export interface IntelligenceSettingsUpdate {
  salesSpikePct?: number;
  salesDropPct?: number;
  marketplaceChangePct?: number;
  stockoutDays?: number;
  slowMoverDays?: number;
  slowMoverMinValue?: number;
  returnRatePct?: number;
  packingDelayHours?: number;
  profitDropPct?: number;
  notifySeverity?: IntelligenceSettingsUpdateNotifySeverity;
  typeSettings?: IntelligenceTypeSetting[];
}

export type PurchaseRecommendationUrgency = typeof PurchaseRecommendationUrgency[keyof typeof PurchaseRecommendationUrgency];


export const PurchaseRecommendationUrgency = {
  critical: 'critical',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export type PurchaseRecommendationStatus = typeof PurchaseRecommendationStatus[keyof typeof PurchaseRecommendationStatus];


export const PurchaseRecommendationStatus = {
  open: 'open',
  converted: 'converted',
  dismissed: 'dismissed',
} as const;

export interface PurchaseRecommendation {
  id: string;
  inventoryItemId: string;
  sku?: string | null;
  title?: string | null;
  categoryId?: string | null;
  suggestedSupplierId?: string | null;
  suggestedSupplierName?: string | null;
  supplierReason?: string | null;
  recommendedQty: number;
  reorderPoint: number;
  safetyStockUnits: number;
  avgDailySales: number;
  daysOfStockRemaining?: number | null;
  leadTimeDays: number;
  unitCostGbp: number;
  estimatedCostGbp: number;
  urgency: PurchaseRecommendationUrgency;
  reason?: string | null;
  status: PurchaseRecommendationStatus;
  sourceRecommendationId?: string | null;
  purchaseOrderId?: string | null;
  approvedBy?: string | null;
  approvedAt?: string | null;
  dismissedBy?: string | null;
  dismissedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SupplierPerformance {
  id: string;
  supplierId: string;
  supplierName?: string | null;
  totalPos: number;
  completedPos: number;
  onTimePos: number;
  latePos: number;
  avgLeadTimeDays?: number | null;
  leadTimeReliability?: number | null;
  totalSpendGbp: number;
  avgUnitCostGbp?: number | null;
  lastOrderAt?: string | null;
  lastDeliveryAt?: string | null;
  computedAt: string;
}

export interface PurchasingRunResult {
  ran: boolean;
  itemsProcessed: number;
  recommendationsCreated: number;
  suppliersEvaluated: number;
  notificationsFired?: number;
  runLogId?: string | null;
}

export type PurchasingRunLogTriggerType = typeof PurchasingRunLogTriggerType[keyof typeof PurchasingRunLogTriggerType];


export const PurchasingRunLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
  system: 'system',
} as const;

export type PurchasingRunLogStatus = typeof PurchasingRunLogStatus[keyof typeof PurchasingRunLogStatus];


export const PurchasingRunLogStatus = {
  running: 'running',
  success: 'success',
  failed: 'failed',
} as const;

export interface PurchasingRunLog {
  id: string;
  triggeredBy?: string | null;
  triggerType: PurchasingRunLogTriggerType;
  status: PurchasingRunLogStatus;
  itemsProcessed: number;
  recommendationsCreated: number;
  suppliersEvaluated: number;
  notificationsFired: number;
  message?: string | null;
  errorMessage?: string | null;
  durationMs?: number | null;
  startedAt: string;
  completedAt?: string | null;
}

export interface PurchasingSummary {
  openRecommendations: number;
  criticalRecommendations: number;
  convertedRecommendations: number;
  estimatedOpenSpend: number;
  totalSuppliers: number;
  avgReliability: number;
  lastRun?: PurchasingRunLog | null;
}

export interface PurchaseApproveRequest {
  supplierId?: string | null;
}

export interface PurchaseApproveResult {
  purchaseOrderId: string;
  recommendation?: PurchaseRecommendation | null;
}

export interface PurchaseBulkApproveRequest {
  ids?: string[];
}

export interface PurchaseBulkApproveResult {
  createdPurchaseOrderIds: string[];
  approvedRecommendations: number;
  skippedNoSupplier: number;
}

export type PurchasingSettingsMinRecommendationUrgency = typeof PurchasingSettingsMinRecommendationUrgency[keyof typeof PurchasingSettingsMinRecommendationUrgency];


export const PurchasingSettingsMinRecommendationUrgency = {
  critical: 'critical',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export interface PurchasingSettings {
  defaultLeadTimeDays: number;
  leadTimeSafetyDays: number;
  minRecommendationUrgency: PurchasingSettingsMinRecommendationUrgency;
  groupBySupplier: boolean;
  minOrderValueGbp: number;
  notifyOnRecommendation: boolean;
  performanceWindowDays: number;
  lastRunAt?: string | null;
}

export type PurchasingSettingsUpdateMinRecommendationUrgency = typeof PurchasingSettingsUpdateMinRecommendationUrgency[keyof typeof PurchasingSettingsUpdateMinRecommendationUrgency];


export const PurchasingSettingsUpdateMinRecommendationUrgency = {
  critical: 'critical',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export interface PurchasingSettingsUpdate {
  defaultLeadTimeDays?: number;
  leadTimeSafetyDays?: number;
  minRecommendationUrgency?: PurchasingSettingsUpdateMinRecommendationUrgency;
  groupBySupplier?: boolean;
  minOrderValueGbp?: number;
  notifyOnRecommendation?: boolean;
  performanceWindowDays?: number;
}

export type AutomationConditionDefOperator = typeof AutomationConditionDefOperator[keyof typeof AutomationConditionDefOperator];


export const AutomationConditionDefOperator = {
  eq: 'eq',
  neq: 'neq',
  gt: 'gt',
  gte: 'gte',
  lt: 'lt',
  lte: 'lte',
  contains: 'contains',
  not_contains: 'not_contains',
  is_empty: 'is_empty',
  is_not_empty: 'is_not_empty',
} as const;

export interface AutomationConditionDef {
  field: string;
  operator: AutomationConditionDefOperator;
  value?: string | number | boolean | null;
}

export type AutomationActionDefActionType = typeof AutomationActionDefActionType[keyof typeof AutomationActionDefActionType];


export const AutomationActionDefActionType = {
  send_alert: 'send_alert',
  create_task: 'create_task',
  send_email: 'send_email',
} as const;

export type AutomationActionDefConfig = { [key: string]: unknown };

export interface AutomationActionDef {
  id?: string | null;
  actionType: AutomationActionDefActionType;
  config?: AutomationActionDefConfig;
  enabled?: boolean;
  sortOrder?: number;
}

export type AutomationActionResultActionType = typeof AutomationActionResultActionType[keyof typeof AutomationActionResultActionType];


export const AutomationActionResultActionType = {
  send_alert: 'send_alert',
  create_task: 'create_task',
  send_email: 'send_email',
} as const;

export type AutomationActionResultStatus = typeof AutomationActionResultStatus[keyof typeof AutomationActionResultStatus];


export const AutomationActionResultStatus = {
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface AutomationActionResult {
  actionId?: string | null;
  actionType: AutomationActionResultActionType;
  status: AutomationActionResultStatus;
  message?: string | null;
}

export type AutomationWorkflowSummaryEventType = typeof AutomationWorkflowSummaryEventType[keyof typeof AutomationWorkflowSummaryEventType];


export const AutomationWorkflowSummaryEventType = {
  order_paid: 'order_paid',
  order_shipped: 'order_shipped',
  return_created: 'return_created',
  low_stock: 'low_stock',
  staff_started: 'staff_started',
  scrap_settled: 'scrap_settled',
  social_post_failed: 'social_post_failed',
} as const;

export type AutomationWorkflowSummaryConditionLogic = typeof AutomationWorkflowSummaryConditionLogic[keyof typeof AutomationWorkflowSummaryConditionLogic];


export const AutomationWorkflowSummaryConditionLogic = {
  all: 'all',
  any: 'any',
} as const;

export type AutomationWorkflowSummaryLastOutcome = typeof AutomationWorkflowSummaryLastOutcome[keyof typeof AutomationWorkflowSummaryLastOutcome] | null;


export const AutomationWorkflowSummaryLastOutcome = {
  skipped: 'skipped',
  success: 'success',
  partial: 'partial',
  failed: 'failed',
} as const;

export interface AutomationWorkflowSummary {
  id: string;
  name: string;
  description?: string | null;
  enabled: boolean;
  eventType: AutomationWorkflowSummaryEventType;
  conditionLogic: AutomationWorkflowSummaryConditionLogic;
  conditionCount: number;
  actionCount: number;
  runCount: number;
  lastRunAt?: string | null;
  lastOutcome?: AutomationWorkflowSummaryLastOutcome;
  createdAt: string;
  updatedAt: string;
}

export interface AutomationWorkflowList {
  items: AutomationWorkflowSummary[];
  total: number;
}

export type AutomationWorkflowDetailEventType = typeof AutomationWorkflowDetailEventType[keyof typeof AutomationWorkflowDetailEventType];


export const AutomationWorkflowDetailEventType = {
  order_paid: 'order_paid',
  order_shipped: 'order_shipped',
  return_created: 'return_created',
  low_stock: 'low_stock',
  staff_started: 'staff_started',
  scrap_settled: 'scrap_settled',
  social_post_failed: 'social_post_failed',
} as const;

export type AutomationWorkflowDetailConditionLogic = typeof AutomationWorkflowDetailConditionLogic[keyof typeof AutomationWorkflowDetailConditionLogic];


export const AutomationWorkflowDetailConditionLogic = {
  all: 'all',
  any: 'any',
} as const;

export type AutomationWorkflowDetailLastOutcome = typeof AutomationWorkflowDetailLastOutcome[keyof typeof AutomationWorkflowDetailLastOutcome] | null;


export const AutomationWorkflowDetailLastOutcome = {
  skipped: 'skipped',
  success: 'success',
  partial: 'partial',
  failed: 'failed',
} as const;

export interface AutomationWorkflowDetail {
  id: string;
  name: string;
  description?: string | null;
  enabled: boolean;
  eventType: AutomationWorkflowDetailEventType;
  conditionLogic: AutomationWorkflowDetailConditionLogic;
  conditions: AutomationConditionDef[];
  actions: AutomationActionDef[];
  runCount: number;
  lastRunAt?: string | null;
  lastOutcome?: AutomationWorkflowDetailLastOutcome;
  createdAt: string;
  updatedAt: string;
}

export type AutomationWorkflowCreateEventType = typeof AutomationWorkflowCreateEventType[keyof typeof AutomationWorkflowCreateEventType];


export const AutomationWorkflowCreateEventType = {
  order_paid: 'order_paid',
  order_shipped: 'order_shipped',
  return_created: 'return_created',
  low_stock: 'low_stock',
  staff_started: 'staff_started',
  scrap_settled: 'scrap_settled',
  social_post_failed: 'social_post_failed',
} as const;

export type AutomationWorkflowCreateConditionLogic = typeof AutomationWorkflowCreateConditionLogic[keyof typeof AutomationWorkflowCreateConditionLogic];


export const AutomationWorkflowCreateConditionLogic = {
  all: 'all',
  any: 'any',
} as const;

export interface AutomationWorkflowCreate {
  name: string;
  description?: string | null;
  enabled?: boolean;
  eventType: AutomationWorkflowCreateEventType;
  conditionLogic?: AutomationWorkflowCreateConditionLogic;
  conditions?: AutomationConditionDef[];
  actions: AutomationActionDef[];
}

export type AutomationWorkflowUpdateEventType = typeof AutomationWorkflowUpdateEventType[keyof typeof AutomationWorkflowUpdateEventType];


export const AutomationWorkflowUpdateEventType = {
  order_paid: 'order_paid',
  order_shipped: 'order_shipped',
  return_created: 'return_created',
  low_stock: 'low_stock',
  staff_started: 'staff_started',
  scrap_settled: 'scrap_settled',
  social_post_failed: 'social_post_failed',
} as const;

export type AutomationWorkflowUpdateConditionLogic = typeof AutomationWorkflowUpdateConditionLogic[keyof typeof AutomationWorkflowUpdateConditionLogic];


export const AutomationWorkflowUpdateConditionLogic = {
  all: 'all',
  any: 'any',
} as const;

export interface AutomationWorkflowUpdate {
  name?: string;
  description?: string | null;
  enabled?: boolean;
  eventType?: AutomationWorkflowUpdateEventType;
  conditionLogic?: AutomationWorkflowUpdateConditionLogic;
  conditions?: AutomationConditionDef[];
  actions?: AutomationActionDef[];
}

export type AutomationLogTriggerEvent = typeof AutomationLogTriggerEvent[keyof typeof AutomationLogTriggerEvent];


export const AutomationLogTriggerEvent = {
  order_paid: 'order_paid',
  order_shipped: 'order_shipped',
  return_created: 'return_created',
  low_stock: 'low_stock',
  staff_started: 'staff_started',
  scrap_settled: 'scrap_settled',
  social_post_failed: 'social_post_failed',
} as const;

export type AutomationLogMode = typeof AutomationLogMode[keyof typeof AutomationLogMode];


export const AutomationLogMode = {
  live: 'live',
  test: 'test',
} as const;

export type AutomationLogOutcome = typeof AutomationLogOutcome[keyof typeof AutomationLogOutcome];


export const AutomationLogOutcome = {
  skipped: 'skipped',
  success: 'success',
  partial: 'partial',
  failed: 'failed',
} as const;

export type AutomationLogEventPayload = { [key: string]: unknown };

export interface AutomationLog {
  id: string;
  workflowId: string;
  workflowName?: string | null;
  triggerEvent: AutomationLogTriggerEvent;
  mode: AutomationLogMode;
  matched: boolean;
  outcome: AutomationLogOutcome;
  eventPayload?: AutomationLogEventPayload;
  actionsResult: AutomationActionResult[];
  errorMessage?: string | null;
  durationMs?: number | null;
  createdAt: string;
}

export interface AutomationLogList {
  items: AutomationLog[];
  total: number;
}

export type AutomationTestRequestEventPayload = { [key: string]: unknown };

export interface AutomationTestRequest {
  eventPayload?: AutomationTestRequestEventPayload;
}

export type AutomationTestResultOutcome = typeof AutomationTestResultOutcome[keyof typeof AutomationTestResultOutcome];


export const AutomationTestResultOutcome = {
  skipped: 'skipped',
  success: 'success',
  partial: 'partial',
  failed: 'failed',
} as const;

export interface AutomationTestResult {
  matched: boolean;
  outcome: AutomationTestResultOutcome;
  actionsResult: AutomationActionResult[];
  message?: string | null;
}

export type AutomationRegistryTriggerEventType = typeof AutomationRegistryTriggerEventType[keyof typeof AutomationRegistryTriggerEventType];


export const AutomationRegistryTriggerEventType = {
  order_paid: 'order_paid',
  order_shipped: 'order_shipped',
  return_created: 'return_created',
  low_stock: 'low_stock',
  staff_started: 'staff_started',
  scrap_settled: 'scrap_settled',
  social_post_failed: 'social_post_failed',
} as const;

export type AutomationRegistryTriggerFieldsItemType = typeof AutomationRegistryTriggerFieldsItemType[keyof typeof AutomationRegistryTriggerFieldsItemType];


export const AutomationRegistryTriggerFieldsItemType = {
  string: 'string',
  number: 'number',
  boolean: 'boolean',
} as const;

export type AutomationRegistryTriggerFieldsItem = {
  path: string;
  label: string;
  type: AutomationRegistryTriggerFieldsItemType;
};

export interface AutomationRegistryTrigger {
  eventType: AutomationRegistryTriggerEventType;
  label: string;
  description: string;
  fields: AutomationRegistryTriggerFieldsItem[];
}

export type AutomationRegistryOperatorOperator = typeof AutomationRegistryOperatorOperator[keyof typeof AutomationRegistryOperatorOperator];


export const AutomationRegistryOperatorOperator = {
  eq: 'eq',
  neq: 'neq',
  gt: 'gt',
  gte: 'gte',
  lt: 'lt',
  lte: 'lte',
  contains: 'contains',
  not_contains: 'not_contains',
  is_empty: 'is_empty',
  is_not_empty: 'is_not_empty',
} as const;

export interface AutomationRegistryOperator {
  operator: AutomationRegistryOperatorOperator;
  label: string;
  unary: boolean;
}

export type AutomationRegistryActionFieldType = typeof AutomationRegistryActionFieldType[keyof typeof AutomationRegistryActionFieldType];


export const AutomationRegistryActionFieldType = {
  string: 'string',
  text: 'text',
  number: 'number',
  boolean: 'boolean',
  select: 'select',
} as const;

export type AutomationRegistryActionFieldOptionsItem = {
  value: string;
  label: string;
};

export interface AutomationRegistryActionField {
  key: string;
  label: string;
  type: AutomationRegistryActionFieldType;
  required: boolean;
  placeholder?: string | null;
  options?: AutomationRegistryActionFieldOptionsItem[] | null;
}

export type AutomationRegistryActionActionType = typeof AutomationRegistryActionActionType[keyof typeof AutomationRegistryActionActionType];


export const AutomationRegistryActionActionType = {
  send_alert: 'send_alert',
  create_task: 'create_task',
  send_email: 'send_email',
} as const;

export interface AutomationRegistryAction {
  actionType: AutomationRegistryActionActionType;
  label: string;
  description: string;
  requiresFeature: string | null;
  fields: AutomationRegistryActionField[];
}

export interface AutomationRegistry {
  triggers: AutomationRegistryTrigger[];
  operators: AutomationRegistryOperator[];
  actions: AutomationRegistryAction[];
}

export type PricingRuleRuleType = typeof PricingRuleRuleType[keyof typeof PricingRuleRuleType];


export const PricingRuleRuleType = {
  spot_price_markup: 'spot_price_markup',
  stock_level: 'stock_level',
  sales_velocity: 'sales_velocity',
  marketplace_adjustment: 'marketplace_adjustment',
  margin_target: 'margin_target',
  competitor_price: 'competitor_price',
  customer_group: 'customer_group',
  dropship_markup: 'dropship_markup',
  manual_override: 'manual_override',
  price_source: 'price_source',
} as const;

export type PricingRuleScope = typeof PricingRuleScope[keyof typeof PricingRuleScope];


export const PricingRuleScope = {
  all: 'all',
  category: 'category',
  item: 'item',
  channel: 'channel',
  sku: 'sku',
  product_family: 'product_family',
  brand_mint: 'brand_mint',
  supplier: 'supplier',
  marketplace: 'marketplace',
  customer_group: 'customer_group',
  tenant_default: 'tenant_default',
} as const;

export type PricingRuleConfig = { [key: string]: unknown };

export type PricingRuleRoundingStrategy = typeof PricingRuleRoundingStrategy[keyof typeof PricingRuleRoundingStrategy] | null;


export const PricingRuleRoundingStrategy = {
  none: 'none',
  nearest_pound: 'nearest_pound',
  ends_99: 'ends_99',
  ends_95: 'ends_95',
} as const;

export type PricingRuleApplyMode = typeof PricingRuleApplyMode[keyof typeof PricingRuleApplyMode] | null;


export const PricingRuleApplyMode = {
  recommend_only: 'recommend_only',
  auto_apply_internal: 'auto_apply_internal',
  approval_required: 'approval_required',
  auto_publish: 'auto_publish',
} as const;

export interface PricingRule {
  id: string;
  name: string;
  description?: string | null;
  ruleType: PricingRuleRuleType;
  enabled: boolean;
  priority: number;
  scope: PricingRuleScope;
  categoryId?: string | null;
  inventoryItemId?: string | null;
  channel?: string | null;
  sku?: string | null;
  productFamily?: string | null;
  brandMint?: string | null;
  supplierId?: string | null;
  customerGroup?: string | null;
  config: PricingRuleConfig;
  minMarginPercent?: number | null;
  maxChangePercent?: number | null;
  roundingStrategy?: PricingRuleRoundingStrategy;
  autoApply?: boolean | null;
  applyMode?: PricingRuleApplyMode;
  maxIncreasePercent?: number | null;
  maxDecreasePercent?: number | null;
  maxChangeGbp?: number | null;
  minMinutesBetweenChanges?: number | null;
  forceApprovalAbovePercent?: number | null;
  lastRunAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type PricingRuleCreateRuleType = typeof PricingRuleCreateRuleType[keyof typeof PricingRuleCreateRuleType];


export const PricingRuleCreateRuleType = {
  spot_price_markup: 'spot_price_markup',
  stock_level: 'stock_level',
  sales_velocity: 'sales_velocity',
  marketplace_adjustment: 'marketplace_adjustment',
  margin_target: 'margin_target',
  competitor_price: 'competitor_price',
  customer_group: 'customer_group',
  dropship_markup: 'dropship_markup',
  manual_override: 'manual_override',
  price_source: 'price_source',
} as const;

export type PricingRuleCreateScope = typeof PricingRuleCreateScope[keyof typeof PricingRuleCreateScope];


export const PricingRuleCreateScope = {
  all: 'all',
  category: 'category',
  item: 'item',
  channel: 'channel',
  sku: 'sku',
  product_family: 'product_family',
  brand_mint: 'brand_mint',
  supplier: 'supplier',
  marketplace: 'marketplace',
  customer_group: 'customer_group',
  tenant_default: 'tenant_default',
} as const;

export type PricingRuleCreateConfig = { [key: string]: unknown };

export type PricingRuleCreateRoundingStrategy = typeof PricingRuleCreateRoundingStrategy[keyof typeof PricingRuleCreateRoundingStrategy] | null;


export const PricingRuleCreateRoundingStrategy = {
  none: 'none',
  nearest_pound: 'nearest_pound',
  ends_99: 'ends_99',
  ends_95: 'ends_95',
} as const;

export type PricingRuleCreateApplyMode = typeof PricingRuleCreateApplyMode[keyof typeof PricingRuleCreateApplyMode] | null;


export const PricingRuleCreateApplyMode = {
  recommend_only: 'recommend_only',
  auto_apply_internal: 'auto_apply_internal',
  approval_required: 'approval_required',
  auto_publish: 'auto_publish',
} as const;

export interface PricingRuleCreate {
  name: string;
  description?: string | null;
  ruleType: PricingRuleCreateRuleType;
  enabled?: boolean;
  priority?: number;
  scope?: PricingRuleCreateScope;
  categoryId?: string | null;
  inventoryItemId?: string | null;
  channel?: string | null;
  sku?: string | null;
  productFamily?: string | null;
  brandMint?: string | null;
  supplierId?: string | null;
  customerGroup?: string | null;
  config?: PricingRuleCreateConfig;
  minMarginPercent?: number | null;
  maxChangePercent?: number | null;
  roundingStrategy?: PricingRuleCreateRoundingStrategy;
  autoApply?: boolean | null;
  applyMode?: PricingRuleCreateApplyMode;
  maxIncreasePercent?: number | null;
  maxDecreasePercent?: number | null;
  maxChangeGbp?: number | null;
  minMinutesBetweenChanges?: number | null;
  forceApprovalAbovePercent?: number | null;
}

export type PricingRuleUpdateRuleType = typeof PricingRuleUpdateRuleType[keyof typeof PricingRuleUpdateRuleType];


export const PricingRuleUpdateRuleType = {
  spot_price_markup: 'spot_price_markup',
  stock_level: 'stock_level',
  sales_velocity: 'sales_velocity',
  marketplace_adjustment: 'marketplace_adjustment',
  margin_target: 'margin_target',
  competitor_price: 'competitor_price',
  customer_group: 'customer_group',
  dropship_markup: 'dropship_markup',
  manual_override: 'manual_override',
  price_source: 'price_source',
} as const;

export type PricingRuleUpdateScope = typeof PricingRuleUpdateScope[keyof typeof PricingRuleUpdateScope];


export const PricingRuleUpdateScope = {
  all: 'all',
  category: 'category',
  item: 'item',
  channel: 'channel',
  sku: 'sku',
  product_family: 'product_family',
  brand_mint: 'brand_mint',
  supplier: 'supplier',
  marketplace: 'marketplace',
  customer_group: 'customer_group',
  tenant_default: 'tenant_default',
} as const;

export type PricingRuleUpdateConfig = { [key: string]: unknown };

export type PricingRuleUpdateRoundingStrategy = typeof PricingRuleUpdateRoundingStrategy[keyof typeof PricingRuleUpdateRoundingStrategy] | null;


export const PricingRuleUpdateRoundingStrategy = {
  none: 'none',
  nearest_pound: 'nearest_pound',
  ends_99: 'ends_99',
  ends_95: 'ends_95',
} as const;

export type PricingRuleUpdateApplyMode = typeof PricingRuleUpdateApplyMode[keyof typeof PricingRuleUpdateApplyMode] | null;


export const PricingRuleUpdateApplyMode = {
  recommend_only: 'recommend_only',
  auto_apply_internal: 'auto_apply_internal',
  approval_required: 'approval_required',
  auto_publish: 'auto_publish',
} as const;

export interface PricingRuleUpdate {
  name?: string;
  description?: string | null;
  ruleType?: PricingRuleUpdateRuleType;
  enabled?: boolean;
  priority?: number;
  scope?: PricingRuleUpdateScope;
  categoryId?: string | null;
  inventoryItemId?: string | null;
  channel?: string | null;
  sku?: string | null;
  productFamily?: string | null;
  brandMint?: string | null;
  supplierId?: string | null;
  customerGroup?: string | null;
  config?: PricingRuleUpdateConfig;
  minMarginPercent?: number | null;
  maxChangePercent?: number | null;
  roundingStrategy?: PricingRuleUpdateRoundingStrategy;
  autoApply?: boolean | null;
  applyMode?: PricingRuleUpdateApplyMode;
  maxIncreasePercent?: number | null;
  maxDecreasePercent?: number | null;
  maxChangeGbp?: number | null;
  minMinutesBetweenChanges?: number | null;
  forceApprovalAbovePercent?: number | null;
}

export type PricingChangeApprovalMarginSeverity = typeof PricingChangeApprovalMarginSeverity[keyof typeof PricingChangeApprovalMarginSeverity] | null;


export const PricingChangeApprovalMarginSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export type PricingChangeApprovalStatus = typeof PricingChangeApprovalStatus[keyof typeof PricingChangeApprovalStatus];


export const PricingChangeApprovalStatus = {
  pending: 'pending',
  approved: 'approved',
  publishing: 'publishing',
  rejected: 'rejected',
  applied: 'applied',
  auto_applied: 'auto_applied',
  failed: 'failed',
  superseded: 'superseded',
  scheduled: 'scheduled',
  ignored: 'ignored',
} as const;

export type PricingChangeApprovalApplyMode = typeof PricingChangeApprovalApplyMode[keyof typeof PricingChangeApprovalApplyMode] | null;


export const PricingChangeApprovalApplyMode = {
  recommend_only: 'recommend_only',
  auto_apply_internal: 'auto_apply_internal',
  approval_required: 'approval_required',
  auto_publish: 'auto_publish',
} as const;

export type PricingChangeApprovalPushResult = { [key: string]: unknown };

export interface PricingChangeApproval {
  id: string;
  inventoryItemId: string;
  sku?: string | null;
  title?: string | null;
  channel?: string | null;
  ruleId?: string | null;
  ruleName?: string | null;
  ruleType?: string | null;
  currentPrice: number;
  proposedPrice: number;
  minAcceptablePrice?: number | null;
  landedUnitCost?: number | null;
  marginPercent?: number | null;
  trueProfitGbp?: number | null;
  trueMarginPercent?: number | null;
  minimumSafePrice?: number | null;
  marginSeverity?: PricingChangeApprovalMarginSeverity;
  calculationSnapshotId?: string | null;
  reason?: string | null;
  status: PricingChangeApprovalStatus;
  reviewedBy?: string | null;
  reviewedAt?: string | null;
  appliedBy?: string | null;
  appliedAt?: string | null;
  applyError?: string | null;
  applyMode?: PricingChangeApprovalApplyMode;
  shouldPublish?: boolean;
  pushResult?: PricingChangeApprovalPushResult;
  pushError?: string | null;
  scheduledFor?: string | null;
  ignored?: boolean;
  createdAt: string;
  updatedAt: string;
}

export type PricingApprovalActionResult = PricingChangeApproval & ({
  jobId?: string | null;
});

export type PricingPriceHistoryEntryEvent = typeof PricingPriceHistoryEntryEvent[keyof typeof PricingPriceHistoryEntryEvent];


export const PricingPriceHistoryEntryEvent = {
  calculated: 'calculated',
  auto_applied: 'auto_applied',
  approved_applied: 'approved_applied',
  scheduled_applied: 'scheduled_applied',
  scheduled_reverted: 'scheduled_reverted',
  bulk_applied: 'bulk_applied',
  published: 'published',
  publish_failed: 'publish_failed',
} as const;

export type PricingPriceHistoryEntryPushResult = { [key: string]: unknown };

export interface PricingPriceHistoryEntry {
  id: string;
  inventoryItemId: string;
  sku?: string | null;
  title?: string | null;
  channel?: string | null;
  event: PricingPriceHistoryEntryEvent;
  oldPrice?: number | null;
  newPrice: number;
  ruleId?: string | null;
  ruleName?: string | null;
  reason?: string | null;
  costAtTimeGbp?: number | null;
  spotAtTimeGbpPerOz?: number | null;
  spotMetal?: string | null;
  expectedProfitGbp?: number | null;
  expectedMarginPercent?: number | null;
  approvalId?: string | null;
  bulkJobId?: string | null;
  scheduleId?: string | null;
  approvedBy?: string | null;
  publishedBy?: string | null;
  pushResult?: PricingPriceHistoryEntryPushResult;
  pushError?: string | null;
  createdAt: string;
}

export interface PricingScheduleConfig {
  weekdays?: number[] | null;
  startTime?: string | null;
  endTime?: string | null;
  minMarginPercentOverride?: number | null;
  priceAdjustPercent?: number | null;
  ruleIds?: string[] | null;
}

export type PricingScheduleKind = typeof PricingScheduleKind[keyof typeof PricingScheduleKind];


export const PricingScheduleKind = {
  window: 'window',
  weekday: 'weekday',
  campaign: 'campaign',
} as const;

export interface PricingSchedule {
  id: string;
  name: string;
  description?: string | null;
  enabled: boolean;
  kind: PricingScheduleKind;
  startsAt?: string | null;
  endsAt?: string | null;
  config?: PricingScheduleConfig;
  active: boolean;
  activatedAt?: string | null;
  revertedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type PricingScheduleUpsertKind = typeof PricingScheduleUpsertKind[keyof typeof PricingScheduleUpsertKind];


export const PricingScheduleUpsertKind = {
  window: 'window',
  weekday: 'weekday',
  campaign: 'campaign',
} as const;

export interface PricingScheduleUpsert {
  name?: string;
  description?: string | null;
  enabled?: boolean;
  kind?: PricingScheduleUpsertKind;
  startsAt?: string | null;
  endsAt?: string | null;
  config?: PricingScheduleConfig;
}

export interface PricingBulkSelection {
  itemIds?: string[] | null;
  q?: string | null;
  categoryId?: string | null;
  supplierId?: string | null;
  brandMint?: string | null;
  marketplace?: string | null;
}

export type PricingBulkSimulationItemsItem = { [key: string]: unknown };

export interface PricingBulkSimulation {
  productCount: number;
  currentExpectedRevenueGbp: number;
  newExpectedRevenueGbp: number;
  estimatedProfitChangeGbp: number;
  marginFloorHits: number;
  approvalsRequired: number;
  items?: PricingBulkSimulationItemsItem[] | null;
  /** True when the returned `items` detail was capped for response size; the persisted simulation (and the apply phase) always covers the full selection. */
  itemsTruncated?: boolean | null;
}

export type PricingBulkJobStatus = typeof PricingBulkJobStatus[keyof typeof PricingBulkJobStatus];


export const PricingBulkJobStatus = {
  simulating: 'simulating',
  simulated: 'simulated',
  confirmed: 'confirmed',
  applying: 'applying',
  applied: 'applied',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export interface PricingBulkJob {
  id: string;
  name?: string | null;
  status: PricingBulkJobStatus;
  selection: PricingBulkSelection;
  publish: boolean;
  simulation?: PricingBulkSimulation | null;
  appliedCount: number;
  failedCount: number;
  errorMessage?: string | null;
  backgroundJobId?: string | null;
  createdBy?: string | null;
  confirmedBy?: string | null;
  confirmedAt?: string | null;
  completedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type PricingApprovalBreakdownSnapshot = { [key: string]: unknown } | null;

export interface PricingApprovalBreakdown {
  approval: PricingChangeApproval;
  snapshot?: PricingApprovalBreakdownSnapshot;
  history?: PricingPriceHistoryEntry[];
}

export interface PricingDashboard {
  productsBelowTargetMargin: number;
  revenueAtRiskGbp: number;
  marginProtectedTodayGbp: number;
  changesPendingApproval: number;
  automatedPriceChangesToday: number;
  averageTrueMarginPercent?: number | null;
  spotLinkedProducts: number;
  premiumProductsRequiringReview: number;
  targetMarginPercent: number;
  spotStale: boolean;
  generatedAt: string;
}

export type PricingMarginViolationSeverity = typeof PricingMarginViolationSeverity[keyof typeof PricingMarginViolationSeverity];


export const PricingMarginViolationSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export type PricingMarginViolationKind = typeof PricingMarginViolationKind[keyof typeof PricingMarginViolationKind];


export const PricingMarginViolationKind = {
  absolute_profit: 'absolute_profit',
  gross_margin_percent: 'gross_margin_percent',
  true_margin_percent: 'true_margin_percent',
  premium_over_melt_percent: 'premium_over_melt_percent',
  markup_percent: 'markup_percent',
  minimum_price: 'minimum_price',
} as const;

export interface PricingMarginViolation {
  ruleId: string;
  ruleName: string;
  severity: PricingMarginViolationSeverity;
  kind: PricingMarginViolationKind;
  required: number;
  actual: number;
  proposedPrice: number;
  estimatedTrueProfitGbp: number;
  estimatedTrueMarginPercent: number;
  minimumSafePrice?: number | null;
}

export type PricingItemContextRecommendationSource = typeof PricingItemContextRecommendationSource[keyof typeof PricingItemContextRecommendationSource] | null;


export const PricingItemContextRecommendationSource = {
  approval: 'approval',
  snapshot: 'snapshot',
} as const;

export type PricingItemContextMarginSeverity = typeof PricingItemContextMarginSeverity[keyof typeof PricingItemContextMarginSeverity] | null;


export const PricingItemContextMarginSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export type PricingItemContextCostBreakdown = { [key: string]: unknown } | null;

export interface PricingItemContext {
  inventoryItemId: string;
  sku?: string | null;
  title?: string | null;
  channel?: string | null;
  currentPrice?: number | null;
  recommendedPrice?: number | null;
  recommendationSource?: PricingItemContextRecommendationSource;
  recommendationApprovalId?: string | null;
  minimumSafePrice?: number | null;
  marginSeverity?: PricingItemContextMarginSeverity;
  violations: PricingMarginViolation[];
  trueMarginPercent?: number | null;
  trueProfitGbp?: number | null;
  targetMarginPercent: number;
  belowTargetMargin: boolean;
  costBreakdown?: PricingItemContextCostBreakdown;
  spotLinked: boolean;
  premium: boolean;
  requiresValuationReview: boolean;
  quantityAvailable: number;
  meltValueGbp?: number | null;
  spotStale: boolean;
}

export interface PricingProductPage {
  items: PricingItemContext[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PricingEvaluateRequest {
  inventoryItemId: string;
  price: number;
  channel?: string | null;
}

export type PricingMarginPreviewSeverity = typeof PricingMarginPreviewSeverity[keyof typeof PricingMarginPreviewSeverity] | null;


export const PricingMarginPreviewSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export type PricingMarginPreviewCostBreakdown = { [key: string]: unknown } | null;

export interface PricingMarginPreview {
  inventoryItemId: string;
  sku?: string | null;
  channel?: string | null;
  proposedPrice: number;
  severity?: PricingMarginPreviewSeverity;
  blocked: boolean;
  requiresApproval: boolean;
  requiresOverride: boolean;
  minimumSafePrice?: number | null;
  estimatedTrueProfitGbp?: number | null;
  estimatedTrueMarginPercent?: number | null;
  violations: PricingMarginViolation[];
  meltUnverifiable: boolean;
  costBreakdown?: PricingMarginPreviewCostBreakdown;
  canOverride: boolean;
}

export type PricingExplainRequestTopic = typeof PricingExplainRequestTopic[keyof typeof PricingExplainRequestTopic];


export const PricingExplainRequestTopic = {
  recommended_price: 'recommended_price',
  margin_change: 'margin_change',
  portfolio_outliers: 'portfolio_outliers',
} as const;

export interface PricingExplainRequest {
  topic: PricingExplainRequestTopic;
  inventoryItemId?: string | null;
  channel?: string | null;
}

export type PricingExplainResultTopic = typeof PricingExplainResultTopic[keyof typeof PricingExplainResultTopic];


export const PricingExplainResultTopic = {
  recommended_price: 'recommended_price',
  margin_change: 'margin_change',
  portfolio_outliers: 'portfolio_outliers',
} as const;

export type PricingExplainResultFacts = { [key: string]: unknown };

export interface PricingExplainResult {
  topic: PricingExplainResultTopic;
  explanation: string;
  facts: PricingExplainResultFacts;
  aiUnavailable: boolean;
}

export interface PricingRunResult {
  ran: boolean;
  skippedReason?: string | null;
  runLogId?: string | null;
  rulesEvaluated: number;
  itemsEvaluated: number;
  changesProposed: number;
  changesAutoApplied: number;
  approvalsCreated: number;
  notificationsFired: number;
  spotStale?: boolean;
  autoApplyPausedForStaleSpot?: boolean;
  changesBlocked?: number;
}

export type PricingRunLogTriggerType = typeof PricingRunLogTriggerType[keyof typeof PricingRunLogTriggerType];


export const PricingRunLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
  system: 'system',
} as const;

export type PricingRunLogStatus = typeof PricingRunLogStatus[keyof typeof PricingRunLogStatus];


export const PricingRunLogStatus = {
  running: 'running',
  success: 'success',
  failed: 'failed',
} as const;

export interface PricingRunLog {
  id: string;
  triggeredBy?: string | null;
  triggerType: PricingRunLogTriggerType;
  status: PricingRunLogStatus;
  rulesEvaluated: number;
  itemsEvaluated: number;
  changesProposed: number;
  changesAutoApplied: number;
  approvalsCreated: number;
  notificationsFired: number;
  message?: string | null;
  errorMessage?: string | null;
  durationMs?: number | null;
  startedAt: string;
  completedAt?: string | null;
}

export interface PricingSummary {
  totalRules: number;
  enabledRules: number;
  pendingApprovals: number;
  appliedChanges: number;
  failedChanges: number;
  lastRun?: PricingRunLog | null;
}

export interface PricingCustomFee {
  label: string;
  amountGbp?: number | null;
  percent?: number | null;
}

export interface PricingFeeProfile {
  id: string;
  name: string;
  channel: string;
  version: number;
  effectiveFrom: string;
  effectiveTo?: string | null;
  archived: boolean;
  feePercent: number;
  fixedFeeGbp: number;
  paymentFeePercent: number;
  paymentFixedFeeGbp: number;
  vatOnFees: boolean;
  returnsAllowancePercent: number;
  promoAllowancePercent: number;
  postageAllowanceGbp: number;
  packagingAllowanceGbp: number;
  customFees: PricingCustomFee[];
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PricingFeeProfileCreate {
  name: string;
  channel: string;
  effectiveFrom?: string;
  effectiveTo?: string | null;
  feePercent?: number;
  fixedFeeGbp?: number;
  paymentFeePercent?: number;
  paymentFixedFeeGbp?: number;
  vatOnFees?: boolean;
  returnsAllowancePercent?: number;
  promoAllowancePercent?: number;
  postageAllowanceGbp?: number;
  packagingAllowanceGbp?: number;
  customFees?: PricingCustomFee[];
  notes?: string | null;
}

export interface PricingFeeProfileUpdate {
  name?: string;
  effectiveFrom?: string;
  effectiveTo?: string | null;
  archived?: boolean;
  feePercent?: number;
  fixedFeeGbp?: number;
  paymentFeePercent?: number;
  paymentFixedFeeGbp?: number;
  vatOnFees?: boolean;
  returnsAllowancePercent?: number;
  promoAllowancePercent?: number;
  postageAllowanceGbp?: number;
  packagingAllowanceGbp?: number;
  customFees?: PricingCustomFee[];
  notes?: string | null;
}

export type PricingMarginRuleLevel = typeof PricingMarginRuleLevel[keyof typeof PricingMarginRuleLevel];


export const PricingMarginRuleLevel = {
  tenant: 'tenant',
  product: 'product',
} as const;

export type PricingMarginRuleSeverity = typeof PricingMarginRuleSeverity[keyof typeof PricingMarginRuleSeverity];


export const PricingMarginRuleSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export interface PricingMarginRule {
  id: string;
  name: string;
  description?: string | null;
  enabled: boolean;
  level: PricingMarginRuleLevel;
  inventoryItemId?: string | null;
  channel?: string | null;
  severity: PricingMarginRuleSeverity;
  minAbsoluteProfitGbp?: number | null;
  minGrossMarginPercent?: number | null;
  minTrueMarginPercent?: number | null;
  minPremiumOverMeltPercent?: number | null;
  minMarkupPercent?: number | null;
  minPriceGbp?: number | null;
  createdAt: string;
  updatedAt: string;
}

export type PricingMarginRuleCreateLevel = typeof PricingMarginRuleCreateLevel[keyof typeof PricingMarginRuleCreateLevel];


export const PricingMarginRuleCreateLevel = {
  tenant: 'tenant',
  product: 'product',
} as const;

export type PricingMarginRuleCreateSeverity = typeof PricingMarginRuleCreateSeverity[keyof typeof PricingMarginRuleCreateSeverity];


export const PricingMarginRuleCreateSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export interface PricingMarginRuleCreate {
  name: string;
  description?: string | null;
  enabled?: boolean;
  level?: PricingMarginRuleCreateLevel;
  inventoryItemId?: string | null;
  channel?: string | null;
  severity?: PricingMarginRuleCreateSeverity;
  minAbsoluteProfitGbp?: number | null;
  minGrossMarginPercent?: number | null;
  minTrueMarginPercent?: number | null;
  minPremiumOverMeltPercent?: number | null;
  minMarkupPercent?: number | null;
  minPriceGbp?: number | null;
}

export type PricingMarginRuleUpdateLevel = typeof PricingMarginRuleUpdateLevel[keyof typeof PricingMarginRuleUpdateLevel];


export const PricingMarginRuleUpdateLevel = {
  tenant: 'tenant',
  product: 'product',
} as const;

export type PricingMarginRuleUpdateSeverity = typeof PricingMarginRuleUpdateSeverity[keyof typeof PricingMarginRuleUpdateSeverity];


export const PricingMarginRuleUpdateSeverity = {
  informational: 'informational',
  warning: 'warning',
  approval_required: 'approval_required',
  hard_block: 'hard_block',
} as const;

export interface PricingMarginRuleUpdate {
  name?: string;
  description?: string | null;
  enabled?: boolean;
  level?: PricingMarginRuleUpdateLevel;
  inventoryItemId?: string | null;
  channel?: string | null;
  severity?: PricingMarginRuleUpdateSeverity;
  minAbsoluteProfitGbp?: number | null;
  minGrossMarginPercent?: number | null;
  minTrueMarginPercent?: number | null;
  minPremiumOverMeltPercent?: number | null;
  minMarkupPercent?: number | null;
  minPriceGbp?: number | null;
}

export type PricingCalculationSnapshotCostBreakdown = { [key: string]: unknown };

export type PricingCalculationSnapshotMarginEvaluation = { [key: string]: unknown };

export interface PricingCalculationSnapshot {
  id: string;
  inventoryItemId: string;
  approvalId?: string | null;
  runLogId?: string | null;
  sku?: string | null;
  channel?: string | null;
  ruleId?: string | null;
  ruleName?: string | null;
  ruleScope?: string | null;
  calcVersion: number;
  proposedPrice: number;
  currentPrice?: number | null;
  minimumSafePrice?: number | null;
  costBreakdown: PricingCalculationSnapshotCostBreakdown;
  marginEvaluation: PricingCalculationSnapshotMarginEvaluation;
  feeProfileId?: string | null;
  feeProfileVersion?: number | null;
  spotMetal?: string | null;
  spotPriceGbpPerOz?: number | null;
  spotProvider?: string | null;
  spotFetchedAt?: string | null;
  spotStale: boolean;
  createdAt: string;
}

export type PricingMarginOverrideContext = typeof PricingMarginOverrideContext[keyof typeof PricingMarginOverrideContext];


export const PricingMarginOverrideContext = {
  manual_save: 'manual_save',
  approval: 'approval',
  engine: 'engine',
  marketplace_push: 'marketplace_push',
} as const;

export interface PricingMarginOverride {
  id: string;
  inventoryItemId: string;
  sku?: string | null;
  context: PricingMarginOverrideContext;
  approvalId?: string | null;
  violatedRuleIds?: string[];
  severity: string;
  price: number;
  minimumSafePrice?: number | null;
  estimatedTrueProfitGbp?: number | null;
  estimatedTrueMarginPercent?: number | null;
  reason: string;
  overriddenBy: string;
  createdAt: string;
}

export interface PricingStockAgeBand {
  minDays: number;
  maxDays: number | null;
  marginRelaxPercent: number;
  flagForMarkdownReview?: boolean;
  applyToPremium?: boolean;
}

export type PricingSettingsRoundingStrategy = typeof PricingSettingsRoundingStrategy[keyof typeof PricingSettingsRoundingStrategy];


export const PricingSettingsRoundingStrategy = {
  none: 'none',
  nearest_pound: 'nearest_pound',
  ends_99: 'ends_99',
  ends_95: 'ends_95',
} as const;

export interface PricingSettings {
  engineEnabled: boolean;
  autoApplyEnabled: boolean;
  minMarginPercent: number;
  maxChangePercent: number;
  minChangeGbp: number;
  roundingStrategy: PricingSettingsRoundingStrategy;
  maxIncreasePercent?: number;
  maxDecreasePercent?: number;
  maxChangeGbp?: number;
  minMinutesBetweenChanges?: number;
  forceApprovalAbovePercent?: number;
  spotStalenessThresholdMinutes: number;
  pauseOnStaleSpot: boolean;
  stockAgeBands: PricingStockAgeBand[];
  lastRunAt?: string | null;
}

export type PricingSettingsUpdateRoundingStrategy = typeof PricingSettingsUpdateRoundingStrategy[keyof typeof PricingSettingsUpdateRoundingStrategy];


export const PricingSettingsUpdateRoundingStrategy = {
  none: 'none',
  nearest_pound: 'nearest_pound',
  ends_99: 'ends_99',
  ends_95: 'ends_95',
} as const;

export interface PricingSettingsUpdate {
  engineEnabled?: boolean;
  autoApplyEnabled?: boolean;
  minMarginPercent?: number;
  maxChangePercent?: number;
  minChangeGbp?: number;
  roundingStrategy?: PricingSettingsUpdateRoundingStrategy;
  maxIncreasePercent?: number;
  maxDecreasePercent?: number;
  maxChangeGbp?: number;
  minMinutesBetweenChanges?: number;
  forceApprovalAbovePercent?: number;
  spotStalenessThresholdMinutes?: number;
  pauseOnStaleSpot?: boolean;
  stockAgeBands?: PricingStockAgeBand[];
}

export interface QuickBooksSyncRequest {
  limit?: number;
}

export type QuickBooksSyncRecordResultStatus = typeof QuickBooksSyncRecordResultStatus[keyof typeof QuickBooksSyncRecordResultStatus];


export const QuickBooksSyncRecordResultStatus = {
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface QuickBooksSyncRecordResult {
  status: QuickBooksSyncRecordResultStatus;
  logId: string;
  qboEntityId?: string | null;
  error?: string | null;
}

export interface QuickBooksSyncRunResult {
  attempted: number;
  success: number;
  failed: number;
  skipped: number;
  results: QuickBooksSyncRecordResult[];
}

export type QuickBooksReconciliationSource = typeof QuickBooksReconciliationSource[keyof typeof QuickBooksReconciliationSource];


export const QuickBooksReconciliationSource = {
  ebay: 'ebay',
  shopify: 'shopify',
  paypal: 'paypal',
  stripe: 'stripe',
  bank: 'bank',
} as const;

export type QuickBooksReconciliationStatus = typeof QuickBooksReconciliationStatus[keyof typeof QuickBooksReconciliationStatus];


export const QuickBooksReconciliationStatus = {
  matched: 'matched',
  mismatch: 'mismatch',
  pending: 'pending',
} as const;

export interface QuickBooksReconciliation {
  id: string;
  source: QuickBooksReconciliationSource;
  payoutReference?: string | null;
  payoutDate?: string | null;
  grossSales?: string;
  refunds?: string;
  marketplaceFees?: string;
  postage?: string;
  netPayout?: string;
  appRecordedTotal?: string;
  marketplacePayoutTotal?: string;
  qboTransactionTotal?: string;
  difference: string;
  status: QuickBooksReconciliationStatus;
  notes?: string | null;
  orderCount?: number;
  createdAt: string;
  updatedAt?: string;
}

export type QuickBooksReconciliationInputSource = typeof QuickBooksReconciliationInputSource[keyof typeof QuickBooksReconciliationInputSource];


export const QuickBooksReconciliationInputSource = {
  ebay: 'ebay',
  shopify: 'shopify',
  paypal: 'paypal',
  stripe: 'stripe',
  bank: 'bank',
} as const;

export interface QuickBooksReconciliationInput {
  source: QuickBooksReconciliationInputSource;
  payoutReference: string;
  payoutDate?: string | null;
  grossSales: number;
  refunds: number;
  marketplaceFees: number;
  postage: number;
  marketplacePayoutTotal: number;
  qboTransactionTotal: number;
  orderCount?: number | null;
  notes?: string | null;
}

export type QuickBooksDashboardStatus = typeof QuickBooksDashboardStatus[keyof typeof QuickBooksDashboardStatus];


export const QuickBooksDashboardStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
} as const;

export type QuickBooksDashboardTotals = {
  pending: number;
  success: number;
  failed: number;
  skipped: number;
};

export interface QuickBooksDashboard {
  connected: boolean;
  status?: QuickBooksDashboardStatus;
  lastSyncAt?: string | null;
  totals: QuickBooksDashboardTotals;
  unmatchedReconciliations?: number;
  recentFailures?: QuickBooksSyncLog[];
}

export type XeroStatusStatus = typeof XeroStatusStatus[keyof typeof XeroStatusStatus];


export const XeroStatusStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
} as const;

/**
 * Operator-facing health of the renewable Xero connection; does not represent the short-lived access-token expiry.
 */
export type XeroStatusConnectionHealth = typeof XeroStatusConnectionHealth[keyof typeof XeroStatusConnectionHealth];


export const XeroStatusConnectionHealth = {
  healthy: 'healthy',
  'needs-reconnect': 'needs-reconnect',
} as const;

export interface XeroStatus {
  status: XeroStatusStatus;
  connected: boolean;
  /** Operator-facing health of the renewable Xero connection; does not represent the short-lived access-token expiry. */
  connectionHealth: XeroStatusConnectionHealth;
  credentialsConfigured: boolean;
  xeroTenantId?: string | null;
  xeroTenantName?: string | null;
  connectedAt?: string | null;
  connectedBy?: string | null;
  lastRefreshedAt?: string | null;
  lastError?: string | null;
  lastSyncAt?: string | null;
  syncRefunds?: boolean;
  callbackUrl?: string | null;
}

export interface XeroSettingsUpdate {
  syncRefunds: boolean;
}

export interface XeroSyncRequest {
  limit?: number;
}

export type XeroSyncRecordResultStatus = typeof XeroSyncRecordResultStatus[keyof typeof XeroSyncRecordResultStatus];


export const XeroSyncRecordResultStatus = {
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface XeroSyncRecordResult {
  status: XeroSyncRecordResultStatus;
  logId: string;
  xeroInvoiceId?: string | null;
  error?: string | null;
}

export interface XeroSyncRunResult {
  attempted: number;
  success: number;
  failed: number;
  skipped: number;
  results: XeroSyncRecordResult[];
}

export type XeroSyncLogRecordType = typeof XeroSyncLogRecordType[keyof typeof XeroSyncLogRecordType];


export const XeroSyncLogRecordType = {
  sale: 'sale',
  refund: 'refund',
} as const;

export type XeroSyncLogTriggerType = typeof XeroSyncLogTriggerType[keyof typeof XeroSyncLogTriggerType];


export const XeroSyncLogTriggerType = {
  manual: 'manual',
  scheduled: 'scheduled',
} as const;

export type XeroSyncLogStatus = typeof XeroSyncLogStatus[keyof typeof XeroSyncLogStatus];


export const XeroSyncLogStatus = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface XeroSyncLog {
  id: string;
  recordType: XeroSyncLogRecordType;
  sourceRecordId?: string | null;
  triggerType: XeroSyncLogTriggerType;
  triggeredBy?: string | null;
  xeroInvoiceId?: string | null;
  status: XeroSyncLogStatus;
  errorMessage?: string | null;
  amount?: string | null;
  vatAmount?: string | null;
  /** Number of sync attempts made for this record (initial push counts as 1). */
  attempts?: number;
  /** True when a FAILED sale record has used up its bounded auto-retry budget and will no longer retry on its own — it needs a manual retry. */
  autoRetriesExhausted?: boolean;
  /** Cap on automatic retries before a failed sale gives up. */
  maxAutoRetries?: number;
  createdAt: string;
  updatedAt?: string;
}

export type XeroDashboardStatus = typeof XeroDashboardStatus[keyof typeof XeroDashboardStatus];


export const XeroDashboardStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
} as const;

export type XeroDashboardTotals = {
  pending: number;
  success: number;
  failed: number;
  skipped: number;
};

export interface XeroDashboard {
  connected: boolean;
  status?: XeroDashboardStatus;
  credentialsConfigured?: boolean;
  lastSyncAt?: string | null;
  lastError?: string | null;
  totals: XeroDashboardTotals;
  recentFailures?: XeroSyncLog[];
}

export type CustomFieldEntityType = typeof CustomFieldEntityType[keyof typeof CustomFieldEntityType];


export const CustomFieldEntityType = {
  CUSTOMER: 'CUSTOMER',
  COMPANY: 'COMPANY',
} as const;

export type CustomFieldType = typeof CustomFieldType[keyof typeof CustomFieldType];


export const CustomFieldType = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  SELECT: 'SELECT',
} as const;

export interface CustomField {
  id: string;
  name: string;
  key: string;
  entityType: CustomFieldEntityType;
  fieldType: CustomFieldType;
  options?: string[] | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CustomFieldInput {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  /**
     * camelCase leaf used in template paths (e.g. "tier" -> {{customer.custom.tier}})
     * @minLength 1
     * @maxLength 80
     */
  key: string;
  entityType: CustomFieldEntityType;
  fieldType: CustomFieldType;
  options?: string[] | null;
  isActive?: boolean;
}

export interface CustomFieldUpdate {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name?: string;
  options?: string[] | null;
  isActive?: boolean;
}

export interface CustomFieldWithValue {
  field: CustomField;
  /** Stringified scalar value (booleans as "true"/"false", numbers as decimal, dates as ISO YYYY-MM-DD) */
  value?: string | null;
  updatedAt?: string | null;
}

export interface CustomFieldValuePair {
  fieldId: string;
  value?: string | null;
}

export interface CustomFieldValuesUpsert {
  entityType: CustomFieldEntityType;
  entityId: string;
  values: CustomFieldValuePair[];
}

export interface PickListItem {
  /** Position number on the pick list (e.g. "001"). */
  position: string;
  title: string;
  /** 12-digit eBay item number when present. */
  itemNumber?: string | null;
  quantity: number;
  /** Decimal string in GBP, e.g. "69.50". */
  valueGbp?: string | null;
}

export type PickListParcelStatus = typeof PickListParcelStatus[keyof typeof PickListParcelStatus];


export const PickListParcelStatus = {
  pending: 'pending',
  picked: 'picked',
  packed: 'packed',
  shipped: 'shipped',
} as const;

export type PickListParcelValidationStatus = typeof PickListParcelValidationStatus[keyof typeof PickListParcelValidationStatus];


export const PickListParcelValidationStatus = {
  clean: 'clean',
  needs_review: 'needs_review',
  broken: 'broken',
} as const;

export interface PickListParcel {
  id: string;
  importId: string;
  sequence: number;
  orderRefs: string[];
  buyerUsername?: string | null;
  customerName?: string | null;
  addressLines: string[];
  items: PickListItem[];
  totalQuantity: number;
  status: PickListParcelStatus;
  validationStatus: PickListParcelValidationStatus;
  cctv: boolean;
  uv: boolean;
  notes?: string | null;
  warnings: string[];
  createdAt: string;
  updatedAt: string;
}

export interface PickListParcelPatch {
  customerName?: string | null;
  addressLines?: string[];
  items?: PickListItem[];
  totalQuantity?: number;
  cctv?: boolean;
  uv?: boolean;
  notes?: string | null;
  validationStatus?: PickListParcelValidationStatus;
}

export interface PickListImportSummary {
  id: string;
  fileName: string;
  fileSize: number;
  expectedParcelCount: number;
  parcelCount: number;
  shippedCount: number;
  warnings: string[];
  createdByUserEmail?: string | null;
  createdAt: string;
}

export interface PickListImportListResponse {
  items: PickListImportSummary[];
  total: number;
  limit: number;
  offset: number;
}

export interface PickListImportHeader {
  id: string;
  fileName: string;
  fileSize: number;
  expectedParcelCount: number;
  warnings: string[];
  createdByUserEmail?: string | null;
  createdAt: string;
}

export interface PickListImportDetail {
  import: PickListImportHeader;
  parcels: PickListParcel[];
}

export interface PickListParcelStatusInput {
  status: PickListParcelStatus;
}

export interface OrderLoss {
  id: string;
  orderId: string;
  type: OrderLossType;
  status: OrderLossStatus;
  estimatedLossAmount: number;
  recoveredAmount: number;
  note: string;
  createdByUserId?: string | null;
  createdAt: string;
  updatedAt: string;
  resolvedAt?: string | null;
}

export type OrderLossWithContext = OrderLoss & ({
  orderNumber?: string | null;
  customerName?: string | null;
});

export interface OrderLossListResponse {
  items: OrderLossWithContext[];
  total: number;
  limit: number;
  offset: number;
}

export interface MarkOrderLossInput {
  type: OrderLossType;
  /** @minimum 0 */
  estimatedLossAmount?: number;
  /** @minimum 0 */
  recoveredAmount?: number;
  /**
     * Operator justification — required, never empty.
     * @minLength 1
     */
  note: string;
}

export interface UpdateOrderLossInput {
  type?: OrderLossType;
  status?: OrderLossStatus;
  /** @minimum 0 */
  estimatedLossAmount?: number;
  /** @minimum 0 */
  recoveredAmount?: number;
  /** @minLength 1 */
  note?: string;
}

/**
 * Intended composite usage; active templates are independent per usage.
 */
export type ImageTemplateUsage = typeof ImageTemplateUsage[keyof typeof ImageTemplateUsage];


export const ImageTemplateUsage = {
  single_coin: 'single_coin',
  shared_hero: 'shared_hero',
} as const;

export interface ImageTemplate {
  id: string;
  name: string;
  imageUrl: string;
  /** Intended composite usage; active templates are independent per usage. */
  usage: ImageTemplateUsage;
  widthPx?: number | null;
  heightPx?: number | null;
  isActive: boolean;
  version: number;
  createdByUserId?: string | null;
  createdAt: string;
  archivedAt: string | null;
}

export type ImageTemplateListResponseActiveByUsage = {
  single_coin: ImageTemplate | null;
  shared_hero: ImageTemplate | null;
};

export interface ImageTemplateListResponse {
  items: ImageTemplate[];
  active?: ImageTemplate | null;
  activeByUsage?: ImageTemplateListResponseActiveByUsage;
}

/**
 * Composition baseline and corresponding active template usage. Defaults to legacy single-coin behavior.
 */
export type GenerateCompositeInputLayout = typeof GenerateCompositeInputLayout[keyof typeof GenerateCompositeInputLayout];


export const GenerateCompositeInputLayout = {
  single_coin: 'single_coin',
  shared_hero: 'shared_hero',
} as const;

/**
 * Optional composite preset settings (Task #1981). When provided the media-worker renders via compositeWithPreset (preset background + reflection applied on a canvas sized to the template) instead of compositeOnTemplate; offsetX/offsetY/scale are still honoured. Absent → existing template-composite path unchanged (backward-compatible).
 */
export type GenerateCompositeInputStudioSettings = { [key: string]: unknown } | null;

export interface CompositeGroundingShadowSettings {
  /**
     * Width as a fraction of the visible product width.
     * @minimum 0.2
     * @maximum 0.9
     */
  width: number;
  /**
     * Height as a fraction of the visible product height.
     * @minimum 0.02
     * @maximum 0.2
     */
  height: number;
  /**
     * Shadow opacity.
     * @minimum 0
     * @maximum 0.6
     */
  intensity: number;
  /**
     * Relative blur amount.
     * @minimum 0
     * @maximum 1
     */
  softness: number;
}

export interface GenerateCompositeInput {
  /**
     * objectPath of the transparent source PNG (typically /objects/uploads/<uuid>).
     * @minLength 1
     */
  sourcePhotoUrl: string;
  /** Composition baseline and corresponding active template usage. Defaults to legacy single-coin behavior. */
  layout?: GenerateCompositeInputLayout;
  /**
     * Horizontal nudge in [-2, 2] (fraction of template width; 0 = centered). Values beyond ±1 pan the source partially off-canvas.
     * @minimum -2
     * @maximum 2
     */
  offsetX: number;
  /**
     * Vertical nudge in [-2, 2] (fraction of template height; 0 = centered). Values beyond ±1 pan the source partially off-canvas.
     * @minimum -2
     * @maximum 2
     */
  offsetY: number;
  /**
     * Scale multiplier in (0, 2]; 1 = auto-fit.
     * @maximum 2
     * @exclusiveMinimum 0
     */
  scale: number;
  /** Whether to render the optional compact contact shadow. Defaults to false. */
  shadowEnabled?: boolean;
  shadowSettings?: CompositeGroundingShadowSettings;
  /** Optional composite preset settings (Task #1981). When provided the media-worker renders via compositeWithPreset (preset background + reflection applied on a canvas sized to the template) instead of compositeOnTemplate; offsetX/offsetY/scale are still honoured. Absent → existing template-composite path unchanged (backward-compatible). */
  studioSettings?: GenerateCompositeInputStudioSettings;
}

export type GenerateCompositeResponseCompositeLayout = typeof GenerateCompositeResponseCompositeLayout[keyof typeof GenerateCompositeResponseCompositeLayout];


export const GenerateCompositeResponseCompositeLayout = {
  single_coin: 'single_coin',
  shared_hero: 'shared_hero',
} as const;

export interface GenerateCompositeResponse {
  inventoryItemId: string;
  compositePhotoUrl: string;
  compositeSourcePhotoUrl: string;
  compositeTemplateId: string;
  compositeTemplateVersion: number;
  compositeLayout: GenerateCompositeResponseCompositeLayout;
  compositeOffsetX: number;
  compositeOffsetY: number;
  compositeScale: number;
  compositeGeneratedAt?: string | null;
}

export type CreateImageTemplateInputUsage = typeof CreateImageTemplateInputUsage[keyof typeof CreateImageTemplateInputUsage];


export const CreateImageTemplateInputUsage = {
  single_coin: 'single_coin',
  shared_hero: 'shared_hero',
} as const;

export interface CreateImageTemplateInput {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  imageUrl: string;
  /** @minLength 1 */
  imageObjectPath: string;
  /** @minimum 1 */
  widthPx?: number;
  /** @minimum 1 */
  heightPx?: number;
  usage?: CreateImageTemplateInputUsage;
  /** If true, mark this new template active immediately. */
  activate?: boolean;
}

export type PackingJobStatus = typeof PackingJobStatus[keyof typeof PackingJobStatus];


export const PackingJobStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  evidence_captured: 'evidence_captured',
  packed: 'packed',
  confirmation_sent: 'confirmation_sent',
  completed: 'completed',
  issue: 'issue',
  cancelled: 'cancelled',
} as const;

export interface PackingJobSummary {
  id: string;
  status: PackingJobStatus;
  groupKey: string;
  customerId: string;
  customerName?: string | null;
  /** Packing-only display name resolved from exact-order marketplace buyer evidence, falling back to the existing customer/snapshot name. Does not modify the linked customer or shipping data. */
  displayName?: string | null;
  /** True when multiple order identities or conflicting exact-order names prevent one safe job-header name. */
  displayNameAmbiguous?: boolean;
  /** True when the job contains orders belonging to more than one customer identity. */
  multipleCustomers?: boolean;
  /** True when at least one order still has only a masked placeholder and no trustworthy exact-order name. */
  buyerNameMasked?: boolean;
  ebayUsername?: string | null;
  /** Buyer's TikTok username (the "Buyer ID" on the shipping label), stored without a leading "@". Null unless a clean, non-masked value was captured at TikTok label import. Shown next to the customer name on the packing list and job-detail header. */
  tiktokUsername?: string | null;
  /** Buyer's TikTok nickname / alias from the label. Null unless a clean, non-masked value was captured at TikTok label import. */
  tiktokNickname?: string | null;
  /** Distinct source channels of the sale orders in this packing job (e.g. ["tiktok_shop"], ["ebay","tiktok_shop"]). Drives the Source-marketplace badge in the packing list. May be empty for a freshly materialised job whose orders were not yet joined. */
  channels?: string[];
  /** Order number(s) for the sale orders in this packing job. Single-order jobs have one entry; combined-shipment jobs have one per order. Shown in the packing list so packers can identify jobs by order number when customer names are redacted. */
  orderNumbers?: string[];
  shipDate: string;
  shipName?: string | null;
  shipPostcode?: string | null;
  shipCity?: string | null;
  totalOrders: number;
  totalUnits: number;
  totalRevenueGbp: number | null;
  totalPostageGbp: number | null;
  isCombinedPostage: boolean;
  operatorNotes?: string | null;
  issueReason?: string | null;
  startedAt?: string | null;
  packedAt?: string | null;
  completedAt?: string | null;
  confirmationSentAt?: string | null;
  confirmationLastEmailMessageId?: string | null;
  createdAt: string;
  updatedAt: string;
  /** Cheap per-job flag for the packing list. True when this job's orders span more than one distinct shipping label/tracking number (i.e. it was combined beyond what the labels actually combined) OR a TikTok order on it has no shipping label/tracking imported yet. Drives the list-row warning badge. The detailed, human-readable discrepancies (including the cross-job "label split" check) are returned only on the job-detail route as `warnings`. */
  labelWarning?: boolean;
  /** Number of photos/videos attached to this packing job. 0 means no packing media has been captured yet. Drives the "Outstanding packing media" daily-check section (active jobs with mediaCount 0) and the media-captured indicator on the packing list. */
  mediaCount?: number;
}

export interface PackingJobOrderLine {
  id: string;
  /** The inventory_items UUID for this sale line. Present when the line is linked to a tracked inventory item; null for free-text / ad-hoc lines. Used by the packing screen to load available serials for the "Link tracked serial" picker. */
  inventoryItemId?: string | null;
  /** UUID of the inventory_serials row currently assigned to this sale line (sale_order_items.serial_id). Null when no tracked serial has been linked to this specific line. */
  serialId?: string | null;
  productTitle: string;
  sku?: string | null;
  quantity: number;
  salePrice: number | null;
  unitCost: number | null;
  /** The inventory item's standing "note to packer" instruction, when set. Shown prominently on the packing screen so the packer always sees per-item handling/filming requirements (e.g. "privy — check it exists and film it"). Distinct from the per-order packing notes. */
  packerNote?: string | null;
  photoUrl?: string | null;
  /** The inventory item's template-background composite render (the curated "what the product looks like" image), when one exists. Object path / absolute URL — render via AuthedImage. Packing screen prefers this over photoUrl so composite-only items (no photos[]) still show a product image. */
  compositePhotoUrl?: string | null;
  /** All product image angles for this line, composite-first then every standard photo (structured photos[] → photoUrl → photoUrls), deduped with blanks dropped. Drives the packing screen's pop-out image lightbox so operators can scroll through every angle. Render each via AuthedImage. Empty when the line has no inventory image. */
  imageUrls?: string[];
}

export interface MarketplaceTrackingSync {
  channel: string;
  /** Latest push status (e.g. success, failed, skipped). */
  status: string;
  at?: string | null;
  message?: string | null;
}

export interface PackingJobOrder {
  id: string;
  /** Order-specific buyer name from exact-order evidence, or the existing order customer/shipping snapshot fallback. */
  displayName?: string | null;
  orderNumber: string;
  externalOrderNumber?: string | null;
  ebayOrderId?: string | null;
  channel: string;
  saleDate: string;
  status: string;
  paymentStatus?: string;
  trackingNumber?: string | null;
  shippingCarrier?: string | null;
  shippingCharged: number;
  postageAllocated: number;
  isPrimaryPostageOrder: boolean;
  /** Certificate / serial number recorded by the packer for this order. */
  certificateNumber?: string | null;
  /** FK to inventory_serials row assigned to this order, when a tracked serial was linked. */
  serialId?: string | null;
  /** TikTok Package ID extracted from the shipping label (e.g. "TTID-…"). Only populated for TikTok Shop orders where a label has been imported. Null for all other channels. */
  tiktokPackageId?: string | null;
  /** Latest marketplace tracking-push outcome for this order, when the channel supports it (currently TikTok Shop). Null when the channel does not push tracking or no push has been attempted yet. */
  marketplaceTrackingSync?: MarketplaceTrackingSync | null;
  lines: PackingJobOrderLine[];
}

export interface CombinePackingJobsRequest {
  /** @minItems 2 */
  jobIds: string[];
}

export interface DismissCombinedShipmentSuggestionRequest {
  /** @minItems 2 */
  jobIds: string[];
}

export interface CombinePackingJobsResult {
  ok: boolean;
  survivorJobId: string;
  mergedJobIds: string[];
}

export interface SplitPackingJobByLabelResult {
  ok: boolean;
  /** IDs of the jobs created (or moved onto) for the split-off label groups. The original jobId keeps the largest label group plus any untracked orders. */
  newJobIds: string[];
}

export interface CombinedShipmentSuggestion {
  customerId: string;
  customerName?: string | null;
  ebayUsername?: string | null;
  /** Combined order count across the suggested jobs. */
  totalOrders: number;
  /** Distinct source channels across the suggested jobs. */
  channels: string[];
  jobs: PackingJobSummary[];
}

/**
 * multiple_labels = job bundles orders spanning >1 distinct tracking number (over-combined vs the labels); missing_label = a TikTok order on the job has no shipping label/tracking imported yet; label_split = an order on this job shares a tracking number with another active packing job (the label combined orders this projection split apart).
 */
export type PackingWarningCode = typeof PackingWarningCode[keyof typeof PackingWarningCode];


export const PackingWarningCode = {
  multiple_labels: 'multiple_labels',
  missing_label: 'missing_label',
  label_split: 'label_split',
} as const;

export type PackingWarningSeverity = typeof PackingWarningSeverity[keyof typeof PackingWarningSeverity];


export const PackingWarningSeverity = {
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export interface PackingWarning {
  /** multiple_labels = job bundles orders spanning >1 distinct tracking number (over-combined vs the labels); missing_label = a TikTok order on the job has no shipping label/tracking imported yet; label_split = an order on this job shares a tracking number with another active packing job (the label combined orders this projection split apart). */
  code: PackingWarningCode;
  severity: PackingWarningSeverity;
  /** Operator-facing, already-humanised explanation. */
  message: string;
  /** Distinct tracking numbers involved, when relevant. */
  trackingNumbers?: string[];
  /** IDs of other active packing jobs involved (label_split only). */
  otherJobIds?: string[];
}

export type PackingJobDetail = PackingJobSummary & ({
  customerEmail?: string | null;
  customerPhone?: string | null;
  shipAddressLine1?: string | null;
  shipAddressLine2?: string | null;
  shipCountry?: string | null;
  assignedUserId?: string | null;
  cancelReason?: string | null;
  reopenReason?: string | null;
  allowedTransitions: PackingJobStatus[];
  /** Label-vs-projection discrepancies for this job. The TikTok shipping label (one tracking number = one parcel) is the source of truth for what was actually combined; packing jobs are a customer/address projection that can disagree. Empty when the job matches the labels. Surfaced in the job-detail "Warnings" panel — "do not combine if the labels have not combined". */
  warnings?: PackingWarning[];
  orders: PackingJobOrder[];
});

export interface PackingJobUpdate {
  status?: PackingJobStatus;
  operatorNotes?: string | null;
  issueReason?: string | null;
  /** Required when transitioning to status=cancelled. */
  cancelReason?: string | null;
  /** Required when transitioning from status=cancelled (currently the only allowed outbound transition is `cancelled -> pending`). */
  reopenReason?: string | null;
}

export type PackingJobMediaMediaType = typeof PackingJobMediaMediaType[keyof typeof PackingJobMediaMediaType];


export const PackingJobMediaMediaType = {
  image: 'image',
  video: 'video',
} as const;

export type PackingJobMediaCapturedVia = typeof PackingJobMediaCapturedVia[keyof typeof PackingJobMediaCapturedVia];


export const PackingJobMediaCapturedVia = {
  webcam: 'webcam',
  upload: 'upload',
  still: 'still',
  ring: 'ring',
} as const;

export interface PackingJobMedia {
  id: string;
  jobId: string;
  objectPath: string;
  fileName: string;
  contentType: string;
  mediaType: PackingJobMediaMediaType;
  sizeBytes: number;
  sortOrder: number;
  capturedVia: PackingJobMediaCapturedVia;
  notes?: string | null;
  uploadedByUserId?: string | null;
  uploadedAt: string;
  servingUrl: string;
}

export type PackingJobMediaCreateMediaType = typeof PackingJobMediaCreateMediaType[keyof typeof PackingJobMediaCreateMediaType];


export const PackingJobMediaCreateMediaType = {
  image: 'image',
  video: 'video',
} as const;

export type PackingJobMediaCreateCapturedVia = typeof PackingJobMediaCreateCapturedVia[keyof typeof PackingJobMediaCreateCapturedVia];


export const PackingJobMediaCreateCapturedVia = {
  webcam: 'webcam',
  upload: 'upload',
  still: 'still',
  ring: 'ring',
} as const;

export interface PackingJobMediaCreate {
  objectPath: string;
  fileName: string;
  contentType: string;
  mediaType: PackingJobMediaCreateMediaType;
  sizeBytes: number;
  capturedVia?: PackingJobMediaCreateCapturedVia;
  notes?: string | null;
}

export interface PackingJobMediaUpdate {
  sortOrder?: number;
  notes?: string | null;
}

export interface PackingJobMaterializeResult {
  scanned: number;
  jobsCreated: number;
  jobsUpdated: number;
  ordersAttached: number;
  ordersSkipped: number;
  /** Group buckets with orders still to attach that were deferred this run because the per-run budget was reached. Drained automatically by the background scheduler. 0 means fully processed. */
  remaining?: number;
}

/**
 * open = needs a decision; done = permanently resolved;
 * deferred = "next time" — resolved only for the job it was deferred on.
 */
export type PackingNoteStatus = typeof PackingNoteStatus[keyof typeof PackingNoteStatus];


export const PackingNoteStatus = {
  open: 'open',
  done: 'done',
  deferred: 'deferred',
} as const;

export interface PackingNote {
  id: string;
  saleOrderId: string;
  body: string;
  status: PackingNoteStatus;
  reply?: string | null;
  deferralReason?: string | null;
  deferredForJobId?: string | null;
  createdByUserId?: string | null;
  createdByEmail?: string | null;
  repliedByEmail?: string | null;
  repliedAt?: string | null;
  resolvedByEmail?: string | null;
  resolvedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type PackingJobNote = PackingNote & {
  /** True when this note still needs a decision for the job being viewed. */
  effectiveOpen: boolean;
  orderNumber: string;
};

export interface PackingNoteCreate {
  /** @minLength 1 */
  body: string;
}

export type PackingNoteResolveResolution = typeof PackingNoteResolveResolution[keyof typeof PackingNoteResolveResolution];


export const PackingNoteResolveResolution = {
  done: 'done',
  next_time: 'next_time',
} as const;

export interface PackingNoteResolve {
  resolution: PackingNoteResolveResolution;
  /** Required (non-empty) when resolution=next_time. */
  reason?: string | null;
  /**
     * The packing job the decision is being made on. Used to scope a
     * next_time deferral so the note re-surfaces on later jobs.
     */
  jobId?: string | null;
}

export interface PackingNoteReply {
  /** @minLength 1 */
  reply: string;
}

export interface CancelledBuyerOrder {
  id: string;
  orderNumber: string;
  status: string;
  cancelReason?: string | null;
  cancelledAt?: string | null;
  saleDate?: string | null;
  /** True when cancelled/updated within the last 24–72h highlight window. */
  withinHighlightWindow: boolean;
}

export interface PackingJobCancelledBuyer {
  /** The buyer's eBay username this lookup matched on (null when the job has none). */
  ebayUsername: string | null;
  /** True when the buyer has any cancelled / reversed order in their history. */
  hasCancellations: boolean;
  /** Cancelled / reversed orders within the last 72h (highlight window). */
  recent: CancelledBuyerOrder[];
  /** Older cancelled / reversed orders for the same buyer. */
  older: CancelledBuyerOrder[];
}

export interface TrackingIntegrationStatus {
  configured: boolean;
  hasApiKey: boolean;
  /** Numbers registered against this tenant in the current calendar month. */
  quotaUsed: number;
  /** Free-tier cap (100 unless overridden). */
  quotaLimit: number;
  lastTestedAt?: string | null;
  /** True when the most recent provider call rejected the saved key with 401/403. Saving a new key (PUT) clears this flag. */
  credentialsInvalid: boolean;
  /** When the saved key was first observed as unauthorised. Null when the key is healthy or not configured. */
  credentialsInvalidAt?: string | null;
}

export interface TrackingIntegrationUpdate {
  /** 17track REST API key. Stored encrypted. */
  apiKey: string;
}

export interface TrackingIntegrationTestResult {
  ok: boolean;
  quotaUsed?: number | null;
  quotaLimit?: number | null;
  error?: string | null;
}

export interface TrackingEvent {
  id: string;
  eventCode: string;
  eventLabel: string;
  eventAt: string;
  location?: string | null;
}

export type TrackingStatusKind = typeof TrackingStatusKind[keyof typeof TrackingStatusKind];


export const TrackingStatusKind = {
  ok: 'ok',
  unsupported: 'unsupported',
  'no-tracking-number': 'no-tracking-number',
  'no-credentials': 'no-credentials',
  'quota-exhausted': 'quota-exhausted',
} as const;

export type TrackingStatusCarrierConfidence = typeof TrackingStatusCarrierConfidence[keyof typeof TrackingStatusCarrierConfidence] | null;


export const TrackingStatusCarrierConfidence = {
  high: 'high',
  medium: 'medium',
} as const;

export type TrackingStatusLatestStatus = typeof TrackingStatusLatestStatus[keyof typeof TrackingStatusLatestStatus] | null;


export const TrackingStatusLatestStatus = {
  InfoReceived: 'InfoReceived',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  PickedUp: 'PickedUp',
  Delivered: 'Delivered',
  Exception: 'Exception',
  Expired: 'Expired',
  Pending: 'Pending',
} as const;

export interface TrackingStatus {
  kind: TrackingStatusKind;
  trackingNumber?: string | null;
  carrier?: string | null;
  carrierConfidence?: TrackingStatusCarrierConfidence;
  events: TrackingEvent[];
  latestStatus?: TrackingStatusLatestStatus;
  lastRefreshedAt?: string | null;
  refreshed: boolean;
  /** True when the tenant's 17track monthly register quota is at/above the 90% guard threshold. Surfaced so the UI can warn operators on manual refresh before the cap is hit. */
  quotaWarning?: boolean;
  /** True when the server served a stale cache snapshot AND kicked off a background refresh against 17track. The FE re-fetches a few seconds later so the in-session view picks up the fresh state without a manual reload. */
  refreshInFlight?: boolean;
}

export interface ConsignmentBatchInput {
  supplierId: string;
  /**
     * @minLength 1
     * @maxLength 120
     */
  batchName: string;
  notes?: string | null;
  /** Agreed capital you owe back to the supplier before profit-split kicks in. Must be > 0. */
  capitalOwedGbp: number;
  /**
     * Supplier's share (0–100) of available profit once capital is recovered.
     * @minimum 0
     * @maximum 100
     */
  profitSplitPercent?: number;
}

export type ConsignmentBatchUpdateStatus = typeof ConsignmentBatchUpdateStatus[keyof typeof ConsignmentBatchUpdateStatus];


export const ConsignmentBatchUpdateStatus = {
  ACTIVE: 'ACTIVE',
  CLEARED: 'CLEARED',
} as const;

export interface ConsignmentBatchUpdate {
  /**
     * @minLength 1
     * @maxLength 120
     */
  batchName?: string;
  notes?: string | null;
  /** Locked once any sale has landed against the batch — server returns 409. */
  capitalOwedGbp?: number;
  /**
     * @minimum 0
     * @maximum 100
     */
  profitSplitPercent?: number;
  status?: ConsignmentBatchUpdateStatus;
}

export type ConsignmentBatchStatus = typeof ConsignmentBatchStatus[keyof typeof ConsignmentBatchStatus];


export const ConsignmentBatchStatus = {
  ACTIVE: 'ACTIVE',
  CLEARED: 'CLEARED',
} as const;

export interface ConsignmentBatch {
  id: string;
  supplierId: string;
  supplierName?: string | null;
  batchName: string;
  notes?: string | null;
  capitalOwedGbp: string;
  profitSplitPercent: string;
  status: ConsignmentBatchStatus;
  createdAt: string;
  updatedAt: string;
}

export interface ConsignmentBatchMetrics {
  capitalOwed: number;
  totalRepayments: number;
  remainingCapitalOwed: number;
  totalSalesGenerated: number;
  grossProfitGenerated: number;
  supplierProfitShare: number;
  companyProfitShare: number;
  /** max(0, grossProfitGenerated − remainingCapitalOwed). Profit eligible for split. */
  availableProfit: number;
}

export type ConsignmentBatchListRow = ConsignmentBatch & {
  metrics: ConsignmentBatchMetrics;
};

export interface ConsignmentBatchPaymentInput {
  /** Repayment amount in GBP. Must be > 0. */
  amountGbp: number;
  /** YYYY-MM-DD. */
  paymentDate: string;
  notes?: string | null;
}

export interface ConsignmentBatchPayment {
  id: string;
  batchId: string;
  amountGbp: string;
  paymentDate: string;
  notes?: string | null;
  createdByUserId?: string | null;
  createdAt: string;
}

export interface ConsignmentBatchLinkedInventory {
  id: string;
  sku: string;
  productTitle: string;
  quantity: number;
  quantitySold: number;
  quantityAvailable: number;
  landedUnitCost?: string | null;
}

export interface ConsignmentBatchDetail {
  batch: ConsignmentBatch;
  metrics: ConsignmentBatchMetrics;
  payments: ConsignmentBatchPayment[];
  linkedInventory: ConsignmentBatchLinkedInventory[];
}

export interface ConsignmentBatchDashboard {
  activeBatchCount: number;
  totalCapitalOwed: number;
  totalRepayments: number;
  totalRemainingCapitalOwed: number;
  totalGrossProfitGenerated: number;
  totalAvailableProfit: number;
  totalSupplierProfitShare: number;
  totalCompanyProfitShare: number;
}

export type ShipmentGroupStatus = typeof ShipmentGroupStatus[keyof typeof ShipmentGroupStatus];


export const ShipmentGroupStatus = {
  AWAITING_SHIP: 'AWAITING_SHIP',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  FINALISED: 'FINALISED',
} as const;

export interface ShipmentGroup {
  id: string;
  /** SG-NNNNN, sequential per tenant. */
  reference: string;
  supplierId: string;
  supplierName?: string | null;
  status: ShipmentGroupStatus;
  shippingProvider?: string | null;
  waybillNumber?: string | null;
  trackingNumber?: string | null;
  trackingLink?: string | null;
  shippingCostGbp: string;
  vatCostGbp: string;
  importDutyCostGbp: string;
  otherFeesGbp: string;
  notes?: string | null;
  createdByUserId?: string | null;
  finalCostedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type ShipmentGroupListRow = ShipmentGroup & {
  poCount: number;
  /** Sum of the 4 group cost buckets in GBP. */
  totalCostGbp: number;
};

/**
 * Per-PO snapshot of the original GBP cost fields, used to restore on disband / PO-remove.
 */
export interface ShipmentGroupSnapshot {
  shipping?: number | null;
  insurance?: number | null;
  importVat?: number | null;
  customs?: number | null;
  bankFees?: number | null;
  other?: number | null;
}

export interface ShipmentGroupLinkedPo {
  joinId: string;
  purchaseOrderId: string;
  poNumber?: string | null;
  orderStatus?: string | null;
  /** Total GBP line-item value of the PO, used as the by-value allocation basis. */
  poValueGbp: number;
  /** Operator-set manual allocation %. When set, takes precedence over the auto %. */
  overrideAllocationPct?: number | null;
  /** Auto-computed proportional share (sums to 100 across the group, equal split when all PO values are 0). */
  autoAllocationPct: number;
  /** overrideAllocationPct ?? autoAllocationPct. Used to allocate group cost buckets onto each PO. */
  effectiveAllocationPct: number;
  orderedQuantity: number;
  acceptedQuantity: number;
  hasValidValuation: boolean;
  snapshot: ShipmentGroupSnapshot;
}

export interface ShipmentGroupTotals {
  shipping: number;
  vat: number;
  duty: number;
  other: number;
  grand: number;
}

export type ShipmentGroupEvidenceEventKind = typeof ShipmentGroupEvidenceEventKind[keyof typeof ShipmentGroupEvidenceEventKind];


export const ShipmentGroupEvidenceEventKind = {
  dispatch: 'dispatch',
  arrival: 'arrival',
} as const;

export type ShipmentGroupEvidenceEventMethod = typeof ShipmentGroupEvidenceEventMethod[keyof typeof ShipmentGroupEvidenceEventMethod];


export const ShipmentGroupEvidenceEventMethod = {
  carrier: 'carrier',
  collection: 'collection',
  hand_delivery: 'hand_delivery',
  other: 'other',
} as const;

export interface ShipmentGroupEvidenceEvent {
  purchaseOrderId: string;
  poNumber?: string | null;
  id: string;
  kind: ShipmentGroupEvidenceEventKind;
  method: ShipmentGroupEvidenceEventMethod;
  occurredAt: string;
  reference?: string | null;
  note?: string | null;
  source: string;
}

export interface ShipmentGroupReceiptException {
  purchaseOrderId: string;
  poNumber?: string | null;
  purchaseOrderItemId: string;
  acceptedQuantity: number;
  damagedQuantity: number;
  quarantinedQuantity: number;
  heldQuantity: number;
  valuationStatus: string;
  note?: string | null;
  createdAt: string;
}

export interface ShipmentGroupReviewReason {
  purchaseOrderId: string;
  poNumber?: string | null;
  id: string;
  code: string;
  reason: string;
  createdAt: string;
}

export interface ShipmentGroupEvidence {
  dispatch: ShipmentGroupEvidenceEvent[];
  arrival: ShipmentGroupEvidenceEvent[];
  receiptExceptions: ShipmentGroupReceiptException[];
  unresolvedReviewReasons: ShipmentGroupReviewReason[];
  dispatchComplete: boolean;
  arrivalComplete: boolean;
  receiptsComplete: boolean;
  costsReady: boolean;
  finaliseReady: boolean;
  blockers: string[];
}

export interface ShipmentGroupDetail {
  group: ShipmentGroup;
  linkedPos: ShipmentGroupLinkedPo[];
  totals: ShipmentGroupTotals;
  /** Sum of effectiveAllocationPct across linked POs (should be 100 ± 0.01). */
  allocationSumPct: number;
  evidence: ShipmentGroupEvidence;
}

export interface ShipmentGroupCreate {
  /**
     * 2+ POs, all from the same supplier, none already in a shipment group.
     * @minItems 2
     */
  poIds: string[];
  /** @maxLength 120 */
  shippingProvider?: string | null;
  /** @maxLength 120 */
  waybillNumber?: string | null;
  /** @maxLength 120 */
  trackingNumber?: string | null;
  notes?: string | null;
}

export type ShipmentGroupUpdateStatus = typeof ShipmentGroupUpdateStatus[keyof typeof ShipmentGroupUpdateStatus];


export const ShipmentGroupUpdateStatus = {
  AWAITING_SHIP: 'AWAITING_SHIP',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  FINALISED: 'FINALISED',
} as const;

export interface ShipmentGroupUpdate {
  /** @maxLength 120 */
  shippingProvider?: string | null;
  /** @maxLength 120 */
  waybillNumber?: string | null;
  /** @maxLength 120 */
  trackingNumber?: string | null;
  /** @maxLength 500 */
  trackingLink?: string | null;
  notes?: string | null;
  shippingCostGbp?: number | null;
  vatCostGbp?: number | null;
  importDutyCostGbp?: number | null;
  otherFeesGbp?: number | null;
  status?: ShipmentGroupUpdateStatus;
}

export interface ShipmentGroupAllocationOverride {
  purchaseOrderId: string;
  /**
     * 0–100, up to 3 decimal places.
     * @minimum 0
     * @maximum 100
     */
  overridePct: number;
}

export interface ShipmentGroupAllocationInput {
  /** Must cover every linked PO exactly once and sum to 100 (± 0.01). Pass `null` to reset to auto by-value. */
  overrides: ShipmentGroupAllocationOverride[] | null;
}

export type InventorySerialStatus = typeof InventorySerialStatus[keyof typeof InventorySerialStatus];


export const InventorySerialStatus = {
  available: 'available',
  dispatched: 'dispatched',
  void: 'void',
} as const;

export interface InventorySerial {
  id: string;
  tenantId: string;
  inventoryItemId: string;
  /** @maxLength 100 */
  serialNumber?: string | null;
  /** @maxLength 100 */
  certificateNumber?: string | null;
  notes?: string | null;
  status: InventorySerialStatus;
  saleLineId?: string | null;
  dispatchedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type InventorySerialBulkAddRequestEntriesItem = {
  /** @maxLength 100 */
  serialNumber?: string | null;
  /** @maxLength 100 */
  certificateNumber?: string | null;
  /** @maxLength 500 */
  notes?: string | null;
};

export interface InventorySerialBulkAddRequest {
  /**
     * @minItems 1
     * @maxItems 500
     */
  entries: InventorySerialBulkAddRequestEntriesItem[];
}

export type InventorySerialUpdateStatus = typeof InventorySerialUpdateStatus[keyof typeof InventorySerialUpdateStatus] | null;


export const InventorySerialUpdateStatus = {
  available: 'available',
  dispatched: 'dispatched',
  void: 'void',
} as const;

export interface InventorySerialUpdate {
  /** @maxLength 100 */
  serialNumber?: string | null;
  /** @maxLength 100 */
  certificateNumber?: string | null;
  /** @maxLength 500 */
  notes?: string | null;
  status?: InventorySerialUpdateStatus;
}

export interface PackingJobOrderCertUpdate {
  /**
     * Free-form certificate or serial number for this order.
     * @maxLength 100
     */
  certificateNumber?: string | null;
}

export interface PackingJobLineSerialUpdate {
  /** UUID of the inventory_serials row to assign to this sale line. Must be "available" and must belong to the same inventory item as the target line. Pass null to unlink the current serial (reverts its status to "available" and clears sale_order_items.serial_id). */
  serialId: string | null;
}

export type ChannelSyncEventResult = typeof ChannelSyncEventResult[keyof typeof ChannelSyncEventResult];


export const ChannelSyncEventResult = {
  success: 'success',
  error: 'error',
  skipped: 'skipped',
} as const;

export type ChannelSyncEventTriggeredBy = typeof ChannelSyncEventTriggeredBy[keyof typeof ChannelSyncEventTriggeredBy];


export const ChannelSyncEventTriggeredBy = {
  sale: 'sale',
  manual: 'manual',
  scheduler: 'scheduler',
} as const;

export type ChannelSyncEventMetadata = { [key: string]: unknown } | null;

export interface ChannelSyncEvent {
  id: string;
  tenantId: string;
  inventoryItemId?: string | null;
  saleOrderId?: string | null;
  /** Canonical channel slug (ebay, shopify, woocommerce, tiktok_shop). */
  channel: string;
  /** Account label, e.g. "primary" or a named eBay account key. */
  accountKey?: string | null;
  sku?: string | null;
  /** Absolute quantity pushed (null for skipped rows). */
  quantityPushed?: number | null;
  result: ChannelSyncEventResult;
  skipReason?: string | null;
  errorMessage?: string | null;
  triggeredBy: ChannelSyncEventTriggeredBy;
  metadata?: ChannelSyncEventMetadata;
  createdAt: string;
}

export type BoxSaleEligibilityCustomer = {
  id: string;
  name: string;
  /** @nullable */
  email: string | null;
  portalStatus: string;
  portalLinked: boolean;
} | null;

export interface BoxSaleEligibilityLine {
  id: string;
  productTitle: string;
  /** @nullable */
  sku: string | null;
  /** @nullable */
  imageUrl: string | null;
  quantity: number;
  /** @nullable */
  salePrice: string | null;
  physicallyReceived: number;
  /** @nullable */
  etaDate: string | null;
  /** @nullable */
  etaDateTo: string | null;
  returnedQuantity: number;
  storedQuantity: number;
  /** @nullable */
  storedPurchaseId: string | null;
  dispatchedQuantity: number;
  preparingToShipQuantity: number;
  directDispatchedQuantity: number;
  directPreparingToShipQuantity: number;
  allocatedQuantity: number;
  hasAllocationLineage: boolean;
  lineRefunded: boolean;
  adjustmentRecorded: boolean;
  preOrderAllocated: boolean;
  preOrderReceivedQuantity: number;
  preOrderPaidQuantity: number;
  preOrderAllocationActive: boolean;
  packingReserved: boolean;
  shipmentReserved: boolean;
  unresolvedShipmentEvidence: boolean;
  serialAssigned: boolean;
  eligibleQuantity: number;
  remainingQuantity: number;
  /** @nullable */
  status: string | null;
  /** @nullable */
  unavailableReason: string | null;
}

export interface BoxSaleEligibility {
  saleOrderId: string;
  orderNumber: string;
  currency: string;
  orderStatus: string;
  paymentStatus: string;
  /** @nullable */
  amountPaid: number | null;
  /** @nullable */
  balanceDue: number | null;
  /** @nullable */
  trackingNumber: string | null;
  /** @nullable */
  saleDate: string | null;
  customer: BoxSaleEligibilityCustomer;
  /** @nullable */
  ownershipError: string | null;
  lines: BoxSaleEligibilityLine[];
}

export interface CommerceBoxStorageCapability {
  available: boolean;
  /** @nullable */
  unavailableReason: string | null;
}

export interface PreorderStorageCorrectionInput {
  /** @pattern ^[a-f0-9]{64}$ */
  previewToken: string;
  confirmPhysicalBarsPresent: true;
  confirmStorageIntent: true;
}

export type PreorderStorageCorrectionPreviewCustomer = {
  id: string;
  name: string;
  portalStatus: string;
} | null;

export type PreorderStorageCorrectionPreviewSale = {
  status: string;
  paymentStatus: string;
};

export type PreorderStorageCorrectionPreviewLine = {
  saleOrderItemId: string;
  productTitle: string;
  /** @nullable */
  sku: string | null;
  quantity: number;
  physicallyReceivedBefore: number;
  physicallyReceivedAfter: number;
  comingSoonQuantityBefore: number;
  comingSoonQuantityAfter: number;
  saleComingSoonBefore: boolean;
  saleComingSoonAfter: boolean;
  preOrderInventoryPendingRemains: boolean;
  /** @nullable */
  inventoryEffectAppliedAtRemains: string | null;
} | null;

export type PreorderStorageCorrectionPreviewAssignment = {
  /** @nullable */
  purchaseOrderItemId: string | null;
  inventoryItemId: string;
  assignedQuantity: number;
  receivedQuantity: number;
  paidQuantity: number;
} | null;

export type PreorderStorageCorrectionPreviewLot = {
  lotId: string;
  lotRef: string;
  quantity: number;
  availableBefore: number;
  availableAfter: number;
  soldBefore: number;
  soldAfter: number;
} | null;

export type PreorderStorageCorrectionPreviewPackingJobRetainedOrdersItem = {
  saleOrderId: string;
  orderNumber: string;
};

export type PreorderStorageCorrectionPreviewPackingJob = {
  id: string;
  statusBefore: string;
  statusAfter: string;
  orderCountBefore: number;
  orderCountAfter: number;
  retainedOrders: PreorderStorageCorrectionPreviewPackingJobRetainedOrdersItem[];
} | null;

export type PreorderStorageCorrectionPreviewBoxInventoryProductCountersChange = typeof PreorderStorageCorrectionPreviewBoxInventoryProductCountersChange[keyof typeof PreorderStorageCorrectionPreviewBoxInventoryProductCountersChange];


export const PreorderStorageCorrectionPreviewBoxInventoryProductCountersChange = {
  none: 'none',
} as const;

export type PreorderStorageCorrectionPreviewBoxDispatchOrShipmentChange = typeof PreorderStorageCorrectionPreviewBoxDispatchOrShipmentChange[keyof typeof PreorderStorageCorrectionPreviewBoxDispatchOrShipmentChange];


export const PreorderStorageCorrectionPreviewBoxDispatchOrShipmentChange = {
  none: 'none',
} as const;

export type PreorderStorageCorrectionPreviewBoxCustomerVerificationChange = typeof PreorderStorageCorrectionPreviewBoxCustomerVerificationChange[keyof typeof PreorderStorageCorrectionPreviewBoxCustomerVerificationChange];


export const PreorderStorageCorrectionPreviewBoxCustomerVerificationChange = {
  none: 'none',
} as const;

export type PreorderStorageCorrectionPreviewBox = {
  quantityToAdd: number;
  inventoryProductCountersChange: PreorderStorageCorrectionPreviewBoxInventoryProductCountersChange;
  dispatchOrShipmentChange: PreorderStorageCorrectionPreviewBoxDispatchOrShipmentChange;
  customerVerificationChange: PreorderStorageCorrectionPreviewBoxCustomerVerificationChange;
};

export type PreorderStorageCorrectionPreviewInventoryCostingPolicy = {
  /** @nullable */
  allocationMethod: string | null;
  /** @nullable */
  ownershipPriority: string | null;
};

export interface PreorderStorageCorrectionPreview {
  saleOrderId: string;
  orderNumber: string;
  eligible: boolean;
  alreadyApplied: boolean;
  blockers: string[];
  /** @nullable */
  previewToken: string | null;
  customer: PreorderStorageCorrectionPreviewCustomer;
  sale: PreorderStorageCorrectionPreviewSale;
  line: PreorderStorageCorrectionPreviewLine;
  assignment: PreorderStorageCorrectionPreviewAssignment;
  lot: PreorderStorageCorrectionPreviewLot;
  packingJob: PreorderStorageCorrectionPreviewPackingJob;
  box: PreorderStorageCorrectionPreviewBox;
  inventoryCostingPolicy: PreorderStorageCorrectionPreviewInventoryCostingPolicy;
}

export type PreorderStorageCorrectionResultLot = {
  lotId: string;
  lotRef: string;
  quantity: number;
  availableBefore: number;
  availableAfter: number;
  soldBefore: number;
  soldAfter: number;
};

export type PreorderStorageCorrectionResultPackingJob = {
  id: string;
  orderCountBefore: number;
  orderCountAfter: number;
};

export type PreorderStorageCorrectionResultConfirmations = {
  physicalBarsPresent: boolean;
  storageIntent: boolean;
};

export type PreorderStorageCorrectionResultStatePreserved = {
  preOrderInventoryPending: boolean;
  /** @nullable */
  inventoryEffectAppliedAt: string | null;
  customerVerificationChanged: false;
  shipmentMarked: false;
};

export interface PreorderStorageCorrectionResult {
  applied: boolean;
  replayed: boolean;
  saleOrderId: string;
  orderNumber: string;
  saleOrderItemId: string;
  storedPurchaseId: string;
  quantityAdded: number;
  lot: PreorderStorageCorrectionResultLot;
  packingJob: PreorderStorageCorrectionResultPackingJob;
  confirmations: PreorderStorageCorrectionResultConfirmations;
  statePreserved: PreorderStorageCorrectionResultStatePreserved;
}

export type WhatsappTrackingBatchInputSource = typeof WhatsappTrackingBatchInputSource[keyof typeof WhatsappTrackingBatchInputSource];


export const WhatsappTrackingBatchInputSource = {
  manual: 'manual',
} as const;

export type WhatsappTrackingBatchInputEntriesItem = {
  /**
     * @minLength 8
     * @maxLength 40
     */
  trackingNumber: string;
  /**
     * @minLength 1
     * @maxLength 180
     */
  customerReference: string;
};

export interface WhatsappTrackingBatchInput {
  source: WhatsappTrackingBatchInputSource;
  isTest?: boolean;
  /**
     * @minItems 1
     * @maxItems 100
     */
  entries: WhatsappTrackingBatchInputEntriesItem[];
}

export type WhatsappTrackingReadinessSenderStatus = typeof WhatsappTrackingReadinessSenderStatus[keyof typeof WhatsappTrackingReadinessSenderStatus];


export const WhatsappTrackingReadinessSenderStatus = {
  unverified: 'unverified',
  configured: 'configured',
  verified: 'verified',
} as const;

export type WhatsappTrackingReadinessTemplateStatus = typeof WhatsappTrackingReadinessTemplateStatus[keyof typeof WhatsappTrackingReadinessTemplateStatus];


export const WhatsappTrackingReadinessTemplateStatus = {
  unverified: 'unverified',
  missing: 'missing',
  pending: 'pending',
  approved_utility: 'approved_utility',
  approved_marketing: 'approved_marketing',
  not_utility: 'not_utility',
  unavailable: 'unavailable',
} as const;

export type WhatsappTrackingReadinessMarketingTemplateStatus = typeof WhatsappTrackingReadinessMarketingTemplateStatus[keyof typeof WhatsappTrackingReadinessMarketingTemplateStatus];


export const WhatsappTrackingReadinessMarketingTemplateStatus = {
  unverified: 'unverified',
  missing: 'missing',
  pending: 'pending',
  approved_utility: 'approved_utility',
  approved_marketing: 'approved_marketing',
  not_utility: 'not_utility',
  unavailable: 'unavailable',
} as const;

export type WhatsappTrackingReadinessTemplateMappingStatus = typeof WhatsappTrackingReadinessTemplateMappingStatus[keyof typeof WhatsappTrackingReadinessTemplateMappingStatus];


export const WhatsappTrackingReadinessTemplateMappingStatus = {
  unverified: 'unverified',
  missing: 'missing',
  valid: 'valid',
  invalid: 'invalid',
} as const;

export interface WhatsappTrackingReadiness {
  sendingEnabled: boolean;
  globalSendEnabled: boolean;
  testCompleted: boolean;
  senderStatus: WhatsappTrackingReadinessSenderStatus;
  templateStatus: WhatsappTrackingReadinessTemplateStatus;
  marketingTemplateStatus: WhatsappTrackingReadinessMarketingTemplateStatus;
  templateMappingStatus: WhatsappTrackingReadinessTemplateMappingStatus;
  /** @nullable */
  templateName?: string | null;
  /** @nullable */
  marketingTemplateName?: string | null;
  blockers: string[];
}

export type WhatsappTrackingBatchSummarySource = typeof WhatsappTrackingBatchSummarySource[keyof typeof WhatsappTrackingBatchSummarySource];


export const WhatsappTrackingBatchSummarySource = {
  manual: 'manual',
  hazel: 'hazel',
  chatgpt: 'chatgpt',
} as const;

export type WhatsappTrackingBatchSummaryStatus = typeof WhatsappTrackingBatchSummaryStatus[keyof typeof WhatsappTrackingBatchSummaryStatus];


export const WhatsappTrackingBatchSummaryStatus = {
  review: 'review',
  sending: 'sending',
  complete: 'complete',
  blocked: 'blocked',
  failed: 'failed',
} as const;

export interface WhatsappTrackingBatchSummary {
  id: string;
  source: WhatsappTrackingBatchSummarySource;
  createdAt: string;
  itemCount: number;
  readyCount: number;
  blockedCount: number;
  status: WhatsappTrackingBatchSummaryStatus;
}

export type WhatsappTrackingBatchItemStatus = typeof WhatsappTrackingBatchItemStatus[keyof typeof WhatsappTrackingBatchItemStatus];


export const WhatsappTrackingBatchItemStatus = {
  ready: 'ready',
  blocked: 'blocked',
  queued: 'queued',
  accepted: 'accepted',
  sending: 'sending',
  sent: 'sent',
  error: 'error',
  send_uncertain: 'send_uncertain',
  failed: 'failed',
  delivered: 'delivered',
  read: 'read',
  undelivered: 'undelivered',
} as const;

export type WhatsappTrackingDeliveryStatusEventsItem = {
  status: string;
  at: string;
};

export interface WhatsappTrackingDelivery {
  status: string;
  updatedAt: string;
  /** @nullable */
  providerMessageSid: string | null;
  statusEvents: WhatsappTrackingDeliveryStatusEventsItem[];
}

export interface WhatsappTrackingBatchItem {
  trackingNumber: string;
  customerReference: string;
  /** @nullable */
  customerId: string | null;
  /** @nullable */
  customerName: string | null;
  /** @nullable */
  saleOrderId: string | null;
  /** @nullable */
  orderNumber: string | null;
  /** @nullable */
  maskedPhone: string | null;
  trackingUrl: string;
  messagePreview: string;
  blockers: string[];
  status: WhatsappTrackingBatchItemStatus;
  delivery?: WhatsappTrackingDelivery | null;
}

export type WhatsappTrackingBatchSource = typeof WhatsappTrackingBatchSource[keyof typeof WhatsappTrackingBatchSource];


export const WhatsappTrackingBatchSource = {
  manual: 'manual',
  hazel: 'hazel',
  chatgpt: 'chatgpt',
} as const;

export type WhatsappTrackingBatchStatus = typeof WhatsappTrackingBatchStatus[keyof typeof WhatsappTrackingBatchStatus];


export const WhatsappTrackingBatchStatus = {
  review: 'review',
  sending: 'sending',
  complete: 'complete',
  blocked: 'blocked',
  failed: 'failed',
} as const;

export interface WhatsappTrackingBatch {
  id: string;
  source: WhatsappTrackingBatchSource;
  createdAt: string;
  status: WhatsappTrackingBatchStatus;
  sendingEnabled: boolean;
  isTest: boolean;
  previewDigest: string;
  items: WhatsappTrackingBatchItem[];
}

export type WhatsappTrackingApprovalAction = typeof WhatsappTrackingApprovalAction[keyof typeof WhatsappTrackingApprovalAction];


export const WhatsappTrackingApprovalAction = {
  test: 'test',
  batch: 'batch',
  retry_failed: 'retry_failed',
} as const;

export interface WhatsappTrackingApproval {
  confirm: true;
  action: WhatsappTrackingApprovalAction;
  /**
     * @minLength 64
     * @maxLength 64
     */
  previewDigest: string;
}

export type WhatsappTrackingSendResultStatus = typeof WhatsappTrackingSendResultStatus[keyof typeof WhatsappTrackingSendResultStatus];


export const WhatsappTrackingSendResultStatus = {
  sending: 'sending',
  complete: 'complete',
} as const;

export interface WhatsappTrackingSendResult {
  batchId: string;
  status: WhatsappTrackingSendResultStatus;
  queuedCount: number;
  messageLogIds: string[];
}

export interface WhatsappOwnerShippingTestPrepare {
  confirmLimitedAuthorization: true;
  /**
     * @minLength 64
     * @maxLength 64
     */
  previewDigest: string;
}

export interface WhatsappOwnerShippingTestAttestation {
  confirmReviewed: true;
  /**
     * @minLength 64
     * @maxLength 64
     */
  previewDigest: string;
}

export interface WhatsappOwnerShippingTestApproval {
  confirmSend: true;
  /**
     * @minLength 64
     * @maxLength 64
     */
  previewDigest: string;
}

export type WhatsappOwnerShippingTestConfigurationSource = typeof WhatsappOwnerShippingTestConfigurationSource[keyof typeof WhatsappOwnerShippingTestConfigurationSource];


export const WhatsappOwnerShippingTestConfigurationSource = {
  tenant_marketplace_integration: 'tenant_marketplace_integration',
} as const;

export type WhatsappOwnerShippingTestConfiguration = {
  source: WhatsappOwnerShippingTestConfigurationSource;
  integrationConfigured: boolean;
  accountSidPresent: boolean;
  encryptedAuthTokenPresent: boolean;
  senderPhonePresent: boolean;
  usableCredentialBundle: boolean;
  requiredTemplateSidSelected: boolean;
  requiredVariableMapPresent: boolean;
};

export type WhatsappOwnerShippingTestAuthorizationRecipientName = typeof WhatsappOwnerShippingTestAuthorizationRecipientName[keyof typeof WhatsappOwnerShippingTestAuthorizationRecipientName];


export const WhatsappOwnerShippingTestAuthorizationRecipientName = {
  Jaswant_Jeerh: 'Jaswant Jeerh',
} as const;

export type WhatsappOwnerShippingTestAuthorizationRecipientPhone = typeof WhatsappOwnerShippingTestAuthorizationRecipientPhone[keyof typeof WhatsappOwnerShippingTestAuthorizationRecipientPhone];


export const WhatsappOwnerShippingTestAuthorizationRecipientPhone = {
  '+447480943258': '+447480943258',
} as const;

export type WhatsappOwnerShippingTestAuthorizationConsentSource = typeof WhatsappOwnerShippingTestAuthorizationConsentSource[keyof typeof WhatsappOwnerShippingTestAuthorizationConsentSource];


export const WhatsappOwnerShippingTestAuthorizationConsentSource = {
  explicit_user_instruction: 'explicit_user_instruction',
} as const;

export type WhatsappOwnerShippingTestAuthorization = {
  recipientName: WhatsappOwnerShippingTestAuthorizationRecipientName;
  recipientPhone: WhatsappOwnerShippingTestAuthorizationRecipientPhone;
  consentSource: WhatsappOwnerShippingTestAuthorizationConsentSource;
  consentScope: string;
  recorded: boolean;
  /** @nullable */
  recordedAt: string | null;
};

export type WhatsappOwnerShippingTestSyntheticValuesCustomerName = typeof WhatsappOwnerShippingTestSyntheticValuesCustomerName[keyof typeof WhatsappOwnerShippingTestSyntheticValuesCustomerName];


export const WhatsappOwnerShippingTestSyntheticValuesCustomerName = {
  SYNTHETIC_TEST_CUSTOMER: 'SYNTHETIC TEST CUSTOMER',
} as const;

export type WhatsappOwnerShippingTestSyntheticValuesOrderNumber = typeof WhatsappOwnerShippingTestSyntheticValuesOrderNumber[keyof typeof WhatsappOwnerShippingTestSyntheticValuesOrderNumber];


export const WhatsappOwnerShippingTestSyntheticValuesOrderNumber = {
  'TEST-ONLY-ORDER-0001': 'TEST-ONLY-ORDER-0001',
} as const;

export type WhatsappOwnerShippingTestSyntheticValuesTrackingNumber = typeof WhatsappOwnerShippingTestSyntheticValuesTrackingNumber[keyof typeof WhatsappOwnerShippingTestSyntheticValuesTrackingNumber];


export const WhatsappOwnerShippingTestSyntheticValuesTrackingNumber = {
  'TEST-ONLY-TRACKING-0001': 'TEST-ONLY-TRACKING-0001',
} as const;

export type WhatsappOwnerShippingTestSyntheticValuesTrackingUrl = typeof WhatsappOwnerShippingTestSyntheticValuesTrackingUrl[keyof typeof WhatsappOwnerShippingTestSyntheticValuesTrackingUrl];


export const WhatsappOwnerShippingTestSyntheticValuesTrackingUrl = {
  'https://trackinginvalid/TEST-ONLY-TRACKING-0001': 'https://tracking.invalid/TEST-ONLY-TRACKING-0001',
} as const;

export type WhatsappOwnerShippingTestSyntheticValues = {
  customerName: WhatsappOwnerShippingTestSyntheticValuesCustomerName;
  orderNumber: WhatsappOwnerShippingTestSyntheticValuesOrderNumber;
  trackingNumber: WhatsappOwnerShippingTestSyntheticValuesTrackingNumber;
  trackingUrl: WhatsappOwnerShippingTestSyntheticValuesTrackingUrl;
};

export type WhatsappOwnerShippingTestSenderLiveLookupStatus = typeof WhatsappOwnerShippingTestSenderLiveLookupStatus[keyof typeof WhatsappOwnerShippingTestSenderLiveLookupStatus];


export const WhatsappOwnerShippingTestSenderLiveLookupStatus = {
  not_checked: 'not_checked',
  checked: 'checked',
  error: 'error',
} as const;

export type WhatsappOwnerShippingTestSender = {
  /** @nullable */
  phone: string | null;
  /** @nullable */
  liveStatus: string | null;
  liveLookupStatus: WhatsappOwnerShippingTestSenderLiveLookupStatus;
  sharedAttestationRecorded: boolean;
};

export type WhatsappOwnerShippingTestTemplateSid = typeof WhatsappOwnerShippingTestTemplateSid[keyof typeof WhatsappOwnerShippingTestTemplateSid];


export const WhatsappOwnerShippingTestTemplateSid = {
  HX0bbc93a1ed563929a9e71d4c35619c91: 'HX0bbc93a1ed563929a9e71d4c35619c91',
} as const;

export type WhatsappOwnerShippingTestTemplateLookupStatus = typeof WhatsappOwnerShippingTestTemplateLookupStatus[keyof typeof WhatsappOwnerShippingTestTemplateLookupStatus];


export const WhatsappOwnerShippingTestTemplateLookupStatus = {
  not_checked: 'not_checked',
  checked: 'checked',
  error: 'error',
} as const;

export type WhatsappOwnerShippingTestTemplate = {
  sid: WhatsappOwnerShippingTestTemplateSid;
  /** @nullable */
  name: string | null;
  /** @nullable */
  language: string | null;
  /** @nullable */
  approvalStatus: string | null;
  /** @nullable */
  category: string | null;
  /** @nullable */
  body: string | null;
  variableMap: WhatsappTrackingTemplateVariableMap | null;
  lookupStatus: WhatsappOwnerShippingTestTemplateLookupStatus;
  exactMatch: boolean;
};

export type WhatsappOwnerShippingTestReadiness = {
  reviewReady: boolean;
  testSendSwitchEnabled: boolean;
  recipientOptedOut: boolean;
  blockers: string[];
};

export type WhatsappOwnerShippingTestAttemptStatus = typeof WhatsappOwnerShippingTestAttemptStatus[keyof typeof WhatsappOwnerShippingTestAttemptStatus];


export const WhatsappOwnerShippingTestAttemptStatus = {
  not_prepared: 'not_prepared',
  review: 'review',
  attested: 'attested',
  sending: 'sending',
  accepted: 'accepted',
  sent: 'sent',
  delivered: 'delivered',
  read: 'read',
  failed: 'failed',
  undelivered: 'undelivered',
  send_uncertain: 'send_uncertain',
} as const;

export type WhatsappOwnerShippingTestAttempt = {
  status: WhatsappOwnerShippingTestAttemptStatus;
  /** @nullable */
  preparedAt: string | null;
  /** @nullable */
  preparedBy: string | null;
  /** @nullable */
  attestedAt: string | null;
  /** @nullable */
  attestedBy: string | null;
  /** @nullable */
  approvedAt: string | null;
  /** @nullable */
  approvedBy: string | null;
  /** @nullable */
  sendStartedAt: string | null;
  /** @nullable */
  providerMessageSid: string | null;
  /** @nullable */
  providerStatus: string | null;
  /** @nullable */
  errorCode: string | null;
  /** @nullable */
  error: string | null;
};

export interface WhatsappOwnerShippingTest {
  canonicalOwnerTenant: boolean;
  /** @maxLength 32 */
  runtimeEnvironment: string;
  configuration: WhatsappOwnerShippingTestConfiguration;
  authorization: WhatsappOwnerShippingTestAuthorization;
  syntheticValues: WhatsappOwnerShippingTestSyntheticValues;
  sender: WhatsappOwnerShippingTestSender;
  template: WhatsappOwnerShippingTestTemplate;
  preview: string;
  /**
     * @minLength 64
     * @maxLength 64
     */
  previewDigest: string;
  readiness: WhatsappOwnerShippingTestReadiness;
  attempt: WhatsappOwnerShippingTestAttempt;
}

export type PortfolioIdempotencyKeyParameter = string;

export type IntegrationAccountKeyParameter = string;

export type IntegrationPageLimitParameter = number;

export type IntegrationPageCursorParameter = string;

export type ListWhatsappTrackingBatches200 = {
  batches: WhatsappTrackingBatchSummary[];
};

export type ListWhatsappInboxConversationsParams = {
status?: ListWhatsappInboxConversationsStatus;
assigned?: ListWhatsappInboxConversationsAssigned;
/**
 * @maxLength 120
 */
search?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
before?: string;
};

export type ListWhatsappInboxConversationsStatus = typeof ListWhatsappInboxConversationsStatus[keyof typeof ListWhatsappInboxConversationsStatus];


export const ListWhatsappInboxConversationsStatus = {
  open: 'open',
  pending: 'pending',
  resolved: 'resolved',
  all: 'all',
} as const;

export type ListWhatsappInboxConversationsAssigned = typeof ListWhatsappInboxConversationsAssigned[keyof typeof ListWhatsappInboxConversationsAssigned];


export const ListWhatsappInboxConversationsAssigned = {
  mine: 'mine',
  unassigned: 'unassigned',
  all: 'all',
} as const;

export type CreateWhatsappInboxNoteBody = {
  /**
     * @minLength 1
     * @maxLength 4000
     */
  body: string;
};

export type UploadWhatsappInboxAttachmentBody = {
  file: Blob;
};

export type ListWhatsappInboxTemplates200 = {
  templates: WhatsappInboxTemplate[];
};

export type ListWhatsappInboxOperators200OperatorsItem = {
  id: string;
  role: string;
  /** @nullable */
  name: string | null;
};

export type ListWhatsappInboxOperators200 = {
  operators: ListWhatsappInboxOperators200OperatorsItem[];
};

export type ListWhatsappInboxQuickReplies200 = {
  quickReplies: WhatsappInboxQuickReply[];
};

export type CreateWhatsappInboxQuickReplyBody = {
  /**
     * @minLength 1
     * @maxLength 120
     */
  title: string;
  /**
     * @minLength 1
     * @maxLength 4000
     */
  body: string;
};

export type GetWhatsappInboxAnalyticsParams = {
/**
 * @minimum 7
 * @maximum 90
 */
days?: number;
};

export type GetWhatnotConditionOptionsParams = {
/**
 * @minLength 1
 * @maxLength 255
 */
taxonomyId: string;
};

export type GetWhatnotCategoryCatalogParams = {
/**
 * @maxLength 100
 */
search?: string;
};

export type ListCustomerOrderEmailNotificationsParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
};

export type GetDemandOverviewParams = {
period?: GetDemandOverviewPeriod;
from?: string;
to?: string;
};

export type GetDemandOverviewPeriod = typeof GetDemandOverviewPeriod[keyof typeof GetDemandOverviewPeriod];


export const GetDemandOverviewPeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
  '6m': '6m',
  '12m': '12m',
  custom: 'custom',
} as const;

export type GetDemandOverview200 = { [key: string]: unknown };

export type GetDemandViewParams = {
period?: GetDemandViewPeriod;
from?: string;
to?: string;
};

export type GetDemandViewPeriod = typeof GetDemandViewPeriod[keyof typeof GetDemandViewPeriod];


export const GetDemandViewPeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
  '6m': '6m',
  '12m': '12m',
  custom: 'custom',
} as const;

export type GetDemandView200 = { [key: string]: unknown };

export type GetDemandProductParams = {
period?: GetDemandProductPeriod;
};

export type GetDemandProductPeriod = typeof GetDemandProductPeriod[keyof typeof GetDemandProductPeriod];


export const GetDemandProductPeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
  '6m': '6m',
  '12m': '12m',
  custom: 'custom',
} as const;

export type GetDemandProduct200 = { [key: string]: unknown };

export type GetDemandTargets200 = { [key: string]: unknown };

export type CreateDemandTargetBodyMetric = typeof CreateDemandTargetBodyMetric[keyof typeof CreateDemandTargetBodyMetric];


export const CreateDemandTargetBodyMetric = {
  units: 'units',
  orders: 'orders',
  revenue: 'revenue',
  trueProfit: 'trueProfit',
} as const;

export type CreateDemandTargetBody = {
  /** @maxLength 120 */
  name: string;
  metric: CreateDemandTargetBodyMetric;
  /** @exclusiveMinimum 0 */
  target: number;
  startDate: string;
  endDate: string;
};

export type ExportDemandProductsParams = {
period?: ExportDemandProductsPeriod;
from?: string;
to?: string;
};

export type ExportDemandProductsPeriod = typeof ExportDemandProductsPeriod[keyof typeof ExportDemandProductsPeriod];


export const ExportDemandProductsPeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
  '6m': '6m',
  '12m': '12m',
  custom: 'custom',
} as const;

export type CreateDemandPurchaseDraftsBody = {
  /** @maxItems 100 */
  productIds: string[];
  /** @maxLength 200 */
  idempotencyKey?: string;
};

export type ListCatalogueReportsParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * @maxLength 200
 */
productKey?: string;
/**
 * @maxLength 120
 */
fieldKey?: string;
status?: ListCatalogueReportsStatus;
sort?: ListCatalogueReportsSort;
direction?: ListCatalogueReportsDirection;
};

export type ListCatalogueReportsStatus = typeof ListCatalogueReportsStatus[keyof typeof ListCatalogueReportsStatus];


export const ListCatalogueReportsStatus = {
  missing: 'missing',
  conflict: 'conflict',
  stale: 'stale',
  ambiguous: 'ambiguous',
  deferred: 'deferred',
  suggested: 'suggested',
} as const;

export type ListCatalogueReportsSort = typeof ListCatalogueReportsSort[keyof typeof ListCatalogueReportsSort];


export const ListCatalogueReportsSort = {
  confidence: 'confidence',
  product: 'product',
  updated_at: 'updated_at',
} as const;

export type ListCatalogueReportsDirection = typeof ListCatalogueReportsDirection[keyof typeof ListCatalogueReportsDirection];


export const ListCatalogueReportsDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ExportCatalogueReportsParams = {
status?: ExportCatalogueReportsStatus;
/**
 * @maxLength 200
 */
productKey?: string;
/**
 * @maxLength 120
 */
fieldKey?: string;
sort?: ExportCatalogueReportsSort;
direction?: ExportCatalogueReportsDirection;
};

export type ExportCatalogueReportsStatus = typeof ExportCatalogueReportsStatus[keyof typeof ExportCatalogueReportsStatus];


export const ExportCatalogueReportsStatus = {
  missing: 'missing',
  conflict: 'conflict',
  stale: 'stale',
  ambiguous: 'ambiguous',
  deferred: 'deferred',
  suggested: 'suggested',
} as const;

export type ExportCatalogueReportsSort = typeof ExportCatalogueReportsSort[keyof typeof ExportCatalogueReportsSort];


export const ExportCatalogueReportsSort = {
  confidence: 'confidence',
  product: 'product',
  updated_at: 'updated_at',
} as const;

export type ExportCatalogueReportsDirection = typeof ExportCatalogueReportsDirection[keyof typeof ExportCatalogueReportsDirection];


export const ExportCatalogueReportsDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ListCatalogueEvidenceParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * @maxLength 200
 */
productKey?: string;
/**
 * @maxLength 120
 */
fieldKey?: string;
};

export type ListCatalogueSuggestionsParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * @maxLength 200
 */
productKey?: string;
/**
 * @maxLength 120
 */
fieldKey?: string;
status?: ListCatalogueSuggestionsStatus;
};

export type ListCatalogueSuggestionsStatus = typeof ListCatalogueSuggestionsStatus[keyof typeof ListCatalogueSuggestionsStatus];


export const ListCatalogueSuggestionsStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export type GetMobileDashboardSecondaryParams = {
range?: GetMobileDashboardSecondaryRange;
};

export type GetMobileDashboardSecondaryRange = typeof GetMobileDashboardSecondaryRange[keyof typeof GetMobileDashboardSecondaryRange];


export const GetMobileDashboardSecondaryRange = {
  today: 'today',
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type GetVatDueSummaryParams = {
preset?: GetVatDueSummaryPreset;
from?: string;
to?: string;
};

export type GetVatDueSummaryPreset = typeof GetVatDueSummaryPreset[keyof typeof GetVatDueSummaryPreset];


export const GetVatDueSummaryPreset = {
  this_month: 'this_month',
  previous_month: 'previous_month',
  current_calendar_quarter: 'current_calendar_quarter',
  previous_calendar_quarter: 'previous_calendar_quarter',
  custom: 'custom',
} as const;

export type UpdateVatPlanningSettingsBody = {
  enabled: boolean;
};

export type RunVatPlanningCatchUpBody = {
  /**
     * @minimum 1
     * @maximum 1000
     */
  limit?: number;
  /** Continue the same fixed-end job */
  jobId?: string;
};

export type ListVatDueEntriesParams = {
preset?: ListVatDueEntriesPreset;
from?: string;
to?: string;
treatment?: string;
status?: string;
workflow?: string;
secondary?: string;
channel?: string;
search?: string;
credited?: boolean;
unresolved?: boolean;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListVatDueEntriesPreset = typeof ListVatDueEntriesPreset[keyof typeof ListVatDueEntriesPreset];


export const ListVatDueEntriesPreset = {
  this_month: 'this_month',
  previous_month: 'previous_month',
  current_calendar_quarter: 'current_calendar_quarter',
  previous_calendar_quarter: 'previous_calendar_quarter',
  custom: 'custom',
} as const;

export type ListInventoryLotsVatReviewParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type GetCustomerPortfolioSettings200 = {
  settings: CustomerPortfolioSettings;
};

export type UpdateCustomerPortfolioSettings200 = {
  settings: CustomerPortfolioSettings;
};

export type ListCustomerPortfolioProductsParams = {
search?: string;
includeInactive?: boolean;
};

export type ListCustomerPortfolioProducts200 = {
  products: PortfolioProduct[];
};

export type CreateCustomerPortfolioProduct201 = {
  product?: PortfolioProduct;
};

export type UpdateCustomerPortfolioProduct200 = {
  product?: PortfolioProduct;
};

export type ListCustomerPortalPortfolioProductsParams = {
search?: string;
};

export type ListCustomerPortalPortfolioProducts200 = {
  products: PortfolioProduct[];
};

export type ListCustomerPortalPortfolioTransactionsParams = {
search?: string;
metal?: CustomerPortfolioMetal;
productType?: CustomerPortfolioProductType;
dealer?: string;
product?: string;
from?: string;
to?: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListCustomerPortfoliosParams = {
customerId: string;
};

export type ListCustomerPortfolios200 = {
  portfolios: CustomerPortfolio[];
};

export type ImportInventory409 = {
  error: string;
  jobId?: string | null;
};

export type ImportSales202 = {
  logId: string;
  status: string;
  jobId?: string | null;
};

export type ImportSales409 = {
  error: string;
  jobId?: string | null;
};

export type ListImportLogsParams = {
kind?: ListImportLogsKind;
};

export type ListImportLogsKind = typeof ListImportLogsKind[keyof typeof ListImportLogsKind];


export const ListImportLogsKind = {
  inventory: 'inventory',
  sales: 'sales',
  shopify_inventory: 'shopify_inventory',
} as const;

export type ResolveImportIssue200 = {
  ok: boolean;
};

export type RollbackImport200 = {
  ok: boolean;
  deletedCount: number;
};

export type GetSocialSettings200 = {[key: string]: string};

export type UpdateSocialSettings200 = {[key: string]: string};

export type ListSocialPostsParams = {
platform?: SocialPlatform;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
sort?: ListSocialPostsSort;
/**
 * @maxLength 300
 */
cursor?: string;
};

export type ListSocialPostsSort = typeof ListSocialPostsSort[keyof typeof ListSocialPostsSort];


export const ListSocialPostsSort = {
  recent: 'recent',
  engagement: 'engagement',
} as const;

export type SyncSocialPlatform202 = {
  queued: boolean;
  jobId: string | null;
  platform: SocialPlatform;
};

export type ListSocialSyncLogsParams = {
platform?: SocialPlatform;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type ListSocialPreparedPostsParams = {
platform?: SocialPlatform;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @maxLength 300
 */
cursor?: string;
};

export type GetSocialCapabilities200 = {
  contractVersion: number;
  capabilities: SocialCapability[];
};

export type GetSocialAnalyticsParams = {
/**
 * @minimum 1
 * @maximum 365
 */
windowDays?: number;
};

export type ListSocialAnalyticsSnapshotsParams = {
/**
 * Number of days of history to return (max 365, ~8 760 rows per platform).
 * @minimum 1
 * @maximum 365
 */
days?: number;
/**
 * Filter to a single platform. Omit to return all platforms.
 */
platform?: SocialPlatform;
};

export type GetSocialAnalyticsWorkspaceParams = {
period?: GetSocialAnalyticsWorkspacePeriod;
/**
 * Exact prepared window selector; must be 7, 30, 90, or 365.
 */
windowDays?: GetSocialAnalyticsWorkspaceWindowDays;
/**
 * @maxLength 32
 */
platform?: string;
metric?: GetSocialAnalyticsWorkspaceMetric;
/**
 * Comma-separated metric names requested by the workspace UI.
 * @maxLength 300
 */
metrics?: string;
};

export type GetSocialAnalyticsWorkspacePeriod = typeof GetSocialAnalyticsWorkspacePeriod[keyof typeof GetSocialAnalyticsWorkspacePeriod];


export const GetSocialAnalyticsWorkspacePeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
  '365d': '365d',
} as const;

export type GetSocialAnalyticsWorkspaceWindowDays = typeof GetSocialAnalyticsWorkspaceWindowDays[keyof typeof GetSocialAnalyticsWorkspaceWindowDays];


export const GetSocialAnalyticsWorkspaceWindowDays = {
  NUMBER_7: 7,
  NUMBER_30: 30,
  NUMBER_90: 90,
  NUMBER_365: 365,
} as const;

export type GetSocialAnalyticsWorkspaceMetric = typeof GetSocialAnalyticsWorkspaceMetric[keyof typeof GetSocialAnalyticsWorkspaceMetric];


export const GetSocialAnalyticsWorkspaceMetric = {
  posts: 'posts',
  engagement: 'engagement',
  reach: 'reach',
  views: 'views',
  clicks: 'clicks',
  conversions: 'conversions',
} as const;

export type GetSocialBestTimeParams = {
period?: GetSocialBestTimePeriod;
/**
 * @maxLength 32
 */
platform?: string;
};

export type GetSocialBestTimePeriod = typeof GetSocialBestTimePeriod[keyof typeof GetSocialBestTimePeriod];


export const GetSocialBestTimePeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type GetSocialTrafficParams = {
period?: GetSocialTrafficPeriod;
};

export type GetSocialTrafficPeriod = typeof GetSocialTrafficPeriod[keyof typeof GetSocialTrafficPeriod];


export const GetSocialTrafficPeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type GetSocialAttributionParams = {
period?: GetSocialAttributionPeriod;
};

export type GetSocialAttributionPeriod = typeof GetSocialAttributionPeriod[keyof typeof GetSocialAttributionPeriod];


export const GetSocialAttributionPeriod = {
  '7d': '7d',
  '30d': '30d',
  '90d': '90d',
} as const;

export type GetSocialLiveOverview200 = {
  items: SocialLiveEvent[];
  bounded: boolean;
  freshness: string;
};

export type GetSocialLiveMetrics200 = { [key: string]: unknown };

export type ListSocialLiveAlerts200 = { [key: string]: unknown };

export type ListSocialLiveModeration200 = { [key: string]: unknown };

export type ListSocialLiveProducts200 = { [key: string]: unknown };

export type ListSocialLiveOffers200 = { [key: string]: unknown };

export type ListSocialInboxParams = {
platform?: SocialPlatform;
isRead?: ListSocialInboxIsRead;
requiresReply?: ListSocialInboxRequiresReply;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 * @maximum 1000
 */
offset?: number;
};

export type ListSocialInboxIsRead = typeof ListSocialInboxIsRead[keyof typeof ListSocialInboxIsRead];


export const ListSocialInboxIsRead = {
  true: 'true',
  false: 'false',
} as const;

export type ListSocialInboxRequiresReply = typeof ListSocialInboxRequiresReply[keyof typeof ListSocialInboxRequiresReply];


export const ListSocialInboxRequiresReply = {
  true: 'true',
  false: 'false',
} as const;

export type ListSocialInbox200 = { [key: string]: unknown };

export type CreateSocialInboxAiSuggestionBody = {
  /** @maxLength 500 */
  instruction?: string;
};

export type ListSocialScheduledPostsParams = {
status?: ListSocialScheduledPostsStatus;
platform?: SocialPlatform;
/**
 * @maxLength 200
 */
search?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListSocialScheduledPostsStatus = typeof ListSocialScheduledPostsStatus[keyof typeof ListSocialScheduledPostsStatus];


export const ListSocialScheduledPostsStatus = {
  draft: 'draft',
  scheduled: 'scheduled',
  publishing: 'publishing',
  posted: 'posted',
  partial: 'partial',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type ListSocialScheduledPosts200 = {
  items: SocialScheduledPost[];
  total: number;
};

export type DeleteSocialScheduledPost200 = {
  ok: boolean;
  id: string;
};

export type DeleteSocialLiveEvent200 = {
  ok: boolean;
  id: string;
};

export type ListSocialCalendarParams = {
from: string;
to: string;
};

export type DeleteSocialCalendarEvent200 = {
  ok: boolean;
  id: string;
};

export type GetSocialAiBestTimesParams = {
platform?: SocialPlatform;
};

export type DisconnectSocialAccount200 = {
  ok: boolean;
  id: string;
  platform: SocialPlatform;
};

export type ListSocialMediaParams = {
assetType?: ListSocialMediaAssetType;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
search?: string;
};

export type ListSocialMediaAssetType = typeof ListSocialMediaAssetType[keyof typeof ListSocialMediaAssetType];


export const ListSocialMediaAssetType = {
  image: 'image',
  video: 'video',
  gif: 'gif',
  document: 'document',
} as const;

export type ListSocialMedia200 = {
  items: SocialMediaAsset[];
  total: number;
  nextCursor?: string | null;
  hasMore?: boolean;
};

export type DeleteSocialMediaAsset200 = {
  ok: boolean;
  id: string;
  /** Storage path of the deleted asset, for caller to clean up object storage */
  storagePath?: string | null;
};

export type ListInventoryPhotosForImportParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
search?: string;
};

export type ListInventoryPhotosForImport200ItemsItem = {
  id: string;
  sku?: string | null;
  productTitle: string;
  photoUrl: string;
};

export type ListInventoryPhotosForImport200 = {
  total: number;
  items: ListInventoryPhotosForImport200ItemsItem[];
};

export type ImportInventoryPhotosBody = {
  ids?: string[];
  all?: boolean;
};

export type ImportInventoryPhotos200 = {
  imported: number;
  skipped: number;
};

export type ListSocialCampaignsParams = {
status?: ListSocialCampaignsStatus;
};

export type ListSocialCampaignsStatus = typeof ListSocialCampaignsStatus[keyof typeof ListSocialCampaignsStatus];


export const ListSocialCampaignsStatus = {
  draft: 'draft',
  active: 'active',
  paused: 'paused',
  completed: 'completed',
  archived: 'archived',
} as const;

export type DeleteSocialCampaign200 = {
  ok: boolean;
  id: string;
};

export type ListEbaySyncIssuesParams = {
status?: ListEbaySyncIssuesStatus;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
accountKey?: string;
};

export type ListEbaySyncIssuesStatus = typeof ListEbaySyncIssuesStatus[keyof typeof ListEbaySyncIssuesStatus];


export const ListEbaySyncIssuesStatus = {
  pending: 'pending',
  skipped: 'skipped',
  resolved: 'resolved',
  all: 'all',
} as const;

export type RetryEbaySyncIssueBody = {
  notes?: string | null;
};

export type ListSuppliersParams = {
search?: string;
type?: string;
active?: boolean;
};

export type GetSupplierDirectoryParams = {
search?: string;
query?: string;
type?: string;
country?: string;
active?: boolean;
period?: GetSupplierDirectoryPeriod;
status?: GetSupplierDirectoryStatus;
sort?: GetSupplierDirectorySort;
direction?: GetSupplierDirectoryDirection;
/**
 * @minimum 1
 */
page?: number;
pageSize?: GetSupplierDirectoryPageSize;
};

export type GetSupplierDirectoryPeriod = typeof GetSupplierDirectoryPeriod[keyof typeof GetSupplierDirectoryPeriod];


export const GetSupplierDirectoryPeriod = {
  '30d': '30d',
  '90d': '90d',
  year: 'year',
  lifetime: 'lifetime',
} as const;

export type GetSupplierDirectoryStatus = typeof GetSupplierDirectoryStatus[keyof typeof GetSupplierDirectoryStatus];


export const GetSupplierDirectoryStatus = {
  ready: 'ready',
  insufficient_data: 'insufficient_data',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type GetSupplierDirectorySort = typeof GetSupplierDirectorySort[keyof typeof GetSupplierDirectorySort];


export const GetSupplierDirectorySort = {
  name: 'name',
  createdAt: 'createdAt',
  poCount: 'poCount',
  totalSpend: 'totalSpend',
  openOrders: 'openOrders',
  onTimeRate: 'onTimeRate',
} as const;

export type GetSupplierDirectoryDirection = typeof GetSupplierDirectoryDirection[keyof typeof GetSupplierDirectoryDirection];


export const GetSupplierDirectoryDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSupplierDirectoryPageSize = typeof GetSupplierDirectoryPageSize[keyof typeof GetSupplierDirectoryPageSize];


export const GetSupplierDirectoryPageSize = {
  NUMBER_20: 20,
  NUMBER_50: 50,
  NUMBER_100: 100,
} as const;

export type ExportSupplierDirectoryParams = {
search?: string;
query?: string;
type?: string;
country?: string;
active?: boolean;
period?: ExportSupplierDirectoryPeriod;
status?: ExportSupplierDirectoryStatus;
sort?: ExportSupplierDirectorySort;
direction?: ExportSupplierDirectoryDirection;
};

export type ExportSupplierDirectoryPeriod = typeof ExportSupplierDirectoryPeriod[keyof typeof ExportSupplierDirectoryPeriod];


export const ExportSupplierDirectoryPeriod = {
  '30d': '30d',
  '90d': '90d',
  year: 'year',
  lifetime: 'lifetime',
} as const;

export type ExportSupplierDirectoryStatus = typeof ExportSupplierDirectoryStatus[keyof typeof ExportSupplierDirectoryStatus];


export const ExportSupplierDirectoryStatus = {
  ready: 'ready',
  insufficient_data: 'insufficient_data',
  preparing: 'preparing',
  unavailable: 'unavailable',
} as const;

export type ExportSupplierDirectorySort = typeof ExportSupplierDirectorySort[keyof typeof ExportSupplierDirectorySort];


export const ExportSupplierDirectorySort = {
  name: 'name',
  createdAt: 'createdAt',
  poCount: 'poCount',
  totalSpend: 'totalSpend',
  openOrders: 'openOrders',
  onTimeRate: 'onTimeRate',
} as const;

export type ExportSupplierDirectoryDirection = typeof ExportSupplierDirectoryDirection[keyof typeof ExportSupplierDirectoryDirection];


export const ExportSupplierDirectoryDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ListSupplierMonthlySummariesParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListSupplierPurchaseOrdersParams = {
search?: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListSupplierProductsParams = {
search?: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListSupplierPricingParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListSupplierDocumentsParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListSupplierConsignmentParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type ListPurchaseOrdersParams = {
search?: string;
status?: string;
supplierId?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type SendPurchaseOrder200 = {
  ok: boolean;
  messageId?: string;
  sentTo: string;
};

export type SendPurchaseOrder503 = {
  error?: string;
  code?: string;
};

export type ListInventoryMintageReviewParams = {
/**
 * @minimum 1
 */
page?: number;
};

export type ListInventoryGridParams = {
search?: string;
/**
 * Comma-separated context flag UUIDs.
 */
flagIds?: string;
flagMode?: ListInventoryGridFlagMode;
status?: string;
metal?: string;
productType?: string;
supplierId?: string;
channel?: string;
stockType?: ListInventoryGridStockType;
/**
 * VAT treatment filter. Comma-separated list of treatments to include
 * — e.g. `MARGIN_SCHEME,STANDARD_VAT`. Empty / omitted = no filter.
 * The sentinel value `UNCLASSIFIED` matches rows where
 * `vat_treatment IS NULL` and can be combined with explicit
 * treatments (`UNCLASSIFIED,MARGIN_SCHEME` = "either unset OR
 * margin"). Unknown values are silently dropped server-side.
 */
vatTreatment?: string;
/**
 * When true, returns only items that are excluded from the TikTok Shop
 * export — Shopify-mirrored items (salesChannel = "Shopify") and
 * eBay soft-import placeholders (needsSkuReview = true). Mutually
 * exclusive with the normal needsSkuReview = false filter. Use the
 * inventory list "TikTok excluded" chip to surface these items so
 * operators can decide whether to relist them as native items.
 */
showTiktokExcluded?: boolean;
/**
 * Filter by valuation classification (advanced_inventory_valuation_enabled only).
 * Pass one of the method enum values (`spot_tracked`, `premium`, `hybrid`,
 * `excluded`, `custom`) to show only items with that classification.
 * The sentinel value `unclassified` matches items where `valuation_method IS NULL`.
 * Ignored when the feature flag is off.
 */
valuationMethod?: string;
/**
 * Maximum number of items to return per page. When omitted, all matching
 * items are returned (backward-compatible unlimited response). Provide an
 * explicit limit to enable offset-style pagination. Capped at 1000.
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
/**
 * Number of items to skip before returning results. Defaults to 0.
 * Only meaningful when `limit` is also provided.
 * @minimum 0
 */
offset?: number;
/**
 * When true, limit and offset paginate normalized product groups
 * (brand + product title) and items contains every lot belonging to
 * the returned groups. The total is the number of matching groups.
 */
grouped?: boolean;
/**
 * When true, includes lifetime realised profit (realizedProfitGbp /
 * realizedGrossProfitGbp) per item. This runs a CTE over sale_order_items
 * and is expensive on large catalogues — omit unless the caller needs the
 * profit column (e.g. when showAllColumns is on or sorting by profit).
 */
includeProfitData?: boolean;
/**
 * Server-side sort order. All modes use `id` as a stable secondary key
 * so rows never duplicate or disappear across pages. Defaults to `updated`
 * (most-recently-created first). `realizedProfit` requires
 * `includeProfitData=true`; when omitted it falls back to `updated` order.
 */
sortBy?: ListInventoryGridSortBy;
/**
 * When true, only items with a positive available quantity
 * (quantity − reserved − sold − damaged > 0) are returned.
 * Used by the inventory list's "Live (Sellable)" default view.
 */
availableOnly?: boolean;
/**
 * Filter by computed stock status. Uses the same thresholds as the
 * client-side `deriveInventoryStatus` helper (LOW_STOCK_THRESHOLD = 5).
 * LIVE = available > 0. LOW_STOCK = 0 < available < 5.
 * RESERVED = available ≤ 0 AND reserved > 0.
 * SOLD_OUT = available ≤ 0, reserved = 0, sold > 0.
 * OUT_OF_STOCK = available ≤ 0, reserved = 0, sold = 0.
 */
derivedStatus?: ListInventoryGridDerivedStatus;
/**
 * Availability bucket filter. OOS = available ≤ 0.
 * LOW = 0 < available < 5. HEALTHY = available ≥ 5.
 */
qtyBucket?: ListInventoryGridQtyBucket;
/**
 * When true, only items with quantity_coming_soon > 0 are returned.
 */
comingSoon?: boolean;
/**
 * When true, only items with a zero or missing landed unit cost are
 * returned (landed_unit_cost = 0 or NULL). For CONSIGNMENT items,
 * also applies when supplier_payout_price is zero or absent.
 */
missingCost?: boolean;
/**
 * Filter by product_kind column. `source` = raw lot awaiting breakdown,
 * `sellable` = regular sellable unit, `both` = hybrid (can be sold as-is
 * or broken down). Omit to include all kinds.
 */
productKind?: ListInventoryGridProductKind;
/**
 * Marketplace whose actual listing identity is checked.
 */
marketplace?: ListInventoryGridMarketplace;
/**
 * Match products with an actual marketplace listing identity or
 * products without one, or products with an explicitly broken
 * marketplace link. Sync configuration and failed attempts alone do
 * not count as listings or broken links.
 */
marketplaceStatus?: ListInventoryGridMarketplaceStatus;
};

export type ListInventoryGridFlagMode = typeof ListInventoryGridFlagMode[keyof typeof ListInventoryGridFlagMode];


export const ListInventoryGridFlagMode = {
  any: 'any',
  all: 'all',
  none: 'none',
  empty: 'empty',
} as const;

export type ListInventoryGridStockType = typeof ListInventoryGridStockType[keyof typeof ListInventoryGridStockType];


export const ListInventoryGridStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type ListInventoryGridSortBy = typeof ListInventoryGridSortBy[keyof typeof ListInventoryGridSortBy];


export const ListInventoryGridSortBy = {
  updated: 'updated',
  available: 'available',
  sold: 'sold',
  value: 'value',
  sku: 'sku',
  realizedProfit: 'realizedProfit',
} as const;

export type ListInventoryGridDerivedStatus = typeof ListInventoryGridDerivedStatus[keyof typeof ListInventoryGridDerivedStatus];


export const ListInventoryGridDerivedStatus = {
  LIVE: 'LIVE',
  LOW_STOCK: 'LOW_STOCK',
  RESERVED: 'RESERVED',
  SOLD_OUT: 'SOLD_OUT',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
} as const;

export type ListInventoryGridQtyBucket = typeof ListInventoryGridQtyBucket[keyof typeof ListInventoryGridQtyBucket];


export const ListInventoryGridQtyBucket = {
  OOS: 'OOS',
  LOW: 'LOW',
  HEALTHY: 'HEALTHY',
} as const;

export type ListInventoryGridProductKind = typeof ListInventoryGridProductKind[keyof typeof ListInventoryGridProductKind];


export const ListInventoryGridProductKind = {
  source: 'source',
  sellable: 'sellable',
  both: 'both',
} as const;

export type ListInventoryGridMarketplace = typeof ListInventoryGridMarketplace[keyof typeof ListInventoryGridMarketplace];


export const ListInventoryGridMarketplace = {
  shopify: 'shopify',
  tiktok_shop: 'tiktok_shop',
  woocommerce: 'woocommerce',
  ebay: 'ebay',
} as const;

export type ListInventoryGridMarketplaceStatus = typeof ListInventoryGridMarketplaceStatus[keyof typeof ListInventoryGridMarketplaceStatus];


export const ListInventoryGridMarketplaceStatus = {
  listed: 'listed',
  not_listed: 'not_listed',
  broken_link: 'broken_link',
} as const;

export type ListInventoryParams = {
search?: string;
/**
 * Comma-separated context flag UUIDs.
 */
flagIds?: string;
flagMode?: ListInventoryFlagMode;
status?: string;
metal?: string;
productType?: string;
supplierId?: string;
channel?: string;
stockType?: ListInventoryStockType;
/**
 * VAT treatment filter. Comma-separated list of treatments to include
 * — e.g. `MARGIN_SCHEME,STANDARD_VAT`. Empty / omitted = no filter.
 * The sentinel value `UNCLASSIFIED` matches rows where
 * `vat_treatment IS NULL` and can be combined with explicit
 * treatments (`UNCLASSIFIED,MARGIN_SCHEME` = "either unset OR
 * margin"). Unknown values are silently dropped server-side.
 */
vatTreatment?: string;
/**
 * When true, returns only items that are excluded from the TikTok Shop
 * export — Shopify-mirrored items (salesChannel = "Shopify") and
 * eBay soft-import placeholders (needsSkuReview = true). Mutually
 * exclusive with the normal needsSkuReview = false filter. Use the
 * inventory list "TikTok excluded" chip to surface these items so
 * operators can decide whether to relist them as native items.
 */
showTiktokExcluded?: boolean;
/**
 * Filter by valuation classification (advanced_inventory_valuation_enabled only).
 * Pass one of the method enum values (`spot_tracked`, `premium`, `hybrid`,
 * `excluded`, `custom`) to show only items with that classification.
 * The sentinel value `unclassified` matches items where `valuation_method IS NULL`.
 * Ignored when the feature flag is off.
 */
valuationMethod?: string;
/**
 * Maximum number of items to return per page. When omitted, all matching
 * items are returned (backward-compatible unlimited response). Provide an
 * explicit limit to enable offset-style pagination. Capped at 1000.
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
/**
 * Number of items to skip before returning results. Defaults to 0.
 * Only meaningful when `limit` is also provided.
 * @minimum 0
 */
offset?: number;
/**
 * When true, limit and offset paginate normalized product groups
 * (brand + product title) and items contains every lot belonging to
 * the returned groups. The total is the number of matching groups.
 */
grouped?: boolean;
/**
 * When true, includes lifetime realised profit (realizedProfitGbp /
 * realizedGrossProfitGbp) per item. This runs a CTE over sale_order_items
 * and is expensive on large catalogues — omit unless the caller needs the
 * profit column (e.g. when showAllColumns is on or sorting by profit).
 */
includeProfitData?: boolean;
/**
 * Server-side sort order. All modes use `id` as a stable secondary key
 * so rows never duplicate or disappear across pages. Defaults to `updated`
 * (most-recently-created first). `realizedProfit` requires
 * `includeProfitData=true`; when omitted it falls back to `updated` order.
 */
sortBy?: ListInventorySortBy;
/**
 * When true, only items with a positive available quantity
 * (quantity − reserved − sold − damaged > 0) are returned.
 * Used by the inventory list's "Live (Sellable)" default view.
 */
availableOnly?: boolean;
/**
 * Filter by computed stock status. Uses the same thresholds as the
 * client-side `deriveInventoryStatus` helper (LOW_STOCK_THRESHOLD = 5).
 * LIVE = available > 0. LOW_STOCK = 0 < available < 5.
 * RESERVED = available ≤ 0 AND reserved > 0.
 * SOLD_OUT = available ≤ 0, reserved = 0, sold > 0.
 * OUT_OF_STOCK = available ≤ 0, reserved = 0, sold = 0.
 */
derivedStatus?: ListInventoryDerivedStatus;
/**
 * Availability bucket filter. OOS = available ≤ 0.
 * LOW = 0 < available < 5. HEALTHY = available ≥ 5.
 */
qtyBucket?: ListInventoryQtyBucket;
/**
 * When true, only items with quantity_coming_soon > 0 are returned.
 */
comingSoon?: boolean;
/**
 * When true, only items with a zero or missing landed unit cost are
 * returned (landed_unit_cost = 0 or NULL). For CONSIGNMENT items,
 * also applies when supplier_payout_price is zero or absent.
 */
missingCost?: boolean;
/**
 * Filter by product_kind column. `source` = raw lot awaiting breakdown,
 * `sellable` = regular sellable unit, `both` = hybrid (can be sold as-is
 * or broken down). Omit to include all kinds.
 */
productKind?: ListInventoryProductKind;
/**
 * When true, disables the default 200-item page cap and returns the
 * full matching catalogue. Use only for callers that genuinely need
 * all items — CSV export, live-view, profit-sort. Omit for normal
 * paginated UI requests.
 */
unlimitedExport?: boolean;
/**
 * Marketplace whose actual listing identity is checked.
 */
marketplace?: ListInventoryMarketplace;
/**
 * Match products with an actual marketplace listing identity or
 * products without one, or products with an explicitly broken
 * marketplace link. Sync configuration and failed attempts alone do
 * not count as listings or broken links.
 */
marketplaceStatus?: ListInventoryMarketplaceStatus;
};

export type ListInventoryFlagMode = typeof ListInventoryFlagMode[keyof typeof ListInventoryFlagMode];


export const ListInventoryFlagMode = {
  any: 'any',
  all: 'all',
  none: 'none',
  empty: 'empty',
} as const;

export type ListInventoryStockType = typeof ListInventoryStockType[keyof typeof ListInventoryStockType];


export const ListInventoryStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type ListInventorySortBy = typeof ListInventorySortBy[keyof typeof ListInventorySortBy];


export const ListInventorySortBy = {
  updated: 'updated',
  available: 'available',
  sold: 'sold',
  value: 'value',
  sku: 'sku',
  realizedProfit: 'realizedProfit',
} as const;

export type ListInventoryDerivedStatus = typeof ListInventoryDerivedStatus[keyof typeof ListInventoryDerivedStatus];


export const ListInventoryDerivedStatus = {
  LIVE: 'LIVE',
  LOW_STOCK: 'LOW_STOCK',
  RESERVED: 'RESERVED',
  SOLD_OUT: 'SOLD_OUT',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
} as const;

export type ListInventoryQtyBucket = typeof ListInventoryQtyBucket[keyof typeof ListInventoryQtyBucket];


export const ListInventoryQtyBucket = {
  OOS: 'OOS',
  LOW: 'LOW',
  HEALTHY: 'HEALTHY',
} as const;

export type ListInventoryProductKind = typeof ListInventoryProductKind[keyof typeof ListInventoryProductKind];


export const ListInventoryProductKind = {
  source: 'source',
  sellable: 'sellable',
  both: 'both',
} as const;

export type ListInventoryMarketplace = typeof ListInventoryMarketplace[keyof typeof ListInventoryMarketplace];


export const ListInventoryMarketplace = {
  shopify: 'shopify',
  tiktok_shop: 'tiktok_shop',
  woocommerce: 'woocommerce',
  ebay: 'ebay',
} as const;

export type ListInventoryMarketplaceStatus = typeof ListInventoryMarketplaceStatus[keyof typeof ListInventoryMarketplaceStatus];


export const ListInventoryMarketplaceStatus = {
  listed: 'listed',
  not_listed: 'not_listed',
  broken_link: 'broken_link',
} as const;

export type ListInventory200 = {
  items: InventoryListItem[];
  /** Total number of items matching the current filters (before pagination). */
  total: number;
};

export type ListMobileInventoryParams = {
/**
 * Search supported product identities: SKU, title, brand, supplier,
 * supplier SKU/reference/barcode, product/barcode, serial number,
 * storage location, and retained product aliases.
 * @maxLength 200
 */
search?: string;
status?: string;
metal?: string;
productType?: string;
supplierId?: string;
channel?: string;
/**
 * Marketplace whose actual listing identity is checked.
 */
marketplace?: ListMobileInventoryMarketplace;
/**
 * Match actual marketplace listings, products without a listing, or
 * products with an explicitly broken marketplace link. Sync
 * configuration and failed attempts alone do not count.
 */
marketplaceStatus?: ListMobileInventoryMarketplaceStatus;
stockType?: ListMobileInventoryStockType;
derivedStatus?: ListMobileInventoryDerivedStatus;
availableOnly?: boolean;
sortBy?: ListMobileInventorySortBy;
/**
 * Legacy bounded offset page. Cursor requests always continue from the cursor instead.
 * @minimum 1
 * @maximum 1000
 */
page?: number;
/**
 * Opaque continuation cursor returned as nextCursor by the previous response.
 * @maxLength 1000
 */
cursor?: string;
/**
 * @minimum 1
 * @maximum 30
 */
pageSize?: number;
};

export type ListMobileInventoryMarketplace = typeof ListMobileInventoryMarketplace[keyof typeof ListMobileInventoryMarketplace];


export const ListMobileInventoryMarketplace = {
  shopify: 'shopify',
  tiktok_shop: 'tiktok_shop',
  woocommerce: 'woocommerce',
  ebay: 'ebay',
} as const;

export type ListMobileInventoryMarketplaceStatus = typeof ListMobileInventoryMarketplaceStatus[keyof typeof ListMobileInventoryMarketplaceStatus];


export const ListMobileInventoryMarketplaceStatus = {
  listed: 'listed',
  not_listed: 'not_listed',
  broken_link: 'broken_link',
} as const;

export type ListMobileInventoryStockType = typeof ListMobileInventoryStockType[keyof typeof ListMobileInventoryStockType];


export const ListMobileInventoryStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type ListMobileInventoryDerivedStatus = typeof ListMobileInventoryDerivedStatus[keyof typeof ListMobileInventoryDerivedStatus];


export const ListMobileInventoryDerivedStatus = {
  LIVE: 'LIVE',
  LOW_STOCK: 'LOW_STOCK',
  RESERVED: 'RESERVED',
  SOLD_OUT: 'SOLD_OUT',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
} as const;

export type ListMobileInventorySortBy = typeof ListMobileInventorySortBy[keyof typeof ListMobileInventorySortBy];


export const ListMobileInventorySortBy = {
  updated: 'updated',
  sku: 'sku',
  title: 'title',
  available: 'available',
} as const;

export type MatchInventoryByIdentityParams = {
/**
 * Product title to fuzzy-match. Required.
 * @minLength 2
 */
title: string;
/**
 * Optional brand hint — boosts similarity ranking when present.
 */
brand?: string;
};

export type CompleteInventoryProductImporterCanvaConnectParams = {
/**
 * @maxLength 1024
 */
state?: string;
/**
 * @maxLength 2048
 */
code?: string;
/**
 * @maxLength 128
 */
error?: string;
};

export type EnqueueInventorySeoReadinessBody = {
  /** @minimum 1 */
  expectedProductInformationVersion: number;
};

export type EnqueueInventorySeoReadiness200 = {
  analysis: InventorySeoReadiness;
  cached: boolean;
};

export type EnqueueInventorySeoReadiness202Status = typeof EnqueueInventorySeoReadiness202Status[keyof typeof EnqueueInventorySeoReadiness202Status];


export const EnqueueInventorySeoReadiness202Status = {
  queued: 'queued',
} as const;

export type EnqueueInventorySeoReadiness202 = {
  jobId: string;
  status: EnqueueInventorySeoReadiness202Status;
  /** @minimum 1 */
  productInformationVersion: number;
  cached: false;
};

export type GetInventorySeoReadinessJob200Status = typeof GetInventorySeoReadinessJob200Status[keyof typeof GetInventorySeoReadinessJob200Status];


export const GetInventorySeoReadinessJob200Status = {
  queued: 'queued',
  claimed: 'claimed',
  processing: 'processing',
  retry_scheduled: 'retry_scheduled',
  succeeded: 'succeeded',
  stale: 'stale',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type GetInventorySeoReadinessJob200 = {
  jobId: string;
  status: GetInventorySeoReadinessJob200Status;
  /** @minimum 1 */
  productInformationVersion: number | null;
  analysis: InventorySeoReadiness | null;
  reason: string | null;
  errorMessage: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type ListInventoryLotsParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
availability?: ListInventoryLotsAvailability;
ownership?: ListInventoryLotsOwnership;
supplier?: string;
purchaseOrder?: string;
location?: string;
receivedFrom?: string;
receivedTo?: string;
/**
 * @minimum 0
 */
minCost?: number;
/**
 * @minimum 0
 */
maxCost?: number;
};

export type ListInventoryLotsAvailability = typeof ListInventoryLotsAvailability[keyof typeof ListInventoryLotsAvailability];


export const ListInventoryLotsAvailability = {
  available: 'available',
  depleted: 'depleted',
  all: 'all',
} as const;

export type ListInventoryLotsOwnership = typeof ListInventoryLotsOwnership[keyof typeof ListInventoryLotsOwnership];


export const ListInventoryLotsOwnership = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type ListInventoryLots200 = {
  lots: InventoryLot[];
  total: number;
  financeVisible: boolean;
};

export type ListInventoryLotPurchasesParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
receivedFrom?: string;
receivedTo?: string;
};

export type ListInventoryLotPurchases200 = {
  items: InventoryLot[];
  total: number;
  financeVisible: boolean;
};

export type ListInventorySalesHistoryParams = {
dateFrom?: string;
dateTo?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
};

export type ListInventorySalesHistory200ItemsItem = { [key: string]: unknown };

export type ListInventorySalesHistory200 = {
  items: ListInventorySalesHistory200ItemsItem[];
  financeVisible: boolean;
};

export type GetInventoryChannelSyncEventsParams = {
/**
 * Filter to a specific channel slug.
 */
channel?: GetInventoryChannelSyncEventsChannel;
/**
 * @maximum 200
 */
limit?: number;
offset?: number;
};

export type GetInventoryChannelSyncEventsChannel = typeof GetInventoryChannelSyncEventsChannel[keyof typeof GetInventoryChannelSyncEventsChannel];


export const GetInventoryChannelSyncEventsChannel = {
  ebay: 'ebay',
  shopify: 'shopify',
  woocommerce: 'woocommerce',
  tiktok_shop: 'tiktok_shop',
} as const;

export type GetInventoryChannelSyncEvents200 = {
  events: ChannelSyncEvent[];
  /** Total matching rows (ignores limit/offset). */
  total: number;
};

export type GetRepairCentreIssues200Summary = {
  critical?: number;
  warning?: number;
  info?: number;
  total?: number;
};

export type GetRepairCentreIssues200 = {
  generatedAt?: string;
  scannedCount?: number;
  summary?: GetRepairCentreIssues200Summary;
  issues?: RepairIssue[];
};

export type GetRepairCentreIssueCount200 = {
  total?: number;
  critical?: number;
};

export type ApplyRepairAction200 = {
  ok?: boolean;
  sku?: string;
  productTitle?: string;
  beforeValues?: InventoryCounters;
  afterValues?: InventoryCounters;
};

export type GetRepairCentreLogsParams = {
limit?: number;
};

export type ListInventoryTransformationsParams = {
sourceInventoryItemId?: string;
outputInventoryItemId?: string;
/**
 * ISO-8601. Inclusive lower bound on createdAt.
 */
since?: string;
/**
 * ISO-8601. Exclusive upper bound on createdAt.
 */
until?: string;
limit?: number;
};

export type RetryCustomerDirectoryMetricsBody = {
  /** Also retry a bounded batch of missing or failed tenant summary customers, without restarting active work. */
  retrySummary?: boolean;
  /** @maxItems 100 */
  customerIds: string[];
};

export type RetryCommerceCustomerDirectoryMetricsBody = {
  /** @maxItems 100 */
  customerIds: string[];
};

export type SearchCustomerPickerParams = {
/**
 * Case-insensitive customer name or contact detail fragment.
 * @minLength 2
 * @maxLength 100
 */
search: string;
/**
 * Maximum number of matching customers to return.
 * @minimum 1
 * @maximum 50
 */
limit?: number;
};

export type SearchCustomerPicker200 = {
  /** @maxItems 50 */
  items: CustomerPickerOption[];
};

export type ListCustomersParams = {
search?: string;
/**
 * Filter to customers whose `customerType` matches exactly. Choose from the `availableTypes` returned in the response.
 */
type?: string;
/**
 * Filter by whether a customer has any sale orders. `has` returns only
 * customers with at least one order; `none` returns only customers with
 * no orders. Omit for no filter. Applied to both the page and the total.
 */
hasOrders?: ListCustomersHasOrders;
/**
 * Filter by the persisted customer risk bucket.
 */
risk?: CustomerRiskLevel;
/**
 * Only customers created on or after this date/instant (inclusive). Accepts an ISO date (`YYYY-MM-DD`) or full ISO date-time.
 */
createdAfter?: string;
/**
 * Only customers created on or before this date/instant (inclusive). Accepts an ISO date (`YYYY-MM-DD`) or full ISO date-time. A bare date is treated as end-of-day so the whole day is included.
 */
createdBefore?: string;
/**
 * Legacy page size. New directory clients should use pageSize. Pass `limit=0` only for the existing sales/invoice customer picker compatibility path. Non-zero values remain accepted for legacy clients and are capped by the server.
 * @minimum 0
 * @maximum 200
 */
limit?: number;
/**
 * Directory page size. Only 10, 20, 50, or 100 are supported.
 */
pageSize?: ListCustomersPageSize;
/**
 * Zero-based offset. Offsets beyond 10,000 are rejected.
 * @minimum 0
 */
offset?: number;
/**
 * Sort order for the page. `created_desc` (default) / `created_asc`
 * order by customer creation date. The remaining keys order by the
 * aggregated stats: `spend_desc` (biggest spenders), `orders_desc`
 * (most orders), `items_desc` (most items purchased),
 * `last_order_desc` (most recent order) and `last_order_asc`
 * (idle customers — least recently ordered first).
 */
sort?: ListCustomersSort;
};

export type ListCustomersHasOrders = typeof ListCustomersHasOrders[keyof typeof ListCustomersHasOrders];


export const ListCustomersHasOrders = {
  has: 'has',
  none: 'none',
} as const;

export type ListCustomersPageSize = typeof ListCustomersPageSize[keyof typeof ListCustomersPageSize];


export const ListCustomersPageSize = {
  NUMBER_10: 10,
  NUMBER_20: 20,
  NUMBER_50: 50,
  NUMBER_100: 100,
} as const;

export type ListCustomersSort = typeof ListCustomersSort[keyof typeof ListCustomersSort];


export const ListCustomersSort = {
  created_desc: 'created_desc',
  created_asc: 'created_asc',
  spend_desc: 'spend_desc',
  orders_desc: 'orders_desc',
  items_desc: 'items_desc',
  last_order_desc: 'last_order_desc',
  last_order_asc: 'last_order_asc',
} as const;

export type ListCustomers200FilterCountsByTypeItem = {
  type: string;
  count: number;
};

/**
 * Tenant-wide match counts per filter option, independent of
 * the currently-applied filters, so the UI can show the shape
 * of the customer base at a glance before drilling in.
 * `byType` lists each non-empty `customerType` with its count;
 * `untyped` counts customers with no type set; `withOrders` /
 * `withoutOrders` count customers that do / don't have any sale
 * orders.
 */
export type ListCustomers200FilterCounts = {
  byType: ListCustomers200FilterCountsByTypeItem[];
  untyped: number;
  withOrders: number;
  withoutOrders: number;
};

/**
 * Availability of tenant-wide prepared customer totals.
 */
export type ListCustomers200SummaryState = typeof ListCustomers200SummaryState[keyof typeof ListCustomers200SummaryState];


export const ListCustomers200SummaryState = {
  ready: 'ready',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export type ListCustomers200 = {
  items: CustomerWithStats[];
  /** Total customers matching the filters before pagination. */
  total: number;
  /** Distinct non-empty `customerType` values across the tenant (unaffected by the current filters), so the UI can populate the customer-type filter dropdown. */
  availableTypes?: string[];
  /**
     * Tenant-wide match counts per filter option, independent of
     * the currently-applied filters, so the UI can show the shape
     * of the customer base at a glance before drilling in.
     * `byType` lists each non-empty `customerType` with its count;
     * `untyped` counts customers with no type set; `withOrders` /
     * `withoutOrders` count customers that do / don't have any sale
     * orders.
     */
  filterCounts?: ListCustomers200FilterCounts;
  summary?: CustomerDirectorySummary | null;
  /** Availability of tenant-wide prepared customer totals. */
  summaryState?: ListCustomers200SummaryState;
  /** Number of visible customers whose prepared summary has never completed. */
  summaryUnavailableCustomers?: number;
  visibility?: CustomerSpendVisibility;
};

export type ListCustomerOrdersParams = {
/**
 * @maxLength 120
 */
search?: string;
/**
 * Comma-separated marketplace/channel filter.
 */
channel?: string;
/**
 * Comma-separated order status filter.
 */
status?: string;
from?: string;
to?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
cursor?: string;
};

export type ExportCustomerOrdersBody = {
  /** @maxLength 120 */
  search?: string;
  /** Comma-separated canonical channel slugs. */
  channel?: string;
  /** Comma-separated canonical order statuses. */
  status?: string;
  from?: string;
  to?: string;
};

export type ListCustomerMessagesParams = {
/**
 * @minimum 20
 * @maximum 50
 */
limit?: number;
cursor?: string;
};

export type GetCustomerWhatsappTemplate502 = {
  error: string;
};

export type ListCustomerAddresses200 = {
  addresses: CustomerAddress[];
};

export type ListCustomerNotesParams = {
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListOrderInternalNotesParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type DeleteOrderInternalNoteParams = {
/**
 * @minimum 1
 */
expectedVersion: number;
};

export type PinOrderInternalNoteBody = {
  pinned: boolean;
  /** @minimum 1 */
  expectedVersion: number;
};

export type GetCustomerActivityParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
cursor?: string;
/**
 * Comma-separated activity categories to include.
 */
category?: string;
};

export type ListCustomerPlatformHandles200 = {
  handles: CustomerPlatformHandle[];
};

export type ListFlagsParams = {
context?: FlagContext;
};

export type ListFlagAssignmentsParams = {
entityType: FlagEntityType;
entityId: string;
context?: FlagContext;
};

export type UnassignFlagParams = {
context?: FlagContext;
};

export type GetSalesProfitBlockersParams = {
reason?: ProfitBlockerReason;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListSalesParams = {
search?: string;
/**
 * Comma-separated context flag UUIDs.
 */
flagIds?: string;
flagMode?: ListSalesFlagMode;
channel?: string;
customerId?: string;
status?: string;
/**
 * Inclusive lower bound for the order sale date.
 */
dateFrom?: string;
/**
 * Inclusive upper bound for the order sale date.
 */
dateTo?: string;
/**
 * Filter to sale orders containing a reportable line with unavailable final cost.
 */
costStatus?: ListSalesCostStatus;
/**
 * Limit costStatus matching lines to this ownership type.
 */
stockType?: ListSalesStockType;
/**
 * Limit costStatus matching consignment lines to this supplier.
 */
supplierId?: string;
/**
 * Inclusive ISO sale-time lower bound for the unavailable-cost review lens.
 */
costFrom?: string;
/**
 * Inclusive ISO sale-time upper bound for the unavailable-cost review lens.
 */
costTo?: string;
/**
 * Filter orders linked to a tenant-scoped packing job with this
 * authoritative fulfilment state.
 */
fulfilmentStatus?: ListSalesFulfilmentStatus;
/**
 * Packing-job operator assignment. Use `unassigned` for orders
 * whose tenant-scoped packing job has no assigned operator.
 */
assignedUserId?: string;
/**
 * Backwards-compatible alias for assignedUserId.
 */
assignedTo?: string;
/**
 * Enable the high-value order filter. When enabled,
 * highValueThreshold is required; supplying the threshold alone also
 * enables the filter. GBP orders compare their item revenue directly.
 * USD, EUR, CAD, and AUD orders are converted using the latest retained daily
 * canonical Twelve Data spot quote pair whose actual FX observation
 * time is at or before the order sale timestamp. One observation per
 * currency per UTC FX-observation date is retained from the bounded
 * two-year canonical history. The pair must have the same provider,
 * metal, and underlying metal timestamp; converted order revenue is
 * rounded to two decimal places before comparison. Orders without a
 * matched historical rate are unavailable to this filter and are not
 * treated as zero.
 */
highValue?: boolean;
/**
 * Minimum GBP item revenue after the documented sale-time conversion and penny rounding.
 * @minimum 0
 */
highValueThreshold?: number;
/**
 * Enable the high-profit order filter. When enabled, highProfitThreshold is required; supplying the threshold alone also enables the filter.
 */
highProfit?: boolean;
/**
 * Minimum true profit in GBP for the high-profit order filter.
 * @minimum 0
 */
highProfitThreshold?: number;
/**
 * Filter to orders whose `paymentStatus` matches exactly, e.g.
 * `Awaiting payment` to surface on-hold (unpaid) orders only.
 */
paymentStatus?: string;
/**
 * Filter by the presence of an active invoice associated with the
 * sale using its structured `[SALE:<order-id>]` marker. Void invoices
 * do not count as invoiced.
 */
invoiceStatus?: ListSalesInvoiceStatus;
/**
 * Derived payment lens applied server-side so pagination totals remain accurate.
 */
paymentLens?: ListSalesPaymentLens;
/**
 * True-profit lens applied server-side (after costs, fees, adjustments, and VAT-independent profit rules).
 */
profit?: ListSalesProfit;
/**
 * When true, narrow to TikTok Shop orders that have a recorded refund
 * (tiktok_shop_orders.refund_status is set and not "none"). Applied
 * server-side so it narrows both the rows and the paginated `total`.
 */
hasTiktokRefund?: boolean;
/**
 * When true, narrow to TikTok Shop orders that have an imported
 * tiktok_shop_orders row but no fulfilment recorded yet (no shipped_at
 * and no tracking_number). Applied server-side so it narrows both the
 * rows and the paginated `total`.
 */
tiktokUnshipped?: boolean;
/**
 * When true, narrow to orders that contain at least one unresolved stub
 * line — a line whose SKU was auto-generated during a TikTok import
 * (TT-SKU-*, TT-PROD-*, TT-ORD-*) and whose unit cost is still £0.
 * Applied server-side so it narrows both the rows and the paginated `total`.
 */
hasStubLines?: boolean;
/**
 * Include the on-hold and unresolved-stub headline counts. Sales list
 * screens may set this false for the usable-row request, then fetch the
 * counts after rows are visible. Defaults false so optional headline
 * work never delays a normal list request.
 */
includeHeadlineCounts?: boolean;
/**
 * Bounded page size. Every sales list response is paginated; callers
 * that omit this value receive the bounded default.
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListSalesFlagMode = typeof ListSalesFlagMode[keyof typeof ListSalesFlagMode];


export const ListSalesFlagMode = {
  any: 'any',
  all: 'all',
  none: 'none',
  empty: 'empty',
} as const;

export type ListSalesCostStatus = typeof ListSalesCostStatus[keyof typeof ListSalesCostStatus];


export const ListSalesCostStatus = {
  unavailable: 'unavailable',
} as const;

export type ListSalesStockType = typeof ListSalesStockType[keyof typeof ListSalesStockType];


export const ListSalesStockType = {
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type ListSalesFulfilmentStatus = typeof ListSalesFulfilmentStatus[keyof typeof ListSalesFulfilmentStatus];


export const ListSalesFulfilmentStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  evidence_captured: 'evidence_captured',
  packed: 'packed',
  confirmation_sent: 'confirmation_sent',
  completed: 'completed',
  issue: 'issue',
  cancelled: 'cancelled',
} as const;

export type ListSalesInvoiceStatus = typeof ListSalesInvoiceStatus[keyof typeof ListSalesInvoiceStatus];


export const ListSalesInvoiceStatus = {
  invoiced: 'invoiced',
  uninvoiced: 'uninvoiced',
} as const;

export type ListSalesPaymentLens = typeof ListSalesPaymentLens[keyof typeof ListSalesPaymentLens];


export const ListSalesPaymentLens = {
  Outstanding: 'Outstanding',
  Due_Today: 'Due Today',
  Overdue: 'Overdue',
  Manual_orders: 'Manual orders',
  Marketplace_orders: 'Marketplace orders',
} as const;

export type ListSalesProfit = typeof ListSalesProfit[keyof typeof ListSalesProfit];


export const ListSalesProfit = {
  profit: 'profit',
  loss: 'loss',
  zero: 'zero',
} as const;

export type ListSales200 = {
  items: SaleOrder[];
  /** Total rows that match the filters before pagination is applied. */
  total: number;
  /** Page size that was applied (`0` means "no limit"). */
  limit: number;
  offset: number;
  /**
     * Count of orders currently on hold (paymentStatus =
     * "Awaiting payment") within the active non-payment filters
     * (channel/search/customer/status), independent of the
     * paymentStatus filter and pagination. Drives the "on hold"
     * headline badge.
     */
  onHoldCount?: number;
  /**
     * Count of orders that contain at least one unresolved stub
     * line (SKU matching TT-SKU-*\/TT-PROD-*\/TT-ORD-* AND
     * unit_cost = 0) within the active non-stub filters. Drives
     * the stub-line alert banner on the sales list.
     */
  stubLineCount?: number;
};

export type GetSalesOnHoldCount200 = {
  /** @minimum 0 */
  onHoldCount: number;
};

export type ListAdjustmentsParams = {
saleOrderId?: string;
customerId?: string;
inventoryItemId?: string;
limit?: number;
};

export type ListStationeryParams = {
/**
 * Only return items where currentQuantity is below 25% of targetQuantity.
 */
lowOnly?: boolean;
};

export type GetCustomerInsightsParams = {
/**
 * Filter by customer acquisition source (e.g. ebay, whatsapp, shopify).
 */
source?: string;
};

export type ListExpensesParams = {
category?: string;
};

export type GetCustomerPurchasingInsightsParams = {
from?: string;
to?: string;
/**
 * @maxLength 100
 */
search?: string;
mint?: string;
metal?: string;
channel?: string;
window?: GetCustomerPurchasingInsightsWindow;
sort?: GetCustomerPurchasingInsightsSort;
direction?: GetCustomerPurchasingInsightsDirection;
/**
 * @minimum 0
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type GetCustomerPurchasingInsightsWindow = typeof GetCustomerPurchasingInsightsWindow[keyof typeof GetCustomerPurchasingInsightsWindow];


export const GetCustomerPurchasingInsightsWindow = {
  overnight: 'overnight',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
} as const;

export type GetCustomerPurchasingInsightsSort = typeof GetCustomerPurchasingInsightsSort[keyof typeof GetCustomerPurchasingInsightsSort];


export const GetCustomerPurchasingInsightsSort = {
  mostRecent: 'mostRecent',
  orders: 'orders',
  units: 'units',
  customer: 'customer',
} as const;

export type GetCustomerPurchasingInsightsDirection = typeof GetCustomerPurchasingInsightsDirection[keyof typeof GetCustomerPurchasingInsightsDirection];


export const GetCustomerPurchasingInsightsDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ExportCustomerPurchasingInsightsParams = {
from?: string;
to?: string;
/**
 * @maxLength 100
 */
search?: string;
mint?: string;
metal?: string;
channel?: string;
window?: ExportCustomerPurchasingInsightsWindow;
};

export type ExportCustomerPurchasingInsightsWindow = typeof ExportCustomerPurchasingInsightsWindow[keyof typeof ExportCustomerPurchasingInsightsWindow];


export const ExportCustomerPurchasingInsightsWindow = {
  overnight: 'overnight',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
} as const;

export type GetSalesReportParams = {
from?: string;
to?: string;
};

export type GetProfitLossReportParams = {
/**
 * Bucket size for the chart and table rows. Defaults to "day".
 */
granularity?: GetProfitLossReportGranularity;
/**
 * ISO date or datetime (inclusive). Defaults to 30 days ago for day, 12 weeks for week, 12 months for month.
 */
from?: string;
/**
 * ISO date or datetime (inclusive). Defaults to now.
 */
to?: string;
/**
 * When set, restricts to consignment lines whose snapshot supplier id matches.
 */
supplierId?: string;
/**
 * When set to OWNED or CONSIGNMENT, restricts to that stock type. Defaults to ALL.
 */
stockType?: GetProfitLossReportStockType;
/**
 * Curated channel filter; case- and spelling-tolerant server-side. Omit for all channels.
 */
channel?: GetProfitLossReportChannel;
};

export type GetProfitLossReportGranularity = typeof GetProfitLossReportGranularity[keyof typeof GetProfitLossReportGranularity];


export const GetProfitLossReportGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type GetProfitLossReportStockType = typeof GetProfitLossReportStockType[keyof typeof GetProfitLossReportStockType];


export const GetProfitLossReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetProfitLossReportChannel = typeof GetProfitLossReportChannel[keyof typeof GetProfitLossReportChannel];


export const GetProfitLossReportChannel = {
  eBay: 'eBay',
  WhatsApp: 'WhatsApp',
  Shopify: 'Shopify',
  Whatnot: 'Whatnot',
  Direct: 'Direct',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
} as const;

export type GetMobileProfitLossParams = {
from?: string;
to?: string;
compare?: boolean;
comparison?: GetMobileProfitLossComparison;
previousFrom?: string;
previousTo?: string;
granularity?: GetMobileProfitLossGranularity;
ownership?: GetMobileProfitLossOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
/**
 * @maxLength 100
 */
search?: string;
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
};

export type GetMobileProfitLossComparison = typeof GetMobileProfitLossComparison[keyof typeof GetMobileProfitLossComparison];


export const GetMobileProfitLossComparison = {
  none: 'none',
  previous_period: 'previous_period',
  year_over_year: 'year_over_year',
} as const;

export type GetMobileProfitLossGranularity = typeof GetMobileProfitLossGranularity[keyof typeof GetMobileProfitLossGranularity];


export const GetMobileProfitLossGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type GetMobileProfitLossOwnership = typeof GetMobileProfitLossOwnership[keyof typeof GetMobileProfitLossOwnership];


export const GetMobileProfitLossOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossSummaryParams = {
from?: string;
to?: string;
compare?: boolean;
comparison?: GetMobileProfitLossSummaryComparison;
previousFrom?: string;
previousTo?: string;
ownership?: GetMobileProfitLossSummaryOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossSummaryComparison = typeof GetMobileProfitLossSummaryComparison[keyof typeof GetMobileProfitLossSummaryComparison];


export const GetMobileProfitLossSummaryComparison = {
  none: 'none',
  previous_period: 'previous_period',
  year_over_year: 'year_over_year',
} as const;

export type GetMobileProfitLossSummaryOwnership = typeof GetMobileProfitLossSummaryOwnership[keyof typeof GetMobileProfitLossSummaryOwnership];


export const GetMobileProfitLossSummaryOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossTrendParams = {
from?: string;
to?: string;
granularity?: GetMobileProfitLossTrendGranularity;
ownership?: GetMobileProfitLossTrendOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossTrendGranularity = typeof GetMobileProfitLossTrendGranularity[keyof typeof GetMobileProfitLossTrendGranularity];


export const GetMobileProfitLossTrendGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type GetMobileProfitLossTrendOwnership = typeof GetMobileProfitLossTrendOwnership[keyof typeof GetMobileProfitLossTrendOwnership];


export const GetMobileProfitLossTrendOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossChartParams = {
from?: string;
to?: string;
granularity?: GetMobileProfitLossChartGranularity;
ownership?: GetMobileProfitLossChartOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossChartGranularity = typeof GetMobileProfitLossChartGranularity[keyof typeof GetMobileProfitLossChartGranularity];


export const GetMobileProfitLossChartGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type GetMobileProfitLossChartOwnership = typeof GetMobileProfitLossChartOwnership[keyof typeof GetMobileProfitLossChartOwnership];


export const GetMobileProfitLossChartOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossChannelsParams = {
from?: string;
to?: string;
ownership?: GetMobileProfitLossChannelsOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossChannelsOwnership = typeof GetMobileProfitLossChannelsOwnership[keyof typeof GetMobileProfitLossChannelsOwnership];


export const GetMobileProfitLossChannelsOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossProductsParams = {
from?: string;
to?: string;
/**
 * @maxLength 100
 */
search?: string;
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
ownership?: GetMobileProfitLossProductsOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossProductsOwnership = typeof GetMobileProfitLossProductsOwnership[keyof typeof GetMobileProfitLossProductsOwnership];


export const GetMobileProfitLossProductsOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossCashParams = {
from?: string;
to?: string;
ownership?: GetMobileProfitLossCashOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossCashOwnership = typeof GetMobileProfitLossCashOwnership[keyof typeof GetMobileProfitLossCashOwnership];


export const GetMobileProfitLossCashOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetMobileProfitLossExceptionsParams = {
from?: string;
to?: string;
ownership?: GetMobileProfitLossExceptionsOwnership;
/**
 * Comma-separated VAT treatments
 * @maxLength 200
 */
vatTreatment?: string;
/**
 * @maxLength 80
 */
channel?: string;
};

export type GetMobileProfitLossExceptionsOwnership = typeof GetMobileProfitLossExceptionsOwnership[keyof typeof GetMobileProfitLossExceptionsOwnership];


export const GetMobileProfitLossExceptionsOwnership = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetSpendVsProfitReportParams = {
/**
 * Bucket size for the chart and table rows. Defaults to "day".
 */
granularity?: GetSpendVsProfitReportGranularity;
/**
 * ISO date (YYYY-MM-DD, treated as London midnight) or full ISO datetime. Half-open with `to`.
 */
from?: string;
/**
 * ISO date (YYYY-MM-DD, treated as the end of that day in London) or full ISO datetime.
 */
to?: string;
/**
 * When set, restricts profit lines (consignment supplier match), purchase spend
 * (PO supplier match) and consignment payouts (payout supplier match). Expenses
 * are excluded entirely when this filter is active because they have no supplier link.
 */
supplierId?: string;
/**
 * When set to OWNED or CONSIGNMENT, restricts the profit aggregation. Spend ignores this filter (spend isn't stock-type scoped).
 */
stockType?: GetSpendVsProfitReportStockType;
/**
 * Default false. When true, also includes unpaid POs (by purchase date) and
 * consignment owed lines (by sale date) in the spend totals. Useful for an
 * "accrual style" view of obligations that haven't yet hit the bank account.
 */
includeLiabilities?: boolean;
};

export type GetSpendVsProfitReportGranularity = typeof GetSpendVsProfitReportGranularity[keyof typeof GetSpendVsProfitReportGranularity];


export const GetSpendVsProfitReportGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type GetSpendVsProfitReportStockType = typeof GetSpendVsProfitReportStockType[keyof typeof GetSpendVsProfitReportStockType];


export const GetSpendVsProfitReportStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetSpendVsProfitCardsParams = {
supplierId?: string;
stockType?: GetSpendVsProfitCardsStockType;
/**
 * Include unpaid purchase orders and outstanding consignment owed.
 */
includeLiabilities?: boolean;
};

export type GetSpendVsProfitCardsStockType = typeof GetSpendVsProfitCardsStockType[keyof typeof GetSpendVsProfitCardsStockType];


export const GetSpendVsProfitCardsStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type DeleteUser200 = {
  ok: boolean;
  id: string;
  email?: string | null;
  clerkDeleted?: boolean;
  clerkSessionsRevoked?: number;
};

export type ResetUserPassword200 = {
  ok: boolean;
  id: string;
  email?: string | null;
  passwordRemoved?: boolean;
  sessionsRevoked?: number;
  sessionsFailed?: number;
  passwordError?: string | null;
};

export type SetUserRole200 = {
  id: string;
  role: string;
};

export type SetUserSectionOverrides200 = {
  id: string;
  sectionAccessOverride: SectionAccessMap | null;
};

export type SetUserPermissionsOverride200 = {
  id: string;
  permissionsOverride: string[] | null;
};

export type ListStockAuditParams = {
limit?: number;
search?: string;
};

export type ListActivityLogParams = {
/**
 * Free-text match on SKU, product title, entity label, user email, action.
 */
search?: string;
entityType?: string;
action?: string;
marketplace?: string;
userId?: string;
limit?: number;
};

export type ListActivityLog200FiltersUsersItem = {
  id: string;
  email: string;
};

export type ListActivityLog200Filters = {
  entityTypes: string[];
  actions: string[];
  marketplaces: string[];
  users: ListActivityLog200FiltersUsersItem[];
};

export type ListActivityLog200 = {
  entries: ActivityLogEntry[];
  filters: ListActivityLog200Filters;
};

export type ListPreOrderBatchActivityParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * Return rows created before this ISO-8601 timestamp.
 */
before?: string;
/**
 * Opaque cursor returned as nextCursor for the next bounded page.
 */
cursor?: string;
/**
 * @maxLength 120
 */
search?: string;
actorUserId?: string;
/**
 * @maxLength 120
 */
eventType?: string;
from?: string;
to?: string;
};

export type ExportPreOrderBatchActivityParams = {
/**
 * @maxLength 120
 */
search?: string;
actorUserId?: string;
/**
 * @maxLength 120
 */
eventType?: string;
from?: string;
to?: string;
};

export type ListAuditLogsParams = {
/**
 * Free-text match on user email, note, fieldChanged, entityId.
 */
search?: string;
entityType?: string;
actionType?: string;
changeSource?: string;
userId?: string;
fieldChanged?: string;
/**
 * ISO timestamp cursor — return rows strictly older than this.
 */
before?: string;
limit?: number;
};

export type GetSalesPerformanceDailyParams = {
/**
 * ISO date (YYYY-MM-DD, London-local) or full ISO datetime. Defaults to 30 days ago.
 */
from?: string;
/**
 * ISO date or datetime. Defaults to now.
 */
to?: string;
/**
 * Curated channel filter; case- and spelling-tolerant server-side. Omit for all channels.
 */
channel?: GetSalesPerformanceDailyChannel;
/**
 * Defaults to ALL.
 */
stockType?: GetSalesPerformanceDailyStockType;
/**
 * Restrict to a single customer.
 */
customerId?: string;
/**
 * Which date a refund hits. `refunded_at` (default) buckets refunds
 * by the day they were processed (matches Shopify/eBay/Stripe style
 * reporting). `sale_date` rolls refunds back to the day of the
 * original sale (each day's totals stay reconciled to its own sales
 * but historical days mutate as new refunds land).
 */
refundBasis?: GetSalesPerformanceDailyRefundBasis;
};

export type GetSalesPerformanceDailyChannel = typeof GetSalesPerformanceDailyChannel[keyof typeof GetSalesPerformanceDailyChannel];


export const GetSalesPerformanceDailyChannel = {
  eBay: 'eBay',
  WhatsApp: 'WhatsApp',
  Shopify: 'Shopify',
  Whatnot: 'Whatnot',
  Direct: 'Direct',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
} as const;

export type GetSalesPerformanceDailyStockType = typeof GetSalesPerformanceDailyStockType[keyof typeof GetSalesPerformanceDailyStockType];


export const GetSalesPerformanceDailyStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetSalesPerformanceDailyRefundBasis = typeof GetSalesPerformanceDailyRefundBasis[keyof typeof GetSalesPerformanceDailyRefundBasis];


export const GetSalesPerformanceDailyRefundBasis = {
  refunded_at: 'refunded_at',
  sale_date: 'sale_date',
} as const;

export type GetSalesPerformanceByChannelParams = {
/**
 * ISO date (YYYY-MM-DD, London-local) or full ISO datetime. Defaults to 30 days ago.
 */
from?: string;
/**
 * ISO date or datetime. Defaults to now.
 */
to?: string;
/**
 * Optional single-channel filter. Omit to see all channels.
 */
channel?: GetSalesPerformanceByChannelChannel;
/**
 * Defaults to ALL.
 */
stockType?: GetSalesPerformanceByChannelStockType;
customerId?: string;
refundBasis?: GetSalesPerformanceByChannelRefundBasis;
};

export type GetSalesPerformanceByChannelChannel = typeof GetSalesPerformanceByChannelChannel[keyof typeof GetSalesPerformanceByChannelChannel];


export const GetSalesPerformanceByChannelChannel = {
  eBay: 'eBay',
  WhatsApp: 'WhatsApp',
  Shopify: 'Shopify',
  Whatnot: 'Whatnot',
  Direct: 'Direct',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
} as const;

export type GetSalesPerformanceByChannelStockType = typeof GetSalesPerformanceByChannelStockType[keyof typeof GetSalesPerformanceByChannelStockType];


export const GetSalesPerformanceByChannelStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetSalesPerformanceByChannelRefundBasis = typeof GetSalesPerformanceByChannelRefundBasis[keyof typeof GetSalesPerformanceByChannelRefundBasis];


export const GetSalesPerformanceByChannelRefundBasis = {
  refunded_at: 'refunded_at',
  sale_date: 'sale_date',
} as const;

export type GetSalesPerformanceSessionsParams = {
/**
 * ISO date (YYYY-MM-DD, London-local) or full ISO datetime. Defaults to 30 days ago.
 */
from?: string;
to?: string;
/**
 * Auto-detection inactivity gap. Defaults to 120 (2h).
 * @minimum 15
 * @maximum 1440
 */
minGapMinutes?: number;
channel?: GetSalesPerformanceSessionsChannel;
stockType?: GetSalesPerformanceSessionsStockType;
customerId?: string;
refundBasis?: GetSalesPerformanceSessionsRefundBasis;
};

export type GetSalesPerformanceSessionsChannel = typeof GetSalesPerformanceSessionsChannel[keyof typeof GetSalesPerformanceSessionsChannel];


export const GetSalesPerformanceSessionsChannel = {
  eBay: 'eBay',
  WhatsApp: 'WhatsApp',
  Shopify: 'Shopify',
  Whatnot: 'Whatnot',
  Direct: 'Direct',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
} as const;

export type GetSalesPerformanceSessionsStockType = typeof GetSalesPerformanceSessionsStockType[keyof typeof GetSalesPerformanceSessionsStockType];


export const GetSalesPerformanceSessionsStockType = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  CONSIGNMENT: 'CONSIGNMENT',
} as const;

export type GetSalesPerformanceSessionsRefundBasis = typeof GetSalesPerformanceSessionsRefundBasis[keyof typeof GetSalesPerformanceSessionsRefundBasis];


export const GetSalesPerformanceSessionsRefundBasis = {
  refunded_at: 'refunded_at',
  sale_date: 'sale_date',
} as const;

export type ListSellingSessionsParams = {
from?: string;
to?: string;
};

export type ListSellingSessions200 = {
  rows: SellingSession[];
};

export type GetSkuByChannelReportParams = {
from?: string;
to?: string;
};

export type TriggerStockReconcile429 = {
  error: string;
  retryAfterSeconds: number;
};

export type GetGmailStatus200 = {
  connected: boolean;
};

export type GetIntegrationsSummaryParams = {
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
cursor?: string;
};

export type GetIntegrationOverviewParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
};

export type GetIntegrationOverview200 = { [key: string]: unknown };

export type GetIntegrationSettingsParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
};

export type GetIntegrationSettings200 = { [key: string]: unknown };

export type GetIntegrationMappingsParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
};

export type GetIntegrationMappings200 = { [key: string]: unknown };

export type GetIntegrationActivityParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: IntegrationPageLimitParameter;
cursor?: IntegrationPageCursorParameter;
};

export type GetIntegrationWebhooksParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: IntegrationPageLimitParameter;
cursor?: IntegrationPageCursorParameter;
};

export type GetIntegrationAdvancedParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
};

export type GetIntegrationAdvanced200 = { [key: string]: unknown };

export type GetIntegrationLogsParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: IntegrationPageLimitParameter;
cursor?: IntegrationPageCursorParameter;
result?: GetIntegrationLogsResult;
};

export type GetIntegrationLogsResult = typeof GetIntegrationLogsResult[keyof typeof GetIntegrationLogsResult];


export const GetIntegrationLogsResult = {
  success: 'success',
  error: 'error',
  skipped: 'skipped',
} as const;

export type QueueIntegrationSyncParams = {
/**
 * @maxLength 128
 */
accountKey?: IntegrationAccountKeyParameter;
};

export type PullShopifyInventory200 = {
  logId: string;
};

export type PullShopifyInventory502 = {
  error?: string;
};

export type ListShopifyDeliveryBackfillRuns200 = {
  runs: ShopifyDeliveryBackfillRun[];
};

export type StartShopifyDeliveryBackfill201 = {
  run: ShopifyDeliveryBackfillRun;
};

export type ContinueShopifyDeliveryBackfill200 = {
  run: ShopifyDeliveryBackfillRun;
  busy: boolean;
};

export type PublishAllShopifyToGoogleYouTube200 = {
  started: boolean;
  message: string;
};

export type PublishAllShopifyToGoogleYouTube409 = {
  error?: string;
  detail?: string;
};

export type PublishAllShopifyToWhatnot202 = {
  started: boolean;
  logId: string;
  message: string;
};

export type PublishAllShopifyToWhatnot409 = {
  error?: string;
  detail?: string;
};

export type PublishAllShopifyToWhatnot502 = {
  error?: string;
  detail?: string;
};

export type PullShopifyCompanies200 = {
  logId: string;
};

export type PullShopifyCompanies502 = {
  error?: string;
};

export type GetCompanyImportLog404 = {
  error?: string;
};

export type ListCompanyImportLogs200 = {
  logs: CompanyImportLog[];
};

export type RegisterShopifyWebhooks400 = {
  error?: string;
};

export type ListShopifyWebhooks200 = {
  webhooks: ShopifyWebhook[];
};

export type ListLatestEbayConnectionSweepResultsParams = {
/**
 * @maxLength 200
 */
tenant?: string;
/**
 * @maxLength 200
 */
account?: string;
classification?: EbayConnectionSweepClassification;
state?: ListLatestEbayConnectionSweepResultsState;
format?: ListLatestEbayConnectionSweepResultsFormat;
};

export type ListLatestEbayConnectionSweepResultsState = typeof ListLatestEbayConnectionSweepResultsState[keyof typeof ListLatestEbayConnectionSweepResultsState];


export const ListLatestEbayConnectionSweepResultsState = {
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type ListLatestEbayConnectionSweepResultsFormat = typeof ListLatestEbayConnectionSweepResultsFormat[keyof typeof ListLatestEbayConnectionSweepResultsFormat];


export const ListLatestEbayConnectionSweepResultsFormat = {
  json: 'json',
  csv: 'csv',
} as const;

export type GetEbayCategorySuggestionsParams = {
/**
 * Free-text query, e.g. "silver britannia coin".
 * @minLength 2
 * @maxLength 100
 */
q: string;
};

export type GetEbayCategorySuggestions200 = {
  suggestions: EbayCategorySuggestion[];
};

export type ListEbaySyncRunsParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
};

export type ListEbaySyncRuns200 = {
  items: EbaySyncRun[];
};

export type FindEbayOrdersParams = {
/**
 * @minLength 2
 */
query: string;
/**
 * @minimum 1
 * @maximum 90
 */
daysBack?: number;
accountKey?: string;
};

export type ListEbayMessagesParams = {
status?: ListEbayMessagesStatus;
};

export type ListEbayMessagesStatus = typeof ListEbayMessagesStatus[keyof typeof ListEbayMessagesStatus];


export const ListEbayMessagesStatus = {
  unread: 'unread',
  all: 'all',
} as const;

export type PushInventoryItemToMarketplacesBodyChannelsItem = typeof PushInventoryItemToMarketplacesBodyChannelsItem[keyof typeof PushInventoryItemToMarketplacesBodyChannelsItem];


export const PushInventoryItemToMarketplacesBodyChannelsItem = {
  shopify: 'shopify',
  ebay: 'ebay',
  woocommerce: 'woocommerce',
} as const;

export type PushInventoryItemToMarketplacesBody = {
  /**
     * Optional channel override. When provided, pushes only
     * to these channels ignoring the item's syncChannels
     * setting.
     */
  channels?: PushInventoryItemToMarketplacesBodyChannelsItem[];
};

export type GetAnalyticsOverviewParams = {
/**
 * @minimum 1
 * @maximum 365
 */
days?: number;
};

export type ListSyncJobsParams = {
slug?: string;
limit?: number;
};

export type ListInventorySerials200 = {
  serials: InventorySerial[];
};

export type BulkAddInventorySerials201 = {
  serials: InventorySerial[];
};

export type UpdateInventorySerial200 = {
  serial: InventorySerial;
};

export type GetPackingSettings200 = {
  /**
     * Maximum allowed duration (seconds) for packing video
     * uploads. NULL or 0 means unlimited.
     */
  videoMaxSeconds: number | null;
  /**
     * Pressing "Start packing" immediately begins an evidence
     * video recording (no modal).
     */
  autoStartRecording: boolean;
  /**
     * Operator cannot stop the auto-started recording manually;
     * it runs until "Packing complete" is pressed.
     */
  lockRecordingUntilComplete: boolean;
  /**
     * At least one media item must be attached before a job can
     * be marked completed.
     */
  requireVideoToComplete: boolean;
  /** Capture audio alongside video. */
  recordAudio: boolean;
  /**
     * Show the optional "Send confirmation" button in the
     * packing flow.
     */
  showSendConfirmation: boolean;
};

export type ListSalePackingMedia200 = {
  items: PackingJobMedia[];
};

export type GetLiveStockExportFields200 = {
  /**
     * Effective ordered list of field keys for the authenticated
     * member. Empty = use the legacy four-column default.
     */
  liveStockExportFields: string[];
  /** True when the member has an explicit override, including []. */
  hasUserOverride?: boolean;
};

export type GetDropshipReportParams = {
from?: string;
to?: string;
};

export type GetCanonicalMarketSnapshotParams = {
/**
 * Optional comma-separated metal selection.
 */
metals?: string;
/**
 * Optional comma-separated currency selection.
 */
currencies?: string;
};

export type StreamCanonicalMarketsParams = {
metals?: string;
currencies?: string;
};

export type StreamMarketWidgetParams = {
parentOrigin?: string;
};

export type GetSpotPriceHistoryParams = {
metal: GetSpotPriceHistoryMetal;
/**
 * @minimum 1
 * @maximum 168
 */
hours?: number;
};

export type GetSpotPriceHistoryMetal = typeof GetSpotPriceHistoryMetal[keyof typeof GetSpotPriceHistoryMetal];


export const GetSpotPriceHistoryMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
  copper: 'copper',
} as const;

export type ListCategoriesParams = {
includeArchived?: boolean;
};

export type UpdateCategory200 = {
  ok: boolean;
};

export type ArchiveCategory200 = {
  ok: boolean;
};

export type ListShopifyCollectionsParams = {
/**
 * Optional filter by collection kind.
 */
kind?: ListShopifyCollectionsKind;
};

export type ListShopifyCollectionsKind = typeof ListShopifyCollectionsKind[keyof typeof ListShopifyCollectionsKind];


export const ListShopifyCollectionsKind = {
  custom: 'custom',
  smart: 'smart',
} as const;

export type ListShopifyCollections200 = {
  items: ShopifyCollection[];
};

export type ListShopifyValidationRunsParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type ListTitleMappingsParams = {
/**
 * Optional substring filter on raw_title (ILIKE).
 */
q?: string;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
};

export type DeleteTitleMapping200 = {
  ok: boolean;
};

export type ListWorkflowRunsParams = {
workflowId?: string;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
};

export type ConnectQuickBooks200 = {
  url: string;
};

export type ListQboAccounts200 = {
  items: QboRef[];
};

export type ListQboTaxCodes200 = {
  items: QboRef[];
};

export type ListQboItems200 = {
  items: QboRef[];
};

export type ListQboCustomers200 = {
  items: QboRef[];
};

export type ListQuickBooksSyncLogsParams = {
status?: ListQuickBooksSyncLogsStatus;
limit?: number;
};

export type ListQuickBooksSyncLogsStatus = typeof ListQuickBooksSyncLogsStatus[keyof typeof ListQuickBooksSyncLogsStatus];


export const ListQuickBooksSyncLogsStatus = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export type ListQuickBooksSyncLogs200 = {
  items: QuickBooksSyncLog[];
};

export type ListQuickBooksReconciliationsParams = {
source?: ListQuickBooksReconciliationsSource;
};

export type ListQuickBooksReconciliationsSource = typeof ListQuickBooksReconciliationsSource[keyof typeof ListQuickBooksReconciliationsSource];


export const ListQuickBooksReconciliationsSource = {
  ebay: 'ebay',
  shopify: 'shopify',
  paypal: 'paypal',
  stripe: 'stripe',
  bank: 'bank',
} as const;

export type ListQuickBooksReconciliations200 = {
  items: QuickBooksReconciliation[];
};

export type ConnectXero200 = {
  url: string;
};

export type ListXeroSyncLogsParams = {
status?: ListXeroSyncLogsStatus;
limit?: number;
};

export type ListXeroSyncLogsStatus = typeof ListXeroSyncLogsStatus[keyof typeof ListXeroSyncLogsStatus];


export const ListXeroSyncLogsStatus = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export type ListXeroSyncLogs200 = {
  items: XeroSyncLog[];
};

export type ConnectTikTokShop200 = {
  url: string;
};

export type ListTikTokDeveloperConnections200 = {
  connections: TikTokDeveloperConnection[];
};

export type VerifyTikTokDeveloperConnection200 = {
  ok: boolean;
  message: string;
};

export type ConnectTikTokDeveloperConnection200 = {
  url: string;
};

export type UpdateTikTokAuthorisedShopBody = {
  syncEnabled?: boolean;
};

export type GetTikTokCategoriesParams = {
/**
 * BCP 47 locale tag for category display names, e.g. "en-GB"
 */
locale?: string;
};

export type ListTikTokProductTypes200 = {
  productTypes: string[];
};

export type ListTikTokShopSyncLogsParams = {
status?: ListTikTokShopSyncLogsStatus;
limit?: number;
};

export type ListTikTokShopSyncLogsStatus = typeof ListTikTokShopSyncLogsStatus[keyof typeof ListTikTokShopSyncLogsStatus];


export const ListTikTokShopSyncLogsStatus = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  skipped: 'skipped',
  warning: 'warning',
} as const;

export type ListTikTokShopSyncLogs200 = {
  items: TikTokShopSyncLog[];
};

export type SyncTikTokShopOrdersBody = {
  /** ISO date-time to sync from (overrides the saved watermark). Use for historical backfill — e.g. supply 2025-07-16T00:00:00Z to pull all orders from that date. Omit to use the automatic watermark. */
  since?: string;
};

export type ListTikTokShopCapabilitiesParams = {
developerConnectionId?: string;
};

export type ListTikTokShopCapabilities200 = {
  items: TikTokConnectionCapability[];
};

export type ListTikTokShopSyncJobsParams = {
developerConnectionId?: string;
shopId?: string;
jobType?: string;
status?: ListTikTokShopSyncJobsStatus;
errorsOnly?: boolean;
limit?: number;
offset?: number;
};

export type ListTikTokShopSyncJobsStatus = typeof ListTikTokShopSyncJobsStatus[keyof typeof ListTikTokShopSyncJobsStatus];


export const ListTikTokShopSyncJobsStatus = {
  queued: 'queued',
  processing: 'processing',
  success: 'success',
  failed: 'failed',
  retry_scheduled: 'retry_scheduled',
  cancelled: 'cancelled',
} as const;

export type ListTikTokShopSyncJobs200 = {
  items: TikTokSyncJob[];
  statusCounts: TikTokSyncJobStatusCounts;
};

export type ListTikTokShopProductMappingsParams = {
q?: string;
unmappedOnly?: boolean;
needsRelinkOnly?: boolean;
limit?: number;
};

export type DeleteTikTokShopProductMapping200 = {
  ok: boolean;
};

export type GetTikTokShopProductPushCapabilityParams = {
force?: boolean;
};

export type GetTikTokShopDuplicateListingsParams = {
inventoryItemId: string;
};

export type GetTikTokShopInventoryPushStatusParams = {
/**
 * Filter by push status (default all)
 */
status?: GetTikTokShopInventoryPushStatusStatus;
/**
 * Search by SKU or title
 */
q?: string;
};

export type GetTikTokShopInventoryPushStatusStatus = typeof GetTikTokShopInventoryPushStatusStatus[keyof typeof GetTikTokShopInventoryPushStatusStatus];


export const GetTikTokShopInventoryPushStatusStatus = {
  all: 'all',
  not_pushed: 'not_pushed',
  in_review: 'in_review',
  live: 'live',
  rejected: 'rejected',
  failed: 'failed',
} as const;

export type DeactivateTikTokShopProducts200 = {
  ok: boolean;
};

export type ListTikTokShopImportedProductsParams = {
q?: string;
limit?: number;
offset?: number;
};

export type ImportTikTokShopProductsBody = {
  /** Optional shop selector. When a tenant has multiple TikTok Shop developer connections, pick which shop to import. Omit to use the generic (tenant-level) connection. */
  developerConnectionId?: string;
};

export type SyncTikTokProductToInventoryBody = {
  /** When true, overwrites existing non-blank inventory fields with TikTok data. Old values are recorded in the audit log. Defaults to false (gap-fill / blank-only mode). */
  force?: boolean;
};

export type SyncTikTokProductToInventory200 = {
  /** Names of inventory fields that were written */
  fieldsPopulated: string[];
  /** Names of fields that had an existing value and were overwritten (only non-empty when force=true) */
  fieldsOverwritten: string[];
};

export type SyncTikTokProductToInventory400 = {
  error: string;
  message?: string;
};

export type AutoLinkTikTokProductsBySku200 = {
  /** Variants newly linked to an inventory item */
  linked: number;
  /** Variants already mapped (skipped) */
  alreadyLinked: number;
  /** Variants with Seller SKU but no matching inventory SKU */
  skipped: number;
  /** Total variants with a Seller SKU examined */
  total: number;
};

/**
 * Map of field name to the value that was written.
 */
export type PullTikTokProductToInventory200Synced = { [key: string]: unknown };

export type PullTikTokProductToInventory200 = {
  ok: boolean;
  /** Map of field name to the value that was written. */
  synced: PullTikTokProductToInventory200Synced;
  /** Human-readable note (e.g. no fields to sync). */
  message?: string;
};

export type SyncAllLinkedInventoryFromTikTokBody = {
  /** Zero-based pagination offset into the ordered list of active linked mappings. Use the returned nextOffset on subsequent calls to advance through all items. */
  offset?: number;
};

export type SyncAllLinkedInventoryFromTikTok200 = {
  /** Number of backfill jobs scheduled in this batch. */
  queued: number;
  /** Number of unique mappings examined this batch (≤ 200). */
  total: number;
  /** Offset to pass on the next call. If total < 200 all linked items have been queued and no further call is needed. */
  nextOffset: number;
};

export type ListTikTokShopMessagesParams = {
saleOrderId?: string;
customerId?: string;
conversationId?: string;
limit?: number;
};

export type GetTikTokShopMessageCapabilityParams = {
force?: boolean;
};

export type MarkTikTokShopMessagesRead200 = {
  ok: boolean;
  updated: number;
};

export type ImportTikTokShippingLabelsBody = {
  /** TikTok shipping label PDF (required) */
  pdf: Blob;
  /** TikTok To Ship CSV export (optional) */
  csv?: Blob;
};

export type ListDemandForecastsParams = {
q?: string;
classification?: ListDemandForecastsClassification;
risk?: ListDemandForecastsRisk;
sort?: ListDemandForecastsSort;
limit?: number;
};

export type ListDemandForecastsClassification = typeof ListDemandForecastsClassification[keyof typeof ListDemandForecastsClassification];


export const ListDemandForecastsClassification = {
  fast_mover: 'fast_mover',
  steady: 'steady',
  slow_mover: 'slow_mover',
  dead_stock: 'dead_stock',
  no_history: 'no_history',
} as const;

export type ListDemandForecastsRisk = typeof ListDemandForecastsRisk[keyof typeof ListDemandForecastsRisk];


export const ListDemandForecastsRisk = {
  stockout: 'stockout',
  overstock: 'overstock',
} as const;

export type ListDemandForecastsSort = typeof ListDemandForecastsSort[keyof typeof ListDemandForecastsSort];


export const ListDemandForecastsSort = {
  risk: 'risk',
  velocity: 'velocity',
  days: 'days',
  reorder: 'reorder',
} as const;

export type ListReorderRecommendationsParams = {
status?: ListReorderRecommendationsStatus;
limit?: number;
};

export type ListReorderRecommendationsStatus = typeof ListReorderRecommendationsStatus[keyof typeof ListReorderRecommendationsStatus];


export const ListReorderRecommendationsStatus = {
  open: 'open',
  dismissed: 'dismissed',
  actioned: 'actioned',
} as const;

export type ListReorderRecommendations200 = {
  items: ReorderRecommendation[];
};

export type ListForecastingRunLogsParams = {
limit?: number;
};

export type ListForecastingRunLogs200 = {
  items: ForecastingRunLog[];
};

export type ListIntelligenceInsightsParams = {
status?: ListIntelligenceInsightsStatus;
type?: ListIntelligenceInsightsType;
source?: ListIntelligenceInsightsSource;
severity?: ListIntelligenceInsightsSeverity;
q?: string;
includeDismissed?: boolean;
savedOnly?: boolean;
limit?: number;
};

export type ListIntelligenceInsightsStatus = typeof ListIntelligenceInsightsStatus[keyof typeof ListIntelligenceInsightsStatus];


export const ListIntelligenceInsightsStatus = {
  active: 'active',
  resolved: 'resolved',
} as const;

export type ListIntelligenceInsightsType = typeof ListIntelligenceInsightsType[keyof typeof ListIntelligenceInsightsType];


export const ListIntelligenceInsightsType = {
  sales_spike: 'sales_spike',
  sales_drop: 'sales_drop',
  marketplace_change: 'marketplace_change',
  stockout_risk: 'stockout_risk',
  slow_moving_stock: 'slow_moving_stock',
  high_return_rate: 'high_return_rate',
  packing_delay: 'packing_delay',
  hr_warning: 'hr_warning',
  social_change: 'social_change',
  profit_warning: 'profit_warning',
  customer_behaviour_change: 'customer_behaviour_change',
} as const;

export type ListIntelligenceInsightsSource = typeof ListIntelligenceInsightsSource[keyof typeof ListIntelligenceInsightsSource];


export const ListIntelligenceInsightsSource = {
  sales: 'sales',
  marketplace: 'marketplace',
  inventory: 'inventory',
  returns: 'returns',
  packing: 'packing',
  hr: 'hr',
  social: 'social',
  finance: 'finance',
  customers: 'customers',
} as const;

export type ListIntelligenceInsightsSeverity = typeof ListIntelligenceInsightsSeverity[keyof typeof ListIntelligenceInsightsSeverity];


export const ListIntelligenceInsightsSeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;

export type ListPurchaseRecommendationsParams = {
status?: ListPurchaseRecommendationsStatus;
limit?: number;
};

export type ListPurchaseRecommendationsStatus = typeof ListPurchaseRecommendationsStatus[keyof typeof ListPurchaseRecommendationsStatus];


export const ListPurchaseRecommendationsStatus = {
  open: 'open',
  converted: 'converted',
  dismissed: 'dismissed',
} as const;

export type ListPurchaseRecommendations200 = {
  items: PurchaseRecommendation[];
};

export type ListSupplierPerformance200 = {
  items: SupplierPerformance[];
};

export type ListPurchasingRunLogsParams = {
limit?: number;
};

export type ListPurchasingRunLogs200 = {
  items: PurchasingRunLog[];
};

export type ListAutomationsParams = {
enabled?: boolean;
};

export type ListAllAutomationLogsParams = {
limit?: number;
outcome?: ListAllAutomationLogsOutcome;
};

export type ListAllAutomationLogsOutcome = typeof ListAllAutomationLogsOutcome[keyof typeof ListAllAutomationLogsOutcome];


export const ListAllAutomationLogsOutcome = {
  skipped: 'skipped',
  success: 'success',
  partial: 'partial',
  failed: 'failed',
} as const;

export type ListAutomationLogsParams = {
limit?: number;
};

export type ListPricingRules200 = {
  items: PricingRule[];
};

export type DeletePricingRule200 = {
  ok: boolean;
};

export type ListPricingFeeProfilesParams = {
includeArchived?: boolean;
};

export type ListPricingFeeProfiles200 = {
  items: PricingFeeProfile[];
};

export type ArchivePricingFeeProfile200 = {
  ok: boolean;
};

export type ListPricingMarginRulesParams = {
inventoryItemId?: string;
};

export type ListPricingMarginRules200 = {
  items: PricingMarginRule[];
};

export type DeletePricingMarginRule200 = {
  ok: boolean;
};

export type ListPricingMarginOverridesParams = {
limit?: number;
};

export type ListPricingMarginOverrides200 = {
  items: PricingMarginOverride[];
};

export type ListPricingApprovalsParams = {
status?: ListPricingApprovalsStatus;
q?: string;
limit?: number;
};

export type ListPricingApprovalsStatus = typeof ListPricingApprovalsStatus[keyof typeof ListPricingApprovalsStatus];


export const ListPricingApprovalsStatus = {
  pending: 'pending',
  approved: 'approved',
  publishing: 'publishing',
  rejected: 'rejected',
  applied: 'applied',
  auto_applied: 'auto_applied',
  failed: 'failed',
  superseded: 'superseded',
  scheduled: 'scheduled',
  ignored: 'ignored',
  all: 'all',
} as const;

export type ListPricingApprovals200 = {
  items: PricingChangeApproval[];
};

export type ApprovePricingChangeBody = {
  overrideReason?: string;
  confirmOverride?: boolean;
  publish?: boolean;
};

export type EditPricingChangeBody = {
  proposedPrice: number;
};

export type SchedulePricingChangeBody = {
  scheduledFor: string;
  publish?: boolean;
  /** Required (with confirmOverride) when scheduling a hard-blocked proposal — same audited margin-override flow as immediate approval. */
  overrideReason?: string;
  confirmOverride?: boolean;
};

export type ListPricingHistoryParams = {
inventoryItemId?: string;
limit?: number;
};

export type ListPricingHistory200 = {
  items: PricingPriceHistoryEntry[];
};

export type ListPricingSchedules200 = {
  items: PricingSchedule[];
};

export type ListPricingBulkJobs200 = {
  items: PricingBulkJob[];
};

export type CreatePricingBulkJobBody = {
  name?: string | null;
  selection: PricingBulkSelection;
  publish?: boolean;
};

export type ListPricingRunLogsParams = {
limit?: number;
};

export type ListPricingRunLogs200 = {
  items: PricingRunLog[];
};

export type ListPricingProductsParams = {
lens?: ListPricingProductsLens;
channel?: string;
q?: string;
page?: number;
pageSize?: number;
};

export type ListPricingProductsLens = typeof ListPricingProductsLens[keyof typeof ListPricingProductsLens];


export const ListPricingProductsLens = {
  all: 'all',
  below_target: 'below_target',
  premium: 'premium',
  spot: 'spot',
  marketplace: 'marketplace',
} as const;

export type GetPricingItemContextParams = {
channel?: string;
};

export type GetDocumentCatalog200 = {
  documentTypes: DocumentTypeCatalogEntry[];
};

export type ListDocumentTemplates200 = {
  templates: DocumentTemplate[];
};

export type CreateDocumentTemplate201 = {
  template: DocumentTemplate;
};

export type GetDocumentTemplateGroup200 = {
  current: DocumentTemplate;
  versions: DocumentTemplate[];
};

export type UpdateDocumentTemplate200 = {
  template: DocumentTemplate;
};

export type PublishDocumentTemplate200 = {
  template: DocumentTemplate;
};

export type ArchiveDocumentTemplate200 = {
  template: DocumentTemplate;
};

export type ListGeneratedDocumentsParams = {
documentType?: string;
sourceKind?: string;
sourceRecordId?: string;
limit?: number;
};

export type ListGeneratedDocuments200 = {
  documents: GeneratedDocument[];
};

export type ListDocumentLogsParams = {
documentId?: string;
limit?: number;
};

export type ListDocumentLogs200 = {
  logs: DocumentGenerationLog[];
};

export type ListDocumentAutoRules200 = {
  rules: DocumentAutoRule[];
};

export type PutDocumentAutoRules200 = {
  rules: DocumentAutoRule[];
};

export type GetGeneratedDocument200 = {
  document: GeneratedDocument;
};

export type DownloadGeneratedDocument200 = {
  url: string;
};

export type EmailGeneratedDocument200 = {
  ok: boolean;
  messageId?: string | null;
};

export type ArchiveGeneratedDocument200 = {
  document: GeneratedDocument;
};

export type ListPostageServices200 = {
  services: PostageService[];
};

export type GetPostageSettings200 = {
  settings: PostageSettings;
};

export type UpdatePostageSettings200 = {
  settings: PostageSettings;
};

export type ListCourierIntegrations200 = {
  couriers: CourierIntegration[];
};

export type CreateCourierIntegration201 = {
  courier: CourierIntegration;
};

export type UpdateCourierIntegration200 = {
  courier: CourierIntegration;
};

export type ListCourierProviderServices200 = {
  services: ProShippingService[];
};

export type ListShipmentsParams = {
status?: string;
saleOrderId?: string;
channel?: string;
};

export type ListShipments200 = {
  shipments: Shipment[];
};

export type CreateShipment201 = {
  shipment: Shipment;
};

export type GetShipment200 = {
  shipment: Shipment;
  labels: ShipmentLabel[];
  tracking: ShipmentTracking[];
};

export type GenerateShipmentLabel200 = {
  shipment: Shipment;
};

export type DownloadShipmentLabel200 = {
  url: string;
};

export type ListCombinedShipments200 = {
  combined: CombinedShipment[];
};

export type CreateCombinedShipment201 = {
  combined: CombinedShipment;
};

export type ExcludeCombinedShipment200 = {
  combined: CombinedShipment;
};

export type ListPickLists200 = {
  pickLists: PickList[];
};

export type CreatePickList201 = {
  pickList: PickList;
};

export type ListShipmentTrackingParams = {
uploadStatus?: string;
};

export type ListShipmentTracking200 = {
  tracking: ShipmentTracking[];
};

export type UploadShipmentTracking200 = {
  tracking: ShipmentTracking;
};

export type ListPostageAudit200 = {
  audit: ShipmentAuditLog[];
};

export type ListCustomFieldsParams = {
entityType?: CustomFieldEntityType;
includeInactive?: boolean;
};

export type ListCustomFieldValuesParams = {
entityType: CustomFieldEntityType;
entityId: string;
};

export type ListPickListImportsParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type UpdatePickListParcel200 = {
  parcel: PickListParcel;
};

export type MarkOrderLoss200 = {
  loss: OrderLoss;
};

export type MarkOrderLoss201 = {
  loss: OrderLoss;
};

export type ListOrderLossesParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
type?: OrderLossType;
status?: OrderLossStatus;
orderId?: string;
/**
 * Filter to losses on orders belonging to this customer.
 */
customerId?: string;
};

export type GetOrderLoss200 = {
  loss: OrderLossWithContext;
};

export type UpdateOrderLoss200 = {
  loss: OrderLoss;
};

export type SetPickListParcelStatus200 = {
  parcel: PickListParcel;
};

export type ReorderInventoryCompositeArchive200 = {
  ok: boolean;
  compositeArchive: CompositeArchiveEntry[];
};

export type DeleteInventoryCompositeArchiveEntry200 = {
  ok: boolean;
  compositeArchive: CompositeArchiveEntry[];
};

export type CreateImageTemplate201 = {
  template: ImageTemplate;
};

export type ActivateImageTemplate200 = {
  template: ImageTemplate;
};

export type ListPackingJobsParams = {
/**
 * Comma-separated list of statuses to filter on.
 */
status?: string;
q?: string;
/**
 * Search field. `tiktok_username` matches the TikTok Shop buyer handle (stored on the customer's external_ref). `order_number` already matches the TikTok order id (external_order_number). `auto` matches any field including the TikTok buyer handle.
 */
mode?: ListPackingJobsMode;
/**
 * Source marketplace filter. Narrows to packing jobs that contain at least one sale order from this channel.
 */
source?: ListPackingJobsSource;
/**
 * ISO date — shipDate >= from.
 */
from?: string;
to?: string;
/**
 * Maximum number of compact queue rows to return.
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * Number of matching rows to skip for bounded pagination.
 * @minimum 0
 * @maximum 10000
 */
offset?: number;
/**
 * Comma-separated internal sale_order UUIDs. When provided, narrows results to packing jobs that contain at least one of these orders. Used by the TikTok label-import dialog to filter the packing screen to today's batch after a successful label import.
 */
sale_order_ids?: string;
/**
 * When true, returns ONLY outstanding-media jobs: active jobs (status pending or in_progress) that have zero attached photos/videos. Overrides the `status` filter. Drives the "Outstanding packing media" daily-check section on the packing page.
 */
outstanding_media?: boolean;
};

export type ListPackingJobsMode = typeof ListPackingJobsMode[keyof typeof ListPackingJobsMode];


export const ListPackingJobsMode = {
  auto: 'auto',
  ebay_username: 'ebay_username',
  tiktok_username: 'tiktok_username',
  customer: 'customer',
  product: 'product',
  order_number: 'order_number',
  tracking: 'tracking',
} as const;

export type ListPackingJobsSource = typeof ListPackingJobsSource[keyof typeof ListPackingJobsSource];


export const ListPackingJobsSource = {
  ebay: 'ebay',
  tiktok_shop: 'tiktok_shop',
  shopify: 'shopify',
  woocommerce: 'woocommerce',
  website: 'website',
  manual: 'manual',
} as const;

export type ListPackingJobs200 = {
  items: PackingJobSummary[];
  total: number;
  hasMore?: boolean;
  nextOffset?: number | null;
};

export type ListCombinedShipmentSuggestionsParams = {
/**
 * Maximum number of candidate packing jobs to inspect.
 * @minimum 1
 * @maximum 50
 */
limit?: number;
};

export type ListCombinedShipmentSuggestions200 = {
  items: CombinedShipmentSuggestion[];
};

export type CombinePackingJobs400 = {
  error?: string;
};

export type DismissCombinedShipmentSuggestion200 = {
  ok: boolean;
};

export type DismissCombinedShipmentSuggestion400 = {
  error?: string;
};

export type UpdatePackingJob200 = {
  ok: boolean;
};

export type UpdatePackingJob409 = {
  error?: string;
  from?: string;
  to?: string;
  allowed?: string[];
};

export type SplitPackingJobByLabel409Reason = typeof SplitPackingJobByLabel409Reason[keyof typeof SplitPackingJobByLabel409Reason];


export const SplitPackingJobByLabel409Reason = {
  not_pending: 'not_pending',
  has_media: 'has_media',
  single_label: 'single_label',
} as const;

export type SplitPackingJobByLabel409 = {
  error: string;
  reason: SplitPackingJobByLabel409Reason;
};

export type SendPackingJobConfirmation200Email = { [key: string]: unknown } | null;

export type SendPackingJobConfirmation200Whatsapp = { [key: string]: unknown } | null;

export type SendPackingJobConfirmation200Sms = { [key: string]: unknown } | null;

export type SendPackingJobConfirmation200 = {
  ok: boolean;
  messageId?: string | null;
  providerMessageId?: string | null;
  logId?: string | null;
  email?: SendPackingJobConfirmation200Email;
  whatsapp?: SendPackingJobConfirmation200Whatsapp;
  sms?: SendPackingJobConfirmation200Sms;
};

export type ListPackingJobMedia200 = {
  items: PackingJobMedia[];
};

export type ListSalePackingNotes200 = {
  items: PackingNote[];
};

export type CreateSalePackingNote400 = {
  error?: string;
};

export type GetPackingJobShareLink200 = {
  /**
     * Absolute HMAC-signed gallery URL, or null when no
     * public base URL is resolvable.
     */
  url?: string | null;
  /**
     * Whether the job has any media attached. The copy
     * button should be shown only when this is true.
     */
  hasMedia: boolean;
};

export type ListPackingJobNotes200 = {
  items: PackingJobNote[];
  /** Number of notes still effectively-open for this job. */
  openCount: number;
};

export type ResolvePackingNote400 = {
  error?: string;
};

export type ReplyPackingNote400 = {
  error?: string;
};

/**
 * Updated packing job item row.
 */
export type SetPackingOrderCert200Item = { [key: string]: unknown };

export type SetPackingOrderCert200 = {
  /** Updated packing job item row. */
  item: SetPackingOrderCert200Item;
};

export type SetPackingLineSerial200 = {
  lineId: string;
  /** The serialId now stored on the sale line (null after unlink). */
  serialId: string | null;
};

export type ListAlertsParams = {
unreadOnly?: boolean;
/**
 * @maximum 200
 */
limit?: number;
};

export type GetAlertsUnreadCount200 = {
  count: number;
};

export type MarkAllAlertsRead200 = {
  updated: number;
};

export type MarkAlertRead200 = {
  ok: boolean;
};

export type GetPushConfig200 = {
  vapidPublicKey: string | null;
};

export type ListNotificationsParams = {
category?: string;
priority?: ListNotificationsPriority;
module?: string;
search?: string;
unreadOnly?: boolean;
includeDismissed?: boolean;
dateFrom?: string;
dateTo?: string;
/**
 * @maximum 200
 */
limit?: number;
offset?: number;
};

export type ListNotificationsPriority = typeof ListNotificationsPriority[keyof typeof ListNotificationsPriority];


export const ListNotificationsPriority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
  urgent: 'urgent',
} as const;

export type MarkNotificationsRead200 = {
  updated: number;
};

export type ListNotificationDeliveryLogsParams = {
alertType?: string;
channel?: ListNotificationDeliveryLogsChannel;
status?: ListNotificationDeliveryLogsStatus;
/**
 * @maximum 500
 */
limit?: number;
offset?: number;
};

export type ListNotificationDeliveryLogsChannel = typeof ListNotificationDeliveryLogsChannel[keyof typeof ListNotificationDeliveryLogsChannel];


export const ListNotificationDeliveryLogsChannel = {
  in_app: 'in_app',
  email: 'email',
  push: 'push',
  digest: 'digest',
} as const;

export type ListNotificationDeliveryLogsStatus = typeof ListNotificationDeliveryLogsStatus[keyof typeof ListNotificationDeliveryLogsStatus];


export const ListNotificationDeliveryLogsStatus = {
  sent: 'sent',
  failed: 'failed',
  skipped: 'skipped',
  queued: 'queued',
} as const;

export type GetConsignmentBatchesParams = {
supplierId?: string;
status?: GetConsignmentBatchesStatus;
};

export type GetConsignmentBatchesStatus = typeof GetConsignmentBatchesStatus[keyof typeof GetConsignmentBatchesStatus];


export const GetConsignmentBatchesStatus = {
  ACTIVE: 'ACTIVE',
  CLEARED: 'CLEARED',
} as const;

export type GetConsignmentBatches200 = {
  items: ConsignmentBatchListRow[];
};

export type GetShipmentGroupsParams = {
supplierId?: string;
status?: GetShipmentGroupsStatus;
};

export type GetShipmentGroupsStatus = typeof GetShipmentGroupsStatus[keyof typeof GetShipmentGroupsStatus];


export const GetShipmentGroupsStatus = {
  AWAITING_SHIP: 'AWAITING_SHIP',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  FINALISED: 'FINALISED',
} as const;

export type GetShipmentGroups200 = {
  items: ShipmentGroupListRow[];
};

export type ListPlatformTenants200 = {
  tenants: PlatformTenant[];
};

export type ListPlatformTenantFeatures200 = {
  tenantId: string;
  features: PlatformTenantFeature[];
};

export type SetPlatformTenantFeature200 = {
  feature: PlatformTenantFeature;
};

export type GetMyFeatures200 = {
  tenantId: string;
  features: FeatureKey[];
  /** True when the caller's tenant is suspended (trial lapse or manual). The FE locks the dashboard to the Client Area billing page so the client can still pay. */
  tenantSuspended?: boolean;
  /** True when the caller's tenant is a demo tenant. Drives the FE Demo Mode banner and "Connected (Demo)" integration statuses; demo tenants never trigger real external side-effects. */
  isDemo?: boolean;
  /** True when this demo tenant has demo sample data toggled on (`tenants.demo_data_enabled`). Always false for non-demo tenants; consumed by the demo-data seeding/reset layer. */
  demoDataEnabled?: boolean;
};

export type ListPublicPages200 = {
  pages: PublicPageSummary[];
};

export type CreatePublicPage201 = {
  page: PublicPage;
};

export type GetPublicPage200 = {
  page: PublicPage;
};

export type UpdatePublicPage200 = {
  page: PublicPage;
};

export type DeletePublicPage200 = {
  ok: boolean;
};

export type SubmitWebsiteSitemap200Status = typeof SubmitWebsiteSitemap200Status[keyof typeof SubmitWebsiteSitemap200Status];


export const SubmitWebsiteSitemap200Status = {
  success: 'success',
  error: 'error',
} as const;

export type SubmitWebsiteSitemap200 = {
  ok: boolean;
  status: SubmitWebsiteSitemap200Status;
  submittedAt?: string;
  sitemapUrl: string;
};

export type NotifyWebsiteSeoPage200Status = typeof NotifyWebsiteSeoPage200Status[keyof typeof NotifyWebsiteSeoPage200Status];


export const NotifyWebsiteSeoPage200Status = {
  success: 'success',
  error: 'error',
} as const;

export type NotifyWebsiteSeoPage200 = {
  ok: boolean;
  status: NotifyWebsiteSeoPage200Status;
  notifiedAt?: string;
  canonicalUrl: string;
};

export type GetWebsiteSeoSearchTrendParams = {
/**
 * @minimum 1
 * @maximum 365
 */
days?: number;
};

export type GetWebsiteSeoIndexingTrendParams = {
/**
 * @minimum 1
 * @maximum 365
 */
days?: number;
};

export type PublishPublicPage200 = {
  page: PublicPage;
};

export type UnpublishPublicPage200 = {
  page: PublicPage;
};

export type ListPublicPageVersions200 = {
  versions: PublicPageVersionSummary[];
};

export type GetPublicPageVersion200 = {
  version: PublicPageVersionDetail;
};

export type RestorePublicPageVersion200 = {
  page: PublicPage;
};

export type GetSiteSettings200 = {
  settings: SiteSetting[];
};

export type UpdateSiteSetting200 = {
  setting: SiteSetting;
};

export type PublishSiteSettings200 = {
  settings: SiteSetting[];
};

export type ListSiteSettingVersionsParams = {
key: SiteSettingKey;
};

export type ListSiteSettingVersions200 = {
  versions: SiteSettingVersionSummary[];
};

export type RestoreSiteSettingVersion200 = {
  setting: SiteSetting;
};

export type GetMyPlatformAccess200 = {
  hasPlatformAccess: boolean;
  /** True when the caller is a member of the canonical platform OWNER tenant. Owner-only feature toggles (e.g. hr_module_enabled) are restricted to such operators. */
  isOwnerOperator: boolean;
};

export type GetMyPlatformPermissions200 = {
  permissions: string[];
};

export type ListTasksParams = {
scope?: ListTasksScope;
status?: string;
projectId?: string;
/**
 * Tenant-local customer UUID; requires team task visibility.
 */
customerId?: string;
/**
 * Optional server-side page bound. Omit to preserve existing task views.
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * Optional page offset used with limit.
 * @minimum 0
 */
offset?: number;
};

export type ListTasksScope = typeof ListTasksScope[keyof typeof ListTasksScope];


export const ListTasksScope = {
  mine: 'mine',
  team: 'team',
  all: 'all',
} as const;

export type ListRemindersParams = {
scope?: ListRemindersScope;
status?: string;
};

export type ListRemindersScope = typeof ListRemindersScope[keyof typeof ListRemindersScope];


export const ListRemindersScope = {
  mine: 'mine',
  team: 'team',
} as const;

export type ListProjectsParams = {
status?: string;
};

export type ListCalendarEventsParams = {
from?: string;
to?: string;
};

export type ListScrapInventoryParams = {
status?: ListScrapInventoryStatus;
metal?: ListScrapInventoryMetal;
};

export type ListScrapInventoryStatus = typeof ListScrapInventoryStatus[keyof typeof ListScrapInventoryStatus];


export const ListScrapInventoryStatus = {
  IN_STOCK: 'IN_STOCK',
  IN_REFINING: 'IN_REFINING',
  REFINED: 'REFINED',
  SOLD: 'SOLD',
  WRITTEN_OFF: 'WRITTEN_OFF',
  CONVERTED: 'CONVERTED',
} as const;

export type ListScrapInventoryMetal = typeof ListScrapInventoryMetal[keyof typeof ListScrapInventoryMetal];


export const ListScrapInventoryMetal = {
  gold: 'gold',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
} as const;

export type GetScrapReportSummaryParams = {
/**
 * ISO date string — scope purchase cost and realised P&L to purchases on/after this date
 */
dateFrom?: string;
/**
 * ISO date string — scope purchase cost and realised P&L to purchases on/before this date
 */
dateTo?: string;
};

export type ListHrStaffParams = {
status?: string;
q?: string;
includeArchived?: boolean;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListHrTimeOffParams = {
status?: string;
};

export type ListHrChangeRequestsParams = {
status?: string;
};

export type ListHrPaymentsParams = {
staffId?: string;
status?: ListHrPaymentsStatus;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListHrPaymentsStatus = typeof ListHrPaymentsStatus[keyof typeof ListHrPaymentsStatus];


export const ListHrPaymentsStatus = {
  due: 'due',
  paid: 'paid',
  cancelled: 'cancelled',
  open: 'open',
} as const;

export type ListHrAuditParams = {
staffId?: string;
entityType?: string;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type GetHrPerformanceSummaryParams = {
from?: string;
to?: string;
};

export type GetHrPerformanceStaffParams = {
staffId: string;
from?: string;
to?: string;
};

export type ListHrClockEventsParams = {
staffId: string;
from?: string;
to?: string;
};

export type ListHrShiftsParams = {
from?: string;
to?: string;
staffId?: string;
};

export type GetHrShiftTimeOffOverlapParams = {
staffId: string;
date: string;
};

export type ListReturnsParams = {
status?: string;
source?: string;
outcome?: string;
q?: string;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListReturnsAuditParams = {
returnId?: string;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type GetReturnsReportSummaryParams = {
fromDate?: string;
toDate?: string;
};

export type ListAssetsParams = {
status?: string;
assetType?: string;
assignedToUserId?: string;
assignedToStaffId?: string;
/**
 * @minimum 0
 */
warrantyExpiringDays?: number;
includeArchived?: boolean;
q?: string;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListComplianceProfilesParams = {
subjectType?: ListComplianceProfilesSubjectType;
status?: string;
riskRating?: string;
reviewDue?: boolean;
q?: string;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListComplianceProfilesSubjectType = typeof ListComplianceProfilesSubjectType[keyof typeof ListComplianceProfilesSubjectType];


export const ListComplianceProfilesSubjectType = {
  customer: 'customer',
  supplier: 'supplier',
} as const;

export type ListComplianceTasksParams = {
status?: string;
profileId?: string;
assignedToUserId?: string;
q?: string;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListShopifyMappingLogsParams = {
inventoryItemId?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
};

export type ListFeatureRequestsParams = {
status?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListAccountBillingInvoicesParams = {
status?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListAccountBillingPaymentsParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type DeleteCompositePreset200 = {
  ok: boolean;
};

export type ListPreOrderBatchesParams = {
status?: string;
q?: string;
supplierId?: string;
allocationType?: PreOrderAllocationType;
operatorUserId?: string;
sort?: ListPreOrderBatchesSort;
/**
 * @minimum 0
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListPreOrderBatchesSort = typeof ListPreOrderBatchesSort[keyof typeof ListPreOrderBatchesSort];


export const ListPreOrderBatchesSort = {
  created_desc: 'created_desc',
  updated_desc: 'updated_desc',
  supplier_asc: 'supplier_asc',
} as const;

export type GetPreOrderBatchParams = {
/**
 * Return aggregate totals and freshness metadata without hydrating item rows.
 */
compact?: boolean;
};

export type ListPreOrderBatchProductsParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
cursor?: string;
/**
 * Filter by product title or SKU
 * @maxLength 120
 */
search?: string;
};

export type GetPreOrderBatchNotesParams = {
/**
 * @maxLength 120
 */
search?: string;
actorUserId?: string;
};

export type UpdatePreOrderBatchNotesBody = {
  /** @maxLength 10000 */
  note: string | null;
};

export type UpdatePreOrderBatchNotes200 = {
  note: string | null;
};

export type SearchPreOrderLinkableInventoryParams = {
/**
 * @minLength 2
 * @maxLength 100
 */
search: string;
};

export type SearchPreOrderLinkableInventory200 = {
  items: PreOrderInventoryChoice[];
};

export type ListPreOrderAllocationsParams = {
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
cursor?: string;
/**
 * Filter by customer, order number, or product title
 * @maxLength 120
 */
search?: string;
/**
 * Filter by one business type, or use unclassified for legacy null values.
 */
allocationType?: typeof ListPreOrderAllocationsAllocationType[keyof typeof ListPreOrderAllocationsAllocationType];
/**
 * Filter by assigned tenant user id, or use unassigned for null assignments.
 */
operatorUserId?: string;
};

export const ListPreOrderAllocationsAllocationType = {...PreOrderAllocationType,  unclassified: 'unclassified',
} as const
export type ListExceptionsParams = {
severity?: ExceptionSeverity;
category?: ExceptionCategory;
/**
 * A single status, "active" (default — any non-closed status), or "all".
 */
status?: string;
/**
 * User id or "unassigned".
 */
assignedUserId?: string;
search?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type DeleteExceptionRule200 = {
  deleted: boolean;
};

export type RepairPurchaseOrderReadModelBody = {
  /** @maxItems 500 */
  purchaseOrderIds?: string[];
};

export type RepairPurchaseOrderReadModel200Result = { [key: string]: unknown };

export type RepairPurchaseOrderReadModel200 = {
  result: RepairPurchaseOrderReadModel200Result;
  report: PurchaseOrderReconciliationReport;
};

export type RetryPurchaseOrderOverview200Status = typeof RetryPurchaseOrderOverview200Status[keyof typeof RetryPurchaseOrderOverview200Status];


export const RetryPurchaseOrderOverview200Status = {
  preparing: 'preparing',
} as const;

export type RetryPurchaseOrderOverview200 = {
  status: RetryPurchaseOrderOverview200Status;
  message: string;
  retryable: boolean;
  /** @minimum 0 */
  attempts: number;
};

export type GetPurchaseOrderOverviewParams = {
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @maxLength 200
 */
search?: string;
status?: string;
/**
 * Canonical mobile quick-filter bucket. When set, rows are filtered
 * server-side while metrics/counts remain scoped by the other
 * criteria and continue to describe all buckets.
 */
quickFilter?: GetPurchaseOrderOverviewQuickFilter;
/**
 * Receiving workflow state used by the mobile operational filters.
 */
workflow?: GetPurchaseOrderOverviewWorkflow;
/**
 * Secondary operational filter. These filters never expose finance values.
 */
secondary?: GetPurchaseOrderOverviewSecondary;
/**
 * Server-side destination-SKU allocation filter. needs_sku includes
 * rows with at least one remaining unreceived line whose destination
 * link is missing or stale; complete includes rows with zero such lines.
 * Rows and general totals are filtered before pagination. allocationCounts
 * remains across the other base criteria, before the active allocation filter.
 */
allocation?: GetPurchaseOrderOverviewAllocation;
supplierId?: string;
/**
 * @maxLength 3
 */
currency?: string;
dateFrom?: string;
dateTo?: string;
groupBy?: GetPurchaseOrderOverviewGroupBy;
sortBy?: GetPurchaseOrderOverviewSortBy;
sortDirection?: GetPurchaseOrderOverviewSortDirection;
savedViewId?: string;
includeMetrics?: boolean;
includeCounts?: boolean;
/**
 * Explicitly retry a failed overview preparation.
 */
retry?: GetPurchaseOrderOverviewRetry;
};

export type GetPurchaseOrderOverviewQuickFilter = typeof GetPurchaseOrderOverviewQuickFilter[keyof typeof GetPurchaseOrderOverviewQuickFilter];


export const GetPurchaseOrderOverviewQuickFilter = {
  'paid-waiting-to-ship': 'paid-waiting-to-ship',
  'awaiting-payment': 'awaiting-payment',
  'in-transit': 'in-transit',
  'awaiting-final-costing': 'awaiting-final-costing',
  'missing-waybill': 'missing-waybill',
  'completed-awaiting-costs': 'completed-awaiting-costs',
  finalised: 'finalised',
  all: 'all',
} as const;

export type GetPurchaseOrderOverviewWorkflow = typeof GetPurchaseOrderOverviewWorkflow[keyof typeof GetPurchaseOrderOverviewWorkflow];


export const GetPurchaseOrderOverviewWorkflow = {
  not_received: 'not_received',
  partial: 'partial',
  complete: 'complete',
} as const;

export type GetPurchaseOrderOverviewSecondary = typeof GetPurchaseOrderOverviewSecondary[keyof typeof GetPurchaseOrderOverviewSecondary];


export const GetPurchaseOrderOverviewSecondary = {
  warnings: 'warnings',
  unpaid: 'unpaid',
  inbound: 'inbound',
} as const;

export type GetPurchaseOrderOverviewAllocation = typeof GetPurchaseOrderOverviewAllocation[keyof typeof GetPurchaseOrderOverviewAllocation];


export const GetPurchaseOrderOverviewAllocation = {
  needs_sku: 'needs_sku',
  complete: 'complete',
  all: 'all',
} as const;

export type GetPurchaseOrderOverviewGroupBy = typeof GetPurchaseOrderOverviewGroupBy[keyof typeof GetPurchaseOrderOverviewGroupBy];


export const GetPurchaseOrderOverviewGroupBy = {
  none: 'none',
  status: 'status',
  supplier: 'supplier',
  currency: 'currency',
  month: 'month',
} as const;

export type GetPurchaseOrderOverviewSortBy = typeof GetPurchaseOrderOverviewSortBy[keyof typeof GetPurchaseOrderOverviewSortBy];


export const GetPurchaseOrderOverviewSortBy = {
  purchaseDate: 'purchaseDate',
  deliveryDate: 'deliveryDate',
  total: 'total',
  supplier: 'supplier',
  status: 'status',
  payment: 'payment',
  updatedAt: 'updatedAt',
} as const;

export type GetPurchaseOrderOverviewSortDirection = typeof GetPurchaseOrderOverviewSortDirection[keyof typeof GetPurchaseOrderOverviewSortDirection];


export const GetPurchaseOrderOverviewSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPurchaseOrderOverviewRetry = typeof GetPurchaseOrderOverviewRetry[keyof typeof GetPurchaseOrderOverviewRetry];


export const GetPurchaseOrderOverviewRetry = {
  true: 'true',
  false: 'false',
} as const;

export type ListPurchaseOrderOverviewInvoicesParams = {
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type ListPurchaseOrderOverviewLinesParams = {
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type ListPurchaseOrderOverviewNotesParams = {
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type ListPurchaseOrderOverviewDocumentsParams = {
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type ListPurchaseOrderRecentAuditParams = {
/**
 * Opaque cursor returned as nextCursor; includes the timestamp and id tie-breaker.
 */
cursor?: string;
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
};

export type GetSalesPerformanceParams = {
start: string;
end: string;
comparison?: GetSalesPerformanceComparison;
channel?: GetSalesPerformanceChannel;
stockOwnership?: GetSalesPerformanceStockOwnership;
orderStatus?: GetSalesPerformanceOrderStatus;
group?: GetSalesPerformanceGroup;
orderGroup?: GetSalesPerformanceOrderGroup;
/**
 * @maxLength 200
 */
search?: string;
/**
 * @maxLength 200
 */
orderSearch?: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type GetSalesPerformanceComparison = typeof GetSalesPerformanceComparison[keyof typeof GetSalesPerformanceComparison];


export const GetSalesPerformanceComparison = {
  previous_period: 'previous_period',
  previous_year: 'previous_year',
  none: 'none',
} as const;

export type GetSalesPerformanceChannel = typeof GetSalesPerformanceChannel[keyof typeof GetSalesPerformanceChannel];


export const GetSalesPerformanceChannel = {
  all: 'all',
  eBay: 'eBay',
  WhatsApp: 'WhatsApp',
  Shopify: 'Shopify',
  Whatnot: 'Whatnot',
  Direct: 'Direct',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
} as const;

export type GetSalesPerformanceStockOwnership = typeof GetSalesPerformanceStockOwnership[keyof typeof GetSalesPerformanceStockOwnership];


export const GetSalesPerformanceStockOwnership = {
  all: 'all',
  owned: 'owned',
  consignment: 'consignment',
} as const;

export type GetSalesPerformanceOrderStatus = typeof GetSalesPerformanceOrderStatus[keyof typeof GetSalesPerformanceOrderStatus];


export const GetSalesPerformanceOrderStatus = {
  recognised: 'recognised',
} as const;

export type GetSalesPerformanceGroup = typeof GetSalesPerformanceGroup[keyof typeof GetSalesPerformanceGroup];


export const GetSalesPerformanceGroup = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type GetSalesPerformanceOrderGroup = typeof GetSalesPerformanceOrderGroup[keyof typeof GetSalesPerformanceOrderGroup];


export const GetSalesPerformanceOrderGroup = {
  none: 'none',
  whatnot_show: 'whatnot_show',
} as const;

export type ExportSalesPerformanceBodyFormat = typeof ExportSalesPerformanceBodyFormat[keyof typeof ExportSalesPerformanceBodyFormat];


export const ExportSalesPerformanceBodyFormat = {
  csv: 'csv',
} as const;

export type ExportSalesPerformanceBody = {
  format?: ExportSalesPerformanceBodyFormat;
  filters: SalesPerformanceRequest;
};

export type GetVariantSplitWorkspaceParams = {
lineId: string;
};

export type SearchVariantSplitDestinationsParams = {
lineId: string;
/**
 * @maxLength 120
 */
q?: string;
/**
 * @minimum 1000
 * @maximum 9999
 */
year?: number;
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
};

export type SearchVariantSplitDestinations200 = {
  results: VariantSplitCandidate[];
  limit: number;
};

export type LoadVariantSplitDraftParams = {
lineId: string;
};

export type DeleteVariantSplitDraftParams = {
lineId: string;
};

export type ListVariantSplitReceiptsParams = {
lineId?: string;
};

export type ListVariantSplitReceipts200 = {
  receipts: VariantSplitReceiptHistoryEntry[];
};

export type GetBoxSaleEligibilityParams = {
/**
 * Identifies the active packing job whose reservation should be excluded when checking units for the Add to Box handoff. The job must contain this sale.
 */
packingJobId?: string;
};

